import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: Date;
  /** The `Upload` scalar type represents a file upload. */
  Upload: import('graphql-upload').FileUpload;
};

export type AddresseeGroup = {
  __typename?: 'AddresseeGroup';
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  employee: Employee;
  employeeId: Scalars['String'];
  id: Scalars['ID'];
  report: Report;
  reportId: Scalars['Int'];
};

export type AddresseeGroupCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  employee: EmployeeCreateNestedOneWithoutAddresseeGroupInput;
  report: ReportCreateNestedOneWithoutAddresseeGroupInput;
};

export type AddresseeGroupCreateManyEmployeeInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  reportId: Scalars['Int'];
};

export type AddresseeGroupCreateManyEmployeeInputEnvelope = {
  data: Array<AddresseeGroupCreateManyEmployeeInput>;
};

export type AddresseeGroupCreateManyReportInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['String'];
};

export type AddresseeGroupCreateManyReportInputEnvelope = {
  data: Array<AddresseeGroupCreateManyReportInput>;
};

export type AddresseeGroupCreateNestedManyWithoutEmployeeInput = {
  connect?: InputMaybe<Array<AddresseeGroupWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AddresseeGroupCreateOrConnectWithoutEmployeeInput>>;
  create?: InputMaybe<Array<AddresseeGroupCreateWithoutEmployeeInput>>;
  createMany?: InputMaybe<AddresseeGroupCreateManyEmployeeInputEnvelope>;
};

export type AddresseeGroupCreateNestedManyWithoutReportInput = {
  connect?: InputMaybe<Array<AddresseeGroupWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AddresseeGroupCreateOrConnectWithoutReportInput>>;
  create?: InputMaybe<Array<AddresseeGroupCreateWithoutReportInput>>;
  createMany?: InputMaybe<AddresseeGroupCreateManyReportInputEnvelope>;
};

export type AddresseeGroupCreateOrConnectWithoutEmployeeInput = {
  create: AddresseeGroupCreateWithoutEmployeeInput;
  where: AddresseeGroupWhereUniqueInput;
};

export type AddresseeGroupCreateOrConnectWithoutReportInput = {
  create: AddresseeGroupCreateWithoutReportInput;
  where: AddresseeGroupWhereUniqueInput;
};

export type AddresseeGroupCreateWithoutEmployeeInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  report: ReportCreateNestedOneWithoutAddresseeGroupInput;
};

export type AddresseeGroupCreateWithoutReportInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  employee: EmployeeCreateNestedOneWithoutAddresseeGroupInput;
};

export type AddresseeGroupListRelationFilter = {
  every?: InputMaybe<AddresseeGroupWhereInput>;
  none?: InputMaybe<AddresseeGroupWhereInput>;
  some?: InputMaybe<AddresseeGroupWhereInput>;
};

export type AddresseeGroupOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type AddresseeGroupOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  deletedBy?: InputMaybe<SortOrder>;
  employee?: InputMaybe<EmployeeOrderByWithRelationInput>;
  employeeId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  report?: InputMaybe<ReportOrderByWithRelationInput>;
  reportId?: InputMaybe<SortOrder>;
};

export enum AddresseeGroupScalarFieldEnum {
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  DeletedAt = 'deletedAt',
  DeletedBy = 'deletedBy',
  EmployeeId = 'employeeId',
  Id = 'id',
  ReportId = 'reportId'
}

export type AddresseeGroupScalarWhereInput = {
  AND?: InputMaybe<Array<AddresseeGroupScalarWhereInput>>;
  NOT?: InputMaybe<Array<AddresseeGroupScalarWhereInput>>;
  OR?: InputMaybe<Array<AddresseeGroupScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  employeeId?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  reportId?: InputMaybe<IntFilter>;
};

export type AddresseeGroupUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employee?: InputMaybe<EmployeeUpdateOneRequiredWithoutAddresseeGroupNestedInput>;
  report?: InputMaybe<ReportUpdateOneRequiredWithoutAddresseeGroupNestedInput>;
};

export type AddresseeGroupUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type AddresseeGroupUpdateManyWithWhereWithoutEmployeeInput = {
  data: AddresseeGroupUpdateManyMutationInput;
  where: AddresseeGroupScalarWhereInput;
};

export type AddresseeGroupUpdateManyWithWhereWithoutReportInput = {
  data: AddresseeGroupUpdateManyMutationInput;
  where: AddresseeGroupScalarWhereInput;
};

export type AddresseeGroupUpdateManyWithoutEmployeeNestedInput = {
  connect?: InputMaybe<Array<AddresseeGroupWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AddresseeGroupCreateOrConnectWithoutEmployeeInput>>;
  create?: InputMaybe<Array<AddresseeGroupCreateWithoutEmployeeInput>>;
  createMany?: InputMaybe<AddresseeGroupCreateManyEmployeeInputEnvelope>;
  delete?: InputMaybe<Array<AddresseeGroupWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AddresseeGroupScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AddresseeGroupWhereUniqueInput>>;
  set?: InputMaybe<Array<AddresseeGroupWhereUniqueInput>>;
  update?: InputMaybe<Array<AddresseeGroupUpdateWithWhereUniqueWithoutEmployeeInput>>;
  updateMany?: InputMaybe<Array<AddresseeGroupUpdateManyWithWhereWithoutEmployeeInput>>;
  upsert?: InputMaybe<Array<AddresseeGroupUpsertWithWhereUniqueWithoutEmployeeInput>>;
};

export type AddresseeGroupUpdateManyWithoutReportNestedInput = {
  connect?: InputMaybe<Array<AddresseeGroupWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AddresseeGroupCreateOrConnectWithoutReportInput>>;
  create?: InputMaybe<Array<AddresseeGroupCreateWithoutReportInput>>;
  createMany?: InputMaybe<AddresseeGroupCreateManyReportInputEnvelope>;
  delete?: InputMaybe<Array<AddresseeGroupWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AddresseeGroupScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AddresseeGroupWhereUniqueInput>>;
  set?: InputMaybe<Array<AddresseeGroupWhereUniqueInput>>;
  update?: InputMaybe<Array<AddresseeGroupUpdateWithWhereUniqueWithoutReportInput>>;
  updateMany?: InputMaybe<Array<AddresseeGroupUpdateManyWithWhereWithoutReportInput>>;
  upsert?: InputMaybe<Array<AddresseeGroupUpsertWithWhereUniqueWithoutReportInput>>;
};

export type AddresseeGroupUpdateWithWhereUniqueWithoutEmployeeInput = {
  data: AddresseeGroupUpdateWithoutEmployeeInput;
  where: AddresseeGroupWhereUniqueInput;
};

export type AddresseeGroupUpdateWithWhereUniqueWithoutReportInput = {
  data: AddresseeGroupUpdateWithoutReportInput;
  where: AddresseeGroupWhereUniqueInput;
};

export type AddresseeGroupUpdateWithoutEmployeeInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  report?: InputMaybe<ReportUpdateOneRequiredWithoutAddresseeGroupNestedInput>;
};

export type AddresseeGroupUpdateWithoutReportInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employee?: InputMaybe<EmployeeUpdateOneRequiredWithoutAddresseeGroupNestedInput>;
};

export type AddresseeGroupUpsertWithWhereUniqueWithoutEmployeeInput = {
  create: AddresseeGroupCreateWithoutEmployeeInput;
  update: AddresseeGroupUpdateWithoutEmployeeInput;
  where: AddresseeGroupWhereUniqueInput;
};

export type AddresseeGroupUpsertWithWhereUniqueWithoutReportInput = {
  create: AddresseeGroupCreateWithoutReportInput;
  update: AddresseeGroupUpdateWithoutReportInput;
  where: AddresseeGroupWhereUniqueInput;
};

export type AddresseeGroupWhereInput = {
  AND?: InputMaybe<Array<AddresseeGroupWhereInput>>;
  NOT?: InputMaybe<Array<AddresseeGroupWhereInput>>;
  OR?: InputMaybe<Array<AddresseeGroupWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  employee?: InputMaybe<EmployeeWhereInput>;
  employeeId?: InputMaybe<StringFilter>;
  id?: InputMaybe<IntFilter>;
  report?: InputMaybe<ReportWhereInput>;
  reportId?: InputMaybe<IntFilter>;
};

export type AddresseeGroupWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type Allocation = {
  __typename?: 'Allocation';
  _count: AllocationCount;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  projectAllocations?: Maybe<Array<ProjectAllocation>>;
};

export type AllocationCount = {
  __typename?: 'AllocationCount';
  projectAllocations: Scalars['Int'];
};

export type AllocationCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  projectAllocations?: InputMaybe<ProjectAllocationCreateNestedManyWithoutAllocationInput>;
};

export type AllocationCreateNestedOneWithoutProjectAllocationsInput = {
  connect?: InputMaybe<AllocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AllocationCreateOrConnectWithoutProjectAllocationsInput>;
  create?: InputMaybe<AllocationCreateWithoutProjectAllocationsInput>;
};

export type AllocationCreateOrConnectWithoutProjectAllocationsInput = {
  create: AllocationCreateWithoutProjectAllocationsInput;
  where: AllocationWhereUniqueInput;
};

export type AllocationCreateWithoutProjectAllocationsInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

export type AllocationOrderByWithRelationInput = {
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  projectAllocations?: InputMaybe<ProjectAllocationOrderByRelationAggregateInput>;
};

export enum AllocationScalarFieldEnum {
  Description = 'description',
  Id = 'id'
}

export type AllocationUpdateInput = {
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  projectAllocations?: InputMaybe<ProjectAllocationUpdateManyWithoutAllocationNestedInput>;
};

export type AllocationUpdateOneRequiredWithoutProjectAllocationsNestedInput = {
  connect?: InputMaybe<AllocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AllocationCreateOrConnectWithoutProjectAllocationsInput>;
  create?: InputMaybe<AllocationCreateWithoutProjectAllocationsInput>;
  update?: InputMaybe<AllocationUpdateWithoutProjectAllocationsInput>;
  upsert?: InputMaybe<AllocationUpsertWithoutProjectAllocationsInput>;
};

export type AllocationUpdateWithoutProjectAllocationsInput = {
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AllocationUpsertWithoutProjectAllocationsInput = {
  create: AllocationCreateWithoutProjectAllocationsInput;
  update: AllocationUpdateWithoutProjectAllocationsInput;
};

export type AllocationWhereInput = {
  AND?: InputMaybe<Array<AllocationWhereInput>>;
  NOT?: InputMaybe<Array<AllocationWhereInput>>;
  OR?: InputMaybe<Array<AllocationWhereInput>>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  projectAllocations?: InputMaybe<ProjectAllocationListRelationFilter>;
};

export type AllocationWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type ApprovalBoard = {
  __typename?: 'ApprovalBoard';
  _count: ApprovalBoardCount;
  approver?: Maybe<Array<Approver>>;
  description: Scalars['String'];
  email?: Maybe<Array<EmailHistory>>;
  id: Scalars['ID'];
  projectApproval?: Maybe<Array<ProjectApproval>>;
};

export type ApprovalBoardCount = {
  __typename?: 'ApprovalBoardCount';
  approver: Scalars['Int'];
  email: Scalars['Int'];
  projectApproval: Scalars['Int'];
};

export type ApprovalBoardCreateInput = {
  approver?: InputMaybe<ApproverCreateNestedManyWithoutApprovalBoardInput>;
  description: Scalars['String'];
  email?: InputMaybe<EmailHistoryCreateNestedManyWithoutApproverInput>;
  id: Scalars['String'];
  projectApproval?: InputMaybe<ProjectApprovalCreateNestedManyWithoutApprovalBoardInput>;
};

export type ApprovalBoardCreateNestedOneWithoutApproverInput = {
  connect?: InputMaybe<ApprovalBoardWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ApprovalBoardCreateOrConnectWithoutApproverInput>;
  create?: InputMaybe<ApprovalBoardCreateWithoutApproverInput>;
};

export type ApprovalBoardCreateNestedOneWithoutEmailInput = {
  connect?: InputMaybe<ApprovalBoardWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ApprovalBoardCreateOrConnectWithoutEmailInput>;
  create?: InputMaybe<ApprovalBoardCreateWithoutEmailInput>;
};

export type ApprovalBoardCreateNestedOneWithoutProjectApprovalInput = {
  connect?: InputMaybe<ApprovalBoardWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ApprovalBoardCreateOrConnectWithoutProjectApprovalInput>;
  create?: InputMaybe<ApprovalBoardCreateWithoutProjectApprovalInput>;
};

export type ApprovalBoardCreateOrConnectWithoutApproverInput = {
  create: ApprovalBoardCreateWithoutApproverInput;
  where: ApprovalBoardWhereUniqueInput;
};

export type ApprovalBoardCreateOrConnectWithoutEmailInput = {
  create: ApprovalBoardCreateWithoutEmailInput;
  where: ApprovalBoardWhereUniqueInput;
};

export type ApprovalBoardCreateOrConnectWithoutProjectApprovalInput = {
  create: ApprovalBoardCreateWithoutProjectApprovalInput;
  where: ApprovalBoardWhereUniqueInput;
};

export type ApprovalBoardCreateWithoutApproverInput = {
  description: Scalars['String'];
  email?: InputMaybe<EmailHistoryCreateNestedManyWithoutApproverInput>;
  id: Scalars['String'];
  projectApproval?: InputMaybe<ProjectApprovalCreateNestedManyWithoutApprovalBoardInput>;
};

export type ApprovalBoardCreateWithoutEmailInput = {
  approver?: InputMaybe<ApproverCreateNestedManyWithoutApprovalBoardInput>;
  description: Scalars['String'];
  id: Scalars['String'];
  projectApproval?: InputMaybe<ProjectApprovalCreateNestedManyWithoutApprovalBoardInput>;
};

export type ApprovalBoardCreateWithoutProjectApprovalInput = {
  approver?: InputMaybe<ApproverCreateNestedManyWithoutApprovalBoardInput>;
  description: Scalars['String'];
  email?: InputMaybe<EmailHistoryCreateNestedManyWithoutApproverInput>;
  id: Scalars['String'];
};

export type ApprovalBoardOrderByWithRelationInput = {
  approver?: InputMaybe<ApproverOrderByRelationAggregateInput>;
  description?: InputMaybe<SortOrder>;
  email?: InputMaybe<EmailHistoryOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  projectApproval?: InputMaybe<ProjectApprovalOrderByRelationAggregateInput>;
};

export enum ApprovalBoardScalarFieldEnum {
  Description = 'description',
  Id = 'id'
}

export type ApprovalBoardUpdateInput = {
  approver?: InputMaybe<ApproverUpdateManyWithoutApprovalBoardNestedInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<EmailHistoryUpdateManyWithoutApproverNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  projectApproval?: InputMaybe<ProjectApprovalUpdateManyWithoutApprovalBoardNestedInput>;
};

export type ApprovalBoardUpdateOneRequiredWithoutApproverNestedInput = {
  connect?: InputMaybe<ApprovalBoardWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ApprovalBoardCreateOrConnectWithoutApproverInput>;
  create?: InputMaybe<ApprovalBoardCreateWithoutApproverInput>;
  update?: InputMaybe<ApprovalBoardUpdateWithoutApproverInput>;
  upsert?: InputMaybe<ApprovalBoardUpsertWithoutApproverInput>;
};

export type ApprovalBoardUpdateOneRequiredWithoutEmailNestedInput = {
  connect?: InputMaybe<ApprovalBoardWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ApprovalBoardCreateOrConnectWithoutEmailInput>;
  create?: InputMaybe<ApprovalBoardCreateWithoutEmailInput>;
  update?: InputMaybe<ApprovalBoardUpdateWithoutEmailInput>;
  upsert?: InputMaybe<ApprovalBoardUpsertWithoutEmailInput>;
};

export type ApprovalBoardUpdateOneRequiredWithoutProjectApprovalNestedInput = {
  connect?: InputMaybe<ApprovalBoardWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ApprovalBoardCreateOrConnectWithoutProjectApprovalInput>;
  create?: InputMaybe<ApprovalBoardCreateWithoutProjectApprovalInput>;
  update?: InputMaybe<ApprovalBoardUpdateWithoutProjectApprovalInput>;
  upsert?: InputMaybe<ApprovalBoardUpsertWithoutProjectApprovalInput>;
};

export type ApprovalBoardUpdateWithoutApproverInput = {
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<EmailHistoryUpdateManyWithoutApproverNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  projectApproval?: InputMaybe<ProjectApprovalUpdateManyWithoutApprovalBoardNestedInput>;
};

export type ApprovalBoardUpdateWithoutEmailInput = {
  approver?: InputMaybe<ApproverUpdateManyWithoutApprovalBoardNestedInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  projectApproval?: InputMaybe<ProjectApprovalUpdateManyWithoutApprovalBoardNestedInput>;
};

export type ApprovalBoardUpdateWithoutProjectApprovalInput = {
  approver?: InputMaybe<ApproverUpdateManyWithoutApprovalBoardNestedInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<EmailHistoryUpdateManyWithoutApproverNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ApprovalBoardUpsertWithoutApproverInput = {
  create: ApprovalBoardCreateWithoutApproverInput;
  update: ApprovalBoardUpdateWithoutApproverInput;
};

export type ApprovalBoardUpsertWithoutEmailInput = {
  create: ApprovalBoardCreateWithoutEmailInput;
  update: ApprovalBoardUpdateWithoutEmailInput;
};

export type ApprovalBoardUpsertWithoutProjectApprovalInput = {
  create: ApprovalBoardCreateWithoutProjectApprovalInput;
  update: ApprovalBoardUpdateWithoutProjectApprovalInput;
};

export type ApprovalBoardWhereInput = {
  AND?: InputMaybe<Array<ApprovalBoardWhereInput>>;
  NOT?: InputMaybe<Array<ApprovalBoardWhereInput>>;
  OR?: InputMaybe<Array<ApprovalBoardWhereInput>>;
  approver?: InputMaybe<ApproverListRelationFilter>;
  description?: InputMaybe<StringFilter>;
  email?: InputMaybe<EmailHistoryListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  projectApproval?: InputMaybe<ProjectApprovalListRelationFilter>;
};

export type ApprovalBoardWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type ApprovalStatus = {
  __typename?: 'ApprovalStatus';
  _count: ApprovalStatusCount;
  description: Scalars['String'];
  id: Scalars['ID'];
  projectApproval?: Maybe<Array<ProjectApproval>>;
};

export type ApprovalStatusCount = {
  __typename?: 'ApprovalStatusCount';
  projectApproval: Scalars['Int'];
};

export type ApprovalStatusCreateInput = {
  description: Scalars['String'];
  id: Scalars['String'];
  projectApproval?: InputMaybe<ProjectApprovalCreateNestedManyWithoutApprovalStatusInput>;
};

export type ApprovalStatusCreateNestedOneWithoutProjectApprovalInput = {
  connect?: InputMaybe<ApprovalStatusWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ApprovalStatusCreateOrConnectWithoutProjectApprovalInput>;
  create?: InputMaybe<ApprovalStatusCreateWithoutProjectApprovalInput>;
};

export type ApprovalStatusCreateOrConnectWithoutProjectApprovalInput = {
  create: ApprovalStatusCreateWithoutProjectApprovalInput;
  where: ApprovalStatusWhereUniqueInput;
};

export type ApprovalStatusCreateWithoutProjectApprovalInput = {
  description: Scalars['String'];
  id: Scalars['String'];
};

export type ApprovalStatusOrderByWithRelationInput = {
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  projectApproval?: InputMaybe<ProjectApprovalOrderByRelationAggregateInput>;
};

export enum ApprovalStatusScalarFieldEnum {
  Description = 'description',
  Id = 'id'
}

export type ApprovalStatusUpdateInput = {
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  projectApproval?: InputMaybe<ProjectApprovalUpdateManyWithoutApprovalStatusNestedInput>;
};

export type ApprovalStatusUpdateOneWithoutProjectApprovalNestedInput = {
  connect?: InputMaybe<ApprovalStatusWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ApprovalStatusCreateOrConnectWithoutProjectApprovalInput>;
  create?: InputMaybe<ApprovalStatusCreateWithoutProjectApprovalInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<ApprovalStatusUpdateWithoutProjectApprovalInput>;
  upsert?: InputMaybe<ApprovalStatusUpsertWithoutProjectApprovalInput>;
};

export type ApprovalStatusUpdateWithoutProjectApprovalInput = {
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ApprovalStatusUpsertWithoutProjectApprovalInput = {
  create: ApprovalStatusCreateWithoutProjectApprovalInput;
  update: ApprovalStatusUpdateWithoutProjectApprovalInput;
};

export type ApprovalStatusWhereInput = {
  AND?: InputMaybe<Array<ApprovalStatusWhereInput>>;
  NOT?: InputMaybe<Array<ApprovalStatusWhereInput>>;
  OR?: InputMaybe<Array<ApprovalStatusWhereInput>>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  projectApproval?: InputMaybe<ProjectApprovalListRelationFilter>;
};

export type ApprovalStatusWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type Approver = {
  __typename?: 'Approver';
  approvalBoard: ApprovalBoard;
  approvalBoardId: Scalars['String'];
  endDate?: Maybe<Scalars['DateTime']>;
  firstName: Scalars['String'];
  function?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  kid: Scalars['String'];
  lastName: Scalars['String'];
  startDate?: Maybe<Scalars['DateTime']>;
};

export type ApproverCreateInput = {
  approvalBoard: ApprovalBoardCreateNestedOneWithoutApproverInput;
  endDate?: InputMaybe<Scalars['DateTime']>;
  firstName: Scalars['String'];
  function?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  kid: Scalars['String'];
  lastName: Scalars['String'];
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type ApproverCreateManyApprovalBoardInput = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  firstName: Scalars['String'];
  function?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  kid: Scalars['String'];
  lastName: Scalars['String'];
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type ApproverCreateManyApprovalBoardInputEnvelope = {
  data: Array<ApproverCreateManyApprovalBoardInput>;
};

export type ApproverCreateNestedManyWithoutApprovalBoardInput = {
  connect?: InputMaybe<Array<ApproverWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ApproverCreateOrConnectWithoutApprovalBoardInput>>;
  create?: InputMaybe<Array<ApproverCreateWithoutApprovalBoardInput>>;
  createMany?: InputMaybe<ApproverCreateManyApprovalBoardInputEnvelope>;
};

export type ApproverCreateOrConnectWithoutApprovalBoardInput = {
  create: ApproverCreateWithoutApprovalBoardInput;
  where: ApproverWhereUniqueInput;
};

export type ApproverCreateWithoutApprovalBoardInput = {
  endDate?: InputMaybe<Scalars['DateTime']>;
  firstName: Scalars['String'];
  function?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  kid: Scalars['String'];
  lastName: Scalars['String'];
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type ApproverListRelationFilter = {
  every?: InputMaybe<ApproverWhereInput>;
  none?: InputMaybe<ApproverWhereInput>;
  some?: InputMaybe<ApproverWhereInput>;
};

export type ApproverOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ApproverOrderByWithRelationInput = {
  approvalBoard?: InputMaybe<ApprovalBoardOrderByWithRelationInput>;
  approvalBoardId?: InputMaybe<SortOrder>;
  endDate?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrder>;
  function?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  kid?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
};

export type ApproverProcess = {
  __typename?: 'ApproverProcess';
  _count: ApproverProcessCount;
  approverRecipient?: Maybe<Array<ApproverRecipient>>;
  contactHistory?: Maybe<Array<ContactHistory>>;
  description: Scalars['String'];
  id: Scalars['ID'];
};

export type ApproverProcessCount = {
  __typename?: 'ApproverProcessCount';
  approverRecipient: Scalars['Int'];
  contactHistory: Scalars['Int'];
};

export type ApproverProcessCreateInput = {
  approverRecipient?: InputMaybe<ApproverRecipientCreateNestedManyWithoutApproverProcessInput>;
  contactHistory?: InputMaybe<ContactHistoryCreateNestedManyWithoutApproverProcessInput>;
  description: Scalars['String'];
  id: Scalars['String'];
};

export type ApproverProcessCreateNestedOneWithoutApproverRecipientInput = {
  connect?: InputMaybe<ApproverProcessWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ApproverProcessCreateOrConnectWithoutApproverRecipientInput>;
  create?: InputMaybe<ApproverProcessCreateWithoutApproverRecipientInput>;
};

export type ApproverProcessCreateNestedOneWithoutContactHistoryInput = {
  connect?: InputMaybe<ApproverProcessWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ApproverProcessCreateOrConnectWithoutContactHistoryInput>;
  create?: InputMaybe<ApproverProcessCreateWithoutContactHistoryInput>;
};

export type ApproverProcessCreateOrConnectWithoutApproverRecipientInput = {
  create: ApproverProcessCreateWithoutApproverRecipientInput;
  where: ApproverProcessWhereUniqueInput;
};

export type ApproverProcessCreateOrConnectWithoutContactHistoryInput = {
  create: ApproverProcessCreateWithoutContactHistoryInput;
  where: ApproverProcessWhereUniqueInput;
};

export type ApproverProcessCreateWithoutApproverRecipientInput = {
  contactHistory?: InputMaybe<ContactHistoryCreateNestedManyWithoutApproverProcessInput>;
  description: Scalars['String'];
  id: Scalars['String'];
};

export type ApproverProcessCreateWithoutContactHistoryInput = {
  approverRecipient?: InputMaybe<ApproverRecipientCreateNestedManyWithoutApproverProcessInput>;
  description: Scalars['String'];
  id: Scalars['String'];
};

export type ApproverProcessOrderByWithRelationInput = {
  approverRecipient?: InputMaybe<ApproverRecipientOrderByRelationAggregateInput>;
  contactHistory?: InputMaybe<ContactHistoryOrderByRelationAggregateInput>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export enum ApproverProcessScalarFieldEnum {
  Description = 'description',
  Id = 'id'
}

export type ApproverProcessUpdateInput = {
  approverRecipient?: InputMaybe<ApproverRecipientUpdateManyWithoutApproverProcessNestedInput>;
  contactHistory?: InputMaybe<ContactHistoryUpdateManyWithoutApproverProcessNestedInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ApproverProcessUpdateOneRequiredWithoutApproverRecipientNestedInput = {
  connect?: InputMaybe<ApproverProcessWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ApproverProcessCreateOrConnectWithoutApproverRecipientInput>;
  create?: InputMaybe<ApproverProcessCreateWithoutApproverRecipientInput>;
  update?: InputMaybe<ApproverProcessUpdateWithoutApproverRecipientInput>;
  upsert?: InputMaybe<ApproverProcessUpsertWithoutApproverRecipientInput>;
};

export type ApproverProcessUpdateOneRequiredWithoutContactHistoryNestedInput = {
  connect?: InputMaybe<ApproverProcessWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ApproverProcessCreateOrConnectWithoutContactHistoryInput>;
  create?: InputMaybe<ApproverProcessCreateWithoutContactHistoryInput>;
  update?: InputMaybe<ApproverProcessUpdateWithoutContactHistoryInput>;
  upsert?: InputMaybe<ApproverProcessUpsertWithoutContactHistoryInput>;
};

export type ApproverProcessUpdateWithoutApproverRecipientInput = {
  contactHistory?: InputMaybe<ContactHistoryUpdateManyWithoutApproverProcessNestedInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ApproverProcessUpdateWithoutContactHistoryInput = {
  approverRecipient?: InputMaybe<ApproverRecipientUpdateManyWithoutApproverProcessNestedInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ApproverProcessUpsertWithoutApproverRecipientInput = {
  create: ApproverProcessCreateWithoutApproverRecipientInput;
  update: ApproverProcessUpdateWithoutApproverRecipientInput;
};

export type ApproverProcessUpsertWithoutContactHistoryInput = {
  create: ApproverProcessCreateWithoutContactHistoryInput;
  update: ApproverProcessUpdateWithoutContactHistoryInput;
};

export type ApproverProcessWhereInput = {
  AND?: InputMaybe<Array<ApproverProcessWhereInput>>;
  NOT?: InputMaybe<Array<ApproverProcessWhereInput>>;
  OR?: InputMaybe<Array<ApproverProcessWhereInput>>;
  approverRecipient?: InputMaybe<ApproverRecipientListRelationFilter>;
  contactHistory?: InputMaybe<ContactHistoryListRelationFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
};

export type ApproverProcessWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type ApproverRecipient = {
  __typename?: 'ApproverRecipient';
  approverProcess: ApproverProcess;
  approverProcessId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  id: Scalars['ID'];
  kid: Scalars['String'];
  lastName: Scalars['String'];
};

export type ApproverRecipientCreateInput = {
  approverProcess: ApproverProcessCreateNestedOneWithoutApproverRecipientInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  kid: Scalars['String'];
  lastName: Scalars['String'];
};

export type ApproverRecipientCreateManyApproverProcessInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  kid: Scalars['String'];
  lastName: Scalars['String'];
};

export type ApproverRecipientCreateManyApproverProcessInputEnvelope = {
  data: Array<ApproverRecipientCreateManyApproverProcessInput>;
};

export type ApproverRecipientCreateNestedManyWithoutApproverProcessInput = {
  connect?: InputMaybe<Array<ApproverRecipientWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ApproverRecipientCreateOrConnectWithoutApproverProcessInput>>;
  create?: InputMaybe<Array<ApproverRecipientCreateWithoutApproverProcessInput>>;
  createMany?: InputMaybe<ApproverRecipientCreateManyApproverProcessInputEnvelope>;
};

export type ApproverRecipientCreateOrConnectWithoutApproverProcessInput = {
  create: ApproverRecipientCreateWithoutApproverProcessInput;
  where: ApproverRecipientWhereUniqueInput;
};

export type ApproverRecipientCreateWithoutApproverProcessInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  kid: Scalars['String'];
  lastName: Scalars['String'];
};

export type ApproverRecipientListRelationFilter = {
  every?: InputMaybe<ApproverRecipientWhereInput>;
  none?: InputMaybe<ApproverRecipientWhereInput>;
  some?: InputMaybe<ApproverRecipientWhereInput>;
};

export type ApproverRecipientOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ApproverRecipientOrderByWithRelationInput = {
  approverProcess?: InputMaybe<ApproverProcessOrderByWithRelationInput>;
  approverProcessId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  deletedBy?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  kid?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
};

export enum ApproverRecipientScalarFieldEnum {
  ApproverProcessId = 'approverProcessId',
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  DeletedAt = 'deletedAt',
  DeletedBy = 'deletedBy',
  FirstName = 'firstName',
  Id = 'id',
  Kid = 'kid',
  LastName = 'lastName'
}

export type ApproverRecipientScalarWhereInput = {
  AND?: InputMaybe<Array<ApproverRecipientScalarWhereInput>>;
  NOT?: InputMaybe<Array<ApproverRecipientScalarWhereInput>>;
  OR?: InputMaybe<Array<ApproverRecipientScalarWhereInput>>;
  approverProcessId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  kid?: InputMaybe<StringFilter>;
  lastName?: InputMaybe<StringFilter>;
};

export type ApproverRecipientUpdateInput = {
  approverProcess?: InputMaybe<ApproverProcessUpdateOneRequiredWithoutApproverRecipientNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  kid?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ApproverRecipientUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  kid?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ApproverRecipientUpdateManyWithWhereWithoutApproverProcessInput = {
  data: ApproverRecipientUpdateManyMutationInput;
  where: ApproverRecipientScalarWhereInput;
};

export type ApproverRecipientUpdateManyWithoutApproverProcessNestedInput = {
  connect?: InputMaybe<Array<ApproverRecipientWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ApproverRecipientCreateOrConnectWithoutApproverProcessInput>>;
  create?: InputMaybe<Array<ApproverRecipientCreateWithoutApproverProcessInput>>;
  createMany?: InputMaybe<ApproverRecipientCreateManyApproverProcessInputEnvelope>;
  delete?: InputMaybe<Array<ApproverRecipientWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ApproverRecipientScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ApproverRecipientWhereUniqueInput>>;
  set?: InputMaybe<Array<ApproverRecipientWhereUniqueInput>>;
  update?: InputMaybe<Array<ApproverRecipientUpdateWithWhereUniqueWithoutApproverProcessInput>>;
  updateMany?: InputMaybe<Array<ApproverRecipientUpdateManyWithWhereWithoutApproverProcessInput>>;
  upsert?: InputMaybe<Array<ApproverRecipientUpsertWithWhereUniqueWithoutApproverProcessInput>>;
};

export type ApproverRecipientUpdateWithWhereUniqueWithoutApproverProcessInput = {
  data: ApproverRecipientUpdateWithoutApproverProcessInput;
  where: ApproverRecipientWhereUniqueInput;
};

export type ApproverRecipientUpdateWithoutApproverProcessInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  kid?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ApproverRecipientUpsertWithWhereUniqueWithoutApproverProcessInput = {
  create: ApproverRecipientCreateWithoutApproverProcessInput;
  update: ApproverRecipientUpdateWithoutApproverProcessInput;
  where: ApproverRecipientWhereUniqueInput;
};

export type ApproverRecipientWhereInput = {
  AND?: InputMaybe<Array<ApproverRecipientWhereInput>>;
  NOT?: InputMaybe<Array<ApproverRecipientWhereInput>>;
  OR?: InputMaybe<Array<ApproverRecipientWhereInput>>;
  approverProcess?: InputMaybe<ApproverProcessWhereInput>;
  approverProcessId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  kid?: InputMaybe<StringFilter>;
  lastName?: InputMaybe<StringFilter>;
};

export type ApproverRecipientWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export enum ApproverScalarFieldEnum {
  ApprovalBoardId = 'approvalBoardId',
  EndDate = 'endDate',
  FirstName = 'firstName',
  Function = 'function',
  Id = 'id',
  Kid = 'kid',
  LastName = 'lastName',
  StartDate = 'startDate'
}

export type ApproverScalarWhereInput = {
  AND?: InputMaybe<Array<ApproverScalarWhereInput>>;
  NOT?: InputMaybe<Array<ApproverScalarWhereInput>>;
  OR?: InputMaybe<Array<ApproverScalarWhereInput>>;
  approvalBoardId?: InputMaybe<StringFilter>;
  endDate?: InputMaybe<DateTimeNullableFilter>;
  firstName?: InputMaybe<StringFilter>;
  function?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  kid?: InputMaybe<StringFilter>;
  lastName?: InputMaybe<StringFilter>;
  startDate?: InputMaybe<DateTimeNullableFilter>;
};

export type ApproverUpdateInput = {
  approvalBoard?: InputMaybe<ApprovalBoardUpdateOneRequiredWithoutApproverNestedInput>;
  endDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  function?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  kid?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type ApproverUpdateManyMutationInput = {
  endDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  function?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  kid?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type ApproverUpdateManyWithWhereWithoutApprovalBoardInput = {
  data: ApproverUpdateManyMutationInput;
  where: ApproverScalarWhereInput;
};

export type ApproverUpdateManyWithoutApprovalBoardNestedInput = {
  connect?: InputMaybe<Array<ApproverWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ApproverCreateOrConnectWithoutApprovalBoardInput>>;
  create?: InputMaybe<Array<ApproverCreateWithoutApprovalBoardInput>>;
  createMany?: InputMaybe<ApproverCreateManyApprovalBoardInputEnvelope>;
  delete?: InputMaybe<Array<ApproverWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ApproverScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ApproverWhereUniqueInput>>;
  set?: InputMaybe<Array<ApproverWhereUniqueInput>>;
  update?: InputMaybe<Array<ApproverUpdateWithWhereUniqueWithoutApprovalBoardInput>>;
  updateMany?: InputMaybe<Array<ApproverUpdateManyWithWhereWithoutApprovalBoardInput>>;
  upsert?: InputMaybe<Array<ApproverUpsertWithWhereUniqueWithoutApprovalBoardInput>>;
};

export type ApproverUpdateWithWhereUniqueWithoutApprovalBoardInput = {
  data: ApproverUpdateWithoutApprovalBoardInput;
  where: ApproverWhereUniqueInput;
};

export type ApproverUpdateWithoutApprovalBoardInput = {
  endDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  firstName?: InputMaybe<StringFieldUpdateOperationsInput>;
  function?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  kid?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type ApproverUpsertWithWhereUniqueWithoutApprovalBoardInput = {
  create: ApproverCreateWithoutApprovalBoardInput;
  update: ApproverUpdateWithoutApprovalBoardInput;
  where: ApproverWhereUniqueInput;
};

export type ApproverWhereInput = {
  AND?: InputMaybe<Array<ApproverWhereInput>>;
  NOT?: InputMaybe<Array<ApproverWhereInput>>;
  OR?: InputMaybe<Array<ApproverWhereInput>>;
  approvalBoard?: InputMaybe<ApprovalBoardWhereInput>;
  approvalBoardId?: InputMaybe<StringFilter>;
  endDate?: InputMaybe<DateTimeNullableFilter>;
  firstName?: InputMaybe<StringFilter>;
  function?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  kid?: InputMaybe<StringFilter>;
  lastName?: InputMaybe<StringFilter>;
  startDate?: InputMaybe<DateTimeNullableFilter>;
};

export type ApproverWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type Asset = {
  __typename?: 'Asset';
  _count: AssetCount;
  description: Scalars['String'];
  finances?: Maybe<Array<Finance>>;
  id: Scalars['ID'];
  isProjectCosts: Scalars['Boolean'];
};

export type AssetCount = {
  __typename?: 'AssetCount';
  finances: Scalars['Int'];
};

export type AssetCreateInput = {
  description: Scalars['String'];
  finances?: InputMaybe<FinanceCreateNestedManyWithoutAssetInput>;
  id?: InputMaybe<Scalars['String']>;
  isProjectCosts?: InputMaybe<Scalars['Boolean']>;
};

export type AssetCreateNestedOneWithoutFinancesInput = {
  connect?: InputMaybe<AssetWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AssetCreateOrConnectWithoutFinancesInput>;
  create?: InputMaybe<AssetCreateWithoutFinancesInput>;
};

export type AssetCreateOrConnectWithoutFinancesInput = {
  create: AssetCreateWithoutFinancesInput;
  where: AssetWhereUniqueInput;
};

export type AssetCreateWithoutFinancesInput = {
  description: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  isProjectCosts?: InputMaybe<Scalars['Boolean']>;
};

export type AssetOrderByWithRelationInput = {
  description?: InputMaybe<SortOrder>;
  finances?: InputMaybe<FinanceOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  isProjectCosts?: InputMaybe<SortOrder>;
};

export enum AssetScalarFieldEnum {
  Description = 'description',
  Id = 'id',
  IsProjectCosts = 'isProjectCosts'
}

export type AssetUpdateInput = {
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  finances?: InputMaybe<FinanceUpdateManyWithoutAssetNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isProjectCosts?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type AssetUpdateOneRequiredWithoutFinancesNestedInput = {
  connect?: InputMaybe<AssetWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AssetCreateOrConnectWithoutFinancesInput>;
  create?: InputMaybe<AssetCreateWithoutFinancesInput>;
  update?: InputMaybe<AssetUpdateWithoutFinancesInput>;
  upsert?: InputMaybe<AssetUpsertWithoutFinancesInput>;
};

export type AssetUpdateWithoutFinancesInput = {
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isProjectCosts?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type AssetUpsertWithoutFinancesInput = {
  create: AssetCreateWithoutFinancesInput;
  update: AssetUpdateWithoutFinancesInput;
};

export type AssetWhereInput = {
  AND?: InputMaybe<Array<AssetWhereInput>>;
  NOT?: InputMaybe<Array<AssetWhereInput>>;
  OR?: InputMaybe<Array<AssetWhereInput>>;
  description?: InputMaybe<StringFilter>;
  finances?: InputMaybe<FinanceListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  isProjectCosts?: InputMaybe<BoolFilter>;
};

export type AssetWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type BoolFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['Boolean']>;
};

export type BoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type BoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolNullableFilter>;
};

export type BusinessProcess = {
  __typename?: 'BusinessProcess';
  _count: BusinessProcessCount;
  businessProcessOnProject?: Maybe<Array<BusinessProcessOnProject>>;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type BusinessProcessComments = {
  __typename?: 'BusinessProcessComments';
  businessProcessOnProject: BusinessProcessOnProject;
  businessProcessOnProjectId: Scalars['String'];
  comment: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type BusinessProcessCommentsCreateInput = {
  businessProcessOnProject: BusinessProcessOnProjectCreateNestedOneWithoutBusinessProcessCommentsInput;
  comment: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type BusinessProcessCommentsCreateManyBusinessProcessOnProjectInput = {
  comment: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type BusinessProcessCommentsCreateManyBusinessProcessOnProjectInputEnvelope = {
  data: Array<BusinessProcessCommentsCreateManyBusinessProcessOnProjectInput>;
};

export type BusinessProcessCommentsCreateNestedManyWithoutBusinessProcessOnProjectInput = {
  connect?: InputMaybe<Array<BusinessProcessCommentsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BusinessProcessCommentsCreateOrConnectWithoutBusinessProcessOnProjectInput>>;
  create?: InputMaybe<Array<BusinessProcessCommentsCreateWithoutBusinessProcessOnProjectInput>>;
  createMany?: InputMaybe<BusinessProcessCommentsCreateManyBusinessProcessOnProjectInputEnvelope>;
};

export type BusinessProcessCommentsCreateOrConnectWithoutBusinessProcessOnProjectInput = {
  create: BusinessProcessCommentsCreateWithoutBusinessProcessOnProjectInput;
  where: BusinessProcessCommentsWhereUniqueInput;
};

export type BusinessProcessCommentsCreateWithoutBusinessProcessOnProjectInput = {
  comment: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type BusinessProcessCommentsListRelationFilter = {
  every?: InputMaybe<BusinessProcessCommentsWhereInput>;
  none?: InputMaybe<BusinessProcessCommentsWhereInput>;
  some?: InputMaybe<BusinessProcessCommentsWhereInput>;
};

export type BusinessProcessCommentsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type BusinessProcessCommentsOrderByWithRelationInput = {
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectOrderByWithRelationInput>;
  businessProcessOnProjectId?: InputMaybe<SortOrder>;
  comment?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  deletedBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export enum BusinessProcessCommentsScalarFieldEnum {
  BusinessProcessOnProjectId = 'businessProcessOnProjectId',
  Comment = 'comment',
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  DeletedAt = 'deletedAt',
  DeletedBy = 'deletedBy',
  Id = 'id'
}

export type BusinessProcessCommentsScalarWhereInput = {
  AND?: InputMaybe<Array<BusinessProcessCommentsScalarWhereInput>>;
  NOT?: InputMaybe<Array<BusinessProcessCommentsScalarWhereInput>>;
  OR?: InputMaybe<Array<BusinessProcessCommentsScalarWhereInput>>;
  businessProcessOnProjectId?: InputMaybe<StringFilter>;
  comment?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
};

export type BusinessProcessCommentsUpdateInput = {
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectUpdateOneRequiredWithoutBusinessProcessCommentsNestedInput>;
  comment?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type BusinessProcessCommentsUpdateManyMutationInput = {
  comment?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type BusinessProcessCommentsUpdateManyWithWhereWithoutBusinessProcessOnProjectInput = {
  data: BusinessProcessCommentsUpdateManyMutationInput;
  where: BusinessProcessCommentsScalarWhereInput;
};

export type BusinessProcessCommentsUpdateManyWithoutBusinessProcessOnProjectNestedInput = {
  connect?: InputMaybe<Array<BusinessProcessCommentsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BusinessProcessCommentsCreateOrConnectWithoutBusinessProcessOnProjectInput>>;
  create?: InputMaybe<Array<BusinessProcessCommentsCreateWithoutBusinessProcessOnProjectInput>>;
  createMany?: InputMaybe<BusinessProcessCommentsCreateManyBusinessProcessOnProjectInputEnvelope>;
  delete?: InputMaybe<Array<BusinessProcessCommentsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BusinessProcessCommentsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BusinessProcessCommentsWhereUniqueInput>>;
  set?: InputMaybe<Array<BusinessProcessCommentsWhereUniqueInput>>;
  update?: InputMaybe<Array<BusinessProcessCommentsUpdateWithWhereUniqueWithoutBusinessProcessOnProjectInput>>;
  updateMany?: InputMaybe<Array<BusinessProcessCommentsUpdateManyWithWhereWithoutBusinessProcessOnProjectInput>>;
  upsert?: InputMaybe<Array<BusinessProcessCommentsUpsertWithWhereUniqueWithoutBusinessProcessOnProjectInput>>;
};

export type BusinessProcessCommentsUpdateWithWhereUniqueWithoutBusinessProcessOnProjectInput = {
  data: BusinessProcessCommentsUpdateWithoutBusinessProcessOnProjectInput;
  where: BusinessProcessCommentsWhereUniqueInput;
};

export type BusinessProcessCommentsUpdateWithoutBusinessProcessOnProjectInput = {
  comment?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type BusinessProcessCommentsUpsertWithWhereUniqueWithoutBusinessProcessOnProjectInput = {
  create: BusinessProcessCommentsCreateWithoutBusinessProcessOnProjectInput;
  update: BusinessProcessCommentsUpdateWithoutBusinessProcessOnProjectInput;
  where: BusinessProcessCommentsWhereUniqueInput;
};

export type BusinessProcessCommentsWhereInput = {
  AND?: InputMaybe<Array<BusinessProcessCommentsWhereInput>>;
  NOT?: InputMaybe<Array<BusinessProcessCommentsWhereInput>>;
  OR?: InputMaybe<Array<BusinessProcessCommentsWhereInput>>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectWhereInput>;
  businessProcessOnProjectId?: InputMaybe<StringFilter>;
  comment?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
};

export type BusinessProcessCommentsWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type BusinessProcessCount = {
  __typename?: 'BusinessProcessCount';
  businessProcessOnProject: Scalars['Int'];
};

export type BusinessProcessCreateInput = {
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectCreateNestedManyWithoutBusinessProcessInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type BusinessProcessCreateNestedOneWithoutBusinessProcessOnProjectInput = {
  connect?: InputMaybe<BusinessProcessWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BusinessProcessCreateOrConnectWithoutBusinessProcessOnProjectInput>;
  create?: InputMaybe<BusinessProcessCreateWithoutBusinessProcessOnProjectInput>;
};

export type BusinessProcessCreateOrConnectWithoutBusinessProcessOnProjectInput = {
  create: BusinessProcessCreateWithoutBusinessProcessOnProjectInput;
  where: BusinessProcessWhereUniqueInput;
};

export type BusinessProcessCreateWithoutBusinessProcessOnProjectInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type BusinessProcessOnProject = {
  __typename?: 'BusinessProcessOnProject';
  BusinessProcessComments?: Maybe<Array<BusinessProcessComments>>;
  _count: BusinessProcessOnProjectCount;
  businessProcess: BusinessProcess;
  businessProcessId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  project: Master;
  projectId: Scalars['String'];
};

export type BusinessProcessOnProjectCount = {
  __typename?: 'BusinessProcessOnProjectCount';
  BusinessProcessComments: Scalars['Int'];
};

export type BusinessProcessOnProjectCreateInput = {
  BusinessProcessComments?: InputMaybe<BusinessProcessCommentsCreateNestedManyWithoutBusinessProcessOnProjectInput>;
  businessProcess: BusinessProcessCreateNestedOneWithoutBusinessProcessOnProjectInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  project: MasterCreateNestedOneWithoutBusinessProcessOnProjectInput;
};

export type BusinessProcessOnProjectCreateManyBusinessProcessInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
};

export type BusinessProcessOnProjectCreateManyBusinessProcessInputEnvelope = {
  data: Array<BusinessProcessOnProjectCreateManyBusinessProcessInput>;
};

export type BusinessProcessOnProjectCreateManyProjectInput = {
  businessProcessId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type BusinessProcessOnProjectCreateManyProjectInputEnvelope = {
  data: Array<BusinessProcessOnProjectCreateManyProjectInput>;
};

export type BusinessProcessOnProjectCreateNestedManyWithoutBusinessProcessInput = {
  connect?: InputMaybe<Array<BusinessProcessOnProjectWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BusinessProcessOnProjectCreateOrConnectWithoutBusinessProcessInput>>;
  create?: InputMaybe<Array<BusinessProcessOnProjectCreateWithoutBusinessProcessInput>>;
  createMany?: InputMaybe<BusinessProcessOnProjectCreateManyBusinessProcessInputEnvelope>;
};

export type BusinessProcessOnProjectCreateNestedManyWithoutProjectInput = {
  connect?: InputMaybe<Array<BusinessProcessOnProjectWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BusinessProcessOnProjectCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<BusinessProcessOnProjectCreateWithoutProjectInput>>;
  createMany?: InputMaybe<BusinessProcessOnProjectCreateManyProjectInputEnvelope>;
};

export type BusinessProcessOnProjectCreateNestedOneWithoutBusinessProcessCommentsInput = {
  connect?: InputMaybe<BusinessProcessOnProjectWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BusinessProcessOnProjectCreateOrConnectWithoutBusinessProcessCommentsInput>;
  create?: InputMaybe<BusinessProcessOnProjectCreateWithoutBusinessProcessCommentsInput>;
};

export type BusinessProcessOnProjectCreateOrConnectWithoutBusinessProcessCommentsInput = {
  create: BusinessProcessOnProjectCreateWithoutBusinessProcessCommentsInput;
  where: BusinessProcessOnProjectWhereUniqueInput;
};

export type BusinessProcessOnProjectCreateOrConnectWithoutBusinessProcessInput = {
  create: BusinessProcessOnProjectCreateWithoutBusinessProcessInput;
  where: BusinessProcessOnProjectWhereUniqueInput;
};

export type BusinessProcessOnProjectCreateOrConnectWithoutProjectInput = {
  create: BusinessProcessOnProjectCreateWithoutProjectInput;
  where: BusinessProcessOnProjectWhereUniqueInput;
};

export type BusinessProcessOnProjectCreateWithoutBusinessProcessCommentsInput = {
  businessProcess: BusinessProcessCreateNestedOneWithoutBusinessProcessOnProjectInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  project: MasterCreateNestedOneWithoutBusinessProcessOnProjectInput;
};

export type BusinessProcessOnProjectCreateWithoutBusinessProcessInput = {
  BusinessProcessComments?: InputMaybe<BusinessProcessCommentsCreateNestedManyWithoutBusinessProcessOnProjectInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  project: MasterCreateNestedOneWithoutBusinessProcessOnProjectInput;
};

export type BusinessProcessOnProjectCreateWithoutProjectInput = {
  BusinessProcessComments?: InputMaybe<BusinessProcessCommentsCreateNestedManyWithoutBusinessProcessOnProjectInput>;
  businessProcess: BusinessProcessCreateNestedOneWithoutBusinessProcessOnProjectInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type BusinessProcessOnProjectListRelationFilter = {
  every?: InputMaybe<BusinessProcessOnProjectWhereInput>;
  none?: InputMaybe<BusinessProcessOnProjectWhereInput>;
  some?: InputMaybe<BusinessProcessOnProjectWhereInput>;
};

export type BusinessProcessOnProjectOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type BusinessProcessOnProjectOrderByWithRelationInput = {
  BusinessProcessComments?: InputMaybe<BusinessProcessCommentsOrderByRelationAggregateInput>;
  businessProcess?: InputMaybe<BusinessProcessOrderByWithRelationInput>;
  businessProcessId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  deletedBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  project?: InputMaybe<MasterOrderByWithRelationInput>;
  projectId?: InputMaybe<SortOrder>;
};

export enum BusinessProcessOnProjectScalarFieldEnum {
  BusinessProcessId = 'businessProcessId',
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  DeletedAt = 'deletedAt',
  DeletedBy = 'deletedBy',
  Id = 'id',
  ProjectId = 'projectId'
}

export type BusinessProcessOnProjectScalarWhereInput = {
  AND?: InputMaybe<Array<BusinessProcessOnProjectScalarWhereInput>>;
  NOT?: InputMaybe<Array<BusinessProcessOnProjectScalarWhereInput>>;
  OR?: InputMaybe<Array<BusinessProcessOnProjectScalarWhereInput>>;
  businessProcessId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  projectId?: InputMaybe<StringFilter>;
};

export type BusinessProcessOnProjectUpdateInput = {
  BusinessProcessComments?: InputMaybe<BusinessProcessCommentsUpdateManyWithoutBusinessProcessOnProjectNestedInput>;
  businessProcess?: InputMaybe<BusinessProcessUpdateOneRequiredWithoutBusinessProcessOnProjectNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutBusinessProcessOnProjectNestedInput>;
};

export type BusinessProcessOnProjectUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type BusinessProcessOnProjectUpdateManyWithWhereWithoutBusinessProcessInput = {
  data: BusinessProcessOnProjectUpdateManyMutationInput;
  where: BusinessProcessOnProjectScalarWhereInput;
};

export type BusinessProcessOnProjectUpdateManyWithWhereWithoutProjectInput = {
  data: BusinessProcessOnProjectUpdateManyMutationInput;
  where: BusinessProcessOnProjectScalarWhereInput;
};

export type BusinessProcessOnProjectUpdateManyWithoutBusinessProcessNestedInput = {
  connect?: InputMaybe<Array<BusinessProcessOnProjectWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BusinessProcessOnProjectCreateOrConnectWithoutBusinessProcessInput>>;
  create?: InputMaybe<Array<BusinessProcessOnProjectCreateWithoutBusinessProcessInput>>;
  createMany?: InputMaybe<BusinessProcessOnProjectCreateManyBusinessProcessInputEnvelope>;
  delete?: InputMaybe<Array<BusinessProcessOnProjectWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BusinessProcessOnProjectScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BusinessProcessOnProjectWhereUniqueInput>>;
  set?: InputMaybe<Array<BusinessProcessOnProjectWhereUniqueInput>>;
  update?: InputMaybe<Array<BusinessProcessOnProjectUpdateWithWhereUniqueWithoutBusinessProcessInput>>;
  updateMany?: InputMaybe<Array<BusinessProcessOnProjectUpdateManyWithWhereWithoutBusinessProcessInput>>;
  upsert?: InputMaybe<Array<BusinessProcessOnProjectUpsertWithWhereUniqueWithoutBusinessProcessInput>>;
};

export type BusinessProcessOnProjectUpdateManyWithoutProjectNestedInput = {
  connect?: InputMaybe<Array<BusinessProcessOnProjectWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BusinessProcessOnProjectCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<BusinessProcessOnProjectCreateWithoutProjectInput>>;
  createMany?: InputMaybe<BusinessProcessOnProjectCreateManyProjectInputEnvelope>;
  delete?: InputMaybe<Array<BusinessProcessOnProjectWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BusinessProcessOnProjectScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BusinessProcessOnProjectWhereUniqueInput>>;
  set?: InputMaybe<Array<BusinessProcessOnProjectWhereUniqueInput>>;
  update?: InputMaybe<Array<BusinessProcessOnProjectUpdateWithWhereUniqueWithoutProjectInput>>;
  updateMany?: InputMaybe<Array<BusinessProcessOnProjectUpdateManyWithWhereWithoutProjectInput>>;
  upsert?: InputMaybe<Array<BusinessProcessOnProjectUpsertWithWhereUniqueWithoutProjectInput>>;
};

export type BusinessProcessOnProjectUpdateOneRequiredWithoutBusinessProcessCommentsNestedInput = {
  connect?: InputMaybe<BusinessProcessOnProjectWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BusinessProcessOnProjectCreateOrConnectWithoutBusinessProcessCommentsInput>;
  create?: InputMaybe<BusinessProcessOnProjectCreateWithoutBusinessProcessCommentsInput>;
  update?: InputMaybe<BusinessProcessOnProjectUpdateWithoutBusinessProcessCommentsInput>;
  upsert?: InputMaybe<BusinessProcessOnProjectUpsertWithoutBusinessProcessCommentsInput>;
};

export type BusinessProcessOnProjectUpdateWithWhereUniqueWithoutBusinessProcessInput = {
  data: BusinessProcessOnProjectUpdateWithoutBusinessProcessInput;
  where: BusinessProcessOnProjectWhereUniqueInput;
};

export type BusinessProcessOnProjectUpdateWithWhereUniqueWithoutProjectInput = {
  data: BusinessProcessOnProjectUpdateWithoutProjectInput;
  where: BusinessProcessOnProjectWhereUniqueInput;
};

export type BusinessProcessOnProjectUpdateWithoutBusinessProcessCommentsInput = {
  businessProcess?: InputMaybe<BusinessProcessUpdateOneRequiredWithoutBusinessProcessOnProjectNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutBusinessProcessOnProjectNestedInput>;
};

export type BusinessProcessOnProjectUpdateWithoutBusinessProcessInput = {
  BusinessProcessComments?: InputMaybe<BusinessProcessCommentsUpdateManyWithoutBusinessProcessOnProjectNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutBusinessProcessOnProjectNestedInput>;
};

export type BusinessProcessOnProjectUpdateWithoutProjectInput = {
  BusinessProcessComments?: InputMaybe<BusinessProcessCommentsUpdateManyWithoutBusinessProcessOnProjectNestedInput>;
  businessProcess?: InputMaybe<BusinessProcessUpdateOneRequiredWithoutBusinessProcessOnProjectNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type BusinessProcessOnProjectUpsertWithWhereUniqueWithoutBusinessProcessInput = {
  create: BusinessProcessOnProjectCreateWithoutBusinessProcessInput;
  update: BusinessProcessOnProjectUpdateWithoutBusinessProcessInput;
  where: BusinessProcessOnProjectWhereUniqueInput;
};

export type BusinessProcessOnProjectUpsertWithWhereUniqueWithoutProjectInput = {
  create: BusinessProcessOnProjectCreateWithoutProjectInput;
  update: BusinessProcessOnProjectUpdateWithoutProjectInput;
  where: BusinessProcessOnProjectWhereUniqueInput;
};

export type BusinessProcessOnProjectUpsertWithoutBusinessProcessCommentsInput = {
  create: BusinessProcessOnProjectCreateWithoutBusinessProcessCommentsInput;
  update: BusinessProcessOnProjectUpdateWithoutBusinessProcessCommentsInput;
};

export type BusinessProcessOnProjectWhereInput = {
  AND?: InputMaybe<Array<BusinessProcessOnProjectWhereInput>>;
  BusinessProcessComments?: InputMaybe<BusinessProcessCommentsListRelationFilter>;
  NOT?: InputMaybe<Array<BusinessProcessOnProjectWhereInput>>;
  OR?: InputMaybe<Array<BusinessProcessOnProjectWhereInput>>;
  businessProcess?: InputMaybe<BusinessProcessWhereInput>;
  businessProcessId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  project?: InputMaybe<MasterWhereInput>;
  projectId?: InputMaybe<StringFilter>;
};

export type BusinessProcessOnProjectWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type BusinessProcessOrderByWithRelationInput = {
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  deletedBy?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export enum BusinessProcessScalarFieldEnum {
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  DeletedAt = 'deletedAt',
  DeletedBy = 'deletedBy',
  Description = 'description',
  Id = 'id',
  Name = 'name'
}

export type BusinessProcessUpdateInput = {
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectUpdateManyWithoutBusinessProcessNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type BusinessProcessUpdateOneRequiredWithoutBusinessProcessOnProjectNestedInput = {
  connect?: InputMaybe<BusinessProcessWhereUniqueInput>;
  connectOrCreate?: InputMaybe<BusinessProcessCreateOrConnectWithoutBusinessProcessOnProjectInput>;
  create?: InputMaybe<BusinessProcessCreateWithoutBusinessProcessOnProjectInput>;
  update?: InputMaybe<BusinessProcessUpdateWithoutBusinessProcessOnProjectInput>;
  upsert?: InputMaybe<BusinessProcessUpsertWithoutBusinessProcessOnProjectInput>;
};

export type BusinessProcessUpdateWithoutBusinessProcessOnProjectInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type BusinessProcessUpsertWithoutBusinessProcessOnProjectInput = {
  create: BusinessProcessCreateWithoutBusinessProcessOnProjectInput;
  update: BusinessProcessUpdateWithoutBusinessProcessOnProjectInput;
};

export type BusinessProcessWhereInput = {
  AND?: InputMaybe<Array<BusinessProcessWhereInput>>;
  NOT?: InputMaybe<Array<BusinessProcessWhereInput>>;
  OR?: InputMaybe<Array<BusinessProcessWhereInput>>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
};

export type BusinessProcessWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type Company = {
  __typename?: 'Company';
  _count: CompanyCount;
  description?: Maybe<Scalars['String']>;
  finances?: Maybe<Array<Finance>>;
  id: Scalars['ID'];
};

export type CompanyCount = {
  __typename?: 'CompanyCount';
  finances: Scalars['Int'];
};

export type CompanyCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  finances?: InputMaybe<FinanceCreateNestedManyWithoutCompanyInput>;
  id: Scalars['String'];
};

export type CompanyCreateNestedOneWithoutFinancesInput = {
  connect?: InputMaybe<CompanyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CompanyCreateOrConnectWithoutFinancesInput>;
  create?: InputMaybe<CompanyCreateWithoutFinancesInput>;
};

export type CompanyCreateOrConnectWithoutFinancesInput = {
  create: CompanyCreateWithoutFinancesInput;
  where: CompanyWhereUniqueInput;
};

export type CompanyCreateWithoutFinancesInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

export type CompanyOrderByWithRelationInput = {
  description?: InputMaybe<SortOrder>;
  finances?: InputMaybe<FinanceOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
};

export enum CompanyScalarFieldEnum {
  Description = 'description',
  Id = 'id'
}

export type CompanyUpdateInput = {
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  finances?: InputMaybe<FinanceUpdateManyWithoutCompanyNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CompanyUpdateOneRequiredWithoutFinancesNestedInput = {
  connect?: InputMaybe<CompanyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CompanyCreateOrConnectWithoutFinancesInput>;
  create?: InputMaybe<CompanyCreateWithoutFinancesInput>;
  update?: InputMaybe<CompanyUpdateWithoutFinancesInput>;
  upsert?: InputMaybe<CompanyUpsertWithoutFinancesInput>;
};

export type CompanyUpdateWithoutFinancesInput = {
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type CompanyUpsertWithoutFinancesInput = {
  create: CompanyCreateWithoutFinancesInput;
  update: CompanyUpdateWithoutFinancesInput;
};

export type CompanyWhereInput = {
  AND?: InputMaybe<Array<CompanyWhereInput>>;
  NOT?: InputMaybe<Array<CompanyWhereInput>>;
  OR?: InputMaybe<Array<CompanyWhereInput>>;
  description?: InputMaybe<StringNullableFilter>;
  finances?: InputMaybe<FinanceListRelationFilter>;
  id?: InputMaybe<StringFilter>;
};

export type CompanyWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type ContactHistory = {
  __typename?: 'ContactHistory';
  addressees?: Maybe<Scalars['String']>;
  approverProcess: ApproverProcess;
  approverProcessId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  isMail: Scalars['Boolean'];
  project: Master;
  projectId: Scalars['String'];
  reply?: Maybe<Scalars['String']>;
  replyComment?: Maybe<Scalars['String']>;
  replyDate?: Maybe<Scalars['DateTime']>;
  replyPerson?: Maybe<Scalars['String']>;
  rowNumber: Scalars['ID'];
  sendDate?: Maybe<Scalars['DateTime']>;
};

export type ContactHistoryCreateInput = {
  addressees?: InputMaybe<Scalars['String']>;
  approverProcess: ApproverProcessCreateNestedOneWithoutContactHistoryInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  isMail?: InputMaybe<Scalars['Boolean']>;
  project: MasterCreateNestedOneWithoutContactHistoryInput;
  reply?: InputMaybe<Scalars['String']>;
  replyComment?: InputMaybe<Scalars['String']>;
  replyDate?: InputMaybe<Scalars['DateTime']>;
  replyPerson?: InputMaybe<Scalars['String']>;
  sendDate?: InputMaybe<Scalars['DateTime']>;
};

export type ContactHistoryCreateManyApproverProcessInput = {
  addressees?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  isMail?: InputMaybe<Scalars['Boolean']>;
  projectId: Scalars['String'];
  reply?: InputMaybe<Scalars['String']>;
  replyComment?: InputMaybe<Scalars['String']>;
  replyDate?: InputMaybe<Scalars['DateTime']>;
  replyPerson?: InputMaybe<Scalars['String']>;
  sendDate?: InputMaybe<Scalars['DateTime']>;
};

export type ContactHistoryCreateManyApproverProcessInputEnvelope = {
  data: Array<ContactHistoryCreateManyApproverProcessInput>;
};

export type ContactHistoryCreateManyProjectInput = {
  addressees?: InputMaybe<Scalars['String']>;
  approverProcessId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  isMail?: InputMaybe<Scalars['Boolean']>;
  reply?: InputMaybe<Scalars['String']>;
  replyComment?: InputMaybe<Scalars['String']>;
  replyDate?: InputMaybe<Scalars['DateTime']>;
  replyPerson?: InputMaybe<Scalars['String']>;
  sendDate?: InputMaybe<Scalars['DateTime']>;
};

export type ContactHistoryCreateManyProjectInputEnvelope = {
  data: Array<ContactHistoryCreateManyProjectInput>;
};

export type ContactHistoryCreateNestedManyWithoutApproverProcessInput = {
  connect?: InputMaybe<Array<ContactHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContactHistoryCreateOrConnectWithoutApproverProcessInput>>;
  create?: InputMaybe<Array<ContactHistoryCreateWithoutApproverProcessInput>>;
  createMany?: InputMaybe<ContactHistoryCreateManyApproverProcessInputEnvelope>;
};

export type ContactHistoryCreateNestedManyWithoutProjectInput = {
  connect?: InputMaybe<Array<ContactHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContactHistoryCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<ContactHistoryCreateWithoutProjectInput>>;
  createMany?: InputMaybe<ContactHistoryCreateManyProjectInputEnvelope>;
};

export type ContactHistoryCreateOrConnectWithoutApproverProcessInput = {
  create: ContactHistoryCreateWithoutApproverProcessInput;
  where: ContactHistoryWhereUniqueInput;
};

export type ContactHistoryCreateOrConnectWithoutProjectInput = {
  create: ContactHistoryCreateWithoutProjectInput;
  where: ContactHistoryWhereUniqueInput;
};

export type ContactHistoryCreateWithoutApproverProcessInput = {
  addressees?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  isMail?: InputMaybe<Scalars['Boolean']>;
  project: MasterCreateNestedOneWithoutContactHistoryInput;
  reply?: InputMaybe<Scalars['String']>;
  replyComment?: InputMaybe<Scalars['String']>;
  replyDate?: InputMaybe<Scalars['DateTime']>;
  replyPerson?: InputMaybe<Scalars['String']>;
  sendDate?: InputMaybe<Scalars['DateTime']>;
};

export type ContactHistoryCreateWithoutProjectInput = {
  addressees?: InputMaybe<Scalars['String']>;
  approverProcess: ApproverProcessCreateNestedOneWithoutContactHistoryInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  isMail?: InputMaybe<Scalars['Boolean']>;
  reply?: InputMaybe<Scalars['String']>;
  replyComment?: InputMaybe<Scalars['String']>;
  replyDate?: InputMaybe<Scalars['DateTime']>;
  replyPerson?: InputMaybe<Scalars['String']>;
  sendDate?: InputMaybe<Scalars['DateTime']>;
};

export type ContactHistoryListRelationFilter = {
  every?: InputMaybe<ContactHistoryWhereInput>;
  none?: InputMaybe<ContactHistoryWhereInput>;
  some?: InputMaybe<ContactHistoryWhereInput>;
};

export type ContactHistoryOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ContactHistoryOrderByWithRelationInput = {
  addressees?: InputMaybe<SortOrder>;
  approverProcess?: InputMaybe<ApproverProcessOrderByWithRelationInput>;
  approverProcessId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  deletedBy?: InputMaybe<SortOrder>;
  isMail?: InputMaybe<SortOrder>;
  project?: InputMaybe<MasterOrderByWithRelationInput>;
  projectId?: InputMaybe<SortOrder>;
  reply?: InputMaybe<SortOrder>;
  replyComment?: InputMaybe<SortOrder>;
  replyDate?: InputMaybe<SortOrder>;
  replyPerson?: InputMaybe<SortOrder>;
  rowNumber?: InputMaybe<SortOrder>;
  sendDate?: InputMaybe<SortOrder>;
};

export enum ContactHistoryScalarFieldEnum {
  Addressees = 'addressees',
  ApproverProcessId = 'approverProcessId',
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  DeletedAt = 'deletedAt',
  DeletedBy = 'deletedBy',
  IsMail = 'isMail',
  ProjectId = 'projectId',
  Reply = 'reply',
  ReplyComment = 'replyComment',
  ReplyDate = 'replyDate',
  ReplyPerson = 'replyPerson',
  RowNumber = 'rowNumber',
  SendDate = 'sendDate'
}

export type ContactHistoryScalarWhereInput = {
  AND?: InputMaybe<Array<ContactHistoryScalarWhereInput>>;
  NOT?: InputMaybe<Array<ContactHistoryScalarWhereInput>>;
  OR?: InputMaybe<Array<ContactHistoryScalarWhereInput>>;
  addressees?: InputMaybe<StringNullableFilter>;
  approverProcessId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  isMail?: InputMaybe<BoolFilter>;
  projectId?: InputMaybe<StringFilter>;
  reply?: InputMaybe<StringNullableFilter>;
  replyComment?: InputMaybe<StringNullableFilter>;
  replyDate?: InputMaybe<DateTimeNullableFilter>;
  replyPerson?: InputMaybe<StringNullableFilter>;
  rowNumber?: InputMaybe<IntFilter>;
  sendDate?: InputMaybe<DateTimeNullableFilter>;
};

export type ContactHistoryUpdateInput = {
  addressees?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approverProcess?: InputMaybe<ApproverProcessUpdateOneRequiredWithoutContactHistoryNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isMail?: InputMaybe<BoolFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutContactHistoryNestedInput>;
  reply?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  replyComment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  replyDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  replyPerson?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sendDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type ContactHistoryUpdateManyMutationInput = {
  addressees?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isMail?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reply?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  replyComment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  replyDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  replyPerson?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sendDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type ContactHistoryUpdateManyWithWhereWithoutApproverProcessInput = {
  data: ContactHistoryUpdateManyMutationInput;
  where: ContactHistoryScalarWhereInput;
};

export type ContactHistoryUpdateManyWithWhereWithoutProjectInput = {
  data: ContactHistoryUpdateManyMutationInput;
  where: ContactHistoryScalarWhereInput;
};

export type ContactHistoryUpdateManyWithoutApproverProcessNestedInput = {
  connect?: InputMaybe<Array<ContactHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContactHistoryCreateOrConnectWithoutApproverProcessInput>>;
  create?: InputMaybe<Array<ContactHistoryCreateWithoutApproverProcessInput>>;
  createMany?: InputMaybe<ContactHistoryCreateManyApproverProcessInputEnvelope>;
  delete?: InputMaybe<Array<ContactHistoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ContactHistoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ContactHistoryWhereUniqueInput>>;
  set?: InputMaybe<Array<ContactHistoryWhereUniqueInput>>;
  update?: InputMaybe<Array<ContactHistoryUpdateWithWhereUniqueWithoutApproverProcessInput>>;
  updateMany?: InputMaybe<Array<ContactHistoryUpdateManyWithWhereWithoutApproverProcessInput>>;
  upsert?: InputMaybe<Array<ContactHistoryUpsertWithWhereUniqueWithoutApproverProcessInput>>;
};

export type ContactHistoryUpdateManyWithoutProjectNestedInput = {
  connect?: InputMaybe<Array<ContactHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ContactHistoryCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<ContactHistoryCreateWithoutProjectInput>>;
  createMany?: InputMaybe<ContactHistoryCreateManyProjectInputEnvelope>;
  delete?: InputMaybe<Array<ContactHistoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ContactHistoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ContactHistoryWhereUniqueInput>>;
  set?: InputMaybe<Array<ContactHistoryWhereUniqueInput>>;
  update?: InputMaybe<Array<ContactHistoryUpdateWithWhereUniqueWithoutProjectInput>>;
  updateMany?: InputMaybe<Array<ContactHistoryUpdateManyWithWhereWithoutProjectInput>>;
  upsert?: InputMaybe<Array<ContactHistoryUpsertWithWhereUniqueWithoutProjectInput>>;
};

export type ContactHistoryUpdateWithWhereUniqueWithoutApproverProcessInput = {
  data: ContactHistoryUpdateWithoutApproverProcessInput;
  where: ContactHistoryWhereUniqueInput;
};

export type ContactHistoryUpdateWithWhereUniqueWithoutProjectInput = {
  data: ContactHistoryUpdateWithoutProjectInput;
  where: ContactHistoryWhereUniqueInput;
};

export type ContactHistoryUpdateWithoutApproverProcessInput = {
  addressees?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isMail?: InputMaybe<BoolFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutContactHistoryNestedInput>;
  reply?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  replyComment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  replyDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  replyPerson?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sendDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type ContactHistoryUpdateWithoutProjectInput = {
  addressees?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  approverProcess?: InputMaybe<ApproverProcessUpdateOneRequiredWithoutContactHistoryNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isMail?: InputMaybe<BoolFieldUpdateOperationsInput>;
  reply?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  replyComment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  replyDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  replyPerson?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sendDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type ContactHistoryUpsertWithWhereUniqueWithoutApproverProcessInput = {
  create: ContactHistoryCreateWithoutApproverProcessInput;
  update: ContactHistoryUpdateWithoutApproverProcessInput;
  where: ContactHistoryWhereUniqueInput;
};

export type ContactHistoryUpsertWithWhereUniqueWithoutProjectInput = {
  create: ContactHistoryCreateWithoutProjectInput;
  update: ContactHistoryUpdateWithoutProjectInput;
  where: ContactHistoryWhereUniqueInput;
};

export type ContactHistoryWhereInput = {
  AND?: InputMaybe<Array<ContactHistoryWhereInput>>;
  NOT?: InputMaybe<Array<ContactHistoryWhereInput>>;
  OR?: InputMaybe<Array<ContactHistoryWhereInput>>;
  addressees?: InputMaybe<StringNullableFilter>;
  approverProcess?: InputMaybe<ApproverProcessWhereInput>;
  approverProcessId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  isMail?: InputMaybe<BoolFilter>;
  project?: InputMaybe<MasterWhereInput>;
  projectId?: InputMaybe<StringFilter>;
  reply?: InputMaybe<StringNullableFilter>;
  replyComment?: InputMaybe<StringNullableFilter>;
  replyDate?: InputMaybe<DateTimeNullableFilter>;
  replyPerson?: InputMaybe<StringNullableFilter>;
  rowNumber?: InputMaybe<IntFilter>;
  sendDate?: InputMaybe<DateTimeNullableFilter>;
};

export type ContactHistoryWhereUniqueInput = {
  rowNumber?: InputMaybe<Scalars['Int']>;
};

export type DashboardProject = {
  __typename?: 'DashboardProject';
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  order?: Maybe<Scalars['Int']>;
  project: Master;
  projectId: Scalars['String'];
};

export type DashboardProjectCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  project: MasterCreateNestedOneWithoutDashboardProjectInput;
};

export type DashboardProjectCreateManyProjectInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
};

export type DashboardProjectCreateManyProjectInputEnvelope = {
  data: Array<DashboardProjectCreateManyProjectInput>;
};

export type DashboardProjectCreateNestedManyWithoutProjectInput = {
  connect?: InputMaybe<Array<DashboardProjectWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DashboardProjectCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<DashboardProjectCreateWithoutProjectInput>>;
  createMany?: InputMaybe<DashboardProjectCreateManyProjectInputEnvelope>;
};

export type DashboardProjectCreateOrConnectWithoutProjectInput = {
  create: DashboardProjectCreateWithoutProjectInput;
  where: DashboardProjectWhereUniqueInput;
};

export type DashboardProjectCreateWithoutProjectInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
};

export type DashboardProjectListRelationFilter = {
  every?: InputMaybe<DashboardProjectWhereInput>;
  none?: InputMaybe<DashboardProjectWhereInput>;
  some?: InputMaybe<DashboardProjectWhereInput>;
};

export type DashboardProjectOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DashboardProjectOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  deletedBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  project?: InputMaybe<MasterOrderByWithRelationInput>;
  projectId?: InputMaybe<SortOrder>;
};

export enum DashboardProjectScalarFieldEnum {
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  DeletedAt = 'deletedAt',
  DeletedBy = 'deletedBy',
  Id = 'id',
  Order = 'order',
  ProjectId = 'projectId'
}

export type DashboardProjectScalarWhereInput = {
  AND?: InputMaybe<Array<DashboardProjectScalarWhereInput>>;
  NOT?: InputMaybe<Array<DashboardProjectScalarWhereInput>>;
  OR?: InputMaybe<Array<DashboardProjectScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntNullableFilter>;
  projectId?: InputMaybe<StringFilter>;
};

export type DashboardProjectUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutDashboardProjectNestedInput>;
};

export type DashboardProjectUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type DashboardProjectUpdateManyWithWhereWithoutProjectInput = {
  data: DashboardProjectUpdateManyMutationInput;
  where: DashboardProjectScalarWhereInput;
};

export type DashboardProjectUpdateManyWithoutProjectNestedInput = {
  connect?: InputMaybe<Array<DashboardProjectWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DashboardProjectCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<DashboardProjectCreateWithoutProjectInput>>;
  createMany?: InputMaybe<DashboardProjectCreateManyProjectInputEnvelope>;
  delete?: InputMaybe<Array<DashboardProjectWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DashboardProjectScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DashboardProjectWhereUniqueInput>>;
  set?: InputMaybe<Array<DashboardProjectWhereUniqueInput>>;
  update?: InputMaybe<Array<DashboardProjectUpdateWithWhereUniqueWithoutProjectInput>>;
  updateMany?: InputMaybe<Array<DashboardProjectUpdateManyWithWhereWithoutProjectInput>>;
  upsert?: InputMaybe<Array<DashboardProjectUpsertWithWhereUniqueWithoutProjectInput>>;
};

export type DashboardProjectUpdateWithWhereUniqueWithoutProjectInput = {
  data: DashboardProjectUpdateWithoutProjectInput;
  where: DashboardProjectWhereUniqueInput;
};

export type DashboardProjectUpdateWithoutProjectInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type DashboardProjectUpsertWithWhereUniqueWithoutProjectInput = {
  create: DashboardProjectCreateWithoutProjectInput;
  update: DashboardProjectUpdateWithoutProjectInput;
  where: DashboardProjectWhereUniqueInput;
};

export type DashboardProjectWhereInput = {
  AND?: InputMaybe<Array<DashboardProjectWhereInput>>;
  NOT?: InputMaybe<Array<DashboardProjectWhereInput>>;
  OR?: InputMaybe<Array<DashboardProjectWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntNullableFilter>;
  project?: InputMaybe<MasterWhereInput>;
  projectId?: InputMaybe<StringFilter>;
};

export type DashboardProjectWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type DateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['DateTime']>;
};

export type DateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type DateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type DateTimeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedDateTimeNullableFilter>;
  _min?: InputMaybe<NestedDateTimeNullableFilter>;
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type DateTimeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedDateTimeFilter>;
  _min?: InputMaybe<NestedDateTimeFilter>;
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type EmailHistory = {
  __typename?: 'EmailHistory';
  approver: ApprovalBoard;
  approverId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  input: Scalars['String'];
  project: Master;
  projectId: Scalars['String'];
  rowNumber?: Maybe<Scalars['Int']>;
};

export type EmailHistoryCreateInput = {
  approver: ApprovalBoardCreateNestedOneWithoutEmailInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  input: Scalars['String'];
  project: MasterCreateNestedOneWithoutEmailInput;
  rowNumber?: InputMaybe<Scalars['Int']>;
};

export type EmailHistoryCreateManyApproverInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  input: Scalars['String'];
  projectId: Scalars['String'];
};

export type EmailHistoryCreateManyApproverInputEnvelope = {
  data: Array<EmailHistoryCreateManyApproverInput>;
};

export type EmailHistoryCreateManyProjectInput = {
  approverId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  input: Scalars['String'];
};

export type EmailHistoryCreateManyProjectInputEnvelope = {
  data: Array<EmailHistoryCreateManyProjectInput>;
};

export type EmailHistoryCreateNestedManyWithoutApproverInput = {
  connect?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EmailHistoryCreateOrConnectWithoutApproverInput>>;
  create?: InputMaybe<Array<EmailHistoryCreateWithoutApproverInput>>;
  createMany?: InputMaybe<EmailHistoryCreateManyApproverInputEnvelope>;
};

export type EmailHistoryCreateNestedManyWithoutProjectInput = {
  connect?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EmailHistoryCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<EmailHistoryCreateWithoutProjectInput>>;
  createMany?: InputMaybe<EmailHistoryCreateManyProjectInputEnvelope>;
};

export type EmailHistoryCreateOrConnectWithoutApproverInput = {
  create: EmailHistoryCreateWithoutApproverInput;
  where: EmailHistoryWhereUniqueInput;
};

export type EmailHistoryCreateOrConnectWithoutProjectInput = {
  create: EmailHistoryCreateWithoutProjectInput;
  where: EmailHistoryWhereUniqueInput;
};

export type EmailHistoryCreateWithoutApproverInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  input: Scalars['String'];
  project: MasterCreateNestedOneWithoutEmailInput;
  rowNumber?: InputMaybe<Scalars['Int']>;
};

export type EmailHistoryCreateWithoutProjectInput = {
  approver: ApprovalBoardCreateNestedOneWithoutEmailInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  input: Scalars['String'];
  rowNumber?: InputMaybe<Scalars['Int']>;
};

export type EmailHistoryListRelationFilter = {
  every?: InputMaybe<EmailHistoryWhereInput>;
  none?: InputMaybe<EmailHistoryWhereInput>;
  some?: InputMaybe<EmailHistoryWhereInput>;
};

export type EmailHistoryOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type EmailHistoryOrderByWithRelationInput = {
  approver?: InputMaybe<ApprovalBoardOrderByWithRelationInput>;
  approverId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  deletedBy?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  input?: InputMaybe<SortOrder>;
  project?: InputMaybe<MasterOrderByWithRelationInput>;
  projectId?: InputMaybe<SortOrder>;
  rowNumber?: InputMaybe<SortOrder>;
};

export enum EmailHistoryScalarFieldEnum {
  ApproverId = 'approverId',
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  DeletedAt = 'deletedAt',
  DeletedBy = 'deletedBy',
  Description = 'description',
  Id = 'id',
  Input = 'input',
  ProjectId = 'projectId',
  RowNumber = 'rowNumber'
}

export type EmailHistoryScalarWhereInput = {
  AND?: InputMaybe<Array<EmailHistoryScalarWhereInput>>;
  NOT?: InputMaybe<Array<EmailHistoryScalarWhereInput>>;
  OR?: InputMaybe<Array<EmailHistoryScalarWhereInput>>;
  approverId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  input?: InputMaybe<StringFilter>;
  projectId?: InputMaybe<StringFilter>;
  rowNumber?: InputMaybe<IntNullableFilter>;
};

export type EmailHistoryUpdateInput = {
  approver?: InputMaybe<ApprovalBoardUpdateOneRequiredWithoutEmailNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  input?: InputMaybe<StringFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutEmailNestedInput>;
  rowNumber?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type EmailHistoryUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  input?: InputMaybe<StringFieldUpdateOperationsInput>;
  rowNumber?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type EmailHistoryUpdateManyWithWhereWithoutApproverInput = {
  data: EmailHistoryUpdateManyMutationInput;
  where: EmailHistoryScalarWhereInput;
};

export type EmailHistoryUpdateManyWithWhereWithoutProjectInput = {
  data: EmailHistoryUpdateManyMutationInput;
  where: EmailHistoryScalarWhereInput;
};

export type EmailHistoryUpdateManyWithoutApproverNestedInput = {
  connect?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EmailHistoryCreateOrConnectWithoutApproverInput>>;
  create?: InputMaybe<Array<EmailHistoryCreateWithoutApproverInput>>;
  createMany?: InputMaybe<EmailHistoryCreateManyApproverInputEnvelope>;
  delete?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<EmailHistoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  set?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  update?: InputMaybe<Array<EmailHistoryUpdateWithWhereUniqueWithoutApproverInput>>;
  updateMany?: InputMaybe<Array<EmailHistoryUpdateManyWithWhereWithoutApproverInput>>;
  upsert?: InputMaybe<Array<EmailHistoryUpsertWithWhereUniqueWithoutApproverInput>>;
};

export type EmailHistoryUpdateManyWithoutProjectNestedInput = {
  connect?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EmailHistoryCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<EmailHistoryCreateWithoutProjectInput>>;
  createMany?: InputMaybe<EmailHistoryCreateManyProjectInputEnvelope>;
  delete?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<EmailHistoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  set?: InputMaybe<Array<EmailHistoryWhereUniqueInput>>;
  update?: InputMaybe<Array<EmailHistoryUpdateWithWhereUniqueWithoutProjectInput>>;
  updateMany?: InputMaybe<Array<EmailHistoryUpdateManyWithWhereWithoutProjectInput>>;
  upsert?: InputMaybe<Array<EmailHistoryUpsertWithWhereUniqueWithoutProjectInput>>;
};

export type EmailHistoryUpdateWithWhereUniqueWithoutApproverInput = {
  data: EmailHistoryUpdateWithoutApproverInput;
  where: EmailHistoryWhereUniqueInput;
};

export type EmailHistoryUpdateWithWhereUniqueWithoutProjectInput = {
  data: EmailHistoryUpdateWithoutProjectInput;
  where: EmailHistoryWhereUniqueInput;
};

export type EmailHistoryUpdateWithoutApproverInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  input?: InputMaybe<StringFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutEmailNestedInput>;
  rowNumber?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type EmailHistoryUpdateWithoutProjectInput = {
  approver?: InputMaybe<ApprovalBoardUpdateOneRequiredWithoutEmailNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  input?: InputMaybe<StringFieldUpdateOperationsInput>;
  rowNumber?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type EmailHistoryUpsertWithWhereUniqueWithoutApproverInput = {
  create: EmailHistoryCreateWithoutApproverInput;
  update: EmailHistoryUpdateWithoutApproverInput;
  where: EmailHistoryWhereUniqueInput;
};

export type EmailHistoryUpsertWithWhereUniqueWithoutProjectInput = {
  create: EmailHistoryCreateWithoutProjectInput;
  update: EmailHistoryUpdateWithoutProjectInput;
  where: EmailHistoryWhereUniqueInput;
};

export type EmailHistoryWhereInput = {
  AND?: InputMaybe<Array<EmailHistoryWhereInput>>;
  NOT?: InputMaybe<Array<EmailHistoryWhereInput>>;
  OR?: InputMaybe<Array<EmailHistoryWhereInput>>;
  approver?: InputMaybe<ApprovalBoardWhereInput>;
  approverId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  input?: InputMaybe<StringFilter>;
  project?: InputMaybe<MasterWhereInput>;
  projectId?: InputMaybe<StringFilter>;
  rowNumber?: InputMaybe<IntNullableFilter>;
};

export type EmailHistoryWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type Employee = {
  __typename?: 'Employee';
  EmployeeMaster?: Maybe<Array<EmployeeMaster>>;
  ProjectInterface?: Maybe<Array<ProjectInterface>>;
  ProjectResourceCapture?: Maybe<Array<ProjectResourceCapture>>;
  ProjectRole?: Maybe<Array<ProjectRole>>;
  Risk?: Maybe<Array<Risk>>;
  _count: EmployeeCount;
  addresseeGroup?: Maybe<Array<AddresseeGroup>>;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
};

export type EmployeeCount = {
  __typename?: 'EmployeeCount';
  EmployeeMaster: Scalars['Int'];
  ProjectInterface: Scalars['Int'];
  ProjectResourceCapture: Scalars['Int'];
  ProjectRole: Scalars['Int'];
  Risk: Scalars['Int'];
  addresseeGroup: Scalars['Int'];
};

export type EmployeeCreateInput = {
  EmployeeMaster?: InputMaybe<EmployeeMasterCreateNestedManyWithoutEmployeeInput>;
  ProjectInterface?: InputMaybe<ProjectInterfaceCreateNestedManyWithoutEmployeeInput>;
  ProjectResourceCapture?: InputMaybe<ProjectResourceCaptureCreateNestedManyWithoutEmployeeInput>;
  ProjectRole?: InputMaybe<ProjectRoleCreateNestedManyWithoutEmployeeInput>;
  Risk?: InputMaybe<RiskCreateNestedManyWithoutEmployeeInput>;
  addresseeGroup?: InputMaybe<AddresseeGroupCreateNestedManyWithoutEmployeeInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
};

export type EmployeeCreateNestedOneWithoutAddresseeGroupInput = {
  connect?: InputMaybe<EmployeeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EmployeeCreateOrConnectWithoutAddresseeGroupInput>;
  create?: InputMaybe<EmployeeCreateWithoutAddresseeGroupInput>;
};

export type EmployeeCreateNestedOneWithoutEmployeeMasterInput = {
  connect?: InputMaybe<EmployeeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EmployeeCreateOrConnectWithoutEmployeeMasterInput>;
  create?: InputMaybe<EmployeeCreateWithoutEmployeeMasterInput>;
};

export type EmployeeCreateNestedOneWithoutProjectInterfaceInput = {
  connect?: InputMaybe<EmployeeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EmployeeCreateOrConnectWithoutProjectInterfaceInput>;
  create?: InputMaybe<EmployeeCreateWithoutProjectInterfaceInput>;
};

export type EmployeeCreateNestedOneWithoutProjectResourceCaptureInput = {
  connect?: InputMaybe<EmployeeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EmployeeCreateOrConnectWithoutProjectResourceCaptureInput>;
  create?: InputMaybe<EmployeeCreateWithoutProjectResourceCaptureInput>;
};

export type EmployeeCreateNestedOneWithoutProjectRoleInput = {
  connect?: InputMaybe<EmployeeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EmployeeCreateOrConnectWithoutProjectRoleInput>;
  create?: InputMaybe<EmployeeCreateWithoutProjectRoleInput>;
};

export type EmployeeCreateNestedOneWithoutRiskInput = {
  connect?: InputMaybe<EmployeeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EmployeeCreateOrConnectWithoutRiskInput>;
  create?: InputMaybe<EmployeeCreateWithoutRiskInput>;
};

export type EmployeeCreateOrConnectWithoutAddresseeGroupInput = {
  create: EmployeeCreateWithoutAddresseeGroupInput;
  where: EmployeeWhereUniqueInput;
};

export type EmployeeCreateOrConnectWithoutEmployeeMasterInput = {
  create: EmployeeCreateWithoutEmployeeMasterInput;
  where: EmployeeWhereUniqueInput;
};

export type EmployeeCreateOrConnectWithoutProjectInterfaceInput = {
  create: EmployeeCreateWithoutProjectInterfaceInput;
  where: EmployeeWhereUniqueInput;
};

export type EmployeeCreateOrConnectWithoutProjectResourceCaptureInput = {
  create: EmployeeCreateWithoutProjectResourceCaptureInput;
  where: EmployeeWhereUniqueInput;
};

export type EmployeeCreateOrConnectWithoutProjectRoleInput = {
  create: EmployeeCreateWithoutProjectRoleInput;
  where: EmployeeWhereUniqueInput;
};

export type EmployeeCreateOrConnectWithoutRiskInput = {
  create: EmployeeCreateWithoutRiskInput;
  where: EmployeeWhereUniqueInput;
};

export type EmployeeCreateWithoutAddresseeGroupInput = {
  EmployeeMaster?: InputMaybe<EmployeeMasterCreateNestedManyWithoutEmployeeInput>;
  ProjectInterface?: InputMaybe<ProjectInterfaceCreateNestedManyWithoutEmployeeInput>;
  ProjectResourceCapture?: InputMaybe<ProjectResourceCaptureCreateNestedManyWithoutEmployeeInput>;
  ProjectRole?: InputMaybe<ProjectRoleCreateNestedManyWithoutEmployeeInput>;
  Risk?: InputMaybe<RiskCreateNestedManyWithoutEmployeeInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
};

export type EmployeeCreateWithoutEmployeeMasterInput = {
  ProjectInterface?: InputMaybe<ProjectInterfaceCreateNestedManyWithoutEmployeeInput>;
  ProjectResourceCapture?: InputMaybe<ProjectResourceCaptureCreateNestedManyWithoutEmployeeInput>;
  ProjectRole?: InputMaybe<ProjectRoleCreateNestedManyWithoutEmployeeInput>;
  Risk?: InputMaybe<RiskCreateNestedManyWithoutEmployeeInput>;
  addresseeGroup?: InputMaybe<AddresseeGroupCreateNestedManyWithoutEmployeeInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
};

export type EmployeeCreateWithoutProjectInterfaceInput = {
  EmployeeMaster?: InputMaybe<EmployeeMasterCreateNestedManyWithoutEmployeeInput>;
  ProjectResourceCapture?: InputMaybe<ProjectResourceCaptureCreateNestedManyWithoutEmployeeInput>;
  ProjectRole?: InputMaybe<ProjectRoleCreateNestedManyWithoutEmployeeInput>;
  Risk?: InputMaybe<RiskCreateNestedManyWithoutEmployeeInput>;
  addresseeGroup?: InputMaybe<AddresseeGroupCreateNestedManyWithoutEmployeeInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
};

export type EmployeeCreateWithoutProjectResourceCaptureInput = {
  EmployeeMaster?: InputMaybe<EmployeeMasterCreateNestedManyWithoutEmployeeInput>;
  ProjectInterface?: InputMaybe<ProjectInterfaceCreateNestedManyWithoutEmployeeInput>;
  ProjectRole?: InputMaybe<ProjectRoleCreateNestedManyWithoutEmployeeInput>;
  Risk?: InputMaybe<RiskCreateNestedManyWithoutEmployeeInput>;
  addresseeGroup?: InputMaybe<AddresseeGroupCreateNestedManyWithoutEmployeeInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
};

export type EmployeeCreateWithoutProjectRoleInput = {
  EmployeeMaster?: InputMaybe<EmployeeMasterCreateNestedManyWithoutEmployeeInput>;
  ProjectInterface?: InputMaybe<ProjectInterfaceCreateNestedManyWithoutEmployeeInput>;
  ProjectResourceCapture?: InputMaybe<ProjectResourceCaptureCreateNestedManyWithoutEmployeeInput>;
  Risk?: InputMaybe<RiskCreateNestedManyWithoutEmployeeInput>;
  addresseeGroup?: InputMaybe<AddresseeGroupCreateNestedManyWithoutEmployeeInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
};

export type EmployeeCreateWithoutRiskInput = {
  EmployeeMaster?: InputMaybe<EmployeeMasterCreateNestedManyWithoutEmployeeInput>;
  ProjectInterface?: InputMaybe<ProjectInterfaceCreateNestedManyWithoutEmployeeInput>;
  ProjectResourceCapture?: InputMaybe<ProjectResourceCaptureCreateNestedManyWithoutEmployeeInput>;
  ProjectRole?: InputMaybe<ProjectRoleCreateNestedManyWithoutEmployeeInput>;
  addresseeGroup?: InputMaybe<AddresseeGroupCreateNestedManyWithoutEmployeeInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
};

export type EmployeeMaster = {
  __typename?: 'EmployeeMaster';
  employee: Employee;
  employeeId: Scalars['String'];
  project: Master;
  projectId: Scalars['String'];
  status: Scalars['Int'];
};

export type EmployeeMasterCreateInput = {
  employee: EmployeeCreateNestedOneWithoutEmployeeMasterInput;
  project: MasterCreateNestedOneWithoutEmployeeMasterInput;
  status: Scalars['Int'];
};

export type EmployeeMasterCreateManyEmployeeInput = {
  projectId: Scalars['String'];
  status: Scalars['Int'];
};

export type EmployeeMasterCreateManyEmployeeInputEnvelope = {
  data: Array<EmployeeMasterCreateManyEmployeeInput>;
};

export type EmployeeMasterCreateManyProjectInput = {
  employeeId: Scalars['String'];
  status: Scalars['Int'];
};

export type EmployeeMasterCreateManyProjectInputEnvelope = {
  data: Array<EmployeeMasterCreateManyProjectInput>;
};

export type EmployeeMasterCreateNestedManyWithoutEmployeeInput = {
  connect?: InputMaybe<Array<EmployeeMasterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EmployeeMasterCreateOrConnectWithoutEmployeeInput>>;
  create?: InputMaybe<Array<EmployeeMasterCreateWithoutEmployeeInput>>;
  createMany?: InputMaybe<EmployeeMasterCreateManyEmployeeInputEnvelope>;
};

export type EmployeeMasterCreateNestedManyWithoutProjectInput = {
  connect?: InputMaybe<Array<EmployeeMasterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EmployeeMasterCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<EmployeeMasterCreateWithoutProjectInput>>;
  createMany?: InputMaybe<EmployeeMasterCreateManyProjectInputEnvelope>;
};

export type EmployeeMasterCreateOrConnectWithoutEmployeeInput = {
  create: EmployeeMasterCreateWithoutEmployeeInput;
  where: EmployeeMasterWhereUniqueInput;
};

export type EmployeeMasterCreateOrConnectWithoutProjectInput = {
  create: EmployeeMasterCreateWithoutProjectInput;
  where: EmployeeMasterWhereUniqueInput;
};

export type EmployeeMasterCreateWithoutEmployeeInput = {
  project: MasterCreateNestedOneWithoutEmployeeMasterInput;
  status: Scalars['Int'];
};

export type EmployeeMasterCreateWithoutProjectInput = {
  employee: EmployeeCreateNestedOneWithoutEmployeeMasterInput;
  status: Scalars['Int'];
};

export type EmployeeMasterListRelationFilter = {
  every?: InputMaybe<EmployeeMasterWhereInput>;
  none?: InputMaybe<EmployeeMasterWhereInput>;
  some?: InputMaybe<EmployeeMasterWhereInput>;
};

export type EmployeeMasterOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type EmployeeMasterOrderByWithRelationInput = {
  employee?: InputMaybe<EmployeeOrderByWithRelationInput>;
  employeeId?: InputMaybe<SortOrder>;
  project?: InputMaybe<MasterOrderByWithRelationInput>;
  projectId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export type EmployeeMasterProjectIdEmployeeIdCompoundUniqueInput = {
  employeeId: Scalars['String'];
  projectId: Scalars['String'];
};

export enum EmployeeMasterScalarFieldEnum {
  EmployeeId = 'employeeId',
  ProjectId = 'projectId',
  Status = 'status'
}

export type EmployeeMasterScalarWhereInput = {
  AND?: InputMaybe<Array<EmployeeMasterScalarWhereInput>>;
  NOT?: InputMaybe<Array<EmployeeMasterScalarWhereInput>>;
  OR?: InputMaybe<Array<EmployeeMasterScalarWhereInput>>;
  employeeId?: InputMaybe<StringFilter>;
  projectId?: InputMaybe<StringFilter>;
  status?: InputMaybe<IntFilter>;
};

export type EmployeeMasterUpdateInput = {
  employee?: InputMaybe<EmployeeUpdateOneRequiredWithoutEmployeeMasterNestedInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutEmployeeMasterNestedInput>;
  status?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type EmployeeMasterUpdateManyMutationInput = {
  status?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type EmployeeMasterUpdateManyWithWhereWithoutEmployeeInput = {
  data: EmployeeMasterUpdateManyMutationInput;
  where: EmployeeMasterScalarWhereInput;
};

export type EmployeeMasterUpdateManyWithWhereWithoutProjectInput = {
  data: EmployeeMasterUpdateManyMutationInput;
  where: EmployeeMasterScalarWhereInput;
};

export type EmployeeMasterUpdateManyWithoutEmployeeNestedInput = {
  connect?: InputMaybe<Array<EmployeeMasterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EmployeeMasterCreateOrConnectWithoutEmployeeInput>>;
  create?: InputMaybe<Array<EmployeeMasterCreateWithoutEmployeeInput>>;
  createMany?: InputMaybe<EmployeeMasterCreateManyEmployeeInputEnvelope>;
  delete?: InputMaybe<Array<EmployeeMasterWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<EmployeeMasterScalarWhereInput>>;
  disconnect?: InputMaybe<Array<EmployeeMasterWhereUniqueInput>>;
  set?: InputMaybe<Array<EmployeeMasterWhereUniqueInput>>;
  update?: InputMaybe<Array<EmployeeMasterUpdateWithWhereUniqueWithoutEmployeeInput>>;
  updateMany?: InputMaybe<Array<EmployeeMasterUpdateManyWithWhereWithoutEmployeeInput>>;
  upsert?: InputMaybe<Array<EmployeeMasterUpsertWithWhereUniqueWithoutEmployeeInput>>;
};

export type EmployeeMasterUpdateManyWithoutProjectNestedInput = {
  connect?: InputMaybe<Array<EmployeeMasterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<EmployeeMasterCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<EmployeeMasterCreateWithoutProjectInput>>;
  createMany?: InputMaybe<EmployeeMasterCreateManyProjectInputEnvelope>;
  delete?: InputMaybe<Array<EmployeeMasterWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<EmployeeMasterScalarWhereInput>>;
  disconnect?: InputMaybe<Array<EmployeeMasterWhereUniqueInput>>;
  set?: InputMaybe<Array<EmployeeMasterWhereUniqueInput>>;
  update?: InputMaybe<Array<EmployeeMasterUpdateWithWhereUniqueWithoutProjectInput>>;
  updateMany?: InputMaybe<Array<EmployeeMasterUpdateManyWithWhereWithoutProjectInput>>;
  upsert?: InputMaybe<Array<EmployeeMasterUpsertWithWhereUniqueWithoutProjectInput>>;
};

export type EmployeeMasterUpdateWithWhereUniqueWithoutEmployeeInput = {
  data: EmployeeMasterUpdateWithoutEmployeeInput;
  where: EmployeeMasterWhereUniqueInput;
};

export type EmployeeMasterUpdateWithWhereUniqueWithoutProjectInput = {
  data: EmployeeMasterUpdateWithoutProjectInput;
  where: EmployeeMasterWhereUniqueInput;
};

export type EmployeeMasterUpdateWithoutEmployeeInput = {
  project?: InputMaybe<MasterUpdateOneRequiredWithoutEmployeeMasterNestedInput>;
  status?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type EmployeeMasterUpdateWithoutProjectInput = {
  employee?: InputMaybe<EmployeeUpdateOneRequiredWithoutEmployeeMasterNestedInput>;
  status?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type EmployeeMasterUpsertWithWhereUniqueWithoutEmployeeInput = {
  create: EmployeeMasterCreateWithoutEmployeeInput;
  update: EmployeeMasterUpdateWithoutEmployeeInput;
  where: EmployeeMasterWhereUniqueInput;
};

export type EmployeeMasterUpsertWithWhereUniqueWithoutProjectInput = {
  create: EmployeeMasterCreateWithoutProjectInput;
  update: EmployeeMasterUpdateWithoutProjectInput;
  where: EmployeeMasterWhereUniqueInput;
};

export type EmployeeMasterWhereInput = {
  AND?: InputMaybe<Array<EmployeeMasterWhereInput>>;
  NOT?: InputMaybe<Array<EmployeeMasterWhereInput>>;
  OR?: InputMaybe<Array<EmployeeMasterWhereInput>>;
  employee?: InputMaybe<EmployeeWhereInput>;
  employeeId?: InputMaybe<StringFilter>;
  project?: InputMaybe<MasterWhereInput>;
  projectId?: InputMaybe<StringFilter>;
  status?: InputMaybe<IntFilter>;
};

export type EmployeeMasterWhereUniqueInput = {
  projectId_employeeId?: InputMaybe<EmployeeMasterProjectIdEmployeeIdCompoundUniqueInput>;
};

export type EmployeeOrderByWithRelationInput = {
  EmployeeMaster?: InputMaybe<EmployeeMasterOrderByRelationAggregateInput>;
  ProjectInterface?: InputMaybe<ProjectInterfaceOrderByRelationAggregateInput>;
  ProjectResourceCapture?: InputMaybe<ProjectResourceCaptureOrderByRelationAggregateInput>;
  ProjectRole?: InputMaybe<ProjectRoleOrderByRelationAggregateInput>;
  Risk?: InputMaybe<RiskOrderByRelationAggregateInput>;
  addresseeGroup?: InputMaybe<AddresseeGroupOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  deletedBy?: InputMaybe<SortOrder>;
  department?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
};

export enum EmployeeScalarFieldEnum {
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  DeletedAt = 'deletedAt',
  DeletedBy = 'deletedBy',
  Department = 'department',
  Email = 'email',
  FirstName = 'firstName',
  Id = 'id',
  LastName = 'lastName'
}

export type EmployeeUpdateInput = {
  EmployeeMaster?: InputMaybe<EmployeeMasterUpdateManyWithoutEmployeeNestedInput>;
  ProjectInterface?: InputMaybe<ProjectInterfaceUpdateManyWithoutEmployeeNestedInput>;
  ProjectResourceCapture?: InputMaybe<ProjectResourceCaptureUpdateManyWithoutEmployeeNestedInput>;
  ProjectRole?: InputMaybe<ProjectRoleUpdateManyWithoutEmployeeNestedInput>;
  Risk?: InputMaybe<RiskUpdateManyWithoutEmployeeNestedInput>;
  addresseeGroup?: InputMaybe<AddresseeGroupUpdateManyWithoutEmployeeNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  department?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EmployeeUpdateOneRequiredWithoutAddresseeGroupNestedInput = {
  connect?: InputMaybe<EmployeeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EmployeeCreateOrConnectWithoutAddresseeGroupInput>;
  create?: InputMaybe<EmployeeCreateWithoutAddresseeGroupInput>;
  update?: InputMaybe<EmployeeUpdateWithoutAddresseeGroupInput>;
  upsert?: InputMaybe<EmployeeUpsertWithoutAddresseeGroupInput>;
};

export type EmployeeUpdateOneRequiredWithoutEmployeeMasterNestedInput = {
  connect?: InputMaybe<EmployeeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EmployeeCreateOrConnectWithoutEmployeeMasterInput>;
  create?: InputMaybe<EmployeeCreateWithoutEmployeeMasterInput>;
  update?: InputMaybe<EmployeeUpdateWithoutEmployeeMasterInput>;
  upsert?: InputMaybe<EmployeeUpsertWithoutEmployeeMasterInput>;
};

export type EmployeeUpdateOneRequiredWithoutProjectInterfaceNestedInput = {
  connect?: InputMaybe<EmployeeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EmployeeCreateOrConnectWithoutProjectInterfaceInput>;
  create?: InputMaybe<EmployeeCreateWithoutProjectInterfaceInput>;
  update?: InputMaybe<EmployeeUpdateWithoutProjectInterfaceInput>;
  upsert?: InputMaybe<EmployeeUpsertWithoutProjectInterfaceInput>;
};

export type EmployeeUpdateOneRequiredWithoutProjectResourceCaptureNestedInput = {
  connect?: InputMaybe<EmployeeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EmployeeCreateOrConnectWithoutProjectResourceCaptureInput>;
  create?: InputMaybe<EmployeeCreateWithoutProjectResourceCaptureInput>;
  update?: InputMaybe<EmployeeUpdateWithoutProjectResourceCaptureInput>;
  upsert?: InputMaybe<EmployeeUpsertWithoutProjectResourceCaptureInput>;
};

export type EmployeeUpdateOneRequiredWithoutProjectRoleNestedInput = {
  connect?: InputMaybe<EmployeeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EmployeeCreateOrConnectWithoutProjectRoleInput>;
  create?: InputMaybe<EmployeeCreateWithoutProjectRoleInput>;
  update?: InputMaybe<EmployeeUpdateWithoutProjectRoleInput>;
  upsert?: InputMaybe<EmployeeUpsertWithoutProjectRoleInput>;
};

export type EmployeeUpdateOneRequiredWithoutRiskNestedInput = {
  connect?: InputMaybe<EmployeeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<EmployeeCreateOrConnectWithoutRiskInput>;
  create?: InputMaybe<EmployeeCreateWithoutRiskInput>;
  update?: InputMaybe<EmployeeUpdateWithoutRiskInput>;
  upsert?: InputMaybe<EmployeeUpsertWithoutRiskInput>;
};

export type EmployeeUpdateWithoutAddresseeGroupInput = {
  EmployeeMaster?: InputMaybe<EmployeeMasterUpdateManyWithoutEmployeeNestedInput>;
  ProjectInterface?: InputMaybe<ProjectInterfaceUpdateManyWithoutEmployeeNestedInput>;
  ProjectResourceCapture?: InputMaybe<ProjectResourceCaptureUpdateManyWithoutEmployeeNestedInput>;
  ProjectRole?: InputMaybe<ProjectRoleUpdateManyWithoutEmployeeNestedInput>;
  Risk?: InputMaybe<RiskUpdateManyWithoutEmployeeNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  department?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EmployeeUpdateWithoutEmployeeMasterInput = {
  ProjectInterface?: InputMaybe<ProjectInterfaceUpdateManyWithoutEmployeeNestedInput>;
  ProjectResourceCapture?: InputMaybe<ProjectResourceCaptureUpdateManyWithoutEmployeeNestedInput>;
  ProjectRole?: InputMaybe<ProjectRoleUpdateManyWithoutEmployeeNestedInput>;
  Risk?: InputMaybe<RiskUpdateManyWithoutEmployeeNestedInput>;
  addresseeGroup?: InputMaybe<AddresseeGroupUpdateManyWithoutEmployeeNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  department?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EmployeeUpdateWithoutProjectInterfaceInput = {
  EmployeeMaster?: InputMaybe<EmployeeMasterUpdateManyWithoutEmployeeNestedInput>;
  ProjectResourceCapture?: InputMaybe<ProjectResourceCaptureUpdateManyWithoutEmployeeNestedInput>;
  ProjectRole?: InputMaybe<ProjectRoleUpdateManyWithoutEmployeeNestedInput>;
  Risk?: InputMaybe<RiskUpdateManyWithoutEmployeeNestedInput>;
  addresseeGroup?: InputMaybe<AddresseeGroupUpdateManyWithoutEmployeeNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  department?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EmployeeUpdateWithoutProjectResourceCaptureInput = {
  EmployeeMaster?: InputMaybe<EmployeeMasterUpdateManyWithoutEmployeeNestedInput>;
  ProjectInterface?: InputMaybe<ProjectInterfaceUpdateManyWithoutEmployeeNestedInput>;
  ProjectRole?: InputMaybe<ProjectRoleUpdateManyWithoutEmployeeNestedInput>;
  Risk?: InputMaybe<RiskUpdateManyWithoutEmployeeNestedInput>;
  addresseeGroup?: InputMaybe<AddresseeGroupUpdateManyWithoutEmployeeNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  department?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EmployeeUpdateWithoutProjectRoleInput = {
  EmployeeMaster?: InputMaybe<EmployeeMasterUpdateManyWithoutEmployeeNestedInput>;
  ProjectInterface?: InputMaybe<ProjectInterfaceUpdateManyWithoutEmployeeNestedInput>;
  ProjectResourceCapture?: InputMaybe<ProjectResourceCaptureUpdateManyWithoutEmployeeNestedInput>;
  Risk?: InputMaybe<RiskUpdateManyWithoutEmployeeNestedInput>;
  addresseeGroup?: InputMaybe<AddresseeGroupUpdateManyWithoutEmployeeNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  department?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EmployeeUpdateWithoutRiskInput = {
  EmployeeMaster?: InputMaybe<EmployeeMasterUpdateManyWithoutEmployeeNestedInput>;
  ProjectInterface?: InputMaybe<ProjectInterfaceUpdateManyWithoutEmployeeNestedInput>;
  ProjectResourceCapture?: InputMaybe<ProjectResourceCaptureUpdateManyWithoutEmployeeNestedInput>;
  ProjectRole?: InputMaybe<ProjectRoleUpdateManyWithoutEmployeeNestedInput>;
  addresseeGroup?: InputMaybe<AddresseeGroupUpdateManyWithoutEmployeeNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  department?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type EmployeeUpsertWithoutAddresseeGroupInput = {
  create: EmployeeCreateWithoutAddresseeGroupInput;
  update: EmployeeUpdateWithoutAddresseeGroupInput;
};

export type EmployeeUpsertWithoutEmployeeMasterInput = {
  create: EmployeeCreateWithoutEmployeeMasterInput;
  update: EmployeeUpdateWithoutEmployeeMasterInput;
};

export type EmployeeUpsertWithoutProjectInterfaceInput = {
  create: EmployeeCreateWithoutProjectInterfaceInput;
  update: EmployeeUpdateWithoutProjectInterfaceInput;
};

export type EmployeeUpsertWithoutProjectResourceCaptureInput = {
  create: EmployeeCreateWithoutProjectResourceCaptureInput;
  update: EmployeeUpdateWithoutProjectResourceCaptureInput;
};

export type EmployeeUpsertWithoutProjectRoleInput = {
  create: EmployeeCreateWithoutProjectRoleInput;
  update: EmployeeUpdateWithoutProjectRoleInput;
};

export type EmployeeUpsertWithoutRiskInput = {
  create: EmployeeCreateWithoutRiskInput;
  update: EmployeeUpdateWithoutRiskInput;
};

export type EmployeeWhereInput = {
  AND?: InputMaybe<Array<EmployeeWhereInput>>;
  EmployeeMaster?: InputMaybe<EmployeeMasterListRelationFilter>;
  NOT?: InputMaybe<Array<EmployeeWhereInput>>;
  OR?: InputMaybe<Array<EmployeeWhereInput>>;
  ProjectInterface?: InputMaybe<ProjectInterfaceListRelationFilter>;
  ProjectResourceCapture?: InputMaybe<ProjectResourceCaptureListRelationFilter>;
  ProjectRole?: InputMaybe<ProjectRoleListRelationFilter>;
  Risk?: InputMaybe<RiskListRelationFilter>;
  addresseeGroup?: InputMaybe<AddresseeGroupListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  department?: InputMaybe<StringNullableFilter>;
  email?: InputMaybe<StringNullableFilter>;
  firstName?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  lastName?: InputMaybe<StringNullableFilter>;
};

export type EmployeeWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type Finance = {
  __typename?: 'Finance';
  asset: Asset;
  assetId: Scalars['String'];
  company: Company;
  companyId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  project: Master;
  projectId: Scalars['String'];
  rowNumber?: Maybe<Scalars['Int']>;
  value: Scalars['Float'];
  year: Scalars['Int'];
};

export type FinanceAvgAggregate = {
  __typename?: 'FinanceAvgAggregate';
  rowNumber?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

export type FinanceAvgAggregateInput = {
  rowNumber?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
  year?: InputMaybe<Scalars['Boolean']>;
};

export type FinanceAvgOrderByAggregateInput = {
  rowNumber?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
  year?: InputMaybe<SortOrder>;
};

export type FinanceCountAggregate = {
  __typename?: 'FinanceCountAggregate';
  _all: Scalars['Int'];
  assetId: Scalars['Int'];
  companyId: Scalars['Int'];
  createdAt: Scalars['Int'];
  createdBy: Scalars['Int'];
  deletedAt: Scalars['Int'];
  deletedBy: Scalars['Int'];
  id: Scalars['Int'];
  projectId: Scalars['Int'];
  rowNumber: Scalars['Int'];
  value: Scalars['Int'];
  year: Scalars['Int'];
};

export type FinanceCountAggregateInput = {
  _all?: InputMaybe<Scalars['Boolean']>;
  assetId?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Boolean']>;
  createdBy?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['Boolean']>;
  deletedBy?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Boolean']>;
  projectId?: InputMaybe<Scalars['Boolean']>;
  rowNumber?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
  year?: InputMaybe<Scalars['Boolean']>;
};

export type FinanceCountOrderByAggregateInput = {
  assetId?: InputMaybe<SortOrder>;
  companyId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  deletedBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  projectId?: InputMaybe<SortOrder>;
  rowNumber?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
  year?: InputMaybe<SortOrder>;
};

export type FinanceCreateInput = {
  asset: AssetCreateNestedOneWithoutFinancesInput;
  company: CompanyCreateNestedOneWithoutFinancesInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  project: MasterCreateNestedOneWithoutFinancesInput;
  rowNumber?: InputMaybe<Scalars['Int']>;
  value: Scalars['Float'];
  year: Scalars['Int'];
};

export type FinanceCreateManyAssetInput = {
  companyId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
  value: Scalars['Float'];
  year: Scalars['Int'];
};

export type FinanceCreateManyAssetInputEnvelope = {
  data: Array<FinanceCreateManyAssetInput>;
};

export type FinanceCreateManyCompanyInput = {
  assetId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
  value: Scalars['Float'];
  year: Scalars['Int'];
};

export type FinanceCreateManyCompanyInputEnvelope = {
  data: Array<FinanceCreateManyCompanyInput>;
};

export type FinanceCreateManyProjectInput = {
  assetId: Scalars['String'];
  companyId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  value: Scalars['Float'];
  year: Scalars['Int'];
};

export type FinanceCreateManyProjectInputEnvelope = {
  data: Array<FinanceCreateManyProjectInput>;
};

export type FinanceCreateNestedManyWithoutAssetInput = {
  connect?: InputMaybe<Array<FinanceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FinanceCreateOrConnectWithoutAssetInput>>;
  create?: InputMaybe<Array<FinanceCreateWithoutAssetInput>>;
  createMany?: InputMaybe<FinanceCreateManyAssetInputEnvelope>;
};

export type FinanceCreateNestedManyWithoutCompanyInput = {
  connect?: InputMaybe<Array<FinanceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FinanceCreateOrConnectWithoutCompanyInput>>;
  create?: InputMaybe<Array<FinanceCreateWithoutCompanyInput>>;
  createMany?: InputMaybe<FinanceCreateManyCompanyInputEnvelope>;
};

export type FinanceCreateNestedManyWithoutProjectInput = {
  connect?: InputMaybe<Array<FinanceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FinanceCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<FinanceCreateWithoutProjectInput>>;
  createMany?: InputMaybe<FinanceCreateManyProjectInputEnvelope>;
};

export type FinanceCreateOrConnectWithoutAssetInput = {
  create: FinanceCreateWithoutAssetInput;
  where: FinanceWhereUniqueInput;
};

export type FinanceCreateOrConnectWithoutCompanyInput = {
  create: FinanceCreateWithoutCompanyInput;
  where: FinanceWhereUniqueInput;
};

export type FinanceCreateOrConnectWithoutProjectInput = {
  create: FinanceCreateWithoutProjectInput;
  where: FinanceWhereUniqueInput;
};

export type FinanceCreateWithoutAssetInput = {
  company: CompanyCreateNestedOneWithoutFinancesInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  project: MasterCreateNestedOneWithoutFinancesInput;
  rowNumber?: InputMaybe<Scalars['Int']>;
  value: Scalars['Float'];
  year: Scalars['Int'];
};

export type FinanceCreateWithoutCompanyInput = {
  asset: AssetCreateNestedOneWithoutFinancesInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  project: MasterCreateNestedOneWithoutFinancesInput;
  rowNumber?: InputMaybe<Scalars['Int']>;
  value: Scalars['Float'];
  year: Scalars['Int'];
};

export type FinanceCreateWithoutProjectInput = {
  asset: AssetCreateNestedOneWithoutFinancesInput;
  company: CompanyCreateNestedOneWithoutFinancesInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  rowNumber?: InputMaybe<Scalars['Int']>;
  value: Scalars['Float'];
  year: Scalars['Int'];
};

export type FinanceGroupBy = {
  __typename?: 'FinanceGroupBy';
  _avg?: Maybe<FinanceAvgAggregate>;
  _count?: Maybe<FinanceCountAggregate>;
  _max?: Maybe<FinanceMaxAggregate>;
  _min?: Maybe<FinanceMinAggregate>;
  _sum?: Maybe<FinanceSumAggregate>;
  assetId: Scalars['String'];
  companyId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  projectId: Scalars['String'];
  rowNumber?: Maybe<Scalars['Int']>;
  value: Scalars['Float'];
  year: Scalars['Int'];
};

export type FinanceListRelationFilter = {
  every?: InputMaybe<FinanceWhereInput>;
  none?: InputMaybe<FinanceWhereInput>;
  some?: InputMaybe<FinanceWhereInput>;
};

export type FinanceMaxAggregate = {
  __typename?: 'FinanceMaxAggregate';
  assetId?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  projectId?: Maybe<Scalars['String']>;
  rowNumber?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Int']>;
};

export type FinanceMaxAggregateInput = {
  assetId?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Boolean']>;
  createdBy?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['Boolean']>;
  deletedBy?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Boolean']>;
  projectId?: InputMaybe<Scalars['Boolean']>;
  rowNumber?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
  year?: InputMaybe<Scalars['Boolean']>;
};

export type FinanceMaxOrderByAggregateInput = {
  assetId?: InputMaybe<SortOrder>;
  companyId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  deletedBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  projectId?: InputMaybe<SortOrder>;
  rowNumber?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
  year?: InputMaybe<SortOrder>;
};

export type FinanceMinAggregate = {
  __typename?: 'FinanceMinAggregate';
  assetId?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  projectId?: Maybe<Scalars['String']>;
  rowNumber?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Int']>;
};

export type FinanceMinAggregateInput = {
  assetId?: InputMaybe<Scalars['Boolean']>;
  companyId?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Boolean']>;
  createdBy?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['Boolean']>;
  deletedBy?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Boolean']>;
  projectId?: InputMaybe<Scalars['Boolean']>;
  rowNumber?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
  year?: InputMaybe<Scalars['Boolean']>;
};

export type FinanceMinOrderByAggregateInput = {
  assetId?: InputMaybe<SortOrder>;
  companyId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  deletedBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  projectId?: InputMaybe<SortOrder>;
  rowNumber?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
  year?: InputMaybe<SortOrder>;
};

export type FinanceOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type FinanceOrderByWithAggregationInput = {
  _avg?: InputMaybe<FinanceAvgOrderByAggregateInput>;
  _count?: InputMaybe<FinanceCountOrderByAggregateInput>;
  _max?: InputMaybe<FinanceMaxOrderByAggregateInput>;
  _min?: InputMaybe<FinanceMinOrderByAggregateInput>;
  _sum?: InputMaybe<FinanceSumOrderByAggregateInput>;
  assetId?: InputMaybe<SortOrder>;
  companyId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  deletedBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  projectId?: InputMaybe<SortOrder>;
  rowNumber?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
  year?: InputMaybe<SortOrder>;
};

export type FinanceOrderByWithRelationInput = {
  asset?: InputMaybe<AssetOrderByWithRelationInput>;
  assetId?: InputMaybe<SortOrder>;
  company?: InputMaybe<CompanyOrderByWithRelationInput>;
  companyId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  deletedBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  project?: InputMaybe<MasterOrderByWithRelationInput>;
  projectId?: InputMaybe<SortOrder>;
  rowNumber?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
  year?: InputMaybe<SortOrder>;
};

export enum FinanceScalarFieldEnum {
  AssetId = 'assetId',
  CompanyId = 'companyId',
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  DeletedAt = 'deletedAt',
  DeletedBy = 'deletedBy',
  Id = 'id',
  ProjectId = 'projectId',
  RowNumber = 'rowNumber',
  Value = 'value',
  Year = 'year'
}

export type FinanceScalarWhereInput = {
  AND?: InputMaybe<Array<FinanceScalarWhereInput>>;
  NOT?: InputMaybe<Array<FinanceScalarWhereInput>>;
  OR?: InputMaybe<Array<FinanceScalarWhereInput>>;
  assetId?: InputMaybe<StringFilter>;
  companyId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  projectId?: InputMaybe<StringFilter>;
  rowNumber?: InputMaybe<IntNullableFilter>;
  value?: InputMaybe<FloatFilter>;
  year?: InputMaybe<IntFilter>;
};

export type FinanceScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<FinanceScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<FinanceScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<FinanceScalarWhereWithAggregatesInput>>;
  assetId?: InputMaybe<StringWithAggregatesFilter>;
  companyId?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  createdBy?: InputMaybe<StringWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  deletedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  projectId?: InputMaybe<StringWithAggregatesFilter>;
  rowNumber?: InputMaybe<IntNullableWithAggregatesFilter>;
  value?: InputMaybe<FloatWithAggregatesFilter>;
  year?: InputMaybe<IntWithAggregatesFilter>;
};

export type FinanceSumAggregate = {
  __typename?: 'FinanceSumAggregate';
  rowNumber?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Int']>;
};

export type FinanceSumAggregateInput = {
  rowNumber?: InputMaybe<Scalars['Boolean']>;
  value?: InputMaybe<Scalars['Boolean']>;
  year?: InputMaybe<Scalars['Boolean']>;
};

export type FinanceSumOrderByAggregateInput = {
  rowNumber?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
  year?: InputMaybe<SortOrder>;
};

export type FinanceUpdateInput = {
  asset?: InputMaybe<AssetUpdateOneRequiredWithoutFinancesNestedInput>;
  company?: InputMaybe<CompanyUpdateOneRequiredWithoutFinancesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutFinancesNestedInput>;
  rowNumber?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  value?: InputMaybe<FloatFieldUpdateOperationsInput>;
  year?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type FinanceUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  rowNumber?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  value?: InputMaybe<FloatFieldUpdateOperationsInput>;
  year?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type FinanceUpdateManyWithWhereWithoutAssetInput = {
  data: FinanceUpdateManyMutationInput;
  where: FinanceScalarWhereInput;
};

export type FinanceUpdateManyWithWhereWithoutCompanyInput = {
  data: FinanceUpdateManyMutationInput;
  where: FinanceScalarWhereInput;
};

export type FinanceUpdateManyWithWhereWithoutProjectInput = {
  data: FinanceUpdateManyMutationInput;
  where: FinanceScalarWhereInput;
};

export type FinanceUpdateManyWithoutAssetNestedInput = {
  connect?: InputMaybe<Array<FinanceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FinanceCreateOrConnectWithoutAssetInput>>;
  create?: InputMaybe<Array<FinanceCreateWithoutAssetInput>>;
  createMany?: InputMaybe<FinanceCreateManyAssetInputEnvelope>;
  delete?: InputMaybe<Array<FinanceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FinanceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FinanceWhereUniqueInput>>;
  set?: InputMaybe<Array<FinanceWhereUniqueInput>>;
  update?: InputMaybe<Array<FinanceUpdateWithWhereUniqueWithoutAssetInput>>;
  updateMany?: InputMaybe<Array<FinanceUpdateManyWithWhereWithoutAssetInput>>;
  upsert?: InputMaybe<Array<FinanceUpsertWithWhereUniqueWithoutAssetInput>>;
};

export type FinanceUpdateManyWithoutCompanyNestedInput = {
  connect?: InputMaybe<Array<FinanceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FinanceCreateOrConnectWithoutCompanyInput>>;
  create?: InputMaybe<Array<FinanceCreateWithoutCompanyInput>>;
  createMany?: InputMaybe<FinanceCreateManyCompanyInputEnvelope>;
  delete?: InputMaybe<Array<FinanceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FinanceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FinanceWhereUniqueInput>>;
  set?: InputMaybe<Array<FinanceWhereUniqueInput>>;
  update?: InputMaybe<Array<FinanceUpdateWithWhereUniqueWithoutCompanyInput>>;
  updateMany?: InputMaybe<Array<FinanceUpdateManyWithWhereWithoutCompanyInput>>;
  upsert?: InputMaybe<Array<FinanceUpsertWithWhereUniqueWithoutCompanyInput>>;
};

export type FinanceUpdateManyWithoutProjectNestedInput = {
  connect?: InputMaybe<Array<FinanceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FinanceCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<FinanceCreateWithoutProjectInput>>;
  createMany?: InputMaybe<FinanceCreateManyProjectInputEnvelope>;
  delete?: InputMaybe<Array<FinanceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FinanceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FinanceWhereUniqueInput>>;
  set?: InputMaybe<Array<FinanceWhereUniqueInput>>;
  update?: InputMaybe<Array<FinanceUpdateWithWhereUniqueWithoutProjectInput>>;
  updateMany?: InputMaybe<Array<FinanceUpdateManyWithWhereWithoutProjectInput>>;
  upsert?: InputMaybe<Array<FinanceUpsertWithWhereUniqueWithoutProjectInput>>;
};

export type FinanceUpdateWithWhereUniqueWithoutAssetInput = {
  data: FinanceUpdateWithoutAssetInput;
  where: FinanceWhereUniqueInput;
};

export type FinanceUpdateWithWhereUniqueWithoutCompanyInput = {
  data: FinanceUpdateWithoutCompanyInput;
  where: FinanceWhereUniqueInput;
};

export type FinanceUpdateWithWhereUniqueWithoutProjectInput = {
  data: FinanceUpdateWithoutProjectInput;
  where: FinanceWhereUniqueInput;
};

export type FinanceUpdateWithoutAssetInput = {
  company?: InputMaybe<CompanyUpdateOneRequiredWithoutFinancesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutFinancesNestedInput>;
  rowNumber?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  value?: InputMaybe<FloatFieldUpdateOperationsInput>;
  year?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type FinanceUpdateWithoutCompanyInput = {
  asset?: InputMaybe<AssetUpdateOneRequiredWithoutFinancesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutFinancesNestedInput>;
  rowNumber?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  value?: InputMaybe<FloatFieldUpdateOperationsInput>;
  year?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type FinanceUpdateWithoutProjectInput = {
  asset?: InputMaybe<AssetUpdateOneRequiredWithoutFinancesNestedInput>;
  company?: InputMaybe<CompanyUpdateOneRequiredWithoutFinancesNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  rowNumber?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  value?: InputMaybe<FloatFieldUpdateOperationsInput>;
  year?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type FinanceUpsertWithWhereUniqueWithoutAssetInput = {
  create: FinanceCreateWithoutAssetInput;
  update: FinanceUpdateWithoutAssetInput;
  where: FinanceWhereUniqueInput;
};

export type FinanceUpsertWithWhereUniqueWithoutCompanyInput = {
  create: FinanceCreateWithoutCompanyInput;
  update: FinanceUpdateWithoutCompanyInput;
  where: FinanceWhereUniqueInput;
};

export type FinanceUpsertWithWhereUniqueWithoutProjectInput = {
  create: FinanceCreateWithoutProjectInput;
  update: FinanceUpdateWithoutProjectInput;
  where: FinanceWhereUniqueInput;
};

export type FinanceWhereInput = {
  AND?: InputMaybe<Array<FinanceWhereInput>>;
  NOT?: InputMaybe<Array<FinanceWhereInput>>;
  OR?: InputMaybe<Array<FinanceWhereInput>>;
  asset?: InputMaybe<AssetWhereInput>;
  assetId?: InputMaybe<StringFilter>;
  company?: InputMaybe<CompanyWhereInput>;
  companyId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  project?: InputMaybe<MasterWhereInput>;
  projectId?: InputMaybe<StringFilter>;
  rowNumber?: InputMaybe<IntNullableFilter>;
  value?: InputMaybe<FloatFilter>;
  year?: InputMaybe<IntFilter>;
};

export type FinanceWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type FloatFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Float']>;
  divide?: InputMaybe<Scalars['Float']>;
  increment?: InputMaybe<Scalars['Float']>;
  multiply?: InputMaybe<Scalars['Float']>;
  set?: InputMaybe<Scalars['Float']>;
};

export type FloatFilter = {
  equals?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<NestedFloatFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

export type FloatNullableFilter = {
  equals?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<NestedFloatNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

export type FloatNullableWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatNullableFilter>;
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedFloatNullableFilter>;
  _min?: InputMaybe<NestedFloatNullableFilter>;
  _sum?: InputMaybe<NestedFloatNullableFilter>;
  equals?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<NestedFloatNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

export type FloatWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatFilter>;
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedFloatFilter>;
  _min?: InputMaybe<NestedFloatFilter>;
  _sum?: InputMaybe<NestedFloatFilter>;
  equals?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<NestedFloatWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

export type Funding = {
  __typename?: 'Funding';
  _count: FundingCount;
  description?: Maybe<Scalars['String']>;
  fundingName: Scalars['String'];
  id: Scalars['ID'];
  projectDescriptions?: Maybe<Array<ProjectDescription>>;
};

export type FundingCount = {
  __typename?: 'FundingCount';
  projectDescriptions: Scalars['Int'];
};

export type FundingCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  fundingName: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  projectDescriptions?: InputMaybe<ProjectDescriptionCreateNestedManyWithoutFundingInput>;
};

export type FundingCreateNestedOneWithoutProjectDescriptionsInput = {
  connect?: InputMaybe<FundingWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FundingCreateOrConnectWithoutProjectDescriptionsInput>;
  create?: InputMaybe<FundingCreateWithoutProjectDescriptionsInput>;
};

export type FundingCreateOrConnectWithoutProjectDescriptionsInput = {
  create: FundingCreateWithoutProjectDescriptionsInput;
  where: FundingWhereUniqueInput;
};

export type FundingCreateWithoutProjectDescriptionsInput = {
  description?: InputMaybe<Scalars['String']>;
  fundingName: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
};

export type FundingOrderByWithRelationInput = {
  description?: InputMaybe<SortOrder>;
  fundingName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  projectDescriptions?: InputMaybe<ProjectDescriptionOrderByRelationAggregateInput>;
};

export enum FundingScalarFieldEnum {
  Description = 'description',
  FundingName = 'fundingName',
  Id = 'id'
}

export type FundingUpdateInput = {
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fundingName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionUpdateManyWithoutFundingNestedInput>;
};

export type FundingUpdateOneWithoutProjectDescriptionsNestedInput = {
  connect?: InputMaybe<FundingWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FundingCreateOrConnectWithoutProjectDescriptionsInput>;
  create?: InputMaybe<FundingCreateWithoutProjectDescriptionsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<FundingUpdateWithoutProjectDescriptionsInput>;
  upsert?: InputMaybe<FundingUpsertWithoutProjectDescriptionsInput>;
};

export type FundingUpdateWithoutProjectDescriptionsInput = {
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  fundingName?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type FundingUpsertWithoutProjectDescriptionsInput = {
  create: FundingCreateWithoutProjectDescriptionsInput;
  update: FundingUpdateWithoutProjectDescriptionsInput;
};

export type FundingWhereInput = {
  AND?: InputMaybe<Array<FundingWhereInput>>;
  NOT?: InputMaybe<Array<FundingWhereInput>>;
  OR?: InputMaybe<Array<FundingWhereInput>>;
  description?: InputMaybe<StringNullableFilter>;
  fundingName?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  projectDescriptions?: InputMaybe<ProjectDescriptionListRelationFilter>;
};

export type FundingWhereUniqueInput = {
  fundingName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type GeneralCostShortHistory = {
  __typename?: 'GeneralCostShortHistory';
  action: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  id: Scalars['ID'];
};

export type GeneralCostShortHistoryCreateInput = {
  action: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
};

export type GeneralCostShortHistoryOrderByWithRelationInput = {
  action?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export enum GeneralCostShortHistoryScalarFieldEnum {
  Action = 'action',
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  Id = 'id'
}

export type GeneralCostShortHistoryUpdateInput = {
  action?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type GeneralCostShortHistoryWhereInput = {
  AND?: InputMaybe<Array<GeneralCostShortHistoryWhereInput>>;
  NOT?: InputMaybe<Array<GeneralCostShortHistoryWhereInput>>;
  OR?: InputMaybe<Array<GeneralCostShortHistoryWhereInput>>;
  action?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
};

export type GeneralCostShortHistoryWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type GerneralItCostSubtype = {
  __typename?: 'GerneralItCostSubtype';
  GerneralItCosts?: Maybe<Array<GerneralItCosts>>;
  _count: GerneralItCostSubtypeCount;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type GerneralItCostSubtypeCount = {
  __typename?: 'GerneralItCostSubtypeCount';
  GerneralItCosts: Scalars['Int'];
};

export type GerneralItCostSubtypeCreateInput = {
  GerneralItCosts?: InputMaybe<GerneralItCostsCreateNestedManyWithoutCostSubtypeInput>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

export type GerneralItCostSubtypeCreateNestedOneWithoutGerneralItCostsInput = {
  connect?: InputMaybe<GerneralItCostSubtypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<GerneralItCostSubtypeCreateOrConnectWithoutGerneralItCostsInput>;
  create?: InputMaybe<GerneralItCostSubtypeCreateWithoutGerneralItCostsInput>;
};

export type GerneralItCostSubtypeCreateOrConnectWithoutGerneralItCostsInput = {
  create: GerneralItCostSubtypeCreateWithoutGerneralItCostsInput;
  where: GerneralItCostSubtypeWhereUniqueInput;
};

export type GerneralItCostSubtypeCreateWithoutGerneralItCostsInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

export type GerneralItCostSubtypeOrderByWithRelationInput = {
  GerneralItCosts?: InputMaybe<GerneralItCostsOrderByRelationAggregateInput>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export enum GerneralItCostSubtypeScalarFieldEnum {
  Description = 'description',
  Id = 'id'
}

export type GerneralItCostSubtypeUpdateInput = {
  GerneralItCosts?: InputMaybe<GerneralItCostsUpdateManyWithoutCostSubtypeNestedInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type GerneralItCostSubtypeUpdateOneRequiredWithoutGerneralItCostsNestedInput = {
  connect?: InputMaybe<GerneralItCostSubtypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<GerneralItCostSubtypeCreateOrConnectWithoutGerneralItCostsInput>;
  create?: InputMaybe<GerneralItCostSubtypeCreateWithoutGerneralItCostsInput>;
  update?: InputMaybe<GerneralItCostSubtypeUpdateWithoutGerneralItCostsInput>;
  upsert?: InputMaybe<GerneralItCostSubtypeUpsertWithoutGerneralItCostsInput>;
};

export type GerneralItCostSubtypeUpdateWithoutGerneralItCostsInput = {
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type GerneralItCostSubtypeUpsertWithoutGerneralItCostsInput = {
  create: GerneralItCostSubtypeCreateWithoutGerneralItCostsInput;
  update: GerneralItCostSubtypeUpdateWithoutGerneralItCostsInput;
};

export type GerneralItCostSubtypeWhereInput = {
  AND?: InputMaybe<Array<GerneralItCostSubtypeWhereInput>>;
  GerneralItCosts?: InputMaybe<GerneralItCostsListRelationFilter>;
  NOT?: InputMaybe<Array<GerneralItCostSubtypeWhereInput>>;
  OR?: InputMaybe<Array<GerneralItCostSubtypeWhereInput>>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
};

export type GerneralItCostSubtypeWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type GerneralItCostType = {
  __typename?: 'GerneralItCostType';
  GerneralItCosts?: Maybe<Array<GerneralItCosts>>;
  _count: GerneralItCostTypeCount;
  description: Scalars['String'];
  id: Scalars['ID'];
};

export type GerneralItCostTypeCount = {
  __typename?: 'GerneralItCostTypeCount';
  GerneralItCosts: Scalars['Int'];
};

export type GerneralItCostTypeCreateInput = {
  GerneralItCosts?: InputMaybe<GerneralItCostsCreateNestedManyWithoutCostTypeInput>;
  description: Scalars['String'];
  id: Scalars['String'];
};

export type GerneralItCostTypeCreateNestedOneWithoutGerneralItCostsInput = {
  connect?: InputMaybe<GerneralItCostTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<GerneralItCostTypeCreateOrConnectWithoutGerneralItCostsInput>;
  create?: InputMaybe<GerneralItCostTypeCreateWithoutGerneralItCostsInput>;
};

export type GerneralItCostTypeCreateOrConnectWithoutGerneralItCostsInput = {
  create: GerneralItCostTypeCreateWithoutGerneralItCostsInput;
  where: GerneralItCostTypeWhereUniqueInput;
};

export type GerneralItCostTypeCreateWithoutGerneralItCostsInput = {
  description: Scalars['String'];
  id: Scalars['String'];
};

export type GerneralItCostTypeOrderByWithRelationInput = {
  GerneralItCosts?: InputMaybe<GerneralItCostsOrderByRelationAggregateInput>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export enum GerneralItCostTypeScalarFieldEnum {
  Description = 'description',
  Id = 'id'
}

export type GerneralItCostTypeUpdateInput = {
  GerneralItCosts?: InputMaybe<GerneralItCostsUpdateManyWithoutCostTypeNestedInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type GerneralItCostTypeUpdateOneRequiredWithoutGerneralItCostsNestedInput = {
  connect?: InputMaybe<GerneralItCostTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<GerneralItCostTypeCreateOrConnectWithoutGerneralItCostsInput>;
  create?: InputMaybe<GerneralItCostTypeCreateWithoutGerneralItCostsInput>;
  update?: InputMaybe<GerneralItCostTypeUpdateWithoutGerneralItCostsInput>;
  upsert?: InputMaybe<GerneralItCostTypeUpsertWithoutGerneralItCostsInput>;
};

export type GerneralItCostTypeUpdateWithoutGerneralItCostsInput = {
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type GerneralItCostTypeUpsertWithoutGerneralItCostsInput = {
  create: GerneralItCostTypeCreateWithoutGerneralItCostsInput;
  update: GerneralItCostTypeUpdateWithoutGerneralItCostsInput;
};

export type GerneralItCostTypeWhereInput = {
  AND?: InputMaybe<Array<GerneralItCostTypeWhereInput>>;
  GerneralItCosts?: InputMaybe<GerneralItCostsListRelationFilter>;
  NOT?: InputMaybe<Array<GerneralItCostTypeWhereInput>>;
  OR?: InputMaybe<Array<GerneralItCostTypeWhereInput>>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
};

export type GerneralItCostTypeWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type GerneralItCosts = {
  __typename?: 'GerneralItCosts';
  costSubtype: GerneralItCostSubtype;
  costSubtypeId: Scalars['String'];
  costType: GerneralItCostType;
  costTypeId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  sum: Scalars['Float'];
  year: Scalars['Int'];
};

export type GerneralItCostsAvgAggregate = {
  __typename?: 'GerneralItCostsAvgAggregate';
  sum?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

export type GerneralItCostsAvgAggregateInput = {
  sum?: InputMaybe<Scalars['Boolean']>;
  year?: InputMaybe<Scalars['Boolean']>;
};

export type GerneralItCostsAvgOrderByAggregateInput = {
  sum?: InputMaybe<SortOrder>;
  year?: InputMaybe<SortOrder>;
};

export type GerneralItCostsCountAggregate = {
  __typename?: 'GerneralItCostsCountAggregate';
  _all: Scalars['Int'];
  costSubtypeId: Scalars['Int'];
  costTypeId: Scalars['Int'];
  createdAt: Scalars['Int'];
  createdBy: Scalars['Int'];
  deletedAt: Scalars['Int'];
  deletedBy: Scalars['Int'];
  id: Scalars['Int'];
  sum: Scalars['Int'];
  year: Scalars['Int'];
};

export type GerneralItCostsCountAggregateInput = {
  _all?: InputMaybe<Scalars['Boolean']>;
  costSubtypeId?: InputMaybe<Scalars['Boolean']>;
  costTypeId?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Boolean']>;
  createdBy?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['Boolean']>;
  deletedBy?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Boolean']>;
  sum?: InputMaybe<Scalars['Boolean']>;
  year?: InputMaybe<Scalars['Boolean']>;
};

export type GerneralItCostsCountOrderByAggregateInput = {
  costSubtypeId?: InputMaybe<SortOrder>;
  costTypeId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  deletedBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  sum?: InputMaybe<SortOrder>;
  year?: InputMaybe<SortOrder>;
};

export type GerneralItCostsCreateInput = {
  costSubtype: GerneralItCostSubtypeCreateNestedOneWithoutGerneralItCostsInput;
  costType: GerneralItCostTypeCreateNestedOneWithoutGerneralItCostsInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  sum: Scalars['Float'];
  year: Scalars['Int'];
};

export type GerneralItCostsCreateManyCostSubtypeInput = {
  costTypeId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  sum: Scalars['Float'];
  year: Scalars['Int'];
};

export type GerneralItCostsCreateManyCostSubtypeInputEnvelope = {
  data: Array<GerneralItCostsCreateManyCostSubtypeInput>;
};

export type GerneralItCostsCreateManyCostTypeInput = {
  costSubtypeId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  sum: Scalars['Float'];
  year: Scalars['Int'];
};

export type GerneralItCostsCreateManyCostTypeInputEnvelope = {
  data: Array<GerneralItCostsCreateManyCostTypeInput>;
};

export type GerneralItCostsCreateNestedManyWithoutCostSubtypeInput = {
  connect?: InputMaybe<Array<GerneralItCostsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<GerneralItCostsCreateOrConnectWithoutCostSubtypeInput>>;
  create?: InputMaybe<Array<GerneralItCostsCreateWithoutCostSubtypeInput>>;
  createMany?: InputMaybe<GerneralItCostsCreateManyCostSubtypeInputEnvelope>;
};

export type GerneralItCostsCreateNestedManyWithoutCostTypeInput = {
  connect?: InputMaybe<Array<GerneralItCostsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<GerneralItCostsCreateOrConnectWithoutCostTypeInput>>;
  create?: InputMaybe<Array<GerneralItCostsCreateWithoutCostTypeInput>>;
  createMany?: InputMaybe<GerneralItCostsCreateManyCostTypeInputEnvelope>;
};

export type GerneralItCostsCreateOrConnectWithoutCostSubtypeInput = {
  create: GerneralItCostsCreateWithoutCostSubtypeInput;
  where: GerneralItCostsWhereUniqueInput;
};

export type GerneralItCostsCreateOrConnectWithoutCostTypeInput = {
  create: GerneralItCostsCreateWithoutCostTypeInput;
  where: GerneralItCostsWhereUniqueInput;
};

export type GerneralItCostsCreateWithoutCostSubtypeInput = {
  costType: GerneralItCostTypeCreateNestedOneWithoutGerneralItCostsInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  sum: Scalars['Float'];
  year: Scalars['Int'];
};

export type GerneralItCostsCreateWithoutCostTypeInput = {
  costSubtype: GerneralItCostSubtypeCreateNestedOneWithoutGerneralItCostsInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  sum: Scalars['Float'];
  year: Scalars['Int'];
};

export type GerneralItCostsGroupBy = {
  __typename?: 'GerneralItCostsGroupBy';
  _avg?: Maybe<GerneralItCostsAvgAggregate>;
  _count?: Maybe<GerneralItCostsCountAggregate>;
  _max?: Maybe<GerneralItCostsMaxAggregate>;
  _min?: Maybe<GerneralItCostsMinAggregate>;
  _sum?: Maybe<GerneralItCostsSumAggregate>;
  costSubtypeId: Scalars['String'];
  costTypeId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  sum: Scalars['Float'];
  year: Scalars['Int'];
};

export type GerneralItCostsListRelationFilter = {
  every?: InputMaybe<GerneralItCostsWhereInput>;
  none?: InputMaybe<GerneralItCostsWhereInput>;
  some?: InputMaybe<GerneralItCostsWhereInput>;
};

export type GerneralItCostsMaxAggregate = {
  __typename?: 'GerneralItCostsMaxAggregate';
  costSubtypeId?: Maybe<Scalars['String']>;
  costTypeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  sum?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Int']>;
};

export type GerneralItCostsMaxAggregateInput = {
  costSubtypeId?: InputMaybe<Scalars['Boolean']>;
  costTypeId?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Boolean']>;
  createdBy?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['Boolean']>;
  deletedBy?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Boolean']>;
  sum?: InputMaybe<Scalars['Boolean']>;
  year?: InputMaybe<Scalars['Boolean']>;
};

export type GerneralItCostsMaxOrderByAggregateInput = {
  costSubtypeId?: InputMaybe<SortOrder>;
  costTypeId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  deletedBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  sum?: InputMaybe<SortOrder>;
  year?: InputMaybe<SortOrder>;
};

export type GerneralItCostsMinAggregate = {
  __typename?: 'GerneralItCostsMinAggregate';
  costSubtypeId?: Maybe<Scalars['String']>;
  costTypeId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  sum?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Int']>;
};

export type GerneralItCostsMinAggregateInput = {
  costSubtypeId?: InputMaybe<Scalars['Boolean']>;
  costTypeId?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Boolean']>;
  createdBy?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['Boolean']>;
  deletedBy?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Boolean']>;
  sum?: InputMaybe<Scalars['Boolean']>;
  year?: InputMaybe<Scalars['Boolean']>;
};

export type GerneralItCostsMinOrderByAggregateInput = {
  costSubtypeId?: InputMaybe<SortOrder>;
  costTypeId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  deletedBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  sum?: InputMaybe<SortOrder>;
  year?: InputMaybe<SortOrder>;
};

export type GerneralItCostsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type GerneralItCostsOrderByWithAggregationInput = {
  _avg?: InputMaybe<GerneralItCostsAvgOrderByAggregateInput>;
  _count?: InputMaybe<GerneralItCostsCountOrderByAggregateInput>;
  _max?: InputMaybe<GerneralItCostsMaxOrderByAggregateInput>;
  _min?: InputMaybe<GerneralItCostsMinOrderByAggregateInput>;
  _sum?: InputMaybe<GerneralItCostsSumOrderByAggregateInput>;
  costSubtypeId?: InputMaybe<SortOrder>;
  costTypeId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  deletedBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  sum?: InputMaybe<SortOrder>;
  year?: InputMaybe<SortOrder>;
};

export type GerneralItCostsOrderByWithRelationInput = {
  costSubtype?: InputMaybe<GerneralItCostSubtypeOrderByWithRelationInput>;
  costSubtypeId?: InputMaybe<SortOrder>;
  costType?: InputMaybe<GerneralItCostTypeOrderByWithRelationInput>;
  costTypeId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  deletedBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  sum?: InputMaybe<SortOrder>;
  year?: InputMaybe<SortOrder>;
};

export enum GerneralItCostsScalarFieldEnum {
  CostSubtypeId = 'costSubtypeId',
  CostTypeId = 'costTypeId',
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  DeletedAt = 'deletedAt',
  DeletedBy = 'deletedBy',
  Id = 'id',
  Sum = 'sum',
  Year = 'year'
}

export type GerneralItCostsScalarWhereInput = {
  AND?: InputMaybe<Array<GerneralItCostsScalarWhereInput>>;
  NOT?: InputMaybe<Array<GerneralItCostsScalarWhereInput>>;
  OR?: InputMaybe<Array<GerneralItCostsScalarWhereInput>>;
  costSubtypeId?: InputMaybe<StringFilter>;
  costTypeId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  sum?: InputMaybe<FloatFilter>;
  year?: InputMaybe<IntFilter>;
};

export type GerneralItCostsScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<GerneralItCostsScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<GerneralItCostsScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<GerneralItCostsScalarWhereWithAggregatesInput>>;
  costSubtypeId?: InputMaybe<StringWithAggregatesFilter>;
  costTypeId?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  createdBy?: InputMaybe<StringWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  deletedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  sum?: InputMaybe<FloatWithAggregatesFilter>;
  year?: InputMaybe<IntWithAggregatesFilter>;
};

export type GerneralItCostsSumAggregate = {
  __typename?: 'GerneralItCostsSumAggregate';
  sum?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Int']>;
};

export type GerneralItCostsSumAggregateInput = {
  sum?: InputMaybe<Scalars['Boolean']>;
  year?: InputMaybe<Scalars['Boolean']>;
};

export type GerneralItCostsSumOrderByAggregateInput = {
  sum?: InputMaybe<SortOrder>;
  year?: InputMaybe<SortOrder>;
};

export type GerneralItCostsUpdateInput = {
  costSubtype?: InputMaybe<GerneralItCostSubtypeUpdateOneRequiredWithoutGerneralItCostsNestedInput>;
  costType?: InputMaybe<GerneralItCostTypeUpdateOneRequiredWithoutGerneralItCostsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  sum?: InputMaybe<FloatFieldUpdateOperationsInput>;
  year?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type GerneralItCostsUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  sum?: InputMaybe<FloatFieldUpdateOperationsInput>;
  year?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type GerneralItCostsUpdateManyWithWhereWithoutCostSubtypeInput = {
  data: GerneralItCostsUpdateManyMutationInput;
  where: GerneralItCostsScalarWhereInput;
};

export type GerneralItCostsUpdateManyWithWhereWithoutCostTypeInput = {
  data: GerneralItCostsUpdateManyMutationInput;
  where: GerneralItCostsScalarWhereInput;
};

export type GerneralItCostsUpdateManyWithoutCostSubtypeNestedInput = {
  connect?: InputMaybe<Array<GerneralItCostsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<GerneralItCostsCreateOrConnectWithoutCostSubtypeInput>>;
  create?: InputMaybe<Array<GerneralItCostsCreateWithoutCostSubtypeInput>>;
  createMany?: InputMaybe<GerneralItCostsCreateManyCostSubtypeInputEnvelope>;
  delete?: InputMaybe<Array<GerneralItCostsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<GerneralItCostsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<GerneralItCostsWhereUniqueInput>>;
  set?: InputMaybe<Array<GerneralItCostsWhereUniqueInput>>;
  update?: InputMaybe<Array<GerneralItCostsUpdateWithWhereUniqueWithoutCostSubtypeInput>>;
  updateMany?: InputMaybe<Array<GerneralItCostsUpdateManyWithWhereWithoutCostSubtypeInput>>;
  upsert?: InputMaybe<Array<GerneralItCostsUpsertWithWhereUniqueWithoutCostSubtypeInput>>;
};

export type GerneralItCostsUpdateManyWithoutCostTypeNestedInput = {
  connect?: InputMaybe<Array<GerneralItCostsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<GerneralItCostsCreateOrConnectWithoutCostTypeInput>>;
  create?: InputMaybe<Array<GerneralItCostsCreateWithoutCostTypeInput>>;
  createMany?: InputMaybe<GerneralItCostsCreateManyCostTypeInputEnvelope>;
  delete?: InputMaybe<Array<GerneralItCostsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<GerneralItCostsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<GerneralItCostsWhereUniqueInput>>;
  set?: InputMaybe<Array<GerneralItCostsWhereUniqueInput>>;
  update?: InputMaybe<Array<GerneralItCostsUpdateWithWhereUniqueWithoutCostTypeInput>>;
  updateMany?: InputMaybe<Array<GerneralItCostsUpdateManyWithWhereWithoutCostTypeInput>>;
  upsert?: InputMaybe<Array<GerneralItCostsUpsertWithWhereUniqueWithoutCostTypeInput>>;
};

export type GerneralItCostsUpdateWithWhereUniqueWithoutCostSubtypeInput = {
  data: GerneralItCostsUpdateWithoutCostSubtypeInput;
  where: GerneralItCostsWhereUniqueInput;
};

export type GerneralItCostsUpdateWithWhereUniqueWithoutCostTypeInput = {
  data: GerneralItCostsUpdateWithoutCostTypeInput;
  where: GerneralItCostsWhereUniqueInput;
};

export type GerneralItCostsUpdateWithoutCostSubtypeInput = {
  costType?: InputMaybe<GerneralItCostTypeUpdateOneRequiredWithoutGerneralItCostsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  sum?: InputMaybe<FloatFieldUpdateOperationsInput>;
  year?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type GerneralItCostsUpdateWithoutCostTypeInput = {
  costSubtype?: InputMaybe<GerneralItCostSubtypeUpdateOneRequiredWithoutGerneralItCostsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  sum?: InputMaybe<FloatFieldUpdateOperationsInput>;
  year?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type GerneralItCostsUpsertWithWhereUniqueWithoutCostSubtypeInput = {
  create: GerneralItCostsCreateWithoutCostSubtypeInput;
  update: GerneralItCostsUpdateWithoutCostSubtypeInput;
  where: GerneralItCostsWhereUniqueInput;
};

export type GerneralItCostsUpsertWithWhereUniqueWithoutCostTypeInput = {
  create: GerneralItCostsCreateWithoutCostTypeInput;
  update: GerneralItCostsUpdateWithoutCostTypeInput;
  where: GerneralItCostsWhereUniqueInput;
};

export type GerneralItCostsWhereInput = {
  AND?: InputMaybe<Array<GerneralItCostsWhereInput>>;
  NOT?: InputMaybe<Array<GerneralItCostsWhereInput>>;
  OR?: InputMaybe<Array<GerneralItCostsWhereInput>>;
  costSubtype?: InputMaybe<GerneralItCostSubtypeWhereInput>;
  costSubtypeId?: InputMaybe<StringFilter>;
  costType?: InputMaybe<GerneralItCostTypeWhereInput>;
  costTypeId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  sum?: InputMaybe<FloatFilter>;
  year?: InputMaybe<IntFilter>;
};

export type GerneralItCostsWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type Goal = {
  __typename?: 'Goal';
  _count: GoalCount;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  project?: Maybe<Array<GoalsOnMaster>>;
};

export type GoalCount = {
  __typename?: 'GoalCount';
  project: Scalars['Int'];
};

export type GoalCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  project?: InputMaybe<GoalsOnMasterCreateNestedManyWithoutGoalInput>;
};

export type GoalCreateNestedOneWithoutProjectInput = {
  connect?: InputMaybe<GoalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<GoalCreateOrConnectWithoutProjectInput>;
  create?: InputMaybe<GoalCreateWithoutProjectInput>;
};

export type GoalCreateOrConnectWithoutProjectInput = {
  create: GoalCreateWithoutProjectInput;
  where: GoalWhereUniqueInput;
};

export type GoalCreateWithoutProjectInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

export type GoalOrderByWithRelationInput = {
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  project?: InputMaybe<GoalsOnMasterOrderByRelationAggregateInput>;
};

export enum GoalScalarFieldEnum {
  Description = 'description',
  Id = 'id'
}

export type GoalUpdateInput = {
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  project?: InputMaybe<GoalsOnMasterUpdateManyWithoutGoalNestedInput>;
};

export type GoalUpdateOneRequiredWithoutProjectNestedInput = {
  connect?: InputMaybe<GoalWhereUniqueInput>;
  connectOrCreate?: InputMaybe<GoalCreateOrConnectWithoutProjectInput>;
  create?: InputMaybe<GoalCreateWithoutProjectInput>;
  update?: InputMaybe<GoalUpdateWithoutProjectInput>;
  upsert?: InputMaybe<GoalUpsertWithoutProjectInput>;
};

export type GoalUpdateWithoutProjectInput = {
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type GoalUpsertWithoutProjectInput = {
  create: GoalCreateWithoutProjectInput;
  update: GoalUpdateWithoutProjectInput;
};

export type GoalWhereInput = {
  AND?: InputMaybe<Array<GoalWhereInput>>;
  NOT?: InputMaybe<Array<GoalWhereInput>>;
  OR?: InputMaybe<Array<GoalWhereInput>>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  project?: InputMaybe<GoalsOnMasterListRelationFilter>;
};

export type GoalWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type GoalsOnMaster = {
  __typename?: 'GoalsOnMaster';
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  goal: Goal;
  goalId: Scalars['String'];
  id: Scalars['ID'];
  project: Master;
  projectId: Scalars['String'];
};

export type GoalsOnMasterCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  goal: GoalCreateNestedOneWithoutProjectInput;
  id?: InputMaybe<Scalars['String']>;
  project: MasterCreateNestedOneWithoutGoalsInput;
};

export type GoalsOnMasterCreateManyGoalInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
};

export type GoalsOnMasterCreateManyGoalInputEnvelope = {
  data: Array<GoalsOnMasterCreateManyGoalInput>;
};

export type GoalsOnMasterCreateManyProjectInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  goalId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
};

export type GoalsOnMasterCreateManyProjectInputEnvelope = {
  data: Array<GoalsOnMasterCreateManyProjectInput>;
};

export type GoalsOnMasterCreateNestedManyWithoutGoalInput = {
  connect?: InputMaybe<Array<GoalsOnMasterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<GoalsOnMasterCreateOrConnectWithoutGoalInput>>;
  create?: InputMaybe<Array<GoalsOnMasterCreateWithoutGoalInput>>;
  createMany?: InputMaybe<GoalsOnMasterCreateManyGoalInputEnvelope>;
};

export type GoalsOnMasterCreateNestedManyWithoutProjectInput = {
  connect?: InputMaybe<Array<GoalsOnMasterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<GoalsOnMasterCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<GoalsOnMasterCreateWithoutProjectInput>>;
  createMany?: InputMaybe<GoalsOnMasterCreateManyProjectInputEnvelope>;
};

export type GoalsOnMasterCreateOrConnectWithoutGoalInput = {
  create: GoalsOnMasterCreateWithoutGoalInput;
  where: GoalsOnMasterWhereUniqueInput;
};

export type GoalsOnMasterCreateOrConnectWithoutProjectInput = {
  create: GoalsOnMasterCreateWithoutProjectInput;
  where: GoalsOnMasterWhereUniqueInput;
};

export type GoalsOnMasterCreateWithoutGoalInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  project: MasterCreateNestedOneWithoutGoalsInput;
};

export type GoalsOnMasterCreateWithoutProjectInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  goal: GoalCreateNestedOneWithoutProjectInput;
  id?: InputMaybe<Scalars['String']>;
};

export type GoalsOnMasterListRelationFilter = {
  every?: InputMaybe<GoalsOnMasterWhereInput>;
  none?: InputMaybe<GoalsOnMasterWhereInput>;
  some?: InputMaybe<GoalsOnMasterWhereInput>;
};

export type GoalsOnMasterOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type GoalsOnMasterOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  deletedBy?: InputMaybe<SortOrder>;
  goal?: InputMaybe<GoalOrderByWithRelationInput>;
  goalId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  project?: InputMaybe<MasterOrderByWithRelationInput>;
  projectId?: InputMaybe<SortOrder>;
};

export enum GoalsOnMasterScalarFieldEnum {
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  DeletedAt = 'deletedAt',
  DeletedBy = 'deletedBy',
  GoalId = 'goalId',
  Id = 'id',
  ProjectId = 'projectId'
}

export type GoalsOnMasterScalarWhereInput = {
  AND?: InputMaybe<Array<GoalsOnMasterScalarWhereInput>>;
  NOT?: InputMaybe<Array<GoalsOnMasterScalarWhereInput>>;
  OR?: InputMaybe<Array<GoalsOnMasterScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  goalId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  projectId?: InputMaybe<StringFilter>;
};

export type GoalsOnMasterUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  goal?: InputMaybe<GoalUpdateOneRequiredWithoutProjectNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutGoalsNestedInput>;
};

export type GoalsOnMasterUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type GoalsOnMasterUpdateManyWithWhereWithoutGoalInput = {
  data: GoalsOnMasterUpdateManyMutationInput;
  where: GoalsOnMasterScalarWhereInput;
};

export type GoalsOnMasterUpdateManyWithWhereWithoutProjectInput = {
  data: GoalsOnMasterUpdateManyMutationInput;
  where: GoalsOnMasterScalarWhereInput;
};

export type GoalsOnMasterUpdateManyWithoutGoalNestedInput = {
  connect?: InputMaybe<Array<GoalsOnMasterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<GoalsOnMasterCreateOrConnectWithoutGoalInput>>;
  create?: InputMaybe<Array<GoalsOnMasterCreateWithoutGoalInput>>;
  createMany?: InputMaybe<GoalsOnMasterCreateManyGoalInputEnvelope>;
  delete?: InputMaybe<Array<GoalsOnMasterWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<GoalsOnMasterScalarWhereInput>>;
  disconnect?: InputMaybe<Array<GoalsOnMasterWhereUniqueInput>>;
  set?: InputMaybe<Array<GoalsOnMasterWhereUniqueInput>>;
  update?: InputMaybe<Array<GoalsOnMasterUpdateWithWhereUniqueWithoutGoalInput>>;
  updateMany?: InputMaybe<Array<GoalsOnMasterUpdateManyWithWhereWithoutGoalInput>>;
  upsert?: InputMaybe<Array<GoalsOnMasterUpsertWithWhereUniqueWithoutGoalInput>>;
};

export type GoalsOnMasterUpdateManyWithoutProjectNestedInput = {
  connect?: InputMaybe<Array<GoalsOnMasterWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<GoalsOnMasterCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<GoalsOnMasterCreateWithoutProjectInput>>;
  createMany?: InputMaybe<GoalsOnMasterCreateManyProjectInputEnvelope>;
  delete?: InputMaybe<Array<GoalsOnMasterWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<GoalsOnMasterScalarWhereInput>>;
  disconnect?: InputMaybe<Array<GoalsOnMasterWhereUniqueInput>>;
  set?: InputMaybe<Array<GoalsOnMasterWhereUniqueInput>>;
  update?: InputMaybe<Array<GoalsOnMasterUpdateWithWhereUniqueWithoutProjectInput>>;
  updateMany?: InputMaybe<Array<GoalsOnMasterUpdateManyWithWhereWithoutProjectInput>>;
  upsert?: InputMaybe<Array<GoalsOnMasterUpsertWithWhereUniqueWithoutProjectInput>>;
};

export type GoalsOnMasterUpdateWithWhereUniqueWithoutGoalInput = {
  data: GoalsOnMasterUpdateWithoutGoalInput;
  where: GoalsOnMasterWhereUniqueInput;
};

export type GoalsOnMasterUpdateWithWhereUniqueWithoutProjectInput = {
  data: GoalsOnMasterUpdateWithoutProjectInput;
  where: GoalsOnMasterWhereUniqueInput;
};

export type GoalsOnMasterUpdateWithoutGoalInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutGoalsNestedInput>;
};

export type GoalsOnMasterUpdateWithoutProjectInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  goal?: InputMaybe<GoalUpdateOneRequiredWithoutProjectNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type GoalsOnMasterUpsertWithWhereUniqueWithoutGoalInput = {
  create: GoalsOnMasterCreateWithoutGoalInput;
  update: GoalsOnMasterUpdateWithoutGoalInput;
  where: GoalsOnMasterWhereUniqueInput;
};

export type GoalsOnMasterUpsertWithWhereUniqueWithoutProjectInput = {
  create: GoalsOnMasterCreateWithoutProjectInput;
  update: GoalsOnMasterUpdateWithoutProjectInput;
  where: GoalsOnMasterWhereUniqueInput;
};

export type GoalsOnMasterWhereInput = {
  AND?: InputMaybe<Array<GoalsOnMasterWhereInput>>;
  NOT?: InputMaybe<Array<GoalsOnMasterWhereInput>>;
  OR?: InputMaybe<Array<GoalsOnMasterWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  goal?: InputMaybe<GoalWhereInput>;
  goalId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  project?: InputMaybe<MasterWhereInput>;
  projectId?: InputMaybe<StringFilter>;
};

export type GoalsOnMasterWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type IntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']>;
  divide?: InputMaybe<Scalars['Int']>;
  increment?: InputMaybe<Scalars['Int']>;
  multiply?: InputMaybe<Scalars['Int']>;
  set?: InputMaybe<Scalars['Int']>;
};

export type IntFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type IntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type IntNullableWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatNullableFilter>;
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedIntNullableFilter>;
  _min?: InputMaybe<NestedIntNullableFilter>;
  _sum?: InputMaybe<NestedIntNullableFilter>;
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type IntWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatFilter>;
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedIntFilter>;
  _min?: InputMaybe<NestedIntFilter>;
  _sum?: InputMaybe<NestedIntFilter>;
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type InterfaceDetail = {
  __typename?: 'InterfaceDetail';
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  interfaceFormat: InterfaceFormat;
  interfaceFormatId: Scalars['String'];
  interfaceType: InterfaceType;
  interfaceTypeId: Scalars['String'];
  isExport: Scalars['Boolean'];
  leanixMappingId?: Maybe<Scalars['String']>;
  projectInterface: ProjectInterface;
  projectInterfaceId: Scalars['String'];
};

export type InterfaceDetailCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  interfaceFormat: InterfaceFormatCreateNestedOneWithoutInterfaceDetailsInput;
  interfaceType: InterfaceTypeCreateNestedOneWithoutInterfaceDetailsInput;
  isExport: Scalars['Boolean'];
  leanixMappingId?: InputMaybe<Scalars['String']>;
  projectInterface: ProjectInterfaceCreateNestedOneWithoutInterfaceDetailInput;
};

export type InterfaceDetailCreateManyInterfaceFormatInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  interfaceTypeId: Scalars['String'];
  isExport: Scalars['Boolean'];
  leanixMappingId?: InputMaybe<Scalars['String']>;
  projectInterfaceId: Scalars['String'];
};

export type InterfaceDetailCreateManyInterfaceFormatInputEnvelope = {
  data: Array<InterfaceDetailCreateManyInterfaceFormatInput>;
};

export type InterfaceDetailCreateManyInterfaceTypeInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  interfaceFormatId: Scalars['String'];
  isExport: Scalars['Boolean'];
  leanixMappingId?: InputMaybe<Scalars['String']>;
  projectInterfaceId: Scalars['String'];
};

export type InterfaceDetailCreateManyInterfaceTypeInputEnvelope = {
  data: Array<InterfaceDetailCreateManyInterfaceTypeInput>;
};

export type InterfaceDetailCreateManyProjectInterfaceInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  interfaceFormatId: Scalars['String'];
  interfaceTypeId: Scalars['String'];
  isExport: Scalars['Boolean'];
  leanixMappingId?: InputMaybe<Scalars['String']>;
};

export type InterfaceDetailCreateManyProjectInterfaceInputEnvelope = {
  data: Array<InterfaceDetailCreateManyProjectInterfaceInput>;
};

export type InterfaceDetailCreateNestedManyWithoutInterfaceFormatInput = {
  connect?: InputMaybe<Array<InterfaceDetailWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<InterfaceDetailCreateOrConnectWithoutInterfaceFormatInput>>;
  create?: InputMaybe<Array<InterfaceDetailCreateWithoutInterfaceFormatInput>>;
  createMany?: InputMaybe<InterfaceDetailCreateManyInterfaceFormatInputEnvelope>;
};

export type InterfaceDetailCreateNestedManyWithoutInterfaceTypeInput = {
  connect?: InputMaybe<Array<InterfaceDetailWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<InterfaceDetailCreateOrConnectWithoutInterfaceTypeInput>>;
  create?: InputMaybe<Array<InterfaceDetailCreateWithoutInterfaceTypeInput>>;
  createMany?: InputMaybe<InterfaceDetailCreateManyInterfaceTypeInputEnvelope>;
};

export type InterfaceDetailCreateNestedManyWithoutProjectInterfaceInput = {
  connect?: InputMaybe<Array<InterfaceDetailWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<InterfaceDetailCreateOrConnectWithoutProjectInterfaceInput>>;
  create?: InputMaybe<Array<InterfaceDetailCreateWithoutProjectInterfaceInput>>;
  createMany?: InputMaybe<InterfaceDetailCreateManyProjectInterfaceInputEnvelope>;
};

export type InterfaceDetailCreateOrConnectWithoutInterfaceFormatInput = {
  create: InterfaceDetailCreateWithoutInterfaceFormatInput;
  where: InterfaceDetailWhereUniqueInput;
};

export type InterfaceDetailCreateOrConnectWithoutInterfaceTypeInput = {
  create: InterfaceDetailCreateWithoutInterfaceTypeInput;
  where: InterfaceDetailWhereUniqueInput;
};

export type InterfaceDetailCreateOrConnectWithoutProjectInterfaceInput = {
  create: InterfaceDetailCreateWithoutProjectInterfaceInput;
  where: InterfaceDetailWhereUniqueInput;
};

export type InterfaceDetailCreateWithoutInterfaceFormatInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  interfaceType: InterfaceTypeCreateNestedOneWithoutInterfaceDetailsInput;
  isExport: Scalars['Boolean'];
  leanixMappingId?: InputMaybe<Scalars['String']>;
  projectInterface: ProjectInterfaceCreateNestedOneWithoutInterfaceDetailInput;
};

export type InterfaceDetailCreateWithoutInterfaceTypeInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  interfaceFormat: InterfaceFormatCreateNestedOneWithoutInterfaceDetailsInput;
  isExport: Scalars['Boolean'];
  leanixMappingId?: InputMaybe<Scalars['String']>;
  projectInterface: ProjectInterfaceCreateNestedOneWithoutInterfaceDetailInput;
};

export type InterfaceDetailCreateWithoutProjectInterfaceInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  interfaceFormat: InterfaceFormatCreateNestedOneWithoutInterfaceDetailsInput;
  interfaceType: InterfaceTypeCreateNestedOneWithoutInterfaceDetailsInput;
  isExport: Scalars['Boolean'];
  leanixMappingId?: InputMaybe<Scalars['String']>;
};

export type InterfaceDetailListRelationFilter = {
  every?: InputMaybe<InterfaceDetailWhereInput>;
  none?: InputMaybe<InterfaceDetailWhereInput>;
  some?: InputMaybe<InterfaceDetailWhereInput>;
};

export type InterfaceDetailOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type InterfaceDetailOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  deletedBy?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  interfaceFormat?: InputMaybe<InterfaceFormatOrderByWithRelationInput>;
  interfaceFormatId?: InputMaybe<SortOrder>;
  interfaceType?: InputMaybe<InterfaceTypeOrderByWithRelationInput>;
  interfaceTypeId?: InputMaybe<SortOrder>;
  isExport?: InputMaybe<SortOrder>;
  leanixMappingId?: InputMaybe<SortOrder>;
  projectInterface?: InputMaybe<ProjectInterfaceOrderByWithRelationInput>;
  projectInterfaceId?: InputMaybe<SortOrder>;
};

export enum InterfaceDetailScalarFieldEnum {
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  DeletedAt = 'deletedAt',
  DeletedBy = 'deletedBy',
  Description = 'description',
  Id = 'id',
  InterfaceFormatId = 'interfaceFormatId',
  InterfaceTypeId = 'interfaceTypeId',
  IsExport = 'isExport',
  LeanixMappingId = 'leanixMappingId',
  ProjectInterfaceId = 'projectInterfaceId'
}

export type InterfaceDetailScalarWhereInput = {
  AND?: InputMaybe<Array<InterfaceDetailScalarWhereInput>>;
  NOT?: InputMaybe<Array<InterfaceDetailScalarWhereInput>>;
  OR?: InputMaybe<Array<InterfaceDetailScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  interfaceFormatId?: InputMaybe<StringFilter>;
  interfaceTypeId?: InputMaybe<StringFilter>;
  isExport?: InputMaybe<BoolFilter>;
  leanixMappingId?: InputMaybe<StringNullableFilter>;
  projectInterfaceId?: InputMaybe<StringFilter>;
};

export type InterfaceDetailUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  interfaceFormat?: InputMaybe<InterfaceFormatUpdateOneRequiredWithoutInterfaceDetailsNestedInput>;
  interfaceType?: InputMaybe<InterfaceTypeUpdateOneRequiredWithoutInterfaceDetailsNestedInput>;
  isExport?: InputMaybe<BoolFieldUpdateOperationsInput>;
  leanixMappingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  projectInterface?: InputMaybe<ProjectInterfaceUpdateOneRequiredWithoutInterfaceDetailNestedInput>;
};

export type InterfaceDetailUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isExport?: InputMaybe<BoolFieldUpdateOperationsInput>;
  leanixMappingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type InterfaceDetailUpdateManyWithWhereWithoutInterfaceFormatInput = {
  data: InterfaceDetailUpdateManyMutationInput;
  where: InterfaceDetailScalarWhereInput;
};

export type InterfaceDetailUpdateManyWithWhereWithoutInterfaceTypeInput = {
  data: InterfaceDetailUpdateManyMutationInput;
  where: InterfaceDetailScalarWhereInput;
};

export type InterfaceDetailUpdateManyWithWhereWithoutProjectInterfaceInput = {
  data: InterfaceDetailUpdateManyMutationInput;
  where: InterfaceDetailScalarWhereInput;
};

export type InterfaceDetailUpdateManyWithoutInterfaceFormatNestedInput = {
  connect?: InputMaybe<Array<InterfaceDetailWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<InterfaceDetailCreateOrConnectWithoutInterfaceFormatInput>>;
  create?: InputMaybe<Array<InterfaceDetailCreateWithoutInterfaceFormatInput>>;
  createMany?: InputMaybe<InterfaceDetailCreateManyInterfaceFormatInputEnvelope>;
  delete?: InputMaybe<Array<InterfaceDetailWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<InterfaceDetailScalarWhereInput>>;
  disconnect?: InputMaybe<Array<InterfaceDetailWhereUniqueInput>>;
  set?: InputMaybe<Array<InterfaceDetailWhereUniqueInput>>;
  update?: InputMaybe<Array<InterfaceDetailUpdateWithWhereUniqueWithoutInterfaceFormatInput>>;
  updateMany?: InputMaybe<Array<InterfaceDetailUpdateManyWithWhereWithoutInterfaceFormatInput>>;
  upsert?: InputMaybe<Array<InterfaceDetailUpsertWithWhereUniqueWithoutInterfaceFormatInput>>;
};

export type InterfaceDetailUpdateManyWithoutInterfaceTypeNestedInput = {
  connect?: InputMaybe<Array<InterfaceDetailWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<InterfaceDetailCreateOrConnectWithoutInterfaceTypeInput>>;
  create?: InputMaybe<Array<InterfaceDetailCreateWithoutInterfaceTypeInput>>;
  createMany?: InputMaybe<InterfaceDetailCreateManyInterfaceTypeInputEnvelope>;
  delete?: InputMaybe<Array<InterfaceDetailWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<InterfaceDetailScalarWhereInput>>;
  disconnect?: InputMaybe<Array<InterfaceDetailWhereUniqueInput>>;
  set?: InputMaybe<Array<InterfaceDetailWhereUniqueInput>>;
  update?: InputMaybe<Array<InterfaceDetailUpdateWithWhereUniqueWithoutInterfaceTypeInput>>;
  updateMany?: InputMaybe<Array<InterfaceDetailUpdateManyWithWhereWithoutInterfaceTypeInput>>;
  upsert?: InputMaybe<Array<InterfaceDetailUpsertWithWhereUniqueWithoutInterfaceTypeInput>>;
};

export type InterfaceDetailUpdateManyWithoutProjectInterfaceNestedInput = {
  connect?: InputMaybe<Array<InterfaceDetailWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<InterfaceDetailCreateOrConnectWithoutProjectInterfaceInput>>;
  create?: InputMaybe<Array<InterfaceDetailCreateWithoutProjectInterfaceInput>>;
  createMany?: InputMaybe<InterfaceDetailCreateManyProjectInterfaceInputEnvelope>;
  delete?: InputMaybe<Array<InterfaceDetailWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<InterfaceDetailScalarWhereInput>>;
  disconnect?: InputMaybe<Array<InterfaceDetailWhereUniqueInput>>;
  set?: InputMaybe<Array<InterfaceDetailWhereUniqueInput>>;
  update?: InputMaybe<Array<InterfaceDetailUpdateWithWhereUniqueWithoutProjectInterfaceInput>>;
  updateMany?: InputMaybe<Array<InterfaceDetailUpdateManyWithWhereWithoutProjectInterfaceInput>>;
  upsert?: InputMaybe<Array<InterfaceDetailUpsertWithWhereUniqueWithoutProjectInterfaceInput>>;
};

export type InterfaceDetailUpdateWithWhereUniqueWithoutInterfaceFormatInput = {
  data: InterfaceDetailUpdateWithoutInterfaceFormatInput;
  where: InterfaceDetailWhereUniqueInput;
};

export type InterfaceDetailUpdateWithWhereUniqueWithoutInterfaceTypeInput = {
  data: InterfaceDetailUpdateWithoutInterfaceTypeInput;
  where: InterfaceDetailWhereUniqueInput;
};

export type InterfaceDetailUpdateWithWhereUniqueWithoutProjectInterfaceInput = {
  data: InterfaceDetailUpdateWithoutProjectInterfaceInput;
  where: InterfaceDetailWhereUniqueInput;
};

export type InterfaceDetailUpdateWithoutInterfaceFormatInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  interfaceType?: InputMaybe<InterfaceTypeUpdateOneRequiredWithoutInterfaceDetailsNestedInput>;
  isExport?: InputMaybe<BoolFieldUpdateOperationsInput>;
  leanixMappingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  projectInterface?: InputMaybe<ProjectInterfaceUpdateOneRequiredWithoutInterfaceDetailNestedInput>;
};

export type InterfaceDetailUpdateWithoutInterfaceTypeInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  interfaceFormat?: InputMaybe<InterfaceFormatUpdateOneRequiredWithoutInterfaceDetailsNestedInput>;
  isExport?: InputMaybe<BoolFieldUpdateOperationsInput>;
  leanixMappingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  projectInterface?: InputMaybe<ProjectInterfaceUpdateOneRequiredWithoutInterfaceDetailNestedInput>;
};

export type InterfaceDetailUpdateWithoutProjectInterfaceInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  interfaceFormat?: InputMaybe<InterfaceFormatUpdateOneRequiredWithoutInterfaceDetailsNestedInput>;
  interfaceType?: InputMaybe<InterfaceTypeUpdateOneRequiredWithoutInterfaceDetailsNestedInput>;
  isExport?: InputMaybe<BoolFieldUpdateOperationsInput>;
  leanixMappingId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type InterfaceDetailUpsertWithWhereUniqueWithoutInterfaceFormatInput = {
  create: InterfaceDetailCreateWithoutInterfaceFormatInput;
  update: InterfaceDetailUpdateWithoutInterfaceFormatInput;
  where: InterfaceDetailWhereUniqueInput;
};

export type InterfaceDetailUpsertWithWhereUniqueWithoutInterfaceTypeInput = {
  create: InterfaceDetailCreateWithoutInterfaceTypeInput;
  update: InterfaceDetailUpdateWithoutInterfaceTypeInput;
  where: InterfaceDetailWhereUniqueInput;
};

export type InterfaceDetailUpsertWithWhereUniqueWithoutProjectInterfaceInput = {
  create: InterfaceDetailCreateWithoutProjectInterfaceInput;
  update: InterfaceDetailUpdateWithoutProjectInterfaceInput;
  where: InterfaceDetailWhereUniqueInput;
};

export type InterfaceDetailWhereInput = {
  AND?: InputMaybe<Array<InterfaceDetailWhereInput>>;
  NOT?: InputMaybe<Array<InterfaceDetailWhereInput>>;
  OR?: InputMaybe<Array<InterfaceDetailWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  interfaceFormat?: InputMaybe<InterfaceFormatWhereInput>;
  interfaceFormatId?: InputMaybe<StringFilter>;
  interfaceType?: InputMaybe<InterfaceTypeWhereInput>;
  interfaceTypeId?: InputMaybe<StringFilter>;
  isExport?: InputMaybe<BoolFilter>;
  leanixMappingId?: InputMaybe<StringNullableFilter>;
  projectInterface?: InputMaybe<ProjectInterfaceWhereInput>;
  projectInterfaceId?: InputMaybe<StringFilter>;
};

export type InterfaceDetailWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type InterfaceFormat = {
  __typename?: 'InterfaceFormat';
  _count: InterfaceFormatCount;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  interfaceDetails?: Maybe<Array<InterfaceDetail>>;
};

export type InterfaceFormatCount = {
  __typename?: 'InterfaceFormatCount';
  interfaceDetails: Scalars['Int'];
};

export type InterfaceFormatCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  interfaceDetails?: InputMaybe<InterfaceDetailCreateNestedManyWithoutInterfaceFormatInput>;
};

export type InterfaceFormatCreateNestedOneWithoutInterfaceDetailsInput = {
  connect?: InputMaybe<InterfaceFormatWhereUniqueInput>;
  connectOrCreate?: InputMaybe<InterfaceFormatCreateOrConnectWithoutInterfaceDetailsInput>;
  create?: InputMaybe<InterfaceFormatCreateWithoutInterfaceDetailsInput>;
};

export type InterfaceFormatCreateOrConnectWithoutInterfaceDetailsInput = {
  create: InterfaceFormatCreateWithoutInterfaceDetailsInput;
  where: InterfaceFormatWhereUniqueInput;
};

export type InterfaceFormatCreateWithoutInterfaceDetailsInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

export type InterfaceFormatOrderByWithRelationInput = {
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  interfaceDetails?: InputMaybe<InterfaceDetailOrderByRelationAggregateInput>;
};

export enum InterfaceFormatScalarFieldEnum {
  Description = 'description',
  Id = 'id'
}

export type InterfaceFormatUpdateInput = {
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  interfaceDetails?: InputMaybe<InterfaceDetailUpdateManyWithoutInterfaceFormatNestedInput>;
};

export type InterfaceFormatUpdateOneRequiredWithoutInterfaceDetailsNestedInput = {
  connect?: InputMaybe<InterfaceFormatWhereUniqueInput>;
  connectOrCreate?: InputMaybe<InterfaceFormatCreateOrConnectWithoutInterfaceDetailsInput>;
  create?: InputMaybe<InterfaceFormatCreateWithoutInterfaceDetailsInput>;
  update?: InputMaybe<InterfaceFormatUpdateWithoutInterfaceDetailsInput>;
  upsert?: InputMaybe<InterfaceFormatUpsertWithoutInterfaceDetailsInput>;
};

export type InterfaceFormatUpdateWithoutInterfaceDetailsInput = {
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type InterfaceFormatUpsertWithoutInterfaceDetailsInput = {
  create: InterfaceFormatCreateWithoutInterfaceDetailsInput;
  update: InterfaceFormatUpdateWithoutInterfaceDetailsInput;
};

export type InterfaceFormatWhereInput = {
  AND?: InputMaybe<Array<InterfaceFormatWhereInput>>;
  NOT?: InputMaybe<Array<InterfaceFormatWhereInput>>;
  OR?: InputMaybe<Array<InterfaceFormatWhereInput>>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  interfaceDetails?: InputMaybe<InterfaceDetailListRelationFilter>;
};

export type InterfaceFormatWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type InterfaceReference = {
  __typename?: 'InterfaceReference';
  _count: InterfaceReferenceCount;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  projectInterface?: Maybe<Array<ProjectInterface>>;
};

export type InterfaceReferenceCount = {
  __typename?: 'InterfaceReferenceCount';
  projectInterface: Scalars['Int'];
};

export type InterfaceReferenceCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  projectInterface?: InputMaybe<ProjectInterfaceCreateNestedManyWithoutInterfaceReferenceInput>;
};

export type InterfaceReferenceCreateNestedOneWithoutProjectInterfaceInput = {
  connect?: InputMaybe<InterfaceReferenceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<InterfaceReferenceCreateOrConnectWithoutProjectInterfaceInput>;
  create?: InputMaybe<InterfaceReferenceCreateWithoutProjectInterfaceInput>;
};

export type InterfaceReferenceCreateOrConnectWithoutProjectInterfaceInput = {
  create: InterfaceReferenceCreateWithoutProjectInterfaceInput;
  where: InterfaceReferenceWhereUniqueInput;
};

export type InterfaceReferenceCreateWithoutProjectInterfaceInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

export type InterfaceReferenceOrderByWithRelationInput = {
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  projectInterface?: InputMaybe<ProjectInterfaceOrderByRelationAggregateInput>;
};

export enum InterfaceReferenceScalarFieldEnum {
  Description = 'description',
  Id = 'id'
}

export type InterfaceReferenceUpdateInput = {
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  projectInterface?: InputMaybe<ProjectInterfaceUpdateManyWithoutInterfaceReferenceNestedInput>;
};

export type InterfaceReferenceUpdateOneRequiredWithoutProjectInterfaceNestedInput = {
  connect?: InputMaybe<InterfaceReferenceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<InterfaceReferenceCreateOrConnectWithoutProjectInterfaceInput>;
  create?: InputMaybe<InterfaceReferenceCreateWithoutProjectInterfaceInput>;
  update?: InputMaybe<InterfaceReferenceUpdateWithoutProjectInterfaceInput>;
  upsert?: InputMaybe<InterfaceReferenceUpsertWithoutProjectInterfaceInput>;
};

export type InterfaceReferenceUpdateWithoutProjectInterfaceInput = {
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type InterfaceReferenceUpsertWithoutProjectInterfaceInput = {
  create: InterfaceReferenceCreateWithoutProjectInterfaceInput;
  update: InterfaceReferenceUpdateWithoutProjectInterfaceInput;
};

export type InterfaceReferenceWhereInput = {
  AND?: InputMaybe<Array<InterfaceReferenceWhereInput>>;
  NOT?: InputMaybe<Array<InterfaceReferenceWhereInput>>;
  OR?: InputMaybe<Array<InterfaceReferenceWhereInput>>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  projectInterface?: InputMaybe<ProjectInterfaceListRelationFilter>;
};

export type InterfaceReferenceWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type InterfaceType = {
  __typename?: 'InterfaceType';
  _count: InterfaceTypeCount;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  interfaceDetails?: Maybe<Array<InterfaceDetail>>;
};

export type InterfaceTypeCount = {
  __typename?: 'InterfaceTypeCount';
  interfaceDetails: Scalars['Int'];
};

export type InterfaceTypeCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  interfaceDetails?: InputMaybe<InterfaceDetailCreateNestedManyWithoutInterfaceTypeInput>;
};

export type InterfaceTypeCreateNestedOneWithoutInterfaceDetailsInput = {
  connect?: InputMaybe<InterfaceTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<InterfaceTypeCreateOrConnectWithoutInterfaceDetailsInput>;
  create?: InputMaybe<InterfaceTypeCreateWithoutInterfaceDetailsInput>;
};

export type InterfaceTypeCreateOrConnectWithoutInterfaceDetailsInput = {
  create: InterfaceTypeCreateWithoutInterfaceDetailsInput;
  where: InterfaceTypeWhereUniqueInput;
};

export type InterfaceTypeCreateWithoutInterfaceDetailsInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

export type InterfaceTypeOrderByWithRelationInput = {
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  interfaceDetails?: InputMaybe<InterfaceDetailOrderByRelationAggregateInput>;
};

export enum InterfaceTypeScalarFieldEnum {
  Description = 'description',
  Id = 'id'
}

export type InterfaceTypeUpdateInput = {
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  interfaceDetails?: InputMaybe<InterfaceDetailUpdateManyWithoutInterfaceTypeNestedInput>;
};

export type InterfaceTypeUpdateOneRequiredWithoutInterfaceDetailsNestedInput = {
  connect?: InputMaybe<InterfaceTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<InterfaceTypeCreateOrConnectWithoutInterfaceDetailsInput>;
  create?: InputMaybe<InterfaceTypeCreateWithoutInterfaceDetailsInput>;
  update?: InputMaybe<InterfaceTypeUpdateWithoutInterfaceDetailsInput>;
  upsert?: InputMaybe<InterfaceTypeUpsertWithoutInterfaceDetailsInput>;
};

export type InterfaceTypeUpdateWithoutInterfaceDetailsInput = {
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type InterfaceTypeUpsertWithoutInterfaceDetailsInput = {
  create: InterfaceTypeCreateWithoutInterfaceDetailsInput;
  update: InterfaceTypeUpdateWithoutInterfaceDetailsInput;
};

export type InterfaceTypeWhereInput = {
  AND?: InputMaybe<Array<InterfaceTypeWhereInput>>;
  NOT?: InputMaybe<Array<InterfaceTypeWhereInput>>;
  OR?: InputMaybe<Array<InterfaceTypeWhereInput>>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  interfaceDetails?: InputMaybe<InterfaceDetailListRelationFilter>;
};

export type InterfaceTypeWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type LandingApplication = {
  __typename?: 'LandingApplication';
  _count: LandingApplicationCount;
  createdAt: Scalars['DateTime'];
  icon?: Maybe<Scalars['String']>;
  iconLocation?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isActive?: Maybe<Scalars['Boolean']>;
  isIframe?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  landingApplicationClusterMapping?: Maybe<Array<LandingApplicationClusterMapping>>;
  landingApplicationGroup?: Maybe<Array<LandingApplicationGroup>>;
  name: Scalars['String'];
  order?: Maybe<Scalars['Int']>;
  tooltip?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  url?: Maybe<Scalars['String']>;
};

export type LandingApplicationCluster = {
  __typename?: 'LandingApplicationCluster';
  _count: LandingApplicationClusterCount;
  clusterName: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  icon: Scalars['String'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  label: Scalars['String'];
  landingApplicationClusterGroup?: Maybe<Array<LandingApplicationClusterGroup>>;
  landingApplicationClusterMapping?: Maybe<Array<LandingApplicationClusterMapping>>;
  order: Scalars['Int'];
  tooltip: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  uri: Scalars['String'];
};

export type LandingApplicationClusterCount = {
  __typename?: 'LandingApplicationClusterCount';
  landingApplicationClusterGroup: Scalars['Int'];
  landingApplicationClusterMapping: Scalars['Int'];
};

export type LandingApplicationClusterCreateInput = {
  clusterName: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  icon: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  label: Scalars['String'];
  landingApplicationClusterGroup?: InputMaybe<LandingApplicationClusterGroupCreateNestedManyWithoutClusterInput>;
  landingApplicationClusterMapping?: InputMaybe<LandingApplicationClusterMappingCreateNestedManyWithoutClusterInput>;
  order?: InputMaybe<Scalars['Int']>;
  tooltip: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  uri: Scalars['String'];
};

export type LandingApplicationClusterCreateNestedOneWithoutLandingApplicationClusterGroupInput = {
  connect?: InputMaybe<LandingApplicationClusterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LandingApplicationClusterCreateOrConnectWithoutLandingApplicationClusterGroupInput>;
  create?: InputMaybe<LandingApplicationClusterCreateWithoutLandingApplicationClusterGroupInput>;
};

export type LandingApplicationClusterCreateNestedOneWithoutLandingApplicationClusterMappingInput = {
  connect?: InputMaybe<LandingApplicationClusterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LandingApplicationClusterCreateOrConnectWithoutLandingApplicationClusterMappingInput>;
  create?: InputMaybe<LandingApplicationClusterCreateWithoutLandingApplicationClusterMappingInput>;
};

export type LandingApplicationClusterCreateOrConnectWithoutLandingApplicationClusterGroupInput = {
  create: LandingApplicationClusterCreateWithoutLandingApplicationClusterGroupInput;
  where: LandingApplicationClusterWhereUniqueInput;
};

export type LandingApplicationClusterCreateOrConnectWithoutLandingApplicationClusterMappingInput = {
  create: LandingApplicationClusterCreateWithoutLandingApplicationClusterMappingInput;
  where: LandingApplicationClusterWhereUniqueInput;
};

export type LandingApplicationClusterCreateWithoutLandingApplicationClusterGroupInput = {
  clusterName: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  icon: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  label: Scalars['String'];
  landingApplicationClusterMapping?: InputMaybe<LandingApplicationClusterMappingCreateNestedManyWithoutClusterInput>;
  order?: InputMaybe<Scalars['Int']>;
  tooltip: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  uri: Scalars['String'];
};

export type LandingApplicationClusterCreateWithoutLandingApplicationClusterMappingInput = {
  clusterName: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  icon: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  isActive: Scalars['Boolean'];
  label: Scalars['String'];
  landingApplicationClusterGroup?: InputMaybe<LandingApplicationClusterGroupCreateNestedManyWithoutClusterInput>;
  order?: InputMaybe<Scalars['Int']>;
  tooltip: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  uri: Scalars['String'];
};

export type LandingApplicationClusterGroup = {
  __typename?: 'LandingApplicationClusterGroup';
  cluster: LandingApplicationCluster;
  clusterId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  groupId: Scalars['String'];
  id: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
};

export type LandingApplicationClusterGroupCreateInput = {
  cluster: LandingApplicationClusterCreateNestedOneWithoutLandingApplicationClusterGroupInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  groupId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LandingApplicationClusterGroupCreateManyClusterInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  groupId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LandingApplicationClusterGroupCreateManyClusterInputEnvelope = {
  data: Array<LandingApplicationClusterGroupCreateManyClusterInput>;
};

export type LandingApplicationClusterGroupCreateNestedManyWithoutClusterInput = {
  connect?: InputMaybe<Array<LandingApplicationClusterGroupWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LandingApplicationClusterGroupCreateOrConnectWithoutClusterInput>>;
  create?: InputMaybe<Array<LandingApplicationClusterGroupCreateWithoutClusterInput>>;
  createMany?: InputMaybe<LandingApplicationClusterGroupCreateManyClusterInputEnvelope>;
};

export type LandingApplicationClusterGroupCreateOrConnectWithoutClusterInput = {
  create: LandingApplicationClusterGroupCreateWithoutClusterInput;
  where: LandingApplicationClusterGroupWhereUniqueInput;
};

export type LandingApplicationClusterGroupCreateWithoutClusterInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  groupId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LandingApplicationClusterGroupListRelationFilter = {
  every?: InputMaybe<LandingApplicationClusterGroupWhereInput>;
  none?: InputMaybe<LandingApplicationClusterGroupWhereInput>;
  some?: InputMaybe<LandingApplicationClusterGroupWhereInput>;
};

export type LandingApplicationClusterGroupOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type LandingApplicationClusterGroupOrderByWithRelationInput = {
  cluster?: InputMaybe<LandingApplicationClusterOrderByWithRelationInput>;
  clusterId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  deletedBy?: InputMaybe<SortOrder>;
  groupId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum LandingApplicationClusterGroupScalarFieldEnum {
  ClusterId = 'clusterId',
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  DeletedAt = 'deletedAt',
  DeletedBy = 'deletedBy',
  GroupId = 'groupId',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

export type LandingApplicationClusterGroupScalarWhereInput = {
  AND?: InputMaybe<Array<LandingApplicationClusterGroupScalarWhereInput>>;
  NOT?: InputMaybe<Array<LandingApplicationClusterGroupScalarWhereInput>>;
  OR?: InputMaybe<Array<LandingApplicationClusterGroupScalarWhereInput>>;
  clusterId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  groupId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type LandingApplicationClusterGroupUpdateInput = {
  cluster?: InputMaybe<LandingApplicationClusterUpdateOneRequiredWithoutLandingApplicationClusterGroupNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  groupId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LandingApplicationClusterGroupUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  groupId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LandingApplicationClusterGroupUpdateManyWithWhereWithoutClusterInput = {
  data: LandingApplicationClusterGroupUpdateManyMutationInput;
  where: LandingApplicationClusterGroupScalarWhereInput;
};

export type LandingApplicationClusterGroupUpdateManyWithoutClusterNestedInput = {
  connect?: InputMaybe<Array<LandingApplicationClusterGroupWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LandingApplicationClusterGroupCreateOrConnectWithoutClusterInput>>;
  create?: InputMaybe<Array<LandingApplicationClusterGroupCreateWithoutClusterInput>>;
  createMany?: InputMaybe<LandingApplicationClusterGroupCreateManyClusterInputEnvelope>;
  delete?: InputMaybe<Array<LandingApplicationClusterGroupWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LandingApplicationClusterGroupScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LandingApplicationClusterGroupWhereUniqueInput>>;
  set?: InputMaybe<Array<LandingApplicationClusterGroupWhereUniqueInput>>;
  update?: InputMaybe<Array<LandingApplicationClusterGroupUpdateWithWhereUniqueWithoutClusterInput>>;
  updateMany?: InputMaybe<Array<LandingApplicationClusterGroupUpdateManyWithWhereWithoutClusterInput>>;
  upsert?: InputMaybe<Array<LandingApplicationClusterGroupUpsertWithWhereUniqueWithoutClusterInput>>;
};

export type LandingApplicationClusterGroupUpdateWithWhereUniqueWithoutClusterInput = {
  data: LandingApplicationClusterGroupUpdateWithoutClusterInput;
  where: LandingApplicationClusterGroupWhereUniqueInput;
};

export type LandingApplicationClusterGroupUpdateWithoutClusterInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  groupId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LandingApplicationClusterGroupUpsertWithWhereUniqueWithoutClusterInput = {
  create: LandingApplicationClusterGroupCreateWithoutClusterInput;
  update: LandingApplicationClusterGroupUpdateWithoutClusterInput;
  where: LandingApplicationClusterGroupWhereUniqueInput;
};

export type LandingApplicationClusterGroupWhereInput = {
  AND?: InputMaybe<Array<LandingApplicationClusterGroupWhereInput>>;
  NOT?: InputMaybe<Array<LandingApplicationClusterGroupWhereInput>>;
  OR?: InputMaybe<Array<LandingApplicationClusterGroupWhereInput>>;
  cluster?: InputMaybe<LandingApplicationClusterWhereInput>;
  clusterId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  groupId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type LandingApplicationClusterGroupWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type LandingApplicationClusterMapping = {
  __typename?: 'LandingApplicationClusterMapping';
  cluster: LandingApplicationCluster;
  clusterId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  landingApplication: LandingApplication;
  landingApplicationId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type LandingApplicationClusterMappingCreateInput = {
  cluster: LandingApplicationClusterCreateNestedOneWithoutLandingApplicationClusterMappingInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  landingApplication: LandingApplicationCreateNestedOneWithoutLandingApplicationClusterMappingInput;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LandingApplicationClusterMappingCreateManyClusterInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  landingApplicationId: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LandingApplicationClusterMappingCreateManyClusterInputEnvelope = {
  data: Array<LandingApplicationClusterMappingCreateManyClusterInput>;
};

export type LandingApplicationClusterMappingCreateManyLandingApplicationInput = {
  clusterId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LandingApplicationClusterMappingCreateManyLandingApplicationInputEnvelope = {
  data: Array<LandingApplicationClusterMappingCreateManyLandingApplicationInput>;
};

export type LandingApplicationClusterMappingCreateNestedManyWithoutClusterInput = {
  connect?: InputMaybe<Array<LandingApplicationClusterMappingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LandingApplicationClusterMappingCreateOrConnectWithoutClusterInput>>;
  create?: InputMaybe<Array<LandingApplicationClusterMappingCreateWithoutClusterInput>>;
  createMany?: InputMaybe<LandingApplicationClusterMappingCreateManyClusterInputEnvelope>;
};

export type LandingApplicationClusterMappingCreateNestedManyWithoutLandingApplicationInput = {
  connect?: InputMaybe<Array<LandingApplicationClusterMappingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LandingApplicationClusterMappingCreateOrConnectWithoutLandingApplicationInput>>;
  create?: InputMaybe<Array<LandingApplicationClusterMappingCreateWithoutLandingApplicationInput>>;
  createMany?: InputMaybe<LandingApplicationClusterMappingCreateManyLandingApplicationInputEnvelope>;
};

export type LandingApplicationClusterMappingCreateOrConnectWithoutClusterInput = {
  create: LandingApplicationClusterMappingCreateWithoutClusterInput;
  where: LandingApplicationClusterMappingWhereUniqueInput;
};

export type LandingApplicationClusterMappingCreateOrConnectWithoutLandingApplicationInput = {
  create: LandingApplicationClusterMappingCreateWithoutLandingApplicationInput;
  where: LandingApplicationClusterMappingWhereUniqueInput;
};

export type LandingApplicationClusterMappingCreateWithoutClusterInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  landingApplication: LandingApplicationCreateNestedOneWithoutLandingApplicationClusterMappingInput;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LandingApplicationClusterMappingCreateWithoutLandingApplicationInput = {
  cluster: LandingApplicationClusterCreateNestedOneWithoutLandingApplicationClusterMappingInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LandingApplicationClusterMappingListRelationFilter = {
  every?: InputMaybe<LandingApplicationClusterMappingWhereInput>;
  none?: InputMaybe<LandingApplicationClusterMappingWhereInput>;
  some?: InputMaybe<LandingApplicationClusterMappingWhereInput>;
};

export type LandingApplicationClusterMappingOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type LandingApplicationClusterMappingOrderByWithRelationInput = {
  cluster?: InputMaybe<LandingApplicationClusterOrderByWithRelationInput>;
  clusterId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  deletedBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  landingApplication?: InputMaybe<LandingApplicationOrderByWithRelationInput>;
  landingApplicationId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum LandingApplicationClusterMappingScalarFieldEnum {
  ClusterId = 'clusterId',
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  DeletedAt = 'deletedAt',
  DeletedBy = 'deletedBy',
  Id = 'id',
  LandingApplicationId = 'landingApplicationId',
  UpdatedAt = 'updatedAt'
}

export type LandingApplicationClusterMappingScalarWhereInput = {
  AND?: InputMaybe<Array<LandingApplicationClusterMappingScalarWhereInput>>;
  NOT?: InputMaybe<Array<LandingApplicationClusterMappingScalarWhereInput>>;
  OR?: InputMaybe<Array<LandingApplicationClusterMappingScalarWhereInput>>;
  clusterId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  landingApplicationId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type LandingApplicationClusterMappingUpdateInput = {
  cluster?: InputMaybe<LandingApplicationClusterUpdateOneRequiredWithoutLandingApplicationClusterMappingNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  landingApplication?: InputMaybe<LandingApplicationUpdateOneRequiredWithoutLandingApplicationClusterMappingNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LandingApplicationClusterMappingUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LandingApplicationClusterMappingUpdateManyWithWhereWithoutClusterInput = {
  data: LandingApplicationClusterMappingUpdateManyMutationInput;
  where: LandingApplicationClusterMappingScalarWhereInput;
};

export type LandingApplicationClusterMappingUpdateManyWithWhereWithoutLandingApplicationInput = {
  data: LandingApplicationClusterMappingUpdateManyMutationInput;
  where: LandingApplicationClusterMappingScalarWhereInput;
};

export type LandingApplicationClusterMappingUpdateManyWithoutClusterNestedInput = {
  connect?: InputMaybe<Array<LandingApplicationClusterMappingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LandingApplicationClusterMappingCreateOrConnectWithoutClusterInput>>;
  create?: InputMaybe<Array<LandingApplicationClusterMappingCreateWithoutClusterInput>>;
  createMany?: InputMaybe<LandingApplicationClusterMappingCreateManyClusterInputEnvelope>;
  delete?: InputMaybe<Array<LandingApplicationClusterMappingWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LandingApplicationClusterMappingScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LandingApplicationClusterMappingWhereUniqueInput>>;
  set?: InputMaybe<Array<LandingApplicationClusterMappingWhereUniqueInput>>;
  update?: InputMaybe<Array<LandingApplicationClusterMappingUpdateWithWhereUniqueWithoutClusterInput>>;
  updateMany?: InputMaybe<Array<LandingApplicationClusterMappingUpdateManyWithWhereWithoutClusterInput>>;
  upsert?: InputMaybe<Array<LandingApplicationClusterMappingUpsertWithWhereUniqueWithoutClusterInput>>;
};

export type LandingApplicationClusterMappingUpdateManyWithoutLandingApplicationNestedInput = {
  connect?: InputMaybe<Array<LandingApplicationClusterMappingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LandingApplicationClusterMappingCreateOrConnectWithoutLandingApplicationInput>>;
  create?: InputMaybe<Array<LandingApplicationClusterMappingCreateWithoutLandingApplicationInput>>;
  createMany?: InputMaybe<LandingApplicationClusterMappingCreateManyLandingApplicationInputEnvelope>;
  delete?: InputMaybe<Array<LandingApplicationClusterMappingWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LandingApplicationClusterMappingScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LandingApplicationClusterMappingWhereUniqueInput>>;
  set?: InputMaybe<Array<LandingApplicationClusterMappingWhereUniqueInput>>;
  update?: InputMaybe<Array<LandingApplicationClusterMappingUpdateWithWhereUniqueWithoutLandingApplicationInput>>;
  updateMany?: InputMaybe<Array<LandingApplicationClusterMappingUpdateManyWithWhereWithoutLandingApplicationInput>>;
  upsert?: InputMaybe<Array<LandingApplicationClusterMappingUpsertWithWhereUniqueWithoutLandingApplicationInput>>;
};

export type LandingApplicationClusterMappingUpdateWithWhereUniqueWithoutClusterInput = {
  data: LandingApplicationClusterMappingUpdateWithoutClusterInput;
  where: LandingApplicationClusterMappingWhereUniqueInput;
};

export type LandingApplicationClusterMappingUpdateWithWhereUniqueWithoutLandingApplicationInput = {
  data: LandingApplicationClusterMappingUpdateWithoutLandingApplicationInput;
  where: LandingApplicationClusterMappingWhereUniqueInput;
};

export type LandingApplicationClusterMappingUpdateWithoutClusterInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  landingApplication?: InputMaybe<LandingApplicationUpdateOneRequiredWithoutLandingApplicationClusterMappingNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LandingApplicationClusterMappingUpdateWithoutLandingApplicationInput = {
  cluster?: InputMaybe<LandingApplicationClusterUpdateOneRequiredWithoutLandingApplicationClusterMappingNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LandingApplicationClusterMappingUpsertWithWhereUniqueWithoutClusterInput = {
  create: LandingApplicationClusterMappingCreateWithoutClusterInput;
  update: LandingApplicationClusterMappingUpdateWithoutClusterInput;
  where: LandingApplicationClusterMappingWhereUniqueInput;
};

export type LandingApplicationClusterMappingUpsertWithWhereUniqueWithoutLandingApplicationInput = {
  create: LandingApplicationClusterMappingCreateWithoutLandingApplicationInput;
  update: LandingApplicationClusterMappingUpdateWithoutLandingApplicationInput;
  where: LandingApplicationClusterMappingWhereUniqueInput;
};

export type LandingApplicationClusterMappingWhereInput = {
  AND?: InputMaybe<Array<LandingApplicationClusterMappingWhereInput>>;
  NOT?: InputMaybe<Array<LandingApplicationClusterMappingWhereInput>>;
  OR?: InputMaybe<Array<LandingApplicationClusterMappingWhereInput>>;
  cluster?: InputMaybe<LandingApplicationClusterWhereInput>;
  clusterId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  landingApplication?: InputMaybe<LandingApplicationWhereInput>;
  landingApplicationId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type LandingApplicationClusterMappingWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type LandingApplicationClusterOrderByWithRelationInput = {
  clusterName?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  deletedBy?: InputMaybe<SortOrder>;
  icon?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  label?: InputMaybe<SortOrder>;
  landingApplicationClusterGroup?: InputMaybe<LandingApplicationClusterGroupOrderByRelationAggregateInput>;
  landingApplicationClusterMapping?: InputMaybe<LandingApplicationClusterMappingOrderByRelationAggregateInput>;
  order?: InputMaybe<SortOrder>;
  tooltip?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  uri?: InputMaybe<SortOrder>;
};

export enum LandingApplicationClusterScalarFieldEnum {
  ClusterName = 'clusterName',
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  DeletedAt = 'deletedAt',
  DeletedBy = 'deletedBy',
  Icon = 'icon',
  Id = 'id',
  IsActive = 'isActive',
  Label = 'label',
  Order = 'order',
  Tooltip = 'tooltip',
  UpdatedAt = 'updatedAt',
  Uri = 'uri'
}

export type LandingApplicationClusterUpdateInput = {
  clusterName?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  icon?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  label?: InputMaybe<StringFieldUpdateOperationsInput>;
  landingApplicationClusterGroup?: InputMaybe<LandingApplicationClusterGroupUpdateManyWithoutClusterNestedInput>;
  landingApplicationClusterMapping?: InputMaybe<LandingApplicationClusterMappingUpdateManyWithoutClusterNestedInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  tooltip?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uri?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type LandingApplicationClusterUpdateOneRequiredWithoutLandingApplicationClusterGroupNestedInput = {
  connect?: InputMaybe<LandingApplicationClusterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LandingApplicationClusterCreateOrConnectWithoutLandingApplicationClusterGroupInput>;
  create?: InputMaybe<LandingApplicationClusterCreateWithoutLandingApplicationClusterGroupInput>;
  update?: InputMaybe<LandingApplicationClusterUpdateWithoutLandingApplicationClusterGroupInput>;
  upsert?: InputMaybe<LandingApplicationClusterUpsertWithoutLandingApplicationClusterGroupInput>;
};

export type LandingApplicationClusterUpdateOneRequiredWithoutLandingApplicationClusterMappingNestedInput = {
  connect?: InputMaybe<LandingApplicationClusterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LandingApplicationClusterCreateOrConnectWithoutLandingApplicationClusterMappingInput>;
  create?: InputMaybe<LandingApplicationClusterCreateWithoutLandingApplicationClusterMappingInput>;
  update?: InputMaybe<LandingApplicationClusterUpdateWithoutLandingApplicationClusterMappingInput>;
  upsert?: InputMaybe<LandingApplicationClusterUpsertWithoutLandingApplicationClusterMappingInput>;
};

export type LandingApplicationClusterUpdateWithoutLandingApplicationClusterGroupInput = {
  clusterName?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  icon?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  label?: InputMaybe<StringFieldUpdateOperationsInput>;
  landingApplicationClusterMapping?: InputMaybe<LandingApplicationClusterMappingUpdateManyWithoutClusterNestedInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  tooltip?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uri?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type LandingApplicationClusterUpdateWithoutLandingApplicationClusterMappingInput = {
  clusterName?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  icon?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  label?: InputMaybe<StringFieldUpdateOperationsInput>;
  landingApplicationClusterGroup?: InputMaybe<LandingApplicationClusterGroupUpdateManyWithoutClusterNestedInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  tooltip?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  uri?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type LandingApplicationClusterUpsertWithoutLandingApplicationClusterGroupInput = {
  create: LandingApplicationClusterCreateWithoutLandingApplicationClusterGroupInput;
  update: LandingApplicationClusterUpdateWithoutLandingApplicationClusterGroupInput;
};

export type LandingApplicationClusterUpsertWithoutLandingApplicationClusterMappingInput = {
  create: LandingApplicationClusterCreateWithoutLandingApplicationClusterMappingInput;
  update: LandingApplicationClusterUpdateWithoutLandingApplicationClusterMappingInput;
};

export type LandingApplicationClusterWhereInput = {
  AND?: InputMaybe<Array<LandingApplicationClusterWhereInput>>;
  NOT?: InputMaybe<Array<LandingApplicationClusterWhereInput>>;
  OR?: InputMaybe<Array<LandingApplicationClusterWhereInput>>;
  clusterName?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  icon?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  isActive?: InputMaybe<BoolFilter>;
  label?: InputMaybe<StringFilter>;
  landingApplicationClusterGroup?: InputMaybe<LandingApplicationClusterGroupListRelationFilter>;
  landingApplicationClusterMapping?: InputMaybe<LandingApplicationClusterMappingListRelationFilter>;
  order?: InputMaybe<IntFilter>;
  tooltip?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  uri?: InputMaybe<StringFilter>;
};

export type LandingApplicationClusterWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type LandingApplicationCount = {
  __typename?: 'LandingApplicationCount';
  landingApplicationClusterMapping: Scalars['Int'];
  landingApplicationGroup: Scalars['Int'];
};

export type LandingApplicationCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  icon?: InputMaybe<Scalars['String']>;
  iconLocation?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isIframe?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  landingApplicationClusterMapping?: InputMaybe<LandingApplicationClusterMappingCreateNestedManyWithoutLandingApplicationInput>;
  landingApplicationGroup?: InputMaybe<LandingApplicationGroupCreateNestedManyWithoutApplicationInput>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  tooltip?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  url?: InputMaybe<Scalars['String']>;
};

export type LandingApplicationCreateNestedOneWithoutLandingApplicationClusterMappingInput = {
  connect?: InputMaybe<LandingApplicationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LandingApplicationCreateOrConnectWithoutLandingApplicationClusterMappingInput>;
  create?: InputMaybe<LandingApplicationCreateWithoutLandingApplicationClusterMappingInput>;
};

export type LandingApplicationCreateNestedOneWithoutLandingApplicationGroupInput = {
  connect?: InputMaybe<LandingApplicationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LandingApplicationCreateOrConnectWithoutLandingApplicationGroupInput>;
  create?: InputMaybe<LandingApplicationCreateWithoutLandingApplicationGroupInput>;
};

export type LandingApplicationCreateOrConnectWithoutLandingApplicationClusterMappingInput = {
  create: LandingApplicationCreateWithoutLandingApplicationClusterMappingInput;
  where: LandingApplicationWhereUniqueInput;
};

export type LandingApplicationCreateOrConnectWithoutLandingApplicationGroupInput = {
  create: LandingApplicationCreateWithoutLandingApplicationGroupInput;
  where: LandingApplicationWhereUniqueInput;
};

export type LandingApplicationCreateWithoutLandingApplicationClusterMappingInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  icon?: InputMaybe<Scalars['String']>;
  iconLocation?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isIframe?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  landingApplicationGroup?: InputMaybe<LandingApplicationGroupCreateNestedManyWithoutApplicationInput>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  tooltip?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  url?: InputMaybe<Scalars['String']>;
};

export type LandingApplicationCreateWithoutLandingApplicationGroupInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  icon?: InputMaybe<Scalars['String']>;
  iconLocation?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isIframe?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  landingApplicationClusterMapping?: InputMaybe<LandingApplicationClusterMappingCreateNestedManyWithoutLandingApplicationInput>;
  name: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  tooltip?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  url?: InputMaybe<Scalars['String']>;
};

export type LandingApplicationGroup = {
  __typename?: 'LandingApplicationGroup';
  application: LandingApplication;
  applicationId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  groupId: Scalars['String'];
  id: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
};

export type LandingApplicationGroupCreateInput = {
  application: LandingApplicationCreateNestedOneWithoutLandingApplicationGroupInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  groupId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LandingApplicationGroupCreateManyApplicationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  groupId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LandingApplicationGroupCreateManyApplicationInputEnvelope = {
  data: Array<LandingApplicationGroupCreateManyApplicationInput>;
};

export type LandingApplicationGroupCreateNestedManyWithoutApplicationInput = {
  connect?: InputMaybe<Array<LandingApplicationGroupWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LandingApplicationGroupCreateOrConnectWithoutApplicationInput>>;
  create?: InputMaybe<Array<LandingApplicationGroupCreateWithoutApplicationInput>>;
  createMany?: InputMaybe<LandingApplicationGroupCreateManyApplicationInputEnvelope>;
};

export type LandingApplicationGroupCreateOrConnectWithoutApplicationInput = {
  create: LandingApplicationGroupCreateWithoutApplicationInput;
  where: LandingApplicationGroupWhereUniqueInput;
};

export type LandingApplicationGroupCreateWithoutApplicationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  groupId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LandingApplicationGroupListRelationFilter = {
  every?: InputMaybe<LandingApplicationGroupWhereInput>;
  none?: InputMaybe<LandingApplicationGroupWhereInput>;
  some?: InputMaybe<LandingApplicationGroupWhereInput>;
};

export type LandingApplicationGroupOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type LandingApplicationGroupOrderByWithRelationInput = {
  application?: InputMaybe<LandingApplicationOrderByWithRelationInput>;
  applicationId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  groupId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum LandingApplicationGroupScalarFieldEnum {
  ApplicationId = 'applicationId',
  CreatedAt = 'createdAt',
  GroupId = 'groupId',
  Id = 'id',
  UpdatedAt = 'updatedAt'
}

export type LandingApplicationGroupScalarWhereInput = {
  AND?: InputMaybe<Array<LandingApplicationGroupScalarWhereInput>>;
  NOT?: InputMaybe<Array<LandingApplicationGroupScalarWhereInput>>;
  OR?: InputMaybe<Array<LandingApplicationGroupScalarWhereInput>>;
  applicationId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  groupId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type LandingApplicationGroupUpdateInput = {
  application?: InputMaybe<LandingApplicationUpdateOneRequiredWithoutLandingApplicationGroupNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  groupId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LandingApplicationGroupUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  groupId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LandingApplicationGroupUpdateManyWithWhereWithoutApplicationInput = {
  data: LandingApplicationGroupUpdateManyMutationInput;
  where: LandingApplicationGroupScalarWhereInput;
};

export type LandingApplicationGroupUpdateManyWithoutApplicationNestedInput = {
  connect?: InputMaybe<Array<LandingApplicationGroupWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LandingApplicationGroupCreateOrConnectWithoutApplicationInput>>;
  create?: InputMaybe<Array<LandingApplicationGroupCreateWithoutApplicationInput>>;
  createMany?: InputMaybe<LandingApplicationGroupCreateManyApplicationInputEnvelope>;
  delete?: InputMaybe<Array<LandingApplicationGroupWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LandingApplicationGroupScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LandingApplicationGroupWhereUniqueInput>>;
  set?: InputMaybe<Array<LandingApplicationGroupWhereUniqueInput>>;
  update?: InputMaybe<Array<LandingApplicationGroupUpdateWithWhereUniqueWithoutApplicationInput>>;
  updateMany?: InputMaybe<Array<LandingApplicationGroupUpdateManyWithWhereWithoutApplicationInput>>;
  upsert?: InputMaybe<Array<LandingApplicationGroupUpsertWithWhereUniqueWithoutApplicationInput>>;
};

export type LandingApplicationGroupUpdateWithWhereUniqueWithoutApplicationInput = {
  data: LandingApplicationGroupUpdateWithoutApplicationInput;
  where: LandingApplicationGroupWhereUniqueInput;
};

export type LandingApplicationGroupUpdateWithoutApplicationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  groupId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LandingApplicationGroupUpsertWithWhereUniqueWithoutApplicationInput = {
  create: LandingApplicationGroupCreateWithoutApplicationInput;
  update: LandingApplicationGroupUpdateWithoutApplicationInput;
  where: LandingApplicationGroupWhereUniqueInput;
};

export type LandingApplicationGroupWhereInput = {
  AND?: InputMaybe<Array<LandingApplicationGroupWhereInput>>;
  NOT?: InputMaybe<Array<LandingApplicationGroupWhereInput>>;
  OR?: InputMaybe<Array<LandingApplicationGroupWhereInput>>;
  application?: InputMaybe<LandingApplicationWhereInput>;
  applicationId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  groupId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type LandingApplicationGroupWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type LandingApplicationOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  icon?: InputMaybe<SortOrder>;
  iconLocation?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  isIframe?: InputMaybe<SortOrder>;
  label?: InputMaybe<SortOrder>;
  landingApplicationClusterMapping?: InputMaybe<LandingApplicationClusterMappingOrderByRelationAggregateInput>;
  landingApplicationGroup?: InputMaybe<LandingApplicationGroupOrderByRelationAggregateInput>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  tooltip?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export enum LandingApplicationScalarFieldEnum {
  CreatedAt = 'createdAt',
  Icon = 'icon',
  IconLocation = 'iconLocation',
  Id = 'id',
  IsActive = 'isActive',
  IsIframe = 'isIframe',
  Label = 'label',
  Name = 'name',
  Order = 'order',
  Tooltip = 'tooltip',
  UpdatedAt = 'updatedAt',
  Url = 'url'
}

export type LandingApplicationUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  icon?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  iconLocation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIframe?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  label?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  landingApplicationClusterMapping?: InputMaybe<LandingApplicationClusterMappingUpdateManyWithoutLandingApplicationNestedInput>;
  landingApplicationGroup?: InputMaybe<LandingApplicationGroupUpdateManyWithoutApplicationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  tooltip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type LandingApplicationUpdateOneRequiredWithoutLandingApplicationClusterMappingNestedInput = {
  connect?: InputMaybe<LandingApplicationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LandingApplicationCreateOrConnectWithoutLandingApplicationClusterMappingInput>;
  create?: InputMaybe<LandingApplicationCreateWithoutLandingApplicationClusterMappingInput>;
  update?: InputMaybe<LandingApplicationUpdateWithoutLandingApplicationClusterMappingInput>;
  upsert?: InputMaybe<LandingApplicationUpsertWithoutLandingApplicationClusterMappingInput>;
};

export type LandingApplicationUpdateOneRequiredWithoutLandingApplicationGroupNestedInput = {
  connect?: InputMaybe<LandingApplicationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LandingApplicationCreateOrConnectWithoutLandingApplicationGroupInput>;
  create?: InputMaybe<LandingApplicationCreateWithoutLandingApplicationGroupInput>;
  update?: InputMaybe<LandingApplicationUpdateWithoutLandingApplicationGroupInput>;
  upsert?: InputMaybe<LandingApplicationUpsertWithoutLandingApplicationGroupInput>;
};

export type LandingApplicationUpdateWithoutLandingApplicationClusterMappingInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  icon?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  iconLocation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIframe?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  label?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  landingApplicationGroup?: InputMaybe<LandingApplicationGroupUpdateManyWithoutApplicationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  tooltip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type LandingApplicationUpdateWithoutLandingApplicationGroupInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  icon?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  iconLocation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isIframe?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  label?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  landingApplicationClusterMapping?: InputMaybe<LandingApplicationClusterMappingUpdateManyWithoutLandingApplicationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  tooltip?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type LandingApplicationUpsertWithoutLandingApplicationClusterMappingInput = {
  create: LandingApplicationCreateWithoutLandingApplicationClusterMappingInput;
  update: LandingApplicationUpdateWithoutLandingApplicationClusterMappingInput;
};

export type LandingApplicationUpsertWithoutLandingApplicationGroupInput = {
  create: LandingApplicationCreateWithoutLandingApplicationGroupInput;
  update: LandingApplicationUpdateWithoutLandingApplicationGroupInput;
};

export type LandingApplicationWhereInput = {
  AND?: InputMaybe<Array<LandingApplicationWhereInput>>;
  NOT?: InputMaybe<Array<LandingApplicationWhereInput>>;
  OR?: InputMaybe<Array<LandingApplicationWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  icon?: InputMaybe<StringNullableFilter>;
  iconLocation?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isActive?: InputMaybe<BoolNullableFilter>;
  isIframe?: InputMaybe<BoolNullableFilter>;
  label?: InputMaybe<StringNullableFilter>;
  landingApplicationClusterMapping?: InputMaybe<LandingApplicationClusterMappingListRelationFilter>;
  landingApplicationGroup?: InputMaybe<LandingApplicationGroupListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntNullableFilter>;
  tooltip?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringNullableFilter>;
};

export type LandingApplicationWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type LeanixMapping = {
  __typename?: 'LeanixMapping';
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  leanixId: Scalars['String'];
  master?: Maybe<Master>;
  name?: Maybe<Scalars['String']>;
  projectId?: Maybe<Scalars['String']>;
  rowNumber?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

export type LeanixMappingCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  leanixId: Scalars['String'];
  master?: InputMaybe<MasterCreateNestedOneWithoutLeanixProjectInput>;
  name?: InputMaybe<Scalars['String']>;
  rowNumber?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
};

export type LeanixMappingCreateNestedOneWithoutMasterInput = {
  connect?: InputMaybe<LeanixMappingWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LeanixMappingCreateOrConnectWithoutMasterInput>;
  create?: InputMaybe<LeanixMappingCreateWithoutMasterInput>;
};

export type LeanixMappingCreateOrConnectWithoutMasterInput = {
  create: LeanixMappingCreateWithoutMasterInput;
  where: LeanixMappingWhereUniqueInput;
};

export type LeanixMappingCreateWithoutMasterInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  leanixId: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  rowNumber?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
};

export type LeanixMappingOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  deletedBy?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  leanixId?: InputMaybe<SortOrder>;
  master?: InputMaybe<MasterOrderByWithRelationInput>;
  name?: InputMaybe<SortOrder>;
  projectId?: InputMaybe<SortOrder>;
  rowNumber?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export enum LeanixMappingScalarFieldEnum {
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  DeletedAt = 'deletedAt',
  DeletedBy = 'deletedBy',
  Description = 'description',
  Id = 'id',
  LeanixId = 'leanixId',
  Name = 'name',
  ProjectId = 'projectId',
  RowNumber = 'rowNumber',
  Type = 'type'
}

export type LeanixMappingUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  leanixId?: InputMaybe<StringFieldUpdateOperationsInput>;
  master?: InputMaybe<MasterUpdateOneWithoutLeanixProjectNestedInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rowNumber?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type LeanixMappingUpdateOneWithoutMasterNestedInput = {
  connect?: InputMaybe<LeanixMappingWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LeanixMappingCreateOrConnectWithoutMasterInput>;
  create?: InputMaybe<LeanixMappingCreateWithoutMasterInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<LeanixMappingUpdateWithoutMasterInput>;
  upsert?: InputMaybe<LeanixMappingUpsertWithoutMasterInput>;
};

export type LeanixMappingUpdateWithoutMasterInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  leanixId?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rowNumber?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type LeanixMappingUpsertWithoutMasterInput = {
  create: LeanixMappingCreateWithoutMasterInput;
  update: LeanixMappingUpdateWithoutMasterInput;
};

export type LeanixMappingWhereInput = {
  AND?: InputMaybe<Array<LeanixMappingWhereInput>>;
  NOT?: InputMaybe<Array<LeanixMappingWhereInput>>;
  OR?: InputMaybe<Array<LeanixMappingWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  leanixId?: InputMaybe<StringFilter>;
  master?: InputMaybe<MasterWhereInput>;
  name?: InputMaybe<StringNullableFilter>;
  projectId?: InputMaybe<StringNullableFilter>;
  rowNumber?: InputMaybe<IntNullableFilter>;
  type?: InputMaybe<StringNullableFilter>;
};

export type LeanixMappingWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['String']>;
};

export type Master = {
  __typename?: 'Master';
  _count: MasterCount;
  budgets?: Maybe<Array<TargetedBudget>>;
  businessProcessOnProject?: Maybe<Array<BusinessProcessOnProject>>;
  contactHistory?: Maybe<Array<ContactHistory>>;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  dashboardProject?: Maybe<Array<DashboardProject>>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  email?: Maybe<Array<EmailHistory>>;
  employeeMaster?: Maybe<Array<EmployeeMaster>>;
  finances?: Maybe<Array<Finance>>;
  goals?: Maybe<Array<GoalsOnMaster>>;
  id: Scalars['ID'];
  leanixProject?: Maybe<LeanixMapping>;
  projectAllocations?: Maybe<Array<ProjectAllocation>>;
  projectApproval?: Maybe<Array<ProjectApproval>>;
  projectDependency?: Maybe<Array<ProjectDependency>>;
  projectDescriptionComment?: Maybe<Array<ProjectDescriptionComment>>;
  projectDescriptions?: Maybe<Array<ProjectDescription>>;
  projectDocuments?: Maybe<Array<ProjectDocuments>>;
  projectInterface?: Maybe<Array<ProjectInterface>>;
  projectPhaseCapture?: Maybe<Array<ProjectPhaseCapture>>;
  projectQuestionnaire?: Maybe<Array<ProjectQuestionnaire>>;
  projectResourceCapture?: Maybe<Array<ProjectResourceCapture>>;
  projectRole?: Maybe<Array<ProjectRole>>;
  projectShortHistory?: Maybe<Array<ProjectShortHistory>>;
  projectStatus?: Maybe<Array<ProjectStatus>>;
  pspMapping?: Maybe<Array<PspMapping>>;
  remarks?: Maybe<Array<Remark>>;
  replacement?: Maybe<Array<Replacement>>;
  report?: Maybe<Array<Report>>;
  risk?: Maybe<Array<Risk>>;
  topProjects?: Maybe<Array<TopProjects>>;
};

export type MasterCount = {
  __typename?: 'MasterCount';
  budgets: Scalars['Int'];
  businessProcessOnProject: Scalars['Int'];
  contactHistory: Scalars['Int'];
  dashboardProject: Scalars['Int'];
  email: Scalars['Int'];
  employeeMaster: Scalars['Int'];
  finances: Scalars['Int'];
  goals: Scalars['Int'];
  projectAllocations: Scalars['Int'];
  projectApproval: Scalars['Int'];
  projectDependency: Scalars['Int'];
  projectDescriptionComment: Scalars['Int'];
  projectDescriptions: Scalars['Int'];
  projectDocuments: Scalars['Int'];
  projectInterface: Scalars['Int'];
  projectPhaseCapture: Scalars['Int'];
  projectQuestionnaire: Scalars['Int'];
  projectResourceCapture: Scalars['Int'];
  projectRole: Scalars['Int'];
  projectShortHistory: Scalars['Int'];
  projectStatus: Scalars['Int'];
  pspMapping: Scalars['Int'];
  remarks: Scalars['Int'];
  replacement: Scalars['Int'];
  report: Scalars['Int'];
  risk: Scalars['Int'];
  topProjects: Scalars['Int'];
};

export type MasterCreateInput = {
  budgets?: InputMaybe<TargetedBudgetCreateNestedManyWithoutMasterInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectCreateNestedManyWithoutProjectInput>;
  contactHistory?: InputMaybe<ContactHistoryCreateNestedManyWithoutProjectInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  dashboardProject?: InputMaybe<DashboardProjectCreateNestedManyWithoutProjectInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<EmailHistoryCreateNestedManyWithoutProjectInput>;
  employeeMaster?: InputMaybe<EmployeeMasterCreateNestedManyWithoutProjectInput>;
  finances?: InputMaybe<FinanceCreateNestedManyWithoutProjectInput>;
  goals?: InputMaybe<GoalsOnMasterCreateNestedManyWithoutProjectInput>;
  id?: InputMaybe<Scalars['String']>;
  leanixProject?: InputMaybe<LeanixMappingCreateNestedOneWithoutMasterInput>;
  projectAllocations?: InputMaybe<ProjectAllocationCreateNestedManyWithoutProjectInput>;
  projectApproval?: InputMaybe<ProjectApprovalCreateNestedManyWithoutProjectInput>;
  projectDependency?: InputMaybe<ProjectDependencyCreateNestedManyWithoutProjectInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentCreateNestedManyWithoutProjectInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionCreateNestedManyWithoutMasterInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsCreateNestedManyWithoutProjectInput>;
  projectInterface?: InputMaybe<ProjectInterfaceCreateNestedManyWithoutProjectInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureCreateNestedManyWithoutProjectInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireCreateNestedManyWithoutProjectInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureCreateNestedManyWithoutProjectInput>;
  projectRole?: InputMaybe<ProjectRoleCreateNestedManyWithoutProjectInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryCreateNestedManyWithoutProjectInput>;
  projectStatus?: InputMaybe<ProjectStatusCreateNestedManyWithoutProjectInput>;
  pspMapping?: InputMaybe<PspMappingCreateNestedManyWithoutMasterInput>;
  remarks?: InputMaybe<RemarkCreateNestedManyWithoutProjectInput>;
  replacement?: InputMaybe<ReplacementCreateNestedManyWithoutProjectInput>;
  report?: InputMaybe<ReportCreateNestedManyWithoutProjectInput>;
  risk?: InputMaybe<RiskCreateNestedManyWithoutProjectInput>;
  topProjects?: InputMaybe<TopProjectsCreateNestedManyWithoutProjectInput>;
};

export type MasterCreateNestedOneWithoutBudgetsInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutBudgetsInput>;
  create?: InputMaybe<MasterCreateWithoutBudgetsInput>;
};

export type MasterCreateNestedOneWithoutBusinessProcessOnProjectInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutBusinessProcessOnProjectInput>;
  create?: InputMaybe<MasterCreateWithoutBusinessProcessOnProjectInput>;
};

export type MasterCreateNestedOneWithoutContactHistoryInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutContactHistoryInput>;
  create?: InputMaybe<MasterCreateWithoutContactHistoryInput>;
};

export type MasterCreateNestedOneWithoutDashboardProjectInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutDashboardProjectInput>;
  create?: InputMaybe<MasterCreateWithoutDashboardProjectInput>;
};

export type MasterCreateNestedOneWithoutEmailInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutEmailInput>;
  create?: InputMaybe<MasterCreateWithoutEmailInput>;
};

export type MasterCreateNestedOneWithoutEmployeeMasterInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutEmployeeMasterInput>;
  create?: InputMaybe<MasterCreateWithoutEmployeeMasterInput>;
};

export type MasterCreateNestedOneWithoutFinancesInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutFinancesInput>;
  create?: InputMaybe<MasterCreateWithoutFinancesInput>;
};

export type MasterCreateNestedOneWithoutGoalsInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutGoalsInput>;
  create?: InputMaybe<MasterCreateWithoutGoalsInput>;
};

export type MasterCreateNestedOneWithoutLeanixProjectInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutLeanixProjectInput>;
  create?: InputMaybe<MasterCreateWithoutLeanixProjectInput>;
};

export type MasterCreateNestedOneWithoutProjectAllocationsInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutProjectAllocationsInput>;
  create?: InputMaybe<MasterCreateWithoutProjectAllocationsInput>;
};

export type MasterCreateNestedOneWithoutProjectApprovalInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutProjectApprovalInput>;
  create?: InputMaybe<MasterCreateWithoutProjectApprovalInput>;
};

export type MasterCreateNestedOneWithoutProjectDependencyInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutProjectDependencyInput>;
  create?: InputMaybe<MasterCreateWithoutProjectDependencyInput>;
};

export type MasterCreateNestedOneWithoutProjectDescriptionCommentInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutProjectDescriptionCommentInput>;
  create?: InputMaybe<MasterCreateWithoutProjectDescriptionCommentInput>;
};

export type MasterCreateNestedOneWithoutProjectDescriptionsInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutProjectDescriptionsInput>;
  create?: InputMaybe<MasterCreateWithoutProjectDescriptionsInput>;
};

export type MasterCreateNestedOneWithoutProjectDocumentsInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutProjectDocumentsInput>;
  create?: InputMaybe<MasterCreateWithoutProjectDocumentsInput>;
};

export type MasterCreateNestedOneWithoutProjectInterfaceInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutProjectInterfaceInput>;
  create?: InputMaybe<MasterCreateWithoutProjectInterfaceInput>;
};

export type MasterCreateNestedOneWithoutProjectPhaseCaptureInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutProjectPhaseCaptureInput>;
  create?: InputMaybe<MasterCreateWithoutProjectPhaseCaptureInput>;
};

export type MasterCreateNestedOneWithoutProjectQuestionnaireInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutProjectQuestionnaireInput>;
  create?: InputMaybe<MasterCreateWithoutProjectQuestionnaireInput>;
};

export type MasterCreateNestedOneWithoutProjectResourceCaptureInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutProjectResourceCaptureInput>;
  create?: InputMaybe<MasterCreateWithoutProjectResourceCaptureInput>;
};

export type MasterCreateNestedOneWithoutProjectRoleInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutProjectRoleInput>;
  create?: InputMaybe<MasterCreateWithoutProjectRoleInput>;
};

export type MasterCreateNestedOneWithoutProjectShortHistoryInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutProjectShortHistoryInput>;
  create?: InputMaybe<MasterCreateWithoutProjectShortHistoryInput>;
};

export type MasterCreateNestedOneWithoutProjectStatusInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutProjectStatusInput>;
  create?: InputMaybe<MasterCreateWithoutProjectStatusInput>;
};

export type MasterCreateNestedOneWithoutPspMappingInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutPspMappingInput>;
  create?: InputMaybe<MasterCreateWithoutPspMappingInput>;
};

export type MasterCreateNestedOneWithoutRemarksInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutRemarksInput>;
  create?: InputMaybe<MasterCreateWithoutRemarksInput>;
};

export type MasterCreateNestedOneWithoutReplacementInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutReplacementInput>;
  create?: InputMaybe<MasterCreateWithoutReplacementInput>;
};

export type MasterCreateNestedOneWithoutReportInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutReportInput>;
  create?: InputMaybe<MasterCreateWithoutReportInput>;
};

export type MasterCreateNestedOneWithoutRiskInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutRiskInput>;
  create?: InputMaybe<MasterCreateWithoutRiskInput>;
};

export type MasterCreateNestedOneWithoutTopProjectsInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutTopProjectsInput>;
  create?: InputMaybe<MasterCreateWithoutTopProjectsInput>;
};

export type MasterCreateOrConnectWithoutBudgetsInput = {
  create: MasterCreateWithoutBudgetsInput;
  where: MasterWhereUniqueInput;
};

export type MasterCreateOrConnectWithoutBusinessProcessOnProjectInput = {
  create: MasterCreateWithoutBusinessProcessOnProjectInput;
  where: MasterWhereUniqueInput;
};

export type MasterCreateOrConnectWithoutContactHistoryInput = {
  create: MasterCreateWithoutContactHistoryInput;
  where: MasterWhereUniqueInput;
};

export type MasterCreateOrConnectWithoutDashboardProjectInput = {
  create: MasterCreateWithoutDashboardProjectInput;
  where: MasterWhereUniqueInput;
};

export type MasterCreateOrConnectWithoutEmailInput = {
  create: MasterCreateWithoutEmailInput;
  where: MasterWhereUniqueInput;
};

export type MasterCreateOrConnectWithoutEmployeeMasterInput = {
  create: MasterCreateWithoutEmployeeMasterInput;
  where: MasterWhereUniqueInput;
};

export type MasterCreateOrConnectWithoutFinancesInput = {
  create: MasterCreateWithoutFinancesInput;
  where: MasterWhereUniqueInput;
};

export type MasterCreateOrConnectWithoutGoalsInput = {
  create: MasterCreateWithoutGoalsInput;
  where: MasterWhereUniqueInput;
};

export type MasterCreateOrConnectWithoutLeanixProjectInput = {
  create: MasterCreateWithoutLeanixProjectInput;
  where: MasterWhereUniqueInput;
};

export type MasterCreateOrConnectWithoutProjectAllocationsInput = {
  create: MasterCreateWithoutProjectAllocationsInput;
  where: MasterWhereUniqueInput;
};

export type MasterCreateOrConnectWithoutProjectApprovalInput = {
  create: MasterCreateWithoutProjectApprovalInput;
  where: MasterWhereUniqueInput;
};

export type MasterCreateOrConnectWithoutProjectDependencyInput = {
  create: MasterCreateWithoutProjectDependencyInput;
  where: MasterWhereUniqueInput;
};

export type MasterCreateOrConnectWithoutProjectDescriptionCommentInput = {
  create: MasterCreateWithoutProjectDescriptionCommentInput;
  where: MasterWhereUniqueInput;
};

export type MasterCreateOrConnectWithoutProjectDescriptionsInput = {
  create: MasterCreateWithoutProjectDescriptionsInput;
  where: MasterWhereUniqueInput;
};

export type MasterCreateOrConnectWithoutProjectDocumentsInput = {
  create: MasterCreateWithoutProjectDocumentsInput;
  where: MasterWhereUniqueInput;
};

export type MasterCreateOrConnectWithoutProjectInterfaceInput = {
  create: MasterCreateWithoutProjectInterfaceInput;
  where: MasterWhereUniqueInput;
};

export type MasterCreateOrConnectWithoutProjectPhaseCaptureInput = {
  create: MasterCreateWithoutProjectPhaseCaptureInput;
  where: MasterWhereUniqueInput;
};

export type MasterCreateOrConnectWithoutProjectQuestionnaireInput = {
  create: MasterCreateWithoutProjectQuestionnaireInput;
  where: MasterWhereUniqueInput;
};

export type MasterCreateOrConnectWithoutProjectResourceCaptureInput = {
  create: MasterCreateWithoutProjectResourceCaptureInput;
  where: MasterWhereUniqueInput;
};

export type MasterCreateOrConnectWithoutProjectRoleInput = {
  create: MasterCreateWithoutProjectRoleInput;
  where: MasterWhereUniqueInput;
};

export type MasterCreateOrConnectWithoutProjectShortHistoryInput = {
  create: MasterCreateWithoutProjectShortHistoryInput;
  where: MasterWhereUniqueInput;
};

export type MasterCreateOrConnectWithoutProjectStatusInput = {
  create: MasterCreateWithoutProjectStatusInput;
  where: MasterWhereUniqueInput;
};

export type MasterCreateOrConnectWithoutPspMappingInput = {
  create: MasterCreateWithoutPspMappingInput;
  where: MasterWhereUniqueInput;
};

export type MasterCreateOrConnectWithoutRemarksInput = {
  create: MasterCreateWithoutRemarksInput;
  where: MasterWhereUniqueInput;
};

export type MasterCreateOrConnectWithoutReplacementInput = {
  create: MasterCreateWithoutReplacementInput;
  where: MasterWhereUniqueInput;
};

export type MasterCreateOrConnectWithoutReportInput = {
  create: MasterCreateWithoutReportInput;
  where: MasterWhereUniqueInput;
};

export type MasterCreateOrConnectWithoutRiskInput = {
  create: MasterCreateWithoutRiskInput;
  where: MasterWhereUniqueInput;
};

export type MasterCreateOrConnectWithoutTopProjectsInput = {
  create: MasterCreateWithoutTopProjectsInput;
  where: MasterWhereUniqueInput;
};

export type MasterCreateWithoutBudgetsInput = {
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectCreateNestedManyWithoutProjectInput>;
  contactHistory?: InputMaybe<ContactHistoryCreateNestedManyWithoutProjectInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  dashboardProject?: InputMaybe<DashboardProjectCreateNestedManyWithoutProjectInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<EmailHistoryCreateNestedManyWithoutProjectInput>;
  employeeMaster?: InputMaybe<EmployeeMasterCreateNestedManyWithoutProjectInput>;
  finances?: InputMaybe<FinanceCreateNestedManyWithoutProjectInput>;
  goals?: InputMaybe<GoalsOnMasterCreateNestedManyWithoutProjectInput>;
  id?: InputMaybe<Scalars['String']>;
  leanixProject?: InputMaybe<LeanixMappingCreateNestedOneWithoutMasterInput>;
  projectAllocations?: InputMaybe<ProjectAllocationCreateNestedManyWithoutProjectInput>;
  projectApproval?: InputMaybe<ProjectApprovalCreateNestedManyWithoutProjectInput>;
  projectDependency?: InputMaybe<ProjectDependencyCreateNestedManyWithoutProjectInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentCreateNestedManyWithoutProjectInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionCreateNestedManyWithoutMasterInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsCreateNestedManyWithoutProjectInput>;
  projectInterface?: InputMaybe<ProjectInterfaceCreateNestedManyWithoutProjectInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureCreateNestedManyWithoutProjectInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireCreateNestedManyWithoutProjectInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureCreateNestedManyWithoutProjectInput>;
  projectRole?: InputMaybe<ProjectRoleCreateNestedManyWithoutProjectInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryCreateNestedManyWithoutProjectInput>;
  projectStatus?: InputMaybe<ProjectStatusCreateNestedManyWithoutProjectInput>;
  pspMapping?: InputMaybe<PspMappingCreateNestedManyWithoutMasterInput>;
  remarks?: InputMaybe<RemarkCreateNestedManyWithoutProjectInput>;
  replacement?: InputMaybe<ReplacementCreateNestedManyWithoutProjectInput>;
  report?: InputMaybe<ReportCreateNestedManyWithoutProjectInput>;
  risk?: InputMaybe<RiskCreateNestedManyWithoutProjectInput>;
  topProjects?: InputMaybe<TopProjectsCreateNestedManyWithoutProjectInput>;
};

export type MasterCreateWithoutBusinessProcessOnProjectInput = {
  budgets?: InputMaybe<TargetedBudgetCreateNestedManyWithoutMasterInput>;
  contactHistory?: InputMaybe<ContactHistoryCreateNestedManyWithoutProjectInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  dashboardProject?: InputMaybe<DashboardProjectCreateNestedManyWithoutProjectInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<EmailHistoryCreateNestedManyWithoutProjectInput>;
  employeeMaster?: InputMaybe<EmployeeMasterCreateNestedManyWithoutProjectInput>;
  finances?: InputMaybe<FinanceCreateNestedManyWithoutProjectInput>;
  goals?: InputMaybe<GoalsOnMasterCreateNestedManyWithoutProjectInput>;
  id?: InputMaybe<Scalars['String']>;
  leanixProject?: InputMaybe<LeanixMappingCreateNestedOneWithoutMasterInput>;
  projectAllocations?: InputMaybe<ProjectAllocationCreateNestedManyWithoutProjectInput>;
  projectApproval?: InputMaybe<ProjectApprovalCreateNestedManyWithoutProjectInput>;
  projectDependency?: InputMaybe<ProjectDependencyCreateNestedManyWithoutProjectInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentCreateNestedManyWithoutProjectInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionCreateNestedManyWithoutMasterInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsCreateNestedManyWithoutProjectInput>;
  projectInterface?: InputMaybe<ProjectInterfaceCreateNestedManyWithoutProjectInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureCreateNestedManyWithoutProjectInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireCreateNestedManyWithoutProjectInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureCreateNestedManyWithoutProjectInput>;
  projectRole?: InputMaybe<ProjectRoleCreateNestedManyWithoutProjectInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryCreateNestedManyWithoutProjectInput>;
  projectStatus?: InputMaybe<ProjectStatusCreateNestedManyWithoutProjectInput>;
  pspMapping?: InputMaybe<PspMappingCreateNestedManyWithoutMasterInput>;
  remarks?: InputMaybe<RemarkCreateNestedManyWithoutProjectInput>;
  replacement?: InputMaybe<ReplacementCreateNestedManyWithoutProjectInput>;
  report?: InputMaybe<ReportCreateNestedManyWithoutProjectInput>;
  risk?: InputMaybe<RiskCreateNestedManyWithoutProjectInput>;
  topProjects?: InputMaybe<TopProjectsCreateNestedManyWithoutProjectInput>;
};

export type MasterCreateWithoutContactHistoryInput = {
  budgets?: InputMaybe<TargetedBudgetCreateNestedManyWithoutMasterInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectCreateNestedManyWithoutProjectInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  dashboardProject?: InputMaybe<DashboardProjectCreateNestedManyWithoutProjectInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<EmailHistoryCreateNestedManyWithoutProjectInput>;
  employeeMaster?: InputMaybe<EmployeeMasterCreateNestedManyWithoutProjectInput>;
  finances?: InputMaybe<FinanceCreateNestedManyWithoutProjectInput>;
  goals?: InputMaybe<GoalsOnMasterCreateNestedManyWithoutProjectInput>;
  id?: InputMaybe<Scalars['String']>;
  leanixProject?: InputMaybe<LeanixMappingCreateNestedOneWithoutMasterInput>;
  projectAllocations?: InputMaybe<ProjectAllocationCreateNestedManyWithoutProjectInput>;
  projectApproval?: InputMaybe<ProjectApprovalCreateNestedManyWithoutProjectInput>;
  projectDependency?: InputMaybe<ProjectDependencyCreateNestedManyWithoutProjectInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentCreateNestedManyWithoutProjectInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionCreateNestedManyWithoutMasterInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsCreateNestedManyWithoutProjectInput>;
  projectInterface?: InputMaybe<ProjectInterfaceCreateNestedManyWithoutProjectInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureCreateNestedManyWithoutProjectInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireCreateNestedManyWithoutProjectInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureCreateNestedManyWithoutProjectInput>;
  projectRole?: InputMaybe<ProjectRoleCreateNestedManyWithoutProjectInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryCreateNestedManyWithoutProjectInput>;
  projectStatus?: InputMaybe<ProjectStatusCreateNestedManyWithoutProjectInput>;
  pspMapping?: InputMaybe<PspMappingCreateNestedManyWithoutMasterInput>;
  remarks?: InputMaybe<RemarkCreateNestedManyWithoutProjectInput>;
  replacement?: InputMaybe<ReplacementCreateNestedManyWithoutProjectInput>;
  report?: InputMaybe<ReportCreateNestedManyWithoutProjectInput>;
  risk?: InputMaybe<RiskCreateNestedManyWithoutProjectInput>;
  topProjects?: InputMaybe<TopProjectsCreateNestedManyWithoutProjectInput>;
};

export type MasterCreateWithoutDashboardProjectInput = {
  budgets?: InputMaybe<TargetedBudgetCreateNestedManyWithoutMasterInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectCreateNestedManyWithoutProjectInput>;
  contactHistory?: InputMaybe<ContactHistoryCreateNestedManyWithoutProjectInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<EmailHistoryCreateNestedManyWithoutProjectInput>;
  employeeMaster?: InputMaybe<EmployeeMasterCreateNestedManyWithoutProjectInput>;
  finances?: InputMaybe<FinanceCreateNestedManyWithoutProjectInput>;
  goals?: InputMaybe<GoalsOnMasterCreateNestedManyWithoutProjectInput>;
  id?: InputMaybe<Scalars['String']>;
  leanixProject?: InputMaybe<LeanixMappingCreateNestedOneWithoutMasterInput>;
  projectAllocations?: InputMaybe<ProjectAllocationCreateNestedManyWithoutProjectInput>;
  projectApproval?: InputMaybe<ProjectApprovalCreateNestedManyWithoutProjectInput>;
  projectDependency?: InputMaybe<ProjectDependencyCreateNestedManyWithoutProjectInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentCreateNestedManyWithoutProjectInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionCreateNestedManyWithoutMasterInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsCreateNestedManyWithoutProjectInput>;
  projectInterface?: InputMaybe<ProjectInterfaceCreateNestedManyWithoutProjectInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureCreateNestedManyWithoutProjectInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireCreateNestedManyWithoutProjectInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureCreateNestedManyWithoutProjectInput>;
  projectRole?: InputMaybe<ProjectRoleCreateNestedManyWithoutProjectInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryCreateNestedManyWithoutProjectInput>;
  projectStatus?: InputMaybe<ProjectStatusCreateNestedManyWithoutProjectInput>;
  pspMapping?: InputMaybe<PspMappingCreateNestedManyWithoutMasterInput>;
  remarks?: InputMaybe<RemarkCreateNestedManyWithoutProjectInput>;
  replacement?: InputMaybe<ReplacementCreateNestedManyWithoutProjectInput>;
  report?: InputMaybe<ReportCreateNestedManyWithoutProjectInput>;
  risk?: InputMaybe<RiskCreateNestedManyWithoutProjectInput>;
  topProjects?: InputMaybe<TopProjectsCreateNestedManyWithoutProjectInput>;
};

export type MasterCreateWithoutEmailInput = {
  budgets?: InputMaybe<TargetedBudgetCreateNestedManyWithoutMasterInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectCreateNestedManyWithoutProjectInput>;
  contactHistory?: InputMaybe<ContactHistoryCreateNestedManyWithoutProjectInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  dashboardProject?: InputMaybe<DashboardProjectCreateNestedManyWithoutProjectInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  employeeMaster?: InputMaybe<EmployeeMasterCreateNestedManyWithoutProjectInput>;
  finances?: InputMaybe<FinanceCreateNestedManyWithoutProjectInput>;
  goals?: InputMaybe<GoalsOnMasterCreateNestedManyWithoutProjectInput>;
  id?: InputMaybe<Scalars['String']>;
  leanixProject?: InputMaybe<LeanixMappingCreateNestedOneWithoutMasterInput>;
  projectAllocations?: InputMaybe<ProjectAllocationCreateNestedManyWithoutProjectInput>;
  projectApproval?: InputMaybe<ProjectApprovalCreateNestedManyWithoutProjectInput>;
  projectDependency?: InputMaybe<ProjectDependencyCreateNestedManyWithoutProjectInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentCreateNestedManyWithoutProjectInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionCreateNestedManyWithoutMasterInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsCreateNestedManyWithoutProjectInput>;
  projectInterface?: InputMaybe<ProjectInterfaceCreateNestedManyWithoutProjectInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureCreateNestedManyWithoutProjectInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireCreateNestedManyWithoutProjectInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureCreateNestedManyWithoutProjectInput>;
  projectRole?: InputMaybe<ProjectRoleCreateNestedManyWithoutProjectInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryCreateNestedManyWithoutProjectInput>;
  projectStatus?: InputMaybe<ProjectStatusCreateNestedManyWithoutProjectInput>;
  pspMapping?: InputMaybe<PspMappingCreateNestedManyWithoutMasterInput>;
  remarks?: InputMaybe<RemarkCreateNestedManyWithoutProjectInput>;
  replacement?: InputMaybe<ReplacementCreateNestedManyWithoutProjectInput>;
  report?: InputMaybe<ReportCreateNestedManyWithoutProjectInput>;
  risk?: InputMaybe<RiskCreateNestedManyWithoutProjectInput>;
  topProjects?: InputMaybe<TopProjectsCreateNestedManyWithoutProjectInput>;
};

export type MasterCreateWithoutEmployeeMasterInput = {
  budgets?: InputMaybe<TargetedBudgetCreateNestedManyWithoutMasterInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectCreateNestedManyWithoutProjectInput>;
  contactHistory?: InputMaybe<ContactHistoryCreateNestedManyWithoutProjectInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  dashboardProject?: InputMaybe<DashboardProjectCreateNestedManyWithoutProjectInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<EmailHistoryCreateNestedManyWithoutProjectInput>;
  finances?: InputMaybe<FinanceCreateNestedManyWithoutProjectInput>;
  goals?: InputMaybe<GoalsOnMasterCreateNestedManyWithoutProjectInput>;
  id?: InputMaybe<Scalars['String']>;
  leanixProject?: InputMaybe<LeanixMappingCreateNestedOneWithoutMasterInput>;
  projectAllocations?: InputMaybe<ProjectAllocationCreateNestedManyWithoutProjectInput>;
  projectApproval?: InputMaybe<ProjectApprovalCreateNestedManyWithoutProjectInput>;
  projectDependency?: InputMaybe<ProjectDependencyCreateNestedManyWithoutProjectInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentCreateNestedManyWithoutProjectInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionCreateNestedManyWithoutMasterInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsCreateNestedManyWithoutProjectInput>;
  projectInterface?: InputMaybe<ProjectInterfaceCreateNestedManyWithoutProjectInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureCreateNestedManyWithoutProjectInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireCreateNestedManyWithoutProjectInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureCreateNestedManyWithoutProjectInput>;
  projectRole?: InputMaybe<ProjectRoleCreateNestedManyWithoutProjectInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryCreateNestedManyWithoutProjectInput>;
  projectStatus?: InputMaybe<ProjectStatusCreateNestedManyWithoutProjectInput>;
  pspMapping?: InputMaybe<PspMappingCreateNestedManyWithoutMasterInput>;
  remarks?: InputMaybe<RemarkCreateNestedManyWithoutProjectInput>;
  replacement?: InputMaybe<ReplacementCreateNestedManyWithoutProjectInput>;
  report?: InputMaybe<ReportCreateNestedManyWithoutProjectInput>;
  risk?: InputMaybe<RiskCreateNestedManyWithoutProjectInput>;
  topProjects?: InputMaybe<TopProjectsCreateNestedManyWithoutProjectInput>;
};

export type MasterCreateWithoutFinancesInput = {
  budgets?: InputMaybe<TargetedBudgetCreateNestedManyWithoutMasterInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectCreateNestedManyWithoutProjectInput>;
  contactHistory?: InputMaybe<ContactHistoryCreateNestedManyWithoutProjectInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  dashboardProject?: InputMaybe<DashboardProjectCreateNestedManyWithoutProjectInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<EmailHistoryCreateNestedManyWithoutProjectInput>;
  employeeMaster?: InputMaybe<EmployeeMasterCreateNestedManyWithoutProjectInput>;
  goals?: InputMaybe<GoalsOnMasterCreateNestedManyWithoutProjectInput>;
  id?: InputMaybe<Scalars['String']>;
  leanixProject?: InputMaybe<LeanixMappingCreateNestedOneWithoutMasterInput>;
  projectAllocations?: InputMaybe<ProjectAllocationCreateNestedManyWithoutProjectInput>;
  projectApproval?: InputMaybe<ProjectApprovalCreateNestedManyWithoutProjectInput>;
  projectDependency?: InputMaybe<ProjectDependencyCreateNestedManyWithoutProjectInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentCreateNestedManyWithoutProjectInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionCreateNestedManyWithoutMasterInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsCreateNestedManyWithoutProjectInput>;
  projectInterface?: InputMaybe<ProjectInterfaceCreateNestedManyWithoutProjectInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureCreateNestedManyWithoutProjectInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireCreateNestedManyWithoutProjectInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureCreateNestedManyWithoutProjectInput>;
  projectRole?: InputMaybe<ProjectRoleCreateNestedManyWithoutProjectInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryCreateNestedManyWithoutProjectInput>;
  projectStatus?: InputMaybe<ProjectStatusCreateNestedManyWithoutProjectInput>;
  pspMapping?: InputMaybe<PspMappingCreateNestedManyWithoutMasterInput>;
  remarks?: InputMaybe<RemarkCreateNestedManyWithoutProjectInput>;
  replacement?: InputMaybe<ReplacementCreateNestedManyWithoutProjectInput>;
  report?: InputMaybe<ReportCreateNestedManyWithoutProjectInput>;
  risk?: InputMaybe<RiskCreateNestedManyWithoutProjectInput>;
  topProjects?: InputMaybe<TopProjectsCreateNestedManyWithoutProjectInput>;
};

export type MasterCreateWithoutGoalsInput = {
  budgets?: InputMaybe<TargetedBudgetCreateNestedManyWithoutMasterInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectCreateNestedManyWithoutProjectInput>;
  contactHistory?: InputMaybe<ContactHistoryCreateNestedManyWithoutProjectInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  dashboardProject?: InputMaybe<DashboardProjectCreateNestedManyWithoutProjectInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<EmailHistoryCreateNestedManyWithoutProjectInput>;
  employeeMaster?: InputMaybe<EmployeeMasterCreateNestedManyWithoutProjectInput>;
  finances?: InputMaybe<FinanceCreateNestedManyWithoutProjectInput>;
  id?: InputMaybe<Scalars['String']>;
  leanixProject?: InputMaybe<LeanixMappingCreateNestedOneWithoutMasterInput>;
  projectAllocations?: InputMaybe<ProjectAllocationCreateNestedManyWithoutProjectInput>;
  projectApproval?: InputMaybe<ProjectApprovalCreateNestedManyWithoutProjectInput>;
  projectDependency?: InputMaybe<ProjectDependencyCreateNestedManyWithoutProjectInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentCreateNestedManyWithoutProjectInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionCreateNestedManyWithoutMasterInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsCreateNestedManyWithoutProjectInput>;
  projectInterface?: InputMaybe<ProjectInterfaceCreateNestedManyWithoutProjectInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureCreateNestedManyWithoutProjectInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireCreateNestedManyWithoutProjectInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureCreateNestedManyWithoutProjectInput>;
  projectRole?: InputMaybe<ProjectRoleCreateNestedManyWithoutProjectInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryCreateNestedManyWithoutProjectInput>;
  projectStatus?: InputMaybe<ProjectStatusCreateNestedManyWithoutProjectInput>;
  pspMapping?: InputMaybe<PspMappingCreateNestedManyWithoutMasterInput>;
  remarks?: InputMaybe<RemarkCreateNestedManyWithoutProjectInput>;
  replacement?: InputMaybe<ReplacementCreateNestedManyWithoutProjectInput>;
  report?: InputMaybe<ReportCreateNestedManyWithoutProjectInput>;
  risk?: InputMaybe<RiskCreateNestedManyWithoutProjectInput>;
  topProjects?: InputMaybe<TopProjectsCreateNestedManyWithoutProjectInput>;
};

export type MasterCreateWithoutLeanixProjectInput = {
  budgets?: InputMaybe<TargetedBudgetCreateNestedManyWithoutMasterInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectCreateNestedManyWithoutProjectInput>;
  contactHistory?: InputMaybe<ContactHistoryCreateNestedManyWithoutProjectInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  dashboardProject?: InputMaybe<DashboardProjectCreateNestedManyWithoutProjectInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<EmailHistoryCreateNestedManyWithoutProjectInput>;
  employeeMaster?: InputMaybe<EmployeeMasterCreateNestedManyWithoutProjectInput>;
  finances?: InputMaybe<FinanceCreateNestedManyWithoutProjectInput>;
  goals?: InputMaybe<GoalsOnMasterCreateNestedManyWithoutProjectInput>;
  id?: InputMaybe<Scalars['String']>;
  projectAllocations?: InputMaybe<ProjectAllocationCreateNestedManyWithoutProjectInput>;
  projectApproval?: InputMaybe<ProjectApprovalCreateNestedManyWithoutProjectInput>;
  projectDependency?: InputMaybe<ProjectDependencyCreateNestedManyWithoutProjectInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentCreateNestedManyWithoutProjectInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionCreateNestedManyWithoutMasterInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsCreateNestedManyWithoutProjectInput>;
  projectInterface?: InputMaybe<ProjectInterfaceCreateNestedManyWithoutProjectInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureCreateNestedManyWithoutProjectInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireCreateNestedManyWithoutProjectInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureCreateNestedManyWithoutProjectInput>;
  projectRole?: InputMaybe<ProjectRoleCreateNestedManyWithoutProjectInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryCreateNestedManyWithoutProjectInput>;
  projectStatus?: InputMaybe<ProjectStatusCreateNestedManyWithoutProjectInput>;
  pspMapping?: InputMaybe<PspMappingCreateNestedManyWithoutMasterInput>;
  remarks?: InputMaybe<RemarkCreateNestedManyWithoutProjectInput>;
  replacement?: InputMaybe<ReplacementCreateNestedManyWithoutProjectInput>;
  report?: InputMaybe<ReportCreateNestedManyWithoutProjectInput>;
  risk?: InputMaybe<RiskCreateNestedManyWithoutProjectInput>;
  topProjects?: InputMaybe<TopProjectsCreateNestedManyWithoutProjectInput>;
};

export type MasterCreateWithoutProjectAllocationsInput = {
  budgets?: InputMaybe<TargetedBudgetCreateNestedManyWithoutMasterInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectCreateNestedManyWithoutProjectInput>;
  contactHistory?: InputMaybe<ContactHistoryCreateNestedManyWithoutProjectInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  dashboardProject?: InputMaybe<DashboardProjectCreateNestedManyWithoutProjectInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<EmailHistoryCreateNestedManyWithoutProjectInput>;
  employeeMaster?: InputMaybe<EmployeeMasterCreateNestedManyWithoutProjectInput>;
  finances?: InputMaybe<FinanceCreateNestedManyWithoutProjectInput>;
  goals?: InputMaybe<GoalsOnMasterCreateNestedManyWithoutProjectInput>;
  id?: InputMaybe<Scalars['String']>;
  leanixProject?: InputMaybe<LeanixMappingCreateNestedOneWithoutMasterInput>;
  projectApproval?: InputMaybe<ProjectApprovalCreateNestedManyWithoutProjectInput>;
  projectDependency?: InputMaybe<ProjectDependencyCreateNestedManyWithoutProjectInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentCreateNestedManyWithoutProjectInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionCreateNestedManyWithoutMasterInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsCreateNestedManyWithoutProjectInput>;
  projectInterface?: InputMaybe<ProjectInterfaceCreateNestedManyWithoutProjectInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureCreateNestedManyWithoutProjectInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireCreateNestedManyWithoutProjectInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureCreateNestedManyWithoutProjectInput>;
  projectRole?: InputMaybe<ProjectRoleCreateNestedManyWithoutProjectInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryCreateNestedManyWithoutProjectInput>;
  projectStatus?: InputMaybe<ProjectStatusCreateNestedManyWithoutProjectInput>;
  pspMapping?: InputMaybe<PspMappingCreateNestedManyWithoutMasterInput>;
  remarks?: InputMaybe<RemarkCreateNestedManyWithoutProjectInput>;
  replacement?: InputMaybe<ReplacementCreateNestedManyWithoutProjectInput>;
  report?: InputMaybe<ReportCreateNestedManyWithoutProjectInput>;
  risk?: InputMaybe<RiskCreateNestedManyWithoutProjectInput>;
  topProjects?: InputMaybe<TopProjectsCreateNestedManyWithoutProjectInput>;
};

export type MasterCreateWithoutProjectApprovalInput = {
  budgets?: InputMaybe<TargetedBudgetCreateNestedManyWithoutMasterInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectCreateNestedManyWithoutProjectInput>;
  contactHistory?: InputMaybe<ContactHistoryCreateNestedManyWithoutProjectInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  dashboardProject?: InputMaybe<DashboardProjectCreateNestedManyWithoutProjectInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<EmailHistoryCreateNestedManyWithoutProjectInput>;
  employeeMaster?: InputMaybe<EmployeeMasterCreateNestedManyWithoutProjectInput>;
  finances?: InputMaybe<FinanceCreateNestedManyWithoutProjectInput>;
  goals?: InputMaybe<GoalsOnMasterCreateNestedManyWithoutProjectInput>;
  id?: InputMaybe<Scalars['String']>;
  leanixProject?: InputMaybe<LeanixMappingCreateNestedOneWithoutMasterInput>;
  projectAllocations?: InputMaybe<ProjectAllocationCreateNestedManyWithoutProjectInput>;
  projectDependency?: InputMaybe<ProjectDependencyCreateNestedManyWithoutProjectInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentCreateNestedManyWithoutProjectInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionCreateNestedManyWithoutMasterInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsCreateNestedManyWithoutProjectInput>;
  projectInterface?: InputMaybe<ProjectInterfaceCreateNestedManyWithoutProjectInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureCreateNestedManyWithoutProjectInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireCreateNestedManyWithoutProjectInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureCreateNestedManyWithoutProjectInput>;
  projectRole?: InputMaybe<ProjectRoleCreateNestedManyWithoutProjectInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryCreateNestedManyWithoutProjectInput>;
  projectStatus?: InputMaybe<ProjectStatusCreateNestedManyWithoutProjectInput>;
  pspMapping?: InputMaybe<PspMappingCreateNestedManyWithoutMasterInput>;
  remarks?: InputMaybe<RemarkCreateNestedManyWithoutProjectInput>;
  replacement?: InputMaybe<ReplacementCreateNestedManyWithoutProjectInput>;
  report?: InputMaybe<ReportCreateNestedManyWithoutProjectInput>;
  risk?: InputMaybe<RiskCreateNestedManyWithoutProjectInput>;
  topProjects?: InputMaybe<TopProjectsCreateNestedManyWithoutProjectInput>;
};

export type MasterCreateWithoutProjectDependencyInput = {
  budgets?: InputMaybe<TargetedBudgetCreateNestedManyWithoutMasterInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectCreateNestedManyWithoutProjectInput>;
  contactHistory?: InputMaybe<ContactHistoryCreateNestedManyWithoutProjectInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  dashboardProject?: InputMaybe<DashboardProjectCreateNestedManyWithoutProjectInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<EmailHistoryCreateNestedManyWithoutProjectInput>;
  employeeMaster?: InputMaybe<EmployeeMasterCreateNestedManyWithoutProjectInput>;
  finances?: InputMaybe<FinanceCreateNestedManyWithoutProjectInput>;
  goals?: InputMaybe<GoalsOnMasterCreateNestedManyWithoutProjectInput>;
  id?: InputMaybe<Scalars['String']>;
  leanixProject?: InputMaybe<LeanixMappingCreateNestedOneWithoutMasterInput>;
  projectAllocations?: InputMaybe<ProjectAllocationCreateNestedManyWithoutProjectInput>;
  projectApproval?: InputMaybe<ProjectApprovalCreateNestedManyWithoutProjectInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentCreateNestedManyWithoutProjectInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionCreateNestedManyWithoutMasterInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsCreateNestedManyWithoutProjectInput>;
  projectInterface?: InputMaybe<ProjectInterfaceCreateNestedManyWithoutProjectInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureCreateNestedManyWithoutProjectInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireCreateNestedManyWithoutProjectInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureCreateNestedManyWithoutProjectInput>;
  projectRole?: InputMaybe<ProjectRoleCreateNestedManyWithoutProjectInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryCreateNestedManyWithoutProjectInput>;
  projectStatus?: InputMaybe<ProjectStatusCreateNestedManyWithoutProjectInput>;
  pspMapping?: InputMaybe<PspMappingCreateNestedManyWithoutMasterInput>;
  remarks?: InputMaybe<RemarkCreateNestedManyWithoutProjectInput>;
  replacement?: InputMaybe<ReplacementCreateNestedManyWithoutProjectInput>;
  report?: InputMaybe<ReportCreateNestedManyWithoutProjectInput>;
  risk?: InputMaybe<RiskCreateNestedManyWithoutProjectInput>;
  topProjects?: InputMaybe<TopProjectsCreateNestedManyWithoutProjectInput>;
};

export type MasterCreateWithoutProjectDescriptionCommentInput = {
  budgets?: InputMaybe<TargetedBudgetCreateNestedManyWithoutMasterInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectCreateNestedManyWithoutProjectInput>;
  contactHistory?: InputMaybe<ContactHistoryCreateNestedManyWithoutProjectInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  dashboardProject?: InputMaybe<DashboardProjectCreateNestedManyWithoutProjectInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<EmailHistoryCreateNestedManyWithoutProjectInput>;
  employeeMaster?: InputMaybe<EmployeeMasterCreateNestedManyWithoutProjectInput>;
  finances?: InputMaybe<FinanceCreateNestedManyWithoutProjectInput>;
  goals?: InputMaybe<GoalsOnMasterCreateNestedManyWithoutProjectInput>;
  id?: InputMaybe<Scalars['String']>;
  leanixProject?: InputMaybe<LeanixMappingCreateNestedOneWithoutMasterInput>;
  projectAllocations?: InputMaybe<ProjectAllocationCreateNestedManyWithoutProjectInput>;
  projectApproval?: InputMaybe<ProjectApprovalCreateNestedManyWithoutProjectInput>;
  projectDependency?: InputMaybe<ProjectDependencyCreateNestedManyWithoutProjectInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionCreateNestedManyWithoutMasterInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsCreateNestedManyWithoutProjectInput>;
  projectInterface?: InputMaybe<ProjectInterfaceCreateNestedManyWithoutProjectInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureCreateNestedManyWithoutProjectInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireCreateNestedManyWithoutProjectInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureCreateNestedManyWithoutProjectInput>;
  projectRole?: InputMaybe<ProjectRoleCreateNestedManyWithoutProjectInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryCreateNestedManyWithoutProjectInput>;
  projectStatus?: InputMaybe<ProjectStatusCreateNestedManyWithoutProjectInput>;
  pspMapping?: InputMaybe<PspMappingCreateNestedManyWithoutMasterInput>;
  remarks?: InputMaybe<RemarkCreateNestedManyWithoutProjectInput>;
  replacement?: InputMaybe<ReplacementCreateNestedManyWithoutProjectInput>;
  report?: InputMaybe<ReportCreateNestedManyWithoutProjectInput>;
  risk?: InputMaybe<RiskCreateNestedManyWithoutProjectInput>;
  topProjects?: InputMaybe<TopProjectsCreateNestedManyWithoutProjectInput>;
};

export type MasterCreateWithoutProjectDescriptionsInput = {
  budgets?: InputMaybe<TargetedBudgetCreateNestedManyWithoutMasterInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectCreateNestedManyWithoutProjectInput>;
  contactHistory?: InputMaybe<ContactHistoryCreateNestedManyWithoutProjectInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  dashboardProject?: InputMaybe<DashboardProjectCreateNestedManyWithoutProjectInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<EmailHistoryCreateNestedManyWithoutProjectInput>;
  employeeMaster?: InputMaybe<EmployeeMasterCreateNestedManyWithoutProjectInput>;
  finances?: InputMaybe<FinanceCreateNestedManyWithoutProjectInput>;
  goals?: InputMaybe<GoalsOnMasterCreateNestedManyWithoutProjectInput>;
  id?: InputMaybe<Scalars['String']>;
  leanixProject?: InputMaybe<LeanixMappingCreateNestedOneWithoutMasterInput>;
  projectAllocations?: InputMaybe<ProjectAllocationCreateNestedManyWithoutProjectInput>;
  projectApproval?: InputMaybe<ProjectApprovalCreateNestedManyWithoutProjectInput>;
  projectDependency?: InputMaybe<ProjectDependencyCreateNestedManyWithoutProjectInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentCreateNestedManyWithoutProjectInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsCreateNestedManyWithoutProjectInput>;
  projectInterface?: InputMaybe<ProjectInterfaceCreateNestedManyWithoutProjectInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureCreateNestedManyWithoutProjectInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireCreateNestedManyWithoutProjectInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureCreateNestedManyWithoutProjectInput>;
  projectRole?: InputMaybe<ProjectRoleCreateNestedManyWithoutProjectInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryCreateNestedManyWithoutProjectInput>;
  projectStatus?: InputMaybe<ProjectStatusCreateNestedManyWithoutProjectInput>;
  pspMapping?: InputMaybe<PspMappingCreateNestedManyWithoutMasterInput>;
  remarks?: InputMaybe<RemarkCreateNestedManyWithoutProjectInput>;
  replacement?: InputMaybe<ReplacementCreateNestedManyWithoutProjectInput>;
  report?: InputMaybe<ReportCreateNestedManyWithoutProjectInput>;
  risk?: InputMaybe<RiskCreateNestedManyWithoutProjectInput>;
  topProjects?: InputMaybe<TopProjectsCreateNestedManyWithoutProjectInput>;
};

export type MasterCreateWithoutProjectDocumentsInput = {
  budgets?: InputMaybe<TargetedBudgetCreateNestedManyWithoutMasterInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectCreateNestedManyWithoutProjectInput>;
  contactHistory?: InputMaybe<ContactHistoryCreateNestedManyWithoutProjectInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  dashboardProject?: InputMaybe<DashboardProjectCreateNestedManyWithoutProjectInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<EmailHistoryCreateNestedManyWithoutProjectInput>;
  employeeMaster?: InputMaybe<EmployeeMasterCreateNestedManyWithoutProjectInput>;
  finances?: InputMaybe<FinanceCreateNestedManyWithoutProjectInput>;
  goals?: InputMaybe<GoalsOnMasterCreateNestedManyWithoutProjectInput>;
  id?: InputMaybe<Scalars['String']>;
  leanixProject?: InputMaybe<LeanixMappingCreateNestedOneWithoutMasterInput>;
  projectAllocations?: InputMaybe<ProjectAllocationCreateNestedManyWithoutProjectInput>;
  projectApproval?: InputMaybe<ProjectApprovalCreateNestedManyWithoutProjectInput>;
  projectDependency?: InputMaybe<ProjectDependencyCreateNestedManyWithoutProjectInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentCreateNestedManyWithoutProjectInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionCreateNestedManyWithoutMasterInput>;
  projectInterface?: InputMaybe<ProjectInterfaceCreateNestedManyWithoutProjectInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureCreateNestedManyWithoutProjectInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireCreateNestedManyWithoutProjectInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureCreateNestedManyWithoutProjectInput>;
  projectRole?: InputMaybe<ProjectRoleCreateNestedManyWithoutProjectInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryCreateNestedManyWithoutProjectInput>;
  projectStatus?: InputMaybe<ProjectStatusCreateNestedManyWithoutProjectInput>;
  pspMapping?: InputMaybe<PspMappingCreateNestedManyWithoutMasterInput>;
  remarks?: InputMaybe<RemarkCreateNestedManyWithoutProjectInput>;
  replacement?: InputMaybe<ReplacementCreateNestedManyWithoutProjectInput>;
  report?: InputMaybe<ReportCreateNestedManyWithoutProjectInput>;
  risk?: InputMaybe<RiskCreateNestedManyWithoutProjectInput>;
  topProjects?: InputMaybe<TopProjectsCreateNestedManyWithoutProjectInput>;
};

export type MasterCreateWithoutProjectInterfaceInput = {
  budgets?: InputMaybe<TargetedBudgetCreateNestedManyWithoutMasterInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectCreateNestedManyWithoutProjectInput>;
  contactHistory?: InputMaybe<ContactHistoryCreateNestedManyWithoutProjectInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  dashboardProject?: InputMaybe<DashboardProjectCreateNestedManyWithoutProjectInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<EmailHistoryCreateNestedManyWithoutProjectInput>;
  employeeMaster?: InputMaybe<EmployeeMasterCreateNestedManyWithoutProjectInput>;
  finances?: InputMaybe<FinanceCreateNestedManyWithoutProjectInput>;
  goals?: InputMaybe<GoalsOnMasterCreateNestedManyWithoutProjectInput>;
  id?: InputMaybe<Scalars['String']>;
  leanixProject?: InputMaybe<LeanixMappingCreateNestedOneWithoutMasterInput>;
  projectAllocations?: InputMaybe<ProjectAllocationCreateNestedManyWithoutProjectInput>;
  projectApproval?: InputMaybe<ProjectApprovalCreateNestedManyWithoutProjectInput>;
  projectDependency?: InputMaybe<ProjectDependencyCreateNestedManyWithoutProjectInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentCreateNestedManyWithoutProjectInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionCreateNestedManyWithoutMasterInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsCreateNestedManyWithoutProjectInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureCreateNestedManyWithoutProjectInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireCreateNestedManyWithoutProjectInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureCreateNestedManyWithoutProjectInput>;
  projectRole?: InputMaybe<ProjectRoleCreateNestedManyWithoutProjectInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryCreateNestedManyWithoutProjectInput>;
  projectStatus?: InputMaybe<ProjectStatusCreateNestedManyWithoutProjectInput>;
  pspMapping?: InputMaybe<PspMappingCreateNestedManyWithoutMasterInput>;
  remarks?: InputMaybe<RemarkCreateNestedManyWithoutProjectInput>;
  replacement?: InputMaybe<ReplacementCreateNestedManyWithoutProjectInput>;
  report?: InputMaybe<ReportCreateNestedManyWithoutProjectInput>;
  risk?: InputMaybe<RiskCreateNestedManyWithoutProjectInput>;
  topProjects?: InputMaybe<TopProjectsCreateNestedManyWithoutProjectInput>;
};

export type MasterCreateWithoutProjectPhaseCaptureInput = {
  budgets?: InputMaybe<TargetedBudgetCreateNestedManyWithoutMasterInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectCreateNestedManyWithoutProjectInput>;
  contactHistory?: InputMaybe<ContactHistoryCreateNestedManyWithoutProjectInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  dashboardProject?: InputMaybe<DashboardProjectCreateNestedManyWithoutProjectInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<EmailHistoryCreateNestedManyWithoutProjectInput>;
  employeeMaster?: InputMaybe<EmployeeMasterCreateNestedManyWithoutProjectInput>;
  finances?: InputMaybe<FinanceCreateNestedManyWithoutProjectInput>;
  goals?: InputMaybe<GoalsOnMasterCreateNestedManyWithoutProjectInput>;
  id?: InputMaybe<Scalars['String']>;
  leanixProject?: InputMaybe<LeanixMappingCreateNestedOneWithoutMasterInput>;
  projectAllocations?: InputMaybe<ProjectAllocationCreateNestedManyWithoutProjectInput>;
  projectApproval?: InputMaybe<ProjectApprovalCreateNestedManyWithoutProjectInput>;
  projectDependency?: InputMaybe<ProjectDependencyCreateNestedManyWithoutProjectInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentCreateNestedManyWithoutProjectInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionCreateNestedManyWithoutMasterInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsCreateNestedManyWithoutProjectInput>;
  projectInterface?: InputMaybe<ProjectInterfaceCreateNestedManyWithoutProjectInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireCreateNestedManyWithoutProjectInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureCreateNestedManyWithoutProjectInput>;
  projectRole?: InputMaybe<ProjectRoleCreateNestedManyWithoutProjectInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryCreateNestedManyWithoutProjectInput>;
  projectStatus?: InputMaybe<ProjectStatusCreateNestedManyWithoutProjectInput>;
  pspMapping?: InputMaybe<PspMappingCreateNestedManyWithoutMasterInput>;
  remarks?: InputMaybe<RemarkCreateNestedManyWithoutProjectInput>;
  replacement?: InputMaybe<ReplacementCreateNestedManyWithoutProjectInput>;
  report?: InputMaybe<ReportCreateNestedManyWithoutProjectInput>;
  risk?: InputMaybe<RiskCreateNestedManyWithoutProjectInput>;
  topProjects?: InputMaybe<TopProjectsCreateNestedManyWithoutProjectInput>;
};

export type MasterCreateWithoutProjectQuestionnaireInput = {
  budgets?: InputMaybe<TargetedBudgetCreateNestedManyWithoutMasterInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectCreateNestedManyWithoutProjectInput>;
  contactHistory?: InputMaybe<ContactHistoryCreateNestedManyWithoutProjectInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  dashboardProject?: InputMaybe<DashboardProjectCreateNestedManyWithoutProjectInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<EmailHistoryCreateNestedManyWithoutProjectInput>;
  employeeMaster?: InputMaybe<EmployeeMasterCreateNestedManyWithoutProjectInput>;
  finances?: InputMaybe<FinanceCreateNestedManyWithoutProjectInput>;
  goals?: InputMaybe<GoalsOnMasterCreateNestedManyWithoutProjectInput>;
  id?: InputMaybe<Scalars['String']>;
  leanixProject?: InputMaybe<LeanixMappingCreateNestedOneWithoutMasterInput>;
  projectAllocations?: InputMaybe<ProjectAllocationCreateNestedManyWithoutProjectInput>;
  projectApproval?: InputMaybe<ProjectApprovalCreateNestedManyWithoutProjectInput>;
  projectDependency?: InputMaybe<ProjectDependencyCreateNestedManyWithoutProjectInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentCreateNestedManyWithoutProjectInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionCreateNestedManyWithoutMasterInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsCreateNestedManyWithoutProjectInput>;
  projectInterface?: InputMaybe<ProjectInterfaceCreateNestedManyWithoutProjectInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureCreateNestedManyWithoutProjectInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureCreateNestedManyWithoutProjectInput>;
  projectRole?: InputMaybe<ProjectRoleCreateNestedManyWithoutProjectInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryCreateNestedManyWithoutProjectInput>;
  projectStatus?: InputMaybe<ProjectStatusCreateNestedManyWithoutProjectInput>;
  pspMapping?: InputMaybe<PspMappingCreateNestedManyWithoutMasterInput>;
  remarks?: InputMaybe<RemarkCreateNestedManyWithoutProjectInput>;
  replacement?: InputMaybe<ReplacementCreateNestedManyWithoutProjectInput>;
  report?: InputMaybe<ReportCreateNestedManyWithoutProjectInput>;
  risk?: InputMaybe<RiskCreateNestedManyWithoutProjectInput>;
  topProjects?: InputMaybe<TopProjectsCreateNestedManyWithoutProjectInput>;
};

export type MasterCreateWithoutProjectResourceCaptureInput = {
  budgets?: InputMaybe<TargetedBudgetCreateNestedManyWithoutMasterInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectCreateNestedManyWithoutProjectInput>;
  contactHistory?: InputMaybe<ContactHistoryCreateNestedManyWithoutProjectInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  dashboardProject?: InputMaybe<DashboardProjectCreateNestedManyWithoutProjectInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<EmailHistoryCreateNestedManyWithoutProjectInput>;
  employeeMaster?: InputMaybe<EmployeeMasterCreateNestedManyWithoutProjectInput>;
  finances?: InputMaybe<FinanceCreateNestedManyWithoutProjectInput>;
  goals?: InputMaybe<GoalsOnMasterCreateNestedManyWithoutProjectInput>;
  id?: InputMaybe<Scalars['String']>;
  leanixProject?: InputMaybe<LeanixMappingCreateNestedOneWithoutMasterInput>;
  projectAllocations?: InputMaybe<ProjectAllocationCreateNestedManyWithoutProjectInput>;
  projectApproval?: InputMaybe<ProjectApprovalCreateNestedManyWithoutProjectInput>;
  projectDependency?: InputMaybe<ProjectDependencyCreateNestedManyWithoutProjectInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentCreateNestedManyWithoutProjectInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionCreateNestedManyWithoutMasterInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsCreateNestedManyWithoutProjectInput>;
  projectInterface?: InputMaybe<ProjectInterfaceCreateNestedManyWithoutProjectInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureCreateNestedManyWithoutProjectInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireCreateNestedManyWithoutProjectInput>;
  projectRole?: InputMaybe<ProjectRoleCreateNestedManyWithoutProjectInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryCreateNestedManyWithoutProjectInput>;
  projectStatus?: InputMaybe<ProjectStatusCreateNestedManyWithoutProjectInput>;
  pspMapping?: InputMaybe<PspMappingCreateNestedManyWithoutMasterInput>;
  remarks?: InputMaybe<RemarkCreateNestedManyWithoutProjectInput>;
  replacement?: InputMaybe<ReplacementCreateNestedManyWithoutProjectInput>;
  report?: InputMaybe<ReportCreateNestedManyWithoutProjectInput>;
  risk?: InputMaybe<RiskCreateNestedManyWithoutProjectInput>;
  topProjects?: InputMaybe<TopProjectsCreateNestedManyWithoutProjectInput>;
};

export type MasterCreateWithoutProjectRoleInput = {
  budgets?: InputMaybe<TargetedBudgetCreateNestedManyWithoutMasterInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectCreateNestedManyWithoutProjectInput>;
  contactHistory?: InputMaybe<ContactHistoryCreateNestedManyWithoutProjectInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  dashboardProject?: InputMaybe<DashboardProjectCreateNestedManyWithoutProjectInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<EmailHistoryCreateNestedManyWithoutProjectInput>;
  employeeMaster?: InputMaybe<EmployeeMasterCreateNestedManyWithoutProjectInput>;
  finances?: InputMaybe<FinanceCreateNestedManyWithoutProjectInput>;
  goals?: InputMaybe<GoalsOnMasterCreateNestedManyWithoutProjectInput>;
  id?: InputMaybe<Scalars['String']>;
  leanixProject?: InputMaybe<LeanixMappingCreateNestedOneWithoutMasterInput>;
  projectAllocations?: InputMaybe<ProjectAllocationCreateNestedManyWithoutProjectInput>;
  projectApproval?: InputMaybe<ProjectApprovalCreateNestedManyWithoutProjectInput>;
  projectDependency?: InputMaybe<ProjectDependencyCreateNestedManyWithoutProjectInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentCreateNestedManyWithoutProjectInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionCreateNestedManyWithoutMasterInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsCreateNestedManyWithoutProjectInput>;
  projectInterface?: InputMaybe<ProjectInterfaceCreateNestedManyWithoutProjectInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureCreateNestedManyWithoutProjectInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireCreateNestedManyWithoutProjectInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureCreateNestedManyWithoutProjectInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryCreateNestedManyWithoutProjectInput>;
  projectStatus?: InputMaybe<ProjectStatusCreateNestedManyWithoutProjectInput>;
  pspMapping?: InputMaybe<PspMappingCreateNestedManyWithoutMasterInput>;
  remarks?: InputMaybe<RemarkCreateNestedManyWithoutProjectInput>;
  replacement?: InputMaybe<ReplacementCreateNestedManyWithoutProjectInput>;
  report?: InputMaybe<ReportCreateNestedManyWithoutProjectInput>;
  risk?: InputMaybe<RiskCreateNestedManyWithoutProjectInput>;
  topProjects?: InputMaybe<TopProjectsCreateNestedManyWithoutProjectInput>;
};

export type MasterCreateWithoutProjectShortHistoryInput = {
  budgets?: InputMaybe<TargetedBudgetCreateNestedManyWithoutMasterInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectCreateNestedManyWithoutProjectInput>;
  contactHistory?: InputMaybe<ContactHistoryCreateNestedManyWithoutProjectInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  dashboardProject?: InputMaybe<DashboardProjectCreateNestedManyWithoutProjectInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<EmailHistoryCreateNestedManyWithoutProjectInput>;
  employeeMaster?: InputMaybe<EmployeeMasterCreateNestedManyWithoutProjectInput>;
  finances?: InputMaybe<FinanceCreateNestedManyWithoutProjectInput>;
  goals?: InputMaybe<GoalsOnMasterCreateNestedManyWithoutProjectInput>;
  id?: InputMaybe<Scalars['String']>;
  leanixProject?: InputMaybe<LeanixMappingCreateNestedOneWithoutMasterInput>;
  projectAllocations?: InputMaybe<ProjectAllocationCreateNestedManyWithoutProjectInput>;
  projectApproval?: InputMaybe<ProjectApprovalCreateNestedManyWithoutProjectInput>;
  projectDependency?: InputMaybe<ProjectDependencyCreateNestedManyWithoutProjectInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentCreateNestedManyWithoutProjectInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionCreateNestedManyWithoutMasterInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsCreateNestedManyWithoutProjectInput>;
  projectInterface?: InputMaybe<ProjectInterfaceCreateNestedManyWithoutProjectInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureCreateNestedManyWithoutProjectInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireCreateNestedManyWithoutProjectInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureCreateNestedManyWithoutProjectInput>;
  projectRole?: InputMaybe<ProjectRoleCreateNestedManyWithoutProjectInput>;
  projectStatus?: InputMaybe<ProjectStatusCreateNestedManyWithoutProjectInput>;
  pspMapping?: InputMaybe<PspMappingCreateNestedManyWithoutMasterInput>;
  remarks?: InputMaybe<RemarkCreateNestedManyWithoutProjectInput>;
  replacement?: InputMaybe<ReplacementCreateNestedManyWithoutProjectInput>;
  report?: InputMaybe<ReportCreateNestedManyWithoutProjectInput>;
  risk?: InputMaybe<RiskCreateNestedManyWithoutProjectInput>;
  topProjects?: InputMaybe<TopProjectsCreateNestedManyWithoutProjectInput>;
};

export type MasterCreateWithoutProjectStatusInput = {
  budgets?: InputMaybe<TargetedBudgetCreateNestedManyWithoutMasterInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectCreateNestedManyWithoutProjectInput>;
  contactHistory?: InputMaybe<ContactHistoryCreateNestedManyWithoutProjectInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  dashboardProject?: InputMaybe<DashboardProjectCreateNestedManyWithoutProjectInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<EmailHistoryCreateNestedManyWithoutProjectInput>;
  employeeMaster?: InputMaybe<EmployeeMasterCreateNestedManyWithoutProjectInput>;
  finances?: InputMaybe<FinanceCreateNestedManyWithoutProjectInput>;
  goals?: InputMaybe<GoalsOnMasterCreateNestedManyWithoutProjectInput>;
  id?: InputMaybe<Scalars['String']>;
  leanixProject?: InputMaybe<LeanixMappingCreateNestedOneWithoutMasterInput>;
  projectAllocations?: InputMaybe<ProjectAllocationCreateNestedManyWithoutProjectInput>;
  projectApproval?: InputMaybe<ProjectApprovalCreateNestedManyWithoutProjectInput>;
  projectDependency?: InputMaybe<ProjectDependencyCreateNestedManyWithoutProjectInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentCreateNestedManyWithoutProjectInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionCreateNestedManyWithoutMasterInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsCreateNestedManyWithoutProjectInput>;
  projectInterface?: InputMaybe<ProjectInterfaceCreateNestedManyWithoutProjectInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureCreateNestedManyWithoutProjectInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireCreateNestedManyWithoutProjectInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureCreateNestedManyWithoutProjectInput>;
  projectRole?: InputMaybe<ProjectRoleCreateNestedManyWithoutProjectInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryCreateNestedManyWithoutProjectInput>;
  pspMapping?: InputMaybe<PspMappingCreateNestedManyWithoutMasterInput>;
  remarks?: InputMaybe<RemarkCreateNestedManyWithoutProjectInput>;
  replacement?: InputMaybe<ReplacementCreateNestedManyWithoutProjectInput>;
  report?: InputMaybe<ReportCreateNestedManyWithoutProjectInput>;
  risk?: InputMaybe<RiskCreateNestedManyWithoutProjectInput>;
  topProjects?: InputMaybe<TopProjectsCreateNestedManyWithoutProjectInput>;
};

export type MasterCreateWithoutPspMappingInput = {
  budgets?: InputMaybe<TargetedBudgetCreateNestedManyWithoutMasterInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectCreateNestedManyWithoutProjectInput>;
  contactHistory?: InputMaybe<ContactHistoryCreateNestedManyWithoutProjectInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  dashboardProject?: InputMaybe<DashboardProjectCreateNestedManyWithoutProjectInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<EmailHistoryCreateNestedManyWithoutProjectInput>;
  employeeMaster?: InputMaybe<EmployeeMasterCreateNestedManyWithoutProjectInput>;
  finances?: InputMaybe<FinanceCreateNestedManyWithoutProjectInput>;
  goals?: InputMaybe<GoalsOnMasterCreateNestedManyWithoutProjectInput>;
  id?: InputMaybe<Scalars['String']>;
  leanixProject?: InputMaybe<LeanixMappingCreateNestedOneWithoutMasterInput>;
  projectAllocations?: InputMaybe<ProjectAllocationCreateNestedManyWithoutProjectInput>;
  projectApproval?: InputMaybe<ProjectApprovalCreateNestedManyWithoutProjectInput>;
  projectDependency?: InputMaybe<ProjectDependencyCreateNestedManyWithoutProjectInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentCreateNestedManyWithoutProjectInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionCreateNestedManyWithoutMasterInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsCreateNestedManyWithoutProjectInput>;
  projectInterface?: InputMaybe<ProjectInterfaceCreateNestedManyWithoutProjectInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureCreateNestedManyWithoutProjectInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireCreateNestedManyWithoutProjectInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureCreateNestedManyWithoutProjectInput>;
  projectRole?: InputMaybe<ProjectRoleCreateNestedManyWithoutProjectInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryCreateNestedManyWithoutProjectInput>;
  projectStatus?: InputMaybe<ProjectStatusCreateNestedManyWithoutProjectInput>;
  remarks?: InputMaybe<RemarkCreateNestedManyWithoutProjectInput>;
  replacement?: InputMaybe<ReplacementCreateNestedManyWithoutProjectInput>;
  report?: InputMaybe<ReportCreateNestedManyWithoutProjectInput>;
  risk?: InputMaybe<RiskCreateNestedManyWithoutProjectInput>;
  topProjects?: InputMaybe<TopProjectsCreateNestedManyWithoutProjectInput>;
};

export type MasterCreateWithoutRemarksInput = {
  budgets?: InputMaybe<TargetedBudgetCreateNestedManyWithoutMasterInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectCreateNestedManyWithoutProjectInput>;
  contactHistory?: InputMaybe<ContactHistoryCreateNestedManyWithoutProjectInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  dashboardProject?: InputMaybe<DashboardProjectCreateNestedManyWithoutProjectInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<EmailHistoryCreateNestedManyWithoutProjectInput>;
  employeeMaster?: InputMaybe<EmployeeMasterCreateNestedManyWithoutProjectInput>;
  finances?: InputMaybe<FinanceCreateNestedManyWithoutProjectInput>;
  goals?: InputMaybe<GoalsOnMasterCreateNestedManyWithoutProjectInput>;
  id?: InputMaybe<Scalars['String']>;
  leanixProject?: InputMaybe<LeanixMappingCreateNestedOneWithoutMasterInput>;
  projectAllocations?: InputMaybe<ProjectAllocationCreateNestedManyWithoutProjectInput>;
  projectApproval?: InputMaybe<ProjectApprovalCreateNestedManyWithoutProjectInput>;
  projectDependency?: InputMaybe<ProjectDependencyCreateNestedManyWithoutProjectInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentCreateNestedManyWithoutProjectInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionCreateNestedManyWithoutMasterInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsCreateNestedManyWithoutProjectInput>;
  projectInterface?: InputMaybe<ProjectInterfaceCreateNestedManyWithoutProjectInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureCreateNestedManyWithoutProjectInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireCreateNestedManyWithoutProjectInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureCreateNestedManyWithoutProjectInput>;
  projectRole?: InputMaybe<ProjectRoleCreateNestedManyWithoutProjectInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryCreateNestedManyWithoutProjectInput>;
  projectStatus?: InputMaybe<ProjectStatusCreateNestedManyWithoutProjectInput>;
  pspMapping?: InputMaybe<PspMappingCreateNestedManyWithoutMasterInput>;
  replacement?: InputMaybe<ReplacementCreateNestedManyWithoutProjectInput>;
  report?: InputMaybe<ReportCreateNestedManyWithoutProjectInput>;
  risk?: InputMaybe<RiskCreateNestedManyWithoutProjectInput>;
  topProjects?: InputMaybe<TopProjectsCreateNestedManyWithoutProjectInput>;
};

export type MasterCreateWithoutReplacementInput = {
  budgets?: InputMaybe<TargetedBudgetCreateNestedManyWithoutMasterInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectCreateNestedManyWithoutProjectInput>;
  contactHistory?: InputMaybe<ContactHistoryCreateNestedManyWithoutProjectInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  dashboardProject?: InputMaybe<DashboardProjectCreateNestedManyWithoutProjectInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<EmailHistoryCreateNestedManyWithoutProjectInput>;
  employeeMaster?: InputMaybe<EmployeeMasterCreateNestedManyWithoutProjectInput>;
  finances?: InputMaybe<FinanceCreateNestedManyWithoutProjectInput>;
  goals?: InputMaybe<GoalsOnMasterCreateNestedManyWithoutProjectInput>;
  id?: InputMaybe<Scalars['String']>;
  leanixProject?: InputMaybe<LeanixMappingCreateNestedOneWithoutMasterInput>;
  projectAllocations?: InputMaybe<ProjectAllocationCreateNestedManyWithoutProjectInput>;
  projectApproval?: InputMaybe<ProjectApprovalCreateNestedManyWithoutProjectInput>;
  projectDependency?: InputMaybe<ProjectDependencyCreateNestedManyWithoutProjectInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentCreateNestedManyWithoutProjectInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionCreateNestedManyWithoutMasterInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsCreateNestedManyWithoutProjectInput>;
  projectInterface?: InputMaybe<ProjectInterfaceCreateNestedManyWithoutProjectInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureCreateNestedManyWithoutProjectInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireCreateNestedManyWithoutProjectInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureCreateNestedManyWithoutProjectInput>;
  projectRole?: InputMaybe<ProjectRoleCreateNestedManyWithoutProjectInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryCreateNestedManyWithoutProjectInput>;
  projectStatus?: InputMaybe<ProjectStatusCreateNestedManyWithoutProjectInput>;
  pspMapping?: InputMaybe<PspMappingCreateNestedManyWithoutMasterInput>;
  remarks?: InputMaybe<RemarkCreateNestedManyWithoutProjectInput>;
  report?: InputMaybe<ReportCreateNestedManyWithoutProjectInput>;
  risk?: InputMaybe<RiskCreateNestedManyWithoutProjectInput>;
  topProjects?: InputMaybe<TopProjectsCreateNestedManyWithoutProjectInput>;
};

export type MasterCreateWithoutReportInput = {
  budgets?: InputMaybe<TargetedBudgetCreateNestedManyWithoutMasterInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectCreateNestedManyWithoutProjectInput>;
  contactHistory?: InputMaybe<ContactHistoryCreateNestedManyWithoutProjectInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  dashboardProject?: InputMaybe<DashboardProjectCreateNestedManyWithoutProjectInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<EmailHistoryCreateNestedManyWithoutProjectInput>;
  employeeMaster?: InputMaybe<EmployeeMasterCreateNestedManyWithoutProjectInput>;
  finances?: InputMaybe<FinanceCreateNestedManyWithoutProjectInput>;
  goals?: InputMaybe<GoalsOnMasterCreateNestedManyWithoutProjectInput>;
  id?: InputMaybe<Scalars['String']>;
  leanixProject?: InputMaybe<LeanixMappingCreateNestedOneWithoutMasterInput>;
  projectAllocations?: InputMaybe<ProjectAllocationCreateNestedManyWithoutProjectInput>;
  projectApproval?: InputMaybe<ProjectApprovalCreateNestedManyWithoutProjectInput>;
  projectDependency?: InputMaybe<ProjectDependencyCreateNestedManyWithoutProjectInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentCreateNestedManyWithoutProjectInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionCreateNestedManyWithoutMasterInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsCreateNestedManyWithoutProjectInput>;
  projectInterface?: InputMaybe<ProjectInterfaceCreateNestedManyWithoutProjectInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureCreateNestedManyWithoutProjectInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireCreateNestedManyWithoutProjectInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureCreateNestedManyWithoutProjectInput>;
  projectRole?: InputMaybe<ProjectRoleCreateNestedManyWithoutProjectInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryCreateNestedManyWithoutProjectInput>;
  projectStatus?: InputMaybe<ProjectStatusCreateNestedManyWithoutProjectInput>;
  pspMapping?: InputMaybe<PspMappingCreateNestedManyWithoutMasterInput>;
  remarks?: InputMaybe<RemarkCreateNestedManyWithoutProjectInput>;
  replacement?: InputMaybe<ReplacementCreateNestedManyWithoutProjectInput>;
  risk?: InputMaybe<RiskCreateNestedManyWithoutProjectInput>;
  topProjects?: InputMaybe<TopProjectsCreateNestedManyWithoutProjectInput>;
};

export type MasterCreateWithoutRiskInput = {
  budgets?: InputMaybe<TargetedBudgetCreateNestedManyWithoutMasterInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectCreateNestedManyWithoutProjectInput>;
  contactHistory?: InputMaybe<ContactHistoryCreateNestedManyWithoutProjectInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  dashboardProject?: InputMaybe<DashboardProjectCreateNestedManyWithoutProjectInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<EmailHistoryCreateNestedManyWithoutProjectInput>;
  employeeMaster?: InputMaybe<EmployeeMasterCreateNestedManyWithoutProjectInput>;
  finances?: InputMaybe<FinanceCreateNestedManyWithoutProjectInput>;
  goals?: InputMaybe<GoalsOnMasterCreateNestedManyWithoutProjectInput>;
  id?: InputMaybe<Scalars['String']>;
  leanixProject?: InputMaybe<LeanixMappingCreateNestedOneWithoutMasterInput>;
  projectAllocations?: InputMaybe<ProjectAllocationCreateNestedManyWithoutProjectInput>;
  projectApproval?: InputMaybe<ProjectApprovalCreateNestedManyWithoutProjectInput>;
  projectDependency?: InputMaybe<ProjectDependencyCreateNestedManyWithoutProjectInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentCreateNestedManyWithoutProjectInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionCreateNestedManyWithoutMasterInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsCreateNestedManyWithoutProjectInput>;
  projectInterface?: InputMaybe<ProjectInterfaceCreateNestedManyWithoutProjectInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureCreateNestedManyWithoutProjectInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireCreateNestedManyWithoutProjectInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureCreateNestedManyWithoutProjectInput>;
  projectRole?: InputMaybe<ProjectRoleCreateNestedManyWithoutProjectInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryCreateNestedManyWithoutProjectInput>;
  projectStatus?: InputMaybe<ProjectStatusCreateNestedManyWithoutProjectInput>;
  pspMapping?: InputMaybe<PspMappingCreateNestedManyWithoutMasterInput>;
  remarks?: InputMaybe<RemarkCreateNestedManyWithoutProjectInput>;
  replacement?: InputMaybe<ReplacementCreateNestedManyWithoutProjectInput>;
  report?: InputMaybe<ReportCreateNestedManyWithoutProjectInput>;
  topProjects?: InputMaybe<TopProjectsCreateNestedManyWithoutProjectInput>;
};

export type MasterCreateWithoutTopProjectsInput = {
  budgets?: InputMaybe<TargetedBudgetCreateNestedManyWithoutMasterInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectCreateNestedManyWithoutProjectInput>;
  contactHistory?: InputMaybe<ContactHistoryCreateNestedManyWithoutProjectInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  dashboardProject?: InputMaybe<DashboardProjectCreateNestedManyWithoutProjectInput>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<EmailHistoryCreateNestedManyWithoutProjectInput>;
  employeeMaster?: InputMaybe<EmployeeMasterCreateNestedManyWithoutProjectInput>;
  finances?: InputMaybe<FinanceCreateNestedManyWithoutProjectInput>;
  goals?: InputMaybe<GoalsOnMasterCreateNestedManyWithoutProjectInput>;
  id?: InputMaybe<Scalars['String']>;
  leanixProject?: InputMaybe<LeanixMappingCreateNestedOneWithoutMasterInput>;
  projectAllocations?: InputMaybe<ProjectAllocationCreateNestedManyWithoutProjectInput>;
  projectApproval?: InputMaybe<ProjectApprovalCreateNestedManyWithoutProjectInput>;
  projectDependency?: InputMaybe<ProjectDependencyCreateNestedManyWithoutProjectInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentCreateNestedManyWithoutProjectInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionCreateNestedManyWithoutMasterInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsCreateNestedManyWithoutProjectInput>;
  projectInterface?: InputMaybe<ProjectInterfaceCreateNestedManyWithoutProjectInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureCreateNestedManyWithoutProjectInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireCreateNestedManyWithoutProjectInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureCreateNestedManyWithoutProjectInput>;
  projectRole?: InputMaybe<ProjectRoleCreateNestedManyWithoutProjectInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryCreateNestedManyWithoutProjectInput>;
  projectStatus?: InputMaybe<ProjectStatusCreateNestedManyWithoutProjectInput>;
  pspMapping?: InputMaybe<PspMappingCreateNestedManyWithoutMasterInput>;
  remarks?: InputMaybe<RemarkCreateNestedManyWithoutProjectInput>;
  replacement?: InputMaybe<ReplacementCreateNestedManyWithoutProjectInput>;
  report?: InputMaybe<ReportCreateNestedManyWithoutProjectInput>;
  risk?: InputMaybe<RiskCreateNestedManyWithoutProjectInput>;
};

export type MasterOrderByWithRelationInput = {
  budgets?: InputMaybe<TargetedBudgetOrderByRelationAggregateInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectOrderByRelationAggregateInput>;
  contactHistory?: InputMaybe<ContactHistoryOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  dashboardProject?: InputMaybe<DashboardProjectOrderByRelationAggregateInput>;
  deletedAt?: InputMaybe<SortOrder>;
  deletedBy?: InputMaybe<SortOrder>;
  email?: InputMaybe<EmailHistoryOrderByRelationAggregateInput>;
  employeeMaster?: InputMaybe<EmployeeMasterOrderByRelationAggregateInput>;
  finances?: InputMaybe<FinanceOrderByRelationAggregateInput>;
  goals?: InputMaybe<GoalsOnMasterOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  leanixProject?: InputMaybe<LeanixMappingOrderByWithRelationInput>;
  projectAllocations?: InputMaybe<ProjectAllocationOrderByRelationAggregateInput>;
  projectApproval?: InputMaybe<ProjectApprovalOrderByRelationAggregateInput>;
  projectDependency?: InputMaybe<ProjectDependencyOrderByRelationAggregateInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentOrderByRelationAggregateInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionOrderByRelationAggregateInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsOrderByRelationAggregateInput>;
  projectInterface?: InputMaybe<ProjectInterfaceOrderByRelationAggregateInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureOrderByRelationAggregateInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireOrderByRelationAggregateInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureOrderByRelationAggregateInput>;
  projectRole?: InputMaybe<ProjectRoleOrderByRelationAggregateInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryOrderByRelationAggregateInput>;
  projectStatus?: InputMaybe<ProjectStatusOrderByRelationAggregateInput>;
  pspMapping?: InputMaybe<PspMappingOrderByRelationAggregateInput>;
  remarks?: InputMaybe<RemarkOrderByRelationAggregateInput>;
  replacement?: InputMaybe<ReplacementOrderByRelationAggregateInput>;
  report?: InputMaybe<ReportOrderByRelationAggregateInput>;
  risk?: InputMaybe<RiskOrderByRelationAggregateInput>;
  topProjects?: InputMaybe<TopProjectsOrderByRelationAggregateInput>;
};

export enum MasterScalarFieldEnum {
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  DeletedAt = 'deletedAt',
  DeletedBy = 'deletedBy',
  Id = 'id'
}

export type MasterUpdateInput = {
  budgets?: InputMaybe<TargetedBudgetUpdateManyWithoutMasterNestedInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectUpdateManyWithoutProjectNestedInput>;
  contactHistory?: InputMaybe<ContactHistoryUpdateManyWithoutProjectNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  dashboardProject?: InputMaybe<DashboardProjectUpdateManyWithoutProjectNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<EmailHistoryUpdateManyWithoutProjectNestedInput>;
  employeeMaster?: InputMaybe<EmployeeMasterUpdateManyWithoutProjectNestedInput>;
  finances?: InputMaybe<FinanceUpdateManyWithoutProjectNestedInput>;
  goals?: InputMaybe<GoalsOnMasterUpdateManyWithoutProjectNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  leanixProject?: InputMaybe<LeanixMappingUpdateOneWithoutMasterNestedInput>;
  projectAllocations?: InputMaybe<ProjectAllocationUpdateManyWithoutProjectNestedInput>;
  projectApproval?: InputMaybe<ProjectApprovalUpdateManyWithoutProjectNestedInput>;
  projectDependency?: InputMaybe<ProjectDependencyUpdateManyWithoutProjectNestedInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentUpdateManyWithoutProjectNestedInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionUpdateManyWithoutMasterNestedInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsUpdateManyWithoutProjectNestedInput>;
  projectInterface?: InputMaybe<ProjectInterfaceUpdateManyWithoutProjectNestedInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureUpdateManyWithoutProjectNestedInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireUpdateManyWithoutProjectNestedInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureUpdateManyWithoutProjectNestedInput>;
  projectRole?: InputMaybe<ProjectRoleUpdateManyWithoutProjectNestedInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryUpdateManyWithoutProjectNestedInput>;
  projectStatus?: InputMaybe<ProjectStatusUpdateManyWithoutProjectNestedInput>;
  pspMapping?: InputMaybe<PspMappingUpdateManyWithoutMasterNestedInput>;
  remarks?: InputMaybe<RemarkUpdateManyWithoutProjectNestedInput>;
  replacement?: InputMaybe<ReplacementUpdateManyWithoutProjectNestedInput>;
  report?: InputMaybe<ReportUpdateManyWithoutProjectNestedInput>;
  risk?: InputMaybe<RiskUpdateManyWithoutProjectNestedInput>;
  topProjects?: InputMaybe<TopProjectsUpdateManyWithoutProjectNestedInput>;
};

export type MasterUpdateOneRequiredWithoutBudgetsNestedInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutBudgetsInput>;
  create?: InputMaybe<MasterCreateWithoutBudgetsInput>;
  update?: InputMaybe<MasterUpdateWithoutBudgetsInput>;
  upsert?: InputMaybe<MasterUpsertWithoutBudgetsInput>;
};

export type MasterUpdateOneRequiredWithoutBusinessProcessOnProjectNestedInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutBusinessProcessOnProjectInput>;
  create?: InputMaybe<MasterCreateWithoutBusinessProcessOnProjectInput>;
  update?: InputMaybe<MasterUpdateWithoutBusinessProcessOnProjectInput>;
  upsert?: InputMaybe<MasterUpsertWithoutBusinessProcessOnProjectInput>;
};

export type MasterUpdateOneRequiredWithoutContactHistoryNestedInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutContactHistoryInput>;
  create?: InputMaybe<MasterCreateWithoutContactHistoryInput>;
  update?: InputMaybe<MasterUpdateWithoutContactHistoryInput>;
  upsert?: InputMaybe<MasterUpsertWithoutContactHistoryInput>;
};

export type MasterUpdateOneRequiredWithoutDashboardProjectNestedInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutDashboardProjectInput>;
  create?: InputMaybe<MasterCreateWithoutDashboardProjectInput>;
  update?: InputMaybe<MasterUpdateWithoutDashboardProjectInput>;
  upsert?: InputMaybe<MasterUpsertWithoutDashboardProjectInput>;
};

export type MasterUpdateOneRequiredWithoutEmailNestedInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutEmailInput>;
  create?: InputMaybe<MasterCreateWithoutEmailInput>;
  update?: InputMaybe<MasterUpdateWithoutEmailInput>;
  upsert?: InputMaybe<MasterUpsertWithoutEmailInput>;
};

export type MasterUpdateOneRequiredWithoutEmployeeMasterNestedInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutEmployeeMasterInput>;
  create?: InputMaybe<MasterCreateWithoutEmployeeMasterInput>;
  update?: InputMaybe<MasterUpdateWithoutEmployeeMasterInput>;
  upsert?: InputMaybe<MasterUpsertWithoutEmployeeMasterInput>;
};

export type MasterUpdateOneRequiredWithoutFinancesNestedInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutFinancesInput>;
  create?: InputMaybe<MasterCreateWithoutFinancesInput>;
  update?: InputMaybe<MasterUpdateWithoutFinancesInput>;
  upsert?: InputMaybe<MasterUpsertWithoutFinancesInput>;
};

export type MasterUpdateOneRequiredWithoutGoalsNestedInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutGoalsInput>;
  create?: InputMaybe<MasterCreateWithoutGoalsInput>;
  update?: InputMaybe<MasterUpdateWithoutGoalsInput>;
  upsert?: InputMaybe<MasterUpsertWithoutGoalsInput>;
};

export type MasterUpdateOneRequiredWithoutProjectAllocationsNestedInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutProjectAllocationsInput>;
  create?: InputMaybe<MasterCreateWithoutProjectAllocationsInput>;
  update?: InputMaybe<MasterUpdateWithoutProjectAllocationsInput>;
  upsert?: InputMaybe<MasterUpsertWithoutProjectAllocationsInput>;
};

export type MasterUpdateOneRequiredWithoutProjectApprovalNestedInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutProjectApprovalInput>;
  create?: InputMaybe<MasterCreateWithoutProjectApprovalInput>;
  update?: InputMaybe<MasterUpdateWithoutProjectApprovalInput>;
  upsert?: InputMaybe<MasterUpsertWithoutProjectApprovalInput>;
};

export type MasterUpdateOneRequiredWithoutProjectDependencyNestedInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutProjectDependencyInput>;
  create?: InputMaybe<MasterCreateWithoutProjectDependencyInput>;
  update?: InputMaybe<MasterUpdateWithoutProjectDependencyInput>;
  upsert?: InputMaybe<MasterUpsertWithoutProjectDependencyInput>;
};

export type MasterUpdateOneRequiredWithoutProjectDescriptionCommentNestedInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutProjectDescriptionCommentInput>;
  create?: InputMaybe<MasterCreateWithoutProjectDescriptionCommentInput>;
  update?: InputMaybe<MasterUpdateWithoutProjectDescriptionCommentInput>;
  upsert?: InputMaybe<MasterUpsertWithoutProjectDescriptionCommentInput>;
};

export type MasterUpdateOneRequiredWithoutProjectDescriptionsNestedInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutProjectDescriptionsInput>;
  create?: InputMaybe<MasterCreateWithoutProjectDescriptionsInput>;
  update?: InputMaybe<MasterUpdateWithoutProjectDescriptionsInput>;
  upsert?: InputMaybe<MasterUpsertWithoutProjectDescriptionsInput>;
};

export type MasterUpdateOneRequiredWithoutProjectDocumentsNestedInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutProjectDocumentsInput>;
  create?: InputMaybe<MasterCreateWithoutProjectDocumentsInput>;
  update?: InputMaybe<MasterUpdateWithoutProjectDocumentsInput>;
  upsert?: InputMaybe<MasterUpsertWithoutProjectDocumentsInput>;
};

export type MasterUpdateOneRequiredWithoutProjectInterfaceNestedInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutProjectInterfaceInput>;
  create?: InputMaybe<MasterCreateWithoutProjectInterfaceInput>;
  update?: InputMaybe<MasterUpdateWithoutProjectInterfaceInput>;
  upsert?: InputMaybe<MasterUpsertWithoutProjectInterfaceInput>;
};

export type MasterUpdateOneRequiredWithoutProjectPhaseCaptureNestedInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutProjectPhaseCaptureInput>;
  create?: InputMaybe<MasterCreateWithoutProjectPhaseCaptureInput>;
  update?: InputMaybe<MasterUpdateWithoutProjectPhaseCaptureInput>;
  upsert?: InputMaybe<MasterUpsertWithoutProjectPhaseCaptureInput>;
};

export type MasterUpdateOneRequiredWithoutProjectQuestionnaireNestedInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutProjectQuestionnaireInput>;
  create?: InputMaybe<MasterCreateWithoutProjectQuestionnaireInput>;
  update?: InputMaybe<MasterUpdateWithoutProjectQuestionnaireInput>;
  upsert?: InputMaybe<MasterUpsertWithoutProjectQuestionnaireInput>;
};

export type MasterUpdateOneRequiredWithoutProjectResourceCaptureNestedInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutProjectResourceCaptureInput>;
  create?: InputMaybe<MasterCreateWithoutProjectResourceCaptureInput>;
  update?: InputMaybe<MasterUpdateWithoutProjectResourceCaptureInput>;
  upsert?: InputMaybe<MasterUpsertWithoutProjectResourceCaptureInput>;
};

export type MasterUpdateOneRequiredWithoutProjectRoleNestedInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutProjectRoleInput>;
  create?: InputMaybe<MasterCreateWithoutProjectRoleInput>;
  update?: InputMaybe<MasterUpdateWithoutProjectRoleInput>;
  upsert?: InputMaybe<MasterUpsertWithoutProjectRoleInput>;
};

export type MasterUpdateOneRequiredWithoutProjectShortHistoryNestedInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutProjectShortHistoryInput>;
  create?: InputMaybe<MasterCreateWithoutProjectShortHistoryInput>;
  update?: InputMaybe<MasterUpdateWithoutProjectShortHistoryInput>;
  upsert?: InputMaybe<MasterUpsertWithoutProjectShortHistoryInput>;
};

export type MasterUpdateOneRequiredWithoutProjectStatusNestedInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutProjectStatusInput>;
  create?: InputMaybe<MasterCreateWithoutProjectStatusInput>;
  update?: InputMaybe<MasterUpdateWithoutProjectStatusInput>;
  upsert?: InputMaybe<MasterUpsertWithoutProjectStatusInput>;
};

export type MasterUpdateOneRequiredWithoutReplacementNestedInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutReplacementInput>;
  create?: InputMaybe<MasterCreateWithoutReplacementInput>;
  update?: InputMaybe<MasterUpdateWithoutReplacementInput>;
  upsert?: InputMaybe<MasterUpsertWithoutReplacementInput>;
};

export type MasterUpdateOneRequiredWithoutReportNestedInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutReportInput>;
  create?: InputMaybe<MasterCreateWithoutReportInput>;
  update?: InputMaybe<MasterUpdateWithoutReportInput>;
  upsert?: InputMaybe<MasterUpsertWithoutReportInput>;
};

export type MasterUpdateOneRequiredWithoutRiskNestedInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutRiskInput>;
  create?: InputMaybe<MasterCreateWithoutRiskInput>;
  update?: InputMaybe<MasterUpdateWithoutRiskInput>;
  upsert?: InputMaybe<MasterUpsertWithoutRiskInput>;
};

export type MasterUpdateOneRequiredWithoutTopProjectsNestedInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutTopProjectsInput>;
  create?: InputMaybe<MasterCreateWithoutTopProjectsInput>;
  update?: InputMaybe<MasterUpdateWithoutTopProjectsInput>;
  upsert?: InputMaybe<MasterUpsertWithoutTopProjectsInput>;
};

export type MasterUpdateOneWithoutLeanixProjectNestedInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutLeanixProjectInput>;
  create?: InputMaybe<MasterCreateWithoutLeanixProjectInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<MasterUpdateWithoutLeanixProjectInput>;
  upsert?: InputMaybe<MasterUpsertWithoutLeanixProjectInput>;
};

export type MasterUpdateOneWithoutPspMappingNestedInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutPspMappingInput>;
  create?: InputMaybe<MasterCreateWithoutPspMappingInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<MasterUpdateWithoutPspMappingInput>;
  upsert?: InputMaybe<MasterUpsertWithoutPspMappingInput>;
};

export type MasterUpdateOneWithoutRemarksNestedInput = {
  connect?: InputMaybe<MasterWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MasterCreateOrConnectWithoutRemarksInput>;
  create?: InputMaybe<MasterCreateWithoutRemarksInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<MasterUpdateWithoutRemarksInput>;
  upsert?: InputMaybe<MasterUpsertWithoutRemarksInput>;
};

export type MasterUpdateWithoutBudgetsInput = {
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectUpdateManyWithoutProjectNestedInput>;
  contactHistory?: InputMaybe<ContactHistoryUpdateManyWithoutProjectNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  dashboardProject?: InputMaybe<DashboardProjectUpdateManyWithoutProjectNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<EmailHistoryUpdateManyWithoutProjectNestedInput>;
  employeeMaster?: InputMaybe<EmployeeMasterUpdateManyWithoutProjectNestedInput>;
  finances?: InputMaybe<FinanceUpdateManyWithoutProjectNestedInput>;
  goals?: InputMaybe<GoalsOnMasterUpdateManyWithoutProjectNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  leanixProject?: InputMaybe<LeanixMappingUpdateOneWithoutMasterNestedInput>;
  projectAllocations?: InputMaybe<ProjectAllocationUpdateManyWithoutProjectNestedInput>;
  projectApproval?: InputMaybe<ProjectApprovalUpdateManyWithoutProjectNestedInput>;
  projectDependency?: InputMaybe<ProjectDependencyUpdateManyWithoutProjectNestedInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentUpdateManyWithoutProjectNestedInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionUpdateManyWithoutMasterNestedInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsUpdateManyWithoutProjectNestedInput>;
  projectInterface?: InputMaybe<ProjectInterfaceUpdateManyWithoutProjectNestedInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureUpdateManyWithoutProjectNestedInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireUpdateManyWithoutProjectNestedInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureUpdateManyWithoutProjectNestedInput>;
  projectRole?: InputMaybe<ProjectRoleUpdateManyWithoutProjectNestedInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryUpdateManyWithoutProjectNestedInput>;
  projectStatus?: InputMaybe<ProjectStatusUpdateManyWithoutProjectNestedInput>;
  pspMapping?: InputMaybe<PspMappingUpdateManyWithoutMasterNestedInput>;
  remarks?: InputMaybe<RemarkUpdateManyWithoutProjectNestedInput>;
  replacement?: InputMaybe<ReplacementUpdateManyWithoutProjectNestedInput>;
  report?: InputMaybe<ReportUpdateManyWithoutProjectNestedInput>;
  risk?: InputMaybe<RiskUpdateManyWithoutProjectNestedInput>;
  topProjects?: InputMaybe<TopProjectsUpdateManyWithoutProjectNestedInput>;
};

export type MasterUpdateWithoutBusinessProcessOnProjectInput = {
  budgets?: InputMaybe<TargetedBudgetUpdateManyWithoutMasterNestedInput>;
  contactHistory?: InputMaybe<ContactHistoryUpdateManyWithoutProjectNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  dashboardProject?: InputMaybe<DashboardProjectUpdateManyWithoutProjectNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<EmailHistoryUpdateManyWithoutProjectNestedInput>;
  employeeMaster?: InputMaybe<EmployeeMasterUpdateManyWithoutProjectNestedInput>;
  finances?: InputMaybe<FinanceUpdateManyWithoutProjectNestedInput>;
  goals?: InputMaybe<GoalsOnMasterUpdateManyWithoutProjectNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  leanixProject?: InputMaybe<LeanixMappingUpdateOneWithoutMasterNestedInput>;
  projectAllocations?: InputMaybe<ProjectAllocationUpdateManyWithoutProjectNestedInput>;
  projectApproval?: InputMaybe<ProjectApprovalUpdateManyWithoutProjectNestedInput>;
  projectDependency?: InputMaybe<ProjectDependencyUpdateManyWithoutProjectNestedInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentUpdateManyWithoutProjectNestedInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionUpdateManyWithoutMasterNestedInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsUpdateManyWithoutProjectNestedInput>;
  projectInterface?: InputMaybe<ProjectInterfaceUpdateManyWithoutProjectNestedInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureUpdateManyWithoutProjectNestedInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireUpdateManyWithoutProjectNestedInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureUpdateManyWithoutProjectNestedInput>;
  projectRole?: InputMaybe<ProjectRoleUpdateManyWithoutProjectNestedInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryUpdateManyWithoutProjectNestedInput>;
  projectStatus?: InputMaybe<ProjectStatusUpdateManyWithoutProjectNestedInput>;
  pspMapping?: InputMaybe<PspMappingUpdateManyWithoutMasterNestedInput>;
  remarks?: InputMaybe<RemarkUpdateManyWithoutProjectNestedInput>;
  replacement?: InputMaybe<ReplacementUpdateManyWithoutProjectNestedInput>;
  report?: InputMaybe<ReportUpdateManyWithoutProjectNestedInput>;
  risk?: InputMaybe<RiskUpdateManyWithoutProjectNestedInput>;
  topProjects?: InputMaybe<TopProjectsUpdateManyWithoutProjectNestedInput>;
};

export type MasterUpdateWithoutContactHistoryInput = {
  budgets?: InputMaybe<TargetedBudgetUpdateManyWithoutMasterNestedInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectUpdateManyWithoutProjectNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  dashboardProject?: InputMaybe<DashboardProjectUpdateManyWithoutProjectNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<EmailHistoryUpdateManyWithoutProjectNestedInput>;
  employeeMaster?: InputMaybe<EmployeeMasterUpdateManyWithoutProjectNestedInput>;
  finances?: InputMaybe<FinanceUpdateManyWithoutProjectNestedInput>;
  goals?: InputMaybe<GoalsOnMasterUpdateManyWithoutProjectNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  leanixProject?: InputMaybe<LeanixMappingUpdateOneWithoutMasterNestedInput>;
  projectAllocations?: InputMaybe<ProjectAllocationUpdateManyWithoutProjectNestedInput>;
  projectApproval?: InputMaybe<ProjectApprovalUpdateManyWithoutProjectNestedInput>;
  projectDependency?: InputMaybe<ProjectDependencyUpdateManyWithoutProjectNestedInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentUpdateManyWithoutProjectNestedInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionUpdateManyWithoutMasterNestedInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsUpdateManyWithoutProjectNestedInput>;
  projectInterface?: InputMaybe<ProjectInterfaceUpdateManyWithoutProjectNestedInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureUpdateManyWithoutProjectNestedInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireUpdateManyWithoutProjectNestedInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureUpdateManyWithoutProjectNestedInput>;
  projectRole?: InputMaybe<ProjectRoleUpdateManyWithoutProjectNestedInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryUpdateManyWithoutProjectNestedInput>;
  projectStatus?: InputMaybe<ProjectStatusUpdateManyWithoutProjectNestedInput>;
  pspMapping?: InputMaybe<PspMappingUpdateManyWithoutMasterNestedInput>;
  remarks?: InputMaybe<RemarkUpdateManyWithoutProjectNestedInput>;
  replacement?: InputMaybe<ReplacementUpdateManyWithoutProjectNestedInput>;
  report?: InputMaybe<ReportUpdateManyWithoutProjectNestedInput>;
  risk?: InputMaybe<RiskUpdateManyWithoutProjectNestedInput>;
  topProjects?: InputMaybe<TopProjectsUpdateManyWithoutProjectNestedInput>;
};

export type MasterUpdateWithoutDashboardProjectInput = {
  budgets?: InputMaybe<TargetedBudgetUpdateManyWithoutMasterNestedInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectUpdateManyWithoutProjectNestedInput>;
  contactHistory?: InputMaybe<ContactHistoryUpdateManyWithoutProjectNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<EmailHistoryUpdateManyWithoutProjectNestedInput>;
  employeeMaster?: InputMaybe<EmployeeMasterUpdateManyWithoutProjectNestedInput>;
  finances?: InputMaybe<FinanceUpdateManyWithoutProjectNestedInput>;
  goals?: InputMaybe<GoalsOnMasterUpdateManyWithoutProjectNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  leanixProject?: InputMaybe<LeanixMappingUpdateOneWithoutMasterNestedInput>;
  projectAllocations?: InputMaybe<ProjectAllocationUpdateManyWithoutProjectNestedInput>;
  projectApproval?: InputMaybe<ProjectApprovalUpdateManyWithoutProjectNestedInput>;
  projectDependency?: InputMaybe<ProjectDependencyUpdateManyWithoutProjectNestedInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentUpdateManyWithoutProjectNestedInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionUpdateManyWithoutMasterNestedInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsUpdateManyWithoutProjectNestedInput>;
  projectInterface?: InputMaybe<ProjectInterfaceUpdateManyWithoutProjectNestedInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureUpdateManyWithoutProjectNestedInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireUpdateManyWithoutProjectNestedInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureUpdateManyWithoutProjectNestedInput>;
  projectRole?: InputMaybe<ProjectRoleUpdateManyWithoutProjectNestedInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryUpdateManyWithoutProjectNestedInput>;
  projectStatus?: InputMaybe<ProjectStatusUpdateManyWithoutProjectNestedInput>;
  pspMapping?: InputMaybe<PspMappingUpdateManyWithoutMasterNestedInput>;
  remarks?: InputMaybe<RemarkUpdateManyWithoutProjectNestedInput>;
  replacement?: InputMaybe<ReplacementUpdateManyWithoutProjectNestedInput>;
  report?: InputMaybe<ReportUpdateManyWithoutProjectNestedInput>;
  risk?: InputMaybe<RiskUpdateManyWithoutProjectNestedInput>;
  topProjects?: InputMaybe<TopProjectsUpdateManyWithoutProjectNestedInput>;
};

export type MasterUpdateWithoutEmailInput = {
  budgets?: InputMaybe<TargetedBudgetUpdateManyWithoutMasterNestedInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectUpdateManyWithoutProjectNestedInput>;
  contactHistory?: InputMaybe<ContactHistoryUpdateManyWithoutProjectNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  dashboardProject?: InputMaybe<DashboardProjectUpdateManyWithoutProjectNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employeeMaster?: InputMaybe<EmployeeMasterUpdateManyWithoutProjectNestedInput>;
  finances?: InputMaybe<FinanceUpdateManyWithoutProjectNestedInput>;
  goals?: InputMaybe<GoalsOnMasterUpdateManyWithoutProjectNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  leanixProject?: InputMaybe<LeanixMappingUpdateOneWithoutMasterNestedInput>;
  projectAllocations?: InputMaybe<ProjectAllocationUpdateManyWithoutProjectNestedInput>;
  projectApproval?: InputMaybe<ProjectApprovalUpdateManyWithoutProjectNestedInput>;
  projectDependency?: InputMaybe<ProjectDependencyUpdateManyWithoutProjectNestedInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentUpdateManyWithoutProjectNestedInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionUpdateManyWithoutMasterNestedInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsUpdateManyWithoutProjectNestedInput>;
  projectInterface?: InputMaybe<ProjectInterfaceUpdateManyWithoutProjectNestedInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureUpdateManyWithoutProjectNestedInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireUpdateManyWithoutProjectNestedInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureUpdateManyWithoutProjectNestedInput>;
  projectRole?: InputMaybe<ProjectRoleUpdateManyWithoutProjectNestedInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryUpdateManyWithoutProjectNestedInput>;
  projectStatus?: InputMaybe<ProjectStatusUpdateManyWithoutProjectNestedInput>;
  pspMapping?: InputMaybe<PspMappingUpdateManyWithoutMasterNestedInput>;
  remarks?: InputMaybe<RemarkUpdateManyWithoutProjectNestedInput>;
  replacement?: InputMaybe<ReplacementUpdateManyWithoutProjectNestedInput>;
  report?: InputMaybe<ReportUpdateManyWithoutProjectNestedInput>;
  risk?: InputMaybe<RiskUpdateManyWithoutProjectNestedInput>;
  topProjects?: InputMaybe<TopProjectsUpdateManyWithoutProjectNestedInput>;
};

export type MasterUpdateWithoutEmployeeMasterInput = {
  budgets?: InputMaybe<TargetedBudgetUpdateManyWithoutMasterNestedInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectUpdateManyWithoutProjectNestedInput>;
  contactHistory?: InputMaybe<ContactHistoryUpdateManyWithoutProjectNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  dashboardProject?: InputMaybe<DashboardProjectUpdateManyWithoutProjectNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<EmailHistoryUpdateManyWithoutProjectNestedInput>;
  finances?: InputMaybe<FinanceUpdateManyWithoutProjectNestedInput>;
  goals?: InputMaybe<GoalsOnMasterUpdateManyWithoutProjectNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  leanixProject?: InputMaybe<LeanixMappingUpdateOneWithoutMasterNestedInput>;
  projectAllocations?: InputMaybe<ProjectAllocationUpdateManyWithoutProjectNestedInput>;
  projectApproval?: InputMaybe<ProjectApprovalUpdateManyWithoutProjectNestedInput>;
  projectDependency?: InputMaybe<ProjectDependencyUpdateManyWithoutProjectNestedInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentUpdateManyWithoutProjectNestedInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionUpdateManyWithoutMasterNestedInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsUpdateManyWithoutProjectNestedInput>;
  projectInterface?: InputMaybe<ProjectInterfaceUpdateManyWithoutProjectNestedInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureUpdateManyWithoutProjectNestedInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireUpdateManyWithoutProjectNestedInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureUpdateManyWithoutProjectNestedInput>;
  projectRole?: InputMaybe<ProjectRoleUpdateManyWithoutProjectNestedInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryUpdateManyWithoutProjectNestedInput>;
  projectStatus?: InputMaybe<ProjectStatusUpdateManyWithoutProjectNestedInput>;
  pspMapping?: InputMaybe<PspMappingUpdateManyWithoutMasterNestedInput>;
  remarks?: InputMaybe<RemarkUpdateManyWithoutProjectNestedInput>;
  replacement?: InputMaybe<ReplacementUpdateManyWithoutProjectNestedInput>;
  report?: InputMaybe<ReportUpdateManyWithoutProjectNestedInput>;
  risk?: InputMaybe<RiskUpdateManyWithoutProjectNestedInput>;
  topProjects?: InputMaybe<TopProjectsUpdateManyWithoutProjectNestedInput>;
};

export type MasterUpdateWithoutFinancesInput = {
  budgets?: InputMaybe<TargetedBudgetUpdateManyWithoutMasterNestedInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectUpdateManyWithoutProjectNestedInput>;
  contactHistory?: InputMaybe<ContactHistoryUpdateManyWithoutProjectNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  dashboardProject?: InputMaybe<DashboardProjectUpdateManyWithoutProjectNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<EmailHistoryUpdateManyWithoutProjectNestedInput>;
  employeeMaster?: InputMaybe<EmployeeMasterUpdateManyWithoutProjectNestedInput>;
  goals?: InputMaybe<GoalsOnMasterUpdateManyWithoutProjectNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  leanixProject?: InputMaybe<LeanixMappingUpdateOneWithoutMasterNestedInput>;
  projectAllocations?: InputMaybe<ProjectAllocationUpdateManyWithoutProjectNestedInput>;
  projectApproval?: InputMaybe<ProjectApprovalUpdateManyWithoutProjectNestedInput>;
  projectDependency?: InputMaybe<ProjectDependencyUpdateManyWithoutProjectNestedInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentUpdateManyWithoutProjectNestedInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionUpdateManyWithoutMasterNestedInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsUpdateManyWithoutProjectNestedInput>;
  projectInterface?: InputMaybe<ProjectInterfaceUpdateManyWithoutProjectNestedInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureUpdateManyWithoutProjectNestedInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireUpdateManyWithoutProjectNestedInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureUpdateManyWithoutProjectNestedInput>;
  projectRole?: InputMaybe<ProjectRoleUpdateManyWithoutProjectNestedInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryUpdateManyWithoutProjectNestedInput>;
  projectStatus?: InputMaybe<ProjectStatusUpdateManyWithoutProjectNestedInput>;
  pspMapping?: InputMaybe<PspMappingUpdateManyWithoutMasterNestedInput>;
  remarks?: InputMaybe<RemarkUpdateManyWithoutProjectNestedInput>;
  replacement?: InputMaybe<ReplacementUpdateManyWithoutProjectNestedInput>;
  report?: InputMaybe<ReportUpdateManyWithoutProjectNestedInput>;
  risk?: InputMaybe<RiskUpdateManyWithoutProjectNestedInput>;
  topProjects?: InputMaybe<TopProjectsUpdateManyWithoutProjectNestedInput>;
};

export type MasterUpdateWithoutGoalsInput = {
  budgets?: InputMaybe<TargetedBudgetUpdateManyWithoutMasterNestedInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectUpdateManyWithoutProjectNestedInput>;
  contactHistory?: InputMaybe<ContactHistoryUpdateManyWithoutProjectNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  dashboardProject?: InputMaybe<DashboardProjectUpdateManyWithoutProjectNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<EmailHistoryUpdateManyWithoutProjectNestedInput>;
  employeeMaster?: InputMaybe<EmployeeMasterUpdateManyWithoutProjectNestedInput>;
  finances?: InputMaybe<FinanceUpdateManyWithoutProjectNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  leanixProject?: InputMaybe<LeanixMappingUpdateOneWithoutMasterNestedInput>;
  projectAllocations?: InputMaybe<ProjectAllocationUpdateManyWithoutProjectNestedInput>;
  projectApproval?: InputMaybe<ProjectApprovalUpdateManyWithoutProjectNestedInput>;
  projectDependency?: InputMaybe<ProjectDependencyUpdateManyWithoutProjectNestedInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentUpdateManyWithoutProjectNestedInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionUpdateManyWithoutMasterNestedInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsUpdateManyWithoutProjectNestedInput>;
  projectInterface?: InputMaybe<ProjectInterfaceUpdateManyWithoutProjectNestedInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureUpdateManyWithoutProjectNestedInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireUpdateManyWithoutProjectNestedInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureUpdateManyWithoutProjectNestedInput>;
  projectRole?: InputMaybe<ProjectRoleUpdateManyWithoutProjectNestedInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryUpdateManyWithoutProjectNestedInput>;
  projectStatus?: InputMaybe<ProjectStatusUpdateManyWithoutProjectNestedInput>;
  pspMapping?: InputMaybe<PspMappingUpdateManyWithoutMasterNestedInput>;
  remarks?: InputMaybe<RemarkUpdateManyWithoutProjectNestedInput>;
  replacement?: InputMaybe<ReplacementUpdateManyWithoutProjectNestedInput>;
  report?: InputMaybe<ReportUpdateManyWithoutProjectNestedInput>;
  risk?: InputMaybe<RiskUpdateManyWithoutProjectNestedInput>;
  topProjects?: InputMaybe<TopProjectsUpdateManyWithoutProjectNestedInput>;
};

export type MasterUpdateWithoutLeanixProjectInput = {
  budgets?: InputMaybe<TargetedBudgetUpdateManyWithoutMasterNestedInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectUpdateManyWithoutProjectNestedInput>;
  contactHistory?: InputMaybe<ContactHistoryUpdateManyWithoutProjectNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  dashboardProject?: InputMaybe<DashboardProjectUpdateManyWithoutProjectNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<EmailHistoryUpdateManyWithoutProjectNestedInput>;
  employeeMaster?: InputMaybe<EmployeeMasterUpdateManyWithoutProjectNestedInput>;
  finances?: InputMaybe<FinanceUpdateManyWithoutProjectNestedInput>;
  goals?: InputMaybe<GoalsOnMasterUpdateManyWithoutProjectNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  projectAllocations?: InputMaybe<ProjectAllocationUpdateManyWithoutProjectNestedInput>;
  projectApproval?: InputMaybe<ProjectApprovalUpdateManyWithoutProjectNestedInput>;
  projectDependency?: InputMaybe<ProjectDependencyUpdateManyWithoutProjectNestedInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentUpdateManyWithoutProjectNestedInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionUpdateManyWithoutMasterNestedInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsUpdateManyWithoutProjectNestedInput>;
  projectInterface?: InputMaybe<ProjectInterfaceUpdateManyWithoutProjectNestedInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureUpdateManyWithoutProjectNestedInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireUpdateManyWithoutProjectNestedInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureUpdateManyWithoutProjectNestedInput>;
  projectRole?: InputMaybe<ProjectRoleUpdateManyWithoutProjectNestedInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryUpdateManyWithoutProjectNestedInput>;
  projectStatus?: InputMaybe<ProjectStatusUpdateManyWithoutProjectNestedInput>;
  pspMapping?: InputMaybe<PspMappingUpdateManyWithoutMasterNestedInput>;
  remarks?: InputMaybe<RemarkUpdateManyWithoutProjectNestedInput>;
  replacement?: InputMaybe<ReplacementUpdateManyWithoutProjectNestedInput>;
  report?: InputMaybe<ReportUpdateManyWithoutProjectNestedInput>;
  risk?: InputMaybe<RiskUpdateManyWithoutProjectNestedInput>;
  topProjects?: InputMaybe<TopProjectsUpdateManyWithoutProjectNestedInput>;
};

export type MasterUpdateWithoutProjectAllocationsInput = {
  budgets?: InputMaybe<TargetedBudgetUpdateManyWithoutMasterNestedInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectUpdateManyWithoutProjectNestedInput>;
  contactHistory?: InputMaybe<ContactHistoryUpdateManyWithoutProjectNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  dashboardProject?: InputMaybe<DashboardProjectUpdateManyWithoutProjectNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<EmailHistoryUpdateManyWithoutProjectNestedInput>;
  employeeMaster?: InputMaybe<EmployeeMasterUpdateManyWithoutProjectNestedInput>;
  finances?: InputMaybe<FinanceUpdateManyWithoutProjectNestedInput>;
  goals?: InputMaybe<GoalsOnMasterUpdateManyWithoutProjectNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  leanixProject?: InputMaybe<LeanixMappingUpdateOneWithoutMasterNestedInput>;
  projectApproval?: InputMaybe<ProjectApprovalUpdateManyWithoutProjectNestedInput>;
  projectDependency?: InputMaybe<ProjectDependencyUpdateManyWithoutProjectNestedInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentUpdateManyWithoutProjectNestedInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionUpdateManyWithoutMasterNestedInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsUpdateManyWithoutProjectNestedInput>;
  projectInterface?: InputMaybe<ProjectInterfaceUpdateManyWithoutProjectNestedInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureUpdateManyWithoutProjectNestedInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireUpdateManyWithoutProjectNestedInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureUpdateManyWithoutProjectNestedInput>;
  projectRole?: InputMaybe<ProjectRoleUpdateManyWithoutProjectNestedInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryUpdateManyWithoutProjectNestedInput>;
  projectStatus?: InputMaybe<ProjectStatusUpdateManyWithoutProjectNestedInput>;
  pspMapping?: InputMaybe<PspMappingUpdateManyWithoutMasterNestedInput>;
  remarks?: InputMaybe<RemarkUpdateManyWithoutProjectNestedInput>;
  replacement?: InputMaybe<ReplacementUpdateManyWithoutProjectNestedInput>;
  report?: InputMaybe<ReportUpdateManyWithoutProjectNestedInput>;
  risk?: InputMaybe<RiskUpdateManyWithoutProjectNestedInput>;
  topProjects?: InputMaybe<TopProjectsUpdateManyWithoutProjectNestedInput>;
};

export type MasterUpdateWithoutProjectApprovalInput = {
  budgets?: InputMaybe<TargetedBudgetUpdateManyWithoutMasterNestedInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectUpdateManyWithoutProjectNestedInput>;
  contactHistory?: InputMaybe<ContactHistoryUpdateManyWithoutProjectNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  dashboardProject?: InputMaybe<DashboardProjectUpdateManyWithoutProjectNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<EmailHistoryUpdateManyWithoutProjectNestedInput>;
  employeeMaster?: InputMaybe<EmployeeMasterUpdateManyWithoutProjectNestedInput>;
  finances?: InputMaybe<FinanceUpdateManyWithoutProjectNestedInput>;
  goals?: InputMaybe<GoalsOnMasterUpdateManyWithoutProjectNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  leanixProject?: InputMaybe<LeanixMappingUpdateOneWithoutMasterNestedInput>;
  projectAllocations?: InputMaybe<ProjectAllocationUpdateManyWithoutProjectNestedInput>;
  projectDependency?: InputMaybe<ProjectDependencyUpdateManyWithoutProjectNestedInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentUpdateManyWithoutProjectNestedInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionUpdateManyWithoutMasterNestedInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsUpdateManyWithoutProjectNestedInput>;
  projectInterface?: InputMaybe<ProjectInterfaceUpdateManyWithoutProjectNestedInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureUpdateManyWithoutProjectNestedInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireUpdateManyWithoutProjectNestedInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureUpdateManyWithoutProjectNestedInput>;
  projectRole?: InputMaybe<ProjectRoleUpdateManyWithoutProjectNestedInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryUpdateManyWithoutProjectNestedInput>;
  projectStatus?: InputMaybe<ProjectStatusUpdateManyWithoutProjectNestedInput>;
  pspMapping?: InputMaybe<PspMappingUpdateManyWithoutMasterNestedInput>;
  remarks?: InputMaybe<RemarkUpdateManyWithoutProjectNestedInput>;
  replacement?: InputMaybe<ReplacementUpdateManyWithoutProjectNestedInput>;
  report?: InputMaybe<ReportUpdateManyWithoutProjectNestedInput>;
  risk?: InputMaybe<RiskUpdateManyWithoutProjectNestedInput>;
  topProjects?: InputMaybe<TopProjectsUpdateManyWithoutProjectNestedInput>;
};

export type MasterUpdateWithoutProjectDependencyInput = {
  budgets?: InputMaybe<TargetedBudgetUpdateManyWithoutMasterNestedInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectUpdateManyWithoutProjectNestedInput>;
  contactHistory?: InputMaybe<ContactHistoryUpdateManyWithoutProjectNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  dashboardProject?: InputMaybe<DashboardProjectUpdateManyWithoutProjectNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<EmailHistoryUpdateManyWithoutProjectNestedInput>;
  employeeMaster?: InputMaybe<EmployeeMasterUpdateManyWithoutProjectNestedInput>;
  finances?: InputMaybe<FinanceUpdateManyWithoutProjectNestedInput>;
  goals?: InputMaybe<GoalsOnMasterUpdateManyWithoutProjectNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  leanixProject?: InputMaybe<LeanixMappingUpdateOneWithoutMasterNestedInput>;
  projectAllocations?: InputMaybe<ProjectAllocationUpdateManyWithoutProjectNestedInput>;
  projectApproval?: InputMaybe<ProjectApprovalUpdateManyWithoutProjectNestedInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentUpdateManyWithoutProjectNestedInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionUpdateManyWithoutMasterNestedInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsUpdateManyWithoutProjectNestedInput>;
  projectInterface?: InputMaybe<ProjectInterfaceUpdateManyWithoutProjectNestedInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureUpdateManyWithoutProjectNestedInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireUpdateManyWithoutProjectNestedInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureUpdateManyWithoutProjectNestedInput>;
  projectRole?: InputMaybe<ProjectRoleUpdateManyWithoutProjectNestedInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryUpdateManyWithoutProjectNestedInput>;
  projectStatus?: InputMaybe<ProjectStatusUpdateManyWithoutProjectNestedInput>;
  pspMapping?: InputMaybe<PspMappingUpdateManyWithoutMasterNestedInput>;
  remarks?: InputMaybe<RemarkUpdateManyWithoutProjectNestedInput>;
  replacement?: InputMaybe<ReplacementUpdateManyWithoutProjectNestedInput>;
  report?: InputMaybe<ReportUpdateManyWithoutProjectNestedInput>;
  risk?: InputMaybe<RiskUpdateManyWithoutProjectNestedInput>;
  topProjects?: InputMaybe<TopProjectsUpdateManyWithoutProjectNestedInput>;
};

export type MasterUpdateWithoutProjectDescriptionCommentInput = {
  budgets?: InputMaybe<TargetedBudgetUpdateManyWithoutMasterNestedInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectUpdateManyWithoutProjectNestedInput>;
  contactHistory?: InputMaybe<ContactHistoryUpdateManyWithoutProjectNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  dashboardProject?: InputMaybe<DashboardProjectUpdateManyWithoutProjectNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<EmailHistoryUpdateManyWithoutProjectNestedInput>;
  employeeMaster?: InputMaybe<EmployeeMasterUpdateManyWithoutProjectNestedInput>;
  finances?: InputMaybe<FinanceUpdateManyWithoutProjectNestedInput>;
  goals?: InputMaybe<GoalsOnMasterUpdateManyWithoutProjectNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  leanixProject?: InputMaybe<LeanixMappingUpdateOneWithoutMasterNestedInput>;
  projectAllocations?: InputMaybe<ProjectAllocationUpdateManyWithoutProjectNestedInput>;
  projectApproval?: InputMaybe<ProjectApprovalUpdateManyWithoutProjectNestedInput>;
  projectDependency?: InputMaybe<ProjectDependencyUpdateManyWithoutProjectNestedInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionUpdateManyWithoutMasterNestedInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsUpdateManyWithoutProjectNestedInput>;
  projectInterface?: InputMaybe<ProjectInterfaceUpdateManyWithoutProjectNestedInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureUpdateManyWithoutProjectNestedInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireUpdateManyWithoutProjectNestedInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureUpdateManyWithoutProjectNestedInput>;
  projectRole?: InputMaybe<ProjectRoleUpdateManyWithoutProjectNestedInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryUpdateManyWithoutProjectNestedInput>;
  projectStatus?: InputMaybe<ProjectStatusUpdateManyWithoutProjectNestedInput>;
  pspMapping?: InputMaybe<PspMappingUpdateManyWithoutMasterNestedInput>;
  remarks?: InputMaybe<RemarkUpdateManyWithoutProjectNestedInput>;
  replacement?: InputMaybe<ReplacementUpdateManyWithoutProjectNestedInput>;
  report?: InputMaybe<ReportUpdateManyWithoutProjectNestedInput>;
  risk?: InputMaybe<RiskUpdateManyWithoutProjectNestedInput>;
  topProjects?: InputMaybe<TopProjectsUpdateManyWithoutProjectNestedInput>;
};

export type MasterUpdateWithoutProjectDescriptionsInput = {
  budgets?: InputMaybe<TargetedBudgetUpdateManyWithoutMasterNestedInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectUpdateManyWithoutProjectNestedInput>;
  contactHistory?: InputMaybe<ContactHistoryUpdateManyWithoutProjectNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  dashboardProject?: InputMaybe<DashboardProjectUpdateManyWithoutProjectNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<EmailHistoryUpdateManyWithoutProjectNestedInput>;
  employeeMaster?: InputMaybe<EmployeeMasterUpdateManyWithoutProjectNestedInput>;
  finances?: InputMaybe<FinanceUpdateManyWithoutProjectNestedInput>;
  goals?: InputMaybe<GoalsOnMasterUpdateManyWithoutProjectNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  leanixProject?: InputMaybe<LeanixMappingUpdateOneWithoutMasterNestedInput>;
  projectAllocations?: InputMaybe<ProjectAllocationUpdateManyWithoutProjectNestedInput>;
  projectApproval?: InputMaybe<ProjectApprovalUpdateManyWithoutProjectNestedInput>;
  projectDependency?: InputMaybe<ProjectDependencyUpdateManyWithoutProjectNestedInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentUpdateManyWithoutProjectNestedInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsUpdateManyWithoutProjectNestedInput>;
  projectInterface?: InputMaybe<ProjectInterfaceUpdateManyWithoutProjectNestedInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureUpdateManyWithoutProjectNestedInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireUpdateManyWithoutProjectNestedInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureUpdateManyWithoutProjectNestedInput>;
  projectRole?: InputMaybe<ProjectRoleUpdateManyWithoutProjectNestedInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryUpdateManyWithoutProjectNestedInput>;
  projectStatus?: InputMaybe<ProjectStatusUpdateManyWithoutProjectNestedInput>;
  pspMapping?: InputMaybe<PspMappingUpdateManyWithoutMasterNestedInput>;
  remarks?: InputMaybe<RemarkUpdateManyWithoutProjectNestedInput>;
  replacement?: InputMaybe<ReplacementUpdateManyWithoutProjectNestedInput>;
  report?: InputMaybe<ReportUpdateManyWithoutProjectNestedInput>;
  risk?: InputMaybe<RiskUpdateManyWithoutProjectNestedInput>;
  topProjects?: InputMaybe<TopProjectsUpdateManyWithoutProjectNestedInput>;
};

export type MasterUpdateWithoutProjectDocumentsInput = {
  budgets?: InputMaybe<TargetedBudgetUpdateManyWithoutMasterNestedInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectUpdateManyWithoutProjectNestedInput>;
  contactHistory?: InputMaybe<ContactHistoryUpdateManyWithoutProjectNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  dashboardProject?: InputMaybe<DashboardProjectUpdateManyWithoutProjectNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<EmailHistoryUpdateManyWithoutProjectNestedInput>;
  employeeMaster?: InputMaybe<EmployeeMasterUpdateManyWithoutProjectNestedInput>;
  finances?: InputMaybe<FinanceUpdateManyWithoutProjectNestedInput>;
  goals?: InputMaybe<GoalsOnMasterUpdateManyWithoutProjectNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  leanixProject?: InputMaybe<LeanixMappingUpdateOneWithoutMasterNestedInput>;
  projectAllocations?: InputMaybe<ProjectAllocationUpdateManyWithoutProjectNestedInput>;
  projectApproval?: InputMaybe<ProjectApprovalUpdateManyWithoutProjectNestedInput>;
  projectDependency?: InputMaybe<ProjectDependencyUpdateManyWithoutProjectNestedInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentUpdateManyWithoutProjectNestedInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionUpdateManyWithoutMasterNestedInput>;
  projectInterface?: InputMaybe<ProjectInterfaceUpdateManyWithoutProjectNestedInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureUpdateManyWithoutProjectNestedInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireUpdateManyWithoutProjectNestedInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureUpdateManyWithoutProjectNestedInput>;
  projectRole?: InputMaybe<ProjectRoleUpdateManyWithoutProjectNestedInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryUpdateManyWithoutProjectNestedInput>;
  projectStatus?: InputMaybe<ProjectStatusUpdateManyWithoutProjectNestedInput>;
  pspMapping?: InputMaybe<PspMappingUpdateManyWithoutMasterNestedInput>;
  remarks?: InputMaybe<RemarkUpdateManyWithoutProjectNestedInput>;
  replacement?: InputMaybe<ReplacementUpdateManyWithoutProjectNestedInput>;
  report?: InputMaybe<ReportUpdateManyWithoutProjectNestedInput>;
  risk?: InputMaybe<RiskUpdateManyWithoutProjectNestedInput>;
  topProjects?: InputMaybe<TopProjectsUpdateManyWithoutProjectNestedInput>;
};

export type MasterUpdateWithoutProjectInterfaceInput = {
  budgets?: InputMaybe<TargetedBudgetUpdateManyWithoutMasterNestedInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectUpdateManyWithoutProjectNestedInput>;
  contactHistory?: InputMaybe<ContactHistoryUpdateManyWithoutProjectNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  dashboardProject?: InputMaybe<DashboardProjectUpdateManyWithoutProjectNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<EmailHistoryUpdateManyWithoutProjectNestedInput>;
  employeeMaster?: InputMaybe<EmployeeMasterUpdateManyWithoutProjectNestedInput>;
  finances?: InputMaybe<FinanceUpdateManyWithoutProjectNestedInput>;
  goals?: InputMaybe<GoalsOnMasterUpdateManyWithoutProjectNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  leanixProject?: InputMaybe<LeanixMappingUpdateOneWithoutMasterNestedInput>;
  projectAllocations?: InputMaybe<ProjectAllocationUpdateManyWithoutProjectNestedInput>;
  projectApproval?: InputMaybe<ProjectApprovalUpdateManyWithoutProjectNestedInput>;
  projectDependency?: InputMaybe<ProjectDependencyUpdateManyWithoutProjectNestedInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentUpdateManyWithoutProjectNestedInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionUpdateManyWithoutMasterNestedInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsUpdateManyWithoutProjectNestedInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureUpdateManyWithoutProjectNestedInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireUpdateManyWithoutProjectNestedInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureUpdateManyWithoutProjectNestedInput>;
  projectRole?: InputMaybe<ProjectRoleUpdateManyWithoutProjectNestedInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryUpdateManyWithoutProjectNestedInput>;
  projectStatus?: InputMaybe<ProjectStatusUpdateManyWithoutProjectNestedInput>;
  pspMapping?: InputMaybe<PspMappingUpdateManyWithoutMasterNestedInput>;
  remarks?: InputMaybe<RemarkUpdateManyWithoutProjectNestedInput>;
  replacement?: InputMaybe<ReplacementUpdateManyWithoutProjectNestedInput>;
  report?: InputMaybe<ReportUpdateManyWithoutProjectNestedInput>;
  risk?: InputMaybe<RiskUpdateManyWithoutProjectNestedInput>;
  topProjects?: InputMaybe<TopProjectsUpdateManyWithoutProjectNestedInput>;
};

export type MasterUpdateWithoutProjectPhaseCaptureInput = {
  budgets?: InputMaybe<TargetedBudgetUpdateManyWithoutMasterNestedInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectUpdateManyWithoutProjectNestedInput>;
  contactHistory?: InputMaybe<ContactHistoryUpdateManyWithoutProjectNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  dashboardProject?: InputMaybe<DashboardProjectUpdateManyWithoutProjectNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<EmailHistoryUpdateManyWithoutProjectNestedInput>;
  employeeMaster?: InputMaybe<EmployeeMasterUpdateManyWithoutProjectNestedInput>;
  finances?: InputMaybe<FinanceUpdateManyWithoutProjectNestedInput>;
  goals?: InputMaybe<GoalsOnMasterUpdateManyWithoutProjectNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  leanixProject?: InputMaybe<LeanixMappingUpdateOneWithoutMasterNestedInput>;
  projectAllocations?: InputMaybe<ProjectAllocationUpdateManyWithoutProjectNestedInput>;
  projectApproval?: InputMaybe<ProjectApprovalUpdateManyWithoutProjectNestedInput>;
  projectDependency?: InputMaybe<ProjectDependencyUpdateManyWithoutProjectNestedInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentUpdateManyWithoutProjectNestedInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionUpdateManyWithoutMasterNestedInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsUpdateManyWithoutProjectNestedInput>;
  projectInterface?: InputMaybe<ProjectInterfaceUpdateManyWithoutProjectNestedInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireUpdateManyWithoutProjectNestedInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureUpdateManyWithoutProjectNestedInput>;
  projectRole?: InputMaybe<ProjectRoleUpdateManyWithoutProjectNestedInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryUpdateManyWithoutProjectNestedInput>;
  projectStatus?: InputMaybe<ProjectStatusUpdateManyWithoutProjectNestedInput>;
  pspMapping?: InputMaybe<PspMappingUpdateManyWithoutMasterNestedInput>;
  remarks?: InputMaybe<RemarkUpdateManyWithoutProjectNestedInput>;
  replacement?: InputMaybe<ReplacementUpdateManyWithoutProjectNestedInput>;
  report?: InputMaybe<ReportUpdateManyWithoutProjectNestedInput>;
  risk?: InputMaybe<RiskUpdateManyWithoutProjectNestedInput>;
  topProjects?: InputMaybe<TopProjectsUpdateManyWithoutProjectNestedInput>;
};

export type MasterUpdateWithoutProjectQuestionnaireInput = {
  budgets?: InputMaybe<TargetedBudgetUpdateManyWithoutMasterNestedInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectUpdateManyWithoutProjectNestedInput>;
  contactHistory?: InputMaybe<ContactHistoryUpdateManyWithoutProjectNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  dashboardProject?: InputMaybe<DashboardProjectUpdateManyWithoutProjectNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<EmailHistoryUpdateManyWithoutProjectNestedInput>;
  employeeMaster?: InputMaybe<EmployeeMasterUpdateManyWithoutProjectNestedInput>;
  finances?: InputMaybe<FinanceUpdateManyWithoutProjectNestedInput>;
  goals?: InputMaybe<GoalsOnMasterUpdateManyWithoutProjectNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  leanixProject?: InputMaybe<LeanixMappingUpdateOneWithoutMasterNestedInput>;
  projectAllocations?: InputMaybe<ProjectAllocationUpdateManyWithoutProjectNestedInput>;
  projectApproval?: InputMaybe<ProjectApprovalUpdateManyWithoutProjectNestedInput>;
  projectDependency?: InputMaybe<ProjectDependencyUpdateManyWithoutProjectNestedInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentUpdateManyWithoutProjectNestedInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionUpdateManyWithoutMasterNestedInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsUpdateManyWithoutProjectNestedInput>;
  projectInterface?: InputMaybe<ProjectInterfaceUpdateManyWithoutProjectNestedInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureUpdateManyWithoutProjectNestedInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureUpdateManyWithoutProjectNestedInput>;
  projectRole?: InputMaybe<ProjectRoleUpdateManyWithoutProjectNestedInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryUpdateManyWithoutProjectNestedInput>;
  projectStatus?: InputMaybe<ProjectStatusUpdateManyWithoutProjectNestedInput>;
  pspMapping?: InputMaybe<PspMappingUpdateManyWithoutMasterNestedInput>;
  remarks?: InputMaybe<RemarkUpdateManyWithoutProjectNestedInput>;
  replacement?: InputMaybe<ReplacementUpdateManyWithoutProjectNestedInput>;
  report?: InputMaybe<ReportUpdateManyWithoutProjectNestedInput>;
  risk?: InputMaybe<RiskUpdateManyWithoutProjectNestedInput>;
  topProjects?: InputMaybe<TopProjectsUpdateManyWithoutProjectNestedInput>;
};

export type MasterUpdateWithoutProjectResourceCaptureInput = {
  budgets?: InputMaybe<TargetedBudgetUpdateManyWithoutMasterNestedInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectUpdateManyWithoutProjectNestedInput>;
  contactHistory?: InputMaybe<ContactHistoryUpdateManyWithoutProjectNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  dashboardProject?: InputMaybe<DashboardProjectUpdateManyWithoutProjectNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<EmailHistoryUpdateManyWithoutProjectNestedInput>;
  employeeMaster?: InputMaybe<EmployeeMasterUpdateManyWithoutProjectNestedInput>;
  finances?: InputMaybe<FinanceUpdateManyWithoutProjectNestedInput>;
  goals?: InputMaybe<GoalsOnMasterUpdateManyWithoutProjectNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  leanixProject?: InputMaybe<LeanixMappingUpdateOneWithoutMasterNestedInput>;
  projectAllocations?: InputMaybe<ProjectAllocationUpdateManyWithoutProjectNestedInput>;
  projectApproval?: InputMaybe<ProjectApprovalUpdateManyWithoutProjectNestedInput>;
  projectDependency?: InputMaybe<ProjectDependencyUpdateManyWithoutProjectNestedInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentUpdateManyWithoutProjectNestedInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionUpdateManyWithoutMasterNestedInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsUpdateManyWithoutProjectNestedInput>;
  projectInterface?: InputMaybe<ProjectInterfaceUpdateManyWithoutProjectNestedInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureUpdateManyWithoutProjectNestedInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireUpdateManyWithoutProjectNestedInput>;
  projectRole?: InputMaybe<ProjectRoleUpdateManyWithoutProjectNestedInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryUpdateManyWithoutProjectNestedInput>;
  projectStatus?: InputMaybe<ProjectStatusUpdateManyWithoutProjectNestedInput>;
  pspMapping?: InputMaybe<PspMappingUpdateManyWithoutMasterNestedInput>;
  remarks?: InputMaybe<RemarkUpdateManyWithoutProjectNestedInput>;
  replacement?: InputMaybe<ReplacementUpdateManyWithoutProjectNestedInput>;
  report?: InputMaybe<ReportUpdateManyWithoutProjectNestedInput>;
  risk?: InputMaybe<RiskUpdateManyWithoutProjectNestedInput>;
  topProjects?: InputMaybe<TopProjectsUpdateManyWithoutProjectNestedInput>;
};

export type MasterUpdateWithoutProjectRoleInput = {
  budgets?: InputMaybe<TargetedBudgetUpdateManyWithoutMasterNestedInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectUpdateManyWithoutProjectNestedInput>;
  contactHistory?: InputMaybe<ContactHistoryUpdateManyWithoutProjectNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  dashboardProject?: InputMaybe<DashboardProjectUpdateManyWithoutProjectNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<EmailHistoryUpdateManyWithoutProjectNestedInput>;
  employeeMaster?: InputMaybe<EmployeeMasterUpdateManyWithoutProjectNestedInput>;
  finances?: InputMaybe<FinanceUpdateManyWithoutProjectNestedInput>;
  goals?: InputMaybe<GoalsOnMasterUpdateManyWithoutProjectNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  leanixProject?: InputMaybe<LeanixMappingUpdateOneWithoutMasterNestedInput>;
  projectAllocations?: InputMaybe<ProjectAllocationUpdateManyWithoutProjectNestedInput>;
  projectApproval?: InputMaybe<ProjectApprovalUpdateManyWithoutProjectNestedInput>;
  projectDependency?: InputMaybe<ProjectDependencyUpdateManyWithoutProjectNestedInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentUpdateManyWithoutProjectNestedInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionUpdateManyWithoutMasterNestedInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsUpdateManyWithoutProjectNestedInput>;
  projectInterface?: InputMaybe<ProjectInterfaceUpdateManyWithoutProjectNestedInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureUpdateManyWithoutProjectNestedInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireUpdateManyWithoutProjectNestedInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureUpdateManyWithoutProjectNestedInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryUpdateManyWithoutProjectNestedInput>;
  projectStatus?: InputMaybe<ProjectStatusUpdateManyWithoutProjectNestedInput>;
  pspMapping?: InputMaybe<PspMappingUpdateManyWithoutMasterNestedInput>;
  remarks?: InputMaybe<RemarkUpdateManyWithoutProjectNestedInput>;
  replacement?: InputMaybe<ReplacementUpdateManyWithoutProjectNestedInput>;
  report?: InputMaybe<ReportUpdateManyWithoutProjectNestedInput>;
  risk?: InputMaybe<RiskUpdateManyWithoutProjectNestedInput>;
  topProjects?: InputMaybe<TopProjectsUpdateManyWithoutProjectNestedInput>;
};

export type MasterUpdateWithoutProjectShortHistoryInput = {
  budgets?: InputMaybe<TargetedBudgetUpdateManyWithoutMasterNestedInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectUpdateManyWithoutProjectNestedInput>;
  contactHistory?: InputMaybe<ContactHistoryUpdateManyWithoutProjectNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  dashboardProject?: InputMaybe<DashboardProjectUpdateManyWithoutProjectNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<EmailHistoryUpdateManyWithoutProjectNestedInput>;
  employeeMaster?: InputMaybe<EmployeeMasterUpdateManyWithoutProjectNestedInput>;
  finances?: InputMaybe<FinanceUpdateManyWithoutProjectNestedInput>;
  goals?: InputMaybe<GoalsOnMasterUpdateManyWithoutProjectNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  leanixProject?: InputMaybe<LeanixMappingUpdateOneWithoutMasterNestedInput>;
  projectAllocations?: InputMaybe<ProjectAllocationUpdateManyWithoutProjectNestedInput>;
  projectApproval?: InputMaybe<ProjectApprovalUpdateManyWithoutProjectNestedInput>;
  projectDependency?: InputMaybe<ProjectDependencyUpdateManyWithoutProjectNestedInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentUpdateManyWithoutProjectNestedInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionUpdateManyWithoutMasterNestedInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsUpdateManyWithoutProjectNestedInput>;
  projectInterface?: InputMaybe<ProjectInterfaceUpdateManyWithoutProjectNestedInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureUpdateManyWithoutProjectNestedInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireUpdateManyWithoutProjectNestedInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureUpdateManyWithoutProjectNestedInput>;
  projectRole?: InputMaybe<ProjectRoleUpdateManyWithoutProjectNestedInput>;
  projectStatus?: InputMaybe<ProjectStatusUpdateManyWithoutProjectNestedInput>;
  pspMapping?: InputMaybe<PspMappingUpdateManyWithoutMasterNestedInput>;
  remarks?: InputMaybe<RemarkUpdateManyWithoutProjectNestedInput>;
  replacement?: InputMaybe<ReplacementUpdateManyWithoutProjectNestedInput>;
  report?: InputMaybe<ReportUpdateManyWithoutProjectNestedInput>;
  risk?: InputMaybe<RiskUpdateManyWithoutProjectNestedInput>;
  topProjects?: InputMaybe<TopProjectsUpdateManyWithoutProjectNestedInput>;
};

export type MasterUpdateWithoutProjectStatusInput = {
  budgets?: InputMaybe<TargetedBudgetUpdateManyWithoutMasterNestedInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectUpdateManyWithoutProjectNestedInput>;
  contactHistory?: InputMaybe<ContactHistoryUpdateManyWithoutProjectNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  dashboardProject?: InputMaybe<DashboardProjectUpdateManyWithoutProjectNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<EmailHistoryUpdateManyWithoutProjectNestedInput>;
  employeeMaster?: InputMaybe<EmployeeMasterUpdateManyWithoutProjectNestedInput>;
  finances?: InputMaybe<FinanceUpdateManyWithoutProjectNestedInput>;
  goals?: InputMaybe<GoalsOnMasterUpdateManyWithoutProjectNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  leanixProject?: InputMaybe<LeanixMappingUpdateOneWithoutMasterNestedInput>;
  projectAllocations?: InputMaybe<ProjectAllocationUpdateManyWithoutProjectNestedInput>;
  projectApproval?: InputMaybe<ProjectApprovalUpdateManyWithoutProjectNestedInput>;
  projectDependency?: InputMaybe<ProjectDependencyUpdateManyWithoutProjectNestedInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentUpdateManyWithoutProjectNestedInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionUpdateManyWithoutMasterNestedInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsUpdateManyWithoutProjectNestedInput>;
  projectInterface?: InputMaybe<ProjectInterfaceUpdateManyWithoutProjectNestedInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureUpdateManyWithoutProjectNestedInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireUpdateManyWithoutProjectNestedInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureUpdateManyWithoutProjectNestedInput>;
  projectRole?: InputMaybe<ProjectRoleUpdateManyWithoutProjectNestedInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryUpdateManyWithoutProjectNestedInput>;
  pspMapping?: InputMaybe<PspMappingUpdateManyWithoutMasterNestedInput>;
  remarks?: InputMaybe<RemarkUpdateManyWithoutProjectNestedInput>;
  replacement?: InputMaybe<ReplacementUpdateManyWithoutProjectNestedInput>;
  report?: InputMaybe<ReportUpdateManyWithoutProjectNestedInput>;
  risk?: InputMaybe<RiskUpdateManyWithoutProjectNestedInput>;
  topProjects?: InputMaybe<TopProjectsUpdateManyWithoutProjectNestedInput>;
};

export type MasterUpdateWithoutPspMappingInput = {
  budgets?: InputMaybe<TargetedBudgetUpdateManyWithoutMasterNestedInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectUpdateManyWithoutProjectNestedInput>;
  contactHistory?: InputMaybe<ContactHistoryUpdateManyWithoutProjectNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  dashboardProject?: InputMaybe<DashboardProjectUpdateManyWithoutProjectNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<EmailHistoryUpdateManyWithoutProjectNestedInput>;
  employeeMaster?: InputMaybe<EmployeeMasterUpdateManyWithoutProjectNestedInput>;
  finances?: InputMaybe<FinanceUpdateManyWithoutProjectNestedInput>;
  goals?: InputMaybe<GoalsOnMasterUpdateManyWithoutProjectNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  leanixProject?: InputMaybe<LeanixMappingUpdateOneWithoutMasterNestedInput>;
  projectAllocations?: InputMaybe<ProjectAllocationUpdateManyWithoutProjectNestedInput>;
  projectApproval?: InputMaybe<ProjectApprovalUpdateManyWithoutProjectNestedInput>;
  projectDependency?: InputMaybe<ProjectDependencyUpdateManyWithoutProjectNestedInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentUpdateManyWithoutProjectNestedInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionUpdateManyWithoutMasterNestedInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsUpdateManyWithoutProjectNestedInput>;
  projectInterface?: InputMaybe<ProjectInterfaceUpdateManyWithoutProjectNestedInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureUpdateManyWithoutProjectNestedInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireUpdateManyWithoutProjectNestedInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureUpdateManyWithoutProjectNestedInput>;
  projectRole?: InputMaybe<ProjectRoleUpdateManyWithoutProjectNestedInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryUpdateManyWithoutProjectNestedInput>;
  projectStatus?: InputMaybe<ProjectStatusUpdateManyWithoutProjectNestedInput>;
  remarks?: InputMaybe<RemarkUpdateManyWithoutProjectNestedInput>;
  replacement?: InputMaybe<ReplacementUpdateManyWithoutProjectNestedInput>;
  report?: InputMaybe<ReportUpdateManyWithoutProjectNestedInput>;
  risk?: InputMaybe<RiskUpdateManyWithoutProjectNestedInput>;
  topProjects?: InputMaybe<TopProjectsUpdateManyWithoutProjectNestedInput>;
};

export type MasterUpdateWithoutRemarksInput = {
  budgets?: InputMaybe<TargetedBudgetUpdateManyWithoutMasterNestedInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectUpdateManyWithoutProjectNestedInput>;
  contactHistory?: InputMaybe<ContactHistoryUpdateManyWithoutProjectNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  dashboardProject?: InputMaybe<DashboardProjectUpdateManyWithoutProjectNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<EmailHistoryUpdateManyWithoutProjectNestedInput>;
  employeeMaster?: InputMaybe<EmployeeMasterUpdateManyWithoutProjectNestedInput>;
  finances?: InputMaybe<FinanceUpdateManyWithoutProjectNestedInput>;
  goals?: InputMaybe<GoalsOnMasterUpdateManyWithoutProjectNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  leanixProject?: InputMaybe<LeanixMappingUpdateOneWithoutMasterNestedInput>;
  projectAllocations?: InputMaybe<ProjectAllocationUpdateManyWithoutProjectNestedInput>;
  projectApproval?: InputMaybe<ProjectApprovalUpdateManyWithoutProjectNestedInput>;
  projectDependency?: InputMaybe<ProjectDependencyUpdateManyWithoutProjectNestedInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentUpdateManyWithoutProjectNestedInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionUpdateManyWithoutMasterNestedInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsUpdateManyWithoutProjectNestedInput>;
  projectInterface?: InputMaybe<ProjectInterfaceUpdateManyWithoutProjectNestedInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureUpdateManyWithoutProjectNestedInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireUpdateManyWithoutProjectNestedInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureUpdateManyWithoutProjectNestedInput>;
  projectRole?: InputMaybe<ProjectRoleUpdateManyWithoutProjectNestedInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryUpdateManyWithoutProjectNestedInput>;
  projectStatus?: InputMaybe<ProjectStatusUpdateManyWithoutProjectNestedInput>;
  pspMapping?: InputMaybe<PspMappingUpdateManyWithoutMasterNestedInput>;
  replacement?: InputMaybe<ReplacementUpdateManyWithoutProjectNestedInput>;
  report?: InputMaybe<ReportUpdateManyWithoutProjectNestedInput>;
  risk?: InputMaybe<RiskUpdateManyWithoutProjectNestedInput>;
  topProjects?: InputMaybe<TopProjectsUpdateManyWithoutProjectNestedInput>;
};

export type MasterUpdateWithoutReplacementInput = {
  budgets?: InputMaybe<TargetedBudgetUpdateManyWithoutMasterNestedInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectUpdateManyWithoutProjectNestedInput>;
  contactHistory?: InputMaybe<ContactHistoryUpdateManyWithoutProjectNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  dashboardProject?: InputMaybe<DashboardProjectUpdateManyWithoutProjectNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<EmailHistoryUpdateManyWithoutProjectNestedInput>;
  employeeMaster?: InputMaybe<EmployeeMasterUpdateManyWithoutProjectNestedInput>;
  finances?: InputMaybe<FinanceUpdateManyWithoutProjectNestedInput>;
  goals?: InputMaybe<GoalsOnMasterUpdateManyWithoutProjectNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  leanixProject?: InputMaybe<LeanixMappingUpdateOneWithoutMasterNestedInput>;
  projectAllocations?: InputMaybe<ProjectAllocationUpdateManyWithoutProjectNestedInput>;
  projectApproval?: InputMaybe<ProjectApprovalUpdateManyWithoutProjectNestedInput>;
  projectDependency?: InputMaybe<ProjectDependencyUpdateManyWithoutProjectNestedInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentUpdateManyWithoutProjectNestedInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionUpdateManyWithoutMasterNestedInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsUpdateManyWithoutProjectNestedInput>;
  projectInterface?: InputMaybe<ProjectInterfaceUpdateManyWithoutProjectNestedInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureUpdateManyWithoutProjectNestedInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireUpdateManyWithoutProjectNestedInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureUpdateManyWithoutProjectNestedInput>;
  projectRole?: InputMaybe<ProjectRoleUpdateManyWithoutProjectNestedInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryUpdateManyWithoutProjectNestedInput>;
  projectStatus?: InputMaybe<ProjectStatusUpdateManyWithoutProjectNestedInput>;
  pspMapping?: InputMaybe<PspMappingUpdateManyWithoutMasterNestedInput>;
  remarks?: InputMaybe<RemarkUpdateManyWithoutProjectNestedInput>;
  report?: InputMaybe<ReportUpdateManyWithoutProjectNestedInput>;
  risk?: InputMaybe<RiskUpdateManyWithoutProjectNestedInput>;
  topProjects?: InputMaybe<TopProjectsUpdateManyWithoutProjectNestedInput>;
};

export type MasterUpdateWithoutReportInput = {
  budgets?: InputMaybe<TargetedBudgetUpdateManyWithoutMasterNestedInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectUpdateManyWithoutProjectNestedInput>;
  contactHistory?: InputMaybe<ContactHistoryUpdateManyWithoutProjectNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  dashboardProject?: InputMaybe<DashboardProjectUpdateManyWithoutProjectNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<EmailHistoryUpdateManyWithoutProjectNestedInput>;
  employeeMaster?: InputMaybe<EmployeeMasterUpdateManyWithoutProjectNestedInput>;
  finances?: InputMaybe<FinanceUpdateManyWithoutProjectNestedInput>;
  goals?: InputMaybe<GoalsOnMasterUpdateManyWithoutProjectNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  leanixProject?: InputMaybe<LeanixMappingUpdateOneWithoutMasterNestedInput>;
  projectAllocations?: InputMaybe<ProjectAllocationUpdateManyWithoutProjectNestedInput>;
  projectApproval?: InputMaybe<ProjectApprovalUpdateManyWithoutProjectNestedInput>;
  projectDependency?: InputMaybe<ProjectDependencyUpdateManyWithoutProjectNestedInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentUpdateManyWithoutProjectNestedInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionUpdateManyWithoutMasterNestedInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsUpdateManyWithoutProjectNestedInput>;
  projectInterface?: InputMaybe<ProjectInterfaceUpdateManyWithoutProjectNestedInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureUpdateManyWithoutProjectNestedInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireUpdateManyWithoutProjectNestedInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureUpdateManyWithoutProjectNestedInput>;
  projectRole?: InputMaybe<ProjectRoleUpdateManyWithoutProjectNestedInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryUpdateManyWithoutProjectNestedInput>;
  projectStatus?: InputMaybe<ProjectStatusUpdateManyWithoutProjectNestedInput>;
  pspMapping?: InputMaybe<PspMappingUpdateManyWithoutMasterNestedInput>;
  remarks?: InputMaybe<RemarkUpdateManyWithoutProjectNestedInput>;
  replacement?: InputMaybe<ReplacementUpdateManyWithoutProjectNestedInput>;
  risk?: InputMaybe<RiskUpdateManyWithoutProjectNestedInput>;
  topProjects?: InputMaybe<TopProjectsUpdateManyWithoutProjectNestedInput>;
};

export type MasterUpdateWithoutRiskInput = {
  budgets?: InputMaybe<TargetedBudgetUpdateManyWithoutMasterNestedInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectUpdateManyWithoutProjectNestedInput>;
  contactHistory?: InputMaybe<ContactHistoryUpdateManyWithoutProjectNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  dashboardProject?: InputMaybe<DashboardProjectUpdateManyWithoutProjectNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<EmailHistoryUpdateManyWithoutProjectNestedInput>;
  employeeMaster?: InputMaybe<EmployeeMasterUpdateManyWithoutProjectNestedInput>;
  finances?: InputMaybe<FinanceUpdateManyWithoutProjectNestedInput>;
  goals?: InputMaybe<GoalsOnMasterUpdateManyWithoutProjectNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  leanixProject?: InputMaybe<LeanixMappingUpdateOneWithoutMasterNestedInput>;
  projectAllocations?: InputMaybe<ProjectAllocationUpdateManyWithoutProjectNestedInput>;
  projectApproval?: InputMaybe<ProjectApprovalUpdateManyWithoutProjectNestedInput>;
  projectDependency?: InputMaybe<ProjectDependencyUpdateManyWithoutProjectNestedInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentUpdateManyWithoutProjectNestedInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionUpdateManyWithoutMasterNestedInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsUpdateManyWithoutProjectNestedInput>;
  projectInterface?: InputMaybe<ProjectInterfaceUpdateManyWithoutProjectNestedInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureUpdateManyWithoutProjectNestedInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireUpdateManyWithoutProjectNestedInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureUpdateManyWithoutProjectNestedInput>;
  projectRole?: InputMaybe<ProjectRoleUpdateManyWithoutProjectNestedInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryUpdateManyWithoutProjectNestedInput>;
  projectStatus?: InputMaybe<ProjectStatusUpdateManyWithoutProjectNestedInput>;
  pspMapping?: InputMaybe<PspMappingUpdateManyWithoutMasterNestedInput>;
  remarks?: InputMaybe<RemarkUpdateManyWithoutProjectNestedInput>;
  replacement?: InputMaybe<ReplacementUpdateManyWithoutProjectNestedInput>;
  report?: InputMaybe<ReportUpdateManyWithoutProjectNestedInput>;
  topProjects?: InputMaybe<TopProjectsUpdateManyWithoutProjectNestedInput>;
};

export type MasterUpdateWithoutTopProjectsInput = {
  budgets?: InputMaybe<TargetedBudgetUpdateManyWithoutMasterNestedInput>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectUpdateManyWithoutProjectNestedInput>;
  contactHistory?: InputMaybe<ContactHistoryUpdateManyWithoutProjectNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  dashboardProject?: InputMaybe<DashboardProjectUpdateManyWithoutProjectNestedInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<EmailHistoryUpdateManyWithoutProjectNestedInput>;
  employeeMaster?: InputMaybe<EmployeeMasterUpdateManyWithoutProjectNestedInput>;
  finances?: InputMaybe<FinanceUpdateManyWithoutProjectNestedInput>;
  goals?: InputMaybe<GoalsOnMasterUpdateManyWithoutProjectNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  leanixProject?: InputMaybe<LeanixMappingUpdateOneWithoutMasterNestedInput>;
  projectAllocations?: InputMaybe<ProjectAllocationUpdateManyWithoutProjectNestedInput>;
  projectApproval?: InputMaybe<ProjectApprovalUpdateManyWithoutProjectNestedInput>;
  projectDependency?: InputMaybe<ProjectDependencyUpdateManyWithoutProjectNestedInput>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentUpdateManyWithoutProjectNestedInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionUpdateManyWithoutMasterNestedInput>;
  projectDocuments?: InputMaybe<ProjectDocumentsUpdateManyWithoutProjectNestedInput>;
  projectInterface?: InputMaybe<ProjectInterfaceUpdateManyWithoutProjectNestedInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureUpdateManyWithoutProjectNestedInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireUpdateManyWithoutProjectNestedInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureUpdateManyWithoutProjectNestedInput>;
  projectRole?: InputMaybe<ProjectRoleUpdateManyWithoutProjectNestedInput>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryUpdateManyWithoutProjectNestedInput>;
  projectStatus?: InputMaybe<ProjectStatusUpdateManyWithoutProjectNestedInput>;
  pspMapping?: InputMaybe<PspMappingUpdateManyWithoutMasterNestedInput>;
  remarks?: InputMaybe<RemarkUpdateManyWithoutProjectNestedInput>;
  replacement?: InputMaybe<ReplacementUpdateManyWithoutProjectNestedInput>;
  report?: InputMaybe<ReportUpdateManyWithoutProjectNestedInput>;
  risk?: InputMaybe<RiskUpdateManyWithoutProjectNestedInput>;
};

export type MasterUpsertWithoutBudgetsInput = {
  create: MasterCreateWithoutBudgetsInput;
  update: MasterUpdateWithoutBudgetsInput;
};

export type MasterUpsertWithoutBusinessProcessOnProjectInput = {
  create: MasterCreateWithoutBusinessProcessOnProjectInput;
  update: MasterUpdateWithoutBusinessProcessOnProjectInput;
};

export type MasterUpsertWithoutContactHistoryInput = {
  create: MasterCreateWithoutContactHistoryInput;
  update: MasterUpdateWithoutContactHistoryInput;
};

export type MasterUpsertWithoutDashboardProjectInput = {
  create: MasterCreateWithoutDashboardProjectInput;
  update: MasterUpdateWithoutDashboardProjectInput;
};

export type MasterUpsertWithoutEmailInput = {
  create: MasterCreateWithoutEmailInput;
  update: MasterUpdateWithoutEmailInput;
};

export type MasterUpsertWithoutEmployeeMasterInput = {
  create: MasterCreateWithoutEmployeeMasterInput;
  update: MasterUpdateWithoutEmployeeMasterInput;
};

export type MasterUpsertWithoutFinancesInput = {
  create: MasterCreateWithoutFinancesInput;
  update: MasterUpdateWithoutFinancesInput;
};

export type MasterUpsertWithoutGoalsInput = {
  create: MasterCreateWithoutGoalsInput;
  update: MasterUpdateWithoutGoalsInput;
};

export type MasterUpsertWithoutLeanixProjectInput = {
  create: MasterCreateWithoutLeanixProjectInput;
  update: MasterUpdateWithoutLeanixProjectInput;
};

export type MasterUpsertWithoutProjectAllocationsInput = {
  create: MasterCreateWithoutProjectAllocationsInput;
  update: MasterUpdateWithoutProjectAllocationsInput;
};

export type MasterUpsertWithoutProjectApprovalInput = {
  create: MasterCreateWithoutProjectApprovalInput;
  update: MasterUpdateWithoutProjectApprovalInput;
};

export type MasterUpsertWithoutProjectDependencyInput = {
  create: MasterCreateWithoutProjectDependencyInput;
  update: MasterUpdateWithoutProjectDependencyInput;
};

export type MasterUpsertWithoutProjectDescriptionCommentInput = {
  create: MasterCreateWithoutProjectDescriptionCommentInput;
  update: MasterUpdateWithoutProjectDescriptionCommentInput;
};

export type MasterUpsertWithoutProjectDescriptionsInput = {
  create: MasterCreateWithoutProjectDescriptionsInput;
  update: MasterUpdateWithoutProjectDescriptionsInput;
};

export type MasterUpsertWithoutProjectDocumentsInput = {
  create: MasterCreateWithoutProjectDocumentsInput;
  update: MasterUpdateWithoutProjectDocumentsInput;
};

export type MasterUpsertWithoutProjectInterfaceInput = {
  create: MasterCreateWithoutProjectInterfaceInput;
  update: MasterUpdateWithoutProjectInterfaceInput;
};

export type MasterUpsertWithoutProjectPhaseCaptureInput = {
  create: MasterCreateWithoutProjectPhaseCaptureInput;
  update: MasterUpdateWithoutProjectPhaseCaptureInput;
};

export type MasterUpsertWithoutProjectQuestionnaireInput = {
  create: MasterCreateWithoutProjectQuestionnaireInput;
  update: MasterUpdateWithoutProjectQuestionnaireInput;
};

export type MasterUpsertWithoutProjectResourceCaptureInput = {
  create: MasterCreateWithoutProjectResourceCaptureInput;
  update: MasterUpdateWithoutProjectResourceCaptureInput;
};

export type MasterUpsertWithoutProjectRoleInput = {
  create: MasterCreateWithoutProjectRoleInput;
  update: MasterUpdateWithoutProjectRoleInput;
};

export type MasterUpsertWithoutProjectShortHistoryInput = {
  create: MasterCreateWithoutProjectShortHistoryInput;
  update: MasterUpdateWithoutProjectShortHistoryInput;
};

export type MasterUpsertWithoutProjectStatusInput = {
  create: MasterCreateWithoutProjectStatusInput;
  update: MasterUpdateWithoutProjectStatusInput;
};

export type MasterUpsertWithoutPspMappingInput = {
  create: MasterCreateWithoutPspMappingInput;
  update: MasterUpdateWithoutPspMappingInput;
};

export type MasterUpsertWithoutRemarksInput = {
  create: MasterCreateWithoutRemarksInput;
  update: MasterUpdateWithoutRemarksInput;
};

export type MasterUpsertWithoutReplacementInput = {
  create: MasterCreateWithoutReplacementInput;
  update: MasterUpdateWithoutReplacementInput;
};

export type MasterUpsertWithoutReportInput = {
  create: MasterCreateWithoutReportInput;
  update: MasterUpdateWithoutReportInput;
};

export type MasterUpsertWithoutRiskInput = {
  create: MasterCreateWithoutRiskInput;
  update: MasterUpdateWithoutRiskInput;
};

export type MasterUpsertWithoutTopProjectsInput = {
  create: MasterCreateWithoutTopProjectsInput;
  update: MasterUpdateWithoutTopProjectsInput;
};

export type MasterWhereInput = {
  AND?: InputMaybe<Array<MasterWhereInput>>;
  NOT?: InputMaybe<Array<MasterWhereInput>>;
  OR?: InputMaybe<Array<MasterWhereInput>>;
  budgets?: InputMaybe<TargetedBudgetListRelationFilter>;
  businessProcessOnProject?: InputMaybe<BusinessProcessOnProjectListRelationFilter>;
  contactHistory?: InputMaybe<ContactHistoryListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  dashboardProject?: InputMaybe<DashboardProjectListRelationFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  email?: InputMaybe<EmailHistoryListRelationFilter>;
  employeeMaster?: InputMaybe<EmployeeMasterListRelationFilter>;
  finances?: InputMaybe<FinanceListRelationFilter>;
  goals?: InputMaybe<GoalsOnMasterListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  leanixProject?: InputMaybe<LeanixMappingWhereInput>;
  projectAllocations?: InputMaybe<ProjectAllocationListRelationFilter>;
  projectApproval?: InputMaybe<ProjectApprovalListRelationFilter>;
  projectDependency?: InputMaybe<ProjectDependencyListRelationFilter>;
  projectDescriptionComment?: InputMaybe<ProjectDescriptionCommentListRelationFilter>;
  projectDescriptions?: InputMaybe<ProjectDescriptionListRelationFilter>;
  projectDocuments?: InputMaybe<ProjectDocumentsListRelationFilter>;
  projectInterface?: InputMaybe<ProjectInterfaceListRelationFilter>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureListRelationFilter>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireListRelationFilter>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureListRelationFilter>;
  projectRole?: InputMaybe<ProjectRoleListRelationFilter>;
  projectShortHistory?: InputMaybe<ProjectShortHistoryListRelationFilter>;
  projectStatus?: InputMaybe<ProjectStatusListRelationFilter>;
  pspMapping?: InputMaybe<PspMappingListRelationFilter>;
  remarks?: InputMaybe<RemarkListRelationFilter>;
  replacement?: InputMaybe<ReplacementListRelationFilter>;
  report?: InputMaybe<ReportListRelationFilter>;
  risk?: InputMaybe<RiskListRelationFilter>;
  topProjects?: InputMaybe<TopProjectsListRelationFilter>;
};

export type MasterWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type Method = {
  __typename?: 'Method';
  _count: MethodCount;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  methodName: Scalars['String'];
  projectDescriptions?: Maybe<Array<ProjectDescription>>;
};

export type MethodCount = {
  __typename?: 'MethodCount';
  projectDescriptions: Scalars['Int'];
};

export type MethodCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  methodName: Scalars['String'];
  projectDescriptions?: InputMaybe<ProjectDescriptionCreateNestedManyWithoutMethodInput>;
};

export type MethodCreateNestedOneWithoutProjectDescriptionsInput = {
  connect?: InputMaybe<MethodWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MethodCreateOrConnectWithoutProjectDescriptionsInput>;
  create?: InputMaybe<MethodCreateWithoutProjectDescriptionsInput>;
};

export type MethodCreateOrConnectWithoutProjectDescriptionsInput = {
  create: MethodCreateWithoutProjectDescriptionsInput;
  where: MethodWhereUniqueInput;
};

export type MethodCreateWithoutProjectDescriptionsInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  methodName: Scalars['String'];
};

export type MethodOrderByWithRelationInput = {
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  methodName?: InputMaybe<SortOrder>;
  projectDescriptions?: InputMaybe<ProjectDescriptionOrderByRelationAggregateInput>;
};

export enum MethodScalarFieldEnum {
  Description = 'description',
  Id = 'id',
  MethodName = 'methodName'
}

export type MethodUpdateInput = {
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  methodName?: InputMaybe<StringFieldUpdateOperationsInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionUpdateManyWithoutMethodNestedInput>;
};

export type MethodUpdateOneWithoutProjectDescriptionsNestedInput = {
  connect?: InputMaybe<MethodWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MethodCreateOrConnectWithoutProjectDescriptionsInput>;
  create?: InputMaybe<MethodCreateWithoutProjectDescriptionsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<MethodUpdateWithoutProjectDescriptionsInput>;
  upsert?: InputMaybe<MethodUpsertWithoutProjectDescriptionsInput>;
};

export type MethodUpdateWithoutProjectDescriptionsInput = {
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  methodName?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type MethodUpsertWithoutProjectDescriptionsInput = {
  create: MethodCreateWithoutProjectDescriptionsInput;
  update: MethodUpdateWithoutProjectDescriptionsInput;
};

export type MethodWhereInput = {
  AND?: InputMaybe<Array<MethodWhereInput>>;
  NOT?: InputMaybe<Array<MethodWhereInput>>;
  OR?: InputMaybe<Array<MethodWhereInput>>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  methodName?: InputMaybe<StringFilter>;
  projectDescriptions?: InputMaybe<ProjectDescriptionListRelationFilter>;
};

export type MethodWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
  methodName?: InputMaybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  createAddresseeGroup: AddresseeGroup;
  createAllocation: Allocation;
  createApprovalBoard: ApprovalBoard;
  createApprovalStatus: ApprovalStatus;
  createApprover: Approver;
  createApproverProcess: ApproverProcess;
  createApproverRecipient: ApproverRecipient;
  createAsset: Asset;
  createBusinessProcess: BusinessProcess;
  createBusinessProcessComment: BusinessProcessComments;
  createBusinessProcessOnProject: BusinessProcessOnProject;
  createCompany: Company;
  createContactHistory: ContactHistory;
  createDashboardProject: DashboardProject;
  createEmailHistory: EmailHistory;
  createEmployee: Employee;
  createEmployeeMaster: EmployeeMaster;
  createFinance: Finance;
  createFunding: Funding;
  createGeneralCostShortHistory: GeneralCostShortHistory;
  createGeneralItCost: GerneralItCosts;
  createGeneralItCostSubtype: GerneralItCostSubtype;
  createGeneralItCostType: GerneralItCostType;
  createGoal: Goal;
  createGoalsOnMaster: GoalsOnMaster;
  createInterfaceDetail: InterfaceDetail;
  createInterfaceFormat: InterfaceFormat;
  createInterfaceReference: InterfaceReference;
  createInterfaceType: InterfaceType;
  createLandingApplication: LandingApplication;
  createLandingApplicationCluster: LandingApplicationCluster;
  createLandingApplicationClusterGroup: LandingApplicationClusterGroup;
  createLandingApplicationClusterMapping: LandingApplicationClusterMapping;
  createLandingApplicationGroup: LandingApplicationGroup;
  createLeanixMapping: LeanixMapping;
  createMaster: Master;
  createMethod: Method;
  createPhaseOnType: PhaseOnType;
  createProjectAllocationInput: ProjectAllocation;
  createProjectApproval: ProjectApproval;
  createProjectDependency: ProjectDependency;
  createProjectDescription: ProjectDescription;
  createProjectDescriptionComment: ProjectDescriptionComment;
  createProjectDocument: ProjectDocuments;
  createProjectInterface: ProjectInterface;
  createProjectPhase: ProjectPhase;
  createProjectPhaseCapture: ProjectPhaseCapture;
  createProjectQuestionnaire: ProjectQuestionnaire;
  createProjectQuestionnaireStatus: ProjectQuestionnaireStatus;
  createProjectResourceCapture: ProjectResourceCapture;
  createProjectRole: ProjectRole;
  createProjectShortHistory: ProjectShortHistory;
  createProjectStatus: ProjectStatus;
  createProjectType: ProjectType;
  createPspMapping: PspMapping;
  createRemark: Remark;
  createReplacement: Replacement;
  createReport: Report;
  createRisk: Risk;
  createRiskDamagePotential: RiskDamagePotential;
  createRiskOccurance: RiskOccurance;
  createRiskStatus: RiskStatus;
  createRole: Role;
  createSecurityGroup: SecurityGroup;
  createSegment: Segment;
  createSequenceStatus: SequenceStatus;
  createTargetedBudget: TargetedBudget;
  createTemplate: Template;
  createTemplateDocument: TemplateDocuments;
  createTopProject: TopProjects;
  removeAddresseeGroup: AddresseeGroup;
  removeAllocation: Allocation;
  removeApprovalBoard: ApprovalBoard;
  removeApprovalStatus: ApprovalStatus;
  removeApprover: Approver;
  removeApproverProcess: ApproverProcess;
  removeApproverRecipient: ApproverRecipient;
  removeAsset: Asset;
  removeBusinessProcess: BusinessProcess;
  removeBusinessProcessComment: BusinessProcessComments;
  removeBusinessProcessOnProject: BusinessProcessOnProject;
  removeCompany: Company;
  removeContactHistory: ContactHistory;
  removeDashboardProject: DashboardProject;
  removeEmailHistory: EmailHistory;
  removeEmployee: Employee;
  removeEmployeeMaster: EmployeeMaster;
  removeFinance: Finance;
  removeFunding: Funding;
  removeGeneralCostShortHistory: GeneralCostShortHistory;
  removeGeneralItCost: GerneralItCosts;
  removeGeneralItCostSubtype: GerneralItCostSubtype;
  removeGeneralItCostType: GerneralItCostType;
  removeGoal: Goal;
  removeGoalsOnMaster: GoalsOnMaster;
  removeInterfaceDetail: InterfaceDetail;
  removeInterfaceFormat: InterfaceFormat;
  removeInterfaceReference: InterfaceReference;
  removeInterfaceType: InterfaceType;
  removeLandingApplication: LandingApplication;
  removeLandingApplicationCluster: LandingApplicationCluster;
  removeLandingApplicationClusterGroup: LandingApplicationClusterGroup;
  removeLandingApplicationClusterMapping: LandingApplicationClusterMapping;
  removeLandingApplicationGroup: LandingApplicationGroup;
  removeLeanixMapping: LeanixMapping;
  removeMaster: Master;
  removeMethod: Method;
  removePhaseOnType: PhaseOnType;
  removeProjectAllocation: ProjectAllocation;
  removeProjectApproval: ProjectApproval;
  removeProjectDependency: ProjectDependency;
  removeProjectDescription: ProjectDescription;
  removeProjectDescriptionComment: ProjectDescriptionComment;
  removeProjectDocument: ProjectDocuments;
  removeProjectInterface: ProjectInterface;
  removeProjectPhase: ProjectPhase;
  removeProjectPhaseCapture: ProjectPhaseCapture;
  removeProjectQuestionnaire: ProjectQuestionnaire;
  removeProjectQuestionnaireStatus: ProjectQuestionnaireStatus;
  removeProjectResourceCapture: ProjectResourceCapture;
  removeProjectRole: ProjectRole;
  removeProjectShortHistory: ProjectShortHistory;
  removeProjectStatus: ProjectStatus;
  removeProjectType: ProjectType;
  removePspMapping: PspMapping;
  removeRemark: Remark;
  removeReplacement: Replacement;
  removeReport: Report;
  removeRisk: Risk;
  removeRiskDamagePotential: RiskDamagePotential;
  removeRiskOccurance: RiskOccurance;
  removeRiskStatus: RiskStatus;
  removeRole: Role;
  removeSecurityGroup: SecurityGroup;
  removeSegment: Segment;
  removeSequenceStatus: SequenceStatus;
  removeTargetedBudget: TargetedBudget;
  removeTemplate: Template;
  removeTemplateDocument: TemplateDocuments;
  removeTopProject: TopProjects;
  updateAddresseeGroup: AddresseeGroup;
  updateAllocation: Allocation;
  updateApprovalBoard: ApprovalBoard;
  updateApprovalStatus: ApprovalStatus;
  updateApprover: Approver;
  updateApproverProcess: ApproverProcess;
  updateApproverRecipient: ApproverRecipient;
  updateAsset: Asset;
  updateBusinessProcess: BusinessProcess;
  updateBusinessProcessComment: BusinessProcessComments;
  updateBusinessProcessOnProject: BusinessProcessOnProject;
  updateCompany: Company;
  updateContactHistory: ContactHistory;
  updateDashboardProject: DashboardProject;
  updateEmailHistory: EmailHistory;
  updateEmployee: Employee;
  updateEmployeeMaster: EmployeeMaster;
  updateFinance: Finance;
  updateFunding: Funding;
  updateGeneralCostShortHistory: GeneralCostShortHistory;
  updateGeneralItCost: GerneralItCosts;
  updateGeneralItCostSubtype: GerneralItCostSubtype;
  updateGeneralItCostType: GerneralItCostType;
  updateGoal: Goal;
  updateGoalsOnMaster: GoalsOnMaster;
  updateInterfaceDetail: InterfaceDetail;
  updateInterfaceFormat: InterfaceFormat;
  updateInterfaceReference: InterfaceReference;
  updateInterfaceType: InterfaceType;
  updateLandingApplication: LandingApplication;
  updateLandingApplicationCluster: LandingApplicationCluster;
  updateLandingApplicationClusterGroup: LandingApplicationClusterGroup;
  updateLandingApplicationClusterMapping: LandingApplicationClusterMapping;
  updateLandingApplicationGroup: LandingApplicationGroup;
  updateLeanixMapping: LeanixMapping;
  updateMaster: Master;
  updateMethod: Method;
  updatePhaseOnType: PhaseOnType;
  updateProjectAllocation: ProjectAllocation;
  updateProjectApproval: ProjectApproval;
  updateProjectDependency: ProjectDependency;
  updateProjectDescription: ProjectDescription;
  updateProjectDescriptionComment: ProjectDescriptionComment;
  updateProjectDocument: ProjectDocuments;
  updateProjectInterface: ProjectInterface;
  updateProjectPhase: ProjectPhase;
  updateProjectPhaseCapture: ProjectPhaseCapture;
  updateProjectQuestionnaire: ProjectQuestionnaire;
  updateProjectQuestionnaireStatus: ProjectQuestionnaireStatus;
  updateProjectResourceCapture: ProjectResourceCapture;
  updateProjectRole: ProjectRole;
  updateProjectShortHistory: ProjectShortHistory;
  updateProjectStatus: ProjectStatus;
  updateProjectType: ProjectType;
  updatePspMapping: PspMapping;
  updateRemark: Remark;
  updateReplacement: Replacement;
  updateReport: Report;
  updateRisk: Risk;
  updateRiskDamagePotential: RiskDamagePotential;
  updateRiskOccurance: RiskOccurance;
  updateRiskStatus: RiskStatus;
  updateRole: Role;
  updateSecurityGroup: SecurityGroup;
  updateSegment: Segment;
  updateSequenceStatus: SequenceStatus;
  updateTargetedBudget: TargetedBudget;
  updateTemplate: Template;
  updateTemplateDocument: TemplateDocuments;
  updateTopProject: TopProjects;
};


export type MutationCreateAddresseeGroupArgs = {
  data: AddresseeGroupCreateInput;
};


export type MutationCreateAllocationArgs = {
  data: AllocationCreateInput;
};


export type MutationCreateApprovalBoardArgs = {
  data: ApprovalBoardCreateInput;
};


export type MutationCreateApprovalStatusArgs = {
  data: ApprovalStatusCreateInput;
};


export type MutationCreateApproverArgs = {
  data: ApproverCreateInput;
};


export type MutationCreateApproverProcessArgs = {
  data: ApproverProcessCreateInput;
};


export type MutationCreateApproverRecipientArgs = {
  data: ApproverRecipientCreateInput;
};


export type MutationCreateAssetArgs = {
  data: AssetCreateInput;
};


export type MutationCreateBusinessProcessArgs = {
  data: BusinessProcessCreateInput;
};


export type MutationCreateBusinessProcessCommentArgs = {
  data: BusinessProcessCommentsCreateInput;
};


export type MutationCreateBusinessProcessOnProjectArgs = {
  data: BusinessProcessOnProjectCreateInput;
};


export type MutationCreateCompanyArgs = {
  data: CompanyCreateInput;
};


export type MutationCreateContactHistoryArgs = {
  data: ContactHistoryCreateInput;
};


export type MutationCreateDashboardProjectArgs = {
  data: DashboardProjectCreateInput;
};


export type MutationCreateEmailHistoryArgs = {
  data: EmailHistoryCreateInput;
};


export type MutationCreateEmployeeArgs = {
  data: EmployeeCreateInput;
};


export type MutationCreateEmployeeMasterArgs = {
  data: EmployeeMasterCreateInput;
};


export type MutationCreateFinanceArgs = {
  data: FinanceCreateInput;
};


export type MutationCreateFundingArgs = {
  data: FundingCreateInput;
};


export type MutationCreateGeneralCostShortHistoryArgs = {
  data: GeneralCostShortHistoryCreateInput;
};


export type MutationCreateGeneralItCostArgs = {
  data: GerneralItCostsCreateInput;
};


export type MutationCreateGeneralItCostSubtypeArgs = {
  data: GerneralItCostSubtypeCreateInput;
};


export type MutationCreateGeneralItCostTypeArgs = {
  data: GerneralItCostTypeCreateInput;
};


export type MutationCreateGoalArgs = {
  data: GoalCreateInput;
};


export type MutationCreateGoalsOnMasterArgs = {
  data: GoalsOnMasterCreateInput;
};


export type MutationCreateInterfaceDetailArgs = {
  data: InterfaceDetailCreateInput;
};


export type MutationCreateInterfaceFormatArgs = {
  data: InterfaceFormatCreateInput;
};


export type MutationCreateInterfaceReferenceArgs = {
  data: InterfaceReferenceCreateInput;
};


export type MutationCreateInterfaceTypeArgs = {
  data: InterfaceTypeCreateInput;
};


export type MutationCreateLandingApplicationArgs = {
  data: LandingApplicationCreateInput;
  file: Scalars['Upload'];
};


export type MutationCreateLandingApplicationClusterArgs = {
  data: LandingApplicationClusterCreateInput;
  file: Scalars['Upload'];
};


export type MutationCreateLandingApplicationClusterGroupArgs = {
  data: LandingApplicationClusterGroupCreateInput;
};


export type MutationCreateLandingApplicationClusterMappingArgs = {
  data: LandingApplicationClusterMappingCreateInput;
};


export type MutationCreateLandingApplicationGroupArgs = {
  data: LandingApplicationGroupCreateInput;
};


export type MutationCreateLeanixMappingArgs = {
  data: LeanixMappingCreateInput;
};


export type MutationCreateMasterArgs = {
  data: MasterCreateInput;
};


export type MutationCreateMethodArgs = {
  data: MethodCreateInput;
};


export type MutationCreatePhaseOnTypeArgs = {
  data: PhaseOnTypeCreateInput;
};


export type MutationCreateProjectAllocationInputArgs = {
  data: ProjectAllocationCreateInput;
};


export type MutationCreateProjectApprovalArgs = {
  data: ProjectApprovalCreateInput;
};


export type MutationCreateProjectDependencyArgs = {
  data: ProjectDependencyCreateInput;
};


export type MutationCreateProjectDescriptionArgs = {
  data: ProjectDescriptionCreateInput;
};


export type MutationCreateProjectDescriptionCommentArgs = {
  data: ProjectDescriptionCommentCreateInput;
};


export type MutationCreateProjectDocumentArgs = {
  data: ProjectDocumentsCreateInput;
  file: Scalars['Upload'];
};


export type MutationCreateProjectInterfaceArgs = {
  data: ProjectInterfaceCreateInput;
};


export type MutationCreateProjectPhaseArgs = {
  data: ProjectPhaseCreateInput;
};


export type MutationCreateProjectPhaseCaptureArgs = {
  data: ProjectPhaseCaptureCreateInput;
};


export type MutationCreateProjectQuestionnaireArgs = {
  data: ProjectQuestionnaireCreateInput;
};


export type MutationCreateProjectQuestionnaireStatusArgs = {
  data: ProjectQuestionnaireStatusCreateInput;
};


export type MutationCreateProjectResourceCaptureArgs = {
  data: ProjectResourceCaptureCreateInput;
};


export type MutationCreateProjectRoleArgs = {
  data: ProjectRoleCreateInput;
};


export type MutationCreateProjectShortHistoryArgs = {
  data: ProjectShortHistoryCreateInput;
};


export type MutationCreateProjectStatusArgs = {
  data: ProjectStatusCreateInput;
};


export type MutationCreateProjectTypeArgs = {
  data: ProjectTypeCreateInput;
};


export type MutationCreatePspMappingArgs = {
  data: PspMappingCreateInput;
};


export type MutationCreateRemarkArgs = {
  data: RemarkCreateInput;
};


export type MutationCreateReplacementArgs = {
  data: ReplacementCreateInput;
};


export type MutationCreateReportArgs = {
  data: ReportCreateInput;
};


export type MutationCreateRiskArgs = {
  data: RiskCreateInput;
};


export type MutationCreateRiskDamagePotentialArgs = {
  data: RiskDamagePotentialCreateInput;
};


export type MutationCreateRiskOccuranceArgs = {
  data: RiskOccuranceCreateInput;
};


export type MutationCreateRiskStatusArgs = {
  data: RiskStatusCreateInput;
};


export type MutationCreateRoleArgs = {
  data: RoleCreateInput;
};


export type MutationCreateSecurityGroupArgs = {
  data: SecurityGroupCreateInput;
};


export type MutationCreateSegmentArgs = {
  data: SegmentCreateInput;
};


export type MutationCreateSequenceStatusArgs = {
  data: SequenceStatusCreateInput;
};


export type MutationCreateTargetedBudgetArgs = {
  data: TargetedBudgetCreateInput;
};


export type MutationCreateTemplateArgs = {
  data: TemplateCreateInput;
};


export type MutationCreateTemplateDocumentArgs = {
  data: TemplateDocumentsCreateInput;
};


export type MutationCreateTopProjectArgs = {
  data: TopProjectsCreateInput;
};


export type MutationRemoveAddresseeGroupArgs = {
  where: AddresseeGroupWhereUniqueInput;
};


export type MutationRemoveAllocationArgs = {
  where: AllocationWhereUniqueInput;
};


export type MutationRemoveApprovalBoardArgs = {
  where: ApprovalBoardWhereUniqueInput;
};


export type MutationRemoveApprovalStatusArgs = {
  where: ApprovalStatusWhereUniqueInput;
};


export type MutationRemoveApproverArgs = {
  where: ApproverWhereUniqueInput;
};


export type MutationRemoveApproverProcessArgs = {
  where: ApproverProcessWhereUniqueInput;
};


export type MutationRemoveApproverRecipientArgs = {
  where: ApproverRecipientWhereUniqueInput;
};


export type MutationRemoveAssetArgs = {
  where: AssetWhereUniqueInput;
};


export type MutationRemoveBusinessProcessArgs = {
  where: BusinessProcessWhereUniqueInput;
};


export type MutationRemoveBusinessProcessCommentArgs = {
  where: BusinessProcessCommentsWhereUniqueInput;
};


export type MutationRemoveBusinessProcessOnProjectArgs = {
  where: BusinessProcessOnProjectWhereUniqueInput;
};


export type MutationRemoveCompanyArgs = {
  where: CompanyWhereUniqueInput;
};


export type MutationRemoveContactHistoryArgs = {
  where: ContactHistoryWhereUniqueInput;
};


export type MutationRemoveDashboardProjectArgs = {
  where: DashboardProjectWhereUniqueInput;
};


export type MutationRemoveEmailHistoryArgs = {
  where: EmailHistoryWhereUniqueInput;
};


export type MutationRemoveEmployeeArgs = {
  where: EmployeeWhereUniqueInput;
};


export type MutationRemoveEmployeeMasterArgs = {
  where: EmployeeMasterWhereUniqueInput;
};


export type MutationRemoveFinanceArgs = {
  where: FinanceWhereUniqueInput;
};


export type MutationRemoveFundingArgs = {
  where: FundingWhereUniqueInput;
};


export type MutationRemoveGeneralCostShortHistoryArgs = {
  where: GeneralCostShortHistoryWhereUniqueInput;
};


export type MutationRemoveGeneralItCostArgs = {
  where: GerneralItCostsWhereUniqueInput;
};


export type MutationRemoveGeneralItCostSubtypeArgs = {
  where: GerneralItCostSubtypeWhereUniqueInput;
};


export type MutationRemoveGeneralItCostTypeArgs = {
  where: GerneralItCostTypeWhereUniqueInput;
};


export type MutationRemoveGoalArgs = {
  where: GoalWhereUniqueInput;
};


export type MutationRemoveGoalsOnMasterArgs = {
  where: GoalsOnMasterWhereUniqueInput;
};


export type MutationRemoveInterfaceDetailArgs = {
  where: InterfaceDetailWhereUniqueInput;
};


export type MutationRemoveInterfaceFormatArgs = {
  where: InterfaceFormatWhereUniqueInput;
};


export type MutationRemoveInterfaceReferenceArgs = {
  where: InterfaceReferenceWhereUniqueInput;
};


export type MutationRemoveInterfaceTypeArgs = {
  where: InterfaceTypeWhereUniqueInput;
};


export type MutationRemoveLandingApplicationArgs = {
  where: LandingApplicationWhereUniqueInput;
};


export type MutationRemoveLandingApplicationClusterArgs = {
  where: LandingApplicationClusterWhereUniqueInput;
};


export type MutationRemoveLandingApplicationClusterGroupArgs = {
  where: LandingApplicationClusterGroupWhereUniqueInput;
};


export type MutationRemoveLandingApplicationClusterMappingArgs = {
  where: LandingApplicationClusterMappingWhereUniqueInput;
};


export type MutationRemoveLandingApplicationGroupArgs = {
  where: LandingApplicationGroupWhereUniqueInput;
};


export type MutationRemoveLeanixMappingArgs = {
  where: LeanixMappingWhereUniqueInput;
};


export type MutationRemoveMasterArgs = {
  where: MasterWhereUniqueInput;
};


export type MutationRemoveMethodArgs = {
  where: MethodWhereUniqueInput;
};


export type MutationRemovePhaseOnTypeArgs = {
  where: PhaseOnTypeWhereUniqueInput;
};


export type MutationRemoveProjectAllocationArgs = {
  where: ProjectAllocationWhereUniqueInput;
};


export type MutationRemoveProjectApprovalArgs = {
  where: ProjectApprovalWhereUniqueInput;
};


export type MutationRemoveProjectDependencyArgs = {
  where: ProjectDependencyWhereUniqueInput;
};


export type MutationRemoveProjectDescriptionArgs = {
  where: ProjectDescriptionWhereUniqueInput;
};


export type MutationRemoveProjectDescriptionCommentArgs = {
  where: ProjectDescriptionCommentWhereUniqueInput;
};


export type MutationRemoveProjectDocumentArgs = {
  where: ProjectDocumentsWhereUniqueInput;
};


export type MutationRemoveProjectInterfaceArgs = {
  where: ProjectInterfaceWhereUniqueInput;
};


export type MutationRemoveProjectPhaseArgs = {
  where: ProjectPhaseWhereUniqueInput;
};


export type MutationRemoveProjectPhaseCaptureArgs = {
  where: ProjectPhaseCaptureWhereUniqueInput;
};


export type MutationRemoveProjectQuestionnaireArgs = {
  where: ProjectQuestionnaireWhereUniqueInput;
};


export type MutationRemoveProjectQuestionnaireStatusArgs = {
  where: ProjectQuestionnaireStatusWhereUniqueInput;
};


export type MutationRemoveProjectResourceCaptureArgs = {
  where: ProjectResourceCaptureWhereUniqueInput;
};


export type MutationRemoveProjectRoleArgs = {
  where: ProjectRoleWhereUniqueInput;
};


export type MutationRemoveProjectShortHistoryArgs = {
  where: ProjectShortHistoryWhereUniqueInput;
};


export type MutationRemoveProjectStatusArgs = {
  where: ProjectStatusWhereUniqueInput;
};


export type MutationRemoveProjectTypeArgs = {
  where: ProjectTypeWhereUniqueInput;
};


export type MutationRemovePspMappingArgs = {
  where: PspMappingWhereUniqueInput;
};


export type MutationRemoveRemarkArgs = {
  where: RemarkWhereUniqueInput;
};


export type MutationRemoveReplacementArgs = {
  where: ReplacementWhereUniqueInput;
};


export type MutationRemoveReportArgs = {
  where: ReportWhereUniqueInput;
};


export type MutationRemoveRiskArgs = {
  where: RiskWhereUniqueInput;
};


export type MutationRemoveRiskDamagePotentialArgs = {
  where: RiskDamagePotentialWhereUniqueInput;
};


export type MutationRemoveRiskOccuranceArgs = {
  where: RiskOccuranceWhereUniqueInput;
};


export type MutationRemoveRiskStatusArgs = {
  where: RiskStatusWhereUniqueInput;
};


export type MutationRemoveRoleArgs = {
  where: RoleWhereUniqueInput;
};


export type MutationRemoveSecurityGroupArgs = {
  where: SecurityGroupWhereUniqueInput;
};


export type MutationRemoveSegmentArgs = {
  where: SegmentWhereUniqueInput;
};


export type MutationRemoveSequenceStatusArgs = {
  where: SequenceStatusWhereUniqueInput;
};


export type MutationRemoveTargetedBudgetArgs = {
  where: TargetedBudgetWhereUniqueInput;
};


export type MutationRemoveTemplateArgs = {
  where: TemplateWhereUniqueInput;
};


export type MutationRemoveTemplateDocumentArgs = {
  where: TemplateDocumentsWhereUniqueInput;
};


export type MutationRemoveTopProjectArgs = {
  where: TopProjectsWhereUniqueInput;
};


export type MutationUpdateAddresseeGroupArgs = {
  data: AddresseeGroupUpdateInput;
  where: AddresseeGroupWhereUniqueInput;
};


export type MutationUpdateAllocationArgs = {
  data: AllocationUpdateInput;
  where: AllocationWhereUniqueInput;
};


export type MutationUpdateApprovalBoardArgs = {
  data: ApprovalBoardUpdateInput;
  where: ApprovalBoardWhereUniqueInput;
};


export type MutationUpdateApprovalStatusArgs = {
  data: ApprovalStatusUpdateInput;
  where: ApprovalStatusWhereUniqueInput;
};


export type MutationUpdateApproverArgs = {
  data: ApproverUpdateInput;
  where: ApproverWhereUniqueInput;
};


export type MutationUpdateApproverProcessArgs = {
  data: ApproverProcessUpdateInput;
  where: ApproverProcessWhereUniqueInput;
};


export type MutationUpdateApproverRecipientArgs = {
  data: ApproverRecipientUpdateInput;
  where: ApproverRecipientWhereUniqueInput;
};


export type MutationUpdateAssetArgs = {
  data: AssetUpdateInput;
  where: AssetWhereUniqueInput;
};


export type MutationUpdateBusinessProcessArgs = {
  data: BusinessProcessUpdateInput;
  where: BusinessProcessWhereUniqueInput;
};


export type MutationUpdateBusinessProcessCommentArgs = {
  data: BusinessProcessCommentsUpdateInput;
  where: BusinessProcessCommentsWhereUniqueInput;
};


export type MutationUpdateBusinessProcessOnProjectArgs = {
  data: BusinessProcessOnProjectUpdateInput;
  where: BusinessProcessOnProjectWhereUniqueInput;
};


export type MutationUpdateCompanyArgs = {
  data: CompanyUpdateInput;
  where: CompanyWhereUniqueInput;
};


export type MutationUpdateContactHistoryArgs = {
  data: ContactHistoryUpdateInput;
  where: ContactHistoryWhereUniqueInput;
};


export type MutationUpdateDashboardProjectArgs = {
  data: DashboardProjectUpdateInput;
  where: DashboardProjectWhereUniqueInput;
};


export type MutationUpdateEmailHistoryArgs = {
  data: EmailHistoryUpdateInput;
  where: EmailHistoryWhereUniqueInput;
};


export type MutationUpdateEmployeeArgs = {
  data: EmployeeUpdateInput;
  where: EmployeeWhereUniqueInput;
};


export type MutationUpdateEmployeeMasterArgs = {
  data: EmployeeMasterUpdateInput;
  where: EmployeeMasterWhereUniqueInput;
};


export type MutationUpdateFinanceArgs = {
  data: FinanceUpdateInput;
  where: FinanceWhereUniqueInput;
};


export type MutationUpdateFundingArgs = {
  data: FundingUpdateInput;
  where: FundingWhereUniqueInput;
};


export type MutationUpdateGeneralCostShortHistoryArgs = {
  data: GeneralCostShortHistoryUpdateInput;
  where: GeneralCostShortHistoryWhereUniqueInput;
};


export type MutationUpdateGeneralItCostArgs = {
  data: GerneralItCostsUpdateInput;
  where: GerneralItCostsWhereUniqueInput;
};


export type MutationUpdateGeneralItCostSubtypeArgs = {
  data: GerneralItCostSubtypeUpdateInput;
  where: GerneralItCostSubtypeWhereUniqueInput;
};


export type MutationUpdateGeneralItCostTypeArgs = {
  data: GerneralItCostTypeUpdateInput;
  where: GerneralItCostTypeWhereUniqueInput;
};


export type MutationUpdateGoalArgs = {
  data: GoalUpdateInput;
  where: GoalWhereUniqueInput;
};


export type MutationUpdateGoalsOnMasterArgs = {
  data: GoalsOnMasterUpdateInput;
  where: GoalsOnMasterWhereUniqueInput;
};


export type MutationUpdateInterfaceDetailArgs = {
  data: InterfaceDetailUpdateInput;
  where: InterfaceDetailWhereUniqueInput;
};


export type MutationUpdateInterfaceFormatArgs = {
  data: InterfaceFormatUpdateInput;
  where: InterfaceFormatWhereUniqueInput;
};


export type MutationUpdateInterfaceReferenceArgs = {
  data: InterfaceReferenceUpdateInput;
  where: InterfaceReferenceWhereUniqueInput;
};


export type MutationUpdateInterfaceTypeArgs = {
  data: InterfaceTypeUpdateInput;
  where: InterfaceTypeWhereUniqueInput;
};


export type MutationUpdateLandingApplicationArgs = {
  data: LandingApplicationUpdateInput;
  file?: InputMaybe<Scalars['Upload']>;
  where: LandingApplicationWhereUniqueInput;
};


export type MutationUpdateLandingApplicationClusterArgs = {
  data: LandingApplicationClusterUpdateInput;
  file?: InputMaybe<Scalars['Upload']>;
  where: LandingApplicationClusterWhereUniqueInput;
};


export type MutationUpdateLandingApplicationClusterGroupArgs = {
  data: LandingApplicationClusterGroupUpdateInput;
  where: LandingApplicationClusterGroupWhereUniqueInput;
};


export type MutationUpdateLandingApplicationClusterMappingArgs = {
  data: LandingApplicationClusterMappingUpdateInput;
  where: LandingApplicationClusterMappingWhereUniqueInput;
};


export type MutationUpdateLandingApplicationGroupArgs = {
  data: LandingApplicationGroupUpdateInput;
  where: LandingApplicationGroupWhereUniqueInput;
};


export type MutationUpdateLeanixMappingArgs = {
  data: LeanixMappingUpdateInput;
  where: LeanixMappingWhereUniqueInput;
};


export type MutationUpdateMasterArgs = {
  data: MasterUpdateInput;
  where: MasterWhereUniqueInput;
};


export type MutationUpdateMethodArgs = {
  data: MethodUpdateInput;
  where: MethodWhereUniqueInput;
};


export type MutationUpdatePhaseOnTypeArgs = {
  data: PhaseOnTypeUpdateInput;
  where: PhaseOnTypeWhereUniqueInput;
};


export type MutationUpdateProjectAllocationArgs = {
  data: ProjectAllocationUpdateInput;
  where: ProjectAllocationWhereUniqueInput;
};


export type MutationUpdateProjectApprovalArgs = {
  data: ProjectApprovalUpdateInput;
  where: ProjectApprovalWhereUniqueInput;
};


export type MutationUpdateProjectDependencyArgs = {
  data: ProjectDependencyUpdateInput;
  where: ProjectDependencyWhereUniqueInput;
};


export type MutationUpdateProjectDescriptionArgs = {
  data: ProjectDescriptionUpdateInput;
  where: ProjectDescriptionWhereUniqueInput;
};


export type MutationUpdateProjectDescriptionCommentArgs = {
  data: ProjectDescriptionCommentUpdateInput;
  where: ProjectDescriptionCommentWhereUniqueInput;
};


export type MutationUpdateProjectDocumentArgs = {
  data: ProjectDocumentsUpdateInput;
  file?: InputMaybe<Scalars['Upload']>;
  where: ProjectDocumentsWhereUniqueInput;
};


export type MutationUpdateProjectInterfaceArgs = {
  data: ProjectInterfaceUpdateInput;
  where: ProjectInterfaceWhereUniqueInput;
};


export type MutationUpdateProjectPhaseArgs = {
  data: ProjectPhaseUpdateInput;
  where: ProjectPhaseWhereUniqueInput;
};


export type MutationUpdateProjectPhaseCaptureArgs = {
  data: ProjectPhaseCaptureUpdateInput;
  where: ProjectPhaseCaptureWhereUniqueInput;
};


export type MutationUpdateProjectQuestionnaireArgs = {
  data: ProjectQuestionnaireUpdateInput;
  where: ProjectQuestionnaireWhereUniqueInput;
};


export type MutationUpdateProjectQuestionnaireStatusArgs = {
  data: ProjectQuestionnaireStatusUpdateInput;
  where: ProjectQuestionnaireStatusWhereUniqueInput;
};


export type MutationUpdateProjectResourceCaptureArgs = {
  data: ProjectResourceCaptureUpdateInput;
  where: ProjectResourceCaptureWhereUniqueInput;
};


export type MutationUpdateProjectRoleArgs = {
  data: ProjectRoleUpdateInput;
  where: ProjectRoleWhereUniqueInput;
};


export type MutationUpdateProjectShortHistoryArgs = {
  data: ProjectShortHistoryUpdateInput;
  where: ProjectShortHistoryWhereUniqueInput;
};


export type MutationUpdateProjectStatusArgs = {
  data: ProjectStatusUpdateInput;
  where: ProjectStatusWhereUniqueInput;
};


export type MutationUpdateProjectTypeArgs = {
  data: ProjectTypeUpdateInput;
  where: ProjectTypeWhereUniqueInput;
};


export type MutationUpdatePspMappingArgs = {
  data: PspMappingUpdateInput;
  where: PspMappingWhereUniqueInput;
};


export type MutationUpdateRemarkArgs = {
  data: RemarkUpdateInput;
  where: RemarkWhereUniqueInput;
};


export type MutationUpdateReplacementArgs = {
  data: ReplacementUpdateInput;
  where: ReplacementWhereUniqueInput;
};


export type MutationUpdateReportArgs = {
  data: ReportUpdateInput;
  where: ReportWhereUniqueInput;
};


export type MutationUpdateRiskArgs = {
  data: RiskUpdateInput;
  where: RiskWhereUniqueInput;
};


export type MutationUpdateRiskDamagePotentialArgs = {
  data: RiskDamagePotentialUpdateInput;
  where: RiskDamagePotentialWhereUniqueInput;
};


export type MutationUpdateRiskOccuranceArgs = {
  data: RiskOccuranceUpdateInput;
  where: RiskOccuranceWhereUniqueInput;
};


export type MutationUpdateRiskStatusArgs = {
  data: RiskStatusUpdateInput;
  where: RiskStatusWhereUniqueInput;
};


export type MutationUpdateRoleArgs = {
  data: RoleUpdateInput;
  where: RoleWhereUniqueInput;
};


export type MutationUpdateSecurityGroupArgs = {
  data: SecurityGroupUpdateInput;
  where: SecurityGroupWhereUniqueInput;
};


export type MutationUpdateSegmentArgs = {
  data: SegmentUpdateInput;
  where: SegmentWhereUniqueInput;
};


export type MutationUpdateSequenceStatusArgs = {
  data: SequenceStatusUpdateInput;
  where: SequenceStatusWhereUniqueInput;
};


export type MutationUpdateTargetedBudgetArgs = {
  data: TargetedBudgetUpdateInput;
  where: TargetedBudgetWhereUniqueInput;
};


export type MutationUpdateTemplateArgs = {
  data: TemplateUpdateInput;
  where: TemplateWhereUniqueInput;
};


export type MutationUpdateTemplateDocumentArgs = {
  data: TemplateDocumentsUpdateInput;
  where: TemplateDocumentsWhereUniqueInput;
};


export type MutationUpdateTopProjectArgs = {
  data: TopProjectsUpdateInput;
  where: TopProjectsWhereUniqueInput;
};

export type NestedBoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type NestedBoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolNullableFilter>;
};

export type NestedDateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type NestedDateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type NestedDateTimeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedDateTimeNullableFilter>;
  _min?: InputMaybe<NestedDateTimeNullableFilter>;
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type NestedDateTimeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedDateTimeFilter>;
  _min?: InputMaybe<NestedDateTimeFilter>;
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type NestedFloatFilter = {
  equals?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<NestedFloatFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

export type NestedFloatNullableFilter = {
  equals?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<NestedFloatNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

export type NestedFloatNullableWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatNullableFilter>;
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedFloatNullableFilter>;
  _min?: InputMaybe<NestedFloatNullableFilter>;
  _sum?: InputMaybe<NestedFloatNullableFilter>;
  equals?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<NestedFloatNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

export type NestedFloatWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatFilter>;
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedFloatFilter>;
  _min?: InputMaybe<NestedFloatFilter>;
  _sum?: InputMaybe<NestedFloatFilter>;
  equals?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<NestedFloatWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

export type NestedIntFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type NestedIntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type NestedIntNullableWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatNullableFilter>;
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedIntNullableFilter>;
  _min?: InputMaybe<NestedIntNullableFilter>;
  _sum?: InputMaybe<NestedIntNullableFilter>;
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type NestedIntWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatFilter>;
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedIntFilter>;
  _min?: InputMaybe<NestedIntFilter>;
  _sum?: InputMaybe<NestedIntFilter>;
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type NestedStringNullableFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type NestedStringNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedStringNullableFilter>;
  _min?: InputMaybe<NestedStringNullableFilter>;
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type NestedStringWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedStringFilter>;
  _min?: InputMaybe<NestedStringFilter>;
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type NullableBoolFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['Boolean']>;
};

export type NullableDateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['DateTime']>;
};

export type NullableFloatFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Float']>;
  divide?: InputMaybe<Scalars['Float']>;
  increment?: InputMaybe<Scalars['Float']>;
  multiply?: InputMaybe<Scalars['Float']>;
  set?: InputMaybe<Scalars['Float']>;
};

export type NullableIntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']>;
  divide?: InputMaybe<Scalars['Int']>;
  increment?: InputMaybe<Scalars['Int']>;
  multiply?: InputMaybe<Scalars['Int']>;
  set?: InputMaybe<Scalars['Int']>;
};

export type NullableStringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']>;
};

export type PhaseOnType = {
  __typename?: 'PhaseOnType';
  id: Scalars['ID'];
  projectPhase: ProjectPhase;
  projectPhaseId: Scalars['String'];
  projectType: ProjectType;
  projectTypeId: Scalars['String'];
};

export type PhaseOnTypeCreateInput = {
  id?: InputMaybe<Scalars['String']>;
  projectPhase: ProjectPhaseCreateNestedOneWithoutPhaseOnTypeInput;
  projectType: ProjectTypeCreateNestedOneWithoutPhaseOnTypeInput;
};

export type PhaseOnTypeCreateManyProjectPhaseInput = {
  id?: InputMaybe<Scalars['String']>;
  projectTypeId: Scalars['String'];
};

export type PhaseOnTypeCreateManyProjectPhaseInputEnvelope = {
  data: Array<PhaseOnTypeCreateManyProjectPhaseInput>;
};

export type PhaseOnTypeCreateManyProjectTypeInput = {
  id?: InputMaybe<Scalars['String']>;
  projectPhaseId: Scalars['String'];
};

export type PhaseOnTypeCreateManyProjectTypeInputEnvelope = {
  data: Array<PhaseOnTypeCreateManyProjectTypeInput>;
};

export type PhaseOnTypeCreateNestedManyWithoutProjectPhaseInput = {
  connect?: InputMaybe<Array<PhaseOnTypeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PhaseOnTypeCreateOrConnectWithoutProjectPhaseInput>>;
  create?: InputMaybe<Array<PhaseOnTypeCreateWithoutProjectPhaseInput>>;
  createMany?: InputMaybe<PhaseOnTypeCreateManyProjectPhaseInputEnvelope>;
};

export type PhaseOnTypeCreateNestedManyWithoutProjectTypeInput = {
  connect?: InputMaybe<Array<PhaseOnTypeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PhaseOnTypeCreateOrConnectWithoutProjectTypeInput>>;
  create?: InputMaybe<Array<PhaseOnTypeCreateWithoutProjectTypeInput>>;
  createMany?: InputMaybe<PhaseOnTypeCreateManyProjectTypeInputEnvelope>;
};

export type PhaseOnTypeCreateOrConnectWithoutProjectPhaseInput = {
  create: PhaseOnTypeCreateWithoutProjectPhaseInput;
  where: PhaseOnTypeWhereUniqueInput;
};

export type PhaseOnTypeCreateOrConnectWithoutProjectTypeInput = {
  create: PhaseOnTypeCreateWithoutProjectTypeInput;
  where: PhaseOnTypeWhereUniqueInput;
};

export type PhaseOnTypeCreateWithoutProjectPhaseInput = {
  id?: InputMaybe<Scalars['String']>;
  projectType: ProjectTypeCreateNestedOneWithoutPhaseOnTypeInput;
};

export type PhaseOnTypeCreateWithoutProjectTypeInput = {
  id?: InputMaybe<Scalars['String']>;
  projectPhase: ProjectPhaseCreateNestedOneWithoutPhaseOnTypeInput;
};

export type PhaseOnTypeListRelationFilter = {
  every?: InputMaybe<PhaseOnTypeWhereInput>;
  none?: InputMaybe<PhaseOnTypeWhereInput>;
  some?: InputMaybe<PhaseOnTypeWhereInput>;
};

export type PhaseOnTypeOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PhaseOnTypeOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>;
  projectPhase?: InputMaybe<ProjectPhaseOrderByWithRelationInput>;
  projectPhaseId?: InputMaybe<SortOrder>;
  projectType?: InputMaybe<ProjectTypeOrderByWithRelationInput>;
  projectTypeId?: InputMaybe<SortOrder>;
};

export enum PhaseOnTypeScalarFieldEnum {
  Id = 'id',
  ProjectPhaseId = 'projectPhaseId',
  ProjectTypeId = 'projectTypeId'
}

export type PhaseOnTypeScalarWhereInput = {
  AND?: InputMaybe<Array<PhaseOnTypeScalarWhereInput>>;
  NOT?: InputMaybe<Array<PhaseOnTypeScalarWhereInput>>;
  OR?: InputMaybe<Array<PhaseOnTypeScalarWhereInput>>;
  id?: InputMaybe<StringFilter>;
  projectPhaseId?: InputMaybe<StringFilter>;
  projectTypeId?: InputMaybe<StringFilter>;
};

export type PhaseOnTypeUpdateInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  projectPhase?: InputMaybe<ProjectPhaseUpdateOneRequiredWithoutPhaseOnTypeNestedInput>;
  projectType?: InputMaybe<ProjectTypeUpdateOneRequiredWithoutPhaseOnTypeNestedInput>;
};

export type PhaseOnTypeUpdateManyMutationInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type PhaseOnTypeUpdateManyWithWhereWithoutProjectPhaseInput = {
  data: PhaseOnTypeUpdateManyMutationInput;
  where: PhaseOnTypeScalarWhereInput;
};

export type PhaseOnTypeUpdateManyWithWhereWithoutProjectTypeInput = {
  data: PhaseOnTypeUpdateManyMutationInput;
  where: PhaseOnTypeScalarWhereInput;
};

export type PhaseOnTypeUpdateManyWithoutProjectPhaseNestedInput = {
  connect?: InputMaybe<Array<PhaseOnTypeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PhaseOnTypeCreateOrConnectWithoutProjectPhaseInput>>;
  create?: InputMaybe<Array<PhaseOnTypeCreateWithoutProjectPhaseInput>>;
  createMany?: InputMaybe<PhaseOnTypeCreateManyProjectPhaseInputEnvelope>;
  delete?: InputMaybe<Array<PhaseOnTypeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PhaseOnTypeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PhaseOnTypeWhereUniqueInput>>;
  set?: InputMaybe<Array<PhaseOnTypeWhereUniqueInput>>;
  update?: InputMaybe<Array<PhaseOnTypeUpdateWithWhereUniqueWithoutProjectPhaseInput>>;
  updateMany?: InputMaybe<Array<PhaseOnTypeUpdateManyWithWhereWithoutProjectPhaseInput>>;
  upsert?: InputMaybe<Array<PhaseOnTypeUpsertWithWhereUniqueWithoutProjectPhaseInput>>;
};

export type PhaseOnTypeUpdateManyWithoutProjectTypeNestedInput = {
  connect?: InputMaybe<Array<PhaseOnTypeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PhaseOnTypeCreateOrConnectWithoutProjectTypeInput>>;
  create?: InputMaybe<Array<PhaseOnTypeCreateWithoutProjectTypeInput>>;
  createMany?: InputMaybe<PhaseOnTypeCreateManyProjectTypeInputEnvelope>;
  delete?: InputMaybe<Array<PhaseOnTypeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PhaseOnTypeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PhaseOnTypeWhereUniqueInput>>;
  set?: InputMaybe<Array<PhaseOnTypeWhereUniqueInput>>;
  update?: InputMaybe<Array<PhaseOnTypeUpdateWithWhereUniqueWithoutProjectTypeInput>>;
  updateMany?: InputMaybe<Array<PhaseOnTypeUpdateManyWithWhereWithoutProjectTypeInput>>;
  upsert?: InputMaybe<Array<PhaseOnTypeUpsertWithWhereUniqueWithoutProjectTypeInput>>;
};

export type PhaseOnTypeUpdateWithWhereUniqueWithoutProjectPhaseInput = {
  data: PhaseOnTypeUpdateWithoutProjectPhaseInput;
  where: PhaseOnTypeWhereUniqueInput;
};

export type PhaseOnTypeUpdateWithWhereUniqueWithoutProjectTypeInput = {
  data: PhaseOnTypeUpdateWithoutProjectTypeInput;
  where: PhaseOnTypeWhereUniqueInput;
};

export type PhaseOnTypeUpdateWithoutProjectPhaseInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  projectType?: InputMaybe<ProjectTypeUpdateOneRequiredWithoutPhaseOnTypeNestedInput>;
};

export type PhaseOnTypeUpdateWithoutProjectTypeInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  projectPhase?: InputMaybe<ProjectPhaseUpdateOneRequiredWithoutPhaseOnTypeNestedInput>;
};

export type PhaseOnTypeUpsertWithWhereUniqueWithoutProjectPhaseInput = {
  create: PhaseOnTypeCreateWithoutProjectPhaseInput;
  update: PhaseOnTypeUpdateWithoutProjectPhaseInput;
  where: PhaseOnTypeWhereUniqueInput;
};

export type PhaseOnTypeUpsertWithWhereUniqueWithoutProjectTypeInput = {
  create: PhaseOnTypeCreateWithoutProjectTypeInput;
  update: PhaseOnTypeUpdateWithoutProjectTypeInput;
  where: PhaseOnTypeWhereUniqueInput;
};

export type PhaseOnTypeWhereInput = {
  AND?: InputMaybe<Array<PhaseOnTypeWhereInput>>;
  NOT?: InputMaybe<Array<PhaseOnTypeWhereInput>>;
  OR?: InputMaybe<Array<PhaseOnTypeWhereInput>>;
  id?: InputMaybe<StringFilter>;
  projectPhase?: InputMaybe<ProjectPhaseWhereInput>;
  projectPhaseId?: InputMaybe<StringFilter>;
  projectType?: InputMaybe<ProjectTypeWhereInput>;
  projectTypeId?: InputMaybe<StringFilter>;
};

export type PhaseOnTypeWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type ProjectAllocation = {
  __typename?: 'ProjectAllocation';
  allocation: Allocation;
  allocationId: Scalars['String'];
  id: Scalars['ID'];
  percentage: Scalars['Float'];
  project: Master;
  projectId: Scalars['String'];
};

export type ProjectAllocationCreateInput = {
  allocation: AllocationCreateNestedOneWithoutProjectAllocationsInput;
  id?: InputMaybe<Scalars['String']>;
  percentage: Scalars['Float'];
  project: MasterCreateNestedOneWithoutProjectAllocationsInput;
};

export type ProjectAllocationCreateManyAllocationInput = {
  id?: InputMaybe<Scalars['String']>;
  percentage: Scalars['Float'];
  projectId: Scalars['String'];
};

export type ProjectAllocationCreateManyAllocationInputEnvelope = {
  data: Array<ProjectAllocationCreateManyAllocationInput>;
};

export type ProjectAllocationCreateManyProjectInput = {
  allocationId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  percentage: Scalars['Float'];
};

export type ProjectAllocationCreateManyProjectInputEnvelope = {
  data: Array<ProjectAllocationCreateManyProjectInput>;
};

export type ProjectAllocationCreateNestedManyWithoutAllocationInput = {
  connect?: InputMaybe<Array<ProjectAllocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectAllocationCreateOrConnectWithoutAllocationInput>>;
  create?: InputMaybe<Array<ProjectAllocationCreateWithoutAllocationInput>>;
  createMany?: InputMaybe<ProjectAllocationCreateManyAllocationInputEnvelope>;
};

export type ProjectAllocationCreateNestedManyWithoutProjectInput = {
  connect?: InputMaybe<Array<ProjectAllocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectAllocationCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<ProjectAllocationCreateWithoutProjectInput>>;
  createMany?: InputMaybe<ProjectAllocationCreateManyProjectInputEnvelope>;
};

export type ProjectAllocationCreateOrConnectWithoutAllocationInput = {
  create: ProjectAllocationCreateWithoutAllocationInput;
  where: ProjectAllocationWhereUniqueInput;
};

export type ProjectAllocationCreateOrConnectWithoutProjectInput = {
  create: ProjectAllocationCreateWithoutProjectInput;
  where: ProjectAllocationWhereUniqueInput;
};

export type ProjectAllocationCreateWithoutAllocationInput = {
  id?: InputMaybe<Scalars['String']>;
  percentage: Scalars['Float'];
  project: MasterCreateNestedOneWithoutProjectAllocationsInput;
};

export type ProjectAllocationCreateWithoutProjectInput = {
  allocation: AllocationCreateNestedOneWithoutProjectAllocationsInput;
  id?: InputMaybe<Scalars['String']>;
  percentage: Scalars['Float'];
};

export type ProjectAllocationListRelationFilter = {
  every?: InputMaybe<ProjectAllocationWhereInput>;
  none?: InputMaybe<ProjectAllocationWhereInput>;
  some?: InputMaybe<ProjectAllocationWhereInput>;
};

export type ProjectAllocationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProjectAllocationOrderByWithRelationInput = {
  allocation?: InputMaybe<AllocationOrderByWithRelationInput>;
  allocationId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  percentage?: InputMaybe<SortOrder>;
  project?: InputMaybe<MasterOrderByWithRelationInput>;
  projectId?: InputMaybe<SortOrder>;
};

export enum ProjectAllocationScalarFieldEnum {
  AllocationId = 'allocationId',
  Id = 'id',
  Percentage = 'percentage',
  ProjectId = 'projectId'
}

export type ProjectAllocationScalarWhereInput = {
  AND?: InputMaybe<Array<ProjectAllocationScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProjectAllocationScalarWhereInput>>;
  OR?: InputMaybe<Array<ProjectAllocationScalarWhereInput>>;
  allocationId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  percentage?: InputMaybe<FloatFilter>;
  projectId?: InputMaybe<StringFilter>;
};

export type ProjectAllocationUpdateInput = {
  allocation?: InputMaybe<AllocationUpdateOneRequiredWithoutProjectAllocationsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  percentage?: InputMaybe<FloatFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutProjectAllocationsNestedInput>;
};

export type ProjectAllocationUpdateManyMutationInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  percentage?: InputMaybe<FloatFieldUpdateOperationsInput>;
};

export type ProjectAllocationUpdateManyWithWhereWithoutAllocationInput = {
  data: ProjectAllocationUpdateManyMutationInput;
  where: ProjectAllocationScalarWhereInput;
};

export type ProjectAllocationUpdateManyWithWhereWithoutProjectInput = {
  data: ProjectAllocationUpdateManyMutationInput;
  where: ProjectAllocationScalarWhereInput;
};

export type ProjectAllocationUpdateManyWithoutAllocationNestedInput = {
  connect?: InputMaybe<Array<ProjectAllocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectAllocationCreateOrConnectWithoutAllocationInput>>;
  create?: InputMaybe<Array<ProjectAllocationCreateWithoutAllocationInput>>;
  createMany?: InputMaybe<ProjectAllocationCreateManyAllocationInputEnvelope>;
  delete?: InputMaybe<Array<ProjectAllocationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProjectAllocationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProjectAllocationWhereUniqueInput>>;
  set?: InputMaybe<Array<ProjectAllocationWhereUniqueInput>>;
  update?: InputMaybe<Array<ProjectAllocationUpdateWithWhereUniqueWithoutAllocationInput>>;
  updateMany?: InputMaybe<Array<ProjectAllocationUpdateManyWithWhereWithoutAllocationInput>>;
  upsert?: InputMaybe<Array<ProjectAllocationUpsertWithWhereUniqueWithoutAllocationInput>>;
};

export type ProjectAllocationUpdateManyWithoutProjectNestedInput = {
  connect?: InputMaybe<Array<ProjectAllocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectAllocationCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<ProjectAllocationCreateWithoutProjectInput>>;
  createMany?: InputMaybe<ProjectAllocationCreateManyProjectInputEnvelope>;
  delete?: InputMaybe<Array<ProjectAllocationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProjectAllocationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProjectAllocationWhereUniqueInput>>;
  set?: InputMaybe<Array<ProjectAllocationWhereUniqueInput>>;
  update?: InputMaybe<Array<ProjectAllocationUpdateWithWhereUniqueWithoutProjectInput>>;
  updateMany?: InputMaybe<Array<ProjectAllocationUpdateManyWithWhereWithoutProjectInput>>;
  upsert?: InputMaybe<Array<ProjectAllocationUpsertWithWhereUniqueWithoutProjectInput>>;
};

export type ProjectAllocationUpdateWithWhereUniqueWithoutAllocationInput = {
  data: ProjectAllocationUpdateWithoutAllocationInput;
  where: ProjectAllocationWhereUniqueInput;
};

export type ProjectAllocationUpdateWithWhereUniqueWithoutProjectInput = {
  data: ProjectAllocationUpdateWithoutProjectInput;
  where: ProjectAllocationWhereUniqueInput;
};

export type ProjectAllocationUpdateWithoutAllocationInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  percentage?: InputMaybe<FloatFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutProjectAllocationsNestedInput>;
};

export type ProjectAllocationUpdateWithoutProjectInput = {
  allocation?: InputMaybe<AllocationUpdateOneRequiredWithoutProjectAllocationsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  percentage?: InputMaybe<FloatFieldUpdateOperationsInput>;
};

export type ProjectAllocationUpsertWithWhereUniqueWithoutAllocationInput = {
  create: ProjectAllocationCreateWithoutAllocationInput;
  update: ProjectAllocationUpdateWithoutAllocationInput;
  where: ProjectAllocationWhereUniqueInput;
};

export type ProjectAllocationUpsertWithWhereUniqueWithoutProjectInput = {
  create: ProjectAllocationCreateWithoutProjectInput;
  update: ProjectAllocationUpdateWithoutProjectInput;
  where: ProjectAllocationWhereUniqueInput;
};

export type ProjectAllocationWhereInput = {
  AND?: InputMaybe<Array<ProjectAllocationWhereInput>>;
  NOT?: InputMaybe<Array<ProjectAllocationWhereInput>>;
  OR?: InputMaybe<Array<ProjectAllocationWhereInput>>;
  allocation?: InputMaybe<AllocationWhereInput>;
  allocationId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  percentage?: InputMaybe<FloatFilter>;
  project?: InputMaybe<MasterWhereInput>;
  projectId?: InputMaybe<StringFilter>;
};

export type ProjectAllocationWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type ProjectApproval = {
  __typename?: 'ProjectApproval';
  ApprovalBoard: ApprovalBoard;
  approvalBoardId: Scalars['String'];
  approvalDate?: Maybe<Scalars['DateTime']>;
  approvalStatus?: Maybe<ApprovalStatus>;
  approvalStatusId?: Maybe<Scalars['String']>;
  approverId?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  project: Master;
  projectId: Scalars['String'];
};

export type ProjectApprovalCreateInput = {
  ApprovalBoard: ApprovalBoardCreateNestedOneWithoutProjectApprovalInput;
  approvalDate?: InputMaybe<Scalars['DateTime']>;
  approvalStatus?: InputMaybe<ApprovalStatusCreateNestedOneWithoutProjectApprovalInput>;
  approverId?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  project: MasterCreateNestedOneWithoutProjectApprovalInput;
};

export type ProjectApprovalCreateManyApprovalBoardInput = {
  approvalDate?: InputMaybe<Scalars['DateTime']>;
  approvalStatusId?: InputMaybe<Scalars['String']>;
  approverId?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
};

export type ProjectApprovalCreateManyApprovalBoardInputEnvelope = {
  data: Array<ProjectApprovalCreateManyApprovalBoardInput>;
};

export type ProjectApprovalCreateManyApprovalStatusInput = {
  approvalBoardId: Scalars['String'];
  approvalDate?: InputMaybe<Scalars['DateTime']>;
  approverId?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
};

export type ProjectApprovalCreateManyApprovalStatusInputEnvelope = {
  data: Array<ProjectApprovalCreateManyApprovalStatusInput>;
};

export type ProjectApprovalCreateManyProjectInput = {
  approvalBoardId: Scalars['String'];
  approvalDate?: InputMaybe<Scalars['DateTime']>;
  approvalStatusId?: InputMaybe<Scalars['String']>;
  approverId?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
};

export type ProjectApprovalCreateManyProjectInputEnvelope = {
  data: Array<ProjectApprovalCreateManyProjectInput>;
};

export type ProjectApprovalCreateNestedManyWithoutApprovalBoardInput = {
  connect?: InputMaybe<Array<ProjectApprovalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectApprovalCreateOrConnectWithoutApprovalBoardInput>>;
  create?: InputMaybe<Array<ProjectApprovalCreateWithoutApprovalBoardInput>>;
  createMany?: InputMaybe<ProjectApprovalCreateManyApprovalBoardInputEnvelope>;
};

export type ProjectApprovalCreateNestedManyWithoutApprovalStatusInput = {
  connect?: InputMaybe<Array<ProjectApprovalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectApprovalCreateOrConnectWithoutApprovalStatusInput>>;
  create?: InputMaybe<Array<ProjectApprovalCreateWithoutApprovalStatusInput>>;
  createMany?: InputMaybe<ProjectApprovalCreateManyApprovalStatusInputEnvelope>;
};

export type ProjectApprovalCreateNestedManyWithoutProjectInput = {
  connect?: InputMaybe<Array<ProjectApprovalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectApprovalCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<ProjectApprovalCreateWithoutProjectInput>>;
  createMany?: InputMaybe<ProjectApprovalCreateManyProjectInputEnvelope>;
};

export type ProjectApprovalCreateOrConnectWithoutApprovalBoardInput = {
  create: ProjectApprovalCreateWithoutApprovalBoardInput;
  where: ProjectApprovalWhereUniqueInput;
};

export type ProjectApprovalCreateOrConnectWithoutApprovalStatusInput = {
  create: ProjectApprovalCreateWithoutApprovalStatusInput;
  where: ProjectApprovalWhereUniqueInput;
};

export type ProjectApprovalCreateOrConnectWithoutProjectInput = {
  create: ProjectApprovalCreateWithoutProjectInput;
  where: ProjectApprovalWhereUniqueInput;
};

export type ProjectApprovalCreateWithoutApprovalBoardInput = {
  approvalDate?: InputMaybe<Scalars['DateTime']>;
  approvalStatus?: InputMaybe<ApprovalStatusCreateNestedOneWithoutProjectApprovalInput>;
  approverId?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  project: MasterCreateNestedOneWithoutProjectApprovalInput;
};

export type ProjectApprovalCreateWithoutApprovalStatusInput = {
  ApprovalBoard: ApprovalBoardCreateNestedOneWithoutProjectApprovalInput;
  approvalDate?: InputMaybe<Scalars['DateTime']>;
  approverId?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  project: MasterCreateNestedOneWithoutProjectApprovalInput;
};

export type ProjectApprovalCreateWithoutProjectInput = {
  ApprovalBoard: ApprovalBoardCreateNestedOneWithoutProjectApprovalInput;
  approvalDate?: InputMaybe<Scalars['DateTime']>;
  approvalStatus?: InputMaybe<ApprovalStatusCreateNestedOneWithoutProjectApprovalInput>;
  approverId?: InputMaybe<Scalars['String']>;
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
};

export type ProjectApprovalListRelationFilter = {
  every?: InputMaybe<ProjectApprovalWhereInput>;
  none?: InputMaybe<ProjectApprovalWhereInput>;
  some?: InputMaybe<ProjectApprovalWhereInput>;
};

export type ProjectApprovalOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProjectApprovalOrderByWithRelationInput = {
  ApprovalBoard?: InputMaybe<ApprovalBoardOrderByWithRelationInput>;
  approvalBoardId?: InputMaybe<SortOrder>;
  approvalDate?: InputMaybe<SortOrder>;
  approvalStatus?: InputMaybe<ApprovalStatusOrderByWithRelationInput>;
  approvalStatusId?: InputMaybe<SortOrder>;
  approverId?: InputMaybe<SortOrder>;
  comment?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  deletedBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  project?: InputMaybe<MasterOrderByWithRelationInput>;
  projectId?: InputMaybe<SortOrder>;
};

export enum ProjectApprovalScalarFieldEnum {
  ApprovalBoardId = 'approvalBoardId',
  ApprovalDate = 'approvalDate',
  ApprovalStatusId = 'approvalStatusId',
  ApproverId = 'approverId',
  Comment = 'comment',
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  DeletedAt = 'deletedAt',
  DeletedBy = 'deletedBy',
  Id = 'id',
  ProjectId = 'projectId'
}

export type ProjectApprovalScalarWhereInput = {
  AND?: InputMaybe<Array<ProjectApprovalScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProjectApprovalScalarWhereInput>>;
  OR?: InputMaybe<Array<ProjectApprovalScalarWhereInput>>;
  approvalBoardId?: InputMaybe<StringFilter>;
  approvalDate?: InputMaybe<DateTimeNullableFilter>;
  approvalStatusId?: InputMaybe<StringNullableFilter>;
  approverId?: InputMaybe<StringNullableFilter>;
  comment?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  projectId?: InputMaybe<StringFilter>;
};

export type ProjectApprovalUpdateInput = {
  ApprovalBoard?: InputMaybe<ApprovalBoardUpdateOneRequiredWithoutProjectApprovalNestedInput>;
  approvalDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  approvalStatus?: InputMaybe<ApprovalStatusUpdateOneWithoutProjectApprovalNestedInput>;
  approverId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  comment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutProjectApprovalNestedInput>;
};

export type ProjectApprovalUpdateManyMutationInput = {
  approvalDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  approverId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  comment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ProjectApprovalUpdateManyWithWhereWithoutApprovalBoardInput = {
  data: ProjectApprovalUpdateManyMutationInput;
  where: ProjectApprovalScalarWhereInput;
};

export type ProjectApprovalUpdateManyWithWhereWithoutApprovalStatusInput = {
  data: ProjectApprovalUpdateManyMutationInput;
  where: ProjectApprovalScalarWhereInput;
};

export type ProjectApprovalUpdateManyWithWhereWithoutProjectInput = {
  data: ProjectApprovalUpdateManyMutationInput;
  where: ProjectApprovalScalarWhereInput;
};

export type ProjectApprovalUpdateManyWithoutApprovalBoardNestedInput = {
  connect?: InputMaybe<Array<ProjectApprovalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectApprovalCreateOrConnectWithoutApprovalBoardInput>>;
  create?: InputMaybe<Array<ProjectApprovalCreateWithoutApprovalBoardInput>>;
  createMany?: InputMaybe<ProjectApprovalCreateManyApprovalBoardInputEnvelope>;
  delete?: InputMaybe<Array<ProjectApprovalWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProjectApprovalScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProjectApprovalWhereUniqueInput>>;
  set?: InputMaybe<Array<ProjectApprovalWhereUniqueInput>>;
  update?: InputMaybe<Array<ProjectApprovalUpdateWithWhereUniqueWithoutApprovalBoardInput>>;
  updateMany?: InputMaybe<Array<ProjectApprovalUpdateManyWithWhereWithoutApprovalBoardInput>>;
  upsert?: InputMaybe<Array<ProjectApprovalUpsertWithWhereUniqueWithoutApprovalBoardInput>>;
};

export type ProjectApprovalUpdateManyWithoutApprovalStatusNestedInput = {
  connect?: InputMaybe<Array<ProjectApprovalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectApprovalCreateOrConnectWithoutApprovalStatusInput>>;
  create?: InputMaybe<Array<ProjectApprovalCreateWithoutApprovalStatusInput>>;
  createMany?: InputMaybe<ProjectApprovalCreateManyApprovalStatusInputEnvelope>;
  delete?: InputMaybe<Array<ProjectApprovalWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProjectApprovalScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProjectApprovalWhereUniqueInput>>;
  set?: InputMaybe<Array<ProjectApprovalWhereUniqueInput>>;
  update?: InputMaybe<Array<ProjectApprovalUpdateWithWhereUniqueWithoutApprovalStatusInput>>;
  updateMany?: InputMaybe<Array<ProjectApprovalUpdateManyWithWhereWithoutApprovalStatusInput>>;
  upsert?: InputMaybe<Array<ProjectApprovalUpsertWithWhereUniqueWithoutApprovalStatusInput>>;
};

export type ProjectApprovalUpdateManyWithoutProjectNestedInput = {
  connect?: InputMaybe<Array<ProjectApprovalWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectApprovalCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<ProjectApprovalCreateWithoutProjectInput>>;
  createMany?: InputMaybe<ProjectApprovalCreateManyProjectInputEnvelope>;
  delete?: InputMaybe<Array<ProjectApprovalWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProjectApprovalScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProjectApprovalWhereUniqueInput>>;
  set?: InputMaybe<Array<ProjectApprovalWhereUniqueInput>>;
  update?: InputMaybe<Array<ProjectApprovalUpdateWithWhereUniqueWithoutProjectInput>>;
  updateMany?: InputMaybe<Array<ProjectApprovalUpdateManyWithWhereWithoutProjectInput>>;
  upsert?: InputMaybe<Array<ProjectApprovalUpsertWithWhereUniqueWithoutProjectInput>>;
};

export type ProjectApprovalUpdateWithWhereUniqueWithoutApprovalBoardInput = {
  data: ProjectApprovalUpdateWithoutApprovalBoardInput;
  where: ProjectApprovalWhereUniqueInput;
};

export type ProjectApprovalUpdateWithWhereUniqueWithoutApprovalStatusInput = {
  data: ProjectApprovalUpdateWithoutApprovalStatusInput;
  where: ProjectApprovalWhereUniqueInput;
};

export type ProjectApprovalUpdateWithWhereUniqueWithoutProjectInput = {
  data: ProjectApprovalUpdateWithoutProjectInput;
  where: ProjectApprovalWhereUniqueInput;
};

export type ProjectApprovalUpdateWithoutApprovalBoardInput = {
  approvalDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  approvalStatus?: InputMaybe<ApprovalStatusUpdateOneWithoutProjectApprovalNestedInput>;
  approverId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  comment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutProjectApprovalNestedInput>;
};

export type ProjectApprovalUpdateWithoutApprovalStatusInput = {
  ApprovalBoard?: InputMaybe<ApprovalBoardUpdateOneRequiredWithoutProjectApprovalNestedInput>;
  approvalDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  approverId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  comment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutProjectApprovalNestedInput>;
};

export type ProjectApprovalUpdateWithoutProjectInput = {
  ApprovalBoard?: InputMaybe<ApprovalBoardUpdateOneRequiredWithoutProjectApprovalNestedInput>;
  approvalDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  approvalStatus?: InputMaybe<ApprovalStatusUpdateOneWithoutProjectApprovalNestedInput>;
  approverId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  comment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ProjectApprovalUpsertWithWhereUniqueWithoutApprovalBoardInput = {
  create: ProjectApprovalCreateWithoutApprovalBoardInput;
  update: ProjectApprovalUpdateWithoutApprovalBoardInput;
  where: ProjectApprovalWhereUniqueInput;
};

export type ProjectApprovalUpsertWithWhereUniqueWithoutApprovalStatusInput = {
  create: ProjectApprovalCreateWithoutApprovalStatusInput;
  update: ProjectApprovalUpdateWithoutApprovalStatusInput;
  where: ProjectApprovalWhereUniqueInput;
};

export type ProjectApprovalUpsertWithWhereUniqueWithoutProjectInput = {
  create: ProjectApprovalCreateWithoutProjectInput;
  update: ProjectApprovalUpdateWithoutProjectInput;
  where: ProjectApprovalWhereUniqueInput;
};

export type ProjectApprovalWhereInput = {
  AND?: InputMaybe<Array<ProjectApprovalWhereInput>>;
  ApprovalBoard?: InputMaybe<ApprovalBoardWhereInput>;
  NOT?: InputMaybe<Array<ProjectApprovalWhereInput>>;
  OR?: InputMaybe<Array<ProjectApprovalWhereInput>>;
  approvalBoardId?: InputMaybe<StringFilter>;
  approvalDate?: InputMaybe<DateTimeNullableFilter>;
  approvalStatus?: InputMaybe<ApprovalStatusWhereInput>;
  approvalStatusId?: InputMaybe<StringNullableFilter>;
  approverId?: InputMaybe<StringNullableFilter>;
  comment?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  project?: InputMaybe<MasterWhereInput>;
  projectId?: InputMaybe<StringFilter>;
};

export type ProjectApprovalWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type ProjectDependency = {
  __typename?: 'ProjectDependency';
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isParent: Scalars['Boolean'];
  leanixId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  project: Master;
  projectId: Scalars['String'];
};

export type ProjectDependencyCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isParent: Scalars['Boolean'];
  leanixId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  project: MasterCreateNestedOneWithoutProjectDependencyInput;
};

export type ProjectDependencyCreateManyProjectInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isParent: Scalars['Boolean'];
  leanixId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type ProjectDependencyCreateManyProjectInputEnvelope = {
  data: Array<ProjectDependencyCreateManyProjectInput>;
};

export type ProjectDependencyCreateNestedManyWithoutProjectInput = {
  connect?: InputMaybe<Array<ProjectDependencyWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectDependencyCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<ProjectDependencyCreateWithoutProjectInput>>;
  createMany?: InputMaybe<ProjectDependencyCreateManyProjectInputEnvelope>;
};

export type ProjectDependencyCreateOrConnectWithoutProjectInput = {
  create: ProjectDependencyCreateWithoutProjectInput;
  where: ProjectDependencyWhereUniqueInput;
};

export type ProjectDependencyCreateWithoutProjectInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isParent: Scalars['Boolean'];
  leanixId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type ProjectDependencyListRelationFilter = {
  every?: InputMaybe<ProjectDependencyWhereInput>;
  none?: InputMaybe<ProjectDependencyWhereInput>;
  some?: InputMaybe<ProjectDependencyWhereInput>;
};

export type ProjectDependencyOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProjectDependencyOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  deletedBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isParent?: InputMaybe<SortOrder>;
  leanixId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  project?: InputMaybe<MasterOrderByWithRelationInput>;
  projectId?: InputMaybe<SortOrder>;
};

export enum ProjectDependencyScalarFieldEnum {
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  DeletedAt = 'deletedAt',
  DeletedBy = 'deletedBy',
  Id = 'id',
  IsParent = 'isParent',
  LeanixId = 'leanixId',
  Name = 'name',
  ProjectId = 'projectId'
}

export type ProjectDependencyScalarWhereInput = {
  AND?: InputMaybe<Array<ProjectDependencyScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProjectDependencyScalarWhereInput>>;
  OR?: InputMaybe<Array<ProjectDependencyScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isParent?: InputMaybe<BoolFilter>;
  leanixId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  projectId?: InputMaybe<StringFilter>;
};

export type ProjectDependencyUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isParent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  leanixId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutProjectDependencyNestedInput>;
};

export type ProjectDependencyUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isParent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  leanixId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ProjectDependencyUpdateManyWithWhereWithoutProjectInput = {
  data: ProjectDependencyUpdateManyMutationInput;
  where: ProjectDependencyScalarWhereInput;
};

export type ProjectDependencyUpdateManyWithoutProjectNestedInput = {
  connect?: InputMaybe<Array<ProjectDependencyWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectDependencyCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<ProjectDependencyCreateWithoutProjectInput>>;
  createMany?: InputMaybe<ProjectDependencyCreateManyProjectInputEnvelope>;
  delete?: InputMaybe<Array<ProjectDependencyWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProjectDependencyScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProjectDependencyWhereUniqueInput>>;
  set?: InputMaybe<Array<ProjectDependencyWhereUniqueInput>>;
  update?: InputMaybe<Array<ProjectDependencyUpdateWithWhereUniqueWithoutProjectInput>>;
  updateMany?: InputMaybe<Array<ProjectDependencyUpdateManyWithWhereWithoutProjectInput>>;
  upsert?: InputMaybe<Array<ProjectDependencyUpsertWithWhereUniqueWithoutProjectInput>>;
};

export type ProjectDependencyUpdateWithWhereUniqueWithoutProjectInput = {
  data: ProjectDependencyUpdateWithoutProjectInput;
  where: ProjectDependencyWhereUniqueInput;
};

export type ProjectDependencyUpdateWithoutProjectInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isParent?: InputMaybe<BoolFieldUpdateOperationsInput>;
  leanixId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ProjectDependencyUpsertWithWhereUniqueWithoutProjectInput = {
  create: ProjectDependencyCreateWithoutProjectInput;
  update: ProjectDependencyUpdateWithoutProjectInput;
  where: ProjectDependencyWhereUniqueInput;
};

export type ProjectDependencyWhereInput = {
  AND?: InputMaybe<Array<ProjectDependencyWhereInput>>;
  NOT?: InputMaybe<Array<ProjectDependencyWhereInput>>;
  OR?: InputMaybe<Array<ProjectDependencyWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isParent?: InputMaybe<BoolFilter>;
  leanixId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  project?: InputMaybe<MasterWhereInput>;
  projectId?: InputMaybe<StringFilter>;
};

export type ProjectDependencyWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type ProjectDescription = {
  __typename?: 'ProjectDescription';
  afa?: Maybe<Scalars['Float']>;
  background?: Maybe<Scalars['String']>;
  category?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  costLocation?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  funding?: Maybe<Funding>;
  fundingId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  master: Master;
  method?: Maybe<Method>;
  methodId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  planing?: Maybe<Scalars['String']>;
  procedure?: Maybe<Scalars['String']>;
  projectDuration?: Maybe<Scalars['Int']>;
  projectId: Scalars['String'];
  projectStart?: Maybe<Scalars['DateTime']>;
  projectType: ProjectType;
  projectTypeId: Scalars['String'];
  sbk?: Maybe<Scalars['String']>;
};

export type ProjectDescriptionComment = {
  __typename?: 'ProjectDescriptionComment';
  comment: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  project: Master;
  projectId: Scalars['String'];
};

export type ProjectDescriptionCommentCreateInput = {
  comment: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  project: MasterCreateNestedOneWithoutProjectDescriptionCommentInput;
};

export type ProjectDescriptionCommentCreateManyProjectInput = {
  comment: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type ProjectDescriptionCommentCreateManyProjectInputEnvelope = {
  data: Array<ProjectDescriptionCommentCreateManyProjectInput>;
};

export type ProjectDescriptionCommentCreateNestedManyWithoutProjectInput = {
  connect?: InputMaybe<Array<ProjectDescriptionCommentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectDescriptionCommentCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<ProjectDescriptionCommentCreateWithoutProjectInput>>;
  createMany?: InputMaybe<ProjectDescriptionCommentCreateManyProjectInputEnvelope>;
};

export type ProjectDescriptionCommentCreateOrConnectWithoutProjectInput = {
  create: ProjectDescriptionCommentCreateWithoutProjectInput;
  where: ProjectDescriptionCommentWhereUniqueInput;
};

export type ProjectDescriptionCommentCreateWithoutProjectInput = {
  comment: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type ProjectDescriptionCommentListRelationFilter = {
  every?: InputMaybe<ProjectDescriptionCommentWhereInput>;
  none?: InputMaybe<ProjectDescriptionCommentWhereInput>;
  some?: InputMaybe<ProjectDescriptionCommentWhereInput>;
};

export type ProjectDescriptionCommentOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProjectDescriptionCommentOrderByWithRelationInput = {
  comment?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  deletedBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  project?: InputMaybe<MasterOrderByWithRelationInput>;
  projectId?: InputMaybe<SortOrder>;
};

export enum ProjectDescriptionCommentScalarFieldEnum {
  Comment = 'comment',
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  DeletedAt = 'deletedAt',
  DeletedBy = 'deletedBy',
  Id = 'id',
  ProjectId = 'projectId'
}

export type ProjectDescriptionCommentScalarWhereInput = {
  AND?: InputMaybe<Array<ProjectDescriptionCommentScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProjectDescriptionCommentScalarWhereInput>>;
  OR?: InputMaybe<Array<ProjectDescriptionCommentScalarWhereInput>>;
  comment?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  projectId?: InputMaybe<StringFilter>;
};

export type ProjectDescriptionCommentUpdateInput = {
  comment?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutProjectDescriptionCommentNestedInput>;
};

export type ProjectDescriptionCommentUpdateManyMutationInput = {
  comment?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ProjectDescriptionCommentUpdateManyWithWhereWithoutProjectInput = {
  data: ProjectDescriptionCommentUpdateManyMutationInput;
  where: ProjectDescriptionCommentScalarWhereInput;
};

export type ProjectDescriptionCommentUpdateManyWithoutProjectNestedInput = {
  connect?: InputMaybe<Array<ProjectDescriptionCommentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectDescriptionCommentCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<ProjectDescriptionCommentCreateWithoutProjectInput>>;
  createMany?: InputMaybe<ProjectDescriptionCommentCreateManyProjectInputEnvelope>;
  delete?: InputMaybe<Array<ProjectDescriptionCommentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProjectDescriptionCommentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProjectDescriptionCommentWhereUniqueInput>>;
  set?: InputMaybe<Array<ProjectDescriptionCommentWhereUniqueInput>>;
  update?: InputMaybe<Array<ProjectDescriptionCommentUpdateWithWhereUniqueWithoutProjectInput>>;
  updateMany?: InputMaybe<Array<ProjectDescriptionCommentUpdateManyWithWhereWithoutProjectInput>>;
  upsert?: InputMaybe<Array<ProjectDescriptionCommentUpsertWithWhereUniqueWithoutProjectInput>>;
};

export type ProjectDescriptionCommentUpdateWithWhereUniqueWithoutProjectInput = {
  data: ProjectDescriptionCommentUpdateWithoutProjectInput;
  where: ProjectDescriptionCommentWhereUniqueInput;
};

export type ProjectDescriptionCommentUpdateWithoutProjectInput = {
  comment?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ProjectDescriptionCommentUpsertWithWhereUniqueWithoutProjectInput = {
  create: ProjectDescriptionCommentCreateWithoutProjectInput;
  update: ProjectDescriptionCommentUpdateWithoutProjectInput;
  where: ProjectDescriptionCommentWhereUniqueInput;
};

export type ProjectDescriptionCommentWhereInput = {
  AND?: InputMaybe<Array<ProjectDescriptionCommentWhereInput>>;
  NOT?: InputMaybe<Array<ProjectDescriptionCommentWhereInput>>;
  OR?: InputMaybe<Array<ProjectDescriptionCommentWhereInput>>;
  comment?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  project?: InputMaybe<MasterWhereInput>;
  projectId?: InputMaybe<StringFilter>;
};

export type ProjectDescriptionCommentWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type ProjectDescriptionCreateInput = {
  afa?: InputMaybe<Scalars['Float']>;
  background?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  costLocation?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  funding?: InputMaybe<FundingCreateNestedOneWithoutProjectDescriptionsInput>;
  id?: InputMaybe<Scalars['String']>;
  master: MasterCreateNestedOneWithoutProjectDescriptionsInput;
  method?: InputMaybe<MethodCreateNestedOneWithoutProjectDescriptionsInput>;
  name: Scalars['String'];
  planing?: InputMaybe<Scalars['String']>;
  procedure?: InputMaybe<Scalars['String']>;
  projectDuration?: InputMaybe<Scalars['Int']>;
  projectStart?: InputMaybe<Scalars['DateTime']>;
  projectType: ProjectTypeCreateNestedOneWithoutProjectDescriptionsInput;
  sbk?: InputMaybe<Scalars['String']>;
};

export type ProjectDescriptionCreateManyFundingInput = {
  afa?: InputMaybe<Scalars['Float']>;
  background?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  costLocation?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  methodId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  planing?: InputMaybe<Scalars['String']>;
  procedure?: InputMaybe<Scalars['String']>;
  projectDuration?: InputMaybe<Scalars['Int']>;
  projectId: Scalars['String'];
  projectStart?: InputMaybe<Scalars['DateTime']>;
  projectTypeId: Scalars['String'];
  sbk?: InputMaybe<Scalars['String']>;
};

export type ProjectDescriptionCreateManyFundingInputEnvelope = {
  data: Array<ProjectDescriptionCreateManyFundingInput>;
};

export type ProjectDescriptionCreateManyMasterInput = {
  afa?: InputMaybe<Scalars['Float']>;
  background?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  costLocation?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  fundingId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  methodId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  planing?: InputMaybe<Scalars['String']>;
  procedure?: InputMaybe<Scalars['String']>;
  projectDuration?: InputMaybe<Scalars['Int']>;
  projectStart?: InputMaybe<Scalars['DateTime']>;
  projectTypeId: Scalars['String'];
  sbk?: InputMaybe<Scalars['String']>;
};

export type ProjectDescriptionCreateManyMasterInputEnvelope = {
  data: Array<ProjectDescriptionCreateManyMasterInput>;
};

export type ProjectDescriptionCreateManyMethodInput = {
  afa?: InputMaybe<Scalars['Float']>;
  background?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  costLocation?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  fundingId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  planing?: InputMaybe<Scalars['String']>;
  procedure?: InputMaybe<Scalars['String']>;
  projectDuration?: InputMaybe<Scalars['Int']>;
  projectId: Scalars['String'];
  projectStart?: InputMaybe<Scalars['DateTime']>;
  projectTypeId: Scalars['String'];
  sbk?: InputMaybe<Scalars['String']>;
};

export type ProjectDescriptionCreateManyMethodInputEnvelope = {
  data: Array<ProjectDescriptionCreateManyMethodInput>;
};

export type ProjectDescriptionCreateManyProjectTypeInput = {
  afa?: InputMaybe<Scalars['Float']>;
  background?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  costLocation?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  fundingId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  methodId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  planing?: InputMaybe<Scalars['String']>;
  procedure?: InputMaybe<Scalars['String']>;
  projectDuration?: InputMaybe<Scalars['Int']>;
  projectId: Scalars['String'];
  projectStart?: InputMaybe<Scalars['DateTime']>;
  sbk?: InputMaybe<Scalars['String']>;
};

export type ProjectDescriptionCreateManyProjectTypeInputEnvelope = {
  data: Array<ProjectDescriptionCreateManyProjectTypeInput>;
};

export type ProjectDescriptionCreateNestedManyWithoutFundingInput = {
  connect?: InputMaybe<Array<ProjectDescriptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectDescriptionCreateOrConnectWithoutFundingInput>>;
  create?: InputMaybe<Array<ProjectDescriptionCreateWithoutFundingInput>>;
  createMany?: InputMaybe<ProjectDescriptionCreateManyFundingInputEnvelope>;
};

export type ProjectDescriptionCreateNestedManyWithoutMasterInput = {
  connect?: InputMaybe<Array<ProjectDescriptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectDescriptionCreateOrConnectWithoutMasterInput>>;
  create?: InputMaybe<Array<ProjectDescriptionCreateWithoutMasterInput>>;
  createMany?: InputMaybe<ProjectDescriptionCreateManyMasterInputEnvelope>;
};

export type ProjectDescriptionCreateNestedManyWithoutMethodInput = {
  connect?: InputMaybe<Array<ProjectDescriptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectDescriptionCreateOrConnectWithoutMethodInput>>;
  create?: InputMaybe<Array<ProjectDescriptionCreateWithoutMethodInput>>;
  createMany?: InputMaybe<ProjectDescriptionCreateManyMethodInputEnvelope>;
};

export type ProjectDescriptionCreateNestedManyWithoutProjectTypeInput = {
  connect?: InputMaybe<Array<ProjectDescriptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectDescriptionCreateOrConnectWithoutProjectTypeInput>>;
  create?: InputMaybe<Array<ProjectDescriptionCreateWithoutProjectTypeInput>>;
  createMany?: InputMaybe<ProjectDescriptionCreateManyProjectTypeInputEnvelope>;
};

export type ProjectDescriptionCreateOrConnectWithoutFundingInput = {
  create: ProjectDescriptionCreateWithoutFundingInput;
  where: ProjectDescriptionWhereUniqueInput;
};

export type ProjectDescriptionCreateOrConnectWithoutMasterInput = {
  create: ProjectDescriptionCreateWithoutMasterInput;
  where: ProjectDescriptionWhereUniqueInput;
};

export type ProjectDescriptionCreateOrConnectWithoutMethodInput = {
  create: ProjectDescriptionCreateWithoutMethodInput;
  where: ProjectDescriptionWhereUniqueInput;
};

export type ProjectDescriptionCreateOrConnectWithoutProjectTypeInput = {
  create: ProjectDescriptionCreateWithoutProjectTypeInput;
  where: ProjectDescriptionWhereUniqueInput;
};

export type ProjectDescriptionCreateWithoutFundingInput = {
  afa?: InputMaybe<Scalars['Float']>;
  background?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  costLocation?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  master: MasterCreateNestedOneWithoutProjectDescriptionsInput;
  method?: InputMaybe<MethodCreateNestedOneWithoutProjectDescriptionsInput>;
  name: Scalars['String'];
  planing?: InputMaybe<Scalars['String']>;
  procedure?: InputMaybe<Scalars['String']>;
  projectDuration?: InputMaybe<Scalars['Int']>;
  projectStart?: InputMaybe<Scalars['DateTime']>;
  projectType: ProjectTypeCreateNestedOneWithoutProjectDescriptionsInput;
  sbk?: InputMaybe<Scalars['String']>;
};

export type ProjectDescriptionCreateWithoutMasterInput = {
  afa?: InputMaybe<Scalars['Float']>;
  background?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  costLocation?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  funding?: InputMaybe<FundingCreateNestedOneWithoutProjectDescriptionsInput>;
  id?: InputMaybe<Scalars['String']>;
  method?: InputMaybe<MethodCreateNestedOneWithoutProjectDescriptionsInput>;
  name: Scalars['String'];
  planing?: InputMaybe<Scalars['String']>;
  procedure?: InputMaybe<Scalars['String']>;
  projectDuration?: InputMaybe<Scalars['Int']>;
  projectStart?: InputMaybe<Scalars['DateTime']>;
  projectType: ProjectTypeCreateNestedOneWithoutProjectDescriptionsInput;
  sbk?: InputMaybe<Scalars['String']>;
};

export type ProjectDescriptionCreateWithoutMethodInput = {
  afa?: InputMaybe<Scalars['Float']>;
  background?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  costLocation?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  funding?: InputMaybe<FundingCreateNestedOneWithoutProjectDescriptionsInput>;
  id?: InputMaybe<Scalars['String']>;
  master: MasterCreateNestedOneWithoutProjectDescriptionsInput;
  name: Scalars['String'];
  planing?: InputMaybe<Scalars['String']>;
  procedure?: InputMaybe<Scalars['String']>;
  projectDuration?: InputMaybe<Scalars['Int']>;
  projectStart?: InputMaybe<Scalars['DateTime']>;
  projectType: ProjectTypeCreateNestedOneWithoutProjectDescriptionsInput;
  sbk?: InputMaybe<Scalars['String']>;
};

export type ProjectDescriptionCreateWithoutProjectTypeInput = {
  afa?: InputMaybe<Scalars['Float']>;
  background?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  comments?: InputMaybe<Scalars['String']>;
  costLocation?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  funding?: InputMaybe<FundingCreateNestedOneWithoutProjectDescriptionsInput>;
  id?: InputMaybe<Scalars['String']>;
  master: MasterCreateNestedOneWithoutProjectDescriptionsInput;
  method?: InputMaybe<MethodCreateNestedOneWithoutProjectDescriptionsInput>;
  name: Scalars['String'];
  planing?: InputMaybe<Scalars['String']>;
  procedure?: InputMaybe<Scalars['String']>;
  projectDuration?: InputMaybe<Scalars['Int']>;
  projectStart?: InputMaybe<Scalars['DateTime']>;
  sbk?: InputMaybe<Scalars['String']>;
};

export type ProjectDescriptionListRelationFilter = {
  every?: InputMaybe<ProjectDescriptionWhereInput>;
  none?: InputMaybe<ProjectDescriptionWhereInput>;
  some?: InputMaybe<ProjectDescriptionWhereInput>;
};

export type ProjectDescriptionOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProjectDescriptionOrderByWithRelationInput = {
  afa?: InputMaybe<SortOrder>;
  background?: InputMaybe<SortOrder>;
  category?: InputMaybe<SortOrder>;
  comments?: InputMaybe<SortOrder>;
  costLocation?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  deletedBy?: InputMaybe<SortOrder>;
  department?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  funding?: InputMaybe<FundingOrderByWithRelationInput>;
  fundingId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  master?: InputMaybe<MasterOrderByWithRelationInput>;
  method?: InputMaybe<MethodOrderByWithRelationInput>;
  methodId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  planing?: InputMaybe<SortOrder>;
  procedure?: InputMaybe<SortOrder>;
  projectDuration?: InputMaybe<SortOrder>;
  projectId?: InputMaybe<SortOrder>;
  projectStart?: InputMaybe<SortOrder>;
  projectType?: InputMaybe<ProjectTypeOrderByWithRelationInput>;
  projectTypeId?: InputMaybe<SortOrder>;
  sbk?: InputMaybe<SortOrder>;
};

export enum ProjectDescriptionScalarFieldEnum {
  Afa = 'afa',
  Background = 'background',
  Category = 'category',
  Comments = 'comments',
  CostLocation = 'costLocation',
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  DeletedAt = 'deletedAt',
  DeletedBy = 'deletedBy',
  Department = 'department',
  Description = 'description',
  FundingId = 'fundingId',
  Id = 'id',
  MethodId = 'methodId',
  Name = 'name',
  Planing = 'planing',
  Procedure = 'procedure',
  ProjectDuration = 'projectDuration',
  ProjectId = 'projectId',
  ProjectStart = 'projectStart',
  ProjectTypeId = 'projectTypeId',
  Sbk = 'sbk'
}

export type ProjectDescriptionScalarWhereInput = {
  AND?: InputMaybe<Array<ProjectDescriptionScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProjectDescriptionScalarWhereInput>>;
  OR?: InputMaybe<Array<ProjectDescriptionScalarWhereInput>>;
  afa?: InputMaybe<FloatNullableFilter>;
  background?: InputMaybe<StringNullableFilter>;
  category?: InputMaybe<StringNullableFilter>;
  comments?: InputMaybe<StringNullableFilter>;
  costLocation?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  department?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  fundingId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  methodId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  planing?: InputMaybe<StringNullableFilter>;
  procedure?: InputMaybe<StringNullableFilter>;
  projectDuration?: InputMaybe<IntNullableFilter>;
  projectId?: InputMaybe<StringFilter>;
  projectStart?: InputMaybe<DateTimeNullableFilter>;
  projectTypeId?: InputMaybe<StringFilter>;
  sbk?: InputMaybe<StringNullableFilter>;
};

export type ProjectDescriptionUpdateInput = {
  afa?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  background?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  category?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  comments?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  costLocation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  department?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  funding?: InputMaybe<FundingUpdateOneWithoutProjectDescriptionsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  master?: InputMaybe<MasterUpdateOneRequiredWithoutProjectDescriptionsNestedInput>;
  method?: InputMaybe<MethodUpdateOneWithoutProjectDescriptionsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  planing?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  procedure?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  projectDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  projectStart?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  projectType?: InputMaybe<ProjectTypeUpdateOneRequiredWithoutProjectDescriptionsNestedInput>;
  sbk?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ProjectDescriptionUpdateManyMutationInput = {
  afa?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  background?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  category?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  comments?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  costLocation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  department?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  planing?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  procedure?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  projectDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  projectStart?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sbk?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ProjectDescriptionUpdateManyWithWhereWithoutFundingInput = {
  data: ProjectDescriptionUpdateManyMutationInput;
  where: ProjectDescriptionScalarWhereInput;
};

export type ProjectDescriptionUpdateManyWithWhereWithoutMasterInput = {
  data: ProjectDescriptionUpdateManyMutationInput;
  where: ProjectDescriptionScalarWhereInput;
};

export type ProjectDescriptionUpdateManyWithWhereWithoutMethodInput = {
  data: ProjectDescriptionUpdateManyMutationInput;
  where: ProjectDescriptionScalarWhereInput;
};

export type ProjectDescriptionUpdateManyWithWhereWithoutProjectTypeInput = {
  data: ProjectDescriptionUpdateManyMutationInput;
  where: ProjectDescriptionScalarWhereInput;
};

export type ProjectDescriptionUpdateManyWithoutFundingNestedInput = {
  connect?: InputMaybe<Array<ProjectDescriptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectDescriptionCreateOrConnectWithoutFundingInput>>;
  create?: InputMaybe<Array<ProjectDescriptionCreateWithoutFundingInput>>;
  createMany?: InputMaybe<ProjectDescriptionCreateManyFundingInputEnvelope>;
  delete?: InputMaybe<Array<ProjectDescriptionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProjectDescriptionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProjectDescriptionWhereUniqueInput>>;
  set?: InputMaybe<Array<ProjectDescriptionWhereUniqueInput>>;
  update?: InputMaybe<Array<ProjectDescriptionUpdateWithWhereUniqueWithoutFundingInput>>;
  updateMany?: InputMaybe<Array<ProjectDescriptionUpdateManyWithWhereWithoutFundingInput>>;
  upsert?: InputMaybe<Array<ProjectDescriptionUpsertWithWhereUniqueWithoutFundingInput>>;
};

export type ProjectDescriptionUpdateManyWithoutMasterNestedInput = {
  connect?: InputMaybe<Array<ProjectDescriptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectDescriptionCreateOrConnectWithoutMasterInput>>;
  create?: InputMaybe<Array<ProjectDescriptionCreateWithoutMasterInput>>;
  createMany?: InputMaybe<ProjectDescriptionCreateManyMasterInputEnvelope>;
  delete?: InputMaybe<Array<ProjectDescriptionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProjectDescriptionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProjectDescriptionWhereUniqueInput>>;
  set?: InputMaybe<Array<ProjectDescriptionWhereUniqueInput>>;
  update?: InputMaybe<Array<ProjectDescriptionUpdateWithWhereUniqueWithoutMasterInput>>;
  updateMany?: InputMaybe<Array<ProjectDescriptionUpdateManyWithWhereWithoutMasterInput>>;
  upsert?: InputMaybe<Array<ProjectDescriptionUpsertWithWhereUniqueWithoutMasterInput>>;
};

export type ProjectDescriptionUpdateManyWithoutMethodNestedInput = {
  connect?: InputMaybe<Array<ProjectDescriptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectDescriptionCreateOrConnectWithoutMethodInput>>;
  create?: InputMaybe<Array<ProjectDescriptionCreateWithoutMethodInput>>;
  createMany?: InputMaybe<ProjectDescriptionCreateManyMethodInputEnvelope>;
  delete?: InputMaybe<Array<ProjectDescriptionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProjectDescriptionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProjectDescriptionWhereUniqueInput>>;
  set?: InputMaybe<Array<ProjectDescriptionWhereUniqueInput>>;
  update?: InputMaybe<Array<ProjectDescriptionUpdateWithWhereUniqueWithoutMethodInput>>;
  updateMany?: InputMaybe<Array<ProjectDescriptionUpdateManyWithWhereWithoutMethodInput>>;
  upsert?: InputMaybe<Array<ProjectDescriptionUpsertWithWhereUniqueWithoutMethodInput>>;
};

export type ProjectDescriptionUpdateManyWithoutProjectTypeNestedInput = {
  connect?: InputMaybe<Array<ProjectDescriptionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectDescriptionCreateOrConnectWithoutProjectTypeInput>>;
  create?: InputMaybe<Array<ProjectDescriptionCreateWithoutProjectTypeInput>>;
  createMany?: InputMaybe<ProjectDescriptionCreateManyProjectTypeInputEnvelope>;
  delete?: InputMaybe<Array<ProjectDescriptionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProjectDescriptionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProjectDescriptionWhereUniqueInput>>;
  set?: InputMaybe<Array<ProjectDescriptionWhereUniqueInput>>;
  update?: InputMaybe<Array<ProjectDescriptionUpdateWithWhereUniqueWithoutProjectTypeInput>>;
  updateMany?: InputMaybe<Array<ProjectDescriptionUpdateManyWithWhereWithoutProjectTypeInput>>;
  upsert?: InputMaybe<Array<ProjectDescriptionUpsertWithWhereUniqueWithoutProjectTypeInput>>;
};

export type ProjectDescriptionUpdateWithWhereUniqueWithoutFundingInput = {
  data: ProjectDescriptionUpdateWithoutFundingInput;
  where: ProjectDescriptionWhereUniqueInput;
};

export type ProjectDescriptionUpdateWithWhereUniqueWithoutMasterInput = {
  data: ProjectDescriptionUpdateWithoutMasterInput;
  where: ProjectDescriptionWhereUniqueInput;
};

export type ProjectDescriptionUpdateWithWhereUniqueWithoutMethodInput = {
  data: ProjectDescriptionUpdateWithoutMethodInput;
  where: ProjectDescriptionWhereUniqueInput;
};

export type ProjectDescriptionUpdateWithWhereUniqueWithoutProjectTypeInput = {
  data: ProjectDescriptionUpdateWithoutProjectTypeInput;
  where: ProjectDescriptionWhereUniqueInput;
};

export type ProjectDescriptionUpdateWithoutFundingInput = {
  afa?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  background?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  category?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  comments?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  costLocation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  department?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  master?: InputMaybe<MasterUpdateOneRequiredWithoutProjectDescriptionsNestedInput>;
  method?: InputMaybe<MethodUpdateOneWithoutProjectDescriptionsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  planing?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  procedure?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  projectDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  projectStart?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  projectType?: InputMaybe<ProjectTypeUpdateOneRequiredWithoutProjectDescriptionsNestedInput>;
  sbk?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ProjectDescriptionUpdateWithoutMasterInput = {
  afa?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  background?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  category?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  comments?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  costLocation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  department?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  funding?: InputMaybe<FundingUpdateOneWithoutProjectDescriptionsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  method?: InputMaybe<MethodUpdateOneWithoutProjectDescriptionsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  planing?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  procedure?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  projectDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  projectStart?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  projectType?: InputMaybe<ProjectTypeUpdateOneRequiredWithoutProjectDescriptionsNestedInput>;
  sbk?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ProjectDescriptionUpdateWithoutMethodInput = {
  afa?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  background?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  category?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  comments?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  costLocation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  department?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  funding?: InputMaybe<FundingUpdateOneWithoutProjectDescriptionsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  master?: InputMaybe<MasterUpdateOneRequiredWithoutProjectDescriptionsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  planing?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  procedure?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  projectDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  projectStart?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  projectType?: InputMaybe<ProjectTypeUpdateOneRequiredWithoutProjectDescriptionsNestedInput>;
  sbk?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ProjectDescriptionUpdateWithoutProjectTypeInput = {
  afa?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  background?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  category?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  comments?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  costLocation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  department?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  funding?: InputMaybe<FundingUpdateOneWithoutProjectDescriptionsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  master?: InputMaybe<MasterUpdateOneRequiredWithoutProjectDescriptionsNestedInput>;
  method?: InputMaybe<MethodUpdateOneWithoutProjectDescriptionsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  planing?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  procedure?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  projectDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  projectStart?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  sbk?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ProjectDescriptionUpsertWithWhereUniqueWithoutFundingInput = {
  create: ProjectDescriptionCreateWithoutFundingInput;
  update: ProjectDescriptionUpdateWithoutFundingInput;
  where: ProjectDescriptionWhereUniqueInput;
};

export type ProjectDescriptionUpsertWithWhereUniqueWithoutMasterInput = {
  create: ProjectDescriptionCreateWithoutMasterInput;
  update: ProjectDescriptionUpdateWithoutMasterInput;
  where: ProjectDescriptionWhereUniqueInput;
};

export type ProjectDescriptionUpsertWithWhereUniqueWithoutMethodInput = {
  create: ProjectDescriptionCreateWithoutMethodInput;
  update: ProjectDescriptionUpdateWithoutMethodInput;
  where: ProjectDescriptionWhereUniqueInput;
};

export type ProjectDescriptionUpsertWithWhereUniqueWithoutProjectTypeInput = {
  create: ProjectDescriptionCreateWithoutProjectTypeInput;
  update: ProjectDescriptionUpdateWithoutProjectTypeInput;
  where: ProjectDescriptionWhereUniqueInput;
};

export type ProjectDescriptionWhereInput = {
  AND?: InputMaybe<Array<ProjectDescriptionWhereInput>>;
  NOT?: InputMaybe<Array<ProjectDescriptionWhereInput>>;
  OR?: InputMaybe<Array<ProjectDescriptionWhereInput>>;
  afa?: InputMaybe<FloatNullableFilter>;
  background?: InputMaybe<StringNullableFilter>;
  category?: InputMaybe<StringNullableFilter>;
  comments?: InputMaybe<StringNullableFilter>;
  costLocation?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  department?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  funding?: InputMaybe<FundingWhereInput>;
  fundingId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  master?: InputMaybe<MasterWhereInput>;
  method?: InputMaybe<MethodWhereInput>;
  methodId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  planing?: InputMaybe<StringNullableFilter>;
  procedure?: InputMaybe<StringNullableFilter>;
  projectDuration?: InputMaybe<IntNullableFilter>;
  projectId?: InputMaybe<StringFilter>;
  projectStart?: InputMaybe<DateTimeNullableFilter>;
  projectType?: InputMaybe<ProjectTypeWhereInput>;
  projectTypeId?: InputMaybe<StringFilter>;
  sbk?: InputMaybe<StringNullableFilter>;
};

export type ProjectDescriptionWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type ProjectDocuments = {
  __typename?: 'ProjectDocuments';
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  location?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  project: Master;
  projectId: Scalars['String'];
  uri: Scalars['String'];
};

export type ProjectDocumentsCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  project: MasterCreateNestedOneWithoutProjectDocumentsInput;
  uri: Scalars['String'];
};

export type ProjectDocumentsCreateManyProjectInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  uri: Scalars['String'];
};

export type ProjectDocumentsCreateManyProjectInputEnvelope = {
  data: Array<ProjectDocumentsCreateManyProjectInput>;
};

export type ProjectDocumentsCreateNestedManyWithoutProjectInput = {
  connect?: InputMaybe<Array<ProjectDocumentsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectDocumentsCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<ProjectDocumentsCreateWithoutProjectInput>>;
  createMany?: InputMaybe<ProjectDocumentsCreateManyProjectInputEnvelope>;
};

export type ProjectDocumentsCreateOrConnectWithoutProjectInput = {
  create: ProjectDocumentsCreateWithoutProjectInput;
  where: ProjectDocumentsWhereUniqueInput;
};

export type ProjectDocumentsCreateWithoutProjectInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  uri: Scalars['String'];
};

export type ProjectDocumentsListRelationFilter = {
  every?: InputMaybe<ProjectDocumentsWhereInput>;
  none?: InputMaybe<ProjectDocumentsWhereInput>;
  some?: InputMaybe<ProjectDocumentsWhereInput>;
};

export type ProjectDocumentsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProjectDocumentsOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  deletedBy?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  location?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  project?: InputMaybe<MasterOrderByWithRelationInput>;
  projectId?: InputMaybe<SortOrder>;
  uri?: InputMaybe<SortOrder>;
};

export enum ProjectDocumentsScalarFieldEnum {
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  DeletedAt = 'deletedAt',
  DeletedBy = 'deletedBy',
  Description = 'description',
  Id = 'id',
  Location = 'location',
  Name = 'name',
  ProjectId = 'projectId',
  Uri = 'uri'
}

export type ProjectDocumentsScalarWhereInput = {
  AND?: InputMaybe<Array<ProjectDocumentsScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProjectDocumentsScalarWhereInput>>;
  OR?: InputMaybe<Array<ProjectDocumentsScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  location?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  projectId?: InputMaybe<StringFilter>;
  uri?: InputMaybe<StringFilter>;
};

export type ProjectDocumentsUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  location?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutProjectDocumentsNestedInput>;
  uri?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ProjectDocumentsUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  location?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  uri?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ProjectDocumentsUpdateManyWithWhereWithoutProjectInput = {
  data: ProjectDocumentsUpdateManyMutationInput;
  where: ProjectDocumentsScalarWhereInput;
};

export type ProjectDocumentsUpdateManyWithoutProjectNestedInput = {
  connect?: InputMaybe<Array<ProjectDocumentsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectDocumentsCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<ProjectDocumentsCreateWithoutProjectInput>>;
  createMany?: InputMaybe<ProjectDocumentsCreateManyProjectInputEnvelope>;
  delete?: InputMaybe<Array<ProjectDocumentsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProjectDocumentsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProjectDocumentsWhereUniqueInput>>;
  set?: InputMaybe<Array<ProjectDocumentsWhereUniqueInput>>;
  update?: InputMaybe<Array<ProjectDocumentsUpdateWithWhereUniqueWithoutProjectInput>>;
  updateMany?: InputMaybe<Array<ProjectDocumentsUpdateManyWithWhereWithoutProjectInput>>;
  upsert?: InputMaybe<Array<ProjectDocumentsUpsertWithWhereUniqueWithoutProjectInput>>;
};

export type ProjectDocumentsUpdateWithWhereUniqueWithoutProjectInput = {
  data: ProjectDocumentsUpdateWithoutProjectInput;
  where: ProjectDocumentsWhereUniqueInput;
};

export type ProjectDocumentsUpdateWithoutProjectInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  location?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  uri?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ProjectDocumentsUpsertWithWhereUniqueWithoutProjectInput = {
  create: ProjectDocumentsCreateWithoutProjectInput;
  update: ProjectDocumentsUpdateWithoutProjectInput;
  where: ProjectDocumentsWhereUniqueInput;
};

export type ProjectDocumentsWhereInput = {
  AND?: InputMaybe<Array<ProjectDocumentsWhereInput>>;
  NOT?: InputMaybe<Array<ProjectDocumentsWhereInput>>;
  OR?: InputMaybe<Array<ProjectDocumentsWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  location?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  project?: InputMaybe<MasterWhereInput>;
  projectId?: InputMaybe<StringFilter>;
  uri?: InputMaybe<StringFilter>;
};

export type ProjectDocumentsWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type ProjectInterface = {
  __typename?: 'ProjectInterface';
  _count: ProjectInterfaceCount;
  cause?: Maybe<Scalars['String']>;
  challenges?: Maybe<Scalars['String']>;
  collaboration?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  employee: Employee;
  employeeId: Scalars['String'];
  id: Scalars['ID'];
  interfaceDetail?: Maybe<Array<InterfaceDetail>>;
  interfaceId: Scalars['String'];
  interfaceReference: InterfaceReference;
  interfaceReferenceId: Scalars['String'];
  isAutomatic: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  project: Master;
  projectId: Scalars['String'];
  riskDamagePotential?: Maybe<RiskDamagePotential>;
  riskDamagePotentialId?: Maybe<Scalars['String']>;
  riskOccurance?: Maybe<RiskOccurance>;
  riskOccuranceId?: Maybe<Scalars['String']>;
  riskStatus?: Maybe<RiskStatus>;
  riskStatusId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['Int']>;
};

export type ProjectInterfaceCount = {
  __typename?: 'ProjectInterfaceCount';
  interfaceDetail: Scalars['Int'];
};

export type ProjectInterfaceCreateInput = {
  cause?: InputMaybe<Scalars['String']>;
  challenges?: InputMaybe<Scalars['String']>;
  collaboration?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  employee: EmployeeCreateNestedOneWithoutProjectInterfaceInput;
  id?: InputMaybe<Scalars['String']>;
  interfaceDetail?: InputMaybe<InterfaceDetailCreateNestedManyWithoutProjectInterfaceInput>;
  interfaceId?: InputMaybe<Scalars['String']>;
  interfaceReference: InterfaceReferenceCreateNestedOneWithoutProjectInterfaceInput;
  isAutomatic: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  project: MasterCreateNestedOneWithoutProjectInterfaceInput;
  riskDamagePotential?: InputMaybe<RiskDamagePotentialCreateNestedOneWithoutProjectInterfaceInput>;
  riskOccurance?: InputMaybe<RiskOccuranceCreateNestedOneWithoutProjectInterfaceInput>;
  riskStatus?: InputMaybe<RiskStatusCreateNestedOneWithoutProjectInterfaceInput>;
  status?: InputMaybe<Scalars['Int']>;
};

export type ProjectInterfaceCreateManyEmployeeInput = {
  cause?: InputMaybe<Scalars['String']>;
  challenges?: InputMaybe<Scalars['String']>;
  collaboration?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  interfaceId?: InputMaybe<Scalars['String']>;
  interfaceReferenceId: Scalars['String'];
  isAutomatic: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
  riskDamagePotentialId?: InputMaybe<Scalars['String']>;
  riskOccuranceId?: InputMaybe<Scalars['String']>;
  riskStatusId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Int']>;
};

export type ProjectInterfaceCreateManyEmployeeInputEnvelope = {
  data: Array<ProjectInterfaceCreateManyEmployeeInput>;
};

export type ProjectInterfaceCreateManyInterfaceReferenceInput = {
  cause?: InputMaybe<Scalars['String']>;
  challenges?: InputMaybe<Scalars['String']>;
  collaboration?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  interfaceId?: InputMaybe<Scalars['String']>;
  isAutomatic: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
  riskDamagePotentialId?: InputMaybe<Scalars['String']>;
  riskOccuranceId?: InputMaybe<Scalars['String']>;
  riskStatusId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Int']>;
};

export type ProjectInterfaceCreateManyInterfaceReferenceInputEnvelope = {
  data: Array<ProjectInterfaceCreateManyInterfaceReferenceInput>;
};

export type ProjectInterfaceCreateManyProjectInput = {
  cause?: InputMaybe<Scalars['String']>;
  challenges?: InputMaybe<Scalars['String']>;
  collaboration?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  interfaceId?: InputMaybe<Scalars['String']>;
  interfaceReferenceId: Scalars['String'];
  isAutomatic: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  riskDamagePotentialId?: InputMaybe<Scalars['String']>;
  riskOccuranceId?: InputMaybe<Scalars['String']>;
  riskStatusId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Int']>;
};

export type ProjectInterfaceCreateManyProjectInputEnvelope = {
  data: Array<ProjectInterfaceCreateManyProjectInput>;
};

export type ProjectInterfaceCreateManyRiskDamagePotentialInput = {
  cause?: InputMaybe<Scalars['String']>;
  challenges?: InputMaybe<Scalars['String']>;
  collaboration?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  interfaceId?: InputMaybe<Scalars['String']>;
  interfaceReferenceId: Scalars['String'];
  isAutomatic: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
  riskOccuranceId?: InputMaybe<Scalars['String']>;
  riskStatusId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Int']>;
};

export type ProjectInterfaceCreateManyRiskDamagePotentialInputEnvelope = {
  data: Array<ProjectInterfaceCreateManyRiskDamagePotentialInput>;
};

export type ProjectInterfaceCreateManyRiskOccuranceInput = {
  cause?: InputMaybe<Scalars['String']>;
  challenges?: InputMaybe<Scalars['String']>;
  collaboration?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  interfaceId?: InputMaybe<Scalars['String']>;
  interfaceReferenceId: Scalars['String'];
  isAutomatic: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
  riskDamagePotentialId?: InputMaybe<Scalars['String']>;
  riskStatusId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Int']>;
};

export type ProjectInterfaceCreateManyRiskOccuranceInputEnvelope = {
  data: Array<ProjectInterfaceCreateManyRiskOccuranceInput>;
};

export type ProjectInterfaceCreateManyRiskStatusInput = {
  cause?: InputMaybe<Scalars['String']>;
  challenges?: InputMaybe<Scalars['String']>;
  collaboration?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  interfaceId?: InputMaybe<Scalars['String']>;
  interfaceReferenceId: Scalars['String'];
  isAutomatic: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
  riskDamagePotentialId?: InputMaybe<Scalars['String']>;
  riskOccuranceId?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['Int']>;
};

export type ProjectInterfaceCreateManyRiskStatusInputEnvelope = {
  data: Array<ProjectInterfaceCreateManyRiskStatusInput>;
};

export type ProjectInterfaceCreateNestedManyWithoutEmployeeInput = {
  connect?: InputMaybe<Array<ProjectInterfaceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectInterfaceCreateOrConnectWithoutEmployeeInput>>;
  create?: InputMaybe<Array<ProjectInterfaceCreateWithoutEmployeeInput>>;
  createMany?: InputMaybe<ProjectInterfaceCreateManyEmployeeInputEnvelope>;
};

export type ProjectInterfaceCreateNestedManyWithoutInterfaceReferenceInput = {
  connect?: InputMaybe<Array<ProjectInterfaceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectInterfaceCreateOrConnectWithoutInterfaceReferenceInput>>;
  create?: InputMaybe<Array<ProjectInterfaceCreateWithoutInterfaceReferenceInput>>;
  createMany?: InputMaybe<ProjectInterfaceCreateManyInterfaceReferenceInputEnvelope>;
};

export type ProjectInterfaceCreateNestedManyWithoutProjectInput = {
  connect?: InputMaybe<Array<ProjectInterfaceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectInterfaceCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<ProjectInterfaceCreateWithoutProjectInput>>;
  createMany?: InputMaybe<ProjectInterfaceCreateManyProjectInputEnvelope>;
};

export type ProjectInterfaceCreateNestedManyWithoutRiskDamagePotentialInput = {
  connect?: InputMaybe<Array<ProjectInterfaceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectInterfaceCreateOrConnectWithoutRiskDamagePotentialInput>>;
  create?: InputMaybe<Array<ProjectInterfaceCreateWithoutRiskDamagePotentialInput>>;
  createMany?: InputMaybe<ProjectInterfaceCreateManyRiskDamagePotentialInputEnvelope>;
};

export type ProjectInterfaceCreateNestedManyWithoutRiskOccuranceInput = {
  connect?: InputMaybe<Array<ProjectInterfaceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectInterfaceCreateOrConnectWithoutRiskOccuranceInput>>;
  create?: InputMaybe<Array<ProjectInterfaceCreateWithoutRiskOccuranceInput>>;
  createMany?: InputMaybe<ProjectInterfaceCreateManyRiskOccuranceInputEnvelope>;
};

export type ProjectInterfaceCreateNestedManyWithoutRiskStatusInput = {
  connect?: InputMaybe<Array<ProjectInterfaceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectInterfaceCreateOrConnectWithoutRiskStatusInput>>;
  create?: InputMaybe<Array<ProjectInterfaceCreateWithoutRiskStatusInput>>;
  createMany?: InputMaybe<ProjectInterfaceCreateManyRiskStatusInputEnvelope>;
};

export type ProjectInterfaceCreateNestedOneWithoutInterfaceDetailInput = {
  connect?: InputMaybe<ProjectInterfaceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProjectInterfaceCreateOrConnectWithoutInterfaceDetailInput>;
  create?: InputMaybe<ProjectInterfaceCreateWithoutInterfaceDetailInput>;
};

export type ProjectInterfaceCreateOrConnectWithoutEmployeeInput = {
  create: ProjectInterfaceCreateWithoutEmployeeInput;
  where: ProjectInterfaceWhereUniqueInput;
};

export type ProjectInterfaceCreateOrConnectWithoutInterfaceDetailInput = {
  create: ProjectInterfaceCreateWithoutInterfaceDetailInput;
  where: ProjectInterfaceWhereUniqueInput;
};

export type ProjectInterfaceCreateOrConnectWithoutInterfaceReferenceInput = {
  create: ProjectInterfaceCreateWithoutInterfaceReferenceInput;
  where: ProjectInterfaceWhereUniqueInput;
};

export type ProjectInterfaceCreateOrConnectWithoutProjectInput = {
  create: ProjectInterfaceCreateWithoutProjectInput;
  where: ProjectInterfaceWhereUniqueInput;
};

export type ProjectInterfaceCreateOrConnectWithoutRiskDamagePotentialInput = {
  create: ProjectInterfaceCreateWithoutRiskDamagePotentialInput;
  where: ProjectInterfaceWhereUniqueInput;
};

export type ProjectInterfaceCreateOrConnectWithoutRiskOccuranceInput = {
  create: ProjectInterfaceCreateWithoutRiskOccuranceInput;
  where: ProjectInterfaceWhereUniqueInput;
};

export type ProjectInterfaceCreateOrConnectWithoutRiskStatusInput = {
  create: ProjectInterfaceCreateWithoutRiskStatusInput;
  where: ProjectInterfaceWhereUniqueInput;
};

export type ProjectInterfaceCreateWithoutEmployeeInput = {
  cause?: InputMaybe<Scalars['String']>;
  challenges?: InputMaybe<Scalars['String']>;
  collaboration?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  interfaceDetail?: InputMaybe<InterfaceDetailCreateNestedManyWithoutProjectInterfaceInput>;
  interfaceId?: InputMaybe<Scalars['String']>;
  interfaceReference: InterfaceReferenceCreateNestedOneWithoutProjectInterfaceInput;
  isAutomatic: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  project: MasterCreateNestedOneWithoutProjectInterfaceInput;
  riskDamagePotential?: InputMaybe<RiskDamagePotentialCreateNestedOneWithoutProjectInterfaceInput>;
  riskOccurance?: InputMaybe<RiskOccuranceCreateNestedOneWithoutProjectInterfaceInput>;
  riskStatus?: InputMaybe<RiskStatusCreateNestedOneWithoutProjectInterfaceInput>;
  status?: InputMaybe<Scalars['Int']>;
};

export type ProjectInterfaceCreateWithoutInterfaceDetailInput = {
  cause?: InputMaybe<Scalars['String']>;
  challenges?: InputMaybe<Scalars['String']>;
  collaboration?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  employee: EmployeeCreateNestedOneWithoutProjectInterfaceInput;
  id?: InputMaybe<Scalars['String']>;
  interfaceId?: InputMaybe<Scalars['String']>;
  interfaceReference: InterfaceReferenceCreateNestedOneWithoutProjectInterfaceInput;
  isAutomatic: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  project: MasterCreateNestedOneWithoutProjectInterfaceInput;
  riskDamagePotential?: InputMaybe<RiskDamagePotentialCreateNestedOneWithoutProjectInterfaceInput>;
  riskOccurance?: InputMaybe<RiskOccuranceCreateNestedOneWithoutProjectInterfaceInput>;
  riskStatus?: InputMaybe<RiskStatusCreateNestedOneWithoutProjectInterfaceInput>;
  status?: InputMaybe<Scalars['Int']>;
};

export type ProjectInterfaceCreateWithoutInterfaceReferenceInput = {
  cause?: InputMaybe<Scalars['String']>;
  challenges?: InputMaybe<Scalars['String']>;
  collaboration?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  employee: EmployeeCreateNestedOneWithoutProjectInterfaceInput;
  id?: InputMaybe<Scalars['String']>;
  interfaceDetail?: InputMaybe<InterfaceDetailCreateNestedManyWithoutProjectInterfaceInput>;
  interfaceId?: InputMaybe<Scalars['String']>;
  isAutomatic: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  project: MasterCreateNestedOneWithoutProjectInterfaceInput;
  riskDamagePotential?: InputMaybe<RiskDamagePotentialCreateNestedOneWithoutProjectInterfaceInput>;
  riskOccurance?: InputMaybe<RiskOccuranceCreateNestedOneWithoutProjectInterfaceInput>;
  riskStatus?: InputMaybe<RiskStatusCreateNestedOneWithoutProjectInterfaceInput>;
  status?: InputMaybe<Scalars['Int']>;
};

export type ProjectInterfaceCreateWithoutProjectInput = {
  cause?: InputMaybe<Scalars['String']>;
  challenges?: InputMaybe<Scalars['String']>;
  collaboration?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  employee: EmployeeCreateNestedOneWithoutProjectInterfaceInput;
  id?: InputMaybe<Scalars['String']>;
  interfaceDetail?: InputMaybe<InterfaceDetailCreateNestedManyWithoutProjectInterfaceInput>;
  interfaceId?: InputMaybe<Scalars['String']>;
  interfaceReference: InterfaceReferenceCreateNestedOneWithoutProjectInterfaceInput;
  isAutomatic: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  riskDamagePotential?: InputMaybe<RiskDamagePotentialCreateNestedOneWithoutProjectInterfaceInput>;
  riskOccurance?: InputMaybe<RiskOccuranceCreateNestedOneWithoutProjectInterfaceInput>;
  riskStatus?: InputMaybe<RiskStatusCreateNestedOneWithoutProjectInterfaceInput>;
  status?: InputMaybe<Scalars['Int']>;
};

export type ProjectInterfaceCreateWithoutRiskDamagePotentialInput = {
  cause?: InputMaybe<Scalars['String']>;
  challenges?: InputMaybe<Scalars['String']>;
  collaboration?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  employee: EmployeeCreateNestedOneWithoutProjectInterfaceInput;
  id?: InputMaybe<Scalars['String']>;
  interfaceDetail?: InputMaybe<InterfaceDetailCreateNestedManyWithoutProjectInterfaceInput>;
  interfaceId?: InputMaybe<Scalars['String']>;
  interfaceReference: InterfaceReferenceCreateNestedOneWithoutProjectInterfaceInput;
  isAutomatic: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  project: MasterCreateNestedOneWithoutProjectInterfaceInput;
  riskOccurance?: InputMaybe<RiskOccuranceCreateNestedOneWithoutProjectInterfaceInput>;
  riskStatus?: InputMaybe<RiskStatusCreateNestedOneWithoutProjectInterfaceInput>;
  status?: InputMaybe<Scalars['Int']>;
};

export type ProjectInterfaceCreateWithoutRiskOccuranceInput = {
  cause?: InputMaybe<Scalars['String']>;
  challenges?: InputMaybe<Scalars['String']>;
  collaboration?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  employee: EmployeeCreateNestedOneWithoutProjectInterfaceInput;
  id?: InputMaybe<Scalars['String']>;
  interfaceDetail?: InputMaybe<InterfaceDetailCreateNestedManyWithoutProjectInterfaceInput>;
  interfaceId?: InputMaybe<Scalars['String']>;
  interfaceReference: InterfaceReferenceCreateNestedOneWithoutProjectInterfaceInput;
  isAutomatic: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  project: MasterCreateNestedOneWithoutProjectInterfaceInput;
  riskDamagePotential?: InputMaybe<RiskDamagePotentialCreateNestedOneWithoutProjectInterfaceInput>;
  riskStatus?: InputMaybe<RiskStatusCreateNestedOneWithoutProjectInterfaceInput>;
  status?: InputMaybe<Scalars['Int']>;
};

export type ProjectInterfaceCreateWithoutRiskStatusInput = {
  cause?: InputMaybe<Scalars['String']>;
  challenges?: InputMaybe<Scalars['String']>;
  collaboration?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  employee: EmployeeCreateNestedOneWithoutProjectInterfaceInput;
  id?: InputMaybe<Scalars['String']>;
  interfaceDetail?: InputMaybe<InterfaceDetailCreateNestedManyWithoutProjectInterfaceInput>;
  interfaceId?: InputMaybe<Scalars['String']>;
  interfaceReference: InterfaceReferenceCreateNestedOneWithoutProjectInterfaceInput;
  isAutomatic: Scalars['Boolean'];
  name?: InputMaybe<Scalars['String']>;
  project: MasterCreateNestedOneWithoutProjectInterfaceInput;
  riskDamagePotential?: InputMaybe<RiskDamagePotentialCreateNestedOneWithoutProjectInterfaceInput>;
  riskOccurance?: InputMaybe<RiskOccuranceCreateNestedOneWithoutProjectInterfaceInput>;
  status?: InputMaybe<Scalars['Int']>;
};

export type ProjectInterfaceListRelationFilter = {
  every?: InputMaybe<ProjectInterfaceWhereInput>;
  none?: InputMaybe<ProjectInterfaceWhereInput>;
  some?: InputMaybe<ProjectInterfaceWhereInput>;
};

export type ProjectInterfaceOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProjectInterfaceOrderByWithRelationInput = {
  cause?: InputMaybe<SortOrder>;
  challenges?: InputMaybe<SortOrder>;
  collaboration?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  deletedBy?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  employee?: InputMaybe<EmployeeOrderByWithRelationInput>;
  employeeId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  interfaceDetail?: InputMaybe<InterfaceDetailOrderByRelationAggregateInput>;
  interfaceId?: InputMaybe<SortOrder>;
  interfaceReference?: InputMaybe<InterfaceReferenceOrderByWithRelationInput>;
  interfaceReferenceId?: InputMaybe<SortOrder>;
  isAutomatic?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  project?: InputMaybe<MasterOrderByWithRelationInput>;
  projectId?: InputMaybe<SortOrder>;
  riskDamagePotential?: InputMaybe<RiskDamagePotentialOrderByWithRelationInput>;
  riskDamagePotentialId?: InputMaybe<SortOrder>;
  riskOccurance?: InputMaybe<RiskOccuranceOrderByWithRelationInput>;
  riskOccuranceId?: InputMaybe<SortOrder>;
  riskStatus?: InputMaybe<RiskStatusOrderByWithRelationInput>;
  riskStatusId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export enum ProjectInterfaceScalarFieldEnum {
  Cause = 'cause',
  Challenges = 'challenges',
  Collaboration = 'collaboration',
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  DeletedAt = 'deletedAt',
  DeletedBy = 'deletedBy',
  Description = 'description',
  EmployeeId = 'employeeId',
  Id = 'id',
  InterfaceId = 'interfaceId',
  InterfaceReferenceId = 'interfaceReferenceId',
  IsAutomatic = 'isAutomatic',
  Name = 'name',
  ProjectId = 'projectId',
  RiskDamagePotentialId = 'riskDamagePotentialId',
  RiskOccuranceId = 'riskOccuranceId',
  RiskStatusId = 'riskStatusId',
  Status = 'status'
}

export type ProjectInterfaceScalarWhereInput = {
  AND?: InputMaybe<Array<ProjectInterfaceScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProjectInterfaceScalarWhereInput>>;
  OR?: InputMaybe<Array<ProjectInterfaceScalarWhereInput>>;
  cause?: InputMaybe<StringNullableFilter>;
  challenges?: InputMaybe<StringNullableFilter>;
  collaboration?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  employeeId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  interfaceId?: InputMaybe<StringFilter>;
  interfaceReferenceId?: InputMaybe<StringFilter>;
  isAutomatic?: InputMaybe<BoolFilter>;
  name?: InputMaybe<StringNullableFilter>;
  projectId?: InputMaybe<StringFilter>;
  riskDamagePotentialId?: InputMaybe<StringNullableFilter>;
  riskOccuranceId?: InputMaybe<StringNullableFilter>;
  riskStatusId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<IntNullableFilter>;
};

export type ProjectInterfaceUpdateInput = {
  cause?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  challenges?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  collaboration?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employee?: InputMaybe<EmployeeUpdateOneRequiredWithoutProjectInterfaceNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  interfaceDetail?: InputMaybe<InterfaceDetailUpdateManyWithoutProjectInterfaceNestedInput>;
  interfaceId?: InputMaybe<StringFieldUpdateOperationsInput>;
  interfaceReference?: InputMaybe<InterfaceReferenceUpdateOneRequiredWithoutProjectInterfaceNestedInput>;
  isAutomatic?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutProjectInterfaceNestedInput>;
  riskDamagePotential?: InputMaybe<RiskDamagePotentialUpdateOneWithoutProjectInterfaceNestedInput>;
  riskOccurance?: InputMaybe<RiskOccuranceUpdateOneWithoutProjectInterfaceNestedInput>;
  riskStatus?: InputMaybe<RiskStatusUpdateOneWithoutProjectInterfaceNestedInput>;
  status?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type ProjectInterfaceUpdateManyMutationInput = {
  cause?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  challenges?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  collaboration?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  interfaceId?: InputMaybe<StringFieldUpdateOperationsInput>;
  isAutomatic?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type ProjectInterfaceUpdateManyWithWhereWithoutEmployeeInput = {
  data: ProjectInterfaceUpdateManyMutationInput;
  where: ProjectInterfaceScalarWhereInput;
};

export type ProjectInterfaceUpdateManyWithWhereWithoutInterfaceReferenceInput = {
  data: ProjectInterfaceUpdateManyMutationInput;
  where: ProjectInterfaceScalarWhereInput;
};

export type ProjectInterfaceUpdateManyWithWhereWithoutProjectInput = {
  data: ProjectInterfaceUpdateManyMutationInput;
  where: ProjectInterfaceScalarWhereInput;
};

export type ProjectInterfaceUpdateManyWithWhereWithoutRiskDamagePotentialInput = {
  data: ProjectInterfaceUpdateManyMutationInput;
  where: ProjectInterfaceScalarWhereInput;
};

export type ProjectInterfaceUpdateManyWithWhereWithoutRiskOccuranceInput = {
  data: ProjectInterfaceUpdateManyMutationInput;
  where: ProjectInterfaceScalarWhereInput;
};

export type ProjectInterfaceUpdateManyWithWhereWithoutRiskStatusInput = {
  data: ProjectInterfaceUpdateManyMutationInput;
  where: ProjectInterfaceScalarWhereInput;
};

export type ProjectInterfaceUpdateManyWithoutEmployeeNestedInput = {
  connect?: InputMaybe<Array<ProjectInterfaceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectInterfaceCreateOrConnectWithoutEmployeeInput>>;
  create?: InputMaybe<Array<ProjectInterfaceCreateWithoutEmployeeInput>>;
  createMany?: InputMaybe<ProjectInterfaceCreateManyEmployeeInputEnvelope>;
  delete?: InputMaybe<Array<ProjectInterfaceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProjectInterfaceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProjectInterfaceWhereUniqueInput>>;
  set?: InputMaybe<Array<ProjectInterfaceWhereUniqueInput>>;
  update?: InputMaybe<Array<ProjectInterfaceUpdateWithWhereUniqueWithoutEmployeeInput>>;
  updateMany?: InputMaybe<Array<ProjectInterfaceUpdateManyWithWhereWithoutEmployeeInput>>;
  upsert?: InputMaybe<Array<ProjectInterfaceUpsertWithWhereUniqueWithoutEmployeeInput>>;
};

export type ProjectInterfaceUpdateManyWithoutInterfaceReferenceNestedInput = {
  connect?: InputMaybe<Array<ProjectInterfaceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectInterfaceCreateOrConnectWithoutInterfaceReferenceInput>>;
  create?: InputMaybe<Array<ProjectInterfaceCreateWithoutInterfaceReferenceInput>>;
  createMany?: InputMaybe<ProjectInterfaceCreateManyInterfaceReferenceInputEnvelope>;
  delete?: InputMaybe<Array<ProjectInterfaceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProjectInterfaceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProjectInterfaceWhereUniqueInput>>;
  set?: InputMaybe<Array<ProjectInterfaceWhereUniqueInput>>;
  update?: InputMaybe<Array<ProjectInterfaceUpdateWithWhereUniqueWithoutInterfaceReferenceInput>>;
  updateMany?: InputMaybe<Array<ProjectInterfaceUpdateManyWithWhereWithoutInterfaceReferenceInput>>;
  upsert?: InputMaybe<Array<ProjectInterfaceUpsertWithWhereUniqueWithoutInterfaceReferenceInput>>;
};

export type ProjectInterfaceUpdateManyWithoutProjectNestedInput = {
  connect?: InputMaybe<Array<ProjectInterfaceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectInterfaceCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<ProjectInterfaceCreateWithoutProjectInput>>;
  createMany?: InputMaybe<ProjectInterfaceCreateManyProjectInputEnvelope>;
  delete?: InputMaybe<Array<ProjectInterfaceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProjectInterfaceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProjectInterfaceWhereUniqueInput>>;
  set?: InputMaybe<Array<ProjectInterfaceWhereUniqueInput>>;
  update?: InputMaybe<Array<ProjectInterfaceUpdateWithWhereUniqueWithoutProjectInput>>;
  updateMany?: InputMaybe<Array<ProjectInterfaceUpdateManyWithWhereWithoutProjectInput>>;
  upsert?: InputMaybe<Array<ProjectInterfaceUpsertWithWhereUniqueWithoutProjectInput>>;
};

export type ProjectInterfaceUpdateManyWithoutRiskDamagePotentialNestedInput = {
  connect?: InputMaybe<Array<ProjectInterfaceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectInterfaceCreateOrConnectWithoutRiskDamagePotentialInput>>;
  create?: InputMaybe<Array<ProjectInterfaceCreateWithoutRiskDamagePotentialInput>>;
  createMany?: InputMaybe<ProjectInterfaceCreateManyRiskDamagePotentialInputEnvelope>;
  delete?: InputMaybe<Array<ProjectInterfaceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProjectInterfaceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProjectInterfaceWhereUniqueInput>>;
  set?: InputMaybe<Array<ProjectInterfaceWhereUniqueInput>>;
  update?: InputMaybe<Array<ProjectInterfaceUpdateWithWhereUniqueWithoutRiskDamagePotentialInput>>;
  updateMany?: InputMaybe<Array<ProjectInterfaceUpdateManyWithWhereWithoutRiskDamagePotentialInput>>;
  upsert?: InputMaybe<Array<ProjectInterfaceUpsertWithWhereUniqueWithoutRiskDamagePotentialInput>>;
};

export type ProjectInterfaceUpdateManyWithoutRiskOccuranceNestedInput = {
  connect?: InputMaybe<Array<ProjectInterfaceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectInterfaceCreateOrConnectWithoutRiskOccuranceInput>>;
  create?: InputMaybe<Array<ProjectInterfaceCreateWithoutRiskOccuranceInput>>;
  createMany?: InputMaybe<ProjectInterfaceCreateManyRiskOccuranceInputEnvelope>;
  delete?: InputMaybe<Array<ProjectInterfaceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProjectInterfaceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProjectInterfaceWhereUniqueInput>>;
  set?: InputMaybe<Array<ProjectInterfaceWhereUniqueInput>>;
  update?: InputMaybe<Array<ProjectInterfaceUpdateWithWhereUniqueWithoutRiskOccuranceInput>>;
  updateMany?: InputMaybe<Array<ProjectInterfaceUpdateManyWithWhereWithoutRiskOccuranceInput>>;
  upsert?: InputMaybe<Array<ProjectInterfaceUpsertWithWhereUniqueWithoutRiskOccuranceInput>>;
};

export type ProjectInterfaceUpdateManyWithoutRiskStatusNestedInput = {
  connect?: InputMaybe<Array<ProjectInterfaceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectInterfaceCreateOrConnectWithoutRiskStatusInput>>;
  create?: InputMaybe<Array<ProjectInterfaceCreateWithoutRiskStatusInput>>;
  createMany?: InputMaybe<ProjectInterfaceCreateManyRiskStatusInputEnvelope>;
  delete?: InputMaybe<Array<ProjectInterfaceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProjectInterfaceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProjectInterfaceWhereUniqueInput>>;
  set?: InputMaybe<Array<ProjectInterfaceWhereUniqueInput>>;
  update?: InputMaybe<Array<ProjectInterfaceUpdateWithWhereUniqueWithoutRiskStatusInput>>;
  updateMany?: InputMaybe<Array<ProjectInterfaceUpdateManyWithWhereWithoutRiskStatusInput>>;
  upsert?: InputMaybe<Array<ProjectInterfaceUpsertWithWhereUniqueWithoutRiskStatusInput>>;
};

export type ProjectInterfaceUpdateOneRequiredWithoutInterfaceDetailNestedInput = {
  connect?: InputMaybe<ProjectInterfaceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProjectInterfaceCreateOrConnectWithoutInterfaceDetailInput>;
  create?: InputMaybe<ProjectInterfaceCreateWithoutInterfaceDetailInput>;
  update?: InputMaybe<ProjectInterfaceUpdateWithoutInterfaceDetailInput>;
  upsert?: InputMaybe<ProjectInterfaceUpsertWithoutInterfaceDetailInput>;
};

export type ProjectInterfaceUpdateWithWhereUniqueWithoutEmployeeInput = {
  data: ProjectInterfaceUpdateWithoutEmployeeInput;
  where: ProjectInterfaceWhereUniqueInput;
};

export type ProjectInterfaceUpdateWithWhereUniqueWithoutInterfaceReferenceInput = {
  data: ProjectInterfaceUpdateWithoutInterfaceReferenceInput;
  where: ProjectInterfaceWhereUniqueInput;
};

export type ProjectInterfaceUpdateWithWhereUniqueWithoutProjectInput = {
  data: ProjectInterfaceUpdateWithoutProjectInput;
  where: ProjectInterfaceWhereUniqueInput;
};

export type ProjectInterfaceUpdateWithWhereUniqueWithoutRiskDamagePotentialInput = {
  data: ProjectInterfaceUpdateWithoutRiskDamagePotentialInput;
  where: ProjectInterfaceWhereUniqueInput;
};

export type ProjectInterfaceUpdateWithWhereUniqueWithoutRiskOccuranceInput = {
  data: ProjectInterfaceUpdateWithoutRiskOccuranceInput;
  where: ProjectInterfaceWhereUniqueInput;
};

export type ProjectInterfaceUpdateWithWhereUniqueWithoutRiskStatusInput = {
  data: ProjectInterfaceUpdateWithoutRiskStatusInput;
  where: ProjectInterfaceWhereUniqueInput;
};

export type ProjectInterfaceUpdateWithoutEmployeeInput = {
  cause?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  challenges?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  collaboration?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  interfaceDetail?: InputMaybe<InterfaceDetailUpdateManyWithoutProjectInterfaceNestedInput>;
  interfaceId?: InputMaybe<StringFieldUpdateOperationsInput>;
  interfaceReference?: InputMaybe<InterfaceReferenceUpdateOneRequiredWithoutProjectInterfaceNestedInput>;
  isAutomatic?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutProjectInterfaceNestedInput>;
  riskDamagePotential?: InputMaybe<RiskDamagePotentialUpdateOneWithoutProjectInterfaceNestedInput>;
  riskOccurance?: InputMaybe<RiskOccuranceUpdateOneWithoutProjectInterfaceNestedInput>;
  riskStatus?: InputMaybe<RiskStatusUpdateOneWithoutProjectInterfaceNestedInput>;
  status?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type ProjectInterfaceUpdateWithoutInterfaceDetailInput = {
  cause?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  challenges?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  collaboration?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employee?: InputMaybe<EmployeeUpdateOneRequiredWithoutProjectInterfaceNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  interfaceId?: InputMaybe<StringFieldUpdateOperationsInput>;
  interfaceReference?: InputMaybe<InterfaceReferenceUpdateOneRequiredWithoutProjectInterfaceNestedInput>;
  isAutomatic?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutProjectInterfaceNestedInput>;
  riskDamagePotential?: InputMaybe<RiskDamagePotentialUpdateOneWithoutProjectInterfaceNestedInput>;
  riskOccurance?: InputMaybe<RiskOccuranceUpdateOneWithoutProjectInterfaceNestedInput>;
  riskStatus?: InputMaybe<RiskStatusUpdateOneWithoutProjectInterfaceNestedInput>;
  status?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type ProjectInterfaceUpdateWithoutInterfaceReferenceInput = {
  cause?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  challenges?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  collaboration?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employee?: InputMaybe<EmployeeUpdateOneRequiredWithoutProjectInterfaceNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  interfaceDetail?: InputMaybe<InterfaceDetailUpdateManyWithoutProjectInterfaceNestedInput>;
  interfaceId?: InputMaybe<StringFieldUpdateOperationsInput>;
  isAutomatic?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutProjectInterfaceNestedInput>;
  riskDamagePotential?: InputMaybe<RiskDamagePotentialUpdateOneWithoutProjectInterfaceNestedInput>;
  riskOccurance?: InputMaybe<RiskOccuranceUpdateOneWithoutProjectInterfaceNestedInput>;
  riskStatus?: InputMaybe<RiskStatusUpdateOneWithoutProjectInterfaceNestedInput>;
  status?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type ProjectInterfaceUpdateWithoutProjectInput = {
  cause?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  challenges?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  collaboration?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employee?: InputMaybe<EmployeeUpdateOneRequiredWithoutProjectInterfaceNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  interfaceDetail?: InputMaybe<InterfaceDetailUpdateManyWithoutProjectInterfaceNestedInput>;
  interfaceId?: InputMaybe<StringFieldUpdateOperationsInput>;
  interfaceReference?: InputMaybe<InterfaceReferenceUpdateOneRequiredWithoutProjectInterfaceNestedInput>;
  isAutomatic?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  riskDamagePotential?: InputMaybe<RiskDamagePotentialUpdateOneWithoutProjectInterfaceNestedInput>;
  riskOccurance?: InputMaybe<RiskOccuranceUpdateOneWithoutProjectInterfaceNestedInput>;
  riskStatus?: InputMaybe<RiskStatusUpdateOneWithoutProjectInterfaceNestedInput>;
  status?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type ProjectInterfaceUpdateWithoutRiskDamagePotentialInput = {
  cause?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  challenges?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  collaboration?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employee?: InputMaybe<EmployeeUpdateOneRequiredWithoutProjectInterfaceNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  interfaceDetail?: InputMaybe<InterfaceDetailUpdateManyWithoutProjectInterfaceNestedInput>;
  interfaceId?: InputMaybe<StringFieldUpdateOperationsInput>;
  interfaceReference?: InputMaybe<InterfaceReferenceUpdateOneRequiredWithoutProjectInterfaceNestedInput>;
  isAutomatic?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutProjectInterfaceNestedInput>;
  riskOccurance?: InputMaybe<RiskOccuranceUpdateOneWithoutProjectInterfaceNestedInput>;
  riskStatus?: InputMaybe<RiskStatusUpdateOneWithoutProjectInterfaceNestedInput>;
  status?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type ProjectInterfaceUpdateWithoutRiskOccuranceInput = {
  cause?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  challenges?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  collaboration?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employee?: InputMaybe<EmployeeUpdateOneRequiredWithoutProjectInterfaceNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  interfaceDetail?: InputMaybe<InterfaceDetailUpdateManyWithoutProjectInterfaceNestedInput>;
  interfaceId?: InputMaybe<StringFieldUpdateOperationsInput>;
  interfaceReference?: InputMaybe<InterfaceReferenceUpdateOneRequiredWithoutProjectInterfaceNestedInput>;
  isAutomatic?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutProjectInterfaceNestedInput>;
  riskDamagePotential?: InputMaybe<RiskDamagePotentialUpdateOneWithoutProjectInterfaceNestedInput>;
  riskStatus?: InputMaybe<RiskStatusUpdateOneWithoutProjectInterfaceNestedInput>;
  status?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type ProjectInterfaceUpdateWithoutRiskStatusInput = {
  cause?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  challenges?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  collaboration?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employee?: InputMaybe<EmployeeUpdateOneRequiredWithoutProjectInterfaceNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  interfaceDetail?: InputMaybe<InterfaceDetailUpdateManyWithoutProjectInterfaceNestedInput>;
  interfaceId?: InputMaybe<StringFieldUpdateOperationsInput>;
  interfaceReference?: InputMaybe<InterfaceReferenceUpdateOneRequiredWithoutProjectInterfaceNestedInput>;
  isAutomatic?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutProjectInterfaceNestedInput>;
  riskDamagePotential?: InputMaybe<RiskDamagePotentialUpdateOneWithoutProjectInterfaceNestedInput>;
  riskOccurance?: InputMaybe<RiskOccuranceUpdateOneWithoutProjectInterfaceNestedInput>;
  status?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type ProjectInterfaceUpsertWithWhereUniqueWithoutEmployeeInput = {
  create: ProjectInterfaceCreateWithoutEmployeeInput;
  update: ProjectInterfaceUpdateWithoutEmployeeInput;
  where: ProjectInterfaceWhereUniqueInput;
};

export type ProjectInterfaceUpsertWithWhereUniqueWithoutInterfaceReferenceInput = {
  create: ProjectInterfaceCreateWithoutInterfaceReferenceInput;
  update: ProjectInterfaceUpdateWithoutInterfaceReferenceInput;
  where: ProjectInterfaceWhereUniqueInput;
};

export type ProjectInterfaceUpsertWithWhereUniqueWithoutProjectInput = {
  create: ProjectInterfaceCreateWithoutProjectInput;
  update: ProjectInterfaceUpdateWithoutProjectInput;
  where: ProjectInterfaceWhereUniqueInput;
};

export type ProjectInterfaceUpsertWithWhereUniqueWithoutRiskDamagePotentialInput = {
  create: ProjectInterfaceCreateWithoutRiskDamagePotentialInput;
  update: ProjectInterfaceUpdateWithoutRiskDamagePotentialInput;
  where: ProjectInterfaceWhereUniqueInput;
};

export type ProjectInterfaceUpsertWithWhereUniqueWithoutRiskOccuranceInput = {
  create: ProjectInterfaceCreateWithoutRiskOccuranceInput;
  update: ProjectInterfaceUpdateWithoutRiskOccuranceInput;
  where: ProjectInterfaceWhereUniqueInput;
};

export type ProjectInterfaceUpsertWithWhereUniqueWithoutRiskStatusInput = {
  create: ProjectInterfaceCreateWithoutRiskStatusInput;
  update: ProjectInterfaceUpdateWithoutRiskStatusInput;
  where: ProjectInterfaceWhereUniqueInput;
};

export type ProjectInterfaceUpsertWithoutInterfaceDetailInput = {
  create: ProjectInterfaceCreateWithoutInterfaceDetailInput;
  update: ProjectInterfaceUpdateWithoutInterfaceDetailInput;
};

export type ProjectInterfaceWhereInput = {
  AND?: InputMaybe<Array<ProjectInterfaceWhereInput>>;
  NOT?: InputMaybe<Array<ProjectInterfaceWhereInput>>;
  OR?: InputMaybe<Array<ProjectInterfaceWhereInput>>;
  cause?: InputMaybe<StringNullableFilter>;
  challenges?: InputMaybe<StringNullableFilter>;
  collaboration?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  employee?: InputMaybe<EmployeeWhereInput>;
  employeeId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  interfaceDetail?: InputMaybe<InterfaceDetailListRelationFilter>;
  interfaceId?: InputMaybe<StringFilter>;
  interfaceReference?: InputMaybe<InterfaceReferenceWhereInput>;
  interfaceReferenceId?: InputMaybe<StringFilter>;
  isAutomatic?: InputMaybe<BoolFilter>;
  name?: InputMaybe<StringNullableFilter>;
  project?: InputMaybe<MasterWhereInput>;
  projectId?: InputMaybe<StringFilter>;
  riskDamagePotential?: InputMaybe<RiskDamagePotentialWhereInput>;
  riskDamagePotentialId?: InputMaybe<StringNullableFilter>;
  riskOccurance?: InputMaybe<RiskOccuranceWhereInput>;
  riskOccuranceId?: InputMaybe<StringNullableFilter>;
  riskStatus?: InputMaybe<RiskStatusWhereInput>;
  riskStatusId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<IntNullableFilter>;
};

export type ProjectInterfaceWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type ProjectPhase = {
  __typename?: 'ProjectPhase';
  _count: ProjectPhaseCount;
  id: Scalars['ID'];
  order: Scalars['Int'];
  phaseOnType?: Maybe<Array<PhaseOnType>>;
  projectPhaseCapture?: Maybe<Array<ProjectPhaseCapture>>;
  projectResourceCapture?: Maybe<Array<ProjectResourceCapture>>;
};

export type ProjectPhaseCapture = {
  __typename?: 'ProjectPhaseCapture';
  comment?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  endDate: Scalars['DateTime'];
  id: Scalars['ID'];
  project: Master;
  projectId: Scalars['String'];
  projectPhase: ProjectPhase;
  projectPhaseId: Scalars['String'];
  startDate: Scalars['DateTime'];
};

export type ProjectPhaseCaptureCreateInput = {
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  endDate: Scalars['DateTime'];
  id?: InputMaybe<Scalars['String']>;
  project: MasterCreateNestedOneWithoutProjectPhaseCaptureInput;
  projectPhase: ProjectPhaseCreateNestedOneWithoutProjectPhaseCaptureInput;
  startDate: Scalars['DateTime'];
};

export type ProjectPhaseCaptureCreateManyProjectInput = {
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  endDate: Scalars['DateTime'];
  id?: InputMaybe<Scalars['String']>;
  projectPhaseId: Scalars['String'];
  startDate: Scalars['DateTime'];
};

export type ProjectPhaseCaptureCreateManyProjectInputEnvelope = {
  data: Array<ProjectPhaseCaptureCreateManyProjectInput>;
};

export type ProjectPhaseCaptureCreateManyProjectPhaseInput = {
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  endDate: Scalars['DateTime'];
  id?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
  startDate: Scalars['DateTime'];
};

export type ProjectPhaseCaptureCreateManyProjectPhaseInputEnvelope = {
  data: Array<ProjectPhaseCaptureCreateManyProjectPhaseInput>;
};

export type ProjectPhaseCaptureCreateNestedManyWithoutProjectInput = {
  connect?: InputMaybe<Array<ProjectPhaseCaptureWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectPhaseCaptureCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<ProjectPhaseCaptureCreateWithoutProjectInput>>;
  createMany?: InputMaybe<ProjectPhaseCaptureCreateManyProjectInputEnvelope>;
};

export type ProjectPhaseCaptureCreateNestedManyWithoutProjectPhaseInput = {
  connect?: InputMaybe<Array<ProjectPhaseCaptureWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectPhaseCaptureCreateOrConnectWithoutProjectPhaseInput>>;
  create?: InputMaybe<Array<ProjectPhaseCaptureCreateWithoutProjectPhaseInput>>;
  createMany?: InputMaybe<ProjectPhaseCaptureCreateManyProjectPhaseInputEnvelope>;
};

export type ProjectPhaseCaptureCreateOrConnectWithoutProjectInput = {
  create: ProjectPhaseCaptureCreateWithoutProjectInput;
  where: ProjectPhaseCaptureWhereUniqueInput;
};

export type ProjectPhaseCaptureCreateOrConnectWithoutProjectPhaseInput = {
  create: ProjectPhaseCaptureCreateWithoutProjectPhaseInput;
  where: ProjectPhaseCaptureWhereUniqueInput;
};

export type ProjectPhaseCaptureCreateWithoutProjectInput = {
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  endDate: Scalars['DateTime'];
  id?: InputMaybe<Scalars['String']>;
  projectPhase: ProjectPhaseCreateNestedOneWithoutProjectPhaseCaptureInput;
  startDate: Scalars['DateTime'];
};

export type ProjectPhaseCaptureCreateWithoutProjectPhaseInput = {
  comment?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  endDate: Scalars['DateTime'];
  id?: InputMaybe<Scalars['String']>;
  project: MasterCreateNestedOneWithoutProjectPhaseCaptureInput;
  startDate: Scalars['DateTime'];
};

export type ProjectPhaseCaptureListRelationFilter = {
  every?: InputMaybe<ProjectPhaseCaptureWhereInput>;
  none?: InputMaybe<ProjectPhaseCaptureWhereInput>;
  some?: InputMaybe<ProjectPhaseCaptureWhereInput>;
};

export type ProjectPhaseCaptureOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProjectPhaseCaptureOrderByWithRelationInput = {
  comment?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  deletedBy?: InputMaybe<SortOrder>;
  endDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  project?: InputMaybe<MasterOrderByWithRelationInput>;
  projectId?: InputMaybe<SortOrder>;
  projectPhase?: InputMaybe<ProjectPhaseOrderByWithRelationInput>;
  projectPhaseId?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
};

export enum ProjectPhaseCaptureScalarFieldEnum {
  Comment = 'comment',
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  DeletedAt = 'deletedAt',
  DeletedBy = 'deletedBy',
  EndDate = 'endDate',
  Id = 'id',
  ProjectId = 'projectId',
  ProjectPhaseId = 'projectPhaseId',
  StartDate = 'startDate'
}

export type ProjectPhaseCaptureScalarWhereInput = {
  AND?: InputMaybe<Array<ProjectPhaseCaptureScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProjectPhaseCaptureScalarWhereInput>>;
  OR?: InputMaybe<Array<ProjectPhaseCaptureScalarWhereInput>>;
  comment?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  endDate?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  projectId?: InputMaybe<StringFilter>;
  projectPhaseId?: InputMaybe<StringFilter>;
  startDate?: InputMaybe<DateTimeFilter>;
};

export type ProjectPhaseCaptureUpdateInput = {
  comment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutProjectPhaseCaptureNestedInput>;
  projectPhase?: InputMaybe<ProjectPhaseUpdateOneRequiredWithoutProjectPhaseCaptureNestedInput>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProjectPhaseCaptureUpdateManyMutationInput = {
  comment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProjectPhaseCaptureUpdateManyWithWhereWithoutProjectInput = {
  data: ProjectPhaseCaptureUpdateManyMutationInput;
  where: ProjectPhaseCaptureScalarWhereInput;
};

export type ProjectPhaseCaptureUpdateManyWithWhereWithoutProjectPhaseInput = {
  data: ProjectPhaseCaptureUpdateManyMutationInput;
  where: ProjectPhaseCaptureScalarWhereInput;
};

export type ProjectPhaseCaptureUpdateManyWithoutProjectNestedInput = {
  connect?: InputMaybe<Array<ProjectPhaseCaptureWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectPhaseCaptureCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<ProjectPhaseCaptureCreateWithoutProjectInput>>;
  createMany?: InputMaybe<ProjectPhaseCaptureCreateManyProjectInputEnvelope>;
  delete?: InputMaybe<Array<ProjectPhaseCaptureWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProjectPhaseCaptureScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProjectPhaseCaptureWhereUniqueInput>>;
  set?: InputMaybe<Array<ProjectPhaseCaptureWhereUniqueInput>>;
  update?: InputMaybe<Array<ProjectPhaseCaptureUpdateWithWhereUniqueWithoutProjectInput>>;
  updateMany?: InputMaybe<Array<ProjectPhaseCaptureUpdateManyWithWhereWithoutProjectInput>>;
  upsert?: InputMaybe<Array<ProjectPhaseCaptureUpsertWithWhereUniqueWithoutProjectInput>>;
};

export type ProjectPhaseCaptureUpdateManyWithoutProjectPhaseNestedInput = {
  connect?: InputMaybe<Array<ProjectPhaseCaptureWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectPhaseCaptureCreateOrConnectWithoutProjectPhaseInput>>;
  create?: InputMaybe<Array<ProjectPhaseCaptureCreateWithoutProjectPhaseInput>>;
  createMany?: InputMaybe<ProjectPhaseCaptureCreateManyProjectPhaseInputEnvelope>;
  delete?: InputMaybe<Array<ProjectPhaseCaptureWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProjectPhaseCaptureScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProjectPhaseCaptureWhereUniqueInput>>;
  set?: InputMaybe<Array<ProjectPhaseCaptureWhereUniqueInput>>;
  update?: InputMaybe<Array<ProjectPhaseCaptureUpdateWithWhereUniqueWithoutProjectPhaseInput>>;
  updateMany?: InputMaybe<Array<ProjectPhaseCaptureUpdateManyWithWhereWithoutProjectPhaseInput>>;
  upsert?: InputMaybe<Array<ProjectPhaseCaptureUpsertWithWhereUniqueWithoutProjectPhaseInput>>;
};

export type ProjectPhaseCaptureUpdateWithWhereUniqueWithoutProjectInput = {
  data: ProjectPhaseCaptureUpdateWithoutProjectInput;
  where: ProjectPhaseCaptureWhereUniqueInput;
};

export type ProjectPhaseCaptureUpdateWithWhereUniqueWithoutProjectPhaseInput = {
  data: ProjectPhaseCaptureUpdateWithoutProjectPhaseInput;
  where: ProjectPhaseCaptureWhereUniqueInput;
};

export type ProjectPhaseCaptureUpdateWithoutProjectInput = {
  comment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  projectPhase?: InputMaybe<ProjectPhaseUpdateOneRequiredWithoutProjectPhaseCaptureNestedInput>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProjectPhaseCaptureUpdateWithoutProjectPhaseInput = {
  comment?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  endDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutProjectPhaseCaptureNestedInput>;
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ProjectPhaseCaptureUpsertWithWhereUniqueWithoutProjectInput = {
  create: ProjectPhaseCaptureCreateWithoutProjectInput;
  update: ProjectPhaseCaptureUpdateWithoutProjectInput;
  where: ProjectPhaseCaptureWhereUniqueInput;
};

export type ProjectPhaseCaptureUpsertWithWhereUniqueWithoutProjectPhaseInput = {
  create: ProjectPhaseCaptureCreateWithoutProjectPhaseInput;
  update: ProjectPhaseCaptureUpdateWithoutProjectPhaseInput;
  where: ProjectPhaseCaptureWhereUniqueInput;
};

export type ProjectPhaseCaptureWhereInput = {
  AND?: InputMaybe<Array<ProjectPhaseCaptureWhereInput>>;
  NOT?: InputMaybe<Array<ProjectPhaseCaptureWhereInput>>;
  OR?: InputMaybe<Array<ProjectPhaseCaptureWhereInput>>;
  comment?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  endDate?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  project?: InputMaybe<MasterWhereInput>;
  projectId?: InputMaybe<StringFilter>;
  projectPhase?: InputMaybe<ProjectPhaseWhereInput>;
  projectPhaseId?: InputMaybe<StringFilter>;
  startDate?: InputMaybe<DateTimeFilter>;
};

export type ProjectPhaseCaptureWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type ProjectPhaseCount = {
  __typename?: 'ProjectPhaseCount';
  phaseOnType: Scalars['Int'];
  projectPhaseCapture: Scalars['Int'];
  projectResourceCapture: Scalars['Int'];
};

export type ProjectPhaseCreateInput = {
  id: Scalars['String'];
  order: Scalars['Int'];
  phaseOnType?: InputMaybe<PhaseOnTypeCreateNestedManyWithoutProjectPhaseInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureCreateNestedManyWithoutProjectPhaseInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureCreateNestedManyWithoutProjectPhaseInput>;
};

export type ProjectPhaseCreateNestedOneWithoutPhaseOnTypeInput = {
  connect?: InputMaybe<ProjectPhaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProjectPhaseCreateOrConnectWithoutPhaseOnTypeInput>;
  create?: InputMaybe<ProjectPhaseCreateWithoutPhaseOnTypeInput>;
};

export type ProjectPhaseCreateNestedOneWithoutProjectPhaseCaptureInput = {
  connect?: InputMaybe<ProjectPhaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProjectPhaseCreateOrConnectWithoutProjectPhaseCaptureInput>;
  create?: InputMaybe<ProjectPhaseCreateWithoutProjectPhaseCaptureInput>;
};

export type ProjectPhaseCreateNestedOneWithoutProjectResourceCaptureInput = {
  connect?: InputMaybe<ProjectPhaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProjectPhaseCreateOrConnectWithoutProjectResourceCaptureInput>;
  create?: InputMaybe<ProjectPhaseCreateWithoutProjectResourceCaptureInput>;
};

export type ProjectPhaseCreateOrConnectWithoutPhaseOnTypeInput = {
  create: ProjectPhaseCreateWithoutPhaseOnTypeInput;
  where: ProjectPhaseWhereUniqueInput;
};

export type ProjectPhaseCreateOrConnectWithoutProjectPhaseCaptureInput = {
  create: ProjectPhaseCreateWithoutProjectPhaseCaptureInput;
  where: ProjectPhaseWhereUniqueInput;
};

export type ProjectPhaseCreateOrConnectWithoutProjectResourceCaptureInput = {
  create: ProjectPhaseCreateWithoutProjectResourceCaptureInput;
  where: ProjectPhaseWhereUniqueInput;
};

export type ProjectPhaseCreateWithoutPhaseOnTypeInput = {
  id: Scalars['String'];
  order: Scalars['Int'];
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureCreateNestedManyWithoutProjectPhaseInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureCreateNestedManyWithoutProjectPhaseInput>;
};

export type ProjectPhaseCreateWithoutProjectPhaseCaptureInput = {
  id: Scalars['String'];
  order: Scalars['Int'];
  phaseOnType?: InputMaybe<PhaseOnTypeCreateNestedManyWithoutProjectPhaseInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureCreateNestedManyWithoutProjectPhaseInput>;
};

export type ProjectPhaseCreateWithoutProjectResourceCaptureInput = {
  id: Scalars['String'];
  order: Scalars['Int'];
  phaseOnType?: InputMaybe<PhaseOnTypeCreateNestedManyWithoutProjectPhaseInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureCreateNestedManyWithoutProjectPhaseInput>;
};

export type ProjectPhaseOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  phaseOnType?: InputMaybe<PhaseOnTypeOrderByRelationAggregateInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureOrderByRelationAggregateInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureOrderByRelationAggregateInput>;
};

export enum ProjectPhaseScalarFieldEnum {
  Id = 'id',
  Order = 'order'
}

export type ProjectPhaseUpdateInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  phaseOnType?: InputMaybe<PhaseOnTypeUpdateManyWithoutProjectPhaseNestedInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureUpdateManyWithoutProjectPhaseNestedInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureUpdateManyWithoutProjectPhaseNestedInput>;
};

export type ProjectPhaseUpdateOneRequiredWithoutPhaseOnTypeNestedInput = {
  connect?: InputMaybe<ProjectPhaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProjectPhaseCreateOrConnectWithoutPhaseOnTypeInput>;
  create?: InputMaybe<ProjectPhaseCreateWithoutPhaseOnTypeInput>;
  update?: InputMaybe<ProjectPhaseUpdateWithoutPhaseOnTypeInput>;
  upsert?: InputMaybe<ProjectPhaseUpsertWithoutPhaseOnTypeInput>;
};

export type ProjectPhaseUpdateOneRequiredWithoutProjectPhaseCaptureNestedInput = {
  connect?: InputMaybe<ProjectPhaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProjectPhaseCreateOrConnectWithoutProjectPhaseCaptureInput>;
  create?: InputMaybe<ProjectPhaseCreateWithoutProjectPhaseCaptureInput>;
  update?: InputMaybe<ProjectPhaseUpdateWithoutProjectPhaseCaptureInput>;
  upsert?: InputMaybe<ProjectPhaseUpsertWithoutProjectPhaseCaptureInput>;
};

export type ProjectPhaseUpdateOneRequiredWithoutProjectResourceCaptureNestedInput = {
  connect?: InputMaybe<ProjectPhaseWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProjectPhaseCreateOrConnectWithoutProjectResourceCaptureInput>;
  create?: InputMaybe<ProjectPhaseCreateWithoutProjectResourceCaptureInput>;
  update?: InputMaybe<ProjectPhaseUpdateWithoutProjectResourceCaptureInput>;
  upsert?: InputMaybe<ProjectPhaseUpsertWithoutProjectResourceCaptureInput>;
};

export type ProjectPhaseUpdateWithoutPhaseOnTypeInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureUpdateManyWithoutProjectPhaseNestedInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureUpdateManyWithoutProjectPhaseNestedInput>;
};

export type ProjectPhaseUpdateWithoutProjectPhaseCaptureInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  phaseOnType?: InputMaybe<PhaseOnTypeUpdateManyWithoutProjectPhaseNestedInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureUpdateManyWithoutProjectPhaseNestedInput>;
};

export type ProjectPhaseUpdateWithoutProjectResourceCaptureInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  phaseOnType?: InputMaybe<PhaseOnTypeUpdateManyWithoutProjectPhaseNestedInput>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureUpdateManyWithoutProjectPhaseNestedInput>;
};

export type ProjectPhaseUpsertWithoutPhaseOnTypeInput = {
  create: ProjectPhaseCreateWithoutPhaseOnTypeInput;
  update: ProjectPhaseUpdateWithoutPhaseOnTypeInput;
};

export type ProjectPhaseUpsertWithoutProjectPhaseCaptureInput = {
  create: ProjectPhaseCreateWithoutProjectPhaseCaptureInput;
  update: ProjectPhaseUpdateWithoutProjectPhaseCaptureInput;
};

export type ProjectPhaseUpsertWithoutProjectResourceCaptureInput = {
  create: ProjectPhaseCreateWithoutProjectResourceCaptureInput;
  update: ProjectPhaseUpdateWithoutProjectResourceCaptureInput;
};

export type ProjectPhaseWhereInput = {
  AND?: InputMaybe<Array<ProjectPhaseWhereInput>>;
  NOT?: InputMaybe<Array<ProjectPhaseWhereInput>>;
  OR?: InputMaybe<Array<ProjectPhaseWhereInput>>;
  id?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntFilter>;
  phaseOnType?: InputMaybe<PhaseOnTypeListRelationFilter>;
  projectPhaseCapture?: InputMaybe<ProjectPhaseCaptureListRelationFilter>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureListRelationFilter>;
};

export type ProjectPhaseWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type ProjectQuestionnaire = {
  __typename?: 'ProjectQuestionnaire';
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  project: Master;
  projectId: Scalars['String'];
  projectQuestionnaireStatus: ProjectQuestionnaireStatus;
  projectQuestionnaireStatusId: Scalars['String'];
  value: Scalars['Boolean'];
};

export type ProjectQuestionnaireCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  project: MasterCreateNestedOneWithoutProjectQuestionnaireInput;
  projectQuestionnaireStatus: ProjectQuestionnaireStatusCreateNestedOneWithoutProjectQuestionnaireInput;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type ProjectQuestionnaireCreateManyProjectInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  projectQuestionnaireStatusId: Scalars['String'];
  value?: InputMaybe<Scalars['Boolean']>;
};

export type ProjectQuestionnaireCreateManyProjectInputEnvelope = {
  data: Array<ProjectQuestionnaireCreateManyProjectInput>;
};

export type ProjectQuestionnaireCreateManyProjectQuestionnaireStatusInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
  value?: InputMaybe<Scalars['Boolean']>;
};

export type ProjectQuestionnaireCreateManyProjectQuestionnaireStatusInputEnvelope = {
  data: Array<ProjectQuestionnaireCreateManyProjectQuestionnaireStatusInput>;
};

export type ProjectQuestionnaireCreateNestedManyWithoutProjectInput = {
  connect?: InputMaybe<Array<ProjectQuestionnaireWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectQuestionnaireCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<ProjectQuestionnaireCreateWithoutProjectInput>>;
  createMany?: InputMaybe<ProjectQuestionnaireCreateManyProjectInputEnvelope>;
};

export type ProjectQuestionnaireCreateNestedManyWithoutProjectQuestionnaireStatusInput = {
  connect?: InputMaybe<Array<ProjectQuestionnaireWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectQuestionnaireCreateOrConnectWithoutProjectQuestionnaireStatusInput>>;
  create?: InputMaybe<Array<ProjectQuestionnaireCreateWithoutProjectQuestionnaireStatusInput>>;
  createMany?: InputMaybe<ProjectQuestionnaireCreateManyProjectQuestionnaireStatusInputEnvelope>;
};

export type ProjectQuestionnaireCreateOrConnectWithoutProjectInput = {
  create: ProjectQuestionnaireCreateWithoutProjectInput;
  where: ProjectQuestionnaireWhereUniqueInput;
};

export type ProjectQuestionnaireCreateOrConnectWithoutProjectQuestionnaireStatusInput = {
  create: ProjectQuestionnaireCreateWithoutProjectQuestionnaireStatusInput;
  where: ProjectQuestionnaireWhereUniqueInput;
};

export type ProjectQuestionnaireCreateWithoutProjectInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  projectQuestionnaireStatus: ProjectQuestionnaireStatusCreateNestedOneWithoutProjectQuestionnaireInput;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type ProjectQuestionnaireCreateWithoutProjectQuestionnaireStatusInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  project: MasterCreateNestedOneWithoutProjectQuestionnaireInput;
  value?: InputMaybe<Scalars['Boolean']>;
};

export type ProjectQuestionnaireListRelationFilter = {
  every?: InputMaybe<ProjectQuestionnaireWhereInput>;
  none?: InputMaybe<ProjectQuestionnaireWhereInput>;
  some?: InputMaybe<ProjectQuestionnaireWhereInput>;
};

export type ProjectQuestionnaireOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProjectQuestionnaireOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  deletedBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  project?: InputMaybe<MasterOrderByWithRelationInput>;
  projectId?: InputMaybe<SortOrder>;
  projectQuestionnaireStatus?: InputMaybe<ProjectQuestionnaireStatusOrderByWithRelationInput>;
  projectQuestionnaireStatusId?: InputMaybe<SortOrder>;
  value?: InputMaybe<SortOrder>;
};

export enum ProjectQuestionnaireScalarFieldEnum {
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  DeletedAt = 'deletedAt',
  DeletedBy = 'deletedBy',
  Id = 'id',
  ProjectId = 'projectId',
  ProjectQuestionnaireStatusId = 'projectQuestionnaireStatusId',
  Value = 'value'
}

export type ProjectQuestionnaireScalarWhereInput = {
  AND?: InputMaybe<Array<ProjectQuestionnaireScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProjectQuestionnaireScalarWhereInput>>;
  OR?: InputMaybe<Array<ProjectQuestionnaireScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  projectId?: InputMaybe<StringFilter>;
  projectQuestionnaireStatusId?: InputMaybe<StringFilter>;
  value?: InputMaybe<BoolFilter>;
};

export type ProjectQuestionnaireStatus = {
  __typename?: 'ProjectQuestionnaireStatus';
  _count: ProjectQuestionnaireStatusCount;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  order?: Maybe<Scalars['Int']>;
  projectQuestionnaire?: Maybe<Array<ProjectQuestionnaire>>;
  question?: Maybe<Scalars['String']>;
};

export type ProjectQuestionnaireStatusCount = {
  __typename?: 'ProjectQuestionnaireStatusCount';
  projectQuestionnaire: Scalars['Int'];
};

export type ProjectQuestionnaireStatusCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireCreateNestedManyWithoutProjectQuestionnaireStatusInput>;
  question?: InputMaybe<Scalars['String']>;
};

export type ProjectQuestionnaireStatusCreateNestedOneWithoutProjectQuestionnaireInput = {
  connect?: InputMaybe<ProjectQuestionnaireStatusWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProjectQuestionnaireStatusCreateOrConnectWithoutProjectQuestionnaireInput>;
  create?: InputMaybe<ProjectQuestionnaireStatusCreateWithoutProjectQuestionnaireInput>;
};

export type ProjectQuestionnaireStatusCreateOrConnectWithoutProjectQuestionnaireInput = {
  create: ProjectQuestionnaireStatusCreateWithoutProjectQuestionnaireInput;
  where: ProjectQuestionnaireStatusWhereUniqueInput;
};

export type ProjectQuestionnaireStatusCreateWithoutProjectQuestionnaireInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  question?: InputMaybe<Scalars['String']>;
};

export type ProjectQuestionnaireStatusOrderByWithRelationInput = {
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireOrderByRelationAggregateInput>;
  question?: InputMaybe<SortOrder>;
};

export enum ProjectQuestionnaireStatusScalarFieldEnum {
  Description = 'description',
  Id = 'id',
  Order = 'order',
  Question = 'question'
}

export type ProjectQuestionnaireStatusUpdateInput = {
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireUpdateManyWithoutProjectQuestionnaireStatusNestedInput>;
  question?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ProjectQuestionnaireStatusUpdateOneRequiredWithoutProjectQuestionnaireNestedInput = {
  connect?: InputMaybe<ProjectQuestionnaireStatusWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProjectQuestionnaireStatusCreateOrConnectWithoutProjectQuestionnaireInput>;
  create?: InputMaybe<ProjectQuestionnaireStatusCreateWithoutProjectQuestionnaireInput>;
  update?: InputMaybe<ProjectQuestionnaireStatusUpdateWithoutProjectQuestionnaireInput>;
  upsert?: InputMaybe<ProjectQuestionnaireStatusUpsertWithoutProjectQuestionnaireInput>;
};

export type ProjectQuestionnaireStatusUpdateWithoutProjectQuestionnaireInput = {
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  question?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ProjectQuestionnaireStatusUpsertWithoutProjectQuestionnaireInput = {
  create: ProjectQuestionnaireStatusCreateWithoutProjectQuestionnaireInput;
  update: ProjectQuestionnaireStatusUpdateWithoutProjectQuestionnaireInput;
};

export type ProjectQuestionnaireStatusWhereInput = {
  AND?: InputMaybe<Array<ProjectQuestionnaireStatusWhereInput>>;
  NOT?: InputMaybe<Array<ProjectQuestionnaireStatusWhereInput>>;
  OR?: InputMaybe<Array<ProjectQuestionnaireStatusWhereInput>>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntNullableFilter>;
  projectQuestionnaire?: InputMaybe<ProjectQuestionnaireListRelationFilter>;
  question?: InputMaybe<StringNullableFilter>;
};

export type ProjectQuestionnaireStatusWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type ProjectQuestionnaireUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutProjectQuestionnaireNestedInput>;
  projectQuestionnaireStatus?: InputMaybe<ProjectQuestionnaireStatusUpdateOneRequiredWithoutProjectQuestionnaireNestedInput>;
  value?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type ProjectQuestionnaireUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  value?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type ProjectQuestionnaireUpdateManyWithWhereWithoutProjectInput = {
  data: ProjectQuestionnaireUpdateManyMutationInput;
  where: ProjectQuestionnaireScalarWhereInput;
};

export type ProjectQuestionnaireUpdateManyWithWhereWithoutProjectQuestionnaireStatusInput = {
  data: ProjectQuestionnaireUpdateManyMutationInput;
  where: ProjectQuestionnaireScalarWhereInput;
};

export type ProjectQuestionnaireUpdateManyWithoutProjectNestedInput = {
  connect?: InputMaybe<Array<ProjectQuestionnaireWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectQuestionnaireCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<ProjectQuestionnaireCreateWithoutProjectInput>>;
  createMany?: InputMaybe<ProjectQuestionnaireCreateManyProjectInputEnvelope>;
  delete?: InputMaybe<Array<ProjectQuestionnaireWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProjectQuestionnaireScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProjectQuestionnaireWhereUniqueInput>>;
  set?: InputMaybe<Array<ProjectQuestionnaireWhereUniqueInput>>;
  update?: InputMaybe<Array<ProjectQuestionnaireUpdateWithWhereUniqueWithoutProjectInput>>;
  updateMany?: InputMaybe<Array<ProjectQuestionnaireUpdateManyWithWhereWithoutProjectInput>>;
  upsert?: InputMaybe<Array<ProjectQuestionnaireUpsertWithWhereUniqueWithoutProjectInput>>;
};

export type ProjectQuestionnaireUpdateManyWithoutProjectQuestionnaireStatusNestedInput = {
  connect?: InputMaybe<Array<ProjectQuestionnaireWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectQuestionnaireCreateOrConnectWithoutProjectQuestionnaireStatusInput>>;
  create?: InputMaybe<Array<ProjectQuestionnaireCreateWithoutProjectQuestionnaireStatusInput>>;
  createMany?: InputMaybe<ProjectQuestionnaireCreateManyProjectQuestionnaireStatusInputEnvelope>;
  delete?: InputMaybe<Array<ProjectQuestionnaireWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProjectQuestionnaireScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProjectQuestionnaireWhereUniqueInput>>;
  set?: InputMaybe<Array<ProjectQuestionnaireWhereUniqueInput>>;
  update?: InputMaybe<Array<ProjectQuestionnaireUpdateWithWhereUniqueWithoutProjectQuestionnaireStatusInput>>;
  updateMany?: InputMaybe<Array<ProjectQuestionnaireUpdateManyWithWhereWithoutProjectQuestionnaireStatusInput>>;
  upsert?: InputMaybe<Array<ProjectQuestionnaireUpsertWithWhereUniqueWithoutProjectQuestionnaireStatusInput>>;
};

export type ProjectQuestionnaireUpdateWithWhereUniqueWithoutProjectInput = {
  data: ProjectQuestionnaireUpdateWithoutProjectInput;
  where: ProjectQuestionnaireWhereUniqueInput;
};

export type ProjectQuestionnaireUpdateWithWhereUniqueWithoutProjectQuestionnaireStatusInput = {
  data: ProjectQuestionnaireUpdateWithoutProjectQuestionnaireStatusInput;
  where: ProjectQuestionnaireWhereUniqueInput;
};

export type ProjectQuestionnaireUpdateWithoutProjectInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  projectQuestionnaireStatus?: InputMaybe<ProjectQuestionnaireStatusUpdateOneRequiredWithoutProjectQuestionnaireNestedInput>;
  value?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type ProjectQuestionnaireUpdateWithoutProjectQuestionnaireStatusInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutProjectQuestionnaireNestedInput>;
  value?: InputMaybe<BoolFieldUpdateOperationsInput>;
};

export type ProjectQuestionnaireUpsertWithWhereUniqueWithoutProjectInput = {
  create: ProjectQuestionnaireCreateWithoutProjectInput;
  update: ProjectQuestionnaireUpdateWithoutProjectInput;
  where: ProjectQuestionnaireWhereUniqueInput;
};

export type ProjectQuestionnaireUpsertWithWhereUniqueWithoutProjectQuestionnaireStatusInput = {
  create: ProjectQuestionnaireCreateWithoutProjectQuestionnaireStatusInput;
  update: ProjectQuestionnaireUpdateWithoutProjectQuestionnaireStatusInput;
  where: ProjectQuestionnaireWhereUniqueInput;
};

export type ProjectQuestionnaireWhereInput = {
  AND?: InputMaybe<Array<ProjectQuestionnaireWhereInput>>;
  NOT?: InputMaybe<Array<ProjectQuestionnaireWhereInput>>;
  OR?: InputMaybe<Array<ProjectQuestionnaireWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  project?: InputMaybe<MasterWhereInput>;
  projectId?: InputMaybe<StringFilter>;
  projectQuestionnaireStatus?: InputMaybe<ProjectQuestionnaireStatusWhereInput>;
  projectQuestionnaireStatusId?: InputMaybe<StringFilter>;
  value?: InputMaybe<BoolFilter>;
};

export type ProjectQuestionnaireWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type ProjectResourceCapture = {
  __typename?: 'ProjectResourceCapture';
  communication: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  department: Scalars['String'];
  employee: Employee;
  employeeId: Scalars['String'];
  endDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  month?: Maybe<Scalars['Float']>;
  onboarding: Scalars['DateTime'];
  project: Master;
  projectId: Scalars['String'];
  projectPhase: ProjectPhase;
  projectPhaseId: Scalars['String'];
  rate: Scalars['Int'];
  role: Role;
  roleId: Scalars['String'];
  update: Scalars['String'];
  year: Scalars['Int'];
};

export type ProjectResourceCaptureAvgAggregate = {
  __typename?: 'ProjectResourceCaptureAvgAggregate';
  month?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  year?: Maybe<Scalars['Float']>;
};

export type ProjectResourceCaptureAvgAggregateInput = {
  month?: InputMaybe<Scalars['Boolean']>;
  rate?: InputMaybe<Scalars['Boolean']>;
  year?: InputMaybe<Scalars['Boolean']>;
};

export type ProjectResourceCaptureAvgOrderByAggregateInput = {
  month?: InputMaybe<SortOrder>;
  rate?: InputMaybe<SortOrder>;
  year?: InputMaybe<SortOrder>;
};

export type ProjectResourceCaptureCountAggregate = {
  __typename?: 'ProjectResourceCaptureCountAggregate';
  _all: Scalars['Int'];
  communication: Scalars['Int'];
  createdAt: Scalars['Int'];
  createdBy: Scalars['Int'];
  deletedAt: Scalars['Int'];
  deletedBy: Scalars['Int'];
  department: Scalars['Int'];
  employeeId: Scalars['Int'];
  endDate: Scalars['Int'];
  id: Scalars['Int'];
  month: Scalars['Int'];
  onboarding: Scalars['Int'];
  projectId: Scalars['Int'];
  projectPhaseId: Scalars['Int'];
  rate: Scalars['Int'];
  roleId: Scalars['Int'];
  update: Scalars['Int'];
  year: Scalars['Int'];
};

export type ProjectResourceCaptureCountAggregateInput = {
  _all?: InputMaybe<Scalars['Boolean']>;
  communication?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Boolean']>;
  createdBy?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['Boolean']>;
  deletedBy?: InputMaybe<Scalars['Boolean']>;
  department?: InputMaybe<Scalars['Boolean']>;
  employeeId?: InputMaybe<Scalars['Boolean']>;
  endDate?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Boolean']>;
  month?: InputMaybe<Scalars['Boolean']>;
  onboarding?: InputMaybe<Scalars['Boolean']>;
  projectId?: InputMaybe<Scalars['Boolean']>;
  projectPhaseId?: InputMaybe<Scalars['Boolean']>;
  rate?: InputMaybe<Scalars['Boolean']>;
  roleId?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<Scalars['Boolean']>;
  year?: InputMaybe<Scalars['Boolean']>;
};

export type ProjectResourceCaptureCountOrderByAggregateInput = {
  communication?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  deletedBy?: InputMaybe<SortOrder>;
  department?: InputMaybe<SortOrder>;
  employeeId?: InputMaybe<SortOrder>;
  endDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  month?: InputMaybe<SortOrder>;
  onboarding?: InputMaybe<SortOrder>;
  projectId?: InputMaybe<SortOrder>;
  projectPhaseId?: InputMaybe<SortOrder>;
  rate?: InputMaybe<SortOrder>;
  roleId?: InputMaybe<SortOrder>;
  update?: InputMaybe<SortOrder>;
  year?: InputMaybe<SortOrder>;
};

export type ProjectResourceCaptureCreateInput = {
  communication: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  department: Scalars['String'];
  employee: EmployeeCreateNestedOneWithoutProjectResourceCaptureInput;
  endDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  month?: InputMaybe<Scalars['Float']>;
  onboarding: Scalars['DateTime'];
  project: MasterCreateNestedOneWithoutProjectResourceCaptureInput;
  projectPhase: ProjectPhaseCreateNestedOneWithoutProjectResourceCaptureInput;
  rate: Scalars['Int'];
  role: RoleCreateNestedOneWithoutProjectResourceCaptureInput;
  update: Scalars['String'];
  year: Scalars['Int'];
};

export type ProjectResourceCaptureCreateManyEmployeeInput = {
  communication: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  department: Scalars['String'];
  endDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  month?: InputMaybe<Scalars['Float']>;
  onboarding: Scalars['DateTime'];
  projectId: Scalars['String'];
  projectPhaseId: Scalars['String'];
  rate: Scalars['Int'];
  roleId: Scalars['String'];
  update: Scalars['String'];
  year: Scalars['Int'];
};

export type ProjectResourceCaptureCreateManyEmployeeInputEnvelope = {
  data: Array<ProjectResourceCaptureCreateManyEmployeeInput>;
};

export type ProjectResourceCaptureCreateManyProjectInput = {
  communication: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  department: Scalars['String'];
  employeeId: Scalars['String'];
  endDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  month?: InputMaybe<Scalars['Float']>;
  onboarding: Scalars['DateTime'];
  projectPhaseId: Scalars['String'];
  rate: Scalars['Int'];
  roleId: Scalars['String'];
  update: Scalars['String'];
  year: Scalars['Int'];
};

export type ProjectResourceCaptureCreateManyProjectInputEnvelope = {
  data: Array<ProjectResourceCaptureCreateManyProjectInput>;
};

export type ProjectResourceCaptureCreateManyProjectPhaseInput = {
  communication: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  department: Scalars['String'];
  employeeId: Scalars['String'];
  endDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  month?: InputMaybe<Scalars['Float']>;
  onboarding: Scalars['DateTime'];
  projectId: Scalars['String'];
  rate: Scalars['Int'];
  roleId: Scalars['String'];
  update: Scalars['String'];
  year: Scalars['Int'];
};

export type ProjectResourceCaptureCreateManyProjectPhaseInputEnvelope = {
  data: Array<ProjectResourceCaptureCreateManyProjectPhaseInput>;
};

export type ProjectResourceCaptureCreateManyRoleInput = {
  communication: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  department: Scalars['String'];
  employeeId: Scalars['String'];
  endDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  month?: InputMaybe<Scalars['Float']>;
  onboarding: Scalars['DateTime'];
  projectId: Scalars['String'];
  projectPhaseId: Scalars['String'];
  rate: Scalars['Int'];
  update: Scalars['String'];
  year: Scalars['Int'];
};

export type ProjectResourceCaptureCreateManyRoleInputEnvelope = {
  data: Array<ProjectResourceCaptureCreateManyRoleInput>;
};

export type ProjectResourceCaptureCreateNestedManyWithoutEmployeeInput = {
  connect?: InputMaybe<Array<ProjectResourceCaptureWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectResourceCaptureCreateOrConnectWithoutEmployeeInput>>;
  create?: InputMaybe<Array<ProjectResourceCaptureCreateWithoutEmployeeInput>>;
  createMany?: InputMaybe<ProjectResourceCaptureCreateManyEmployeeInputEnvelope>;
};

export type ProjectResourceCaptureCreateNestedManyWithoutProjectInput = {
  connect?: InputMaybe<Array<ProjectResourceCaptureWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectResourceCaptureCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<ProjectResourceCaptureCreateWithoutProjectInput>>;
  createMany?: InputMaybe<ProjectResourceCaptureCreateManyProjectInputEnvelope>;
};

export type ProjectResourceCaptureCreateNestedManyWithoutProjectPhaseInput = {
  connect?: InputMaybe<Array<ProjectResourceCaptureWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectResourceCaptureCreateOrConnectWithoutProjectPhaseInput>>;
  create?: InputMaybe<Array<ProjectResourceCaptureCreateWithoutProjectPhaseInput>>;
  createMany?: InputMaybe<ProjectResourceCaptureCreateManyProjectPhaseInputEnvelope>;
};

export type ProjectResourceCaptureCreateNestedManyWithoutRoleInput = {
  connect?: InputMaybe<Array<ProjectResourceCaptureWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectResourceCaptureCreateOrConnectWithoutRoleInput>>;
  create?: InputMaybe<Array<ProjectResourceCaptureCreateWithoutRoleInput>>;
  createMany?: InputMaybe<ProjectResourceCaptureCreateManyRoleInputEnvelope>;
};

export type ProjectResourceCaptureCreateOrConnectWithoutEmployeeInput = {
  create: ProjectResourceCaptureCreateWithoutEmployeeInput;
  where: ProjectResourceCaptureWhereUniqueInput;
};

export type ProjectResourceCaptureCreateOrConnectWithoutProjectInput = {
  create: ProjectResourceCaptureCreateWithoutProjectInput;
  where: ProjectResourceCaptureWhereUniqueInput;
};

export type ProjectResourceCaptureCreateOrConnectWithoutProjectPhaseInput = {
  create: ProjectResourceCaptureCreateWithoutProjectPhaseInput;
  where: ProjectResourceCaptureWhereUniqueInput;
};

export type ProjectResourceCaptureCreateOrConnectWithoutRoleInput = {
  create: ProjectResourceCaptureCreateWithoutRoleInput;
  where: ProjectResourceCaptureWhereUniqueInput;
};

export type ProjectResourceCaptureCreateWithoutEmployeeInput = {
  communication: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  department: Scalars['String'];
  endDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  month?: InputMaybe<Scalars['Float']>;
  onboarding: Scalars['DateTime'];
  project: MasterCreateNestedOneWithoutProjectResourceCaptureInput;
  projectPhase: ProjectPhaseCreateNestedOneWithoutProjectResourceCaptureInput;
  rate: Scalars['Int'];
  role: RoleCreateNestedOneWithoutProjectResourceCaptureInput;
  update: Scalars['String'];
  year: Scalars['Int'];
};

export type ProjectResourceCaptureCreateWithoutProjectInput = {
  communication: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  department: Scalars['String'];
  employee: EmployeeCreateNestedOneWithoutProjectResourceCaptureInput;
  endDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  month?: InputMaybe<Scalars['Float']>;
  onboarding: Scalars['DateTime'];
  projectPhase: ProjectPhaseCreateNestedOneWithoutProjectResourceCaptureInput;
  rate: Scalars['Int'];
  role: RoleCreateNestedOneWithoutProjectResourceCaptureInput;
  update: Scalars['String'];
  year: Scalars['Int'];
};

export type ProjectResourceCaptureCreateWithoutProjectPhaseInput = {
  communication: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  department: Scalars['String'];
  employee: EmployeeCreateNestedOneWithoutProjectResourceCaptureInput;
  endDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  month?: InputMaybe<Scalars['Float']>;
  onboarding: Scalars['DateTime'];
  project: MasterCreateNestedOneWithoutProjectResourceCaptureInput;
  rate: Scalars['Int'];
  role: RoleCreateNestedOneWithoutProjectResourceCaptureInput;
  update: Scalars['String'];
  year: Scalars['Int'];
};

export type ProjectResourceCaptureCreateWithoutRoleInput = {
  communication: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  department: Scalars['String'];
  employee: EmployeeCreateNestedOneWithoutProjectResourceCaptureInput;
  endDate?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  month?: InputMaybe<Scalars['Float']>;
  onboarding: Scalars['DateTime'];
  project: MasterCreateNestedOneWithoutProjectResourceCaptureInput;
  projectPhase: ProjectPhaseCreateNestedOneWithoutProjectResourceCaptureInput;
  rate: Scalars['Int'];
  update: Scalars['String'];
  year: Scalars['Int'];
};

export type ProjectResourceCaptureGroupBy = {
  __typename?: 'ProjectResourceCaptureGroupBy';
  _avg?: Maybe<ProjectResourceCaptureAvgAggregate>;
  _count?: Maybe<ProjectResourceCaptureCountAggregate>;
  _max?: Maybe<ProjectResourceCaptureMaxAggregate>;
  _min?: Maybe<ProjectResourceCaptureMinAggregate>;
  _sum?: Maybe<ProjectResourceCaptureSumAggregate>;
  communication: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  department: Scalars['String'];
  employeeId: Scalars['String'];
  endDate?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  month?: Maybe<Scalars['Float']>;
  onboarding: Scalars['DateTime'];
  projectId: Scalars['String'];
  projectPhaseId: Scalars['String'];
  rate: Scalars['Int'];
  roleId: Scalars['String'];
  update: Scalars['String'];
  year: Scalars['Int'];
};

export type ProjectResourceCaptureListRelationFilter = {
  every?: InputMaybe<ProjectResourceCaptureWhereInput>;
  none?: InputMaybe<ProjectResourceCaptureWhereInput>;
  some?: InputMaybe<ProjectResourceCaptureWhereInput>;
};

export type ProjectResourceCaptureMaxAggregate = {
  __typename?: 'ProjectResourceCaptureMaxAggregate';
  communication?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  employeeId?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  month?: Maybe<Scalars['Float']>;
  onboarding?: Maybe<Scalars['DateTime']>;
  projectId?: Maybe<Scalars['String']>;
  projectPhaseId?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['Int']>;
  roleId?: Maybe<Scalars['String']>;
  update?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};

export type ProjectResourceCaptureMaxAggregateInput = {
  communication?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Boolean']>;
  createdBy?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['Boolean']>;
  deletedBy?: InputMaybe<Scalars['Boolean']>;
  department?: InputMaybe<Scalars['Boolean']>;
  employeeId?: InputMaybe<Scalars['Boolean']>;
  endDate?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Boolean']>;
  month?: InputMaybe<Scalars['Boolean']>;
  onboarding?: InputMaybe<Scalars['Boolean']>;
  projectId?: InputMaybe<Scalars['Boolean']>;
  projectPhaseId?: InputMaybe<Scalars['Boolean']>;
  rate?: InputMaybe<Scalars['Boolean']>;
  roleId?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<Scalars['Boolean']>;
  year?: InputMaybe<Scalars['Boolean']>;
};

export type ProjectResourceCaptureMaxOrderByAggregateInput = {
  communication?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  deletedBy?: InputMaybe<SortOrder>;
  department?: InputMaybe<SortOrder>;
  employeeId?: InputMaybe<SortOrder>;
  endDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  month?: InputMaybe<SortOrder>;
  onboarding?: InputMaybe<SortOrder>;
  projectId?: InputMaybe<SortOrder>;
  projectPhaseId?: InputMaybe<SortOrder>;
  rate?: InputMaybe<SortOrder>;
  roleId?: InputMaybe<SortOrder>;
  update?: InputMaybe<SortOrder>;
  year?: InputMaybe<SortOrder>;
};

export type ProjectResourceCaptureMinAggregate = {
  __typename?: 'ProjectResourceCaptureMinAggregate';
  communication?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  employeeId?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  month?: Maybe<Scalars['Float']>;
  onboarding?: Maybe<Scalars['DateTime']>;
  projectId?: Maybe<Scalars['String']>;
  projectPhaseId?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['Int']>;
  roleId?: Maybe<Scalars['String']>;
  update?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};

export type ProjectResourceCaptureMinAggregateInput = {
  communication?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['Boolean']>;
  createdBy?: InputMaybe<Scalars['Boolean']>;
  deletedAt?: InputMaybe<Scalars['Boolean']>;
  deletedBy?: InputMaybe<Scalars['Boolean']>;
  department?: InputMaybe<Scalars['Boolean']>;
  employeeId?: InputMaybe<Scalars['Boolean']>;
  endDate?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Boolean']>;
  month?: InputMaybe<Scalars['Boolean']>;
  onboarding?: InputMaybe<Scalars['Boolean']>;
  projectId?: InputMaybe<Scalars['Boolean']>;
  projectPhaseId?: InputMaybe<Scalars['Boolean']>;
  rate?: InputMaybe<Scalars['Boolean']>;
  roleId?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<Scalars['Boolean']>;
  year?: InputMaybe<Scalars['Boolean']>;
};

export type ProjectResourceCaptureMinOrderByAggregateInput = {
  communication?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  deletedBy?: InputMaybe<SortOrder>;
  department?: InputMaybe<SortOrder>;
  employeeId?: InputMaybe<SortOrder>;
  endDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  month?: InputMaybe<SortOrder>;
  onboarding?: InputMaybe<SortOrder>;
  projectId?: InputMaybe<SortOrder>;
  projectPhaseId?: InputMaybe<SortOrder>;
  rate?: InputMaybe<SortOrder>;
  roleId?: InputMaybe<SortOrder>;
  update?: InputMaybe<SortOrder>;
  year?: InputMaybe<SortOrder>;
};

export type ProjectResourceCaptureOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProjectResourceCaptureOrderByWithAggregationInput = {
  _avg?: InputMaybe<ProjectResourceCaptureAvgOrderByAggregateInput>;
  _count?: InputMaybe<ProjectResourceCaptureCountOrderByAggregateInput>;
  _max?: InputMaybe<ProjectResourceCaptureMaxOrderByAggregateInput>;
  _min?: InputMaybe<ProjectResourceCaptureMinOrderByAggregateInput>;
  _sum?: InputMaybe<ProjectResourceCaptureSumOrderByAggregateInput>;
  communication?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  deletedBy?: InputMaybe<SortOrder>;
  department?: InputMaybe<SortOrder>;
  employeeId?: InputMaybe<SortOrder>;
  endDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  month?: InputMaybe<SortOrder>;
  onboarding?: InputMaybe<SortOrder>;
  projectId?: InputMaybe<SortOrder>;
  projectPhaseId?: InputMaybe<SortOrder>;
  rate?: InputMaybe<SortOrder>;
  roleId?: InputMaybe<SortOrder>;
  update?: InputMaybe<SortOrder>;
  year?: InputMaybe<SortOrder>;
};

export type ProjectResourceCaptureOrderByWithRelationInput = {
  communication?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  deletedBy?: InputMaybe<SortOrder>;
  department?: InputMaybe<SortOrder>;
  employee?: InputMaybe<EmployeeOrderByWithRelationInput>;
  employeeId?: InputMaybe<SortOrder>;
  endDate?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  month?: InputMaybe<SortOrder>;
  onboarding?: InputMaybe<SortOrder>;
  project?: InputMaybe<MasterOrderByWithRelationInput>;
  projectId?: InputMaybe<SortOrder>;
  projectPhase?: InputMaybe<ProjectPhaseOrderByWithRelationInput>;
  projectPhaseId?: InputMaybe<SortOrder>;
  rate?: InputMaybe<SortOrder>;
  role?: InputMaybe<RoleOrderByWithRelationInput>;
  roleId?: InputMaybe<SortOrder>;
  update?: InputMaybe<SortOrder>;
  year?: InputMaybe<SortOrder>;
};

export enum ProjectResourceCaptureScalarFieldEnum {
  Communication = 'communication',
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  DeletedAt = 'deletedAt',
  DeletedBy = 'deletedBy',
  Department = 'department',
  EmployeeId = 'employeeId',
  EndDate = 'endDate',
  Id = 'id',
  Month = 'month',
  Onboarding = 'onboarding',
  ProjectId = 'projectId',
  ProjectPhaseId = 'projectPhaseId',
  Rate = 'rate',
  RoleId = 'roleId',
  Update = 'update',
  Year = 'year'
}

export type ProjectResourceCaptureScalarWhereInput = {
  AND?: InputMaybe<Array<ProjectResourceCaptureScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProjectResourceCaptureScalarWhereInput>>;
  OR?: InputMaybe<Array<ProjectResourceCaptureScalarWhereInput>>;
  communication?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  department?: InputMaybe<StringFilter>;
  employeeId?: InputMaybe<StringFilter>;
  endDate?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  month?: InputMaybe<FloatNullableFilter>;
  onboarding?: InputMaybe<DateTimeFilter>;
  projectId?: InputMaybe<StringFilter>;
  projectPhaseId?: InputMaybe<StringFilter>;
  rate?: InputMaybe<IntFilter>;
  roleId?: InputMaybe<StringFilter>;
  update?: InputMaybe<StringFilter>;
  year?: InputMaybe<IntFilter>;
};

export type ProjectResourceCaptureScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ProjectResourceCaptureScalarWhereWithAggregatesInput>>;
  NOT?: InputMaybe<Array<ProjectResourceCaptureScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ProjectResourceCaptureScalarWhereWithAggregatesInput>>;
  communication?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  createdBy?: InputMaybe<StringWithAggregatesFilter>;
  deletedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  deletedBy?: InputMaybe<StringNullableWithAggregatesFilter>;
  department?: InputMaybe<StringWithAggregatesFilter>;
  employeeId?: InputMaybe<StringWithAggregatesFilter>;
  endDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  month?: InputMaybe<FloatNullableWithAggregatesFilter>;
  onboarding?: InputMaybe<DateTimeWithAggregatesFilter>;
  projectId?: InputMaybe<StringWithAggregatesFilter>;
  projectPhaseId?: InputMaybe<StringWithAggregatesFilter>;
  rate?: InputMaybe<IntWithAggregatesFilter>;
  roleId?: InputMaybe<StringWithAggregatesFilter>;
  update?: InputMaybe<StringWithAggregatesFilter>;
  year?: InputMaybe<IntWithAggregatesFilter>;
};

export type ProjectResourceCaptureSumAggregate = {
  __typename?: 'ProjectResourceCaptureSumAggregate';
  month?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Int']>;
  year?: Maybe<Scalars['Int']>;
};

export type ProjectResourceCaptureSumAggregateInput = {
  month?: InputMaybe<Scalars['Boolean']>;
  rate?: InputMaybe<Scalars['Boolean']>;
  year?: InputMaybe<Scalars['Boolean']>;
};

export type ProjectResourceCaptureSumOrderByAggregateInput = {
  month?: InputMaybe<SortOrder>;
  rate?: InputMaybe<SortOrder>;
  year?: InputMaybe<SortOrder>;
};

export type ProjectResourceCaptureUpdateInput = {
  communication?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  department?: InputMaybe<StringFieldUpdateOperationsInput>;
  employee?: InputMaybe<EmployeeUpdateOneRequiredWithoutProjectResourceCaptureNestedInput>;
  endDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  month?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  onboarding?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutProjectResourceCaptureNestedInput>;
  projectPhase?: InputMaybe<ProjectPhaseUpdateOneRequiredWithoutProjectResourceCaptureNestedInput>;
  rate?: InputMaybe<IntFieldUpdateOperationsInput>;
  role?: InputMaybe<RoleUpdateOneRequiredWithoutProjectResourceCaptureNestedInput>;
  update?: InputMaybe<StringFieldUpdateOperationsInput>;
  year?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type ProjectResourceCaptureUpdateManyMutationInput = {
  communication?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  department?: InputMaybe<StringFieldUpdateOperationsInput>;
  endDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  month?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  onboarding?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  rate?: InputMaybe<IntFieldUpdateOperationsInput>;
  update?: InputMaybe<StringFieldUpdateOperationsInput>;
  year?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type ProjectResourceCaptureUpdateManyWithWhereWithoutEmployeeInput = {
  data: ProjectResourceCaptureUpdateManyMutationInput;
  where: ProjectResourceCaptureScalarWhereInput;
};

export type ProjectResourceCaptureUpdateManyWithWhereWithoutProjectInput = {
  data: ProjectResourceCaptureUpdateManyMutationInput;
  where: ProjectResourceCaptureScalarWhereInput;
};

export type ProjectResourceCaptureUpdateManyWithWhereWithoutProjectPhaseInput = {
  data: ProjectResourceCaptureUpdateManyMutationInput;
  where: ProjectResourceCaptureScalarWhereInput;
};

export type ProjectResourceCaptureUpdateManyWithWhereWithoutRoleInput = {
  data: ProjectResourceCaptureUpdateManyMutationInput;
  where: ProjectResourceCaptureScalarWhereInput;
};

export type ProjectResourceCaptureUpdateManyWithoutEmployeeNestedInput = {
  connect?: InputMaybe<Array<ProjectResourceCaptureWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectResourceCaptureCreateOrConnectWithoutEmployeeInput>>;
  create?: InputMaybe<Array<ProjectResourceCaptureCreateWithoutEmployeeInput>>;
  createMany?: InputMaybe<ProjectResourceCaptureCreateManyEmployeeInputEnvelope>;
  delete?: InputMaybe<Array<ProjectResourceCaptureWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProjectResourceCaptureScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProjectResourceCaptureWhereUniqueInput>>;
  set?: InputMaybe<Array<ProjectResourceCaptureWhereUniqueInput>>;
  update?: InputMaybe<Array<ProjectResourceCaptureUpdateWithWhereUniqueWithoutEmployeeInput>>;
  updateMany?: InputMaybe<Array<ProjectResourceCaptureUpdateManyWithWhereWithoutEmployeeInput>>;
  upsert?: InputMaybe<Array<ProjectResourceCaptureUpsertWithWhereUniqueWithoutEmployeeInput>>;
};

export type ProjectResourceCaptureUpdateManyWithoutProjectNestedInput = {
  connect?: InputMaybe<Array<ProjectResourceCaptureWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectResourceCaptureCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<ProjectResourceCaptureCreateWithoutProjectInput>>;
  createMany?: InputMaybe<ProjectResourceCaptureCreateManyProjectInputEnvelope>;
  delete?: InputMaybe<Array<ProjectResourceCaptureWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProjectResourceCaptureScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProjectResourceCaptureWhereUniqueInput>>;
  set?: InputMaybe<Array<ProjectResourceCaptureWhereUniqueInput>>;
  update?: InputMaybe<Array<ProjectResourceCaptureUpdateWithWhereUniqueWithoutProjectInput>>;
  updateMany?: InputMaybe<Array<ProjectResourceCaptureUpdateManyWithWhereWithoutProjectInput>>;
  upsert?: InputMaybe<Array<ProjectResourceCaptureUpsertWithWhereUniqueWithoutProjectInput>>;
};

export type ProjectResourceCaptureUpdateManyWithoutProjectPhaseNestedInput = {
  connect?: InputMaybe<Array<ProjectResourceCaptureWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectResourceCaptureCreateOrConnectWithoutProjectPhaseInput>>;
  create?: InputMaybe<Array<ProjectResourceCaptureCreateWithoutProjectPhaseInput>>;
  createMany?: InputMaybe<ProjectResourceCaptureCreateManyProjectPhaseInputEnvelope>;
  delete?: InputMaybe<Array<ProjectResourceCaptureWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProjectResourceCaptureScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProjectResourceCaptureWhereUniqueInput>>;
  set?: InputMaybe<Array<ProjectResourceCaptureWhereUniqueInput>>;
  update?: InputMaybe<Array<ProjectResourceCaptureUpdateWithWhereUniqueWithoutProjectPhaseInput>>;
  updateMany?: InputMaybe<Array<ProjectResourceCaptureUpdateManyWithWhereWithoutProjectPhaseInput>>;
  upsert?: InputMaybe<Array<ProjectResourceCaptureUpsertWithWhereUniqueWithoutProjectPhaseInput>>;
};

export type ProjectResourceCaptureUpdateManyWithoutRoleNestedInput = {
  connect?: InputMaybe<Array<ProjectResourceCaptureWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectResourceCaptureCreateOrConnectWithoutRoleInput>>;
  create?: InputMaybe<Array<ProjectResourceCaptureCreateWithoutRoleInput>>;
  createMany?: InputMaybe<ProjectResourceCaptureCreateManyRoleInputEnvelope>;
  delete?: InputMaybe<Array<ProjectResourceCaptureWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProjectResourceCaptureScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProjectResourceCaptureWhereUniqueInput>>;
  set?: InputMaybe<Array<ProjectResourceCaptureWhereUniqueInput>>;
  update?: InputMaybe<Array<ProjectResourceCaptureUpdateWithWhereUniqueWithoutRoleInput>>;
  updateMany?: InputMaybe<Array<ProjectResourceCaptureUpdateManyWithWhereWithoutRoleInput>>;
  upsert?: InputMaybe<Array<ProjectResourceCaptureUpsertWithWhereUniqueWithoutRoleInput>>;
};

export type ProjectResourceCaptureUpdateWithWhereUniqueWithoutEmployeeInput = {
  data: ProjectResourceCaptureUpdateWithoutEmployeeInput;
  where: ProjectResourceCaptureWhereUniqueInput;
};

export type ProjectResourceCaptureUpdateWithWhereUniqueWithoutProjectInput = {
  data: ProjectResourceCaptureUpdateWithoutProjectInput;
  where: ProjectResourceCaptureWhereUniqueInput;
};

export type ProjectResourceCaptureUpdateWithWhereUniqueWithoutProjectPhaseInput = {
  data: ProjectResourceCaptureUpdateWithoutProjectPhaseInput;
  where: ProjectResourceCaptureWhereUniqueInput;
};

export type ProjectResourceCaptureUpdateWithWhereUniqueWithoutRoleInput = {
  data: ProjectResourceCaptureUpdateWithoutRoleInput;
  where: ProjectResourceCaptureWhereUniqueInput;
};

export type ProjectResourceCaptureUpdateWithoutEmployeeInput = {
  communication?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  department?: InputMaybe<StringFieldUpdateOperationsInput>;
  endDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  month?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  onboarding?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutProjectResourceCaptureNestedInput>;
  projectPhase?: InputMaybe<ProjectPhaseUpdateOneRequiredWithoutProjectResourceCaptureNestedInput>;
  rate?: InputMaybe<IntFieldUpdateOperationsInput>;
  role?: InputMaybe<RoleUpdateOneRequiredWithoutProjectResourceCaptureNestedInput>;
  update?: InputMaybe<StringFieldUpdateOperationsInput>;
  year?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type ProjectResourceCaptureUpdateWithoutProjectInput = {
  communication?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  department?: InputMaybe<StringFieldUpdateOperationsInput>;
  employee?: InputMaybe<EmployeeUpdateOneRequiredWithoutProjectResourceCaptureNestedInput>;
  endDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  month?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  onboarding?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  projectPhase?: InputMaybe<ProjectPhaseUpdateOneRequiredWithoutProjectResourceCaptureNestedInput>;
  rate?: InputMaybe<IntFieldUpdateOperationsInput>;
  role?: InputMaybe<RoleUpdateOneRequiredWithoutProjectResourceCaptureNestedInput>;
  update?: InputMaybe<StringFieldUpdateOperationsInput>;
  year?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type ProjectResourceCaptureUpdateWithoutProjectPhaseInput = {
  communication?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  department?: InputMaybe<StringFieldUpdateOperationsInput>;
  employee?: InputMaybe<EmployeeUpdateOneRequiredWithoutProjectResourceCaptureNestedInput>;
  endDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  month?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  onboarding?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutProjectResourceCaptureNestedInput>;
  rate?: InputMaybe<IntFieldUpdateOperationsInput>;
  role?: InputMaybe<RoleUpdateOneRequiredWithoutProjectResourceCaptureNestedInput>;
  update?: InputMaybe<StringFieldUpdateOperationsInput>;
  year?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type ProjectResourceCaptureUpdateWithoutRoleInput = {
  communication?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  department?: InputMaybe<StringFieldUpdateOperationsInput>;
  employee?: InputMaybe<EmployeeUpdateOneRequiredWithoutProjectResourceCaptureNestedInput>;
  endDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  month?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  onboarding?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutProjectResourceCaptureNestedInput>;
  projectPhase?: InputMaybe<ProjectPhaseUpdateOneRequiredWithoutProjectResourceCaptureNestedInput>;
  rate?: InputMaybe<IntFieldUpdateOperationsInput>;
  update?: InputMaybe<StringFieldUpdateOperationsInput>;
  year?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type ProjectResourceCaptureUpsertWithWhereUniqueWithoutEmployeeInput = {
  create: ProjectResourceCaptureCreateWithoutEmployeeInput;
  update: ProjectResourceCaptureUpdateWithoutEmployeeInput;
  where: ProjectResourceCaptureWhereUniqueInput;
};

export type ProjectResourceCaptureUpsertWithWhereUniqueWithoutProjectInput = {
  create: ProjectResourceCaptureCreateWithoutProjectInput;
  update: ProjectResourceCaptureUpdateWithoutProjectInput;
  where: ProjectResourceCaptureWhereUniqueInput;
};

export type ProjectResourceCaptureUpsertWithWhereUniqueWithoutProjectPhaseInput = {
  create: ProjectResourceCaptureCreateWithoutProjectPhaseInput;
  update: ProjectResourceCaptureUpdateWithoutProjectPhaseInput;
  where: ProjectResourceCaptureWhereUniqueInput;
};

export type ProjectResourceCaptureUpsertWithWhereUniqueWithoutRoleInput = {
  create: ProjectResourceCaptureCreateWithoutRoleInput;
  update: ProjectResourceCaptureUpdateWithoutRoleInput;
  where: ProjectResourceCaptureWhereUniqueInput;
};

export type ProjectResourceCaptureWhereInput = {
  AND?: InputMaybe<Array<ProjectResourceCaptureWhereInput>>;
  NOT?: InputMaybe<Array<ProjectResourceCaptureWhereInput>>;
  OR?: InputMaybe<Array<ProjectResourceCaptureWhereInput>>;
  communication?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  department?: InputMaybe<StringFilter>;
  employee?: InputMaybe<EmployeeWhereInput>;
  employeeId?: InputMaybe<StringFilter>;
  endDate?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  month?: InputMaybe<FloatNullableFilter>;
  onboarding?: InputMaybe<DateTimeFilter>;
  project?: InputMaybe<MasterWhereInput>;
  projectId?: InputMaybe<StringFilter>;
  projectPhase?: InputMaybe<ProjectPhaseWhereInput>;
  projectPhaseId?: InputMaybe<StringFilter>;
  rate?: InputMaybe<IntFilter>;
  role?: InputMaybe<RoleWhereInput>;
  roleId?: InputMaybe<StringFilter>;
  update?: InputMaybe<StringFilter>;
  year?: InputMaybe<IntFilter>;
};

export type ProjectResourceCaptureWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type ProjectRole = {
  __typename?: 'ProjectRole';
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  employee: Employee;
  employeeId: Scalars['String'];
  id: Scalars['ID'];
  project: Master;
  projectId: Scalars['String'];
  role: Role;
  roleId: Scalars['String'];
  rowNumber?: Maybe<Scalars['Int']>;
};

export type ProjectRoleCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  employee: EmployeeCreateNestedOneWithoutProjectRoleInput;
  id?: InputMaybe<Scalars['String']>;
  project: MasterCreateNestedOneWithoutProjectRoleInput;
  role: RoleCreateNestedOneWithoutProjectRoleInput;
  rowNumber?: InputMaybe<Scalars['Int']>;
};

export type ProjectRoleCreateManyEmployeeInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
  roleId: Scalars['String'];
};

export type ProjectRoleCreateManyEmployeeInputEnvelope = {
  data: Array<ProjectRoleCreateManyEmployeeInput>;
};

export type ProjectRoleCreateManyProjectInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  roleId: Scalars['String'];
};

export type ProjectRoleCreateManyProjectInputEnvelope = {
  data: Array<ProjectRoleCreateManyProjectInput>;
};

export type ProjectRoleCreateManyRoleInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
};

export type ProjectRoleCreateManyRoleInputEnvelope = {
  data: Array<ProjectRoleCreateManyRoleInput>;
};

export type ProjectRoleCreateNestedManyWithoutEmployeeInput = {
  connect?: InputMaybe<Array<ProjectRoleWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectRoleCreateOrConnectWithoutEmployeeInput>>;
  create?: InputMaybe<Array<ProjectRoleCreateWithoutEmployeeInput>>;
  createMany?: InputMaybe<ProjectRoleCreateManyEmployeeInputEnvelope>;
};

export type ProjectRoleCreateNestedManyWithoutProjectInput = {
  connect?: InputMaybe<Array<ProjectRoleWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectRoleCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<ProjectRoleCreateWithoutProjectInput>>;
  createMany?: InputMaybe<ProjectRoleCreateManyProjectInputEnvelope>;
};

export type ProjectRoleCreateNestedManyWithoutRoleInput = {
  connect?: InputMaybe<Array<ProjectRoleWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectRoleCreateOrConnectWithoutRoleInput>>;
  create?: InputMaybe<Array<ProjectRoleCreateWithoutRoleInput>>;
  createMany?: InputMaybe<ProjectRoleCreateManyRoleInputEnvelope>;
};

export type ProjectRoleCreateOrConnectWithoutEmployeeInput = {
  create: ProjectRoleCreateWithoutEmployeeInput;
  where: ProjectRoleWhereUniqueInput;
};

export type ProjectRoleCreateOrConnectWithoutProjectInput = {
  create: ProjectRoleCreateWithoutProjectInput;
  where: ProjectRoleWhereUniqueInput;
};

export type ProjectRoleCreateOrConnectWithoutRoleInput = {
  create: ProjectRoleCreateWithoutRoleInput;
  where: ProjectRoleWhereUniqueInput;
};

export type ProjectRoleCreateWithoutEmployeeInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  project: MasterCreateNestedOneWithoutProjectRoleInput;
  role: RoleCreateNestedOneWithoutProjectRoleInput;
  rowNumber?: InputMaybe<Scalars['Int']>;
};

export type ProjectRoleCreateWithoutProjectInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  employee: EmployeeCreateNestedOneWithoutProjectRoleInput;
  id?: InputMaybe<Scalars['String']>;
  role: RoleCreateNestedOneWithoutProjectRoleInput;
  rowNumber?: InputMaybe<Scalars['Int']>;
};

export type ProjectRoleCreateWithoutRoleInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  employee: EmployeeCreateNestedOneWithoutProjectRoleInput;
  id?: InputMaybe<Scalars['String']>;
  project: MasterCreateNestedOneWithoutProjectRoleInput;
  rowNumber?: InputMaybe<Scalars['Int']>;
};

export type ProjectRoleListRelationFilter = {
  every?: InputMaybe<ProjectRoleWhereInput>;
  none?: InputMaybe<ProjectRoleWhereInput>;
  some?: InputMaybe<ProjectRoleWhereInput>;
};

export type ProjectRoleOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProjectRoleOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  deletedBy?: InputMaybe<SortOrder>;
  employee?: InputMaybe<EmployeeOrderByWithRelationInput>;
  employeeId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  project?: InputMaybe<MasterOrderByWithRelationInput>;
  projectId?: InputMaybe<SortOrder>;
  role?: InputMaybe<RoleOrderByWithRelationInput>;
  roleId?: InputMaybe<SortOrder>;
  rowNumber?: InputMaybe<SortOrder>;
};

export enum ProjectRoleScalarFieldEnum {
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  DeletedAt = 'deletedAt',
  DeletedBy = 'deletedBy',
  EmployeeId = 'employeeId',
  Id = 'id',
  ProjectId = 'projectId',
  RoleId = 'roleId',
  RowNumber = 'rowNumber'
}

export type ProjectRoleScalarWhereInput = {
  AND?: InputMaybe<Array<ProjectRoleScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProjectRoleScalarWhereInput>>;
  OR?: InputMaybe<Array<ProjectRoleScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  employeeId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  projectId?: InputMaybe<StringFilter>;
  roleId?: InputMaybe<StringFilter>;
  rowNumber?: InputMaybe<IntNullableFilter>;
};

export type ProjectRoleUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employee?: InputMaybe<EmployeeUpdateOneRequiredWithoutProjectRoleNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutProjectRoleNestedInput>;
  role?: InputMaybe<RoleUpdateOneRequiredWithoutProjectRoleNestedInput>;
  rowNumber?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type ProjectRoleUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  rowNumber?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type ProjectRoleUpdateManyWithWhereWithoutEmployeeInput = {
  data: ProjectRoleUpdateManyMutationInput;
  where: ProjectRoleScalarWhereInput;
};

export type ProjectRoleUpdateManyWithWhereWithoutProjectInput = {
  data: ProjectRoleUpdateManyMutationInput;
  where: ProjectRoleScalarWhereInput;
};

export type ProjectRoleUpdateManyWithWhereWithoutRoleInput = {
  data: ProjectRoleUpdateManyMutationInput;
  where: ProjectRoleScalarWhereInput;
};

export type ProjectRoleUpdateManyWithoutEmployeeNestedInput = {
  connect?: InputMaybe<Array<ProjectRoleWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectRoleCreateOrConnectWithoutEmployeeInput>>;
  create?: InputMaybe<Array<ProjectRoleCreateWithoutEmployeeInput>>;
  createMany?: InputMaybe<ProjectRoleCreateManyEmployeeInputEnvelope>;
  delete?: InputMaybe<Array<ProjectRoleWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProjectRoleScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProjectRoleWhereUniqueInput>>;
  set?: InputMaybe<Array<ProjectRoleWhereUniqueInput>>;
  update?: InputMaybe<Array<ProjectRoleUpdateWithWhereUniqueWithoutEmployeeInput>>;
  updateMany?: InputMaybe<Array<ProjectRoleUpdateManyWithWhereWithoutEmployeeInput>>;
  upsert?: InputMaybe<Array<ProjectRoleUpsertWithWhereUniqueWithoutEmployeeInput>>;
};

export type ProjectRoleUpdateManyWithoutProjectNestedInput = {
  connect?: InputMaybe<Array<ProjectRoleWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectRoleCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<ProjectRoleCreateWithoutProjectInput>>;
  createMany?: InputMaybe<ProjectRoleCreateManyProjectInputEnvelope>;
  delete?: InputMaybe<Array<ProjectRoleWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProjectRoleScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProjectRoleWhereUniqueInput>>;
  set?: InputMaybe<Array<ProjectRoleWhereUniqueInput>>;
  update?: InputMaybe<Array<ProjectRoleUpdateWithWhereUniqueWithoutProjectInput>>;
  updateMany?: InputMaybe<Array<ProjectRoleUpdateManyWithWhereWithoutProjectInput>>;
  upsert?: InputMaybe<Array<ProjectRoleUpsertWithWhereUniqueWithoutProjectInput>>;
};

export type ProjectRoleUpdateManyWithoutRoleNestedInput = {
  connect?: InputMaybe<Array<ProjectRoleWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectRoleCreateOrConnectWithoutRoleInput>>;
  create?: InputMaybe<Array<ProjectRoleCreateWithoutRoleInput>>;
  createMany?: InputMaybe<ProjectRoleCreateManyRoleInputEnvelope>;
  delete?: InputMaybe<Array<ProjectRoleWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProjectRoleScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProjectRoleWhereUniqueInput>>;
  set?: InputMaybe<Array<ProjectRoleWhereUniqueInput>>;
  update?: InputMaybe<Array<ProjectRoleUpdateWithWhereUniqueWithoutRoleInput>>;
  updateMany?: InputMaybe<Array<ProjectRoleUpdateManyWithWhereWithoutRoleInput>>;
  upsert?: InputMaybe<Array<ProjectRoleUpsertWithWhereUniqueWithoutRoleInput>>;
};

export type ProjectRoleUpdateWithWhereUniqueWithoutEmployeeInput = {
  data: ProjectRoleUpdateWithoutEmployeeInput;
  where: ProjectRoleWhereUniqueInput;
};

export type ProjectRoleUpdateWithWhereUniqueWithoutProjectInput = {
  data: ProjectRoleUpdateWithoutProjectInput;
  where: ProjectRoleWhereUniqueInput;
};

export type ProjectRoleUpdateWithWhereUniqueWithoutRoleInput = {
  data: ProjectRoleUpdateWithoutRoleInput;
  where: ProjectRoleWhereUniqueInput;
};

export type ProjectRoleUpdateWithoutEmployeeInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutProjectRoleNestedInput>;
  role?: InputMaybe<RoleUpdateOneRequiredWithoutProjectRoleNestedInput>;
  rowNumber?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type ProjectRoleUpdateWithoutProjectInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employee?: InputMaybe<EmployeeUpdateOneRequiredWithoutProjectRoleNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  role?: InputMaybe<RoleUpdateOneRequiredWithoutProjectRoleNestedInput>;
  rowNumber?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type ProjectRoleUpdateWithoutRoleInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employee?: InputMaybe<EmployeeUpdateOneRequiredWithoutProjectRoleNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutProjectRoleNestedInput>;
  rowNumber?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type ProjectRoleUpsertWithWhereUniqueWithoutEmployeeInput = {
  create: ProjectRoleCreateWithoutEmployeeInput;
  update: ProjectRoleUpdateWithoutEmployeeInput;
  where: ProjectRoleWhereUniqueInput;
};

export type ProjectRoleUpsertWithWhereUniqueWithoutProjectInput = {
  create: ProjectRoleCreateWithoutProjectInput;
  update: ProjectRoleUpdateWithoutProjectInput;
  where: ProjectRoleWhereUniqueInput;
};

export type ProjectRoleUpsertWithWhereUniqueWithoutRoleInput = {
  create: ProjectRoleCreateWithoutRoleInput;
  update: ProjectRoleUpdateWithoutRoleInput;
  where: ProjectRoleWhereUniqueInput;
};

export type ProjectRoleWhereInput = {
  AND?: InputMaybe<Array<ProjectRoleWhereInput>>;
  NOT?: InputMaybe<Array<ProjectRoleWhereInput>>;
  OR?: InputMaybe<Array<ProjectRoleWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  employee?: InputMaybe<EmployeeWhereInput>;
  employeeId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  project?: InputMaybe<MasterWhereInput>;
  projectId?: InputMaybe<StringFilter>;
  role?: InputMaybe<RoleWhereInput>;
  roleId?: InputMaybe<StringFilter>;
  rowNumber?: InputMaybe<IntNullableFilter>;
};

export type ProjectRoleWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type ProjectShortHistory = {
  __typename?: 'ProjectShortHistory';
  action: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  project: Master;
  projectId: Scalars['String'];
  rowNumber?: Maybe<Scalars['Int']>;
};

export type ProjectShortHistoryCreateInput = {
  action: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  project: MasterCreateNestedOneWithoutProjectShortHistoryInput;
  rowNumber?: InputMaybe<Scalars['Int']>;
};

export type ProjectShortHistoryCreateManyProjectInput = {
  action: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type ProjectShortHistoryCreateManyProjectInputEnvelope = {
  data: Array<ProjectShortHistoryCreateManyProjectInput>;
};

export type ProjectShortHistoryCreateNestedManyWithoutProjectInput = {
  connect?: InputMaybe<Array<ProjectShortHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectShortHistoryCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<ProjectShortHistoryCreateWithoutProjectInput>>;
  createMany?: InputMaybe<ProjectShortHistoryCreateManyProjectInputEnvelope>;
};

export type ProjectShortHistoryCreateOrConnectWithoutProjectInput = {
  create: ProjectShortHistoryCreateWithoutProjectInput;
  where: ProjectShortHistoryWhereUniqueInput;
};

export type ProjectShortHistoryCreateWithoutProjectInput = {
  action: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  rowNumber?: InputMaybe<Scalars['Int']>;
};

export type ProjectShortHistoryListRelationFilter = {
  every?: InputMaybe<ProjectShortHistoryWhereInput>;
  none?: InputMaybe<ProjectShortHistoryWhereInput>;
  some?: InputMaybe<ProjectShortHistoryWhereInput>;
};

export type ProjectShortHistoryOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProjectShortHistoryOrderByWithRelationInput = {
  action?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  project?: InputMaybe<MasterOrderByWithRelationInput>;
  projectId?: InputMaybe<SortOrder>;
  rowNumber?: InputMaybe<SortOrder>;
};

export enum ProjectShortHistoryScalarFieldEnum {
  Action = 'action',
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  Id = 'id',
  ProjectId = 'projectId',
  RowNumber = 'rowNumber'
}

export type ProjectShortHistoryScalarWhereInput = {
  AND?: InputMaybe<Array<ProjectShortHistoryScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProjectShortHistoryScalarWhereInput>>;
  OR?: InputMaybe<Array<ProjectShortHistoryScalarWhereInput>>;
  action?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  projectId?: InputMaybe<StringFilter>;
  rowNumber?: InputMaybe<IntNullableFilter>;
};

export type ProjectShortHistoryUpdateInput = {
  action?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutProjectShortHistoryNestedInput>;
  rowNumber?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type ProjectShortHistoryUpdateManyMutationInput = {
  action?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  rowNumber?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type ProjectShortHistoryUpdateManyWithWhereWithoutProjectInput = {
  data: ProjectShortHistoryUpdateManyMutationInput;
  where: ProjectShortHistoryScalarWhereInput;
};

export type ProjectShortHistoryUpdateManyWithoutProjectNestedInput = {
  connect?: InputMaybe<Array<ProjectShortHistoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectShortHistoryCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<ProjectShortHistoryCreateWithoutProjectInput>>;
  createMany?: InputMaybe<ProjectShortHistoryCreateManyProjectInputEnvelope>;
  delete?: InputMaybe<Array<ProjectShortHistoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProjectShortHistoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProjectShortHistoryWhereUniqueInput>>;
  set?: InputMaybe<Array<ProjectShortHistoryWhereUniqueInput>>;
  update?: InputMaybe<Array<ProjectShortHistoryUpdateWithWhereUniqueWithoutProjectInput>>;
  updateMany?: InputMaybe<Array<ProjectShortHistoryUpdateManyWithWhereWithoutProjectInput>>;
  upsert?: InputMaybe<Array<ProjectShortHistoryUpsertWithWhereUniqueWithoutProjectInput>>;
};

export type ProjectShortHistoryUpdateWithWhereUniqueWithoutProjectInput = {
  data: ProjectShortHistoryUpdateWithoutProjectInput;
  where: ProjectShortHistoryWhereUniqueInput;
};

export type ProjectShortHistoryUpdateWithoutProjectInput = {
  action?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  rowNumber?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type ProjectShortHistoryUpsertWithWhereUniqueWithoutProjectInput = {
  create: ProjectShortHistoryCreateWithoutProjectInput;
  update: ProjectShortHistoryUpdateWithoutProjectInput;
  where: ProjectShortHistoryWhereUniqueInput;
};

export type ProjectShortHistoryWhereInput = {
  AND?: InputMaybe<Array<ProjectShortHistoryWhereInput>>;
  NOT?: InputMaybe<Array<ProjectShortHistoryWhereInput>>;
  OR?: InputMaybe<Array<ProjectShortHistoryWhereInput>>;
  action?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  project?: InputMaybe<MasterWhereInput>;
  projectId?: InputMaybe<StringFilter>;
  rowNumber?: InputMaybe<IntNullableFilter>;
};

export type ProjectShortHistoryWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type ProjectStatus = {
  __typename?: 'ProjectStatus';
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  project: Master;
  projectId: Scalars['String'];
  sequenceStatus: SequenceStatus;
  sequenceStatusId: Scalars['String'];
};

export type ProjectStatusCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  project: MasterCreateNestedOneWithoutProjectStatusInput;
  sequenceStatus: SequenceStatusCreateNestedOneWithoutProjectStatusInput;
};

export type ProjectStatusCreateManyProjectInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  sequenceStatusId: Scalars['String'];
};

export type ProjectStatusCreateManyProjectInputEnvelope = {
  data: Array<ProjectStatusCreateManyProjectInput>;
};

export type ProjectStatusCreateManySequenceStatusInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  projectId: Scalars['String'];
};

export type ProjectStatusCreateManySequenceStatusInputEnvelope = {
  data: Array<ProjectStatusCreateManySequenceStatusInput>;
};

export type ProjectStatusCreateNestedManyWithoutProjectInput = {
  connect?: InputMaybe<Array<ProjectStatusWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectStatusCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<ProjectStatusCreateWithoutProjectInput>>;
  createMany?: InputMaybe<ProjectStatusCreateManyProjectInputEnvelope>;
};

export type ProjectStatusCreateNestedManyWithoutSequenceStatusInput = {
  connect?: InputMaybe<Array<ProjectStatusWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectStatusCreateOrConnectWithoutSequenceStatusInput>>;
  create?: InputMaybe<Array<ProjectStatusCreateWithoutSequenceStatusInput>>;
  createMany?: InputMaybe<ProjectStatusCreateManySequenceStatusInputEnvelope>;
};

export type ProjectStatusCreateOrConnectWithoutProjectInput = {
  create: ProjectStatusCreateWithoutProjectInput;
  where: ProjectStatusWhereUniqueInput;
};

export type ProjectStatusCreateOrConnectWithoutSequenceStatusInput = {
  create: ProjectStatusCreateWithoutSequenceStatusInput;
  where: ProjectStatusWhereUniqueInput;
};

export type ProjectStatusCreateWithoutProjectInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  sequenceStatus: SequenceStatusCreateNestedOneWithoutProjectStatusInput;
};

export type ProjectStatusCreateWithoutSequenceStatusInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  project: MasterCreateNestedOneWithoutProjectStatusInput;
};

export type ProjectStatusListRelationFilter = {
  every?: InputMaybe<ProjectStatusWhereInput>;
  none?: InputMaybe<ProjectStatusWhereInput>;
  some?: InputMaybe<ProjectStatusWhereInput>;
};

export type ProjectStatusOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ProjectStatusOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  deletedBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  project?: InputMaybe<MasterOrderByWithRelationInput>;
  projectId?: InputMaybe<SortOrder>;
  sequenceStatus?: InputMaybe<SequenceStatusOrderByWithRelationInput>;
  sequenceStatusId?: InputMaybe<SortOrder>;
};

export enum ProjectStatusScalarFieldEnum {
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  DeletedAt = 'deletedAt',
  DeletedBy = 'deletedBy',
  Id = 'id',
  ProjectId = 'projectId',
  SequenceStatusId = 'sequenceStatusId'
}

export type ProjectStatusScalarWhereInput = {
  AND?: InputMaybe<Array<ProjectStatusScalarWhereInput>>;
  NOT?: InputMaybe<Array<ProjectStatusScalarWhereInput>>;
  OR?: InputMaybe<Array<ProjectStatusScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  projectId?: InputMaybe<StringFilter>;
  sequenceStatusId?: InputMaybe<StringFilter>;
};

export type ProjectStatusUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutProjectStatusNestedInput>;
  sequenceStatus?: InputMaybe<SequenceStatusUpdateOneRequiredWithoutProjectStatusNestedInput>;
};

export type ProjectStatusUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ProjectStatusUpdateManyWithWhereWithoutProjectInput = {
  data: ProjectStatusUpdateManyMutationInput;
  where: ProjectStatusScalarWhereInput;
};

export type ProjectStatusUpdateManyWithWhereWithoutSequenceStatusInput = {
  data: ProjectStatusUpdateManyMutationInput;
  where: ProjectStatusScalarWhereInput;
};

export type ProjectStatusUpdateManyWithoutProjectNestedInput = {
  connect?: InputMaybe<Array<ProjectStatusWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectStatusCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<ProjectStatusCreateWithoutProjectInput>>;
  createMany?: InputMaybe<ProjectStatusCreateManyProjectInputEnvelope>;
  delete?: InputMaybe<Array<ProjectStatusWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProjectStatusScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProjectStatusWhereUniqueInput>>;
  set?: InputMaybe<Array<ProjectStatusWhereUniqueInput>>;
  update?: InputMaybe<Array<ProjectStatusUpdateWithWhereUniqueWithoutProjectInput>>;
  updateMany?: InputMaybe<Array<ProjectStatusUpdateManyWithWhereWithoutProjectInput>>;
  upsert?: InputMaybe<Array<ProjectStatusUpsertWithWhereUniqueWithoutProjectInput>>;
};

export type ProjectStatusUpdateManyWithoutSequenceStatusNestedInput = {
  connect?: InputMaybe<Array<ProjectStatusWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ProjectStatusCreateOrConnectWithoutSequenceStatusInput>>;
  create?: InputMaybe<Array<ProjectStatusCreateWithoutSequenceStatusInput>>;
  createMany?: InputMaybe<ProjectStatusCreateManySequenceStatusInputEnvelope>;
  delete?: InputMaybe<Array<ProjectStatusWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ProjectStatusScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ProjectStatusWhereUniqueInput>>;
  set?: InputMaybe<Array<ProjectStatusWhereUniqueInput>>;
  update?: InputMaybe<Array<ProjectStatusUpdateWithWhereUniqueWithoutSequenceStatusInput>>;
  updateMany?: InputMaybe<Array<ProjectStatusUpdateManyWithWhereWithoutSequenceStatusInput>>;
  upsert?: InputMaybe<Array<ProjectStatusUpsertWithWhereUniqueWithoutSequenceStatusInput>>;
};

export type ProjectStatusUpdateWithWhereUniqueWithoutProjectInput = {
  data: ProjectStatusUpdateWithoutProjectInput;
  where: ProjectStatusWhereUniqueInput;
};

export type ProjectStatusUpdateWithWhereUniqueWithoutSequenceStatusInput = {
  data: ProjectStatusUpdateWithoutSequenceStatusInput;
  where: ProjectStatusWhereUniqueInput;
};

export type ProjectStatusUpdateWithoutProjectInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sequenceStatus?: InputMaybe<SequenceStatusUpdateOneRequiredWithoutProjectStatusNestedInput>;
};

export type ProjectStatusUpdateWithoutSequenceStatusInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutProjectStatusNestedInput>;
};

export type ProjectStatusUpsertWithWhereUniqueWithoutProjectInput = {
  create: ProjectStatusCreateWithoutProjectInput;
  update: ProjectStatusUpdateWithoutProjectInput;
  where: ProjectStatusWhereUniqueInput;
};

export type ProjectStatusUpsertWithWhereUniqueWithoutSequenceStatusInput = {
  create: ProjectStatusCreateWithoutSequenceStatusInput;
  update: ProjectStatusUpdateWithoutSequenceStatusInput;
  where: ProjectStatusWhereUniqueInput;
};

export type ProjectStatusWhereInput = {
  AND?: InputMaybe<Array<ProjectStatusWhereInput>>;
  NOT?: InputMaybe<Array<ProjectStatusWhereInput>>;
  OR?: InputMaybe<Array<ProjectStatusWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  project?: InputMaybe<MasterWhereInput>;
  projectId?: InputMaybe<StringFilter>;
  sequenceStatus?: InputMaybe<SequenceStatusWhereInput>;
  sequenceStatusId?: InputMaybe<StringFilter>;
};

export type ProjectStatusWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type ProjectType = {
  __typename?: 'ProjectType';
  _count: ProjectTypeCount;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  order?: Maybe<Scalars['Int']>;
  phaseOnType?: Maybe<Array<PhaseOnType>>;
  projectDescriptions?: Maybe<Array<ProjectDescription>>;
  projectType: Scalars['String'];
  projectTypeSub?: Maybe<Scalars['String']>;
};

export type ProjectTypeCount = {
  __typename?: 'ProjectTypeCount';
  phaseOnType: Scalars['Int'];
  projectDescriptions: Scalars['Int'];
};

export type ProjectTypeCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  phaseOnType?: InputMaybe<PhaseOnTypeCreateNestedManyWithoutProjectTypeInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionCreateNestedManyWithoutProjectTypeInput>;
  projectType: Scalars['String'];
  projectTypeSub?: InputMaybe<Scalars['String']>;
};

export type ProjectTypeCreateNestedOneWithoutPhaseOnTypeInput = {
  connect?: InputMaybe<ProjectTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProjectTypeCreateOrConnectWithoutPhaseOnTypeInput>;
  create?: InputMaybe<ProjectTypeCreateWithoutPhaseOnTypeInput>;
};

export type ProjectTypeCreateNestedOneWithoutProjectDescriptionsInput = {
  connect?: InputMaybe<ProjectTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProjectTypeCreateOrConnectWithoutProjectDescriptionsInput>;
  create?: InputMaybe<ProjectTypeCreateWithoutProjectDescriptionsInput>;
};

export type ProjectTypeCreateOrConnectWithoutPhaseOnTypeInput = {
  create: ProjectTypeCreateWithoutPhaseOnTypeInput;
  where: ProjectTypeWhereUniqueInput;
};

export type ProjectTypeCreateOrConnectWithoutProjectDescriptionsInput = {
  create: ProjectTypeCreateWithoutProjectDescriptionsInput;
  where: ProjectTypeWhereUniqueInput;
};

export type ProjectTypeCreateWithoutPhaseOnTypeInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  projectDescriptions?: InputMaybe<ProjectDescriptionCreateNestedManyWithoutProjectTypeInput>;
  projectType: Scalars['String'];
  projectTypeSub?: InputMaybe<Scalars['String']>;
};

export type ProjectTypeCreateWithoutProjectDescriptionsInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  phaseOnType?: InputMaybe<PhaseOnTypeCreateNestedManyWithoutProjectTypeInput>;
  projectType: Scalars['String'];
  projectTypeSub?: InputMaybe<Scalars['String']>;
};

export type ProjectTypeOrderByWithRelationInput = {
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  phaseOnType?: InputMaybe<PhaseOnTypeOrderByRelationAggregateInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionOrderByRelationAggregateInput>;
  projectType?: InputMaybe<SortOrder>;
  projectTypeSub?: InputMaybe<SortOrder>;
};

export enum ProjectTypeScalarFieldEnum {
  Description = 'description',
  Id = 'id',
  Order = 'order',
  ProjectType = 'projectType',
  ProjectTypeSub = 'projectTypeSub'
}

export type ProjectTypeUpdateInput = {
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  phaseOnType?: InputMaybe<PhaseOnTypeUpdateManyWithoutProjectTypeNestedInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionUpdateManyWithoutProjectTypeNestedInput>;
  projectType?: InputMaybe<StringFieldUpdateOperationsInput>;
  projectTypeSub?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ProjectTypeUpdateOneRequiredWithoutPhaseOnTypeNestedInput = {
  connect?: InputMaybe<ProjectTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProjectTypeCreateOrConnectWithoutPhaseOnTypeInput>;
  create?: InputMaybe<ProjectTypeCreateWithoutPhaseOnTypeInput>;
  update?: InputMaybe<ProjectTypeUpdateWithoutPhaseOnTypeInput>;
  upsert?: InputMaybe<ProjectTypeUpsertWithoutPhaseOnTypeInput>;
};

export type ProjectTypeUpdateOneRequiredWithoutProjectDescriptionsNestedInput = {
  connect?: InputMaybe<ProjectTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ProjectTypeCreateOrConnectWithoutProjectDescriptionsInput>;
  create?: InputMaybe<ProjectTypeCreateWithoutProjectDescriptionsInput>;
  update?: InputMaybe<ProjectTypeUpdateWithoutProjectDescriptionsInput>;
  upsert?: InputMaybe<ProjectTypeUpsertWithoutProjectDescriptionsInput>;
};

export type ProjectTypeUpdateWithoutPhaseOnTypeInput = {
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  projectDescriptions?: InputMaybe<ProjectDescriptionUpdateManyWithoutProjectTypeNestedInput>;
  projectType?: InputMaybe<StringFieldUpdateOperationsInput>;
  projectTypeSub?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ProjectTypeUpdateWithoutProjectDescriptionsInput = {
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  phaseOnType?: InputMaybe<PhaseOnTypeUpdateManyWithoutProjectTypeNestedInput>;
  projectType?: InputMaybe<StringFieldUpdateOperationsInput>;
  projectTypeSub?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ProjectTypeUpsertWithoutPhaseOnTypeInput = {
  create: ProjectTypeCreateWithoutPhaseOnTypeInput;
  update: ProjectTypeUpdateWithoutPhaseOnTypeInput;
};

export type ProjectTypeUpsertWithoutProjectDescriptionsInput = {
  create: ProjectTypeCreateWithoutProjectDescriptionsInput;
  update: ProjectTypeUpdateWithoutProjectDescriptionsInput;
};

export type ProjectTypeWhereInput = {
  AND?: InputMaybe<Array<ProjectTypeWhereInput>>;
  NOT?: InputMaybe<Array<ProjectTypeWhereInput>>;
  OR?: InputMaybe<Array<ProjectTypeWhereInput>>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntNullableFilter>;
  phaseOnType?: InputMaybe<PhaseOnTypeListRelationFilter>;
  projectDescriptions?: InputMaybe<ProjectDescriptionListRelationFilter>;
  projectType?: InputMaybe<StringFilter>;
  projectTypeSub?: InputMaybe<StringNullableFilter>;
};

export type ProjectTypeWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type PspMapping = {
  __typename?: 'PspMapping';
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  master?: Maybe<Master>;
  name?: Maybe<Scalars['String']>;
  projectId?: Maybe<Scalars['String']>;
  pspElement: Scalars['String'];
  psp_description?: Maybe<Scalars['String']>;
  rowNumber?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

export type PspMappingCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  master?: InputMaybe<MasterCreateNestedOneWithoutPspMappingInput>;
  name?: InputMaybe<Scalars['String']>;
  pspElement: Scalars['String'];
  psp_description?: InputMaybe<Scalars['String']>;
  rowNumber?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
};

export type PspMappingCreateManyMasterInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  pspElement: Scalars['String'];
  psp_description?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type PspMappingCreateManyMasterInputEnvelope = {
  data: Array<PspMappingCreateManyMasterInput>;
};

export type PspMappingCreateNestedManyWithoutMasterInput = {
  connect?: InputMaybe<Array<PspMappingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PspMappingCreateOrConnectWithoutMasterInput>>;
  create?: InputMaybe<Array<PspMappingCreateWithoutMasterInput>>;
  createMany?: InputMaybe<PspMappingCreateManyMasterInputEnvelope>;
};

export type PspMappingCreateOrConnectWithoutMasterInput = {
  create: PspMappingCreateWithoutMasterInput;
  where: PspMappingWhereUniqueInput;
};

export type PspMappingCreateWithoutMasterInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  pspElement: Scalars['String'];
  psp_description?: InputMaybe<Scalars['String']>;
  rowNumber?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
};

export type PspMappingListRelationFilter = {
  every?: InputMaybe<PspMappingWhereInput>;
  none?: InputMaybe<PspMappingWhereInput>;
  some?: InputMaybe<PspMappingWhereInput>;
};

export type PspMappingOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PspMappingOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  deletedBy?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  master?: InputMaybe<MasterOrderByWithRelationInput>;
  name?: InputMaybe<SortOrder>;
  projectId?: InputMaybe<SortOrder>;
  pspElement?: InputMaybe<SortOrder>;
  psp_description?: InputMaybe<SortOrder>;
  rowNumber?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export enum PspMappingScalarFieldEnum {
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  DeletedAt = 'deletedAt',
  DeletedBy = 'deletedBy',
  Description = 'description',
  Id = 'id',
  Name = 'name',
  ProjectId = 'projectId',
  PspElement = 'pspElement',
  PspDescription = 'psp_description',
  RowNumber = 'rowNumber',
  Type = 'type'
}

export type PspMappingScalarWhereInput = {
  AND?: InputMaybe<Array<PspMappingScalarWhereInput>>;
  NOT?: InputMaybe<Array<PspMappingScalarWhereInput>>;
  OR?: InputMaybe<Array<PspMappingScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringNullableFilter>;
  projectId?: InputMaybe<StringNullableFilter>;
  pspElement?: InputMaybe<StringFilter>;
  psp_description?: InputMaybe<StringNullableFilter>;
  rowNumber?: InputMaybe<IntNullableFilter>;
  type?: InputMaybe<StringNullableFilter>;
};

export type PspMappingUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  master?: InputMaybe<MasterUpdateOneWithoutPspMappingNestedInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pspElement?: InputMaybe<StringFieldUpdateOperationsInput>;
  psp_description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rowNumber?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type PspMappingUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pspElement?: InputMaybe<StringFieldUpdateOperationsInput>;
  psp_description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rowNumber?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type PspMappingUpdateManyWithWhereWithoutMasterInput = {
  data: PspMappingUpdateManyMutationInput;
  where: PspMappingScalarWhereInput;
};

export type PspMappingUpdateManyWithoutMasterNestedInput = {
  connect?: InputMaybe<Array<PspMappingWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PspMappingCreateOrConnectWithoutMasterInput>>;
  create?: InputMaybe<Array<PspMappingCreateWithoutMasterInput>>;
  createMany?: InputMaybe<PspMappingCreateManyMasterInputEnvelope>;
  delete?: InputMaybe<Array<PspMappingWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PspMappingScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PspMappingWhereUniqueInput>>;
  set?: InputMaybe<Array<PspMappingWhereUniqueInput>>;
  update?: InputMaybe<Array<PspMappingUpdateWithWhereUniqueWithoutMasterInput>>;
  updateMany?: InputMaybe<Array<PspMappingUpdateManyWithWhereWithoutMasterInput>>;
  upsert?: InputMaybe<Array<PspMappingUpsertWithWhereUniqueWithoutMasterInput>>;
};

export type PspMappingUpdateWithWhereUniqueWithoutMasterInput = {
  data: PspMappingUpdateWithoutMasterInput;
  where: PspMappingWhereUniqueInput;
};

export type PspMappingUpdateWithoutMasterInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  pspElement?: InputMaybe<StringFieldUpdateOperationsInput>;
  psp_description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rowNumber?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type PspMappingUpsertWithWhereUniqueWithoutMasterInput = {
  create: PspMappingCreateWithoutMasterInput;
  update: PspMappingUpdateWithoutMasterInput;
  where: PspMappingWhereUniqueInput;
};

export type PspMappingWhereInput = {
  AND?: InputMaybe<Array<PspMappingWhereInput>>;
  NOT?: InputMaybe<Array<PspMappingWhereInput>>;
  OR?: InputMaybe<Array<PspMappingWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  master?: InputMaybe<MasterWhereInput>;
  name?: InputMaybe<StringNullableFilter>;
  projectId?: InputMaybe<StringNullableFilter>;
  pspElement?: InputMaybe<StringFilter>;
  psp_description?: InputMaybe<StringNullableFilter>;
  rowNumber?: InputMaybe<IntNullableFilter>;
  type?: InputMaybe<StringNullableFilter>;
};

export type PspMappingWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  ContactHistories: Array<ContactHistory>;
  addresseeGroup: AddresseeGroup;
  addresseeGroups: Array<AddresseeGroup>;
  allocation: Allocation;
  allocations: Array<Allocation>;
  approvalBoard: ApprovalBoard;
  approvalBoards: Array<ApprovalBoard>;
  approvalStatus: ApprovalStatus;
  approvalStatuses: Array<ApprovalStatus>;
  approver: Approver;
  approverProcess: ApproverProcess;
  approverProcesses: Array<ApproverProcess>;
  approverRecipient: ApproverRecipient;
  approverRecipients: Array<ApproverRecipient>;
  approvers: Array<Approver>;
  asset: Asset;
  assets: Array<Asset>;
  businessProcess: BusinessProcess;
  businessProcessComment: BusinessProcessComments;
  businessProcessComments: Array<BusinessProcessComments>;
  businessProcessOnProject: BusinessProcessOnProject;
  businessProcessOnProjects: Array<BusinessProcessOnProject>;
  businessProcesses: Array<BusinessProcess>;
  companies: Array<Company>;
  company: Company;
  contactHistory: ContactHistory;
  dashboardProject: DashboardProject;
  dashboardProjects: Array<DashboardProject>;
  emailHistories: Array<EmailHistory>;
  emailHistory: EmailHistory;
  employee: Employee;
  employeeMaster: EmployeeMaster;
  employeeMasters: Array<EmployeeMaster>;
  employees: Array<Employee>;
  finance: Finance;
  finances: Array<Finance>;
  funding: Funding;
  fundings: Array<Funding>;
  generalCostShortHistories: Array<GeneralCostShortHistory>;
  generalCostShortHistory: GeneralCostShortHistory;
  generalItCost: GerneralItCosts;
  generalItCostSubtype: GerneralItCostSubtype;
  generalItCostSubtypes: Array<GerneralItCostSubtype>;
  generalItCostType: GerneralItCostType;
  generalItCostTypes: Array<GerneralItCostType>;
  generalItCosts: Array<GerneralItCosts>;
  getLastFinancesPerYear: Array<Finance>;
  goal: Goal;
  goals: Array<Goal>;
  goalsOnMaster: GoalsOnMaster;
  goalsOnMasters: Array<GoalsOnMaster>;
  groupFinances: Array<FinanceGroupBy>;
  groupGeneralItCost: Array<GerneralItCostsGroupBy>;
  groupProjectResourceCaptures: Array<ProjectResourceCaptureGroupBy>;
  interfaceDetail: InterfaceDetail;
  interfaceDetails: Array<InterfaceDetail>;
  interfaceFormat: InterfaceFormat;
  interfaceFormats: Array<InterfaceFormat>;
  interfaceReference: InterfaceReference;
  interfaceReferences: Array<InterfaceReference>;
  interfaceType: InterfaceType;
  interfaceTypes: Array<InterfaceType>;
  landingApplication: LandingApplication;
  landingApplicationCluster: LandingApplicationCluster;
  landingApplicationClusterGroup: LandingApplicationClusterGroup;
  landingApplicationClusterGroups: Array<LandingApplicationClusterGroup>;
  landingApplicationClusterMapping: LandingApplicationClusterMapping;
  landingApplicationClusterMappings: Array<LandingApplicationClusterMapping>;
  landingApplicationClusters: Array<LandingApplicationCluster>;
  landingApplicationGroup: LandingApplicationGroup;
  landingApplicationGroups: Array<LandingApplicationGroup>;
  landingApplications: Array<LandingApplication>;
  leanixMapping: LeanixMapping;
  leanixMappings: Array<LeanixMapping>;
  master: Master;
  masters: Array<Master>;
  method: Method;
  methods: Array<Method>;
  phaseOnType: PhaseOnType;
  phaseOnTypes: Array<PhaseOnType>;
  projectAllocation: ProjectAllocation;
  projectAllocations: Array<ProjectAllocation>;
  projectApproval: ProjectApproval;
  projectApprovals: Array<ProjectApproval>;
  projectDependencies: Array<ProjectDependency>;
  projectDependency: ProjectDependency;
  projectDescription: ProjectDescription;
  projectDescriptionComment: ProjectDescriptionComment;
  projectDescriptionComments: Array<ProjectDescriptionComment>;
  projectDescriptions: Array<ProjectDescription>;
  projectDocument: ProjectDocuments;
  projectDocuments: Array<ProjectDocuments>;
  projectInterface: ProjectInterface;
  projectInterfaces: Array<ProjectInterface>;
  projectPhase: ProjectPhase;
  projectPhaseCapture: ProjectPhaseCapture;
  projectPhaseCaptures: Array<ProjectPhaseCapture>;
  projectPhases: Array<ProjectPhase>;
  projectQuestionnaire: ProjectQuestionnaire;
  projectQuestionnaireStatus: ProjectQuestionnaireStatus;
  projectQuestionnaireStatuses: Array<ProjectQuestionnaireStatus>;
  projectQuestionnaires: Array<ProjectQuestionnaire>;
  projectResourceCapture: ProjectResourceCapture;
  projectResourceCaptures: Array<ProjectResourceCapture>;
  projectRole: ProjectRole;
  projectRoles: Array<ProjectRole>;
  projectShortHistories: Array<ProjectShortHistory>;
  projectShortHistory: ProjectShortHistory;
  projectStatus: ProjectStatus;
  projectStatuses: Array<ProjectStatus>;
  projectType: ProjectType;
  projectTypes: Array<ProjectType>;
  pspMapping: PspMapping;
  pspMappings: Array<PspMapping>;
  remark: Remark;
  remarks: Array<Remark>;
  replacement: Replacement;
  replacements: Array<Replacement>;
  report: Report;
  reports: Array<Report>;
  risk: Risk;
  riskDamagePotential: RiskDamagePotential;
  riskDamagePotentials: Array<RiskDamagePotential>;
  riskOccurance: RiskOccurance;
  riskOccurances: Array<RiskOccurance>;
  riskStatus: RiskStatus;
  riskStatuses: Array<RiskStatus>;
  risks: Array<Risk>;
  role: Role;
  roles: Array<Role>;
  securityGroup: SecurityGroup;
  securityGroups: Array<SecurityGroup>;
  segment: Segment;
  segments: Array<Segment>;
  sequenceStatus: SequenceStatus;
  sequenceStatuses: Array<SequenceStatus>;
  targetedBudget: TargetedBudget;
  targetedBudgets: Array<TargetedBudget>;
  template: Template;
  templateDocument: TemplateDocuments;
  templateDocuments: Array<TemplateDocuments>;
  templates: Array<Template>;
  topProject: TopProjects;
  topProjects: Array<TopProjects>;
};


export type QueryContactHistoriesArgs = {
  cursor?: InputMaybe<ContactHistoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<ContactHistoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ContactHistoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ContactHistoryWhereInput>;
};


export type QueryAddresseeGroupArgs = {
  where: AddresseeGroupWhereUniqueInput;
};


export type QueryAddresseeGroupsArgs = {
  cursor?: InputMaybe<AddresseeGroupWhereUniqueInput>;
  distinct?: InputMaybe<Array<AddresseeGroupScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AddresseeGroupOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AddresseeGroupWhereInput>;
};


export type QueryAllocationArgs = {
  where: AllocationWhereUniqueInput;
};


export type QueryAllocationsArgs = {
  cursor?: InputMaybe<AllocationWhereUniqueInput>;
  distinct?: InputMaybe<Array<AllocationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AllocationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AllocationWhereInput>;
};


export type QueryApprovalBoardArgs = {
  where: ApprovalBoardWhereUniqueInput;
};


export type QueryApprovalBoardsArgs = {
  cursor?: InputMaybe<ApprovalBoardWhereUniqueInput>;
  distinct?: InputMaybe<Array<ApprovalBoardScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ApprovalBoardOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ApprovalBoardWhereInput>;
};


export type QueryApprovalStatusArgs = {
  where: ApprovalStatusWhereUniqueInput;
};


export type QueryApprovalStatusesArgs = {
  cursor?: InputMaybe<ApprovalStatusWhereUniqueInput>;
  distinct?: InputMaybe<Array<ApprovalStatusScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ApprovalStatusOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ApprovalStatusWhereInput>;
};


export type QueryApproverArgs = {
  where: ApproverWhereUniqueInput;
};


export type QueryApproverProcessArgs = {
  where: ApproverProcessWhereUniqueInput;
};


export type QueryApproverProcessesArgs = {
  cursor?: InputMaybe<ApproverProcessWhereUniqueInput>;
  distinct?: InputMaybe<Array<ApproverProcessScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ApproverProcessOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ApproverProcessWhereInput>;
};


export type QueryApproverRecipientArgs = {
  where: ApproverRecipientWhereUniqueInput;
};


export type QueryApproverRecipientsArgs = {
  cursor?: InputMaybe<ApproverRecipientWhereUniqueInput>;
  distinct?: InputMaybe<Array<ApproverRecipientScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ApproverRecipientOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ApproverRecipientWhereInput>;
};


export type QueryApproversArgs = {
  cursor?: InputMaybe<ApproverWhereUniqueInput>;
  distinct?: InputMaybe<Array<ApproverScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ApproverOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ApproverWhereInput>;
};


export type QueryAssetArgs = {
  where: AssetWhereUniqueInput;
};


export type QueryAssetsArgs = {
  cursor?: InputMaybe<AssetWhereUniqueInput>;
  distinct?: InputMaybe<Array<AssetScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AssetOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AssetWhereInput>;
};


export type QueryBusinessProcessArgs = {
  where: BusinessProcessWhereUniqueInput;
};


export type QueryBusinessProcessCommentArgs = {
  where: BusinessProcessCommentsWhereUniqueInput;
};


export type QueryBusinessProcessCommentsArgs = {
  cursor?: InputMaybe<BusinessProcessCommentsWhereUniqueInput>;
  distinct?: InputMaybe<Array<BusinessProcessCommentsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BusinessProcessCommentsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BusinessProcessCommentsWhereInput>;
};


export type QueryBusinessProcessOnProjectArgs = {
  where: BusinessProcessOnProjectWhereUniqueInput;
};


export type QueryBusinessProcessOnProjectsArgs = {
  cursor?: InputMaybe<BusinessProcessOnProjectWhereUniqueInput>;
  distinct?: InputMaybe<Array<BusinessProcessOnProjectScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BusinessProcessOnProjectOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BusinessProcessOnProjectWhereInput>;
};


export type QueryBusinessProcessesArgs = {
  cursor?: InputMaybe<BusinessProcessWhereUniqueInput>;
  distinct?: InputMaybe<Array<BusinessProcessScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BusinessProcessOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<BusinessProcessWhereInput>;
};


export type QueryCompaniesArgs = {
  cursor?: InputMaybe<CompanyWhereUniqueInput>;
  distinct?: InputMaybe<Array<CompanyScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CompanyOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CompanyWhereInput>;
};


export type QueryCompanyArgs = {
  where: CompanyWhereUniqueInput;
};


export type QueryContactHistoryArgs = {
  where: ContactHistoryWhereUniqueInput;
};


export type QueryDashboardProjectArgs = {
  where: DashboardProjectWhereUniqueInput;
};


export type QueryDashboardProjectsArgs = {
  cursor?: InputMaybe<DashboardProjectWhereUniqueInput>;
  distinct?: InputMaybe<Array<DashboardProjectScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DashboardProjectOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DashboardProjectWhereInput>;
};


export type QueryEmailHistoriesArgs = {
  cursor?: InputMaybe<EmailHistoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<EmailHistoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<EmailHistoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EmailHistoryWhereInput>;
};


export type QueryEmailHistoryArgs = {
  where: EmailHistoryWhereUniqueInput;
};


export type QueryEmployeeArgs = {
  where: EmployeeWhereUniqueInput;
};


export type QueryEmployeeMasterArgs = {
  where: EmployeeMasterWhereUniqueInput;
};


export type QueryEmployeeMastersArgs = {
  cursor?: InputMaybe<EmployeeMasterWhereUniqueInput>;
  distinct?: InputMaybe<Array<EmployeeMasterScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<EmployeeMasterOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EmployeeMasterWhereInput>;
};


export type QueryEmployeesArgs = {
  cursor?: InputMaybe<EmployeeWhereUniqueInput>;
  distinct?: InputMaybe<Array<EmployeeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<EmployeeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EmployeeWhereInput>;
};


export type QueryFinanceArgs = {
  where: FinanceWhereUniqueInput;
};


export type QueryFinancesArgs = {
  cursor?: InputMaybe<FinanceWhereUniqueInput>;
  distinct?: InputMaybe<Array<FinanceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FinanceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FinanceWhereInput>;
};


export type QueryFundingArgs = {
  where: FundingWhereUniqueInput;
};


export type QueryFundingsArgs = {
  cursor?: InputMaybe<FundingWhereUniqueInput>;
  distinct?: InputMaybe<Array<FundingScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FundingOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FundingWhereInput>;
};


export type QueryGeneralCostShortHistoriesArgs = {
  cursor?: InputMaybe<GeneralCostShortHistoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<GeneralCostShortHistoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<GeneralCostShortHistoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GeneralCostShortHistoryWhereInput>;
};


export type QueryGeneralCostShortHistoryArgs = {
  where: GeneralCostShortHistoryWhereUniqueInput;
};


export type QueryGeneralItCostArgs = {
  where: GerneralItCostsWhereUniqueInput;
};


export type QueryGeneralItCostSubtypeArgs = {
  where: GerneralItCostSubtypeWhereUniqueInput;
};


export type QueryGeneralItCostSubtypesArgs = {
  cursor?: InputMaybe<GerneralItCostSubtypeWhereUniqueInput>;
  distinct?: InputMaybe<Array<GerneralItCostSubtypeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<GerneralItCostSubtypeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GerneralItCostSubtypeWhereInput>;
};


export type QueryGeneralItCostTypeArgs = {
  where: GerneralItCostTypeWhereUniqueInput;
};


export type QueryGeneralItCostTypesArgs = {
  cursor?: InputMaybe<GerneralItCostTypeWhereUniqueInput>;
  distinct?: InputMaybe<Array<GerneralItCostTypeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<GerneralItCostTypeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GerneralItCostTypeWhereInput>;
};


export type QueryGeneralItCostsArgs = {
  cursor?: InputMaybe<GerneralItCostsWhereUniqueInput>;
  distinct?: InputMaybe<Array<GerneralItCostsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<GerneralItCostsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GerneralItCostsWhereInput>;
};


export type QueryGetLastFinancesPerYearArgs = {
  cursor?: InputMaybe<FinanceWhereUniqueInput>;
  distinct?: InputMaybe<Array<FinanceScalarFieldEnum>>;
  olderThan?: InputMaybe<Scalars['DateTime']>;
  orderBy?: InputMaybe<Array<FinanceOrderByWithRelationInput>>;
  projectId?: InputMaybe<Scalars['String']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FinanceWhereInput>;
};


export type QueryGoalArgs = {
  where: GoalWhereUniqueInput;
};


export type QueryGoalsArgs = {
  cursor?: InputMaybe<GoalWhereUniqueInput>;
  distinct?: InputMaybe<Array<GoalScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<GoalOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GoalWhereInput>;
};


export type QueryGoalsOnMasterArgs = {
  where: GoalsOnMasterWhereUniqueInput;
};


export type QueryGoalsOnMastersArgs = {
  cursor?: InputMaybe<GoalsOnMasterWhereUniqueInput>;
  distinct?: InputMaybe<Array<GoalsOnMasterScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<GoalsOnMasterOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GoalsOnMasterWhereInput>;
};


export type QueryGroupFinancesArgs = {
  _avg?: InputMaybe<FinanceAvgAggregateInput>;
  _count?: InputMaybe<FinanceCountAggregateInput>;
  _max?: InputMaybe<FinanceMaxAggregateInput>;
  _min?: InputMaybe<FinanceMinAggregateInput>;
  _sum?: InputMaybe<FinanceSumAggregateInput>;
  by: Array<FinanceScalarFieldEnum>;
  having?: InputMaybe<FinanceScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<FinanceOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FinanceWhereInput>;
};


export type QueryGroupGeneralItCostArgs = {
  _avg?: InputMaybe<GerneralItCostsAvgAggregateInput>;
  _count?: InputMaybe<GerneralItCostsCountAggregateInput>;
  _max?: InputMaybe<GerneralItCostsMaxAggregateInput>;
  _min?: InputMaybe<GerneralItCostsMinAggregateInput>;
  _sum?: InputMaybe<GerneralItCostsSumAggregateInput>;
  by: Array<GerneralItCostsScalarFieldEnum>;
  having?: InputMaybe<GerneralItCostsScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<GerneralItCostsOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GerneralItCostsWhereInput>;
};


export type QueryGroupProjectResourceCapturesArgs = {
  _avg?: InputMaybe<ProjectResourceCaptureAvgAggregateInput>;
  _count?: InputMaybe<ProjectResourceCaptureCountAggregateInput>;
  _max?: InputMaybe<ProjectResourceCaptureMaxAggregateInput>;
  _min?: InputMaybe<ProjectResourceCaptureMinAggregateInput>;
  _sum?: InputMaybe<ProjectResourceCaptureSumAggregateInput>;
  by: Array<ProjectResourceCaptureScalarFieldEnum>;
  having?: InputMaybe<ProjectResourceCaptureScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<ProjectResourceCaptureOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProjectResourceCaptureWhereInput>;
};


export type QueryInterfaceDetailArgs = {
  where: InterfaceDetailWhereUniqueInput;
};


export type QueryInterfaceDetailsArgs = {
  cursor?: InputMaybe<InterfaceDetailWhereUniqueInput>;
  distinct?: InputMaybe<Array<InterfaceDetailScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<InterfaceDetailOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<InterfaceDetailWhereInput>;
};


export type QueryInterfaceFormatArgs = {
  where: InterfaceFormatWhereUniqueInput;
};


export type QueryInterfaceFormatsArgs = {
  cursor?: InputMaybe<InterfaceFormatWhereUniqueInput>;
  distinct?: InputMaybe<Array<InterfaceFormatScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<InterfaceFormatOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<InterfaceFormatWhereInput>;
};


export type QueryInterfaceReferenceArgs = {
  where: InterfaceReferenceWhereUniqueInput;
};


export type QueryInterfaceReferencesArgs = {
  cursor?: InputMaybe<InterfaceReferenceWhereUniqueInput>;
  distinct?: InputMaybe<Array<InterfaceReferenceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<InterfaceReferenceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<InterfaceReferenceWhereInput>;
};


export type QueryInterfaceTypeArgs = {
  where: InterfaceTypeWhereUniqueInput;
};


export type QueryInterfaceTypesArgs = {
  cursor?: InputMaybe<InterfaceTypeWhereUniqueInput>;
  distinct?: InputMaybe<Array<InterfaceTypeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<InterfaceTypeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<InterfaceTypeWhereInput>;
};


export type QueryLandingApplicationArgs = {
  where: LandingApplicationWhereUniqueInput;
};


export type QueryLandingApplicationClusterArgs = {
  where: LandingApplicationClusterWhereUniqueInput;
};


export type QueryLandingApplicationClusterGroupArgs = {
  where: LandingApplicationClusterGroupWhereUniqueInput;
};


export type QueryLandingApplicationClusterGroupsArgs = {
  cursor?: InputMaybe<LandingApplicationClusterGroupWhereUniqueInput>;
  distinct?: InputMaybe<Array<LandingApplicationClusterGroupScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<LandingApplicationClusterGroupOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LandingApplicationClusterGroupWhereInput>;
};


export type QueryLandingApplicationClusterMappingArgs = {
  where: LandingApplicationClusterMappingWhereUniqueInput;
};


export type QueryLandingApplicationClusterMappingsArgs = {
  cursor?: InputMaybe<LandingApplicationClusterMappingWhereUniqueInput>;
  distinct?: InputMaybe<Array<LandingApplicationClusterMappingScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<LandingApplicationClusterMappingOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LandingApplicationClusterMappingWhereInput>;
};


export type QueryLandingApplicationClustersArgs = {
  cursor?: InputMaybe<LandingApplicationClusterWhereUniqueInput>;
  distinct?: InputMaybe<Array<LandingApplicationClusterScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<LandingApplicationClusterOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LandingApplicationClusterWhereInput>;
};


export type QueryLandingApplicationGroupArgs = {
  where: LandingApplicationGroupWhereUniqueInput;
};


export type QueryLandingApplicationGroupsArgs = {
  cursor?: InputMaybe<LandingApplicationGroupWhereUniqueInput>;
  distinct?: InputMaybe<Array<LandingApplicationGroupScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<LandingApplicationGroupOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LandingApplicationGroupWhereInput>;
};


export type QueryLandingApplicationsArgs = {
  cursor?: InputMaybe<LandingApplicationWhereUniqueInput>;
  distinct?: InputMaybe<Array<LandingApplicationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<LandingApplicationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LandingApplicationWhereInput>;
};


export type QueryLeanixMappingArgs = {
  where: LeanixMappingWhereUniqueInput;
};


export type QueryLeanixMappingsArgs = {
  cursor?: InputMaybe<LeanixMappingWhereUniqueInput>;
  distinct?: InputMaybe<Array<LeanixMappingScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<LeanixMappingOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LeanixMappingWhereInput>;
};


export type QueryMasterArgs = {
  where: MasterWhereUniqueInput;
};


export type QueryMastersArgs = {
  cursor?: InputMaybe<MasterWhereUniqueInput>;
  distinct?: InputMaybe<Array<MasterScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MasterOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MasterWhereInput>;
};


export type QueryMethodArgs = {
  where: MethodWhereUniqueInput;
};


export type QueryMethodsArgs = {
  cursor?: InputMaybe<MethodWhereUniqueInput>;
  distinct?: InputMaybe<Array<MethodScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MethodOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MethodWhereInput>;
};


export type QueryPhaseOnTypeArgs = {
  where: PhaseOnTypeWhereUniqueInput;
};


export type QueryPhaseOnTypesArgs = {
  cursor?: InputMaybe<PhaseOnTypeWhereUniqueInput>;
  distinct?: InputMaybe<Array<PhaseOnTypeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PhaseOnTypeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PhaseOnTypeWhereInput>;
};


export type QueryProjectAllocationArgs = {
  where: ProjectAllocationWhereUniqueInput;
};


export type QueryProjectAllocationsArgs = {
  cursor?: InputMaybe<ProjectAllocationWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProjectAllocationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProjectAllocationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProjectAllocationWhereInput>;
};


export type QueryProjectApprovalArgs = {
  where: ProjectApprovalWhereUniqueInput;
};


export type QueryProjectApprovalsArgs = {
  cursor?: InputMaybe<ProjectApprovalWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProjectApprovalScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProjectApprovalOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProjectApprovalWhereInput>;
};


export type QueryProjectDependenciesArgs = {
  cursor?: InputMaybe<ProjectDependencyWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProjectDependencyScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProjectDependencyOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProjectDependencyWhereInput>;
};


export type QueryProjectDependencyArgs = {
  where: ProjectDependencyWhereUniqueInput;
};


export type QueryProjectDescriptionArgs = {
  where: ProjectDescriptionWhereUniqueInput;
};


export type QueryProjectDescriptionCommentArgs = {
  where: ProjectDescriptionCommentWhereUniqueInput;
};


export type QueryProjectDescriptionCommentsArgs = {
  cursor?: InputMaybe<ProjectDescriptionCommentWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProjectDescriptionCommentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProjectDescriptionCommentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProjectDescriptionCommentWhereInput>;
};


export type QueryProjectDescriptionsArgs = {
  cursor?: InputMaybe<ProjectDescriptionWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProjectDescriptionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProjectDescriptionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProjectDescriptionWhereInput>;
};


export type QueryProjectDocumentArgs = {
  where: ProjectDocumentsWhereUniqueInput;
};


export type QueryProjectDocumentsArgs = {
  cursor?: InputMaybe<ProjectDocumentsWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProjectDocumentsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProjectDocumentsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProjectDocumentsWhereInput>;
};


export type QueryProjectInterfaceArgs = {
  where: ProjectInterfaceWhereUniqueInput;
};


export type QueryProjectInterfacesArgs = {
  cursor?: InputMaybe<ProjectInterfaceWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProjectInterfaceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProjectInterfaceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProjectInterfaceWhereInput>;
};


export type QueryProjectPhaseArgs = {
  where: ProjectPhaseWhereUniqueInput;
};


export type QueryProjectPhaseCaptureArgs = {
  where: ProjectPhaseCaptureWhereUniqueInput;
};


export type QueryProjectPhaseCapturesArgs = {
  cursor?: InputMaybe<ProjectPhaseCaptureWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProjectPhaseCaptureScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProjectPhaseCaptureOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProjectPhaseCaptureWhereInput>;
};


export type QueryProjectPhasesArgs = {
  cursor?: InputMaybe<ProjectPhaseWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProjectPhaseScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProjectPhaseOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProjectPhaseWhereInput>;
};


export type QueryProjectQuestionnaireArgs = {
  where: ProjectQuestionnaireWhereUniqueInput;
};


export type QueryProjectQuestionnaireStatusArgs = {
  where: ProjectQuestionnaireStatusWhereUniqueInput;
};


export type QueryProjectQuestionnaireStatusesArgs = {
  cursor?: InputMaybe<ProjectQuestionnaireStatusWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProjectQuestionnaireStatusScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProjectQuestionnaireStatusOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProjectQuestionnaireStatusWhereInput>;
};


export type QueryProjectQuestionnairesArgs = {
  cursor?: InputMaybe<ProjectQuestionnaireWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProjectQuestionnaireScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProjectQuestionnaireOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProjectQuestionnaireWhereInput>;
};


export type QueryProjectResourceCaptureArgs = {
  where: ProjectResourceCaptureWhereUniqueInput;
};


export type QueryProjectResourceCapturesArgs = {
  cursor?: InputMaybe<ProjectResourceCaptureWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProjectResourceCaptureScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProjectResourceCaptureOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProjectResourceCaptureWhereInput>;
};


export type QueryProjectRoleArgs = {
  where: ProjectRoleWhereUniqueInput;
};


export type QueryProjectRolesArgs = {
  cursor?: InputMaybe<ProjectRoleWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProjectRoleScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProjectRoleOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProjectRoleWhereInput>;
};


export type QueryProjectShortHistoriesArgs = {
  cursor?: InputMaybe<ProjectShortHistoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProjectShortHistoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProjectShortHistoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProjectShortHistoryWhereInput>;
};


export type QueryProjectShortHistoryArgs = {
  where: ProjectShortHistoryWhereUniqueInput;
};


export type QueryProjectStatusArgs = {
  where: ProjectStatusWhereUniqueInput;
};


export type QueryProjectStatusesArgs = {
  cursor?: InputMaybe<ProjectStatusWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProjectStatusScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProjectStatusOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProjectStatusWhereInput>;
};


export type QueryProjectTypeArgs = {
  where: ProjectTypeWhereUniqueInput;
};


export type QueryProjectTypesArgs = {
  cursor?: InputMaybe<ProjectTypeWhereUniqueInput>;
  distinct?: InputMaybe<Array<ProjectTypeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ProjectTypeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ProjectTypeWhereInput>;
};


export type QueryPspMappingArgs = {
  where: PspMappingWhereUniqueInput;
};


export type QueryPspMappingsArgs = {
  cursor?: InputMaybe<PspMappingWhereUniqueInput>;
  distinct?: InputMaybe<Array<PspMappingScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PspMappingOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PspMappingWhereInput>;
};


export type QueryRemarkArgs = {
  where: RemarkWhereUniqueInput;
};


export type QueryRemarksArgs = {
  cursor?: InputMaybe<RemarkWhereUniqueInput>;
  distinct?: InputMaybe<Array<RemarkScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<RemarkOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RemarkWhereInput>;
};


export type QueryReplacementArgs = {
  where: ReplacementWhereUniqueInput;
};


export type QueryReplacementsArgs = {
  cursor?: InputMaybe<ReplacementWhereUniqueInput>;
  distinct?: InputMaybe<Array<ReplacementScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ReplacementOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ReplacementWhereInput>;
};


export type QueryReportArgs = {
  where: ReportWhereUniqueInput;
};


export type QueryReportsArgs = {
  cursor?: InputMaybe<ReportWhereUniqueInput>;
  distinct?: InputMaybe<Array<ReportScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ReportOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ReportWhereInput>;
};


export type QueryRiskArgs = {
  where: RiskWhereUniqueInput;
};


export type QueryRiskDamagePotentialArgs = {
  where: RiskDamagePotentialWhereUniqueInput;
};


export type QueryRiskDamagePotentialsArgs = {
  cursor?: InputMaybe<RiskDamagePotentialWhereUniqueInput>;
  distinct?: InputMaybe<Array<RiskDamagePotentialScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<RiskDamagePotentialOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RiskDamagePotentialWhereInput>;
};


export type QueryRiskOccuranceArgs = {
  where: RiskOccuranceWhereUniqueInput;
};


export type QueryRiskOccurancesArgs = {
  cursor?: InputMaybe<RiskOccuranceWhereUniqueInput>;
  distinct?: InputMaybe<Array<RiskOccuranceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<RiskOccuranceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RiskOccuranceWhereInput>;
};


export type QueryRiskStatusArgs = {
  where: RiskStatusWhereUniqueInput;
};


export type QueryRiskStatusesArgs = {
  cursor?: InputMaybe<RiskStatusWhereUniqueInput>;
  distinct?: InputMaybe<Array<RiskStatusScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<RiskStatusOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RiskStatusWhereInput>;
};


export type QueryRisksArgs = {
  cursor?: InputMaybe<RiskWhereUniqueInput>;
  distinct?: InputMaybe<Array<RiskScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<RiskOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RiskWhereInput>;
};


export type QueryRoleArgs = {
  where: RoleWhereUniqueInput;
};


export type QueryRolesArgs = {
  cursor?: InputMaybe<RoleWhereUniqueInput>;
  distinct?: InputMaybe<Array<RoleScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<RoleOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RoleWhereInput>;
};


export type QuerySecurityGroupArgs = {
  where: SecurityGroupWhereUniqueInput;
};


export type QuerySecurityGroupsArgs = {
  cursor?: InputMaybe<SecurityGroupWhereUniqueInput>;
  distinct?: InputMaybe<Array<SecurityGroupScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SecurityGroupOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SecurityGroupWhereInput>;
};


export type QuerySegmentArgs = {
  where: SegmentWhereUniqueInput;
};


export type QuerySegmentsArgs = {
  cursor?: InputMaybe<SegmentWhereUniqueInput>;
  distinct?: InputMaybe<Array<SegmentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SegmentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SegmentWhereInput>;
};


export type QuerySequenceStatusArgs = {
  where: SequenceStatusWhereUniqueInput;
};


export type QuerySequenceStatusesArgs = {
  cursor?: InputMaybe<SequenceStatusWhereUniqueInput>;
  distinct?: InputMaybe<Array<SequenceStatusScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SequenceStatusOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SequenceStatusWhereInput>;
};


export type QueryTargetedBudgetArgs = {
  where: TargetedBudgetWhereUniqueInput;
};


export type QueryTargetedBudgetsArgs = {
  cursor?: InputMaybe<TargetedBudgetWhereUniqueInput>;
  distinct?: InputMaybe<Array<TargetedBudgetScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TargetedBudgetOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TargetedBudgetWhereInput>;
};


export type QueryTemplateArgs = {
  where: TemplateWhereUniqueInput;
};


export type QueryTemplateDocumentArgs = {
  where: TemplateDocumentsWhereUniqueInput;
};


export type QueryTemplateDocumentsArgs = {
  cursor?: InputMaybe<TemplateDocumentsWhereUniqueInput>;
  distinct?: InputMaybe<Array<TemplateDocumentsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TemplateDocumentsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TemplateDocumentsWhereInput>;
};


export type QueryTemplatesArgs = {
  cursor?: InputMaybe<TemplateWhereUniqueInput>;
  distinct?: InputMaybe<Array<TemplateScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TemplateOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TemplateWhereInput>;
};


export type QueryTopProjectArgs = {
  where: TopProjectsWhereUniqueInput;
};


export type QueryTopProjectsArgs = {
  cursor?: InputMaybe<TopProjectsWhereUniqueInput>;
  distinct?: InputMaybe<Array<TopProjectsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TopProjectsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TopProjectsWhereInput>;
};

export type Remark = {
  __typename?: 'Remark';
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  project?: Maybe<Master>;
  projectId?: Maybe<Scalars['String']>;
  remark: Scalars['String'];
  segment: Segment;
  segmentId: Scalars['String'];
};

export type RemarkCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<MasterCreateNestedOneWithoutRemarksInput>;
  remark: Scalars['String'];
  segment: SegmentCreateNestedOneWithoutRemarksInput;
};

export type RemarkCreateManyProjectInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  remark: Scalars['String'];
  segmentId: Scalars['String'];
};

export type RemarkCreateManyProjectInputEnvelope = {
  data: Array<RemarkCreateManyProjectInput>;
};

export type RemarkCreateManySegmentInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  projectId?: InputMaybe<Scalars['String']>;
  remark: Scalars['String'];
};

export type RemarkCreateManySegmentInputEnvelope = {
  data: Array<RemarkCreateManySegmentInput>;
};

export type RemarkCreateNestedManyWithoutProjectInput = {
  connect?: InputMaybe<Array<RemarkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RemarkCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<RemarkCreateWithoutProjectInput>>;
  createMany?: InputMaybe<RemarkCreateManyProjectInputEnvelope>;
};

export type RemarkCreateNestedManyWithoutSegmentInput = {
  connect?: InputMaybe<Array<RemarkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RemarkCreateOrConnectWithoutSegmentInput>>;
  create?: InputMaybe<Array<RemarkCreateWithoutSegmentInput>>;
  createMany?: InputMaybe<RemarkCreateManySegmentInputEnvelope>;
};

export type RemarkCreateOrConnectWithoutProjectInput = {
  create: RemarkCreateWithoutProjectInput;
  where: RemarkWhereUniqueInput;
};

export type RemarkCreateOrConnectWithoutSegmentInput = {
  create: RemarkCreateWithoutSegmentInput;
  where: RemarkWhereUniqueInput;
};

export type RemarkCreateWithoutProjectInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  remark: Scalars['String'];
  segment: SegmentCreateNestedOneWithoutRemarksInput;
};

export type RemarkCreateWithoutSegmentInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  project?: InputMaybe<MasterCreateNestedOneWithoutRemarksInput>;
  remark: Scalars['String'];
};

export type RemarkListRelationFilter = {
  every?: InputMaybe<RemarkWhereInput>;
  none?: InputMaybe<RemarkWhereInput>;
  some?: InputMaybe<RemarkWhereInput>;
};

export type RemarkOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type RemarkOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  deletedBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  project?: InputMaybe<MasterOrderByWithRelationInput>;
  projectId?: InputMaybe<SortOrder>;
  remark?: InputMaybe<SortOrder>;
  segment?: InputMaybe<SegmentOrderByWithRelationInput>;
  segmentId?: InputMaybe<SortOrder>;
};

export enum RemarkScalarFieldEnum {
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  DeletedAt = 'deletedAt',
  DeletedBy = 'deletedBy',
  Id = 'id',
  ProjectId = 'projectId',
  Remark = 'remark',
  SegmentId = 'segmentId'
}

export type RemarkScalarWhereInput = {
  AND?: InputMaybe<Array<RemarkScalarWhereInput>>;
  NOT?: InputMaybe<Array<RemarkScalarWhereInput>>;
  OR?: InputMaybe<Array<RemarkScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  projectId?: InputMaybe<StringNullableFilter>;
  remark?: InputMaybe<StringFilter>;
  segmentId?: InputMaybe<StringFilter>;
};

export type RemarkUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneWithoutRemarksNestedInput>;
  remark?: InputMaybe<StringFieldUpdateOperationsInput>;
  segment?: InputMaybe<SegmentUpdateOneRequiredWithoutRemarksNestedInput>;
};

export type RemarkUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  remark?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type RemarkUpdateManyWithWhereWithoutProjectInput = {
  data: RemarkUpdateManyMutationInput;
  where: RemarkScalarWhereInput;
};

export type RemarkUpdateManyWithWhereWithoutSegmentInput = {
  data: RemarkUpdateManyMutationInput;
  where: RemarkScalarWhereInput;
};

export type RemarkUpdateManyWithoutProjectNestedInput = {
  connect?: InputMaybe<Array<RemarkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RemarkCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<RemarkCreateWithoutProjectInput>>;
  createMany?: InputMaybe<RemarkCreateManyProjectInputEnvelope>;
  delete?: InputMaybe<Array<RemarkWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RemarkScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RemarkWhereUniqueInput>>;
  set?: InputMaybe<Array<RemarkWhereUniqueInput>>;
  update?: InputMaybe<Array<RemarkUpdateWithWhereUniqueWithoutProjectInput>>;
  updateMany?: InputMaybe<Array<RemarkUpdateManyWithWhereWithoutProjectInput>>;
  upsert?: InputMaybe<Array<RemarkUpsertWithWhereUniqueWithoutProjectInput>>;
};

export type RemarkUpdateManyWithoutSegmentNestedInput = {
  connect?: InputMaybe<Array<RemarkWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RemarkCreateOrConnectWithoutSegmentInput>>;
  create?: InputMaybe<Array<RemarkCreateWithoutSegmentInput>>;
  createMany?: InputMaybe<RemarkCreateManySegmentInputEnvelope>;
  delete?: InputMaybe<Array<RemarkWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RemarkScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RemarkWhereUniqueInput>>;
  set?: InputMaybe<Array<RemarkWhereUniqueInput>>;
  update?: InputMaybe<Array<RemarkUpdateWithWhereUniqueWithoutSegmentInput>>;
  updateMany?: InputMaybe<Array<RemarkUpdateManyWithWhereWithoutSegmentInput>>;
  upsert?: InputMaybe<Array<RemarkUpsertWithWhereUniqueWithoutSegmentInput>>;
};

export type RemarkUpdateWithWhereUniqueWithoutProjectInput = {
  data: RemarkUpdateWithoutProjectInput;
  where: RemarkWhereUniqueInput;
};

export type RemarkUpdateWithWhereUniqueWithoutSegmentInput = {
  data: RemarkUpdateWithoutSegmentInput;
  where: RemarkWhereUniqueInput;
};

export type RemarkUpdateWithoutProjectInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  remark?: InputMaybe<StringFieldUpdateOperationsInput>;
  segment?: InputMaybe<SegmentUpdateOneRequiredWithoutRemarksNestedInput>;
};

export type RemarkUpdateWithoutSegmentInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneWithoutRemarksNestedInput>;
  remark?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type RemarkUpsertWithWhereUniqueWithoutProjectInput = {
  create: RemarkCreateWithoutProjectInput;
  update: RemarkUpdateWithoutProjectInput;
  where: RemarkWhereUniqueInput;
};

export type RemarkUpsertWithWhereUniqueWithoutSegmentInput = {
  create: RemarkCreateWithoutSegmentInput;
  update: RemarkUpdateWithoutSegmentInput;
  where: RemarkWhereUniqueInput;
};

export type RemarkWhereInput = {
  AND?: InputMaybe<Array<RemarkWhereInput>>;
  NOT?: InputMaybe<Array<RemarkWhereInput>>;
  OR?: InputMaybe<Array<RemarkWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  project?: InputMaybe<MasterWhereInput>;
  projectId?: InputMaybe<StringNullableFilter>;
  remark?: InputMaybe<StringFilter>;
  segment?: InputMaybe<SegmentWhereInput>;
  segmentId?: InputMaybe<StringFilter>;
};

export type RemarkWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type Replacement = {
  __typename?: 'Replacement';
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  date: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  leanixId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  project: Master;
  projectId: Scalars['String'];
};

export type ReplacementCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  date: Scalars['DateTime'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  leanixId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  project: MasterCreateNestedOneWithoutReplacementInput;
};

export type ReplacementCreateManyProjectInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  date: Scalars['DateTime'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  leanixId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type ReplacementCreateManyProjectInputEnvelope = {
  data: Array<ReplacementCreateManyProjectInput>;
};

export type ReplacementCreateNestedManyWithoutProjectInput = {
  connect?: InputMaybe<Array<ReplacementWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ReplacementCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<ReplacementCreateWithoutProjectInput>>;
  createMany?: InputMaybe<ReplacementCreateManyProjectInputEnvelope>;
};

export type ReplacementCreateOrConnectWithoutProjectInput = {
  create: ReplacementCreateWithoutProjectInput;
  where: ReplacementWhereUniqueInput;
};

export type ReplacementCreateWithoutProjectInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  date: Scalars['DateTime'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  leanixId?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type ReplacementListRelationFilter = {
  every?: InputMaybe<ReplacementWhereInput>;
  none?: InputMaybe<ReplacementWhereInput>;
  some?: InputMaybe<ReplacementWhereInput>;
};

export type ReplacementOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ReplacementOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  date?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  deletedBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  leanixId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  project?: InputMaybe<MasterOrderByWithRelationInput>;
  projectId?: InputMaybe<SortOrder>;
};

export enum ReplacementScalarFieldEnum {
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  Date = 'date',
  DeletedAt = 'deletedAt',
  DeletedBy = 'deletedBy',
  Id = 'id',
  LeanixId = 'leanixId',
  Name = 'name',
  ProjectId = 'projectId'
}

export type ReplacementScalarWhereInput = {
  AND?: InputMaybe<Array<ReplacementScalarWhereInput>>;
  NOT?: InputMaybe<Array<ReplacementScalarWhereInput>>;
  OR?: InputMaybe<Array<ReplacementScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  date?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  leanixId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  projectId?: InputMaybe<StringFilter>;
};

export type ReplacementUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  leanixId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutReplacementNestedInput>;
};

export type ReplacementUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  leanixId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ReplacementUpdateManyWithWhereWithoutProjectInput = {
  data: ReplacementUpdateManyMutationInput;
  where: ReplacementScalarWhereInput;
};

export type ReplacementUpdateManyWithoutProjectNestedInput = {
  connect?: InputMaybe<Array<ReplacementWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ReplacementCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<ReplacementCreateWithoutProjectInput>>;
  createMany?: InputMaybe<ReplacementCreateManyProjectInputEnvelope>;
  delete?: InputMaybe<Array<ReplacementWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ReplacementScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ReplacementWhereUniqueInput>>;
  set?: InputMaybe<Array<ReplacementWhereUniqueInput>>;
  update?: InputMaybe<Array<ReplacementUpdateWithWhereUniqueWithoutProjectInput>>;
  updateMany?: InputMaybe<Array<ReplacementUpdateManyWithWhereWithoutProjectInput>>;
  upsert?: InputMaybe<Array<ReplacementUpsertWithWhereUniqueWithoutProjectInput>>;
};

export type ReplacementUpdateWithWhereUniqueWithoutProjectInput = {
  data: ReplacementUpdateWithoutProjectInput;
  where: ReplacementWhereUniqueInput;
};

export type ReplacementUpdateWithoutProjectInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  date?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  leanixId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ReplacementUpsertWithWhereUniqueWithoutProjectInput = {
  create: ReplacementCreateWithoutProjectInput;
  update: ReplacementUpdateWithoutProjectInput;
  where: ReplacementWhereUniqueInput;
};

export type ReplacementWhereInput = {
  AND?: InputMaybe<Array<ReplacementWhereInput>>;
  NOT?: InputMaybe<Array<ReplacementWhereInput>>;
  OR?: InputMaybe<Array<ReplacementWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  date?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  leanixId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  project?: InputMaybe<MasterWhereInput>;
  projectId?: InputMaybe<StringFilter>;
};

export type ReplacementWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type Report = {
  __typename?: 'Report';
  _count: ReportCount;
  addresseeGroup?: Maybe<Array<AddresseeGroup>>;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  project: Master;
  projectId: Scalars['String'];
  reportLink: Scalars['String'];
  reportTitle: Scalars['String'];
  update?: Maybe<Scalars['DateTime']>;
};

export type ReportCount = {
  __typename?: 'ReportCount';
  addresseeGroup: Scalars['Int'];
};

export type ReportCreateInput = {
  addresseeGroup?: InputMaybe<AddresseeGroupCreateNestedManyWithoutReportInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  project: MasterCreateNestedOneWithoutReportInput;
  reportLink: Scalars['String'];
  reportTitle: Scalars['String'];
  update?: InputMaybe<Scalars['DateTime']>;
};

export type ReportCreateManyProjectInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  reportLink: Scalars['String'];
  reportTitle: Scalars['String'];
  update?: InputMaybe<Scalars['DateTime']>;
};

export type ReportCreateManyProjectInputEnvelope = {
  data: Array<ReportCreateManyProjectInput>;
};

export type ReportCreateNestedManyWithoutProjectInput = {
  connect?: InputMaybe<Array<ReportWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ReportCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<ReportCreateWithoutProjectInput>>;
  createMany?: InputMaybe<ReportCreateManyProjectInputEnvelope>;
};

export type ReportCreateNestedOneWithoutAddresseeGroupInput = {
  connect?: InputMaybe<ReportWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ReportCreateOrConnectWithoutAddresseeGroupInput>;
  create?: InputMaybe<ReportCreateWithoutAddresseeGroupInput>;
};

export type ReportCreateOrConnectWithoutAddresseeGroupInput = {
  create: ReportCreateWithoutAddresseeGroupInput;
  where: ReportWhereUniqueInput;
};

export type ReportCreateOrConnectWithoutProjectInput = {
  create: ReportCreateWithoutProjectInput;
  where: ReportWhereUniqueInput;
};

export type ReportCreateWithoutAddresseeGroupInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  project: MasterCreateNestedOneWithoutReportInput;
  reportLink: Scalars['String'];
  reportTitle: Scalars['String'];
  update?: InputMaybe<Scalars['DateTime']>;
};

export type ReportCreateWithoutProjectInput = {
  addresseeGroup?: InputMaybe<AddresseeGroupCreateNestedManyWithoutReportInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  reportLink: Scalars['String'];
  reportTitle: Scalars['String'];
  update?: InputMaybe<Scalars['DateTime']>;
};

export type ReportListRelationFilter = {
  every?: InputMaybe<ReportWhereInput>;
  none?: InputMaybe<ReportWhereInput>;
  some?: InputMaybe<ReportWhereInput>;
};

export type ReportOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ReportOrderByWithRelationInput = {
  addresseeGroup?: InputMaybe<AddresseeGroupOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  deletedBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  project?: InputMaybe<MasterOrderByWithRelationInput>;
  projectId?: InputMaybe<SortOrder>;
  reportLink?: InputMaybe<SortOrder>;
  reportTitle?: InputMaybe<SortOrder>;
  update?: InputMaybe<SortOrder>;
};

export enum ReportScalarFieldEnum {
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  DeletedAt = 'deletedAt',
  DeletedBy = 'deletedBy',
  Id = 'id',
  ProjectId = 'projectId',
  ReportLink = 'reportLink',
  ReportTitle = 'reportTitle',
  Update = 'update'
}

export type ReportScalarWhereInput = {
  AND?: InputMaybe<Array<ReportScalarWhereInput>>;
  NOT?: InputMaybe<Array<ReportScalarWhereInput>>;
  OR?: InputMaybe<Array<ReportScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  projectId?: InputMaybe<StringFilter>;
  reportLink?: InputMaybe<StringFilter>;
  reportTitle?: InputMaybe<StringFilter>;
  update?: InputMaybe<DateTimeNullableFilter>;
};

export type ReportUpdateInput = {
  addresseeGroup?: InputMaybe<AddresseeGroupUpdateManyWithoutReportNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutReportNestedInput>;
  reportLink?: InputMaybe<StringFieldUpdateOperationsInput>;
  reportTitle?: InputMaybe<StringFieldUpdateOperationsInput>;
  update?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type ReportUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reportLink?: InputMaybe<StringFieldUpdateOperationsInput>;
  reportTitle?: InputMaybe<StringFieldUpdateOperationsInput>;
  update?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type ReportUpdateManyWithWhereWithoutProjectInput = {
  data: ReportUpdateManyMutationInput;
  where: ReportScalarWhereInput;
};

export type ReportUpdateManyWithoutProjectNestedInput = {
  connect?: InputMaybe<Array<ReportWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ReportCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<ReportCreateWithoutProjectInput>>;
  createMany?: InputMaybe<ReportCreateManyProjectInputEnvelope>;
  delete?: InputMaybe<Array<ReportWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ReportScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ReportWhereUniqueInput>>;
  set?: InputMaybe<Array<ReportWhereUniqueInput>>;
  update?: InputMaybe<Array<ReportUpdateWithWhereUniqueWithoutProjectInput>>;
  updateMany?: InputMaybe<Array<ReportUpdateManyWithWhereWithoutProjectInput>>;
  upsert?: InputMaybe<Array<ReportUpsertWithWhereUniqueWithoutProjectInput>>;
};

export type ReportUpdateOneRequiredWithoutAddresseeGroupNestedInput = {
  connect?: InputMaybe<ReportWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ReportCreateOrConnectWithoutAddresseeGroupInput>;
  create?: InputMaybe<ReportCreateWithoutAddresseeGroupInput>;
  update?: InputMaybe<ReportUpdateWithoutAddresseeGroupInput>;
  upsert?: InputMaybe<ReportUpsertWithoutAddresseeGroupInput>;
};

export type ReportUpdateWithWhereUniqueWithoutProjectInput = {
  data: ReportUpdateWithoutProjectInput;
  where: ReportWhereUniqueInput;
};

export type ReportUpdateWithoutAddresseeGroupInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutReportNestedInput>;
  reportLink?: InputMaybe<StringFieldUpdateOperationsInput>;
  reportTitle?: InputMaybe<StringFieldUpdateOperationsInput>;
  update?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type ReportUpdateWithoutProjectInput = {
  addresseeGroup?: InputMaybe<AddresseeGroupUpdateManyWithoutReportNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reportLink?: InputMaybe<StringFieldUpdateOperationsInput>;
  reportTitle?: InputMaybe<StringFieldUpdateOperationsInput>;
  update?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type ReportUpsertWithWhereUniqueWithoutProjectInput = {
  create: ReportCreateWithoutProjectInput;
  update: ReportUpdateWithoutProjectInput;
  where: ReportWhereUniqueInput;
};

export type ReportUpsertWithoutAddresseeGroupInput = {
  create: ReportCreateWithoutAddresseeGroupInput;
  update: ReportUpdateWithoutAddresseeGroupInput;
};

export type ReportWhereInput = {
  AND?: InputMaybe<Array<ReportWhereInput>>;
  NOT?: InputMaybe<Array<ReportWhereInput>>;
  OR?: InputMaybe<Array<ReportWhereInput>>;
  addresseeGroup?: InputMaybe<AddresseeGroupListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  project?: InputMaybe<MasterWhereInput>;
  projectId?: InputMaybe<StringFilter>;
  reportLink?: InputMaybe<StringFilter>;
  reportTitle?: InputMaybe<StringFilter>;
  update?: InputMaybe<DateTimeNullableFilter>;
};

export type ReportWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type Risk = {
  __typename?: 'Risk';
  action?: Maybe<Scalars['String']>;
  cause?: Maybe<Scalars['String']>;
  consequence?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  employee: Employee;
  employeeId: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  project: Master;
  projectId: Scalars['String'];
  riskDamagePotential: RiskDamagePotential;
  riskDamagePotentialId: Scalars['String'];
  riskId: Scalars['String'];
  riskOccurance: RiskOccurance;
  riskOccuranceId: Scalars['String'];
  riskStatus: RiskStatus;
  riskStatusId: Scalars['String'];
  status?: Maybe<Scalars['Int']>;
};

export type RiskCreateInput = {
  action?: InputMaybe<Scalars['String']>;
  cause?: InputMaybe<Scalars['String']>;
  consequence?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  employee: EmployeeCreateNestedOneWithoutRiskInput;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  project: MasterCreateNestedOneWithoutRiskInput;
  riskDamagePotential: RiskDamagePotentialCreateNestedOneWithoutRiskInput;
  riskId?: InputMaybe<Scalars['String']>;
  riskOccurance: RiskOccuranceCreateNestedOneWithoutRiskInput;
  riskStatus: RiskStatusCreateNestedOneWithoutRiskInput;
  status?: InputMaybe<Scalars['Int']>;
};

export type RiskCreateManyEmployeeInput = {
  action?: InputMaybe<Scalars['String']>;
  cause?: InputMaybe<Scalars['String']>;
  consequence?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  projectId: Scalars['String'];
  riskDamagePotentialId: Scalars['String'];
  riskId?: InputMaybe<Scalars['String']>;
  riskOccuranceId: Scalars['String'];
  riskStatusId: Scalars['String'];
  status?: InputMaybe<Scalars['Int']>;
};

export type RiskCreateManyEmployeeInputEnvelope = {
  data: Array<RiskCreateManyEmployeeInput>;
};

export type RiskCreateManyProjectInput = {
  action?: InputMaybe<Scalars['String']>;
  cause?: InputMaybe<Scalars['String']>;
  consequence?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  riskDamagePotentialId: Scalars['String'];
  riskId?: InputMaybe<Scalars['String']>;
  riskOccuranceId: Scalars['String'];
  riskStatusId: Scalars['String'];
  status?: InputMaybe<Scalars['Int']>;
};

export type RiskCreateManyProjectInputEnvelope = {
  data: Array<RiskCreateManyProjectInput>;
};

export type RiskCreateManyRiskDamagePotentialInput = {
  action?: InputMaybe<Scalars['String']>;
  cause?: InputMaybe<Scalars['String']>;
  consequence?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  projectId: Scalars['String'];
  riskId?: InputMaybe<Scalars['String']>;
  riskOccuranceId: Scalars['String'];
  riskStatusId: Scalars['String'];
  status?: InputMaybe<Scalars['Int']>;
};

export type RiskCreateManyRiskDamagePotentialInputEnvelope = {
  data: Array<RiskCreateManyRiskDamagePotentialInput>;
};

export type RiskCreateManyRiskOccuranceInput = {
  action?: InputMaybe<Scalars['String']>;
  cause?: InputMaybe<Scalars['String']>;
  consequence?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  projectId: Scalars['String'];
  riskDamagePotentialId: Scalars['String'];
  riskId?: InputMaybe<Scalars['String']>;
  riskStatusId: Scalars['String'];
  status?: InputMaybe<Scalars['Int']>;
};

export type RiskCreateManyRiskOccuranceInputEnvelope = {
  data: Array<RiskCreateManyRiskOccuranceInput>;
};

export type RiskCreateManyRiskStatusInput = {
  action?: InputMaybe<Scalars['String']>;
  cause?: InputMaybe<Scalars['String']>;
  consequence?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  employeeId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  projectId: Scalars['String'];
  riskDamagePotentialId: Scalars['String'];
  riskId?: InputMaybe<Scalars['String']>;
  riskOccuranceId: Scalars['String'];
  status?: InputMaybe<Scalars['Int']>;
};

export type RiskCreateManyRiskStatusInputEnvelope = {
  data: Array<RiskCreateManyRiskStatusInput>;
};

export type RiskCreateNestedManyWithoutEmployeeInput = {
  connect?: InputMaybe<Array<RiskWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RiskCreateOrConnectWithoutEmployeeInput>>;
  create?: InputMaybe<Array<RiskCreateWithoutEmployeeInput>>;
  createMany?: InputMaybe<RiskCreateManyEmployeeInputEnvelope>;
};

export type RiskCreateNestedManyWithoutProjectInput = {
  connect?: InputMaybe<Array<RiskWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RiskCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<RiskCreateWithoutProjectInput>>;
  createMany?: InputMaybe<RiskCreateManyProjectInputEnvelope>;
};

export type RiskCreateNestedManyWithoutRiskDamagePotentialInput = {
  connect?: InputMaybe<Array<RiskWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RiskCreateOrConnectWithoutRiskDamagePotentialInput>>;
  create?: InputMaybe<Array<RiskCreateWithoutRiskDamagePotentialInput>>;
  createMany?: InputMaybe<RiskCreateManyRiskDamagePotentialInputEnvelope>;
};

export type RiskCreateNestedManyWithoutRiskOccuranceInput = {
  connect?: InputMaybe<Array<RiskWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RiskCreateOrConnectWithoutRiskOccuranceInput>>;
  create?: InputMaybe<Array<RiskCreateWithoutRiskOccuranceInput>>;
  createMany?: InputMaybe<RiskCreateManyRiskOccuranceInputEnvelope>;
};

export type RiskCreateNestedManyWithoutRiskStatusInput = {
  connect?: InputMaybe<Array<RiskWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RiskCreateOrConnectWithoutRiskStatusInput>>;
  create?: InputMaybe<Array<RiskCreateWithoutRiskStatusInput>>;
  createMany?: InputMaybe<RiskCreateManyRiskStatusInputEnvelope>;
};

export type RiskCreateOrConnectWithoutEmployeeInput = {
  create: RiskCreateWithoutEmployeeInput;
  where: RiskWhereUniqueInput;
};

export type RiskCreateOrConnectWithoutProjectInput = {
  create: RiskCreateWithoutProjectInput;
  where: RiskWhereUniqueInput;
};

export type RiskCreateOrConnectWithoutRiskDamagePotentialInput = {
  create: RiskCreateWithoutRiskDamagePotentialInput;
  where: RiskWhereUniqueInput;
};

export type RiskCreateOrConnectWithoutRiskOccuranceInput = {
  create: RiskCreateWithoutRiskOccuranceInput;
  where: RiskWhereUniqueInput;
};

export type RiskCreateOrConnectWithoutRiskStatusInput = {
  create: RiskCreateWithoutRiskStatusInput;
  where: RiskWhereUniqueInput;
};

export type RiskCreateWithoutEmployeeInput = {
  action?: InputMaybe<Scalars['String']>;
  cause?: InputMaybe<Scalars['String']>;
  consequence?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  project: MasterCreateNestedOneWithoutRiskInput;
  riskDamagePotential: RiskDamagePotentialCreateNestedOneWithoutRiskInput;
  riskId?: InputMaybe<Scalars['String']>;
  riskOccurance: RiskOccuranceCreateNestedOneWithoutRiskInput;
  riskStatus: RiskStatusCreateNestedOneWithoutRiskInput;
  status?: InputMaybe<Scalars['Int']>;
};

export type RiskCreateWithoutProjectInput = {
  action?: InputMaybe<Scalars['String']>;
  cause?: InputMaybe<Scalars['String']>;
  consequence?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  employee: EmployeeCreateNestedOneWithoutRiskInput;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  riskDamagePotential: RiskDamagePotentialCreateNestedOneWithoutRiskInput;
  riskId?: InputMaybe<Scalars['String']>;
  riskOccurance: RiskOccuranceCreateNestedOneWithoutRiskInput;
  riskStatus: RiskStatusCreateNestedOneWithoutRiskInput;
  status?: InputMaybe<Scalars['Int']>;
};

export type RiskCreateWithoutRiskDamagePotentialInput = {
  action?: InputMaybe<Scalars['String']>;
  cause?: InputMaybe<Scalars['String']>;
  consequence?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  employee: EmployeeCreateNestedOneWithoutRiskInput;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  project: MasterCreateNestedOneWithoutRiskInput;
  riskId?: InputMaybe<Scalars['String']>;
  riskOccurance: RiskOccuranceCreateNestedOneWithoutRiskInput;
  riskStatus: RiskStatusCreateNestedOneWithoutRiskInput;
  status?: InputMaybe<Scalars['Int']>;
};

export type RiskCreateWithoutRiskOccuranceInput = {
  action?: InputMaybe<Scalars['String']>;
  cause?: InputMaybe<Scalars['String']>;
  consequence?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  employee: EmployeeCreateNestedOneWithoutRiskInput;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  project: MasterCreateNestedOneWithoutRiskInput;
  riskDamagePotential: RiskDamagePotentialCreateNestedOneWithoutRiskInput;
  riskId?: InputMaybe<Scalars['String']>;
  riskStatus: RiskStatusCreateNestedOneWithoutRiskInput;
  status?: InputMaybe<Scalars['Int']>;
};

export type RiskCreateWithoutRiskStatusInput = {
  action?: InputMaybe<Scalars['String']>;
  cause?: InputMaybe<Scalars['String']>;
  consequence?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  employee: EmployeeCreateNestedOneWithoutRiskInput;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  project: MasterCreateNestedOneWithoutRiskInput;
  riskDamagePotential: RiskDamagePotentialCreateNestedOneWithoutRiskInput;
  riskId?: InputMaybe<Scalars['String']>;
  riskOccurance: RiskOccuranceCreateNestedOneWithoutRiskInput;
  status?: InputMaybe<Scalars['Int']>;
};

export type RiskDamagePotential = {
  __typename?: 'RiskDamagePotential';
  ProjectInterface?: Maybe<Array<ProjectInterface>>;
  Risk?: Maybe<Array<Risk>>;
  _count: RiskDamagePotentialCount;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type RiskDamagePotentialCount = {
  __typename?: 'RiskDamagePotentialCount';
  ProjectInterface: Scalars['Int'];
  Risk: Scalars['Int'];
};

export type RiskDamagePotentialCreateInput = {
  ProjectInterface?: InputMaybe<ProjectInterfaceCreateNestedManyWithoutRiskDamagePotentialInput>;
  Risk?: InputMaybe<RiskCreateNestedManyWithoutRiskDamagePotentialInput>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

export type RiskDamagePotentialCreateNestedOneWithoutProjectInterfaceInput = {
  connect?: InputMaybe<RiskDamagePotentialWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RiskDamagePotentialCreateOrConnectWithoutProjectInterfaceInput>;
  create?: InputMaybe<RiskDamagePotentialCreateWithoutProjectInterfaceInput>;
};

export type RiskDamagePotentialCreateNestedOneWithoutRiskInput = {
  connect?: InputMaybe<RiskDamagePotentialWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RiskDamagePotentialCreateOrConnectWithoutRiskInput>;
  create?: InputMaybe<RiskDamagePotentialCreateWithoutRiskInput>;
};

export type RiskDamagePotentialCreateOrConnectWithoutProjectInterfaceInput = {
  create: RiskDamagePotentialCreateWithoutProjectInterfaceInput;
  where: RiskDamagePotentialWhereUniqueInput;
};

export type RiskDamagePotentialCreateOrConnectWithoutRiskInput = {
  create: RiskDamagePotentialCreateWithoutRiskInput;
  where: RiskDamagePotentialWhereUniqueInput;
};

export type RiskDamagePotentialCreateWithoutProjectInterfaceInput = {
  Risk?: InputMaybe<RiskCreateNestedManyWithoutRiskDamagePotentialInput>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

export type RiskDamagePotentialCreateWithoutRiskInput = {
  ProjectInterface?: InputMaybe<ProjectInterfaceCreateNestedManyWithoutRiskDamagePotentialInput>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

export type RiskDamagePotentialOrderByWithRelationInput = {
  ProjectInterface?: InputMaybe<ProjectInterfaceOrderByRelationAggregateInput>;
  Risk?: InputMaybe<RiskOrderByRelationAggregateInput>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export enum RiskDamagePotentialScalarFieldEnum {
  Description = 'description',
  Id = 'id'
}

export type RiskDamagePotentialUpdateInput = {
  ProjectInterface?: InputMaybe<ProjectInterfaceUpdateManyWithoutRiskDamagePotentialNestedInput>;
  Risk?: InputMaybe<RiskUpdateManyWithoutRiskDamagePotentialNestedInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type RiskDamagePotentialUpdateOneRequiredWithoutRiskNestedInput = {
  connect?: InputMaybe<RiskDamagePotentialWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RiskDamagePotentialCreateOrConnectWithoutRiskInput>;
  create?: InputMaybe<RiskDamagePotentialCreateWithoutRiskInput>;
  update?: InputMaybe<RiskDamagePotentialUpdateWithoutRiskInput>;
  upsert?: InputMaybe<RiskDamagePotentialUpsertWithoutRiskInput>;
};

export type RiskDamagePotentialUpdateOneWithoutProjectInterfaceNestedInput = {
  connect?: InputMaybe<RiskDamagePotentialWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RiskDamagePotentialCreateOrConnectWithoutProjectInterfaceInput>;
  create?: InputMaybe<RiskDamagePotentialCreateWithoutProjectInterfaceInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<RiskDamagePotentialUpdateWithoutProjectInterfaceInput>;
  upsert?: InputMaybe<RiskDamagePotentialUpsertWithoutProjectInterfaceInput>;
};

export type RiskDamagePotentialUpdateWithoutProjectInterfaceInput = {
  Risk?: InputMaybe<RiskUpdateManyWithoutRiskDamagePotentialNestedInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type RiskDamagePotentialUpdateWithoutRiskInput = {
  ProjectInterface?: InputMaybe<ProjectInterfaceUpdateManyWithoutRiskDamagePotentialNestedInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type RiskDamagePotentialUpsertWithoutProjectInterfaceInput = {
  create: RiskDamagePotentialCreateWithoutProjectInterfaceInput;
  update: RiskDamagePotentialUpdateWithoutProjectInterfaceInput;
};

export type RiskDamagePotentialUpsertWithoutRiskInput = {
  create: RiskDamagePotentialCreateWithoutRiskInput;
  update: RiskDamagePotentialUpdateWithoutRiskInput;
};

export type RiskDamagePotentialWhereInput = {
  AND?: InputMaybe<Array<RiskDamagePotentialWhereInput>>;
  NOT?: InputMaybe<Array<RiskDamagePotentialWhereInput>>;
  OR?: InputMaybe<Array<RiskDamagePotentialWhereInput>>;
  ProjectInterface?: InputMaybe<ProjectInterfaceListRelationFilter>;
  Risk?: InputMaybe<RiskListRelationFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
};

export type RiskDamagePotentialWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type RiskListRelationFilter = {
  every?: InputMaybe<RiskWhereInput>;
  none?: InputMaybe<RiskWhereInput>;
  some?: InputMaybe<RiskWhereInput>;
};

export type RiskOccurance = {
  __typename?: 'RiskOccurance';
  ProjectInterface?: Maybe<Array<ProjectInterface>>;
  Risk?: Maybe<Array<Risk>>;
  _count: RiskOccuranceCount;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type RiskOccuranceCount = {
  __typename?: 'RiskOccuranceCount';
  ProjectInterface: Scalars['Int'];
  Risk: Scalars['Int'];
};

export type RiskOccuranceCreateInput = {
  ProjectInterface?: InputMaybe<ProjectInterfaceCreateNestedManyWithoutRiskOccuranceInput>;
  Risk?: InputMaybe<RiskCreateNestedManyWithoutRiskOccuranceInput>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

export type RiskOccuranceCreateNestedOneWithoutProjectInterfaceInput = {
  connect?: InputMaybe<RiskOccuranceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RiskOccuranceCreateOrConnectWithoutProjectInterfaceInput>;
  create?: InputMaybe<RiskOccuranceCreateWithoutProjectInterfaceInput>;
};

export type RiskOccuranceCreateNestedOneWithoutRiskInput = {
  connect?: InputMaybe<RiskOccuranceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RiskOccuranceCreateOrConnectWithoutRiskInput>;
  create?: InputMaybe<RiskOccuranceCreateWithoutRiskInput>;
};

export type RiskOccuranceCreateOrConnectWithoutProjectInterfaceInput = {
  create: RiskOccuranceCreateWithoutProjectInterfaceInput;
  where: RiskOccuranceWhereUniqueInput;
};

export type RiskOccuranceCreateOrConnectWithoutRiskInput = {
  create: RiskOccuranceCreateWithoutRiskInput;
  where: RiskOccuranceWhereUniqueInput;
};

export type RiskOccuranceCreateWithoutProjectInterfaceInput = {
  Risk?: InputMaybe<RiskCreateNestedManyWithoutRiskOccuranceInput>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

export type RiskOccuranceCreateWithoutRiskInput = {
  ProjectInterface?: InputMaybe<ProjectInterfaceCreateNestedManyWithoutRiskOccuranceInput>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

export type RiskOccuranceOrderByWithRelationInput = {
  ProjectInterface?: InputMaybe<ProjectInterfaceOrderByRelationAggregateInput>;
  Risk?: InputMaybe<RiskOrderByRelationAggregateInput>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export enum RiskOccuranceScalarFieldEnum {
  Description = 'description',
  Id = 'id'
}

export type RiskOccuranceUpdateInput = {
  ProjectInterface?: InputMaybe<ProjectInterfaceUpdateManyWithoutRiskOccuranceNestedInput>;
  Risk?: InputMaybe<RiskUpdateManyWithoutRiskOccuranceNestedInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type RiskOccuranceUpdateOneRequiredWithoutRiskNestedInput = {
  connect?: InputMaybe<RiskOccuranceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RiskOccuranceCreateOrConnectWithoutRiskInput>;
  create?: InputMaybe<RiskOccuranceCreateWithoutRiskInput>;
  update?: InputMaybe<RiskOccuranceUpdateWithoutRiskInput>;
  upsert?: InputMaybe<RiskOccuranceUpsertWithoutRiskInput>;
};

export type RiskOccuranceUpdateOneWithoutProjectInterfaceNestedInput = {
  connect?: InputMaybe<RiskOccuranceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RiskOccuranceCreateOrConnectWithoutProjectInterfaceInput>;
  create?: InputMaybe<RiskOccuranceCreateWithoutProjectInterfaceInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<RiskOccuranceUpdateWithoutProjectInterfaceInput>;
  upsert?: InputMaybe<RiskOccuranceUpsertWithoutProjectInterfaceInput>;
};

export type RiskOccuranceUpdateWithoutProjectInterfaceInput = {
  Risk?: InputMaybe<RiskUpdateManyWithoutRiskOccuranceNestedInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type RiskOccuranceUpdateWithoutRiskInput = {
  ProjectInterface?: InputMaybe<ProjectInterfaceUpdateManyWithoutRiskOccuranceNestedInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type RiskOccuranceUpsertWithoutProjectInterfaceInput = {
  create: RiskOccuranceCreateWithoutProjectInterfaceInput;
  update: RiskOccuranceUpdateWithoutProjectInterfaceInput;
};

export type RiskOccuranceUpsertWithoutRiskInput = {
  create: RiskOccuranceCreateWithoutRiskInput;
  update: RiskOccuranceUpdateWithoutRiskInput;
};

export type RiskOccuranceWhereInput = {
  AND?: InputMaybe<Array<RiskOccuranceWhereInput>>;
  NOT?: InputMaybe<Array<RiskOccuranceWhereInput>>;
  OR?: InputMaybe<Array<RiskOccuranceWhereInput>>;
  ProjectInterface?: InputMaybe<ProjectInterfaceListRelationFilter>;
  Risk?: InputMaybe<RiskListRelationFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
};

export type RiskOccuranceWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type RiskOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type RiskOrderByWithRelationInput = {
  action?: InputMaybe<SortOrder>;
  cause?: InputMaybe<SortOrder>;
  consequence?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  deletedBy?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  employee?: InputMaybe<EmployeeOrderByWithRelationInput>;
  employeeId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  project?: InputMaybe<MasterOrderByWithRelationInput>;
  projectId?: InputMaybe<SortOrder>;
  riskDamagePotential?: InputMaybe<RiskDamagePotentialOrderByWithRelationInput>;
  riskDamagePotentialId?: InputMaybe<SortOrder>;
  riskId?: InputMaybe<SortOrder>;
  riskOccurance?: InputMaybe<RiskOccuranceOrderByWithRelationInput>;
  riskOccuranceId?: InputMaybe<SortOrder>;
  riskStatus?: InputMaybe<RiskStatusOrderByWithRelationInput>;
  riskStatusId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
};

export enum RiskScalarFieldEnum {
  Action = 'action',
  Cause = 'cause',
  Consequence = 'consequence',
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  DeletedAt = 'deletedAt',
  DeletedBy = 'deletedBy',
  Description = 'description',
  EmployeeId = 'employeeId',
  Id = 'id',
  Name = 'name',
  ProjectId = 'projectId',
  RiskDamagePotentialId = 'riskDamagePotentialId',
  RiskId = 'riskId',
  RiskOccuranceId = 'riskOccuranceId',
  RiskStatusId = 'riskStatusId',
  Status = 'status'
}

export type RiskScalarWhereInput = {
  AND?: InputMaybe<Array<RiskScalarWhereInput>>;
  NOT?: InputMaybe<Array<RiskScalarWhereInput>>;
  OR?: InputMaybe<Array<RiskScalarWhereInput>>;
  action?: InputMaybe<StringNullableFilter>;
  cause?: InputMaybe<StringNullableFilter>;
  consequence?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  employeeId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  projectId?: InputMaybe<StringFilter>;
  riskDamagePotentialId?: InputMaybe<StringFilter>;
  riskId?: InputMaybe<StringFilter>;
  riskOccuranceId?: InputMaybe<StringFilter>;
  riskStatusId?: InputMaybe<StringFilter>;
  status?: InputMaybe<IntNullableFilter>;
};

export type RiskStatus = {
  __typename?: 'RiskStatus';
  ProjectInterface?: Maybe<Array<ProjectInterface>>;
  Risk?: Maybe<Array<Risk>>;
  _count: RiskStatusCount;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type RiskStatusCount = {
  __typename?: 'RiskStatusCount';
  ProjectInterface: Scalars['Int'];
  Risk: Scalars['Int'];
};

export type RiskStatusCreateInput = {
  ProjectInterface?: InputMaybe<ProjectInterfaceCreateNestedManyWithoutRiskStatusInput>;
  Risk?: InputMaybe<RiskCreateNestedManyWithoutRiskStatusInput>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

export type RiskStatusCreateNestedOneWithoutProjectInterfaceInput = {
  connect?: InputMaybe<RiskStatusWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RiskStatusCreateOrConnectWithoutProjectInterfaceInput>;
  create?: InputMaybe<RiskStatusCreateWithoutProjectInterfaceInput>;
};

export type RiskStatusCreateNestedOneWithoutRiskInput = {
  connect?: InputMaybe<RiskStatusWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RiskStatusCreateOrConnectWithoutRiskInput>;
  create?: InputMaybe<RiskStatusCreateWithoutRiskInput>;
};

export type RiskStatusCreateOrConnectWithoutProjectInterfaceInput = {
  create: RiskStatusCreateWithoutProjectInterfaceInput;
  where: RiskStatusWhereUniqueInput;
};

export type RiskStatusCreateOrConnectWithoutRiskInput = {
  create: RiskStatusCreateWithoutRiskInput;
  where: RiskStatusWhereUniqueInput;
};

export type RiskStatusCreateWithoutProjectInterfaceInput = {
  Risk?: InputMaybe<RiskCreateNestedManyWithoutRiskStatusInput>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

export type RiskStatusCreateWithoutRiskInput = {
  ProjectInterface?: InputMaybe<ProjectInterfaceCreateNestedManyWithoutRiskStatusInput>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

export type RiskStatusOrderByWithRelationInput = {
  ProjectInterface?: InputMaybe<ProjectInterfaceOrderByRelationAggregateInput>;
  Risk?: InputMaybe<RiskOrderByRelationAggregateInput>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export enum RiskStatusScalarFieldEnum {
  Description = 'description',
  Id = 'id'
}

export type RiskStatusUpdateInput = {
  ProjectInterface?: InputMaybe<ProjectInterfaceUpdateManyWithoutRiskStatusNestedInput>;
  Risk?: InputMaybe<RiskUpdateManyWithoutRiskStatusNestedInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type RiskStatusUpdateOneRequiredWithoutRiskNestedInput = {
  connect?: InputMaybe<RiskStatusWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RiskStatusCreateOrConnectWithoutRiskInput>;
  create?: InputMaybe<RiskStatusCreateWithoutRiskInput>;
  update?: InputMaybe<RiskStatusUpdateWithoutRiskInput>;
  upsert?: InputMaybe<RiskStatusUpsertWithoutRiskInput>;
};

export type RiskStatusUpdateOneWithoutProjectInterfaceNestedInput = {
  connect?: InputMaybe<RiskStatusWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RiskStatusCreateOrConnectWithoutProjectInterfaceInput>;
  create?: InputMaybe<RiskStatusCreateWithoutProjectInterfaceInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<RiskStatusUpdateWithoutProjectInterfaceInput>;
  upsert?: InputMaybe<RiskStatusUpsertWithoutProjectInterfaceInput>;
};

export type RiskStatusUpdateWithoutProjectInterfaceInput = {
  Risk?: InputMaybe<RiskUpdateManyWithoutRiskStatusNestedInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type RiskStatusUpdateWithoutRiskInput = {
  ProjectInterface?: InputMaybe<ProjectInterfaceUpdateManyWithoutRiskStatusNestedInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type RiskStatusUpsertWithoutProjectInterfaceInput = {
  create: RiskStatusCreateWithoutProjectInterfaceInput;
  update: RiskStatusUpdateWithoutProjectInterfaceInput;
};

export type RiskStatusUpsertWithoutRiskInput = {
  create: RiskStatusCreateWithoutRiskInput;
  update: RiskStatusUpdateWithoutRiskInput;
};

export type RiskStatusWhereInput = {
  AND?: InputMaybe<Array<RiskStatusWhereInput>>;
  NOT?: InputMaybe<Array<RiskStatusWhereInput>>;
  OR?: InputMaybe<Array<RiskStatusWhereInput>>;
  ProjectInterface?: InputMaybe<ProjectInterfaceListRelationFilter>;
  Risk?: InputMaybe<RiskListRelationFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
};

export type RiskStatusWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type RiskUpdateInput = {
  action?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cause?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  consequence?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employee?: InputMaybe<EmployeeUpdateOneRequiredWithoutRiskNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutRiskNestedInput>;
  riskDamagePotential?: InputMaybe<RiskDamagePotentialUpdateOneRequiredWithoutRiskNestedInput>;
  riskId?: InputMaybe<StringFieldUpdateOperationsInput>;
  riskOccurance?: InputMaybe<RiskOccuranceUpdateOneRequiredWithoutRiskNestedInput>;
  riskStatus?: InputMaybe<RiskStatusUpdateOneRequiredWithoutRiskNestedInput>;
  status?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type RiskUpdateManyMutationInput = {
  action?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cause?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  consequence?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  riskId?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type RiskUpdateManyWithWhereWithoutEmployeeInput = {
  data: RiskUpdateManyMutationInput;
  where: RiskScalarWhereInput;
};

export type RiskUpdateManyWithWhereWithoutProjectInput = {
  data: RiskUpdateManyMutationInput;
  where: RiskScalarWhereInput;
};

export type RiskUpdateManyWithWhereWithoutRiskDamagePotentialInput = {
  data: RiskUpdateManyMutationInput;
  where: RiskScalarWhereInput;
};

export type RiskUpdateManyWithWhereWithoutRiskOccuranceInput = {
  data: RiskUpdateManyMutationInput;
  where: RiskScalarWhereInput;
};

export type RiskUpdateManyWithWhereWithoutRiskStatusInput = {
  data: RiskUpdateManyMutationInput;
  where: RiskScalarWhereInput;
};

export type RiskUpdateManyWithoutEmployeeNestedInput = {
  connect?: InputMaybe<Array<RiskWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RiskCreateOrConnectWithoutEmployeeInput>>;
  create?: InputMaybe<Array<RiskCreateWithoutEmployeeInput>>;
  createMany?: InputMaybe<RiskCreateManyEmployeeInputEnvelope>;
  delete?: InputMaybe<Array<RiskWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RiskScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RiskWhereUniqueInput>>;
  set?: InputMaybe<Array<RiskWhereUniqueInput>>;
  update?: InputMaybe<Array<RiskUpdateWithWhereUniqueWithoutEmployeeInput>>;
  updateMany?: InputMaybe<Array<RiskUpdateManyWithWhereWithoutEmployeeInput>>;
  upsert?: InputMaybe<Array<RiskUpsertWithWhereUniqueWithoutEmployeeInput>>;
};

export type RiskUpdateManyWithoutProjectNestedInput = {
  connect?: InputMaybe<Array<RiskWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RiskCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<RiskCreateWithoutProjectInput>>;
  createMany?: InputMaybe<RiskCreateManyProjectInputEnvelope>;
  delete?: InputMaybe<Array<RiskWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RiskScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RiskWhereUniqueInput>>;
  set?: InputMaybe<Array<RiskWhereUniqueInput>>;
  update?: InputMaybe<Array<RiskUpdateWithWhereUniqueWithoutProjectInput>>;
  updateMany?: InputMaybe<Array<RiskUpdateManyWithWhereWithoutProjectInput>>;
  upsert?: InputMaybe<Array<RiskUpsertWithWhereUniqueWithoutProjectInput>>;
};

export type RiskUpdateManyWithoutRiskDamagePotentialNestedInput = {
  connect?: InputMaybe<Array<RiskWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RiskCreateOrConnectWithoutRiskDamagePotentialInput>>;
  create?: InputMaybe<Array<RiskCreateWithoutRiskDamagePotentialInput>>;
  createMany?: InputMaybe<RiskCreateManyRiskDamagePotentialInputEnvelope>;
  delete?: InputMaybe<Array<RiskWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RiskScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RiskWhereUniqueInput>>;
  set?: InputMaybe<Array<RiskWhereUniqueInput>>;
  update?: InputMaybe<Array<RiskUpdateWithWhereUniqueWithoutRiskDamagePotentialInput>>;
  updateMany?: InputMaybe<Array<RiskUpdateManyWithWhereWithoutRiskDamagePotentialInput>>;
  upsert?: InputMaybe<Array<RiskUpsertWithWhereUniqueWithoutRiskDamagePotentialInput>>;
};

export type RiskUpdateManyWithoutRiskOccuranceNestedInput = {
  connect?: InputMaybe<Array<RiskWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RiskCreateOrConnectWithoutRiskOccuranceInput>>;
  create?: InputMaybe<Array<RiskCreateWithoutRiskOccuranceInput>>;
  createMany?: InputMaybe<RiskCreateManyRiskOccuranceInputEnvelope>;
  delete?: InputMaybe<Array<RiskWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RiskScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RiskWhereUniqueInput>>;
  set?: InputMaybe<Array<RiskWhereUniqueInput>>;
  update?: InputMaybe<Array<RiskUpdateWithWhereUniqueWithoutRiskOccuranceInput>>;
  updateMany?: InputMaybe<Array<RiskUpdateManyWithWhereWithoutRiskOccuranceInput>>;
  upsert?: InputMaybe<Array<RiskUpsertWithWhereUniqueWithoutRiskOccuranceInput>>;
};

export type RiskUpdateManyWithoutRiskStatusNestedInput = {
  connect?: InputMaybe<Array<RiskWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RiskCreateOrConnectWithoutRiskStatusInput>>;
  create?: InputMaybe<Array<RiskCreateWithoutRiskStatusInput>>;
  createMany?: InputMaybe<RiskCreateManyRiskStatusInputEnvelope>;
  delete?: InputMaybe<Array<RiskWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RiskScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RiskWhereUniqueInput>>;
  set?: InputMaybe<Array<RiskWhereUniqueInput>>;
  update?: InputMaybe<Array<RiskUpdateWithWhereUniqueWithoutRiskStatusInput>>;
  updateMany?: InputMaybe<Array<RiskUpdateManyWithWhereWithoutRiskStatusInput>>;
  upsert?: InputMaybe<Array<RiskUpsertWithWhereUniqueWithoutRiskStatusInput>>;
};

export type RiskUpdateWithWhereUniqueWithoutEmployeeInput = {
  data: RiskUpdateWithoutEmployeeInput;
  where: RiskWhereUniqueInput;
};

export type RiskUpdateWithWhereUniqueWithoutProjectInput = {
  data: RiskUpdateWithoutProjectInput;
  where: RiskWhereUniqueInput;
};

export type RiskUpdateWithWhereUniqueWithoutRiskDamagePotentialInput = {
  data: RiskUpdateWithoutRiskDamagePotentialInput;
  where: RiskWhereUniqueInput;
};

export type RiskUpdateWithWhereUniqueWithoutRiskOccuranceInput = {
  data: RiskUpdateWithoutRiskOccuranceInput;
  where: RiskWhereUniqueInput;
};

export type RiskUpdateWithWhereUniqueWithoutRiskStatusInput = {
  data: RiskUpdateWithoutRiskStatusInput;
  where: RiskWhereUniqueInput;
};

export type RiskUpdateWithoutEmployeeInput = {
  action?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cause?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  consequence?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutRiskNestedInput>;
  riskDamagePotential?: InputMaybe<RiskDamagePotentialUpdateOneRequiredWithoutRiskNestedInput>;
  riskId?: InputMaybe<StringFieldUpdateOperationsInput>;
  riskOccurance?: InputMaybe<RiskOccuranceUpdateOneRequiredWithoutRiskNestedInput>;
  riskStatus?: InputMaybe<RiskStatusUpdateOneRequiredWithoutRiskNestedInput>;
  status?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type RiskUpdateWithoutProjectInput = {
  action?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cause?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  consequence?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employee?: InputMaybe<EmployeeUpdateOneRequiredWithoutRiskNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  riskDamagePotential?: InputMaybe<RiskDamagePotentialUpdateOneRequiredWithoutRiskNestedInput>;
  riskId?: InputMaybe<StringFieldUpdateOperationsInput>;
  riskOccurance?: InputMaybe<RiskOccuranceUpdateOneRequiredWithoutRiskNestedInput>;
  riskStatus?: InputMaybe<RiskStatusUpdateOneRequiredWithoutRiskNestedInput>;
  status?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type RiskUpdateWithoutRiskDamagePotentialInput = {
  action?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cause?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  consequence?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employee?: InputMaybe<EmployeeUpdateOneRequiredWithoutRiskNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutRiskNestedInput>;
  riskId?: InputMaybe<StringFieldUpdateOperationsInput>;
  riskOccurance?: InputMaybe<RiskOccuranceUpdateOneRequiredWithoutRiskNestedInput>;
  riskStatus?: InputMaybe<RiskStatusUpdateOneRequiredWithoutRiskNestedInput>;
  status?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type RiskUpdateWithoutRiskOccuranceInput = {
  action?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cause?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  consequence?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employee?: InputMaybe<EmployeeUpdateOneRequiredWithoutRiskNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutRiskNestedInput>;
  riskDamagePotential?: InputMaybe<RiskDamagePotentialUpdateOneRequiredWithoutRiskNestedInput>;
  riskId?: InputMaybe<StringFieldUpdateOperationsInput>;
  riskStatus?: InputMaybe<RiskStatusUpdateOneRequiredWithoutRiskNestedInput>;
  status?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type RiskUpdateWithoutRiskStatusInput = {
  action?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  cause?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  consequence?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  employee?: InputMaybe<EmployeeUpdateOneRequiredWithoutRiskNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutRiskNestedInput>;
  riskDamagePotential?: InputMaybe<RiskDamagePotentialUpdateOneRequiredWithoutRiskNestedInput>;
  riskId?: InputMaybe<StringFieldUpdateOperationsInput>;
  riskOccurance?: InputMaybe<RiskOccuranceUpdateOneRequiredWithoutRiskNestedInput>;
  status?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type RiskUpsertWithWhereUniqueWithoutEmployeeInput = {
  create: RiskCreateWithoutEmployeeInput;
  update: RiskUpdateWithoutEmployeeInput;
  where: RiskWhereUniqueInput;
};

export type RiskUpsertWithWhereUniqueWithoutProjectInput = {
  create: RiskCreateWithoutProjectInput;
  update: RiskUpdateWithoutProjectInput;
  where: RiskWhereUniqueInput;
};

export type RiskUpsertWithWhereUniqueWithoutRiskDamagePotentialInput = {
  create: RiskCreateWithoutRiskDamagePotentialInput;
  update: RiskUpdateWithoutRiskDamagePotentialInput;
  where: RiskWhereUniqueInput;
};

export type RiskUpsertWithWhereUniqueWithoutRiskOccuranceInput = {
  create: RiskCreateWithoutRiskOccuranceInput;
  update: RiskUpdateWithoutRiskOccuranceInput;
  where: RiskWhereUniqueInput;
};

export type RiskUpsertWithWhereUniqueWithoutRiskStatusInput = {
  create: RiskCreateWithoutRiskStatusInput;
  update: RiskUpdateWithoutRiskStatusInput;
  where: RiskWhereUniqueInput;
};

export type RiskWhereInput = {
  AND?: InputMaybe<Array<RiskWhereInput>>;
  NOT?: InputMaybe<Array<RiskWhereInput>>;
  OR?: InputMaybe<Array<RiskWhereInput>>;
  action?: InputMaybe<StringNullableFilter>;
  cause?: InputMaybe<StringNullableFilter>;
  consequence?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  employee?: InputMaybe<EmployeeWhereInput>;
  employeeId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  project?: InputMaybe<MasterWhereInput>;
  projectId?: InputMaybe<StringFilter>;
  riskDamagePotential?: InputMaybe<RiskDamagePotentialWhereInput>;
  riskDamagePotentialId?: InputMaybe<StringFilter>;
  riskId?: InputMaybe<StringFilter>;
  riskOccurance?: InputMaybe<RiskOccuranceWhereInput>;
  riskOccuranceId?: InputMaybe<StringFilter>;
  riskStatus?: InputMaybe<RiskStatusWhereInput>;
  riskStatusId?: InputMaybe<StringFilter>;
  status?: InputMaybe<IntNullableFilter>;
};

export type RiskWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type Role = {
  __typename?: 'Role';
  _count: RoleCount;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  main: Scalars['Boolean'];
  projectResourceCapture?: Maybe<Array<ProjectResourceCapture>>;
  projectRole?: Maybe<Array<ProjectRole>>;
};

export type RoleCount = {
  __typename?: 'RoleCount';
  projectResourceCapture: Scalars['Int'];
  projectRole: Scalars['Int'];
};

export type RoleCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  main: Scalars['Boolean'];
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureCreateNestedManyWithoutRoleInput>;
  projectRole?: InputMaybe<ProjectRoleCreateNestedManyWithoutRoleInput>;
};

export type RoleCreateNestedOneWithoutProjectResourceCaptureInput = {
  connect?: InputMaybe<RoleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RoleCreateOrConnectWithoutProjectResourceCaptureInput>;
  create?: InputMaybe<RoleCreateWithoutProjectResourceCaptureInput>;
};

export type RoleCreateNestedOneWithoutProjectRoleInput = {
  connect?: InputMaybe<RoleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RoleCreateOrConnectWithoutProjectRoleInput>;
  create?: InputMaybe<RoleCreateWithoutProjectRoleInput>;
};

export type RoleCreateOrConnectWithoutProjectResourceCaptureInput = {
  create: RoleCreateWithoutProjectResourceCaptureInput;
  where: RoleWhereUniqueInput;
};

export type RoleCreateOrConnectWithoutProjectRoleInput = {
  create: RoleCreateWithoutProjectRoleInput;
  where: RoleWhereUniqueInput;
};

export type RoleCreateWithoutProjectResourceCaptureInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  main: Scalars['Boolean'];
  projectRole?: InputMaybe<ProjectRoleCreateNestedManyWithoutRoleInput>;
};

export type RoleCreateWithoutProjectRoleInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  main: Scalars['Boolean'];
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureCreateNestedManyWithoutRoleInput>;
};

export type RoleOrderByWithRelationInput = {
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  main?: InputMaybe<SortOrder>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureOrderByRelationAggregateInput>;
  projectRole?: InputMaybe<ProjectRoleOrderByRelationAggregateInput>;
};

export enum RoleScalarFieldEnum {
  Description = 'description',
  Id = 'id',
  Main = 'main'
}

export type RoleUpdateInput = {
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  main?: InputMaybe<BoolFieldUpdateOperationsInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureUpdateManyWithoutRoleNestedInput>;
  projectRole?: InputMaybe<ProjectRoleUpdateManyWithoutRoleNestedInput>;
};

export type RoleUpdateOneRequiredWithoutProjectResourceCaptureNestedInput = {
  connect?: InputMaybe<RoleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RoleCreateOrConnectWithoutProjectResourceCaptureInput>;
  create?: InputMaybe<RoleCreateWithoutProjectResourceCaptureInput>;
  update?: InputMaybe<RoleUpdateWithoutProjectResourceCaptureInput>;
  upsert?: InputMaybe<RoleUpsertWithoutProjectResourceCaptureInput>;
};

export type RoleUpdateOneRequiredWithoutProjectRoleNestedInput = {
  connect?: InputMaybe<RoleWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RoleCreateOrConnectWithoutProjectRoleInput>;
  create?: InputMaybe<RoleCreateWithoutProjectRoleInput>;
  update?: InputMaybe<RoleUpdateWithoutProjectRoleInput>;
  upsert?: InputMaybe<RoleUpsertWithoutProjectRoleInput>;
};

export type RoleUpdateWithoutProjectResourceCaptureInput = {
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  main?: InputMaybe<BoolFieldUpdateOperationsInput>;
  projectRole?: InputMaybe<ProjectRoleUpdateManyWithoutRoleNestedInput>;
};

export type RoleUpdateWithoutProjectRoleInput = {
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  main?: InputMaybe<BoolFieldUpdateOperationsInput>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureUpdateManyWithoutRoleNestedInput>;
};

export type RoleUpsertWithoutProjectResourceCaptureInput = {
  create: RoleCreateWithoutProjectResourceCaptureInput;
  update: RoleUpdateWithoutProjectResourceCaptureInput;
};

export type RoleUpsertWithoutProjectRoleInput = {
  create: RoleCreateWithoutProjectRoleInput;
  update: RoleUpdateWithoutProjectRoleInput;
};

export type RoleWhereInput = {
  AND?: InputMaybe<Array<RoleWhereInput>>;
  NOT?: InputMaybe<Array<RoleWhereInput>>;
  OR?: InputMaybe<Array<RoleWhereInput>>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  main?: InputMaybe<BoolFilter>;
  projectResourceCapture?: InputMaybe<ProjectResourceCaptureListRelationFilter>;
  projectRole?: InputMaybe<ProjectRoleListRelationFilter>;
};

export type RoleWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type SecurityGroup = {
  __typename?: 'SecurityGroup';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type SecurityGroupCreateInput = {
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type SecurityGroupOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export enum SecurityGroupScalarFieldEnum {
  Id = 'id',
  Name = 'name'
}

export type SecurityGroupUpdateInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type SecurityGroupWhereInput = {
  AND?: InputMaybe<Array<SecurityGroupWhereInput>>;
  NOT?: InputMaybe<Array<SecurityGroupWhereInput>>;
  OR?: InputMaybe<Array<SecurityGroupWhereInput>>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
};

export type SecurityGroupWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type Segment = {
  __typename?: 'Segment';
  _count: SegmentCount;
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  remarks?: Maybe<Array<Remark>>;
  segment: Scalars['String'];
};

export type SegmentCount = {
  __typename?: 'SegmentCount';
  remarks: Scalars['Int'];
};

export type SegmentCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  remarks?: InputMaybe<RemarkCreateNestedManyWithoutSegmentInput>;
  segment: Scalars['String'];
};

export type SegmentCreateNestedOneWithoutRemarksInput = {
  connect?: InputMaybe<SegmentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SegmentCreateOrConnectWithoutRemarksInput>;
  create?: InputMaybe<SegmentCreateWithoutRemarksInput>;
};

export type SegmentCreateOrConnectWithoutRemarksInput = {
  create: SegmentCreateWithoutRemarksInput;
  where: SegmentWhereUniqueInput;
};

export type SegmentCreateWithoutRemarksInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  segment: Scalars['String'];
};

export type SegmentOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  deletedBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  remarks?: InputMaybe<RemarkOrderByRelationAggregateInput>;
  segment?: InputMaybe<SortOrder>;
};

export enum SegmentScalarFieldEnum {
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  DeletedAt = 'deletedAt',
  DeletedBy = 'deletedBy',
  Id = 'id',
  Segment = 'segment'
}

export type SegmentUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  remarks?: InputMaybe<RemarkUpdateManyWithoutSegmentNestedInput>;
  segment?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type SegmentUpdateOneRequiredWithoutRemarksNestedInput = {
  connect?: InputMaybe<SegmentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SegmentCreateOrConnectWithoutRemarksInput>;
  create?: InputMaybe<SegmentCreateWithoutRemarksInput>;
  update?: InputMaybe<SegmentUpdateWithoutRemarksInput>;
  upsert?: InputMaybe<SegmentUpsertWithoutRemarksInput>;
};

export type SegmentUpdateWithoutRemarksInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  segment?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type SegmentUpsertWithoutRemarksInput = {
  create: SegmentCreateWithoutRemarksInput;
  update: SegmentUpdateWithoutRemarksInput;
};

export type SegmentWhereInput = {
  AND?: InputMaybe<Array<SegmentWhereInput>>;
  NOT?: InputMaybe<Array<SegmentWhereInput>>;
  OR?: InputMaybe<Array<SegmentWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  remarks?: InputMaybe<RemarkListRelationFilter>;
  segment?: InputMaybe<StringFilter>;
};

export type SegmentWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type SequenceStatus = {
  __typename?: 'SequenceStatus';
  _count: SequenceStatusCount;
  description?: Maybe<Scalars['String']>;
  descriptionLong?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  order?: Maybe<Scalars['Int']>;
  projectStatus?: Maybe<Array<ProjectStatus>>;
};

export type SequenceStatusCount = {
  __typename?: 'SequenceStatusCount';
  projectStatus: Scalars['Int'];
};

export type SequenceStatusCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  descriptionLong?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
  projectStatus?: InputMaybe<ProjectStatusCreateNestedManyWithoutSequenceStatusInput>;
};

export type SequenceStatusCreateNestedOneWithoutProjectStatusInput = {
  connect?: InputMaybe<SequenceStatusWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SequenceStatusCreateOrConnectWithoutProjectStatusInput>;
  create?: InputMaybe<SequenceStatusCreateWithoutProjectStatusInput>;
};

export type SequenceStatusCreateOrConnectWithoutProjectStatusInput = {
  create: SequenceStatusCreateWithoutProjectStatusInput;
  where: SequenceStatusWhereUniqueInput;
};

export type SequenceStatusCreateWithoutProjectStatusInput = {
  description?: InputMaybe<Scalars['String']>;
  descriptionLong?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  order?: InputMaybe<Scalars['Int']>;
};

export type SequenceStatusOrderByWithRelationInput = {
  description?: InputMaybe<SortOrder>;
  descriptionLong?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  order?: InputMaybe<SortOrder>;
  projectStatus?: InputMaybe<ProjectStatusOrderByRelationAggregateInput>;
};

export enum SequenceStatusScalarFieldEnum {
  Description = 'description',
  DescriptionLong = 'descriptionLong',
  Id = 'id',
  Order = 'order'
}

export type SequenceStatusUpdateInput = {
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionLong?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  projectStatus?: InputMaybe<ProjectStatusUpdateManyWithoutSequenceStatusNestedInput>;
};

export type SequenceStatusUpdateOneRequiredWithoutProjectStatusNestedInput = {
  connect?: InputMaybe<SequenceStatusWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SequenceStatusCreateOrConnectWithoutProjectStatusInput>;
  create?: InputMaybe<SequenceStatusCreateWithoutProjectStatusInput>;
  update?: InputMaybe<SequenceStatusUpdateWithoutProjectStatusInput>;
  upsert?: InputMaybe<SequenceStatusUpsertWithoutProjectStatusInput>;
};

export type SequenceStatusUpdateWithoutProjectStatusInput = {
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  descriptionLong?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type SequenceStatusUpsertWithoutProjectStatusInput = {
  create: SequenceStatusCreateWithoutProjectStatusInput;
  update: SequenceStatusUpdateWithoutProjectStatusInput;
};

export type SequenceStatusWhereInput = {
  AND?: InputMaybe<Array<SequenceStatusWhereInput>>;
  NOT?: InputMaybe<Array<SequenceStatusWhereInput>>;
  OR?: InputMaybe<Array<SequenceStatusWhereInput>>;
  description?: InputMaybe<StringNullableFilter>;
  descriptionLong?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  order?: InputMaybe<IntNullableFilter>;
  projectStatus?: InputMaybe<ProjectStatusListRelationFilter>;
};

export type SequenceStatusWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type StringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']>;
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type StringNullableFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type StringNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedStringNullableFilter>;
  _min?: InputMaybe<NestedStringNullableFilter>;
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type StringWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedStringFilter>;
  _min?: InputMaybe<NestedStringFilter>;
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  landingApplicationChanged: LandingApplication;
  landingApplicationClusterChanged: LandingApplicationCluster;
};

export type TargetedBudget = {
  __typename?: 'TargetedBudget';
  TargetedBudgetDetails?: Maybe<Array<TargetedBudgetDetails>>;
  _count: TargetedBudgetCount;
  action: Scalars['String'];
  ar: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  hawApprovedAt?: Maybe<Scalars['DateTime']>;
  hawApprovedBy?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  master: Master;
  procedure: Scalars['String'];
  projectApprovedAt?: Maybe<Scalars['DateTime']>;
  projectApprovedBy?: Maybe<Scalars['String']>;
  projectId: Scalars['String'];
  reason: Scalars['String'];
};

export type TargetedBudgetCount = {
  __typename?: 'TargetedBudgetCount';
  TargetedBudgetDetails: Scalars['Int'];
};

export type TargetedBudgetCreateInput = {
  TargetedBudgetDetails?: InputMaybe<TargetedBudgetDetailsCreateNestedManyWithoutTargetedBudgetInput>;
  action: Scalars['String'];
  ar: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  hawApprovedAt?: InputMaybe<Scalars['DateTime']>;
  hawApprovedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  master: MasterCreateNestedOneWithoutBudgetsInput;
  procedure: Scalars['String'];
  projectApprovedAt?: InputMaybe<Scalars['DateTime']>;
  projectApprovedBy?: InputMaybe<Scalars['String']>;
  reason: Scalars['String'];
};

export type TargetedBudgetCreateManyMasterInput = {
  action: Scalars['String'];
  ar: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  hawApprovedAt?: InputMaybe<Scalars['DateTime']>;
  hawApprovedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  procedure: Scalars['String'];
  projectApprovedAt?: InputMaybe<Scalars['DateTime']>;
  projectApprovedBy?: InputMaybe<Scalars['String']>;
  reason: Scalars['String'];
};

export type TargetedBudgetCreateManyMasterInputEnvelope = {
  data: Array<TargetedBudgetCreateManyMasterInput>;
};

export type TargetedBudgetCreateNestedManyWithoutMasterInput = {
  connect?: InputMaybe<Array<TargetedBudgetWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TargetedBudgetCreateOrConnectWithoutMasterInput>>;
  create?: InputMaybe<Array<TargetedBudgetCreateWithoutMasterInput>>;
  createMany?: InputMaybe<TargetedBudgetCreateManyMasterInputEnvelope>;
};

export type TargetedBudgetCreateOrConnectWithoutMasterInput = {
  create: TargetedBudgetCreateWithoutMasterInput;
  where: TargetedBudgetWhereUniqueInput;
};

export type TargetedBudgetCreateWithoutMasterInput = {
  TargetedBudgetDetails?: InputMaybe<TargetedBudgetDetailsCreateNestedManyWithoutTargetedBudgetInput>;
  action: Scalars['String'];
  ar: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  hawApprovedAt?: InputMaybe<Scalars['DateTime']>;
  hawApprovedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  procedure: Scalars['String'];
  projectApprovedAt?: InputMaybe<Scalars['DateTime']>;
  projectApprovedBy?: InputMaybe<Scalars['String']>;
  reason: Scalars['String'];
};

export type TargetedBudgetDetails = {
  __typename?: 'TargetedBudgetDetails';
  budgetNew: Scalars['Float'];
  budgetOld: Scalars['Float'];
  id: Scalars['ID'];
  targetedBudget: TargetedBudget;
  targetedBudgetId: Scalars['String'];
  targetedBudgetType: TargetedBudgetType;
  targetedBudgetTypeId: Scalars['String'];
};

export type TargetedBudgetDetailsCreateManyTargetedBudgetInput = {
  budgetNew: Scalars['Float'];
  budgetOld: Scalars['Float'];
  id?: InputMaybe<Scalars['String']>;
  targetedBudgetTypeId: Scalars['String'];
};

export type TargetedBudgetDetailsCreateManyTargetedBudgetInputEnvelope = {
  data: Array<TargetedBudgetDetailsCreateManyTargetedBudgetInput>;
};

export type TargetedBudgetDetailsCreateNestedManyWithoutTargetedBudgetInput = {
  connect?: InputMaybe<Array<TargetedBudgetDetailsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TargetedBudgetDetailsCreateOrConnectWithoutTargetedBudgetInput>>;
  create?: InputMaybe<Array<TargetedBudgetDetailsCreateWithoutTargetedBudgetInput>>;
  createMany?: InputMaybe<TargetedBudgetDetailsCreateManyTargetedBudgetInputEnvelope>;
};

export type TargetedBudgetDetailsCreateOrConnectWithoutTargetedBudgetInput = {
  create: TargetedBudgetDetailsCreateWithoutTargetedBudgetInput;
  where: TargetedBudgetDetailsWhereUniqueInput;
};

export type TargetedBudgetDetailsCreateWithoutTargetedBudgetInput = {
  budgetNew: Scalars['Float'];
  budgetOld: Scalars['Float'];
  id?: InputMaybe<Scalars['String']>;
  targetedBudgetType: TargetedBudgetTypeCreateNestedOneWithoutTargetedBudgetDetailsInput;
};

export type TargetedBudgetDetailsListRelationFilter = {
  every?: InputMaybe<TargetedBudgetDetailsWhereInput>;
  none?: InputMaybe<TargetedBudgetDetailsWhereInput>;
  some?: InputMaybe<TargetedBudgetDetailsWhereInput>;
};

export type TargetedBudgetDetailsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type TargetedBudgetDetailsScalarWhereInput = {
  AND?: InputMaybe<Array<TargetedBudgetDetailsScalarWhereInput>>;
  NOT?: InputMaybe<Array<TargetedBudgetDetailsScalarWhereInput>>;
  OR?: InputMaybe<Array<TargetedBudgetDetailsScalarWhereInput>>;
  budgetNew?: InputMaybe<FloatFilter>;
  budgetOld?: InputMaybe<FloatFilter>;
  id?: InputMaybe<StringFilter>;
  targetedBudgetId?: InputMaybe<StringFilter>;
  targetedBudgetTypeId?: InputMaybe<StringFilter>;
};

export type TargetedBudgetDetailsUpdateManyMutationInput = {
  budgetNew?: InputMaybe<FloatFieldUpdateOperationsInput>;
  budgetOld?: InputMaybe<FloatFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TargetedBudgetDetailsUpdateManyWithWhereWithoutTargetedBudgetInput = {
  data: TargetedBudgetDetailsUpdateManyMutationInput;
  where: TargetedBudgetDetailsScalarWhereInput;
};

export type TargetedBudgetDetailsUpdateManyWithoutTargetedBudgetNestedInput = {
  connect?: InputMaybe<Array<TargetedBudgetDetailsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TargetedBudgetDetailsCreateOrConnectWithoutTargetedBudgetInput>>;
  create?: InputMaybe<Array<TargetedBudgetDetailsCreateWithoutTargetedBudgetInput>>;
  createMany?: InputMaybe<TargetedBudgetDetailsCreateManyTargetedBudgetInputEnvelope>;
  delete?: InputMaybe<Array<TargetedBudgetDetailsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TargetedBudgetDetailsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TargetedBudgetDetailsWhereUniqueInput>>;
  set?: InputMaybe<Array<TargetedBudgetDetailsWhereUniqueInput>>;
  update?: InputMaybe<Array<TargetedBudgetDetailsUpdateWithWhereUniqueWithoutTargetedBudgetInput>>;
  updateMany?: InputMaybe<Array<TargetedBudgetDetailsUpdateManyWithWhereWithoutTargetedBudgetInput>>;
  upsert?: InputMaybe<Array<TargetedBudgetDetailsUpsertWithWhereUniqueWithoutTargetedBudgetInput>>;
};

export type TargetedBudgetDetailsUpdateWithWhereUniqueWithoutTargetedBudgetInput = {
  data: TargetedBudgetDetailsUpdateWithoutTargetedBudgetInput;
  where: TargetedBudgetDetailsWhereUniqueInput;
};

export type TargetedBudgetDetailsUpdateWithoutTargetedBudgetInput = {
  budgetNew?: InputMaybe<FloatFieldUpdateOperationsInput>;
  budgetOld?: InputMaybe<FloatFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  targetedBudgetType?: InputMaybe<TargetedBudgetTypeUpdateOneRequiredWithoutTargetedBudgetDetailsNestedInput>;
};

export type TargetedBudgetDetailsUpsertWithWhereUniqueWithoutTargetedBudgetInput = {
  create: TargetedBudgetDetailsCreateWithoutTargetedBudgetInput;
  update: TargetedBudgetDetailsUpdateWithoutTargetedBudgetInput;
  where: TargetedBudgetDetailsWhereUniqueInput;
};

export type TargetedBudgetDetailsWhereInput = {
  AND?: InputMaybe<Array<TargetedBudgetDetailsWhereInput>>;
  NOT?: InputMaybe<Array<TargetedBudgetDetailsWhereInput>>;
  OR?: InputMaybe<Array<TargetedBudgetDetailsWhereInput>>;
  budgetNew?: InputMaybe<FloatFilter>;
  budgetOld?: InputMaybe<FloatFilter>;
  id?: InputMaybe<StringFilter>;
  targetedBudget?: InputMaybe<TargetedBudgetWhereInput>;
  targetedBudgetId?: InputMaybe<StringFilter>;
  targetedBudgetType?: InputMaybe<TargetedBudgetTypeWhereInput>;
  targetedBudgetTypeId?: InputMaybe<StringFilter>;
};

export type TargetedBudgetDetailsWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type TargetedBudgetListRelationFilter = {
  every?: InputMaybe<TargetedBudgetWhereInput>;
  none?: InputMaybe<TargetedBudgetWhereInput>;
  some?: InputMaybe<TargetedBudgetWhereInput>;
};

export type TargetedBudgetOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type TargetedBudgetOrderByWithRelationInput = {
  TargetedBudgetDetails?: InputMaybe<TargetedBudgetDetailsOrderByRelationAggregateInput>;
  action?: InputMaybe<SortOrder>;
  ar?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  deletedBy?: InputMaybe<SortOrder>;
  hawApprovedAt?: InputMaybe<SortOrder>;
  hawApprovedBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  master?: InputMaybe<MasterOrderByWithRelationInput>;
  procedure?: InputMaybe<SortOrder>;
  projectApprovedAt?: InputMaybe<SortOrder>;
  projectApprovedBy?: InputMaybe<SortOrder>;
  projectId?: InputMaybe<SortOrder>;
  reason?: InputMaybe<SortOrder>;
};

export enum TargetedBudgetScalarFieldEnum {
  Action = 'action',
  Ar = 'ar',
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  DeletedAt = 'deletedAt',
  DeletedBy = 'deletedBy',
  HawApprovedAt = 'hawApprovedAt',
  HawApprovedBy = 'hawApprovedBy',
  Id = 'id',
  Procedure = 'procedure',
  ProjectApprovedAt = 'projectApprovedAt',
  ProjectApprovedBy = 'projectApprovedBy',
  ProjectId = 'projectId',
  Reason = 'reason'
}

export type TargetedBudgetScalarWhereInput = {
  AND?: InputMaybe<Array<TargetedBudgetScalarWhereInput>>;
  NOT?: InputMaybe<Array<TargetedBudgetScalarWhereInput>>;
  OR?: InputMaybe<Array<TargetedBudgetScalarWhereInput>>;
  action?: InputMaybe<StringFilter>;
  ar?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  hawApprovedAt?: InputMaybe<DateTimeNullableFilter>;
  hawApprovedBy?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  procedure?: InputMaybe<StringFilter>;
  projectApprovedAt?: InputMaybe<DateTimeNullableFilter>;
  projectApprovedBy?: InputMaybe<StringNullableFilter>;
  projectId?: InputMaybe<StringFilter>;
  reason?: InputMaybe<StringFilter>;
};

export type TargetedBudgetType = {
  __typename?: 'TargetedBudgetType';
  TargetedBudgetDetails?: Maybe<Array<TargetedBudgetDetails>>;
  _count: TargetedBudgetTypeCount;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type TargetedBudgetTypeCount = {
  __typename?: 'TargetedBudgetTypeCount';
  TargetedBudgetDetails: Scalars['Int'];
};

export type TargetedBudgetTypeCreateNestedOneWithoutTargetedBudgetDetailsInput = {
  connect?: InputMaybe<TargetedBudgetTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TargetedBudgetTypeCreateOrConnectWithoutTargetedBudgetDetailsInput>;
  create?: InputMaybe<TargetedBudgetTypeCreateWithoutTargetedBudgetDetailsInput>;
};

export type TargetedBudgetTypeCreateOrConnectWithoutTargetedBudgetDetailsInput = {
  create: TargetedBudgetTypeCreateWithoutTargetedBudgetDetailsInput;
  where: TargetedBudgetTypeWhereUniqueInput;
};

export type TargetedBudgetTypeCreateWithoutTargetedBudgetDetailsInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

export type TargetedBudgetTypeUpdateOneRequiredWithoutTargetedBudgetDetailsNestedInput = {
  connect?: InputMaybe<TargetedBudgetTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TargetedBudgetTypeCreateOrConnectWithoutTargetedBudgetDetailsInput>;
  create?: InputMaybe<TargetedBudgetTypeCreateWithoutTargetedBudgetDetailsInput>;
  update?: InputMaybe<TargetedBudgetTypeUpdateWithoutTargetedBudgetDetailsInput>;
  upsert?: InputMaybe<TargetedBudgetTypeUpsertWithoutTargetedBudgetDetailsInput>;
};

export type TargetedBudgetTypeUpdateWithoutTargetedBudgetDetailsInput = {
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TargetedBudgetTypeUpsertWithoutTargetedBudgetDetailsInput = {
  create: TargetedBudgetTypeCreateWithoutTargetedBudgetDetailsInput;
  update: TargetedBudgetTypeUpdateWithoutTargetedBudgetDetailsInput;
};

export type TargetedBudgetTypeWhereInput = {
  AND?: InputMaybe<Array<TargetedBudgetTypeWhereInput>>;
  NOT?: InputMaybe<Array<TargetedBudgetTypeWhereInput>>;
  OR?: InputMaybe<Array<TargetedBudgetTypeWhereInput>>;
  TargetedBudgetDetails?: InputMaybe<TargetedBudgetDetailsListRelationFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
};

export type TargetedBudgetTypeWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type TargetedBudgetUpdateInput = {
  TargetedBudgetDetails?: InputMaybe<TargetedBudgetDetailsUpdateManyWithoutTargetedBudgetNestedInput>;
  action?: InputMaybe<StringFieldUpdateOperationsInput>;
  ar?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hawApprovedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  hawApprovedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  master?: InputMaybe<MasterUpdateOneRequiredWithoutBudgetsNestedInput>;
  procedure?: InputMaybe<StringFieldUpdateOperationsInput>;
  projectApprovedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  projectApprovedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reason?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TargetedBudgetUpdateManyMutationInput = {
  action?: InputMaybe<StringFieldUpdateOperationsInput>;
  ar?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hawApprovedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  hawApprovedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  procedure?: InputMaybe<StringFieldUpdateOperationsInput>;
  projectApprovedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  projectApprovedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reason?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TargetedBudgetUpdateManyWithWhereWithoutMasterInput = {
  data: TargetedBudgetUpdateManyMutationInput;
  where: TargetedBudgetScalarWhereInput;
};

export type TargetedBudgetUpdateManyWithoutMasterNestedInput = {
  connect?: InputMaybe<Array<TargetedBudgetWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TargetedBudgetCreateOrConnectWithoutMasterInput>>;
  create?: InputMaybe<Array<TargetedBudgetCreateWithoutMasterInput>>;
  createMany?: InputMaybe<TargetedBudgetCreateManyMasterInputEnvelope>;
  delete?: InputMaybe<Array<TargetedBudgetWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TargetedBudgetScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TargetedBudgetWhereUniqueInput>>;
  set?: InputMaybe<Array<TargetedBudgetWhereUniqueInput>>;
  update?: InputMaybe<Array<TargetedBudgetUpdateWithWhereUniqueWithoutMasterInput>>;
  updateMany?: InputMaybe<Array<TargetedBudgetUpdateManyWithWhereWithoutMasterInput>>;
  upsert?: InputMaybe<Array<TargetedBudgetUpsertWithWhereUniqueWithoutMasterInput>>;
};

export type TargetedBudgetUpdateWithWhereUniqueWithoutMasterInput = {
  data: TargetedBudgetUpdateWithoutMasterInput;
  where: TargetedBudgetWhereUniqueInput;
};

export type TargetedBudgetUpdateWithoutMasterInput = {
  TargetedBudgetDetails?: InputMaybe<TargetedBudgetDetailsUpdateManyWithoutTargetedBudgetNestedInput>;
  action?: InputMaybe<StringFieldUpdateOperationsInput>;
  ar?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  hawApprovedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  hawApprovedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  procedure?: InputMaybe<StringFieldUpdateOperationsInput>;
  projectApprovedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  projectApprovedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  reason?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TargetedBudgetUpsertWithWhereUniqueWithoutMasterInput = {
  create: TargetedBudgetCreateWithoutMasterInput;
  update: TargetedBudgetUpdateWithoutMasterInput;
  where: TargetedBudgetWhereUniqueInput;
};

export type TargetedBudgetWhereInput = {
  AND?: InputMaybe<Array<TargetedBudgetWhereInput>>;
  NOT?: InputMaybe<Array<TargetedBudgetWhereInput>>;
  OR?: InputMaybe<Array<TargetedBudgetWhereInput>>;
  TargetedBudgetDetails?: InputMaybe<TargetedBudgetDetailsListRelationFilter>;
  action?: InputMaybe<StringFilter>;
  ar?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  hawApprovedAt?: InputMaybe<DateTimeNullableFilter>;
  hawApprovedBy?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  master?: InputMaybe<MasterWhereInput>;
  procedure?: InputMaybe<StringFilter>;
  projectApprovedAt?: InputMaybe<DateTimeNullableFilter>;
  projectApprovedBy?: InputMaybe<StringNullableFilter>;
  projectId?: InputMaybe<StringFilter>;
  reason?: InputMaybe<StringFilter>;
};

export type TargetedBudgetWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type Template = {
  __typename?: 'Template';
  _count: TemplateCount;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  templateDocuments?: Maybe<Array<TemplateDocuments>>;
};

export type TemplateCount = {
  __typename?: 'TemplateCount';
  templateDocuments: Scalars['Int'];
};

export type TemplateCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  templateDocuments?: InputMaybe<TemplateDocumentsCreateNestedManyWithoutTemplateInput>;
};

export type TemplateCreateNestedOneWithoutTemplateDocumentsInput = {
  connect?: InputMaybe<TemplateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TemplateCreateOrConnectWithoutTemplateDocumentsInput>;
  create?: InputMaybe<TemplateCreateWithoutTemplateDocumentsInput>;
};

export type TemplateCreateOrConnectWithoutTemplateDocumentsInput = {
  create: TemplateCreateWithoutTemplateDocumentsInput;
  where: TemplateWhereUniqueInput;
};

export type TemplateCreateWithoutTemplateDocumentsInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

export type TemplateDocuments = {
  __typename?: 'TemplateDocuments';
  createdAt: Scalars['DateTime'];
  createdBy: Scalars['String'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  template: Template;
  templateId: Scalars['String'];
  uri: Scalars['String'];
};

export type TemplateDocumentsCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  template: TemplateCreateNestedOneWithoutTemplateDocumentsInput;
  uri: Scalars['String'];
};

export type TemplateDocumentsCreateManyTemplateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  uri: Scalars['String'];
};

export type TemplateDocumentsCreateManyTemplateInputEnvelope = {
  data: Array<TemplateDocumentsCreateManyTemplateInput>;
};

export type TemplateDocumentsCreateNestedManyWithoutTemplateInput = {
  connect?: InputMaybe<Array<TemplateDocumentsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TemplateDocumentsCreateOrConnectWithoutTemplateInput>>;
  create?: InputMaybe<Array<TemplateDocumentsCreateWithoutTemplateInput>>;
  createMany?: InputMaybe<TemplateDocumentsCreateManyTemplateInputEnvelope>;
};

export type TemplateDocumentsCreateOrConnectWithoutTemplateInput = {
  create: TemplateDocumentsCreateWithoutTemplateInput;
  where: TemplateDocumentsWhereUniqueInput;
};

export type TemplateDocumentsCreateWithoutTemplateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy: Scalars['String'];
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  uri: Scalars['String'];
};

export type TemplateDocumentsListRelationFilter = {
  every?: InputMaybe<TemplateDocumentsWhereInput>;
  none?: InputMaybe<TemplateDocumentsWhereInput>;
  some?: InputMaybe<TemplateDocumentsWhereInput>;
};

export type TemplateDocumentsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type TemplateDocumentsOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  deletedBy?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  template?: InputMaybe<TemplateOrderByWithRelationInput>;
  templateId?: InputMaybe<SortOrder>;
  uri?: InputMaybe<SortOrder>;
};

export enum TemplateDocumentsScalarFieldEnum {
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  DeletedAt = 'deletedAt',
  DeletedBy = 'deletedBy',
  Description = 'description',
  Id = 'id',
  Name = 'name',
  TemplateId = 'templateId',
  Uri = 'uri'
}

export type TemplateDocumentsScalarWhereInput = {
  AND?: InputMaybe<Array<TemplateDocumentsScalarWhereInput>>;
  NOT?: InputMaybe<Array<TemplateDocumentsScalarWhereInput>>;
  OR?: InputMaybe<Array<TemplateDocumentsScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  templateId?: InputMaybe<StringFilter>;
  uri?: InputMaybe<StringFilter>;
};

export type TemplateDocumentsUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  template?: InputMaybe<TemplateUpdateOneRequiredWithoutTemplateDocumentsNestedInput>;
  uri?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TemplateDocumentsUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  uri?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TemplateDocumentsUpdateManyWithWhereWithoutTemplateInput = {
  data: TemplateDocumentsUpdateManyMutationInput;
  where: TemplateDocumentsScalarWhereInput;
};

export type TemplateDocumentsUpdateManyWithoutTemplateNestedInput = {
  connect?: InputMaybe<Array<TemplateDocumentsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TemplateDocumentsCreateOrConnectWithoutTemplateInput>>;
  create?: InputMaybe<Array<TemplateDocumentsCreateWithoutTemplateInput>>;
  createMany?: InputMaybe<TemplateDocumentsCreateManyTemplateInputEnvelope>;
  delete?: InputMaybe<Array<TemplateDocumentsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TemplateDocumentsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TemplateDocumentsWhereUniqueInput>>;
  set?: InputMaybe<Array<TemplateDocumentsWhereUniqueInput>>;
  update?: InputMaybe<Array<TemplateDocumentsUpdateWithWhereUniqueWithoutTemplateInput>>;
  updateMany?: InputMaybe<Array<TemplateDocumentsUpdateManyWithWhereWithoutTemplateInput>>;
  upsert?: InputMaybe<Array<TemplateDocumentsUpsertWithWhereUniqueWithoutTemplateInput>>;
};

export type TemplateDocumentsUpdateWithWhereUniqueWithoutTemplateInput = {
  data: TemplateDocumentsUpdateWithoutTemplateInput;
  where: TemplateDocumentsWhereUniqueInput;
};

export type TemplateDocumentsUpdateWithoutTemplateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<StringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  uri?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TemplateDocumentsUpsertWithWhereUniqueWithoutTemplateInput = {
  create: TemplateDocumentsCreateWithoutTemplateInput;
  update: TemplateDocumentsUpdateWithoutTemplateInput;
  where: TemplateDocumentsWhereUniqueInput;
};

export type TemplateDocumentsWhereInput = {
  AND?: InputMaybe<Array<TemplateDocumentsWhereInput>>;
  NOT?: InputMaybe<Array<TemplateDocumentsWhereInput>>;
  OR?: InputMaybe<Array<TemplateDocumentsWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  template?: InputMaybe<TemplateWhereInput>;
  templateId?: InputMaybe<StringFilter>;
  uri?: InputMaybe<StringFilter>;
};

export type TemplateDocumentsWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type TemplateOrderByWithRelationInput = {
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  templateDocuments?: InputMaybe<TemplateDocumentsOrderByRelationAggregateInput>;
};

export enum TemplateScalarFieldEnum {
  Description = 'description',
  Id = 'id'
}

export type TemplateUpdateInput = {
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  templateDocuments?: InputMaybe<TemplateDocumentsUpdateManyWithoutTemplateNestedInput>;
};

export type TemplateUpdateOneRequiredWithoutTemplateDocumentsNestedInput = {
  connect?: InputMaybe<TemplateWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TemplateCreateOrConnectWithoutTemplateDocumentsInput>;
  create?: InputMaybe<TemplateCreateWithoutTemplateDocumentsInput>;
  update?: InputMaybe<TemplateUpdateWithoutTemplateDocumentsInput>;
  upsert?: InputMaybe<TemplateUpsertWithoutTemplateDocumentsInput>;
};

export type TemplateUpdateWithoutTemplateDocumentsInput = {
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TemplateUpsertWithoutTemplateDocumentsInput = {
  create: TemplateCreateWithoutTemplateDocumentsInput;
  update: TemplateUpdateWithoutTemplateDocumentsInput;
};

export type TemplateWhereInput = {
  AND?: InputMaybe<Array<TemplateWhereInput>>;
  NOT?: InputMaybe<Array<TemplateWhereInput>>;
  OR?: InputMaybe<Array<TemplateWhereInput>>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  templateDocuments?: InputMaybe<TemplateDocumentsListRelationFilter>;
};

export type TemplateWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type TopProjects = {
  __typename?: 'TopProjects';
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  deletedBy?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  project: Master;
  projectId: Scalars['String'];
};

export type TopProjectsCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  project: MasterCreateNestedOneWithoutTopProjectsInput;
};

export type TopProjectsCreateManyProjectInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type TopProjectsCreateManyProjectInputEnvelope = {
  data: Array<TopProjectsCreateManyProjectInput>;
};

export type TopProjectsCreateNestedManyWithoutProjectInput = {
  connect?: InputMaybe<Array<TopProjectsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TopProjectsCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<TopProjectsCreateWithoutProjectInput>>;
  createMany?: InputMaybe<TopProjectsCreateManyProjectInputEnvelope>;
};

export type TopProjectsCreateOrConnectWithoutProjectInput = {
  create: TopProjectsCreateWithoutProjectInput;
  where: TopProjectsWhereUniqueInput;
};

export type TopProjectsCreateWithoutProjectInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  createdBy?: InputMaybe<Scalars['String']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  deletedBy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type TopProjectsListRelationFilter = {
  every?: InputMaybe<TopProjectsWhereInput>;
  none?: InputMaybe<TopProjectsWhereInput>;
  some?: InputMaybe<TopProjectsWhereInput>;
};

export type TopProjectsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type TopProjectsOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  createdBy?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrder>;
  deletedBy?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  project?: InputMaybe<MasterOrderByWithRelationInput>;
  projectId?: InputMaybe<SortOrder>;
};

export enum TopProjectsScalarFieldEnum {
  CreatedAt = 'createdAt',
  CreatedBy = 'createdBy',
  DeletedAt = 'deletedAt',
  DeletedBy = 'deletedBy',
  Id = 'id',
  ProjectId = 'projectId'
}

export type TopProjectsScalarWhereInput = {
  AND?: InputMaybe<Array<TopProjectsScalarWhereInput>>;
  NOT?: InputMaybe<Array<TopProjectsScalarWhereInput>>;
  OR?: InputMaybe<Array<TopProjectsScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  projectId?: InputMaybe<StringFilter>;
};

export type TopProjectsUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  project?: InputMaybe<MasterUpdateOneRequiredWithoutTopProjectsNestedInput>;
};

export type TopProjectsUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TopProjectsUpdateManyWithWhereWithoutProjectInput = {
  data: TopProjectsUpdateManyMutationInput;
  where: TopProjectsScalarWhereInput;
};

export type TopProjectsUpdateManyWithoutProjectNestedInput = {
  connect?: InputMaybe<Array<TopProjectsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TopProjectsCreateOrConnectWithoutProjectInput>>;
  create?: InputMaybe<Array<TopProjectsCreateWithoutProjectInput>>;
  createMany?: InputMaybe<TopProjectsCreateManyProjectInputEnvelope>;
  delete?: InputMaybe<Array<TopProjectsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TopProjectsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TopProjectsWhereUniqueInput>>;
  set?: InputMaybe<Array<TopProjectsWhereUniqueInput>>;
  update?: InputMaybe<Array<TopProjectsUpdateWithWhereUniqueWithoutProjectInput>>;
  updateMany?: InputMaybe<Array<TopProjectsUpdateManyWithWhereWithoutProjectInput>>;
  upsert?: InputMaybe<Array<TopProjectsUpsertWithWhereUniqueWithoutProjectInput>>;
};

export type TopProjectsUpdateWithWhereUniqueWithoutProjectInput = {
  data: TopProjectsUpdateWithoutProjectInput;
  where: TopProjectsWhereUniqueInput;
};

export type TopProjectsUpdateWithoutProjectInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  createdBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deletedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TopProjectsUpsertWithWhereUniqueWithoutProjectInput = {
  create: TopProjectsCreateWithoutProjectInput;
  update: TopProjectsUpdateWithoutProjectInput;
  where: TopProjectsWhereUniqueInput;
};

export type TopProjectsWhereInput = {
  AND?: InputMaybe<Array<TopProjectsWhereInput>>;
  NOT?: InputMaybe<Array<TopProjectsWhereInput>>;
  OR?: InputMaybe<Array<TopProjectsWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  createdBy?: InputMaybe<StringNullableFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  deletedBy?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  project?: InputMaybe<MasterWhereInput>;
  projectId?: InputMaybe<StringFilter>;
};

export type TopProjectsWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type MasterDetailsFragment = { __typename?: 'Master', id: string, createdAt: Date, createdBy: string, projectDocuments?: Array<{ __typename?: 'ProjectDocuments', id: string, name: string, description?: string | null | undefined, uri: string }> | null | undefined, goals?: Array<{ __typename?: 'GoalsOnMaster', goal: { __typename?: 'Goal', id: string, description?: string | null | undefined } }> | null | undefined, projectDescriptions?: Array<{ __typename?: 'ProjectDescription', background?: string | null | undefined, description?: string | null | undefined, name: string, category?: string | null | undefined, deletedBy?: string | null | undefined, id: string, planing?: string | null | undefined, procedure?: string | null | undefined, comments?: string | null | undefined, projectDuration?: number | null | undefined, projectStart?: Date | null | undefined, method?: { __typename?: 'Method', methodName: string } | null | undefined, projectType: { __typename?: 'ProjectType', id: string, projectType: string, projectTypeSub?: string | null | undefined } }> | null | undefined, projectApproval?: Array<{ __typename?: 'ProjectApproval', id: string, comment?: string | null | undefined, deletedBy?: string | null | undefined, approvalBoardId: string, approvalStatus?: { __typename?: 'ApprovalStatus', description: string, id: string } | null | undefined, ApprovalBoard: { __typename?: 'ApprovalBoard', id: string, description: string, approver?: Array<{ __typename?: 'Approver', kid: string, firstName: string, lastName: string, startDate?: Date | null | undefined, endDate?: Date | null | undefined, function?: string | null | undefined }> | null | undefined } }> | null | undefined, projectStatus?: Array<{ __typename?: 'ProjectStatus', id: string, sequenceStatusId: string, createdBy: string, deletedBy?: string | null | undefined, createdAt: Date, sequenceStatus: { __typename?: 'SequenceStatus', description?: string | null | undefined, descriptionLong?: string | null | undefined, order?: number | null | undefined } }> | null | undefined, projectRole?: Array<{ __typename?: 'ProjectRole', id: string, deletedBy?: string | null | undefined, employee: { __typename?: 'Employee', firstName?: string | null | undefined, lastName?: string | null | undefined, id: string }, role: { __typename?: 'Role', id: string } }> | null | undefined, finances?: Array<{ __typename?: 'Finance', value: number, asset: { __typename?: 'Asset', isProjectCosts: boolean } }> | null | undefined, projectAllocations?: Array<{ __typename?: 'ProjectAllocation', id: string, allocationId: string, percentage: number }> | null | undefined, remarks?: Array<{ __typename?: 'Remark', remark: string, deletedBy?: string | null | undefined, segment: { __typename?: 'Segment', segment: string } }> | null | undefined, projectInterface?: Array<{ __typename?: 'ProjectInterface', cause?: string | null | undefined, challenges?: string | null | undefined, collaboration?: string | null | undefined, createdBy: string, deletedAt?: Date | null | undefined, description?: string | null | undefined, employeeId: string, id: string, projectId: string, status?: number | null | undefined, name?: string | null | undefined }> | null | undefined };

export type GetAssetsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAssetsQuery = { __typename?: 'Query', assets: Array<{ __typename?: 'Asset', id: string, description: string, isProjectCosts: boolean }> };

export type GetLandingApplicationsQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<LandingApplicationOrderByWithRelationInput> | LandingApplicationOrderByWithRelationInput>;
  where?: InputMaybe<LandingApplicationWhereInput>;
}>;


export type GetLandingApplicationsQuery = { __typename?: 'Query', landingApplications: Array<{ __typename?: 'LandingApplication', id: string, name: string, icon?: string | null | undefined, iconLocation?: string | null | undefined, url?: string | null | undefined, tooltip?: string | null | undefined, isIframe?: boolean | null | undefined, order?: number | null | undefined, createdAt: Date, updatedAt: Date, landingApplicationGroup?: Array<{ __typename?: 'LandingApplicationGroup', groupId: string }> | null | undefined, landingApplicationClusterMapping?: Array<{ __typename?: 'LandingApplicationClusterMapping', clusterId: string, deletedBy?: string | null | undefined }> | null | undefined }> };

export type GetLandingApplicationQueryVariables = Exact<{
  where: LandingApplicationWhereUniqueInput;
}>;


export type GetLandingApplicationQuery = { __typename?: 'Query', landingApplication: { __typename?: 'LandingApplication', id: string, icon?: string | null | undefined, name: string, url?: string | null | undefined, isIframe?: boolean | null | undefined, landingApplicationGroup?: Array<{ __typename?: 'LandingApplicationGroup', groupId: string }> | null | undefined } };

export type GetCompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompaniesQuery = { __typename?: 'Query', companies: Array<{ __typename?: 'Company', id: string, description?: string | null | undefined }> };

export type GetAssetsCompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAssetsCompaniesQuery = { __typename?: 'Query', assets: Array<{ __typename?: 'Asset', id: string, isProjectCosts: boolean }>, companies: Array<{ __typename?: 'Company', id: string }> };

export type GetAllocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllocationsQuery = { __typename?: 'Query', allocations: Array<{ __typename?: 'Allocation', id: string, description?: string | null | undefined, projectAllocations?: Array<{ __typename?: 'ProjectAllocation', id: string }> | null | undefined }> };

export type GetProjectAllocationsQueryVariables = Exact<{
  projectAllocationsWhere?: InputMaybe<ProjectAllocationWhereInput>;
}>;


export type GetProjectAllocationsQuery = { __typename?: 'Query', projectAllocations: Array<{ __typename?: 'ProjectAllocation', id: string, percentage: number, allocationId: string }> };

export type UpdateProjectAllocationMutationVariables = Exact<{
  data: MasterUpdateInput;
  where: MasterWhereUniqueInput;
}>;


export type UpdateProjectAllocationMutation = { __typename?: 'Mutation', updateMaster: { __typename?: 'Master', projectAllocations?: Array<{ __typename?: 'ProjectAllocation', id: string, percentage: number, allocationId: string, projectId: string }> | null | undefined } };

export type GetProjectTypesQueryVariables = Exact<{
  where?: InputMaybe<ProjectTypeWhereInput>;
  orderBy?: InputMaybe<Array<ProjectTypeOrderByWithRelationInput> | ProjectTypeOrderByWithRelationInput>;
}>;


export type GetProjectTypesQuery = { __typename?: 'Query', projectTypes: Array<{ __typename?: 'ProjectType', id: string, projectType: string, projectTypeSub?: string | null | undefined, description?: string | null | undefined, order?: number | null | undefined }> };

export type GetGoalsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGoalsQuery = { __typename?: 'Query', goals: Array<{ __typename?: 'Goal', id: string, description?: string | null | undefined }> };

export type GetFinancesQueryVariables = Exact<{
  where?: InputMaybe<FinanceWhereInput>;
}>;


export type GetFinancesQuery = { __typename?: 'Query', finances: Array<{ __typename?: 'Finance', companyId: string, id: string, value: number, year: number, asset: { __typename?: 'Asset', id: string, isProjectCosts: boolean } }> };

export type RemoveFinanceMutationVariables = Exact<{
  where: FinanceWhereUniqueInput;
}>;


export type RemoveFinanceMutation = { __typename?: 'Mutation', removeFinance: { __typename?: 'Finance', id: string } };

export type GetFinancialQueryVariables = Exact<{
  where?: InputMaybe<FinanceWhereInput>;
}>;


export type GetFinancialQuery = { __typename?: 'Query', finances: Array<{ __typename?: 'Finance', companyId: string, id: string, value: number, year: number, asset: { __typename?: 'Asset', id: string, isProjectCosts: boolean } }>, assets: Array<{ __typename?: 'Asset', id: string, isProjectCosts: boolean }>, companies: Array<{ __typename?: 'Company', id: string }> };

export type UpdateFinanceMutationVariables = Exact<{
  data: FinanceUpdateInput;
  where: FinanceWhereUniqueInput;
}>;


export type UpdateFinanceMutation = { __typename?: 'Mutation', updateFinance: { __typename?: 'Finance', id: string, value: number } };

export type CreateFinanceMutationVariables = Exact<{
  data: FinanceCreateInput;
}>;


export type CreateFinanceMutation = { __typename?: 'Mutation', createFinance: { __typename?: 'Finance', assetId: string, companyId: string, id: string, projectId: string, value: number, year: number } };

export type GetFinancialYearsQueryVariables = Exact<{
  distinct?: InputMaybe<Array<FinanceScalarFieldEnum> | FinanceScalarFieldEnum>;
  where?: InputMaybe<FinanceWhereInput>;
}>;


export type GetFinancialYearsQuery = { __typename?: 'Query', finances: Array<{ __typename?: 'Finance', year: number }> };

export type CreateProjectShortHistoryMutationVariables = Exact<{
  data: ProjectShortHistoryCreateInput;
}>;


export type CreateProjectShortHistoryMutation = { __typename?: 'Mutation', createProjectShortHistory: { __typename?: 'ProjectShortHistory', action: string, projectId: string, id: string } };

export type GetInterfaceTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInterfaceTypesQuery = { __typename?: 'Query', interfaceTypes: Array<{ __typename?: 'InterfaceType', id: string, description?: string | null | undefined }> };

export type GetInterfaceFormatsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInterfaceFormatsQuery = { __typename?: 'Query', interfaceFormats: Array<{ __typename?: 'InterfaceFormat', id: string, description?: string | null | undefined }> };

export type GetApplicationsQueryVariables = Exact<{
  where?: InputMaybe<LeanixMappingWhereInput>;
}>;


export type GetApplicationsQuery = { __typename?: 'Query', leanixMappings: Array<{ __typename?: 'LeanixMapping', id: string, leanixId: string, description?: string | null | undefined, name?: string | null | undefined, type?: string | null | undefined }> };

export type CreateProjectDescriptionMutationVariables = Exact<{
  data: ProjectDescriptionCreateInput;
}>;


export type CreateProjectDescriptionMutation = { __typename?: 'Mutation', createProjectDescription: { __typename?: 'ProjectDescription', id: string, projectTypeId: string, description?: string | null | undefined, background?: string | null | undefined, planing?: string | null | undefined, name: string } };

export type UpdateProjectDescriptionMutationVariables = Exact<{
  data: ProjectDescriptionUpdateInput;
  where: ProjectDescriptionWhereUniqueInput;
}>;


export type UpdateProjectDescriptionMutation = { __typename?: 'Mutation', updateProjectDescription: { __typename?: 'ProjectDescription', sbk?: string | null | undefined } };

export type UpdateProjectCommentsMutationVariables = Exact<{
  data: ProjectDescriptionUpdateInput;
  where: ProjectDescriptionWhereUniqueInput;
}>;


export type UpdateProjectCommentsMutation = { __typename?: 'Mutation', updateProjectDescription: { __typename?: 'ProjectDescription', comments?: string | null | undefined, category?: string | null | undefined } };

export type GetProjectDescriptionsQueryVariables = Exact<{
  where?: InputMaybe<ProjectDescriptionWhereInput>;
}>;


export type GetProjectDescriptionsQuery = { __typename?: 'Query', projectDescriptions: Array<{ __typename?: 'ProjectDescription', id: string, sbk?: string | null | undefined }> };

export type CreateMasterMutationVariables = Exact<{
  data: MasterCreateInput;
}>;


export type CreateMasterMutation = { __typename?: 'Mutation', createMaster: { __typename?: 'Master', id: string, projectDescriptions?: Array<{ __typename?: 'ProjectDescription', name: string, description?: string | null | undefined }> | null | undefined } };

export type CreateProjectStatusMutationVariables = Exact<{
  data: ProjectStatusCreateInput;
}>;


export type CreateProjectStatusMutation = { __typename?: 'Mutation', createProjectStatus: { __typename?: 'ProjectStatus', id: string, projectId: string } };

export type UpdateProjectStatusMutationVariables = Exact<{
  data: ProjectStatusUpdateInput;
  where: ProjectStatusWhereUniqueInput;
}>;


export type UpdateProjectStatusMutation = { __typename?: 'Mutation', updateProjectStatus: { __typename?: 'ProjectStatus', id: string, projectId: string } };

export type UpdateProjectRoleMutationVariables = Exact<{
  data: ProjectRoleUpdateInput;
  where: ProjectRoleWhereUniqueInput;
}>;


export type UpdateProjectRoleMutation = { __typename?: 'Mutation', updateProjectRole: { __typename?: 'ProjectRole', id: string } };

export type CreateGoalsOnMasterMutationVariables = Exact<{
  data: GoalsOnMasterCreateInput;
}>;


export type CreateGoalsOnMasterMutation = { __typename?: 'Mutation', createGoalsOnMaster: { __typename?: 'GoalsOnMaster', id: string } };

export type CreateProjectDocumentMutationVariables = Exact<{
  data: ProjectDocumentsCreateInput;
  file: Scalars['Upload'];
}>;


export type CreateProjectDocumentMutation = { __typename?: 'Mutation', createProjectDocument: { __typename?: 'ProjectDocuments', id: string, uri: string } };

export type RemoveProjectDocumentMutationVariables = Exact<{
  where: ProjectDocumentsWhereUniqueInput;
}>;


export type RemoveProjectDocumentMutation = { __typename?: 'Mutation', removeProjectDocument: { __typename?: 'ProjectDocuments', id: string } };

export type GetProjectsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetProjectsQuery = { __typename?: 'Query', masters: Array<{ __typename?: 'Master', id: string, createdAt: Date, projectDescriptions?: Array<{ __typename?: 'ProjectDescription', id: string, name: string, description?: string | null | undefined }> | null | undefined, projectStatus?: Array<{ __typename?: 'ProjectStatus', sequenceStatusId: string }> | null | undefined }> };

export type GetApprovalBoardsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetApprovalBoardsQuery = { __typename?: 'Query', approvalBoards: Array<{ __typename?: 'ApprovalBoard', id: string, description: string }> };

export type GetMasterWithApprovalsQueryVariables = Exact<{
  where?: InputMaybe<MasterWhereInput>;
}>;


export type GetMasterWithApprovalsQuery = { __typename?: 'Query', masters: Array<{ __typename?: 'Master', id: string, projectApproval?: Array<{ __typename?: 'ProjectApproval', id: string, ApprovalBoard: { __typename?: 'ApprovalBoard', id: string, description: string }, approvalStatus?: { __typename?: 'ApprovalStatus', id: string, description: string } | null | undefined }> | null | undefined, projectStatus?: Array<{ __typename?: 'ProjectStatus', id: string, sequenceStatusId: string, deletedBy?: string | null | undefined }> | null | undefined, projectDescriptions?: Array<{ __typename?: 'ProjectDescription', name: string }> | null | undefined }> };

export type GetProjectsByStatusQueryVariables = Exact<{
  where?: InputMaybe<MasterWhereInput>;
}>;


export type GetProjectsByStatusQuery = { __typename?: 'Query', masters: Array<{ __typename?: 'Master', id: string, createdAt: Date, createdBy: string, projectDescriptions?: Array<{ __typename?: 'ProjectDescription', id: string, name: string, description?: string | null | undefined }> | null | undefined, projectStatus?: Array<{ __typename?: 'ProjectStatus', id: string, sequenceStatusId: string, deletedBy?: string | null | undefined }> | null | undefined }> };

export type GetMailInfoByProjectQueryVariables = Exact<{
  where: MasterWhereUniqueInput;
  where2?: InputMaybe<EmployeeMasterWhereInput>;
}>;


export type GetMailInfoByProjectQuery = { __typename?: 'Query', master: { __typename?: 'Master', projectDescriptions?: Array<{ __typename?: 'ProjectDescription', name: string }> | null | undefined }, employeeMasters: Array<{ __typename?: 'EmployeeMaster', employee: { __typename?: 'Employee', firstName?: string | null | undefined, lastName?: string | null | undefined, email?: string | null | undefined } }> };

export type DashboardGetFilteredProjectsQueryVariables = Exact<{
  projectStatus?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  projectDescriptions?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type DashboardGetFilteredProjectsQuery = { __typename?: 'Query', masters: Array<{ __typename?: 'Master', id: string, createdAt: Date, createdBy: string, projectDocuments?: Array<{ __typename?: 'ProjectDocuments', id: string, name: string, description?: string | null | undefined, uri: string }> | null | undefined, goals?: Array<{ __typename?: 'GoalsOnMaster', goal: { __typename?: 'Goal', id: string, description?: string | null | undefined } }> | null | undefined, projectDescriptions?: Array<{ __typename?: 'ProjectDescription', background?: string | null | undefined, description?: string | null | undefined, name: string, category?: string | null | undefined, deletedBy?: string | null | undefined, id: string, planing?: string | null | undefined, procedure?: string | null | undefined, comments?: string | null | undefined, projectDuration?: number | null | undefined, projectStart?: Date | null | undefined, method?: { __typename?: 'Method', methodName: string } | null | undefined, projectType: { __typename?: 'ProjectType', id: string, projectType: string, projectTypeSub?: string | null | undefined } }> | null | undefined, projectApproval?: Array<{ __typename?: 'ProjectApproval', id: string, comment?: string | null | undefined, deletedBy?: string | null | undefined, approvalBoardId: string, approvalStatus?: { __typename?: 'ApprovalStatus', description: string, id: string } | null | undefined, ApprovalBoard: { __typename?: 'ApprovalBoard', id: string, description: string, approver?: Array<{ __typename?: 'Approver', kid: string, firstName: string, lastName: string, startDate?: Date | null | undefined, endDate?: Date | null | undefined, function?: string | null | undefined }> | null | undefined } }> | null | undefined, projectStatus?: Array<{ __typename?: 'ProjectStatus', id: string, sequenceStatusId: string, createdBy: string, deletedBy?: string | null | undefined, createdAt: Date, sequenceStatus: { __typename?: 'SequenceStatus', description?: string | null | undefined, descriptionLong?: string | null | undefined, order?: number | null | undefined } }> | null | undefined, projectRole?: Array<{ __typename?: 'ProjectRole', id: string, deletedBy?: string | null | undefined, employee: { __typename?: 'Employee', firstName?: string | null | undefined, lastName?: string | null | undefined, id: string }, role: { __typename?: 'Role', id: string } }> | null | undefined, finances?: Array<{ __typename?: 'Finance', value: number, asset: { __typename?: 'Asset', isProjectCosts: boolean } }> | null | undefined, projectAllocations?: Array<{ __typename?: 'ProjectAllocation', id: string, allocationId: string, percentage: number }> | null | undefined, remarks?: Array<{ __typename?: 'Remark', remark: string, deletedBy?: string | null | undefined, segment: { __typename?: 'Segment', segment: string } }> | null | undefined, projectInterface?: Array<{ __typename?: 'ProjectInterface', cause?: string | null | undefined, challenges?: string | null | undefined, collaboration?: string | null | undefined, createdBy: string, deletedAt?: Date | null | undefined, description?: string | null | undefined, employeeId: string, id: string, projectId: string, status?: number | null | undefined, name?: string | null | undefined }> | null | undefined }> };

export type DashboardGetFilteredProjectsByResourceQueryVariables = Exact<{
  projectStatus?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  projectEmployee?: InputMaybe<Scalars['String']>;
}>;


export type DashboardGetFilteredProjectsByResourceQuery = { __typename?: 'Query', masters: Array<{ __typename?: 'Master', id: string, projectDescriptions?: Array<{ __typename?: 'ProjectDescription', name: string, background?: string | null | undefined, deletedBy?: string | null | undefined }> | null | undefined, projectStatus?: Array<{ __typename?: 'ProjectStatus', sequenceStatusId: string, deletedBy?: string | null | undefined }> | null | undefined, projectRole?: Array<{ __typename?: 'ProjectRole', role: { __typename?: 'Role', id: string }, employee: { __typename?: 'Employee', lastName?: string | null | undefined } }> | null | undefined }> };

export type DashboardGetProjectByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type DashboardGetProjectByIdQuery = { __typename?: 'Query', masters: Array<{ __typename?: 'Master', id: string, createdAt: Date, createdBy: string, projectDocuments?: Array<{ __typename?: 'ProjectDocuments', id: string, name: string, description?: string | null | undefined, uri: string }> | null | undefined, goals?: Array<{ __typename?: 'GoalsOnMaster', goal: { __typename?: 'Goal', id: string, description?: string | null | undefined } }> | null | undefined, projectDescriptions?: Array<{ __typename?: 'ProjectDescription', background?: string | null | undefined, description?: string | null | undefined, name: string, category?: string | null | undefined, deletedBy?: string | null | undefined, id: string, planing?: string | null | undefined, procedure?: string | null | undefined, comments?: string | null | undefined, projectDuration?: number | null | undefined, projectStart?: Date | null | undefined, method?: { __typename?: 'Method', methodName: string } | null | undefined, projectType: { __typename?: 'ProjectType', id: string, projectType: string, projectTypeSub?: string | null | undefined } }> | null | undefined, projectApproval?: Array<{ __typename?: 'ProjectApproval', id: string, comment?: string | null | undefined, deletedBy?: string | null | undefined, approvalBoardId: string, approvalStatus?: { __typename?: 'ApprovalStatus', description: string, id: string } | null | undefined, ApprovalBoard: { __typename?: 'ApprovalBoard', id: string, description: string, approver?: Array<{ __typename?: 'Approver', kid: string, firstName: string, lastName: string, startDate?: Date | null | undefined, endDate?: Date | null | undefined, function?: string | null | undefined }> | null | undefined } }> | null | undefined, projectStatus?: Array<{ __typename?: 'ProjectStatus', id: string, sequenceStatusId: string, createdBy: string, deletedBy?: string | null | undefined, createdAt: Date, sequenceStatus: { __typename?: 'SequenceStatus', description?: string | null | undefined, descriptionLong?: string | null | undefined, order?: number | null | undefined } }> | null | undefined, projectRole?: Array<{ __typename?: 'ProjectRole', id: string, deletedBy?: string | null | undefined, employee: { __typename?: 'Employee', firstName?: string | null | undefined, lastName?: string | null | undefined, id: string }, role: { __typename?: 'Role', id: string } }> | null | undefined, finances?: Array<{ __typename?: 'Finance', value: number, asset: { __typename?: 'Asset', isProjectCosts: boolean } }> | null | undefined, projectAllocations?: Array<{ __typename?: 'ProjectAllocation', id: string, allocationId: string, percentage: number }> | null | undefined, remarks?: Array<{ __typename?: 'Remark', remark: string, deletedBy?: string | null | undefined, segment: { __typename?: 'Segment', segment: string } }> | null | undefined, projectInterface?: Array<{ __typename?: 'ProjectInterface', cause?: string | null | undefined, challenges?: string | null | undefined, collaboration?: string | null | undefined, createdBy: string, deletedAt?: Date | null | undefined, description?: string | null | undefined, employeeId: string, id: string, projectId: string, status?: number | null | undefined, name?: string | null | undefined }> | null | undefined }> };

export type GetEmployeeByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetEmployeeByIdQuery = { __typename?: 'Query', employee: { __typename?: 'Employee', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, email?: string | null | undefined } };

export type UpdateApprovalStatusMutationVariables = Exact<{
  data: MasterUpdateInput;
  projectId: Scalars['String'];
}>;


export type UpdateApprovalStatusMutation = { __typename?: 'Mutation', updateMaster: { __typename?: 'Master', id: string } };

export type GetFinancesByProjectQueryVariables = Exact<{
  where?: InputMaybe<FinanceWhereInput>;
  orderBy?: InputMaybe<Array<FinanceOrderByWithRelationInput> | FinanceOrderByWithRelationInput>;
}>;


export type GetFinancesByProjectQuery = { __typename?: 'Query', finances: Array<{ __typename?: 'Finance', id: string, value: number, year: number, asset: { __typename?: 'Asset', id: string, isProjectCosts: boolean }, company: { __typename?: 'Company', id: string } }> };

export type GetFinancialByProjectQueryVariables = Exact<{
  where?: InputMaybe<FinanceWhereInput>;
  financeOrderBy?: InputMaybe<Array<FinanceOrderByWithRelationInput> | FinanceOrderByWithRelationInput>;
  assetsOrderBy?: InputMaybe<Array<AssetOrderByWithRelationInput> | AssetOrderByWithRelationInput>;
  companiesOrderBy?: InputMaybe<Array<CompanyOrderByWithRelationInput> | CompanyOrderByWithRelationInput>;
}>;


export type GetFinancialByProjectQuery = { __typename?: 'Query', finances: Array<{ __typename?: 'Finance', id: string, value: number, year: number, deletedBy?: string | null | undefined, asset: { __typename?: 'Asset', id: string, isProjectCosts: boolean }, company: { __typename?: 'Company', id: string } }>, assets: Array<{ __typename?: 'Asset', id: string, isProjectCosts: boolean, description: string }>, companies: Array<{ __typename?: 'Company', id: string, description?: string | null | undefined }> };

export type GetFinancialSumByProjectQueryVariables = Exact<{
  where?: InputMaybe<FinanceWhereInput>;
  financeOrderBy?: InputMaybe<Array<FinanceOrderByWithRelationInput> | FinanceOrderByWithRelationInput>;
  assetsOrderBy?: InputMaybe<Array<AssetOrderByWithRelationInput> | AssetOrderByWithRelationInput>;
  companiesOrderBy?: InputMaybe<Array<CompanyOrderByWithRelationInput> | CompanyOrderByWithRelationInput>;
}>;


export type GetFinancialSumByProjectQuery = { __typename?: 'Query', finances: Array<{ __typename?: 'Finance', id: string, assetId: string, companyId: string, year: number, value: number, createdAt: Date }>, assets: Array<{ __typename?: 'Asset', id: string, isProjectCosts: boolean, description: string }>, companies: Array<{ __typename?: 'Company', id: string, description?: string | null | undefined }> };

export type GetLastFinancesPerYearQueryVariables = Exact<{
  olderThan?: InputMaybe<Scalars['DateTime']>;
  projectId?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<FinanceWhereInput>;
}>;


export type GetLastFinancesPerYearQuery = { __typename?: 'Query', getLastFinancesPerYear: Array<{ __typename?: 'Finance', id: string, value: number, assetId: string, companyId: string, year: number }> };

export type GroupByFinancialQueryVariables = Exact<{
  by: Array<FinanceScalarFieldEnum> | FinanceScalarFieldEnum;
  sum?: InputMaybe<FinanceSumAggregateInput>;
  where?: InputMaybe<FinanceWhereInput>;
  assetsOrderBy?: InputMaybe<Array<AssetOrderByWithRelationInput> | AssetOrderByWithRelationInput>;
  companiesOrderBy?: InputMaybe<Array<CompanyOrderByWithRelationInput> | CompanyOrderByWithRelationInput>;
}>;


export type GroupByFinancialQuery = { __typename?: 'Query', groupFinances: Array<{ __typename?: 'FinanceGroupBy', assetId: string, companyId: string, year: number, _sum?: { __typename?: 'FinanceSumAggregate', value?: number | null | undefined } | null | undefined }>, assets: Array<{ __typename?: 'Asset', id: string, isProjectCosts: boolean, description: string }>, companies: Array<{ __typename?: 'Company', id: string, description?: string | null | undefined }> };

export type GroupProjectResourceCapturesQueryVariables = Exact<{
  by: Array<ProjectResourceCaptureScalarFieldEnum> | ProjectResourceCaptureScalarFieldEnum;
  sum?: InputMaybe<ProjectResourceCaptureSumAggregateInput>;
  where?: InputMaybe<ProjectResourceCaptureWhereInput>;
}>;


export type GroupProjectResourceCapturesQuery = { __typename?: 'Query', groupProjectResourceCaptures: Array<{ __typename?: 'ProjectResourceCaptureGroupBy', year: number, _sum?: { __typename?: 'ProjectResourceCaptureSumAggregate', rate?: number | null | undefined } | null | undefined }> };

export type GetAssetsByProjectQueryVariables = Exact<{
  distinct?: InputMaybe<Array<FinanceScalarFieldEnum> | FinanceScalarFieldEnum>;
  where?: InputMaybe<FinanceWhereInput>;
}>;


export type GetAssetsByProjectQuery = { __typename?: 'Query', finances: Array<{ __typename?: 'Finance', id: string, asset: { __typename?: 'Asset', id: string } }> };

export type CreateEmployeeMutationVariables = Exact<{
  data: EmployeeCreateInput;
}>;


export type CreateEmployeeMutation = { __typename?: 'Mutation', createEmployee: { __typename?: 'Employee', id: string } };

export type GetEmployeeQueryVariables = Exact<{
  where: EmployeeWhereUniqueInput;
}>;


export type GetEmployeeQuery = { __typename?: 'Query', employee: { __typename?: 'Employee', id: string } };

export type GetProjectDocumentsQueryVariables = Exact<{
  where?: InputMaybe<ProjectDocumentsWhereInput>;
}>;


export type GetProjectDocumentsQuery = { __typename?: 'Query', projectDocuments: Array<{ __typename?: 'ProjectDocuments', id: string, name: string, description?: string | null | undefined, uri: string, location?: string | null | undefined, project: { __typename?: 'Master', projectDescriptions?: Array<{ __typename?: 'ProjectDescription', id: string, name: string }> | null | undefined, projectStatus?: Array<{ __typename?: 'ProjectStatus', id: string }> | null | undefined } }> };

export type GetEmployeesByRoleQueryVariables = Exact<{
  roleId: Scalars['String'];
}>;


export type GetEmployeesByRoleQuery = { __typename?: 'Query', projectRoles: Array<{ __typename?: 'ProjectRole', id: string, role: { __typename?: 'Role', id: string, description?: string | null | undefined }, employee: { __typename?: 'Employee', firstName?: string | null | undefined, lastName?: string | null | undefined, id: string } }> };

export type GetAllEmployeesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllEmployeesQuery = { __typename?: 'Query', employees: Array<{ __typename?: 'Employee', firstName?: string | null | undefined, id: string, lastName?: string | null | undefined }> };

export type CreateProjectRoleMutationVariables = Exact<{
  createdBy: Scalars['String'];
  projectId: Scalars['String'];
  roleId: Scalars['String'];
  employeeId: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
}>;


export type CreateProjectRoleMutation = { __typename?: 'Mutation', createProjectRole: { __typename?: 'ProjectRole', createdBy: string, projectId: string, roleId: string, employeeId: string } };

export type UpdateProjectFundingMutationVariables = Exact<{
  fundingName: Scalars['String'];
  projectId: Scalars['String'];
}>;


export type UpdateProjectFundingMutation = { __typename?: 'Mutation', updateProjectDescription: { __typename?: 'ProjectDescription', id: string, fundingId?: string | null | undefined } };

export type GetFundingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFundingsQuery = { __typename?: 'Query', fundings: Array<{ __typename?: 'Funding', description?: string | null | undefined, fundingName: string, id: string }> };

export type ApprovalBoardsQueryVariables = Exact<{ [key: string]: never; }>;


export type ApprovalBoardsQuery = { __typename?: 'Query', approvalBoards: Array<{ __typename?: 'ApprovalBoard', description: string, id: string }> };

export type ApproverFragment = { __typename?: 'Approver', id: string, firstName: string, lastName: string, kid: string, approvalBoard: { __typename?: 'ApprovalBoard', id: string, description: string } };

export type ApproversQueryVariables = Exact<{ [key: string]: never; }>;


export type ApproversQuery = { __typename?: 'Query', approvers: Array<{ __typename?: 'Approver', id: string, firstName: string, lastName: string, kid: string, approvalBoard: { __typename?: 'ApprovalBoard', id: string, description: string } }> };

export type CreateApproverMutationVariables = Exact<{
  data: ApproverCreateInput;
}>;


export type CreateApproverMutation = { __typename?: 'Mutation', createApprover: { __typename?: 'Approver', id: string, firstName: string, lastName: string, kid: string, approvalBoard: { __typename?: 'ApprovalBoard', id: string, description: string } } };

export type RemoveApproverMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveApproverMutation = { __typename?: 'Mutation', removeApprover: { __typename?: 'Approver', id: string } };

export type UpdateApproverMutationVariables = Exact<{
  data: ApproverUpdateInput;
  id: Scalars['String'];
}>;


export type UpdateApproverMutation = { __typename?: 'Mutation', updateApprover: { __typename?: 'Approver', id: string, firstName: string, lastName: string, kid: string, approvalBoard: { __typename?: 'ApprovalBoard', id: string, description: string } } };

export type LandingApplicationFragment = { __typename?: 'LandingApplication', id: string, name: string, url?: string | null | undefined, icon?: string | null | undefined, iconLocation?: string | null | undefined, tooltip?: string | null | undefined, order?: number | null | undefined, label?: string | null | undefined, isActive?: boolean | null | undefined, landingApplicationGroup?: Array<{ __typename?: 'LandingApplicationGroup', id: string }> | null | undefined, landingApplicationClusterMapping?: Array<{ __typename?: 'LandingApplicationClusterMapping', id: string, deletedBy?: string | null | undefined, cluster: { __typename?: 'LandingApplicationCluster', clusterName: string, id: string } }> | null | undefined };

export type LandingApplicationsQueryVariables = Exact<{ [key: string]: never; }>;


export type LandingApplicationsQuery = { __typename?: 'Query', landingApplications: Array<{ __typename?: 'LandingApplication', id: string, name: string, url?: string | null | undefined, icon?: string | null | undefined, iconLocation?: string | null | undefined, tooltip?: string | null | undefined, order?: number | null | undefined, label?: string | null | undefined, isActive?: boolean | null | undefined, landingApplicationGroup?: Array<{ __typename?: 'LandingApplicationGroup', id: string }> | null | undefined, landingApplicationClusterMapping?: Array<{ __typename?: 'LandingApplicationClusterMapping', id: string, deletedBy?: string | null | undefined, cluster: { __typename?: 'LandingApplicationCluster', clusterName: string, id: string } }> | null | undefined }> };

export type LandingApplicationClustersQueryVariables = Exact<{ [key: string]: never; }>;


export type LandingApplicationClustersQuery = { __typename?: 'Query', landingApplicationClusters: Array<{ __typename?: 'LandingApplicationCluster', id: string, clusterName: string, label: string, isActive: boolean, tooltip: string, icon: string, order: number, landingApplicationClusterGroup?: Array<{ __typename?: 'LandingApplicationClusterGroup', id: string, groupId: string, deletedBy?: string | null | undefined }> | null | undefined, landingApplicationClusterMapping?: Array<{ __typename?: 'LandingApplicationClusterMapping', id: string, deletedBy?: string | null | undefined }> | null | undefined }> };

export type CreateLandingApplicationMutationVariables = Exact<{
  data: LandingApplicationCreateInput;
  file: Scalars['Upload'];
}>;


export type CreateLandingApplicationMutation = { __typename?: 'Mutation', createLandingApplication: { __typename?: 'LandingApplication', id: string, name: string, url?: string | null | undefined, icon?: string | null | undefined, iconLocation?: string | null | undefined, tooltip?: string | null | undefined, order?: number | null | undefined, label?: string | null | undefined, isActive?: boolean | null | undefined, landingApplicationGroup?: Array<{ __typename?: 'LandingApplicationGroup', id: string }> | null | undefined, landingApplicationClusterMapping?: Array<{ __typename?: 'LandingApplicationClusterMapping', id: string, deletedBy?: string | null | undefined, cluster: { __typename?: 'LandingApplicationCluster', clusterName: string, id: string } }> | null | undefined } };

export type UpdateLandingApplicationMutationVariables = Exact<{
  data: LandingApplicationUpdateInput;
  id: Scalars['String'];
  file?: InputMaybe<Scalars['Upload']>;
}>;


export type UpdateLandingApplicationMutation = { __typename?: 'Mutation', updateLandingApplication: { __typename?: 'LandingApplication', id: string, name: string, url?: string | null | undefined, icon?: string | null | undefined, iconLocation?: string | null | undefined, tooltip?: string | null | undefined, order?: number | null | undefined, label?: string | null | undefined, isActive?: boolean | null | undefined, landingApplicationGroup?: Array<{ __typename?: 'LandingApplicationGroup', id: string }> | null | undefined, landingApplicationClusterMapping?: Array<{ __typename?: 'LandingApplicationClusterMapping', id: string, deletedBy?: string | null | undefined, cluster: { __typename?: 'LandingApplicationCluster', clusterName: string, id: string } }> | null | undefined } };

export type ProjectApprovalsQueryVariables = Exact<{
  approvalStatus?: InputMaybe<Scalars['String']>;
}>;


export type ProjectApprovalsQuery = { __typename?: 'Query', projectApprovals: Array<{ __typename?: 'ProjectApproval', id: string, approvalBoardId: string, createdAt: Date, comment?: string | null | undefined, project: { __typename?: 'Master', id: string, projectDescriptions?: Array<{ __typename?: 'ProjectDescription', name: string }> | null | undefined }, ApprovalBoard: { __typename?: 'ApprovalBoard', description: string, id: string }, approvalStatus?: { __typename?: 'ApprovalStatus', description: string, id: string } | null | undefined }> };

export type ApprovalStatusesQueryVariables = Exact<{ [key: string]: never; }>;


export type ApprovalStatusesQuery = { __typename?: 'Query', approvalStatuses: Array<{ __typename?: 'ApprovalStatus', id: string, description: string }> };

export type ApproverProcessesQueryVariables = Exact<{ [key: string]: never; }>;


export type ApproverProcessesQuery = { __typename?: 'Query', approverProcesses: Array<{ __typename?: 'ApproverProcess', description: string, id: string, approverRecipient?: Array<{ __typename?: 'ApproverRecipient', firstName: string }> | null | undefined }> };

export type CreateApproverProcessMutationVariables = Exact<{
  data: ApproverProcessCreateInput;
}>;


export type CreateApproverProcessMutation = { __typename?: 'Mutation', createApproverProcess: { __typename?: 'ApproverProcess', description: string, id: string, approverRecipient?: Array<{ __typename?: 'ApproverRecipient', firstName: string }> | null | undefined } };

export type ApproverRecipientFragment = { __typename?: 'ApproverRecipient', id: string, firstName: string, lastName: string, kid: string, approverProcess: { __typename?: 'ApproverProcess', id: string, description: string } };

export type ApproverRecipientsQueryVariables = Exact<{ [key: string]: never; }>;


export type ApproverRecipientsQuery = { __typename?: 'Query', approverRecipients: Array<{ __typename?: 'ApproverRecipient', id: string, firstName: string, lastName: string, kid: string, approverProcess: { __typename?: 'ApproverProcess', id: string, description: string } }> };

export type CreateApproverRecipientMutationVariables = Exact<{
  data: ApproverRecipientCreateInput;
}>;


export type CreateApproverRecipientMutation = { __typename?: 'Mutation', createApproverRecipient: { __typename?: 'ApproverRecipient', id: string, firstName: string, lastName: string, kid: string, approverProcess: { __typename?: 'ApproverProcess', id: string, description: string } } };

export type RemoveApproverRecipientMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type RemoveApproverRecipientMutation = { __typename?: 'Mutation', removeApproverRecipient: { __typename?: 'ApproverRecipient', id: string } };

export type UpdateApproverRecipientMutationVariables = Exact<{
  data: ApproverRecipientUpdateInput;
  id: Scalars['String'];
}>;


export type UpdateApproverRecipientMutation = { __typename?: 'Mutation', updateApproverRecipient: { __typename?: 'ApproverRecipient', id: string, firstName: string, lastName: string, kid: string, approverProcess: { __typename?: 'ApproverProcess', id: string, description: string } } };

export type GetProjectQuestionnaireStatusesQueryVariables = Exact<{
  where?: InputMaybe<ProjectQuestionnaireStatusWhereInput>;
  orderBy?: InputMaybe<Array<ProjectQuestionnaireStatusOrderByWithRelationInput> | ProjectQuestionnaireStatusOrderByWithRelationInput>;
}>;


export type GetProjectQuestionnaireStatusesQuery = { __typename?: 'Query', projectQuestionnaireStatuses: Array<{ __typename?: 'ProjectQuestionnaireStatus', id: string, order?: number | null | undefined, question?: string | null | undefined }> };

export type GetProjectQuestionnairesQueryVariables = Exact<{
  where?: InputMaybe<ProjectQuestionnaireWhereInput>;
}>;


export type GetProjectQuestionnairesQuery = { __typename?: 'Query', projectQuestionnaires: Array<{ __typename?: 'ProjectQuestionnaire', id: string, value: boolean }> };

export type CreateProjectQuestionnaireMutationVariables = Exact<{
  data: ProjectQuestionnaireCreateInput;
}>;


export type CreateProjectQuestionnaireMutation = { __typename?: 'Mutation', createProjectQuestionnaire: { __typename?: 'ProjectQuestionnaire', id: string } };

export type CreateProjectApprovalMutationVariables = Exact<{
  data: ProjectApprovalCreateInput;
}>;


export type CreateProjectApprovalMutation = { __typename?: 'Mutation', createProjectApproval: { __typename?: 'ProjectApproval', createdBy: string } };

export type UpdateProjectApprovalMutationVariables = Exact<{
  data: ProjectApprovalUpdateInput;
  where: ProjectApprovalWhereUniqueInput;
}>;


export type UpdateProjectApprovalMutation = { __typename?: 'Mutation', updateProjectApproval: { __typename?: 'ProjectApproval', createdBy: string } };

export type CreateProjectAllocationInputMutationVariables = Exact<{
  data: ProjectAllocationCreateInput;
}>;


export type CreateProjectAllocationInputMutation = { __typename?: 'Mutation', createProjectAllocationInput: { __typename?: 'ProjectAllocation', id: string } };

export type GetGeneralItCostsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGeneralItCostsQuery = { __typename?: 'Query', generalItCosts: Array<{ __typename?: 'GerneralItCosts', id: string, costTypeId: string, costSubtypeId: string, year: number, sum: number, deletedBy?: string | null | undefined }>, generalItCostTypes: Array<{ __typename?: 'GerneralItCostType', id: string, description: string, GerneralItCosts?: Array<{ __typename?: 'GerneralItCosts', costSubtypeId: string }> | null | undefined }>, generalItCostSubtypes: Array<{ __typename?: 'GerneralItCostSubtype', id: string, description?: string | null | undefined }> };

export type UpdateGeneralItCostMutationVariables = Exact<{
  data: GerneralItCostsUpdateInput;
  where: GerneralItCostsWhereUniqueInput;
}>;


export type UpdateGeneralItCostMutation = { __typename?: 'Mutation', updateGeneralItCost: { __typename?: 'GerneralItCosts', id: string, sum: number } };

export type CreateGeneralItCostMutationVariables = Exact<{
  data: GerneralItCostsCreateInput;
}>;


export type CreateGeneralItCostMutation = { __typename?: 'Mutation', createGeneralItCost: { __typename?: 'GerneralItCosts', costTypeId: string, costSubtypeId: string, id: string, sum: number, year: number } };

export type RemoveGeneralItCostMutationVariables = Exact<{
  where: GerneralItCostsWhereUniqueInput;
}>;


export type RemoveGeneralItCostMutation = { __typename?: 'Mutation', removeGeneralItCost: { __typename?: 'GerneralItCosts', id: string } };

export type GetApproverMailsQueryVariables = Exact<{
  where?: InputMaybe<ApproverWhereInput>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type GetApproverMailsQuery = { __typename?: 'Query', approvers: Array<{ __typename?: 'Approver', kid: string }> };

export type DeleteMasterMutationVariables = Exact<{
  data: MasterUpdateInput;
  where: MasterWhereUniqueInput;
}>;


export type DeleteMasterMutation = { __typename?: 'Mutation', updateMaster: { __typename?: 'Master', deletedAt?: Date | null | undefined, deletedBy?: string | null | undefined } };

export type UpdateProjectDocumentMutationVariables = Exact<{
  data: ProjectDocumentsUpdateInput;
  where: ProjectDocumentsWhereUniqueInput;
}>;


export type UpdateProjectDocumentMutation = { __typename?: 'Mutation', updateProjectDocument: { __typename?: 'ProjectDocuments', id: string, uri: string } };

export type CreateRemarkMutationVariables = Exact<{
  data: RemarkCreateInput;
}>;


export type CreateRemarkMutation = { __typename?: 'Mutation', createRemark: { __typename?: 'Remark', id: string } };

export type GetSegmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSegmentsQuery = { __typename?: 'Query', segments: Array<{ __typename?: 'Segment', id: string, segment: string }> };

export type CreateGeneralCostShortHistoryMutationVariables = Exact<{
  data: GeneralCostShortHistoryCreateInput;
}>;


export type CreateGeneralCostShortHistoryMutation = { __typename?: 'Mutation', createGeneralCostShortHistory: { __typename?: 'GeneralCostShortHistory', id: string } };

export type EmailHistoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type EmailHistoriesQuery = { __typename?: 'Query', emailHistories: Array<{ __typename?: 'EmailHistory', approverId: string, createdAt: Date, createdBy: string, deletedAt?: Date | null | undefined, deletedBy?: string | null | undefined, id: string, input: string, projectId: string, description?: string | null | undefined }> };

export type GetEmailHistoryQueryVariables = Exact<{
  projectId: Scalars['String'];
  approverId: Scalars['String'];
}>;


export type GetEmailHistoryQuery = { __typename?: 'Query', emailHistories: Array<{ __typename?: 'EmailHistory', approverId: string, createdAt: Date, createdBy: string, deletedAt?: Date | null | undefined, deletedBy?: string | null | undefined, id: string, input: string, projectId: string, description?: string | null | undefined }> };

export type CreateEmailHistoryMutationVariables = Exact<{
  data: EmailHistoryCreateInput;
}>;


export type CreateEmailHistoryMutation = { __typename?: 'Mutation', createEmailHistory: { __typename?: 'EmailHistory', approverId: string, projectId: string, id: string, input: string, description?: string | null | undefined } };

export type ContactHistoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type ContactHistoriesQuery = { __typename?: 'Query', ContactHistories: Array<{ __typename?: 'ContactHistory', addressees?: string | null | undefined, approverProcessId: string, isMail: boolean, projectId: string, rowNumber: string, sendDate?: Date | null | undefined, createdAt: Date, createdBy?: string | null | undefined }> };

export type CreateContactHistoryMutationVariables = Exact<{
  data: ContactHistoryCreateInput;
}>;


export type CreateContactHistoryMutation = { __typename?: 'Mutation', createContactHistory: { __typename?: 'ContactHistory', addressees?: string | null | undefined, approverProcessId: string, isMail: boolean, projectId: string, rowNumber: string, sendDate?: Date | null | undefined, createdAt: Date, createdBy?: string | null | undefined } };

export type ResourceplanningGetProjectByIdQueryVariables = Exact<{
  id: Scalars['String'];
  orderBy?: InputMaybe<Array<MasterOrderByWithRelationInput> | MasterOrderByWithRelationInput>;
}>;


export type ResourceplanningGetProjectByIdQuery = { __typename?: 'Query', masters: Array<{ __typename?: 'Master', id: string, createdAt: Date, createdBy: string, projectResourceCapture?: Array<{ __typename?: 'ProjectResourceCapture', id: string, roleId: string, department: string, employeeId: string, projectPhaseId: string, year: number, month?: number | null | undefined, rate: number, communication: string, update: string, onboarding: Date, endDate?: Date | null | undefined, deletedBy?: string | null | undefined, employee: { __typename?: 'Employee', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined } }> | null | undefined, projectDocuments?: Array<{ __typename?: 'ProjectDocuments', id: string, name: string, description?: string | null | undefined, uri: string }> | null | undefined, goals?: Array<{ __typename?: 'GoalsOnMaster', goal: { __typename?: 'Goal', id: string, description?: string | null | undefined } }> | null | undefined, projectDescriptions?: Array<{ __typename?: 'ProjectDescription', background?: string | null | undefined, description?: string | null | undefined, name: string, category?: string | null | undefined, deletedBy?: string | null | undefined, id: string, planing?: string | null | undefined, procedure?: string | null | undefined, comments?: string | null | undefined, projectDuration?: number | null | undefined, projectStart?: Date | null | undefined, method?: { __typename?: 'Method', methodName: string } | null | undefined, projectType: { __typename?: 'ProjectType', id: string, projectType: string, projectTypeSub?: string | null | undefined } }> | null | undefined, projectApproval?: Array<{ __typename?: 'ProjectApproval', id: string, comment?: string | null | undefined, deletedBy?: string | null | undefined, approvalBoardId: string, approvalStatus?: { __typename?: 'ApprovalStatus', description: string, id: string } | null | undefined, ApprovalBoard: { __typename?: 'ApprovalBoard', id: string, description: string, approver?: Array<{ __typename?: 'Approver', kid: string, firstName: string, lastName: string, startDate?: Date | null | undefined, endDate?: Date | null | undefined, function?: string | null | undefined }> | null | undefined } }> | null | undefined, projectStatus?: Array<{ __typename?: 'ProjectStatus', id: string, sequenceStatusId: string, createdBy: string, deletedBy?: string | null | undefined, createdAt: Date, sequenceStatus: { __typename?: 'SequenceStatus', description?: string | null | undefined, descriptionLong?: string | null | undefined, order?: number | null | undefined } }> | null | undefined, projectRole?: Array<{ __typename?: 'ProjectRole', id: string, deletedBy?: string | null | undefined, employee: { __typename?: 'Employee', firstName?: string | null | undefined, lastName?: string | null | undefined, id: string }, role: { __typename?: 'Role', id: string } }> | null | undefined, finances?: Array<{ __typename?: 'Finance', value: number, asset: { __typename?: 'Asset', isProjectCosts: boolean } }> | null | undefined, projectAllocations?: Array<{ __typename?: 'ProjectAllocation', id: string, allocationId: string, percentage: number }> | null | undefined, remarks?: Array<{ __typename?: 'Remark', remark: string, deletedBy?: string | null | undefined, segment: { __typename?: 'Segment', segment: string } }> | null | undefined, projectInterface?: Array<{ __typename?: 'ProjectInterface', cause?: string | null | undefined, challenges?: string | null | undefined, collaboration?: string | null | undefined, createdBy: string, deletedAt?: Date | null | undefined, description?: string | null | undefined, employeeId: string, id: string, projectId: string, status?: number | null | undefined, name?: string | null | undefined }> | null | undefined }> };

export type ResourceplanningDropdownDataQueryVariables = Exact<{
  where?: InputMaybe<EmployeeWhereInput>;
  projectPhasesWhere2?: InputMaybe<ProjectPhaseWhereInput>;
}>;


export type ResourceplanningDropdownDataQuery = { __typename?: 'Query', projectPhases: Array<{ __typename?: 'ProjectPhase', id: string }>, employees: Array<{ __typename?: 'Employee', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined, department?: string | null | undefined }>, roles: Array<{ __typename?: 'Role', id: string }> };

export type CreateProjectResourceCaptureMutationVariables = Exact<{
  data: ProjectResourceCaptureCreateInput;
}>;


export type CreateProjectResourceCaptureMutation = { __typename?: 'Mutation', createProjectResourceCapture: { __typename?: 'ProjectResourceCapture', id: string } };

export type UpdateProjectResourceCaptureMutationVariables = Exact<{
  data: ProjectResourceCaptureUpdateInput;
  where: ProjectResourceCaptureWhereUniqueInput;
}>;


export type UpdateProjectResourceCaptureMutation = { __typename?: 'Mutation', updateProjectResourceCapture: { __typename?: 'ProjectResourceCapture', id: string } };

export type ReportingGetProjectByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ReportingGetProjectByIdQuery = { __typename?: 'Query', masters: Array<{ __typename?: 'Master', id: string, createdAt: Date, createdBy: string, projectPhaseCapture?: Array<{ __typename?: 'ProjectPhaseCapture', id: string, projectPhaseId: string, comment?: string | null | undefined, startDate: Date, endDate: Date, deletedBy?: string | null | undefined }> | null | undefined, projectResourceCapture?: Array<{ __typename?: 'ProjectResourceCapture', roleId: string, department: string, employee: { __typename?: 'Employee', firstName?: string | null | undefined, lastName?: string | null | undefined } }> | null | undefined, projectShortHistory?: Array<{ __typename?: 'ProjectShortHistory', createdAt: Date, createdBy?: string | null | undefined, action: string, rowNumber?: number | null | undefined }> | null | undefined, report?: Array<{ __typename?: 'Report', deletedBy?: string | null | undefined, createdBy: string, id: string, projectId: string, reportLink: string, reportTitle: string, update?: Date | null | undefined, addresseeGroup?: Array<{ __typename?: 'AddresseeGroup', reportId: number, employeeId: string, createdBy: string, deletedBy?: string | null | undefined }> | null | undefined, project: { __typename?: 'Master', projectDescriptions?: Array<{ __typename?: 'ProjectDescription', name: string }> | null | undefined } }> | null | undefined, projectInterface?: Array<{ __typename?: 'ProjectInterface', cause?: string | null | undefined, challenges?: string | null | undefined, collaboration?: string | null | undefined, createdBy: string, deletedBy?: string | null | undefined, deletedAt?: Date | null | undefined, description?: string | null | undefined, employeeId: string, id: string, projectId: string, status?: number | null | undefined, name?: string | null | undefined, employee: { __typename?: 'Employee', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined }, interfaceReference: { __typename?: 'InterfaceReference', description?: string | null | undefined, id: string }, interfaceDetail?: Array<{ __typename?: 'InterfaceDetail', description?: string | null | undefined, id: string, interfaceFormatId: string, interfaceTypeId: string, isExport: boolean, interfaceFormat: { __typename?: 'InterfaceFormat', id: string, description?: string | null | undefined }, interfaceType: { __typename?: 'InterfaceType', description?: string | null | undefined, id: string } }> | null | undefined }> | null | undefined, projectDocuments?: Array<{ __typename?: 'ProjectDocuments', id: string, name: string, description?: string | null | undefined, uri: string }> | null | undefined, goals?: Array<{ __typename?: 'GoalsOnMaster', goal: { __typename?: 'Goal', id: string, description?: string | null | undefined } }> | null | undefined, projectDescriptions?: Array<{ __typename?: 'ProjectDescription', background?: string | null | undefined, description?: string | null | undefined, name: string, category?: string | null | undefined, deletedBy?: string | null | undefined, id: string, planing?: string | null | undefined, procedure?: string | null | undefined, comments?: string | null | undefined, projectDuration?: number | null | undefined, projectStart?: Date | null | undefined, method?: { __typename?: 'Method', methodName: string } | null | undefined, projectType: { __typename?: 'ProjectType', id: string, projectType: string, projectTypeSub?: string | null | undefined } }> | null | undefined, projectApproval?: Array<{ __typename?: 'ProjectApproval', id: string, comment?: string | null | undefined, deletedBy?: string | null | undefined, approvalBoardId: string, approvalStatus?: { __typename?: 'ApprovalStatus', description: string, id: string } | null | undefined, ApprovalBoard: { __typename?: 'ApprovalBoard', id: string, description: string, approver?: Array<{ __typename?: 'Approver', kid: string, firstName: string, lastName: string, startDate?: Date | null | undefined, endDate?: Date | null | undefined, function?: string | null | undefined }> | null | undefined } }> | null | undefined, projectStatus?: Array<{ __typename?: 'ProjectStatus', id: string, sequenceStatusId: string, createdBy: string, deletedBy?: string | null | undefined, createdAt: Date, sequenceStatus: { __typename?: 'SequenceStatus', description?: string | null | undefined, descriptionLong?: string | null | undefined, order?: number | null | undefined } }> | null | undefined, projectRole?: Array<{ __typename?: 'ProjectRole', id: string, deletedBy?: string | null | undefined, employee: { __typename?: 'Employee', firstName?: string | null | undefined, lastName?: string | null | undefined, id: string }, role: { __typename?: 'Role', id: string } }> | null | undefined, finances?: Array<{ __typename?: 'Finance', value: number, asset: { __typename?: 'Asset', isProjectCosts: boolean } }> | null | undefined, projectAllocations?: Array<{ __typename?: 'ProjectAllocation', id: string, allocationId: string, percentage: number }> | null | undefined, remarks?: Array<{ __typename?: 'Remark', remark: string, deletedBy?: string | null | undefined, segment: { __typename?: 'Segment', segment: string } }> | null | undefined }> };

export type UpdateProjectPhaseCaptureMutationVariables = Exact<{
  data: ProjectPhaseCaptureUpdateInput;
  where: ProjectPhaseCaptureWhereUniqueInput;
}>;


export type UpdateProjectPhaseCaptureMutation = { __typename?: 'Mutation', updateProjectPhaseCapture: { __typename?: 'ProjectPhaseCapture', id: string } };

export type ProjectPhasesQueryVariables = Exact<{
  where?: InputMaybe<ProjectPhaseWhereInput>;
}>;


export type ProjectPhasesQuery = { __typename?: 'Query', projectPhases: Array<{ __typename?: 'ProjectPhase', id: string }> };

export type GetProjectInterfacesQueryVariables = Exact<{
  where?: InputMaybe<ProjectInterfaceWhereInput>;
}>;


export type GetProjectInterfacesQuery = { __typename?: 'Query', projectInterfaces: Array<{ __typename?: 'ProjectInterface', deletedBy?: string | null | undefined, id: string, projectId: string, cause?: string | null | undefined, employeeId: string, name?: string | null | undefined, description?: string | null | undefined, challenges?: string | null | undefined, interfaceId: string, status?: number | null | undefined, collaboration?: string | null | undefined, isAutomatic: boolean, interfaceReferenceId: string, riskStatusId?: string | null | undefined, riskOccuranceId?: string | null | undefined, riskDamagePotentialId?: string | null | undefined, interfaceDetail?: Array<{ __typename?: 'InterfaceDetail', leanixMappingId?: string | null | undefined, id: string, deletedBy?: string | null | undefined, createdAt: Date, description?: string | null | undefined, interfaceTypeId: string, interfaceFormatId: string, isExport: boolean }> | null | undefined }> };

export type GetProjectInterfaceByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetProjectInterfaceByIdQuery = { __typename?: 'Query', projectInterface: { __typename?: 'ProjectInterface', id: string, name?: string | null | undefined, cause?: string | null | undefined, interfaceReferenceId: string, employeeId: string, collaboration?: string | null | undefined, challenges?: string | null | undefined, status?: number | null | undefined, description?: string | null | undefined, isAutomatic: boolean, riskStatusId?: string | null | undefined, riskOccuranceId?: string | null | undefined, riskDamagePotentialId?: string | null | undefined, interfaceId: string, deletedBy?: string | null | undefined } };

export type ReportingGetProjectInterfacesByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ReportingGetProjectInterfacesByIdQuery = { __typename?: 'Query', masters: Array<{ __typename?: 'Master', id: string, createdAt: Date, createdBy: string, projectInterface?: Array<{ __typename?: 'ProjectInterface', cause?: string | null | undefined, challenges?: string | null | undefined, collaboration?: string | null | undefined, createdBy: string, deletedAt?: Date | null | undefined, description?: string | null | undefined, employeeId: string, interfaceReferenceId: string, id: string, projectId: string, status?: number | null | undefined, name?: string | null | undefined, employee: { __typename?: 'Employee', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined }, interfaceReference: { __typename?: 'InterfaceReference', description?: string | null | undefined, id: string }, interfaceDetail?: Array<{ __typename?: 'InterfaceDetail', description?: string | null | undefined, id: string, interfaceFormatId: string, interfaceTypeId: string, isExport: boolean, interfaceFormat: { __typename?: 'InterfaceFormat', id: string, description?: string | null | undefined }, interfaceType: { __typename?: 'InterfaceType', description?: string | null | undefined, id: string } }> | null | undefined }> | null | undefined, projectDocuments?: Array<{ __typename?: 'ProjectDocuments', id: string, name: string, description?: string | null | undefined, uri: string }> | null | undefined, goals?: Array<{ __typename?: 'GoalsOnMaster', goal: { __typename?: 'Goal', id: string, description?: string | null | undefined } }> | null | undefined, projectDescriptions?: Array<{ __typename?: 'ProjectDescription', background?: string | null | undefined, description?: string | null | undefined, name: string, category?: string | null | undefined, deletedBy?: string | null | undefined, id: string, planing?: string | null | undefined, procedure?: string | null | undefined, comments?: string | null | undefined, projectDuration?: number | null | undefined, projectStart?: Date | null | undefined, method?: { __typename?: 'Method', methodName: string } | null | undefined, projectType: { __typename?: 'ProjectType', id: string, projectType: string, projectTypeSub?: string | null | undefined } }> | null | undefined, projectApproval?: Array<{ __typename?: 'ProjectApproval', id: string, comment?: string | null | undefined, deletedBy?: string | null | undefined, approvalBoardId: string, approvalStatus?: { __typename?: 'ApprovalStatus', description: string, id: string } | null | undefined, ApprovalBoard: { __typename?: 'ApprovalBoard', id: string, description: string, approver?: Array<{ __typename?: 'Approver', kid: string, firstName: string, lastName: string, startDate?: Date | null | undefined, endDate?: Date | null | undefined, function?: string | null | undefined }> | null | undefined } }> | null | undefined, projectStatus?: Array<{ __typename?: 'ProjectStatus', id: string, sequenceStatusId: string, createdBy: string, deletedBy?: string | null | undefined, createdAt: Date, sequenceStatus: { __typename?: 'SequenceStatus', description?: string | null | undefined, descriptionLong?: string | null | undefined, order?: number | null | undefined } }> | null | undefined, projectRole?: Array<{ __typename?: 'ProjectRole', id: string, deletedBy?: string | null | undefined, employee: { __typename?: 'Employee', firstName?: string | null | undefined, lastName?: string | null | undefined, id: string }, role: { __typename?: 'Role', id: string } }> | null | undefined, finances?: Array<{ __typename?: 'Finance', value: number, asset: { __typename?: 'Asset', isProjectCosts: boolean } }> | null | undefined, projectAllocations?: Array<{ __typename?: 'ProjectAllocation', id: string, allocationId: string, percentage: number }> | null | undefined, remarks?: Array<{ __typename?: 'Remark', remark: string, deletedBy?: string | null | undefined, segment: { __typename?: 'Segment', segment: string } }> | null | undefined }> };

export type CreateInterfaceDetailMutationVariables = Exact<{
  data: InterfaceDetailCreateInput;
}>;


export type CreateInterfaceDetailMutation = { __typename?: 'Mutation', createInterfaceDetail: { __typename?: 'InterfaceDetail', id: string, description?: string | null | undefined, projectInterfaceId: string, interfaceTypeId: string, interfaceFormatId: string, isExport: boolean } };

export type CreateProjectInterfaceMutationVariables = Exact<{
  data: ProjectInterfaceCreateInput;
}>;


export type CreateProjectInterfaceMutation = { __typename?: 'Mutation', createProjectInterface: { __typename?: 'ProjectInterface', projectId: string, interfaceReferenceId: string, description?: string | null | undefined, cause?: string | null | undefined, challenges?: string | null | undefined, collaboration?: string | null | undefined, status?: number | null | undefined, deletedBy?: string | null | undefined, employeeId: string, interfaceDetail?: Array<{ __typename?: 'InterfaceDetail', id: string }> | null | undefined } };

export type GetLandingApplicationClustersQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<LandingApplicationClusterOrderByWithRelationInput> | LandingApplicationClusterOrderByWithRelationInput>;
  where?: InputMaybe<LandingApplicationClusterWhereInput>;
}>;


export type GetLandingApplicationClustersQuery = { __typename?: 'Query', landingApplicationClusters: Array<{ __typename?: 'LandingApplicationCluster', id: string, clusterName: string, label: string, isActive: boolean, tooltip: string, icon: string, order: number, uri: string, landingApplicationClusterGroup?: Array<{ __typename?: 'LandingApplicationClusterGroup', id: string, groupId: string, deletedBy?: string | null | undefined }> | null | undefined }> };

export type CreateLandingApplicationClusterMappingMutationVariables = Exact<{
  data: LandingApplicationClusterMappingCreateInput;
}>;


export type CreateLandingApplicationClusterMappingMutation = { __typename?: 'Mutation', createLandingApplicationClusterMapping: { __typename?: 'LandingApplicationClusterMapping', id: string } };

export type UpdateLandingApplicationClusterMappingMutationVariables = Exact<{
  data: LandingApplicationClusterMappingUpdateInput;
  where: LandingApplicationClusterMappingWhereUniqueInput;
}>;


export type UpdateLandingApplicationClusterMappingMutation = { __typename?: 'Mutation', updateLandingApplicationClusterMapping: { __typename?: 'LandingApplicationClusterMapping', id: string } };

export type CreateLandingApplicationClusterMutationVariables = Exact<{
  data: LandingApplicationClusterCreateInput;
  file: Scalars['Upload'];
}>;


export type CreateLandingApplicationClusterMutation = { __typename?: 'Mutation', createLandingApplicationCluster: { __typename?: 'LandingApplicationCluster', id: string } };

export type GetSecurityGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSecurityGroupsQuery = { __typename?: 'Query', securityGroups: Array<{ __typename?: 'SecurityGroup', id: string, name: string }> };

export type UpdateLandingApplicationClusterMutationVariables = Exact<{
  data: LandingApplicationClusterUpdateInput;
  where: LandingApplicationClusterWhereUniqueInput;
  file?: InputMaybe<Scalars['Upload']>;
}>;


export type UpdateLandingApplicationClusterMutation = { __typename?: 'Mutation', updateLandingApplicationCluster: { __typename?: 'LandingApplicationCluster', id: string } };

export type CreateLandingApplicationClusterGroupMutationVariables = Exact<{
  data: LandingApplicationClusterGroupCreateInput;
}>;


export type CreateLandingApplicationClusterGroupMutation = { __typename?: 'Mutation', createLandingApplicationClusterGroup: { __typename?: 'LandingApplicationClusterGroup', id: string } };

export type UpdateLandingApplicationClusterGroupMutationVariables = Exact<{
  data: LandingApplicationClusterGroupUpdateInput;
  where: LandingApplicationClusterGroupWhereUniqueInput;
}>;


export type UpdateLandingApplicationClusterGroupMutation = { __typename?: 'Mutation', updateLandingApplicationClusterGroup: { __typename?: 'LandingApplicationClusterGroup', id: string } };

export type UpdateInterfaceDetailMutationVariables = Exact<{
  data: InterfaceDetailUpdateInput;
  where: InterfaceDetailWhereUniqueInput;
}>;


export type UpdateInterfaceDetailMutation = { __typename?: 'Mutation', updateInterfaceDetail: { __typename?: 'InterfaceDetail', id: string } };

export type GetInterfaceDetailQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInterfaceDetailQuery = { __typename?: 'Query', interfaceDetails: Array<{ __typename?: 'InterfaceDetail', deletedBy?: string | null | undefined, id: string, projectInterfaceId: string, leanixMappingId?: string | null | undefined, description?: string | null | undefined, interfaceFormatId: string, interfaceTypeId: string, isExport: boolean, createdAt: Date, createdBy?: string | null | undefined }> };

export type UpdateProjectInterfaceMutationVariables = Exact<{
  data: ProjectInterfaceUpdateInput;
  where: ProjectInterfaceWhereUniqueInput;
}>;


export type UpdateProjectInterfaceMutation = { __typename?: 'Mutation', updateProjectInterface: { __typename?: 'ProjectInterface', id: string } };

export type CreateLeanixMappingMutationVariables = Exact<{
  data: LeanixMappingCreateInput;
}>;


export type CreateLeanixMappingMutation = { __typename?: 'Mutation', createLeanixMapping: { __typename?: 'LeanixMapping', id: string, description?: string | null | undefined, name?: string | null | undefined, leanixId: string, type?: string | null | undefined, deletedBy?: string | null | undefined, master?: { __typename?: 'Master', id: string } | null | undefined } };

export type RiskCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type RiskCategoriesQuery = { __typename?: 'Query', riskOccurances: Array<{ __typename?: 'RiskOccurance', id: string }>, riskDamagePotentials: Array<{ __typename?: 'RiskDamagePotential', id: string }>, riskStatuses: Array<{ __typename?: 'RiskStatus', id: string }> };

export type CheckProjectResourceCaptureQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
  projectStatus?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  projectEmployee?: InputMaybe<Scalars['String']>;
}>;


export type CheckProjectResourceCaptureQuery = { __typename?: 'Query', masters: Array<{ __typename?: 'Master', id: string }> };

export type CreateAddresseeGroupMutationVariables = Exact<{
  data: AddresseeGroupCreateInput;
}>;


export type CreateAddresseeGroupMutation = { __typename?: 'Mutation', createAddresseeGroup: { __typename?: 'AddresseeGroup', employeeId: string, createdBy: string, report: { __typename?: 'Report', id: string } } };

export type UpdateAddresseeGroupMutationVariables = Exact<{
  data: AddresseeGroupUpdateInput;
  where: AddresseeGroupWhereUniqueInput;
}>;


export type UpdateAddresseeGroupMutation = { __typename?: 'Mutation', updateAddresseeGroup: { __typename?: 'AddresseeGroup', deletedBy?: string | null | undefined, deletedAt?: Date | null | undefined } };

export type GetAddresseeGroupQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAddresseeGroupQuery = { __typename?: 'Query', addresseeGroups: Array<{ __typename?: 'AddresseeGroup', id: string, deletedBy?: string | null | undefined, employeeId: string, reportId: number, employee: { __typename?: 'Employee', id: string, firstName?: string | null | undefined, lastName?: string | null | undefined } }> };

export type UpdateReportMutationVariables = Exact<{
  data: ReportUpdateInput;
  where: ReportWhereUniqueInput;
}>;


export type UpdateReportMutation = { __typename?: 'Mutation', updateReport: { __typename?: 'Report', reportLink: string, deletedBy?: string | null | undefined } };

export type CreateReportMutationVariables = Exact<{
  data: ReportCreateInput;
}>;


export type CreateReportMutation = { __typename?: 'Mutation', createReport: { __typename?: 'Report', reportLink: string } };

export type ProjectDescriptionNamesQueryVariables = Exact<{
  where?: InputMaybe<ProjectDescriptionWhereInput>;
}>;


export type ProjectDescriptionNamesQuery = { __typename?: 'Query', projectDescriptions: Array<{ __typename?: 'ProjectDescription', name: string }> };

export type GetProjectApprovalsByIdQueryVariables = Exact<{
  projectId: Scalars['String'];
  approvalBoardId: Scalars['String'];
}>;


export type GetProjectApprovalsByIdQuery = { __typename?: 'Query', projectApprovals: Array<{ __typename?: 'ProjectApproval', approvalStatusId?: string | null | undefined }> };

export type CheckProjectApprovalsQueryVariables = Exact<{
  where?: InputMaybe<ProjectApprovalWhereInput>;
  take?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<ProjectApprovalOrderByWithRelationInput> | ProjectApprovalOrderByWithRelationInput>;
}>;


export type CheckProjectApprovalsQuery = { __typename?: 'Query', projectApprovals: Array<{ __typename?: 'ProjectApproval', id: string }> };

export const MasterDetailsFragmentDoc = gql`
    fragment MasterDetails on Master {
  id
  projectDocuments {
    id
    name
    description
    uri
  }
  createdAt
  createdBy
  goals {
    goal {
      id
      description
    }
  }
  projectDescriptions {
    background
    description
    name
    category
    deletedBy
    id
    planing
    procedure
    comments
    projectDuration
    projectStart
    method {
      methodName
    }
    projectType {
      id
      projectType
      projectTypeSub
    }
  }
  projectApproval {
    id
    approvalStatus {
      description
      id
    }
    comment
    deletedBy
    approvalBoardId
    ApprovalBoard {
      id
      description
      approver {
        kid
        firstName
        lastName
        startDate
        endDate
        function
      }
    }
  }
  projectStatus {
    id
    sequenceStatusId
    createdBy
    deletedBy
    createdAt
    sequenceStatus {
      description
      descriptionLong
      order
    }
  }
  projectRole {
    id
    employee {
      firstName
      lastName
      id
    }
    role {
      id
    }
    deletedBy
  }
  finances {
    value
    asset {
      isProjectCosts
    }
  }
  projectAllocations {
    id
    allocationId
    percentage
  }
  remarks {
    remark
    deletedBy
    segment {
      segment
    }
  }
  projectInterface {
    cause
    challenges
    collaboration
    createdBy
    deletedAt
    description
    employeeId
    id
    projectId
    status
    name
  }
  projectInterface {
    cause
    challenges
    collaboration
    createdBy
    deletedAt
    description
    employeeId
    id
    projectId
    status
    name
  }
}
    `;
export const ApproverFragmentDoc = gql`
    fragment Approver on Approver {
  id
  firstName
  lastName
  kid
  approvalBoard {
    id
    description
  }
}
    `;
export const LandingApplicationFragmentDoc = gql`
    fragment LandingApplication on LandingApplication {
  id
  name
  url
  icon
  iconLocation
  tooltip
  order
  label
  isActive
  landingApplicationGroup {
    id
  }
  landingApplicationClusterMapping {
    id
    deletedBy
    cluster {
      clusterName
      id
    }
  }
}
    `;
export const ApproverRecipientFragmentDoc = gql`
    fragment ApproverRecipient on ApproverRecipient {
  id
  firstName
  lastName
  kid
  approverProcess {
    id
    description
  }
}
    `;
export const GetAssetsDocument = gql`
    query getAssets {
  assets {
    id
    description
    isProjectCosts
  }
}
    `;

/**
 * __useGetAssetsQuery__
 *
 * To run a query within a React component, call `useGetAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAssetsQuery(baseOptions?: Apollo.QueryHookOptions<GetAssetsQuery, GetAssetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssetsQuery, GetAssetsQueryVariables>(GetAssetsDocument, options);
      }
export function useGetAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssetsQuery, GetAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssetsQuery, GetAssetsQueryVariables>(GetAssetsDocument, options);
        }
export type GetAssetsQueryHookResult = ReturnType<typeof useGetAssetsQuery>;
export type GetAssetsLazyQueryHookResult = ReturnType<typeof useGetAssetsLazyQuery>;
export type GetAssetsQueryResult = Apollo.QueryResult<GetAssetsQuery, GetAssetsQueryVariables>;
export const GetLandingApplicationsDocument = gql`
    query getLandingApplications($orderBy: [LandingApplicationOrderByWithRelationInput!], $where: LandingApplicationWhereInput) {
  landingApplications(orderBy: $orderBy, where: $where) {
    id
    name
    icon
    iconLocation
    url
    tooltip
    isIframe
    order
    landingApplicationGroup {
      groupId
    }
    landingApplicationClusterMapping {
      clusterId
      deletedBy
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetLandingApplicationsQuery__
 *
 * To run a query within a React component, call `useGetLandingApplicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLandingApplicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLandingApplicationsQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetLandingApplicationsQuery(baseOptions?: Apollo.QueryHookOptions<GetLandingApplicationsQuery, GetLandingApplicationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLandingApplicationsQuery, GetLandingApplicationsQueryVariables>(GetLandingApplicationsDocument, options);
      }
export function useGetLandingApplicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLandingApplicationsQuery, GetLandingApplicationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLandingApplicationsQuery, GetLandingApplicationsQueryVariables>(GetLandingApplicationsDocument, options);
        }
export type GetLandingApplicationsQueryHookResult = ReturnType<typeof useGetLandingApplicationsQuery>;
export type GetLandingApplicationsLazyQueryHookResult = ReturnType<typeof useGetLandingApplicationsLazyQuery>;
export type GetLandingApplicationsQueryResult = Apollo.QueryResult<GetLandingApplicationsQuery, GetLandingApplicationsQueryVariables>;
export const GetLandingApplicationDocument = gql`
    query getLandingApplication($where: LandingApplicationWhereUniqueInput!) {
  landingApplication(where: $where) {
    id
    icon
    name
    url
    isIframe
    landingApplicationGroup {
      groupId
    }
  }
}
    `;

/**
 * __useGetLandingApplicationQuery__
 *
 * To run a query within a React component, call `useGetLandingApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLandingApplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLandingApplicationQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetLandingApplicationQuery(baseOptions: Apollo.QueryHookOptions<GetLandingApplicationQuery, GetLandingApplicationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLandingApplicationQuery, GetLandingApplicationQueryVariables>(GetLandingApplicationDocument, options);
      }
export function useGetLandingApplicationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLandingApplicationQuery, GetLandingApplicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLandingApplicationQuery, GetLandingApplicationQueryVariables>(GetLandingApplicationDocument, options);
        }
export type GetLandingApplicationQueryHookResult = ReturnType<typeof useGetLandingApplicationQuery>;
export type GetLandingApplicationLazyQueryHookResult = ReturnType<typeof useGetLandingApplicationLazyQuery>;
export type GetLandingApplicationQueryResult = Apollo.QueryResult<GetLandingApplicationQuery, GetLandingApplicationQueryVariables>;
export const GetCompaniesDocument = gql`
    query getCompanies {
  companies {
    id
    description
  }
}
    `;

/**
 * __useGetCompaniesQuery__
 *
 * To run a query within a React component, call `useGetCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompaniesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<GetCompaniesQuery, GetCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompaniesQuery, GetCompaniesQueryVariables>(GetCompaniesDocument, options);
      }
export function useGetCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompaniesQuery, GetCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompaniesQuery, GetCompaniesQueryVariables>(GetCompaniesDocument, options);
        }
export type GetCompaniesQueryHookResult = ReturnType<typeof useGetCompaniesQuery>;
export type GetCompaniesLazyQueryHookResult = ReturnType<typeof useGetCompaniesLazyQuery>;
export type GetCompaniesQueryResult = Apollo.QueryResult<GetCompaniesQuery, GetCompaniesQueryVariables>;
export const GetAssetsCompaniesDocument = gql`
    query getAssetsCompanies {
  assets {
    id
    isProjectCosts
  }
  companies {
    id
  }
}
    `;

/**
 * __useGetAssetsCompaniesQuery__
 *
 * To run a query within a React component, call `useGetAssetsCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetsCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetsCompaniesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAssetsCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<GetAssetsCompaniesQuery, GetAssetsCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssetsCompaniesQuery, GetAssetsCompaniesQueryVariables>(GetAssetsCompaniesDocument, options);
      }
export function useGetAssetsCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssetsCompaniesQuery, GetAssetsCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssetsCompaniesQuery, GetAssetsCompaniesQueryVariables>(GetAssetsCompaniesDocument, options);
        }
export type GetAssetsCompaniesQueryHookResult = ReturnType<typeof useGetAssetsCompaniesQuery>;
export type GetAssetsCompaniesLazyQueryHookResult = ReturnType<typeof useGetAssetsCompaniesLazyQuery>;
export type GetAssetsCompaniesQueryResult = Apollo.QueryResult<GetAssetsCompaniesQuery, GetAssetsCompaniesQueryVariables>;
export const GetAllocationsDocument = gql`
    query getAllocations {
  allocations {
    id
    description
    projectAllocations {
      id
    }
  }
}
    `;

/**
 * __useGetAllocationsQuery__
 *
 * To run a query within a React component, call `useGetAllocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllocationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllocationsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllocationsQuery, GetAllocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllocationsQuery, GetAllocationsQueryVariables>(GetAllocationsDocument, options);
      }
export function useGetAllocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllocationsQuery, GetAllocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllocationsQuery, GetAllocationsQueryVariables>(GetAllocationsDocument, options);
        }
export type GetAllocationsQueryHookResult = ReturnType<typeof useGetAllocationsQuery>;
export type GetAllocationsLazyQueryHookResult = ReturnType<typeof useGetAllocationsLazyQuery>;
export type GetAllocationsQueryResult = Apollo.QueryResult<GetAllocationsQuery, GetAllocationsQueryVariables>;
export const GetProjectAllocationsDocument = gql`
    query getProjectAllocations($projectAllocationsWhere: ProjectAllocationWhereInput) {
  projectAllocations(where: $projectAllocationsWhere) {
    id
    percentage
    allocationId
  }
}
    `;

/**
 * __useGetProjectAllocationsQuery__
 *
 * To run a query within a React component, call `useGetProjectAllocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectAllocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectAllocationsQuery({
 *   variables: {
 *      projectAllocationsWhere: // value for 'projectAllocationsWhere'
 *   },
 * });
 */
export function useGetProjectAllocationsQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectAllocationsQuery, GetProjectAllocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectAllocationsQuery, GetProjectAllocationsQueryVariables>(GetProjectAllocationsDocument, options);
      }
export function useGetProjectAllocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectAllocationsQuery, GetProjectAllocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectAllocationsQuery, GetProjectAllocationsQueryVariables>(GetProjectAllocationsDocument, options);
        }
export type GetProjectAllocationsQueryHookResult = ReturnType<typeof useGetProjectAllocationsQuery>;
export type GetProjectAllocationsLazyQueryHookResult = ReturnType<typeof useGetProjectAllocationsLazyQuery>;
export type GetProjectAllocationsQueryResult = Apollo.QueryResult<GetProjectAllocationsQuery, GetProjectAllocationsQueryVariables>;
export const UpdateProjectAllocationDocument = gql`
    mutation updateProjectAllocation($data: MasterUpdateInput!, $where: MasterWhereUniqueInput!) {
  updateMaster(data: $data, where: $where) {
    projectAllocations {
      id
      percentage
      allocationId
      projectId
    }
  }
}
    `;
export type UpdateProjectAllocationMutationFn = Apollo.MutationFunction<UpdateProjectAllocationMutation, UpdateProjectAllocationMutationVariables>;

/**
 * __useUpdateProjectAllocationMutation__
 *
 * To run a mutation, you first call `useUpdateProjectAllocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectAllocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectAllocationMutation, { data, loading, error }] = useUpdateProjectAllocationMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateProjectAllocationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectAllocationMutation, UpdateProjectAllocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectAllocationMutation, UpdateProjectAllocationMutationVariables>(UpdateProjectAllocationDocument, options);
      }
export type UpdateProjectAllocationMutationHookResult = ReturnType<typeof useUpdateProjectAllocationMutation>;
export type UpdateProjectAllocationMutationResult = Apollo.MutationResult<UpdateProjectAllocationMutation>;
export type UpdateProjectAllocationMutationOptions = Apollo.BaseMutationOptions<UpdateProjectAllocationMutation, UpdateProjectAllocationMutationVariables>;
export const GetProjectTypesDocument = gql`
    query getProjectTypes($where: ProjectTypeWhereInput, $orderBy: [ProjectTypeOrderByWithRelationInput!]) {
  projectTypes(where: $where, orderBy: $orderBy) {
    id
    projectType
    projectTypeSub
    description
    order
  }
}
    `;

/**
 * __useGetProjectTypesQuery__
 *
 * To run a query within a React component, call `useGetProjectTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectTypesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetProjectTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectTypesQuery, GetProjectTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectTypesQuery, GetProjectTypesQueryVariables>(GetProjectTypesDocument, options);
      }
export function useGetProjectTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectTypesQuery, GetProjectTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectTypesQuery, GetProjectTypesQueryVariables>(GetProjectTypesDocument, options);
        }
export type GetProjectTypesQueryHookResult = ReturnType<typeof useGetProjectTypesQuery>;
export type GetProjectTypesLazyQueryHookResult = ReturnType<typeof useGetProjectTypesLazyQuery>;
export type GetProjectTypesQueryResult = Apollo.QueryResult<GetProjectTypesQuery, GetProjectTypesQueryVariables>;
export const GetGoalsDocument = gql`
    query getGoals {
  goals {
    id
    description
  }
}
    `;

/**
 * __useGetGoalsQuery__
 *
 * To run a query within a React component, call `useGetGoalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGoalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGoalsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGoalsQuery(baseOptions?: Apollo.QueryHookOptions<GetGoalsQuery, GetGoalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGoalsQuery, GetGoalsQueryVariables>(GetGoalsDocument, options);
      }
export function useGetGoalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGoalsQuery, GetGoalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGoalsQuery, GetGoalsQueryVariables>(GetGoalsDocument, options);
        }
export type GetGoalsQueryHookResult = ReturnType<typeof useGetGoalsQuery>;
export type GetGoalsLazyQueryHookResult = ReturnType<typeof useGetGoalsLazyQuery>;
export type GetGoalsQueryResult = Apollo.QueryResult<GetGoalsQuery, GetGoalsQueryVariables>;
export const GetFinancesDocument = gql`
    query getFinances($where: FinanceWhereInput) {
  finances(where: $where) {
    asset {
      id
      isProjectCosts
    }
    companyId
    id
    value
    year
  }
}
    `;

/**
 * __useGetFinancesQuery__
 *
 * To run a query within a React component, call `useGetFinancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinancesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetFinancesQuery(baseOptions?: Apollo.QueryHookOptions<GetFinancesQuery, GetFinancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFinancesQuery, GetFinancesQueryVariables>(GetFinancesDocument, options);
      }
export function useGetFinancesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFinancesQuery, GetFinancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFinancesQuery, GetFinancesQueryVariables>(GetFinancesDocument, options);
        }
export type GetFinancesQueryHookResult = ReturnType<typeof useGetFinancesQuery>;
export type GetFinancesLazyQueryHookResult = ReturnType<typeof useGetFinancesLazyQuery>;
export type GetFinancesQueryResult = Apollo.QueryResult<GetFinancesQuery, GetFinancesQueryVariables>;
export const RemoveFinanceDocument = gql`
    mutation removeFinance($where: FinanceWhereUniqueInput!) {
  removeFinance(where: $where) {
    id
  }
}
    `;
export type RemoveFinanceMutationFn = Apollo.MutationFunction<RemoveFinanceMutation, RemoveFinanceMutationVariables>;

/**
 * __useRemoveFinanceMutation__
 *
 * To run a mutation, you first call `useRemoveFinanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveFinanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeFinanceMutation, { data, loading, error }] = useRemoveFinanceMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useRemoveFinanceMutation(baseOptions?: Apollo.MutationHookOptions<RemoveFinanceMutation, RemoveFinanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveFinanceMutation, RemoveFinanceMutationVariables>(RemoveFinanceDocument, options);
      }
export type RemoveFinanceMutationHookResult = ReturnType<typeof useRemoveFinanceMutation>;
export type RemoveFinanceMutationResult = Apollo.MutationResult<RemoveFinanceMutation>;
export type RemoveFinanceMutationOptions = Apollo.BaseMutationOptions<RemoveFinanceMutation, RemoveFinanceMutationVariables>;
export const GetFinancialDocument = gql`
    query getFinancial($where: FinanceWhereInput) {
  finances(where: $where) {
    asset {
      id
      isProjectCosts
    }
    companyId
    id
    value
    year
  }
  assets {
    id
    isProjectCosts
  }
  companies {
    id
  }
}
    `;

/**
 * __useGetFinancialQuery__
 *
 * To run a query within a React component, call `useGetFinancialQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinancialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinancialQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetFinancialQuery(baseOptions?: Apollo.QueryHookOptions<GetFinancialQuery, GetFinancialQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFinancialQuery, GetFinancialQueryVariables>(GetFinancialDocument, options);
      }
export function useGetFinancialLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFinancialQuery, GetFinancialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFinancialQuery, GetFinancialQueryVariables>(GetFinancialDocument, options);
        }
export type GetFinancialQueryHookResult = ReturnType<typeof useGetFinancialQuery>;
export type GetFinancialLazyQueryHookResult = ReturnType<typeof useGetFinancialLazyQuery>;
export type GetFinancialQueryResult = Apollo.QueryResult<GetFinancialQuery, GetFinancialQueryVariables>;
export const UpdateFinanceDocument = gql`
    mutation updateFinance($data: FinanceUpdateInput!, $where: FinanceWhereUniqueInput!) {
  updateFinance(data: $data, where: $where) {
    id
    value
  }
}
    `;
export type UpdateFinanceMutationFn = Apollo.MutationFunction<UpdateFinanceMutation, UpdateFinanceMutationVariables>;

/**
 * __useUpdateFinanceMutation__
 *
 * To run a mutation, you first call `useUpdateFinanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFinanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFinanceMutation, { data, loading, error }] = useUpdateFinanceMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateFinanceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFinanceMutation, UpdateFinanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFinanceMutation, UpdateFinanceMutationVariables>(UpdateFinanceDocument, options);
      }
export type UpdateFinanceMutationHookResult = ReturnType<typeof useUpdateFinanceMutation>;
export type UpdateFinanceMutationResult = Apollo.MutationResult<UpdateFinanceMutation>;
export type UpdateFinanceMutationOptions = Apollo.BaseMutationOptions<UpdateFinanceMutation, UpdateFinanceMutationVariables>;
export const CreateFinanceDocument = gql`
    mutation createFinance($data: FinanceCreateInput!) {
  createFinance(data: $data) {
    assetId
    companyId
    id
    projectId
    value
    year
  }
}
    `;
export type CreateFinanceMutationFn = Apollo.MutationFunction<CreateFinanceMutation, CreateFinanceMutationVariables>;

/**
 * __useCreateFinanceMutation__
 *
 * To run a mutation, you first call `useCreateFinanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFinanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFinanceMutation, { data, loading, error }] = useCreateFinanceMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateFinanceMutation(baseOptions?: Apollo.MutationHookOptions<CreateFinanceMutation, CreateFinanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFinanceMutation, CreateFinanceMutationVariables>(CreateFinanceDocument, options);
      }
export type CreateFinanceMutationHookResult = ReturnType<typeof useCreateFinanceMutation>;
export type CreateFinanceMutationResult = Apollo.MutationResult<CreateFinanceMutation>;
export type CreateFinanceMutationOptions = Apollo.BaseMutationOptions<CreateFinanceMutation, CreateFinanceMutationVariables>;
export const GetFinancialYearsDocument = gql`
    query getFinancialYears($distinct: [FinanceScalarFieldEnum!], $where: FinanceWhereInput) {
  finances(distinct: $distinct, where: $where) {
    year
  }
}
    `;

/**
 * __useGetFinancialYearsQuery__
 *
 * To run a query within a React component, call `useGetFinancialYearsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinancialYearsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinancialYearsQuery({
 *   variables: {
 *      distinct: // value for 'distinct'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetFinancialYearsQuery(baseOptions?: Apollo.QueryHookOptions<GetFinancialYearsQuery, GetFinancialYearsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFinancialYearsQuery, GetFinancialYearsQueryVariables>(GetFinancialYearsDocument, options);
      }
export function useGetFinancialYearsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFinancialYearsQuery, GetFinancialYearsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFinancialYearsQuery, GetFinancialYearsQueryVariables>(GetFinancialYearsDocument, options);
        }
export type GetFinancialYearsQueryHookResult = ReturnType<typeof useGetFinancialYearsQuery>;
export type GetFinancialYearsLazyQueryHookResult = ReturnType<typeof useGetFinancialYearsLazyQuery>;
export type GetFinancialYearsQueryResult = Apollo.QueryResult<GetFinancialYearsQuery, GetFinancialYearsQueryVariables>;
export const CreateProjectShortHistoryDocument = gql`
    mutation createProjectShortHistory($data: ProjectShortHistoryCreateInput!) {
  createProjectShortHistory(data: $data) {
    action
    projectId
    id
  }
}
    `;
export type CreateProjectShortHistoryMutationFn = Apollo.MutationFunction<CreateProjectShortHistoryMutation, CreateProjectShortHistoryMutationVariables>;

/**
 * __useCreateProjectShortHistoryMutation__
 *
 * To run a mutation, you first call `useCreateProjectShortHistoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectShortHistoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectShortHistoryMutation, { data, loading, error }] = useCreateProjectShortHistoryMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateProjectShortHistoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectShortHistoryMutation, CreateProjectShortHistoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectShortHistoryMutation, CreateProjectShortHistoryMutationVariables>(CreateProjectShortHistoryDocument, options);
      }
export type CreateProjectShortHistoryMutationHookResult = ReturnType<typeof useCreateProjectShortHistoryMutation>;
export type CreateProjectShortHistoryMutationResult = Apollo.MutationResult<CreateProjectShortHistoryMutation>;
export type CreateProjectShortHistoryMutationOptions = Apollo.BaseMutationOptions<CreateProjectShortHistoryMutation, CreateProjectShortHistoryMutationVariables>;
export const GetInterfaceTypesDocument = gql`
    query getInterfaceTypes {
  interfaceTypes {
    id
    description
  }
}
    `;

/**
 * __useGetInterfaceTypesQuery__
 *
 * To run a query within a React component, call `useGetInterfaceTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInterfaceTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInterfaceTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInterfaceTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetInterfaceTypesQuery, GetInterfaceTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInterfaceTypesQuery, GetInterfaceTypesQueryVariables>(GetInterfaceTypesDocument, options);
      }
export function useGetInterfaceTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInterfaceTypesQuery, GetInterfaceTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInterfaceTypesQuery, GetInterfaceTypesQueryVariables>(GetInterfaceTypesDocument, options);
        }
export type GetInterfaceTypesQueryHookResult = ReturnType<typeof useGetInterfaceTypesQuery>;
export type GetInterfaceTypesLazyQueryHookResult = ReturnType<typeof useGetInterfaceTypesLazyQuery>;
export type GetInterfaceTypesQueryResult = Apollo.QueryResult<GetInterfaceTypesQuery, GetInterfaceTypesQueryVariables>;
export const GetInterfaceFormatsDocument = gql`
    query getInterfaceFormats {
  interfaceFormats {
    id
    description
  }
}
    `;

/**
 * __useGetInterfaceFormatsQuery__
 *
 * To run a query within a React component, call `useGetInterfaceFormatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInterfaceFormatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInterfaceFormatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInterfaceFormatsQuery(baseOptions?: Apollo.QueryHookOptions<GetInterfaceFormatsQuery, GetInterfaceFormatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInterfaceFormatsQuery, GetInterfaceFormatsQueryVariables>(GetInterfaceFormatsDocument, options);
      }
export function useGetInterfaceFormatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInterfaceFormatsQuery, GetInterfaceFormatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInterfaceFormatsQuery, GetInterfaceFormatsQueryVariables>(GetInterfaceFormatsDocument, options);
        }
export type GetInterfaceFormatsQueryHookResult = ReturnType<typeof useGetInterfaceFormatsQuery>;
export type GetInterfaceFormatsLazyQueryHookResult = ReturnType<typeof useGetInterfaceFormatsLazyQuery>;
export type GetInterfaceFormatsQueryResult = Apollo.QueryResult<GetInterfaceFormatsQuery, GetInterfaceFormatsQueryVariables>;
export const GetApplicationsDocument = gql`
    query getApplications($where: LeanixMappingWhereInput) {
  leanixMappings(where: $where) {
    id
    leanixId
    description
    name
    type
  }
}
    `;

/**
 * __useGetApplicationsQuery__
 *
 * To run a query within a React component, call `useGetApplicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApplicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApplicationsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetApplicationsQuery(baseOptions?: Apollo.QueryHookOptions<GetApplicationsQuery, GetApplicationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApplicationsQuery, GetApplicationsQueryVariables>(GetApplicationsDocument, options);
      }
export function useGetApplicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApplicationsQuery, GetApplicationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApplicationsQuery, GetApplicationsQueryVariables>(GetApplicationsDocument, options);
        }
export type GetApplicationsQueryHookResult = ReturnType<typeof useGetApplicationsQuery>;
export type GetApplicationsLazyQueryHookResult = ReturnType<typeof useGetApplicationsLazyQuery>;
export type GetApplicationsQueryResult = Apollo.QueryResult<GetApplicationsQuery, GetApplicationsQueryVariables>;
export const CreateProjectDescriptionDocument = gql`
    mutation createProjectDescription($data: ProjectDescriptionCreateInput!) {
  createProjectDescription(data: $data) {
    id
    projectTypeId
    description
    background
    planing
    name
  }
}
    `;
export type CreateProjectDescriptionMutationFn = Apollo.MutationFunction<CreateProjectDescriptionMutation, CreateProjectDescriptionMutationVariables>;

/**
 * __useCreateProjectDescriptionMutation__
 *
 * To run a mutation, you first call `useCreateProjectDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectDescriptionMutation, { data, loading, error }] = useCreateProjectDescriptionMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateProjectDescriptionMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectDescriptionMutation, CreateProjectDescriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectDescriptionMutation, CreateProjectDescriptionMutationVariables>(CreateProjectDescriptionDocument, options);
      }
export type CreateProjectDescriptionMutationHookResult = ReturnType<typeof useCreateProjectDescriptionMutation>;
export type CreateProjectDescriptionMutationResult = Apollo.MutationResult<CreateProjectDescriptionMutation>;
export type CreateProjectDescriptionMutationOptions = Apollo.BaseMutationOptions<CreateProjectDescriptionMutation, CreateProjectDescriptionMutationVariables>;
export const UpdateProjectDescriptionDocument = gql`
    mutation updateProjectDescription($data: ProjectDescriptionUpdateInput!, $where: ProjectDescriptionWhereUniqueInput!) {
  updateProjectDescription(data: $data, where: $where) {
    sbk
  }
}
    `;
export type UpdateProjectDescriptionMutationFn = Apollo.MutationFunction<UpdateProjectDescriptionMutation, UpdateProjectDescriptionMutationVariables>;

/**
 * __useUpdateProjectDescriptionMutation__
 *
 * To run a mutation, you first call `useUpdateProjectDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectDescriptionMutation, { data, loading, error }] = useUpdateProjectDescriptionMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateProjectDescriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectDescriptionMutation, UpdateProjectDescriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectDescriptionMutation, UpdateProjectDescriptionMutationVariables>(UpdateProjectDescriptionDocument, options);
      }
export type UpdateProjectDescriptionMutationHookResult = ReturnType<typeof useUpdateProjectDescriptionMutation>;
export type UpdateProjectDescriptionMutationResult = Apollo.MutationResult<UpdateProjectDescriptionMutation>;
export type UpdateProjectDescriptionMutationOptions = Apollo.BaseMutationOptions<UpdateProjectDescriptionMutation, UpdateProjectDescriptionMutationVariables>;
export const UpdateProjectCommentsDocument = gql`
    mutation updateProjectComments($data: ProjectDescriptionUpdateInput!, $where: ProjectDescriptionWhereUniqueInput!) {
  updateProjectDescription(data: $data, where: $where) {
    comments
    category
  }
}
    `;
export type UpdateProjectCommentsMutationFn = Apollo.MutationFunction<UpdateProjectCommentsMutation, UpdateProjectCommentsMutationVariables>;

/**
 * __useUpdateProjectCommentsMutation__
 *
 * To run a mutation, you first call `useUpdateProjectCommentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectCommentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectCommentsMutation, { data, loading, error }] = useUpdateProjectCommentsMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateProjectCommentsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectCommentsMutation, UpdateProjectCommentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectCommentsMutation, UpdateProjectCommentsMutationVariables>(UpdateProjectCommentsDocument, options);
      }
export type UpdateProjectCommentsMutationHookResult = ReturnType<typeof useUpdateProjectCommentsMutation>;
export type UpdateProjectCommentsMutationResult = Apollo.MutationResult<UpdateProjectCommentsMutation>;
export type UpdateProjectCommentsMutationOptions = Apollo.BaseMutationOptions<UpdateProjectCommentsMutation, UpdateProjectCommentsMutationVariables>;
export const GetProjectDescriptionsDocument = gql`
    query getProjectDescriptions($where: ProjectDescriptionWhereInput) {
  projectDescriptions(where: $where) {
    id
    sbk
  }
}
    `;

/**
 * __useGetProjectDescriptionsQuery__
 *
 * To run a query within a React component, call `useGetProjectDescriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectDescriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectDescriptionsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetProjectDescriptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectDescriptionsQuery, GetProjectDescriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectDescriptionsQuery, GetProjectDescriptionsQueryVariables>(GetProjectDescriptionsDocument, options);
      }
export function useGetProjectDescriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectDescriptionsQuery, GetProjectDescriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectDescriptionsQuery, GetProjectDescriptionsQueryVariables>(GetProjectDescriptionsDocument, options);
        }
export type GetProjectDescriptionsQueryHookResult = ReturnType<typeof useGetProjectDescriptionsQuery>;
export type GetProjectDescriptionsLazyQueryHookResult = ReturnType<typeof useGetProjectDescriptionsLazyQuery>;
export type GetProjectDescriptionsQueryResult = Apollo.QueryResult<GetProjectDescriptionsQuery, GetProjectDescriptionsQueryVariables>;
export const CreateMasterDocument = gql`
    mutation createMaster($data: MasterCreateInput!) {
  createMaster(data: $data) {
    id
    projectDescriptions {
      name
      description
    }
  }
}
    `;
export type CreateMasterMutationFn = Apollo.MutationFunction<CreateMasterMutation, CreateMasterMutationVariables>;

/**
 * __useCreateMasterMutation__
 *
 * To run a mutation, you first call `useCreateMasterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMasterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMasterMutation, { data, loading, error }] = useCreateMasterMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateMasterMutation(baseOptions?: Apollo.MutationHookOptions<CreateMasterMutation, CreateMasterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMasterMutation, CreateMasterMutationVariables>(CreateMasterDocument, options);
      }
export type CreateMasterMutationHookResult = ReturnType<typeof useCreateMasterMutation>;
export type CreateMasterMutationResult = Apollo.MutationResult<CreateMasterMutation>;
export type CreateMasterMutationOptions = Apollo.BaseMutationOptions<CreateMasterMutation, CreateMasterMutationVariables>;
export const CreateProjectStatusDocument = gql`
    mutation createProjectStatus($data: ProjectStatusCreateInput!) {
  createProjectStatus(data: $data) {
    id
    projectId
  }
}
    `;
export type CreateProjectStatusMutationFn = Apollo.MutationFunction<CreateProjectStatusMutation, CreateProjectStatusMutationVariables>;

/**
 * __useCreateProjectStatusMutation__
 *
 * To run a mutation, you first call `useCreateProjectStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectStatusMutation, { data, loading, error }] = useCreateProjectStatusMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateProjectStatusMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectStatusMutation, CreateProjectStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectStatusMutation, CreateProjectStatusMutationVariables>(CreateProjectStatusDocument, options);
      }
export type CreateProjectStatusMutationHookResult = ReturnType<typeof useCreateProjectStatusMutation>;
export type CreateProjectStatusMutationResult = Apollo.MutationResult<CreateProjectStatusMutation>;
export type CreateProjectStatusMutationOptions = Apollo.BaseMutationOptions<CreateProjectStatusMutation, CreateProjectStatusMutationVariables>;
export const UpdateProjectStatusDocument = gql`
    mutation updateProjectStatus($data: ProjectStatusUpdateInput!, $where: ProjectStatusWhereUniqueInput!) {
  updateProjectStatus(data: $data, where: $where) {
    id
    projectId
  }
}
    `;
export type UpdateProjectStatusMutationFn = Apollo.MutationFunction<UpdateProjectStatusMutation, UpdateProjectStatusMutationVariables>;

/**
 * __useUpdateProjectStatusMutation__
 *
 * To run a mutation, you first call `useUpdateProjectStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectStatusMutation, { data, loading, error }] = useUpdateProjectStatusMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateProjectStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectStatusMutation, UpdateProjectStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectStatusMutation, UpdateProjectStatusMutationVariables>(UpdateProjectStatusDocument, options);
      }
export type UpdateProjectStatusMutationHookResult = ReturnType<typeof useUpdateProjectStatusMutation>;
export type UpdateProjectStatusMutationResult = Apollo.MutationResult<UpdateProjectStatusMutation>;
export type UpdateProjectStatusMutationOptions = Apollo.BaseMutationOptions<UpdateProjectStatusMutation, UpdateProjectStatusMutationVariables>;
export const UpdateProjectRoleDocument = gql`
    mutation updateProjectRole($data: ProjectRoleUpdateInput!, $where: ProjectRoleWhereUniqueInput!) {
  updateProjectRole(data: $data, where: $where) {
    id
  }
}
    `;
export type UpdateProjectRoleMutationFn = Apollo.MutationFunction<UpdateProjectRoleMutation, UpdateProjectRoleMutationVariables>;

/**
 * __useUpdateProjectRoleMutation__
 *
 * To run a mutation, you first call `useUpdateProjectRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectRoleMutation, { data, loading, error }] = useUpdateProjectRoleMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateProjectRoleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectRoleMutation, UpdateProjectRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectRoleMutation, UpdateProjectRoleMutationVariables>(UpdateProjectRoleDocument, options);
      }
export type UpdateProjectRoleMutationHookResult = ReturnType<typeof useUpdateProjectRoleMutation>;
export type UpdateProjectRoleMutationResult = Apollo.MutationResult<UpdateProjectRoleMutation>;
export type UpdateProjectRoleMutationOptions = Apollo.BaseMutationOptions<UpdateProjectRoleMutation, UpdateProjectRoleMutationVariables>;
export const CreateGoalsOnMasterDocument = gql`
    mutation createGoalsOnMaster($data: GoalsOnMasterCreateInput!) {
  createGoalsOnMaster(data: $data) {
    id
  }
}
    `;
export type CreateGoalsOnMasterMutationFn = Apollo.MutationFunction<CreateGoalsOnMasterMutation, CreateGoalsOnMasterMutationVariables>;

/**
 * __useCreateGoalsOnMasterMutation__
 *
 * To run a mutation, you first call `useCreateGoalsOnMasterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGoalsOnMasterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGoalsOnMasterMutation, { data, loading, error }] = useCreateGoalsOnMasterMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateGoalsOnMasterMutation(baseOptions?: Apollo.MutationHookOptions<CreateGoalsOnMasterMutation, CreateGoalsOnMasterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGoalsOnMasterMutation, CreateGoalsOnMasterMutationVariables>(CreateGoalsOnMasterDocument, options);
      }
export type CreateGoalsOnMasterMutationHookResult = ReturnType<typeof useCreateGoalsOnMasterMutation>;
export type CreateGoalsOnMasterMutationResult = Apollo.MutationResult<CreateGoalsOnMasterMutation>;
export type CreateGoalsOnMasterMutationOptions = Apollo.BaseMutationOptions<CreateGoalsOnMasterMutation, CreateGoalsOnMasterMutationVariables>;
export const CreateProjectDocumentDocument = gql`
    mutation createProjectDocument($data: ProjectDocumentsCreateInput!, $file: Upload!) {
  createProjectDocument(data: $data, file: $file) {
    id
    uri
  }
}
    `;
export type CreateProjectDocumentMutationFn = Apollo.MutationFunction<CreateProjectDocumentMutation, CreateProjectDocumentMutationVariables>;

/**
 * __useCreateProjectDocumentMutation__
 *
 * To run a mutation, you first call `useCreateProjectDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectDocumentMutation, { data, loading, error }] = useCreateProjectDocumentMutation({
 *   variables: {
 *      data: // value for 'data'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useCreateProjectDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectDocumentMutation, CreateProjectDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectDocumentMutation, CreateProjectDocumentMutationVariables>(CreateProjectDocumentDocument, options);
      }
export type CreateProjectDocumentMutationHookResult = ReturnType<typeof useCreateProjectDocumentMutation>;
export type CreateProjectDocumentMutationResult = Apollo.MutationResult<CreateProjectDocumentMutation>;
export type CreateProjectDocumentMutationOptions = Apollo.BaseMutationOptions<CreateProjectDocumentMutation, CreateProjectDocumentMutationVariables>;
export const RemoveProjectDocumentDocument = gql`
    mutation removeProjectDocument($where: ProjectDocumentsWhereUniqueInput!) {
  removeProjectDocument(where: $where) {
    id
  }
}
    `;
export type RemoveProjectDocumentMutationFn = Apollo.MutationFunction<RemoveProjectDocumentMutation, RemoveProjectDocumentMutationVariables>;

/**
 * __useRemoveProjectDocumentMutation__
 *
 * To run a mutation, you first call `useRemoveProjectDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveProjectDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeProjectDocumentMutation, { data, loading, error }] = useRemoveProjectDocumentMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useRemoveProjectDocumentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveProjectDocumentMutation, RemoveProjectDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveProjectDocumentMutation, RemoveProjectDocumentMutationVariables>(RemoveProjectDocumentDocument, options);
      }
export type RemoveProjectDocumentMutationHookResult = ReturnType<typeof useRemoveProjectDocumentMutation>;
export type RemoveProjectDocumentMutationResult = Apollo.MutationResult<RemoveProjectDocumentMutation>;
export type RemoveProjectDocumentMutationOptions = Apollo.BaseMutationOptions<RemoveProjectDocumentMutation, RemoveProjectDocumentMutationVariables>;
export const GetProjectsDocument = gql`
    query getProjects {
  masters {
    id
    projectDescriptions {
      id
      name
      description
    }
    projectStatus {
      sequenceStatusId
    }
    createdAt
  }
}
    `;

/**
 * __useGetProjectsQuery__
 *
 * To run a query within a React component, call `useGetProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetProjectsQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectsQuery, GetProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectsQuery, GetProjectsQueryVariables>(GetProjectsDocument, options);
      }
export function useGetProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectsQuery, GetProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectsQuery, GetProjectsQueryVariables>(GetProjectsDocument, options);
        }
export type GetProjectsQueryHookResult = ReturnType<typeof useGetProjectsQuery>;
export type GetProjectsLazyQueryHookResult = ReturnType<typeof useGetProjectsLazyQuery>;
export type GetProjectsQueryResult = Apollo.QueryResult<GetProjectsQuery, GetProjectsQueryVariables>;
export const GetApprovalBoardsDocument = gql`
    query getApprovalBoards {
  approvalBoards {
    id
    description
  }
}
    `;

/**
 * __useGetApprovalBoardsQuery__
 *
 * To run a query within a React component, call `useGetApprovalBoardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApprovalBoardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApprovalBoardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetApprovalBoardsQuery(baseOptions?: Apollo.QueryHookOptions<GetApprovalBoardsQuery, GetApprovalBoardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApprovalBoardsQuery, GetApprovalBoardsQueryVariables>(GetApprovalBoardsDocument, options);
      }
export function useGetApprovalBoardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApprovalBoardsQuery, GetApprovalBoardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApprovalBoardsQuery, GetApprovalBoardsQueryVariables>(GetApprovalBoardsDocument, options);
        }
export type GetApprovalBoardsQueryHookResult = ReturnType<typeof useGetApprovalBoardsQuery>;
export type GetApprovalBoardsLazyQueryHookResult = ReturnType<typeof useGetApprovalBoardsLazyQuery>;
export type GetApprovalBoardsQueryResult = Apollo.QueryResult<GetApprovalBoardsQuery, GetApprovalBoardsQueryVariables>;
export const GetMasterWithApprovalsDocument = gql`
    query getMasterWithApprovals($where: MasterWhereInput) {
  masters(where: $where) {
    id
    projectApproval {
      id
      ApprovalBoard {
        id
        description
      }
      approvalStatus {
        id
        description
      }
    }
    projectStatus {
      id
      sequenceStatusId
      deletedBy
    }
    projectDescriptions {
      name
    }
  }
}
    `;

/**
 * __useGetMasterWithApprovalsQuery__
 *
 * To run a query within a React component, call `useGetMasterWithApprovalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMasterWithApprovalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMasterWithApprovalsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetMasterWithApprovalsQuery(baseOptions?: Apollo.QueryHookOptions<GetMasterWithApprovalsQuery, GetMasterWithApprovalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMasterWithApprovalsQuery, GetMasterWithApprovalsQueryVariables>(GetMasterWithApprovalsDocument, options);
      }
export function useGetMasterWithApprovalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMasterWithApprovalsQuery, GetMasterWithApprovalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMasterWithApprovalsQuery, GetMasterWithApprovalsQueryVariables>(GetMasterWithApprovalsDocument, options);
        }
export type GetMasterWithApprovalsQueryHookResult = ReturnType<typeof useGetMasterWithApprovalsQuery>;
export type GetMasterWithApprovalsLazyQueryHookResult = ReturnType<typeof useGetMasterWithApprovalsLazyQuery>;
export type GetMasterWithApprovalsQueryResult = Apollo.QueryResult<GetMasterWithApprovalsQuery, GetMasterWithApprovalsQueryVariables>;
export const GetProjectsByStatusDocument = gql`
    query getProjectsByStatus($where: MasterWhereInput) {
  masters(where: $where) {
    id
    projectDescriptions {
      id
      name
      description
    }
    projectStatus {
      id
      sequenceStatusId
      deletedBy
    }
    createdAt
    createdBy
  }
}
    `;

/**
 * __useGetProjectsByStatusQuery__
 *
 * To run a query within a React component, call `useGetProjectsByStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectsByStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectsByStatusQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetProjectsByStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectsByStatusQuery, GetProjectsByStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectsByStatusQuery, GetProjectsByStatusQueryVariables>(GetProjectsByStatusDocument, options);
      }
export function useGetProjectsByStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectsByStatusQuery, GetProjectsByStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectsByStatusQuery, GetProjectsByStatusQueryVariables>(GetProjectsByStatusDocument, options);
        }
export type GetProjectsByStatusQueryHookResult = ReturnType<typeof useGetProjectsByStatusQuery>;
export type GetProjectsByStatusLazyQueryHookResult = ReturnType<typeof useGetProjectsByStatusLazyQuery>;
export type GetProjectsByStatusQueryResult = Apollo.QueryResult<GetProjectsByStatusQuery, GetProjectsByStatusQueryVariables>;
export const GetMailInfoByProjectDocument = gql`
    query getMailInfoByProject($where: MasterWhereUniqueInput!, $where2: EmployeeMasterWhereInput) {
  master(where: $where) {
    projectDescriptions {
      name
    }
  }
  employeeMasters(where: $where2) {
    employee {
      firstName
      lastName
      email
    }
  }
}
    `;

/**
 * __useGetMailInfoByProjectQuery__
 *
 * To run a query within a React component, call `useGetMailInfoByProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMailInfoByProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMailInfoByProjectQuery({
 *   variables: {
 *      where: // value for 'where'
 *      where2: // value for 'where2'
 *   },
 * });
 */
export function useGetMailInfoByProjectQuery(baseOptions: Apollo.QueryHookOptions<GetMailInfoByProjectQuery, GetMailInfoByProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMailInfoByProjectQuery, GetMailInfoByProjectQueryVariables>(GetMailInfoByProjectDocument, options);
      }
export function useGetMailInfoByProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMailInfoByProjectQuery, GetMailInfoByProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMailInfoByProjectQuery, GetMailInfoByProjectQueryVariables>(GetMailInfoByProjectDocument, options);
        }
export type GetMailInfoByProjectQueryHookResult = ReturnType<typeof useGetMailInfoByProjectQuery>;
export type GetMailInfoByProjectLazyQueryHookResult = ReturnType<typeof useGetMailInfoByProjectLazyQuery>;
export type GetMailInfoByProjectQueryResult = Apollo.QueryResult<GetMailInfoByProjectQuery, GetMailInfoByProjectQueryVariables>;
export const DashboardGetFilteredProjectsDocument = gql`
    query dashboardGetFilteredProjects($projectStatus: [String!], $projectDescriptions: [String!]) {
  masters(
    where: {projectStatus: {some: {sequenceStatusId: {in: $projectStatus}, deletedBy: {equals: null}}}, projectDescriptions: {some: {projectId: {in: $projectDescriptions}, deletedBy: {equals: null}}}}
  ) {
    ...MasterDetails
  }
}
    ${MasterDetailsFragmentDoc}`;

/**
 * __useDashboardGetFilteredProjectsQuery__
 *
 * To run a query within a React component, call `useDashboardGetFilteredProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardGetFilteredProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardGetFilteredProjectsQuery({
 *   variables: {
 *      projectStatus: // value for 'projectStatus'
 *      projectDescriptions: // value for 'projectDescriptions'
 *   },
 * });
 */
export function useDashboardGetFilteredProjectsQuery(baseOptions?: Apollo.QueryHookOptions<DashboardGetFilteredProjectsQuery, DashboardGetFilteredProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardGetFilteredProjectsQuery, DashboardGetFilteredProjectsQueryVariables>(DashboardGetFilteredProjectsDocument, options);
      }
export function useDashboardGetFilteredProjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardGetFilteredProjectsQuery, DashboardGetFilteredProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardGetFilteredProjectsQuery, DashboardGetFilteredProjectsQueryVariables>(DashboardGetFilteredProjectsDocument, options);
        }
export type DashboardGetFilteredProjectsQueryHookResult = ReturnType<typeof useDashboardGetFilteredProjectsQuery>;
export type DashboardGetFilteredProjectsLazyQueryHookResult = ReturnType<typeof useDashboardGetFilteredProjectsLazyQuery>;
export type DashboardGetFilteredProjectsQueryResult = Apollo.QueryResult<DashboardGetFilteredProjectsQuery, DashboardGetFilteredProjectsQueryVariables>;
export const DashboardGetFilteredProjectsByResourceDocument = gql`
    query dashboardGetFilteredProjectsByResource($projectStatus: [String!], $projectEmployee: String) {
  masters(
    where: {projectStatus: {some: {sequenceStatusId: {in: $projectStatus}, deletedBy: {equals: null}}}, OR: [{projectRole: {some: {employeeId: {equals: $projectEmployee}, deletedBy: {equals: null}, roleId: {equals: "Projektleitung"}}}}, {projectResourceCapture: {some: {employeeId: {equals: $projectEmployee}, deletedBy: {equals: null}}}}]}
  ) {
    id
    projectDescriptions {
      name
      background
      deletedBy
    }
    projectStatus {
      sequenceStatusId
      deletedBy
    }
    projectRole {
      role {
        id
      }
      employee {
        lastName
      }
    }
  }
}
    `;

/**
 * __useDashboardGetFilteredProjectsByResourceQuery__
 *
 * To run a query within a React component, call `useDashboardGetFilteredProjectsByResourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardGetFilteredProjectsByResourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardGetFilteredProjectsByResourceQuery({
 *   variables: {
 *      projectStatus: // value for 'projectStatus'
 *      projectEmployee: // value for 'projectEmployee'
 *   },
 * });
 */
export function useDashboardGetFilteredProjectsByResourceQuery(baseOptions?: Apollo.QueryHookOptions<DashboardGetFilteredProjectsByResourceQuery, DashboardGetFilteredProjectsByResourceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardGetFilteredProjectsByResourceQuery, DashboardGetFilteredProjectsByResourceQueryVariables>(DashboardGetFilteredProjectsByResourceDocument, options);
      }
export function useDashboardGetFilteredProjectsByResourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardGetFilteredProjectsByResourceQuery, DashboardGetFilteredProjectsByResourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardGetFilteredProjectsByResourceQuery, DashboardGetFilteredProjectsByResourceQueryVariables>(DashboardGetFilteredProjectsByResourceDocument, options);
        }
export type DashboardGetFilteredProjectsByResourceQueryHookResult = ReturnType<typeof useDashboardGetFilteredProjectsByResourceQuery>;
export type DashboardGetFilteredProjectsByResourceLazyQueryHookResult = ReturnType<typeof useDashboardGetFilteredProjectsByResourceLazyQuery>;
export type DashboardGetFilteredProjectsByResourceQueryResult = Apollo.QueryResult<DashboardGetFilteredProjectsByResourceQuery, DashboardGetFilteredProjectsByResourceQueryVariables>;
export const DashboardGetProjectByIdDocument = gql`
    query dashboardGetProjectById($id: String!) {
  masters(where: {id: {equals: $id}}) {
    ...MasterDetails
  }
}
    ${MasterDetailsFragmentDoc}`;

/**
 * __useDashboardGetProjectByIdQuery__
 *
 * To run a query within a React component, call `useDashboardGetProjectByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardGetProjectByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardGetProjectByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDashboardGetProjectByIdQuery(baseOptions: Apollo.QueryHookOptions<DashboardGetProjectByIdQuery, DashboardGetProjectByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardGetProjectByIdQuery, DashboardGetProjectByIdQueryVariables>(DashboardGetProjectByIdDocument, options);
      }
export function useDashboardGetProjectByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardGetProjectByIdQuery, DashboardGetProjectByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardGetProjectByIdQuery, DashboardGetProjectByIdQueryVariables>(DashboardGetProjectByIdDocument, options);
        }
export type DashboardGetProjectByIdQueryHookResult = ReturnType<typeof useDashboardGetProjectByIdQuery>;
export type DashboardGetProjectByIdLazyQueryHookResult = ReturnType<typeof useDashboardGetProjectByIdLazyQuery>;
export type DashboardGetProjectByIdQueryResult = Apollo.QueryResult<DashboardGetProjectByIdQuery, DashboardGetProjectByIdQueryVariables>;
export const GetEmployeeByIdDocument = gql`
    query getEmployeeById($id: String!) {
  employee(where: {id: $id}) {
    id
    firstName
    lastName
    email
  }
}
    `;

/**
 * __useGetEmployeeByIdQuery__
 *
 * To run a query within a React component, call `useGetEmployeeByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEmployeeByIdQuery(baseOptions: Apollo.QueryHookOptions<GetEmployeeByIdQuery, GetEmployeeByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeeByIdQuery, GetEmployeeByIdQueryVariables>(GetEmployeeByIdDocument, options);
      }
export function useGetEmployeeByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeeByIdQuery, GetEmployeeByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeeByIdQuery, GetEmployeeByIdQueryVariables>(GetEmployeeByIdDocument, options);
        }
export type GetEmployeeByIdQueryHookResult = ReturnType<typeof useGetEmployeeByIdQuery>;
export type GetEmployeeByIdLazyQueryHookResult = ReturnType<typeof useGetEmployeeByIdLazyQuery>;
export type GetEmployeeByIdQueryResult = Apollo.QueryResult<GetEmployeeByIdQuery, GetEmployeeByIdQueryVariables>;
export const UpdateApprovalStatusDocument = gql`
    mutation updateApprovalStatus($data: MasterUpdateInput!, $projectId: String!) {
  updateMaster(data: $data, where: {id: $projectId}) {
    id
  }
}
    `;
export type UpdateApprovalStatusMutationFn = Apollo.MutationFunction<UpdateApprovalStatusMutation, UpdateApprovalStatusMutationVariables>;

/**
 * __useUpdateApprovalStatusMutation__
 *
 * To run a mutation, you first call `useUpdateApprovalStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApprovalStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApprovalStatusMutation, { data, loading, error }] = useUpdateApprovalStatusMutation({
 *   variables: {
 *      data: // value for 'data'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useUpdateApprovalStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateApprovalStatusMutation, UpdateApprovalStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateApprovalStatusMutation, UpdateApprovalStatusMutationVariables>(UpdateApprovalStatusDocument, options);
      }
export type UpdateApprovalStatusMutationHookResult = ReturnType<typeof useUpdateApprovalStatusMutation>;
export type UpdateApprovalStatusMutationResult = Apollo.MutationResult<UpdateApprovalStatusMutation>;
export type UpdateApprovalStatusMutationOptions = Apollo.BaseMutationOptions<UpdateApprovalStatusMutation, UpdateApprovalStatusMutationVariables>;
export const GetFinancesByProjectDocument = gql`
    query getFinancesByProject($where: FinanceWhereInput, $orderBy: [FinanceOrderByWithRelationInput!]) {
  finances(where: $where, orderBy: $orderBy) {
    id
    value
    year
    asset {
      id
      isProjectCosts
    }
    company {
      id
    }
  }
}
    `;

/**
 * __useGetFinancesByProjectQuery__
 *
 * To run a query within a React component, call `useGetFinancesByProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinancesByProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinancesByProjectQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetFinancesByProjectQuery(baseOptions?: Apollo.QueryHookOptions<GetFinancesByProjectQuery, GetFinancesByProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFinancesByProjectQuery, GetFinancesByProjectQueryVariables>(GetFinancesByProjectDocument, options);
      }
export function useGetFinancesByProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFinancesByProjectQuery, GetFinancesByProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFinancesByProjectQuery, GetFinancesByProjectQueryVariables>(GetFinancesByProjectDocument, options);
        }
export type GetFinancesByProjectQueryHookResult = ReturnType<typeof useGetFinancesByProjectQuery>;
export type GetFinancesByProjectLazyQueryHookResult = ReturnType<typeof useGetFinancesByProjectLazyQuery>;
export type GetFinancesByProjectQueryResult = Apollo.QueryResult<GetFinancesByProjectQuery, GetFinancesByProjectQueryVariables>;
export const GetFinancialByProjectDocument = gql`
    query getFinancialByProject($where: FinanceWhereInput, $financeOrderBy: [FinanceOrderByWithRelationInput!], $assetsOrderBy: [AssetOrderByWithRelationInput!], $companiesOrderBy: [CompanyOrderByWithRelationInput!]) {
  finances(where: $where, orderBy: $financeOrderBy) {
    id
    value
    year
    asset {
      id
      isProjectCosts
    }
    company {
      id
    }
    deletedBy
  }
  assets(orderBy: $assetsOrderBy) {
    id
    isProjectCosts
    description
  }
  companies(orderBy: $companiesOrderBy) {
    id
    description
  }
}
    `;

/**
 * __useGetFinancialByProjectQuery__
 *
 * To run a query within a React component, call `useGetFinancialByProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinancialByProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinancialByProjectQuery({
 *   variables: {
 *      where: // value for 'where'
 *      financeOrderBy: // value for 'financeOrderBy'
 *      assetsOrderBy: // value for 'assetsOrderBy'
 *      companiesOrderBy: // value for 'companiesOrderBy'
 *   },
 * });
 */
export function useGetFinancialByProjectQuery(baseOptions?: Apollo.QueryHookOptions<GetFinancialByProjectQuery, GetFinancialByProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFinancialByProjectQuery, GetFinancialByProjectQueryVariables>(GetFinancialByProjectDocument, options);
      }
export function useGetFinancialByProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFinancialByProjectQuery, GetFinancialByProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFinancialByProjectQuery, GetFinancialByProjectQueryVariables>(GetFinancialByProjectDocument, options);
        }
export type GetFinancialByProjectQueryHookResult = ReturnType<typeof useGetFinancialByProjectQuery>;
export type GetFinancialByProjectLazyQueryHookResult = ReturnType<typeof useGetFinancialByProjectLazyQuery>;
export type GetFinancialByProjectQueryResult = Apollo.QueryResult<GetFinancialByProjectQuery, GetFinancialByProjectQueryVariables>;
export const GetFinancialSumByProjectDocument = gql`
    query getFinancialSumByProject($where: FinanceWhereInput, $financeOrderBy: [FinanceOrderByWithRelationInput!], $assetsOrderBy: [AssetOrderByWithRelationInput!], $companiesOrderBy: [CompanyOrderByWithRelationInput!]) {
  finances(where: $where, orderBy: $financeOrderBy) {
    id
    assetId
    companyId
    year
    value
    createdAt
  }
  assets(orderBy: $assetsOrderBy) {
    id
    isProjectCosts
    description
  }
  companies(orderBy: $companiesOrderBy) {
    id
    description
  }
}
    `;

/**
 * __useGetFinancialSumByProjectQuery__
 *
 * To run a query within a React component, call `useGetFinancialSumByProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinancialSumByProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinancialSumByProjectQuery({
 *   variables: {
 *      where: // value for 'where'
 *      financeOrderBy: // value for 'financeOrderBy'
 *      assetsOrderBy: // value for 'assetsOrderBy'
 *      companiesOrderBy: // value for 'companiesOrderBy'
 *   },
 * });
 */
export function useGetFinancialSumByProjectQuery(baseOptions?: Apollo.QueryHookOptions<GetFinancialSumByProjectQuery, GetFinancialSumByProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFinancialSumByProjectQuery, GetFinancialSumByProjectQueryVariables>(GetFinancialSumByProjectDocument, options);
      }
export function useGetFinancialSumByProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFinancialSumByProjectQuery, GetFinancialSumByProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFinancialSumByProjectQuery, GetFinancialSumByProjectQueryVariables>(GetFinancialSumByProjectDocument, options);
        }
export type GetFinancialSumByProjectQueryHookResult = ReturnType<typeof useGetFinancialSumByProjectQuery>;
export type GetFinancialSumByProjectLazyQueryHookResult = ReturnType<typeof useGetFinancialSumByProjectLazyQuery>;
export type GetFinancialSumByProjectQueryResult = Apollo.QueryResult<GetFinancialSumByProjectQuery, GetFinancialSumByProjectQueryVariables>;
export const GetLastFinancesPerYearDocument = gql`
    query getLastFinancesPerYear($olderThan: DateTime, $projectId: String, $where: FinanceWhereInput) {
  getLastFinancesPerYear(
    olderThan: $olderThan
    projectId: $projectId
    where: $where
  ) {
    id
    value
    assetId
    companyId
    year
  }
}
    `;

/**
 * __useGetLastFinancesPerYearQuery__
 *
 * To run a query within a React component, call `useGetLastFinancesPerYearQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLastFinancesPerYearQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLastFinancesPerYearQuery({
 *   variables: {
 *      olderThan: // value for 'olderThan'
 *      projectId: // value for 'projectId'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetLastFinancesPerYearQuery(baseOptions?: Apollo.QueryHookOptions<GetLastFinancesPerYearQuery, GetLastFinancesPerYearQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLastFinancesPerYearQuery, GetLastFinancesPerYearQueryVariables>(GetLastFinancesPerYearDocument, options);
      }
export function useGetLastFinancesPerYearLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLastFinancesPerYearQuery, GetLastFinancesPerYearQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLastFinancesPerYearQuery, GetLastFinancesPerYearQueryVariables>(GetLastFinancesPerYearDocument, options);
        }
export type GetLastFinancesPerYearQueryHookResult = ReturnType<typeof useGetLastFinancesPerYearQuery>;
export type GetLastFinancesPerYearLazyQueryHookResult = ReturnType<typeof useGetLastFinancesPerYearLazyQuery>;
export type GetLastFinancesPerYearQueryResult = Apollo.QueryResult<GetLastFinancesPerYearQuery, GetLastFinancesPerYearQueryVariables>;
export const GroupByFinancialDocument = gql`
    query groupByFinancial($by: [FinanceScalarFieldEnum!]!, $sum: FinanceSumAggregateInput, $where: FinanceWhereInput, $assetsOrderBy: [AssetOrderByWithRelationInput!], $companiesOrderBy: [CompanyOrderByWithRelationInput!]) {
  groupFinances(by: $by, _sum: $sum, where: $where) {
    assetId
    companyId
    year
    _sum {
      value
    }
  }
  assets(orderBy: $assetsOrderBy) {
    id
    isProjectCosts
    description
  }
  companies(orderBy: $companiesOrderBy) {
    id
    description
  }
}
    `;

/**
 * __useGroupByFinancialQuery__
 *
 * To run a query within a React component, call `useGroupByFinancialQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupByFinancialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupByFinancialQuery({
 *   variables: {
 *      by: // value for 'by'
 *      sum: // value for 'sum'
 *      where: // value for 'where'
 *      assetsOrderBy: // value for 'assetsOrderBy'
 *      companiesOrderBy: // value for 'companiesOrderBy'
 *   },
 * });
 */
export function useGroupByFinancialQuery(baseOptions: Apollo.QueryHookOptions<GroupByFinancialQuery, GroupByFinancialQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupByFinancialQuery, GroupByFinancialQueryVariables>(GroupByFinancialDocument, options);
      }
export function useGroupByFinancialLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupByFinancialQuery, GroupByFinancialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupByFinancialQuery, GroupByFinancialQueryVariables>(GroupByFinancialDocument, options);
        }
export type GroupByFinancialQueryHookResult = ReturnType<typeof useGroupByFinancialQuery>;
export type GroupByFinancialLazyQueryHookResult = ReturnType<typeof useGroupByFinancialLazyQuery>;
export type GroupByFinancialQueryResult = Apollo.QueryResult<GroupByFinancialQuery, GroupByFinancialQueryVariables>;
export const GroupProjectResourceCapturesDocument = gql`
    query groupProjectResourceCaptures($by: [ProjectResourceCaptureScalarFieldEnum!]!, $sum: ProjectResourceCaptureSumAggregateInput, $where: ProjectResourceCaptureWhereInput) {
  groupProjectResourceCaptures(by: $by, _sum: $sum, where: $where) {
    _sum {
      rate
    }
    year
  }
}
    `;

/**
 * __useGroupProjectResourceCapturesQuery__
 *
 * To run a query within a React component, call `useGroupProjectResourceCapturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupProjectResourceCapturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupProjectResourceCapturesQuery({
 *   variables: {
 *      by: // value for 'by'
 *      sum: // value for 'sum'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGroupProjectResourceCapturesQuery(baseOptions: Apollo.QueryHookOptions<GroupProjectResourceCapturesQuery, GroupProjectResourceCapturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupProjectResourceCapturesQuery, GroupProjectResourceCapturesQueryVariables>(GroupProjectResourceCapturesDocument, options);
      }
export function useGroupProjectResourceCapturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupProjectResourceCapturesQuery, GroupProjectResourceCapturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupProjectResourceCapturesQuery, GroupProjectResourceCapturesQueryVariables>(GroupProjectResourceCapturesDocument, options);
        }
export type GroupProjectResourceCapturesQueryHookResult = ReturnType<typeof useGroupProjectResourceCapturesQuery>;
export type GroupProjectResourceCapturesLazyQueryHookResult = ReturnType<typeof useGroupProjectResourceCapturesLazyQuery>;
export type GroupProjectResourceCapturesQueryResult = Apollo.QueryResult<GroupProjectResourceCapturesQuery, GroupProjectResourceCapturesQueryVariables>;
export const GetAssetsByProjectDocument = gql`
    query getAssetsByProject($distinct: [FinanceScalarFieldEnum!], $where: FinanceWhereInput) {
  finances(distinct: $distinct, where: $where) {
    id
    asset {
      id
    }
  }
}
    `;

/**
 * __useGetAssetsByProjectQuery__
 *
 * To run a query within a React component, call `useGetAssetsByProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAssetsByProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAssetsByProjectQuery({
 *   variables: {
 *      distinct: // value for 'distinct'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetAssetsByProjectQuery(baseOptions?: Apollo.QueryHookOptions<GetAssetsByProjectQuery, GetAssetsByProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAssetsByProjectQuery, GetAssetsByProjectQueryVariables>(GetAssetsByProjectDocument, options);
      }
export function useGetAssetsByProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAssetsByProjectQuery, GetAssetsByProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAssetsByProjectQuery, GetAssetsByProjectQueryVariables>(GetAssetsByProjectDocument, options);
        }
export type GetAssetsByProjectQueryHookResult = ReturnType<typeof useGetAssetsByProjectQuery>;
export type GetAssetsByProjectLazyQueryHookResult = ReturnType<typeof useGetAssetsByProjectLazyQuery>;
export type GetAssetsByProjectQueryResult = Apollo.QueryResult<GetAssetsByProjectQuery, GetAssetsByProjectQueryVariables>;
export const CreateEmployeeDocument = gql`
    mutation createEmployee($data: EmployeeCreateInput!) {
  createEmployee(data: $data) {
    id
  }
}
    `;
export type CreateEmployeeMutationFn = Apollo.MutationFunction<CreateEmployeeMutation, CreateEmployeeMutationVariables>;

/**
 * __useCreateEmployeeMutation__
 *
 * To run a mutation, you first call `useCreateEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmployeeMutation, { data, loading, error }] = useCreateEmployeeMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmployeeMutation, CreateEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmployeeMutation, CreateEmployeeMutationVariables>(CreateEmployeeDocument, options);
      }
export type CreateEmployeeMutationHookResult = ReturnType<typeof useCreateEmployeeMutation>;
export type CreateEmployeeMutationResult = Apollo.MutationResult<CreateEmployeeMutation>;
export type CreateEmployeeMutationOptions = Apollo.BaseMutationOptions<CreateEmployeeMutation, CreateEmployeeMutationVariables>;
export const GetEmployeeDocument = gql`
    query getEmployee($where: EmployeeWhereUniqueInput!) {
  employee(where: $where) {
    id
  }
}
    `;

/**
 * __useGetEmployeeQuery__
 *
 * To run a query within a React component, call `useGetEmployeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetEmployeeQuery(baseOptions: Apollo.QueryHookOptions<GetEmployeeQuery, GetEmployeeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeeQuery, GetEmployeeQueryVariables>(GetEmployeeDocument, options);
      }
export function useGetEmployeeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeeQuery, GetEmployeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeeQuery, GetEmployeeQueryVariables>(GetEmployeeDocument, options);
        }
export type GetEmployeeQueryHookResult = ReturnType<typeof useGetEmployeeQuery>;
export type GetEmployeeLazyQueryHookResult = ReturnType<typeof useGetEmployeeLazyQuery>;
export type GetEmployeeQueryResult = Apollo.QueryResult<GetEmployeeQuery, GetEmployeeQueryVariables>;
export const GetProjectDocumentsDocument = gql`
    query getProjectDocuments($where: ProjectDocumentsWhereInput) {
  projectDocuments(where: $where) {
    id
    name
    description
    uri
    location
    project {
      projectDescriptions {
        id
        name
      }
      projectStatus {
        id
      }
    }
  }
}
    `;

/**
 * __useGetProjectDocumentsQuery__
 *
 * To run a query within a React component, call `useGetProjectDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectDocumentsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetProjectDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectDocumentsQuery, GetProjectDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectDocumentsQuery, GetProjectDocumentsQueryVariables>(GetProjectDocumentsDocument, options);
      }
export function useGetProjectDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectDocumentsQuery, GetProjectDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectDocumentsQuery, GetProjectDocumentsQueryVariables>(GetProjectDocumentsDocument, options);
        }
export type GetProjectDocumentsQueryHookResult = ReturnType<typeof useGetProjectDocumentsQuery>;
export type GetProjectDocumentsLazyQueryHookResult = ReturnType<typeof useGetProjectDocumentsLazyQuery>;
export type GetProjectDocumentsQueryResult = Apollo.QueryResult<GetProjectDocumentsQuery, GetProjectDocumentsQueryVariables>;
export const GetEmployeesByRoleDocument = gql`
    query getEmployeesByRole($roleId: String!) {
  projectRoles(where: {roleId: {equals: $roleId}}) {
    id
    role {
      id
      description
    }
    employee {
      firstName
      lastName
      id
    }
  }
}
    `;

/**
 * __useGetEmployeesByRoleQuery__
 *
 * To run a query within a React component, call `useGetEmployeesByRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeesByRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeesByRoleQuery({
 *   variables: {
 *      roleId: // value for 'roleId'
 *   },
 * });
 */
export function useGetEmployeesByRoleQuery(baseOptions: Apollo.QueryHookOptions<GetEmployeesByRoleQuery, GetEmployeesByRoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeesByRoleQuery, GetEmployeesByRoleQueryVariables>(GetEmployeesByRoleDocument, options);
      }
export function useGetEmployeesByRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeesByRoleQuery, GetEmployeesByRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeesByRoleQuery, GetEmployeesByRoleQueryVariables>(GetEmployeesByRoleDocument, options);
        }
export type GetEmployeesByRoleQueryHookResult = ReturnType<typeof useGetEmployeesByRoleQuery>;
export type GetEmployeesByRoleLazyQueryHookResult = ReturnType<typeof useGetEmployeesByRoleLazyQuery>;
export type GetEmployeesByRoleQueryResult = Apollo.QueryResult<GetEmployeesByRoleQuery, GetEmployeesByRoleQueryVariables>;
export const GetAllEmployeesDocument = gql`
    query getAllEmployees {
  employees {
    firstName
    id
    lastName
  }
}
    `;

/**
 * __useGetAllEmployeesQuery__
 *
 * To run a query within a React component, call `useGetAllEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllEmployeesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllEmployeesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllEmployeesQuery, GetAllEmployeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllEmployeesQuery, GetAllEmployeesQueryVariables>(GetAllEmployeesDocument, options);
      }
export function useGetAllEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllEmployeesQuery, GetAllEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllEmployeesQuery, GetAllEmployeesQueryVariables>(GetAllEmployeesDocument, options);
        }
export type GetAllEmployeesQueryHookResult = ReturnType<typeof useGetAllEmployeesQuery>;
export type GetAllEmployeesLazyQueryHookResult = ReturnType<typeof useGetAllEmployeesLazyQuery>;
export type GetAllEmployeesQueryResult = Apollo.QueryResult<GetAllEmployeesQuery, GetAllEmployeesQueryVariables>;
export const CreateProjectRoleDocument = gql`
    mutation createProjectRole($createdBy: String!, $projectId: String!, $roleId: String!, $employeeId: String!, $firstName: String!, $lastName: String!, $email: String!) {
  createProjectRole(
    data: {createdBy: $createdBy, project: {connect: {id: $projectId}}, role: {connect: {id: $roleId}}, employee: {connectOrCreate: {where: {id: $employeeId}, create: {id: $employeeId, firstName: $firstName, lastName: $lastName, email: $email, createdBy: $createdBy}}}}
  ) {
    createdBy
    projectId
    roleId
    employeeId
  }
}
    `;
export type CreateProjectRoleMutationFn = Apollo.MutationFunction<CreateProjectRoleMutation, CreateProjectRoleMutationVariables>;

/**
 * __useCreateProjectRoleMutation__
 *
 * To run a mutation, you first call `useCreateProjectRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectRoleMutation, { data, loading, error }] = useCreateProjectRoleMutation({
 *   variables: {
 *      createdBy: // value for 'createdBy'
 *      projectId: // value for 'projectId'
 *      roleId: // value for 'roleId'
 *      employeeId: // value for 'employeeId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useCreateProjectRoleMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectRoleMutation, CreateProjectRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectRoleMutation, CreateProjectRoleMutationVariables>(CreateProjectRoleDocument, options);
      }
export type CreateProjectRoleMutationHookResult = ReturnType<typeof useCreateProjectRoleMutation>;
export type CreateProjectRoleMutationResult = Apollo.MutationResult<CreateProjectRoleMutation>;
export type CreateProjectRoleMutationOptions = Apollo.BaseMutationOptions<CreateProjectRoleMutation, CreateProjectRoleMutationVariables>;
export const UpdateProjectFundingDocument = gql`
    mutation UpdateProjectFunding($fundingName: String!, $projectId: String!) {
  updateProjectDescription(
    data: {funding: {connect: {fundingName: $fundingName}}}
    where: {id: $projectId}
  ) {
    id
    fundingId
  }
}
    `;
export type UpdateProjectFundingMutationFn = Apollo.MutationFunction<UpdateProjectFundingMutation, UpdateProjectFundingMutationVariables>;

/**
 * __useUpdateProjectFundingMutation__
 *
 * To run a mutation, you first call `useUpdateProjectFundingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectFundingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectFundingMutation, { data, loading, error }] = useUpdateProjectFundingMutation({
 *   variables: {
 *      fundingName: // value for 'fundingName'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useUpdateProjectFundingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectFundingMutation, UpdateProjectFundingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectFundingMutation, UpdateProjectFundingMutationVariables>(UpdateProjectFundingDocument, options);
      }
export type UpdateProjectFundingMutationHookResult = ReturnType<typeof useUpdateProjectFundingMutation>;
export type UpdateProjectFundingMutationResult = Apollo.MutationResult<UpdateProjectFundingMutation>;
export type UpdateProjectFundingMutationOptions = Apollo.BaseMutationOptions<UpdateProjectFundingMutation, UpdateProjectFundingMutationVariables>;
export const GetFundingsDocument = gql`
    query getFundings {
  fundings {
    description
    fundingName
    id
  }
}
    `;

/**
 * __useGetFundingsQuery__
 *
 * To run a query within a React component, call `useGetFundingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFundingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFundingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFundingsQuery(baseOptions?: Apollo.QueryHookOptions<GetFundingsQuery, GetFundingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFundingsQuery, GetFundingsQueryVariables>(GetFundingsDocument, options);
      }
export function useGetFundingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFundingsQuery, GetFundingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFundingsQuery, GetFundingsQueryVariables>(GetFundingsDocument, options);
        }
export type GetFundingsQueryHookResult = ReturnType<typeof useGetFundingsQuery>;
export type GetFundingsLazyQueryHookResult = ReturnType<typeof useGetFundingsLazyQuery>;
export type GetFundingsQueryResult = Apollo.QueryResult<GetFundingsQuery, GetFundingsQueryVariables>;
export const ApprovalBoardsDocument = gql`
    query ApprovalBoards {
  approvalBoards {
    description
    id
  }
}
    `;

/**
 * __useApprovalBoardsQuery__
 *
 * To run a query within a React component, call `useApprovalBoardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useApprovalBoardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApprovalBoardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useApprovalBoardsQuery(baseOptions?: Apollo.QueryHookOptions<ApprovalBoardsQuery, ApprovalBoardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApprovalBoardsQuery, ApprovalBoardsQueryVariables>(ApprovalBoardsDocument, options);
      }
export function useApprovalBoardsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApprovalBoardsQuery, ApprovalBoardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApprovalBoardsQuery, ApprovalBoardsQueryVariables>(ApprovalBoardsDocument, options);
        }
export type ApprovalBoardsQueryHookResult = ReturnType<typeof useApprovalBoardsQuery>;
export type ApprovalBoardsLazyQueryHookResult = ReturnType<typeof useApprovalBoardsLazyQuery>;
export type ApprovalBoardsQueryResult = Apollo.QueryResult<ApprovalBoardsQuery, ApprovalBoardsQueryVariables>;
export const ApproversDocument = gql`
    query Approvers {
  approvers {
    ...Approver
  }
}
    ${ApproverFragmentDoc}`;

/**
 * __useApproversQuery__
 *
 * To run a query within a React component, call `useApproversQuery` and pass it any options that fit your needs.
 * When your component renders, `useApproversQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApproversQuery({
 *   variables: {
 *   },
 * });
 */
export function useApproversQuery(baseOptions?: Apollo.QueryHookOptions<ApproversQuery, ApproversQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApproversQuery, ApproversQueryVariables>(ApproversDocument, options);
      }
export function useApproversLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApproversQuery, ApproversQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApproversQuery, ApproversQueryVariables>(ApproversDocument, options);
        }
export type ApproversQueryHookResult = ReturnType<typeof useApproversQuery>;
export type ApproversLazyQueryHookResult = ReturnType<typeof useApproversLazyQuery>;
export type ApproversQueryResult = Apollo.QueryResult<ApproversQuery, ApproversQueryVariables>;
export const CreateApproverDocument = gql`
    mutation createApprover($data: ApproverCreateInput!) {
  createApprover(data: $data) {
    ...Approver
  }
}
    ${ApproverFragmentDoc}`;
export type CreateApproverMutationFn = Apollo.MutationFunction<CreateApproverMutation, CreateApproverMutationVariables>;

/**
 * __useCreateApproverMutation__
 *
 * To run a mutation, you first call `useCreateApproverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApproverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApproverMutation, { data, loading, error }] = useCreateApproverMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateApproverMutation(baseOptions?: Apollo.MutationHookOptions<CreateApproverMutation, CreateApproverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateApproverMutation, CreateApproverMutationVariables>(CreateApproverDocument, options);
      }
export type CreateApproverMutationHookResult = ReturnType<typeof useCreateApproverMutation>;
export type CreateApproverMutationResult = Apollo.MutationResult<CreateApproverMutation>;
export type CreateApproverMutationOptions = Apollo.BaseMutationOptions<CreateApproverMutation, CreateApproverMutationVariables>;
export const RemoveApproverDocument = gql`
    mutation RemoveApprover($id: String!) {
  removeApprover(where: {id: $id}) {
    id
  }
}
    `;
export type RemoveApproverMutationFn = Apollo.MutationFunction<RemoveApproverMutation, RemoveApproverMutationVariables>;

/**
 * __useRemoveApproverMutation__
 *
 * To run a mutation, you first call `useRemoveApproverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveApproverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeApproverMutation, { data, loading, error }] = useRemoveApproverMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveApproverMutation(baseOptions?: Apollo.MutationHookOptions<RemoveApproverMutation, RemoveApproverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveApproverMutation, RemoveApproverMutationVariables>(RemoveApproverDocument, options);
      }
export type RemoveApproverMutationHookResult = ReturnType<typeof useRemoveApproverMutation>;
export type RemoveApproverMutationResult = Apollo.MutationResult<RemoveApproverMutation>;
export type RemoveApproverMutationOptions = Apollo.BaseMutationOptions<RemoveApproverMutation, RemoveApproverMutationVariables>;
export const UpdateApproverDocument = gql`
    mutation UpdateApprover($data: ApproverUpdateInput!, $id: String!) {
  updateApprover(data: $data, where: {id: $id}) {
    ...Approver
  }
}
    ${ApproverFragmentDoc}`;
export type UpdateApproverMutationFn = Apollo.MutationFunction<UpdateApproverMutation, UpdateApproverMutationVariables>;

/**
 * __useUpdateApproverMutation__
 *
 * To run a mutation, you first call `useUpdateApproverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApproverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApproverMutation, { data, loading, error }] = useUpdateApproverMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateApproverMutation(baseOptions?: Apollo.MutationHookOptions<UpdateApproverMutation, UpdateApproverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateApproverMutation, UpdateApproverMutationVariables>(UpdateApproverDocument, options);
      }
export type UpdateApproverMutationHookResult = ReturnType<typeof useUpdateApproverMutation>;
export type UpdateApproverMutationResult = Apollo.MutationResult<UpdateApproverMutation>;
export type UpdateApproverMutationOptions = Apollo.BaseMutationOptions<UpdateApproverMutation, UpdateApproverMutationVariables>;
export const LandingApplicationsDocument = gql`
    query LandingApplications {
  landingApplications {
    ...LandingApplication
  }
}
    ${LandingApplicationFragmentDoc}`;

/**
 * __useLandingApplicationsQuery__
 *
 * To run a query within a React component, call `useLandingApplicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLandingApplicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLandingApplicationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLandingApplicationsQuery(baseOptions?: Apollo.QueryHookOptions<LandingApplicationsQuery, LandingApplicationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LandingApplicationsQuery, LandingApplicationsQueryVariables>(LandingApplicationsDocument, options);
      }
export function useLandingApplicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LandingApplicationsQuery, LandingApplicationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LandingApplicationsQuery, LandingApplicationsQueryVariables>(LandingApplicationsDocument, options);
        }
export type LandingApplicationsQueryHookResult = ReturnType<typeof useLandingApplicationsQuery>;
export type LandingApplicationsLazyQueryHookResult = ReturnType<typeof useLandingApplicationsLazyQuery>;
export type LandingApplicationsQueryResult = Apollo.QueryResult<LandingApplicationsQuery, LandingApplicationsQueryVariables>;
export const LandingApplicationClustersDocument = gql`
    query LandingApplicationClusters {
  landingApplicationClusters {
    id
    clusterName
    label
    isActive
    tooltip
    icon
    order
    landingApplicationClusterGroup {
      id
      groupId
      deletedBy
    }
    landingApplicationClusterMapping {
      id
      deletedBy
    }
  }
}
    `;

/**
 * __useLandingApplicationClustersQuery__
 *
 * To run a query within a React component, call `useLandingApplicationClustersQuery` and pass it any options that fit your needs.
 * When your component renders, `useLandingApplicationClustersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLandingApplicationClustersQuery({
 *   variables: {
 *   },
 * });
 */
export function useLandingApplicationClustersQuery(baseOptions?: Apollo.QueryHookOptions<LandingApplicationClustersQuery, LandingApplicationClustersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LandingApplicationClustersQuery, LandingApplicationClustersQueryVariables>(LandingApplicationClustersDocument, options);
      }
export function useLandingApplicationClustersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LandingApplicationClustersQuery, LandingApplicationClustersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LandingApplicationClustersQuery, LandingApplicationClustersQueryVariables>(LandingApplicationClustersDocument, options);
        }
export type LandingApplicationClustersQueryHookResult = ReturnType<typeof useLandingApplicationClustersQuery>;
export type LandingApplicationClustersLazyQueryHookResult = ReturnType<typeof useLandingApplicationClustersLazyQuery>;
export type LandingApplicationClustersQueryResult = Apollo.QueryResult<LandingApplicationClustersQuery, LandingApplicationClustersQueryVariables>;
export const CreateLandingApplicationDocument = gql`
    mutation createLandingApplication($data: LandingApplicationCreateInput!, $file: Upload!) {
  createLandingApplication(data: $data, file: $file) {
    ...LandingApplication
  }
}
    ${LandingApplicationFragmentDoc}`;
export type CreateLandingApplicationMutationFn = Apollo.MutationFunction<CreateLandingApplicationMutation, CreateLandingApplicationMutationVariables>;

/**
 * __useCreateLandingApplicationMutation__
 *
 * To run a mutation, you first call `useCreateLandingApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLandingApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLandingApplicationMutation, { data, loading, error }] = useCreateLandingApplicationMutation({
 *   variables: {
 *      data: // value for 'data'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useCreateLandingApplicationMutation(baseOptions?: Apollo.MutationHookOptions<CreateLandingApplicationMutation, CreateLandingApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLandingApplicationMutation, CreateLandingApplicationMutationVariables>(CreateLandingApplicationDocument, options);
      }
export type CreateLandingApplicationMutationHookResult = ReturnType<typeof useCreateLandingApplicationMutation>;
export type CreateLandingApplicationMutationResult = Apollo.MutationResult<CreateLandingApplicationMutation>;
export type CreateLandingApplicationMutationOptions = Apollo.BaseMutationOptions<CreateLandingApplicationMutation, CreateLandingApplicationMutationVariables>;
export const UpdateLandingApplicationDocument = gql`
    mutation updateLandingApplication($data: LandingApplicationUpdateInput!, $id: String!, $file: Upload) {
  updateLandingApplication(data: $data, where: {id: $id}, file: $file) {
    ...LandingApplication
  }
}
    ${LandingApplicationFragmentDoc}`;
export type UpdateLandingApplicationMutationFn = Apollo.MutationFunction<UpdateLandingApplicationMutation, UpdateLandingApplicationMutationVariables>;

/**
 * __useUpdateLandingApplicationMutation__
 *
 * To run a mutation, you first call `useUpdateLandingApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLandingApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLandingApplicationMutation, { data, loading, error }] = useUpdateLandingApplicationMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUpdateLandingApplicationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLandingApplicationMutation, UpdateLandingApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLandingApplicationMutation, UpdateLandingApplicationMutationVariables>(UpdateLandingApplicationDocument, options);
      }
export type UpdateLandingApplicationMutationHookResult = ReturnType<typeof useUpdateLandingApplicationMutation>;
export type UpdateLandingApplicationMutationResult = Apollo.MutationResult<UpdateLandingApplicationMutation>;
export type UpdateLandingApplicationMutationOptions = Apollo.BaseMutationOptions<UpdateLandingApplicationMutation, UpdateLandingApplicationMutationVariables>;
export const ProjectApprovalsDocument = gql`
    query ProjectApprovals($approvalStatus: String) {
  projectApprovals(where: {approvalStatus: {id: {contains: $approvalStatus}}}) {
    id
    project {
      id
      projectDescriptions {
        name
      }
    }
    ApprovalBoard {
      description
      id
    }
    approvalStatus {
      description
      id
    }
    approvalBoardId
    createdAt
    comment
  }
}
    `;

/**
 * __useProjectApprovalsQuery__
 *
 * To run a query within a React component, call `useProjectApprovalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectApprovalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectApprovalsQuery({
 *   variables: {
 *      approvalStatus: // value for 'approvalStatus'
 *   },
 * });
 */
export function useProjectApprovalsQuery(baseOptions?: Apollo.QueryHookOptions<ProjectApprovalsQuery, ProjectApprovalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectApprovalsQuery, ProjectApprovalsQueryVariables>(ProjectApprovalsDocument, options);
      }
export function useProjectApprovalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectApprovalsQuery, ProjectApprovalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectApprovalsQuery, ProjectApprovalsQueryVariables>(ProjectApprovalsDocument, options);
        }
export type ProjectApprovalsQueryHookResult = ReturnType<typeof useProjectApprovalsQuery>;
export type ProjectApprovalsLazyQueryHookResult = ReturnType<typeof useProjectApprovalsLazyQuery>;
export type ProjectApprovalsQueryResult = Apollo.QueryResult<ProjectApprovalsQuery, ProjectApprovalsQueryVariables>;
export const ApprovalStatusesDocument = gql`
    query ApprovalStatuses {
  approvalStatuses {
    id
    description
  }
}
    `;

/**
 * __useApprovalStatusesQuery__
 *
 * To run a query within a React component, call `useApprovalStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useApprovalStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApprovalStatusesQuery({
 *   variables: {
 *   },
 * });
 */
export function useApprovalStatusesQuery(baseOptions?: Apollo.QueryHookOptions<ApprovalStatusesQuery, ApprovalStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApprovalStatusesQuery, ApprovalStatusesQueryVariables>(ApprovalStatusesDocument, options);
      }
export function useApprovalStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApprovalStatusesQuery, ApprovalStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApprovalStatusesQuery, ApprovalStatusesQueryVariables>(ApprovalStatusesDocument, options);
        }
export type ApprovalStatusesQueryHookResult = ReturnType<typeof useApprovalStatusesQuery>;
export type ApprovalStatusesLazyQueryHookResult = ReturnType<typeof useApprovalStatusesLazyQuery>;
export type ApprovalStatusesQueryResult = Apollo.QueryResult<ApprovalStatusesQuery, ApprovalStatusesQueryVariables>;
export const ApproverProcessesDocument = gql`
    query ApproverProcesses {
  approverProcesses {
    description
    id
    approverRecipient {
      firstName
    }
  }
}
    `;

/**
 * __useApproverProcessesQuery__
 *
 * To run a query within a React component, call `useApproverProcessesQuery` and pass it any options that fit your needs.
 * When your component renders, `useApproverProcessesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApproverProcessesQuery({
 *   variables: {
 *   },
 * });
 */
export function useApproverProcessesQuery(baseOptions?: Apollo.QueryHookOptions<ApproverProcessesQuery, ApproverProcessesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApproverProcessesQuery, ApproverProcessesQueryVariables>(ApproverProcessesDocument, options);
      }
export function useApproverProcessesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApproverProcessesQuery, ApproverProcessesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApproverProcessesQuery, ApproverProcessesQueryVariables>(ApproverProcessesDocument, options);
        }
export type ApproverProcessesQueryHookResult = ReturnType<typeof useApproverProcessesQuery>;
export type ApproverProcessesLazyQueryHookResult = ReturnType<typeof useApproverProcessesLazyQuery>;
export type ApproverProcessesQueryResult = Apollo.QueryResult<ApproverProcessesQuery, ApproverProcessesQueryVariables>;
export const CreateApproverProcessDocument = gql`
    mutation createApproverProcess($data: ApproverProcessCreateInput!) {
  createApproverProcess(data: $data) {
    description
    id
    approverRecipient {
      firstName
    }
  }
}
    `;
export type CreateApproverProcessMutationFn = Apollo.MutationFunction<CreateApproverProcessMutation, CreateApproverProcessMutationVariables>;

/**
 * __useCreateApproverProcessMutation__
 *
 * To run a mutation, you first call `useCreateApproverProcessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApproverProcessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApproverProcessMutation, { data, loading, error }] = useCreateApproverProcessMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateApproverProcessMutation(baseOptions?: Apollo.MutationHookOptions<CreateApproverProcessMutation, CreateApproverProcessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateApproverProcessMutation, CreateApproverProcessMutationVariables>(CreateApproverProcessDocument, options);
      }
export type CreateApproverProcessMutationHookResult = ReturnType<typeof useCreateApproverProcessMutation>;
export type CreateApproverProcessMutationResult = Apollo.MutationResult<CreateApproverProcessMutation>;
export type CreateApproverProcessMutationOptions = Apollo.BaseMutationOptions<CreateApproverProcessMutation, CreateApproverProcessMutationVariables>;
export const ApproverRecipientsDocument = gql`
    query ApproverRecipients {
  approverRecipients {
    ...ApproverRecipient
  }
}
    ${ApproverRecipientFragmentDoc}`;

/**
 * __useApproverRecipientsQuery__
 *
 * To run a query within a React component, call `useApproverRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useApproverRecipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApproverRecipientsQuery({
 *   variables: {
 *   },
 * });
 */
export function useApproverRecipientsQuery(baseOptions?: Apollo.QueryHookOptions<ApproverRecipientsQuery, ApproverRecipientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApproverRecipientsQuery, ApproverRecipientsQueryVariables>(ApproverRecipientsDocument, options);
      }
export function useApproverRecipientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApproverRecipientsQuery, ApproverRecipientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApproverRecipientsQuery, ApproverRecipientsQueryVariables>(ApproverRecipientsDocument, options);
        }
export type ApproverRecipientsQueryHookResult = ReturnType<typeof useApproverRecipientsQuery>;
export type ApproverRecipientsLazyQueryHookResult = ReturnType<typeof useApproverRecipientsLazyQuery>;
export type ApproverRecipientsQueryResult = Apollo.QueryResult<ApproverRecipientsQuery, ApproverRecipientsQueryVariables>;
export const CreateApproverRecipientDocument = gql`
    mutation createApproverRecipient($data: ApproverRecipientCreateInput!) {
  createApproverRecipient(data: $data) {
    ...ApproverRecipient
  }
}
    ${ApproverRecipientFragmentDoc}`;
export type CreateApproverRecipientMutationFn = Apollo.MutationFunction<CreateApproverRecipientMutation, CreateApproverRecipientMutationVariables>;

/**
 * __useCreateApproverRecipientMutation__
 *
 * To run a mutation, you first call `useCreateApproverRecipientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApproverRecipientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApproverRecipientMutation, { data, loading, error }] = useCreateApproverRecipientMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateApproverRecipientMutation(baseOptions?: Apollo.MutationHookOptions<CreateApproverRecipientMutation, CreateApproverRecipientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateApproverRecipientMutation, CreateApproverRecipientMutationVariables>(CreateApproverRecipientDocument, options);
      }
export type CreateApproverRecipientMutationHookResult = ReturnType<typeof useCreateApproverRecipientMutation>;
export type CreateApproverRecipientMutationResult = Apollo.MutationResult<CreateApproverRecipientMutation>;
export type CreateApproverRecipientMutationOptions = Apollo.BaseMutationOptions<CreateApproverRecipientMutation, CreateApproverRecipientMutationVariables>;
export const RemoveApproverRecipientDocument = gql`
    mutation RemoveApproverRecipient($id: String!) {
  removeApproverRecipient(where: {id: $id}) {
    id
  }
}
    `;
export type RemoveApproverRecipientMutationFn = Apollo.MutationFunction<RemoveApproverRecipientMutation, RemoveApproverRecipientMutationVariables>;

/**
 * __useRemoveApproverRecipientMutation__
 *
 * To run a mutation, you first call `useRemoveApproverRecipientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveApproverRecipientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeApproverRecipientMutation, { data, loading, error }] = useRemoveApproverRecipientMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveApproverRecipientMutation(baseOptions?: Apollo.MutationHookOptions<RemoveApproverRecipientMutation, RemoveApproverRecipientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveApproverRecipientMutation, RemoveApproverRecipientMutationVariables>(RemoveApproverRecipientDocument, options);
      }
export type RemoveApproverRecipientMutationHookResult = ReturnType<typeof useRemoveApproverRecipientMutation>;
export type RemoveApproverRecipientMutationResult = Apollo.MutationResult<RemoveApproverRecipientMutation>;
export type RemoveApproverRecipientMutationOptions = Apollo.BaseMutationOptions<RemoveApproverRecipientMutation, RemoveApproverRecipientMutationVariables>;
export const UpdateApproverRecipientDocument = gql`
    mutation UpdateApproverRecipient($data: ApproverRecipientUpdateInput!, $id: String!) {
  updateApproverRecipient(data: $data, where: {id: $id}) {
    ...ApproverRecipient
  }
}
    ${ApproverRecipientFragmentDoc}`;
export type UpdateApproverRecipientMutationFn = Apollo.MutationFunction<UpdateApproverRecipientMutation, UpdateApproverRecipientMutationVariables>;

/**
 * __useUpdateApproverRecipientMutation__
 *
 * To run a mutation, you first call `useUpdateApproverRecipientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApproverRecipientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApproverRecipientMutation, { data, loading, error }] = useUpdateApproverRecipientMutation({
 *   variables: {
 *      data: // value for 'data'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateApproverRecipientMutation(baseOptions?: Apollo.MutationHookOptions<UpdateApproverRecipientMutation, UpdateApproverRecipientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateApproverRecipientMutation, UpdateApproverRecipientMutationVariables>(UpdateApproverRecipientDocument, options);
      }
export type UpdateApproverRecipientMutationHookResult = ReturnType<typeof useUpdateApproverRecipientMutation>;
export type UpdateApproverRecipientMutationResult = Apollo.MutationResult<UpdateApproverRecipientMutation>;
export type UpdateApproverRecipientMutationOptions = Apollo.BaseMutationOptions<UpdateApproverRecipientMutation, UpdateApproverRecipientMutationVariables>;
export const GetProjectQuestionnaireStatusesDocument = gql`
    query getProjectQuestionnaireStatuses($where: ProjectQuestionnaireStatusWhereInput, $orderBy: [ProjectQuestionnaireStatusOrderByWithRelationInput!]) {
  projectQuestionnaireStatuses(where: $where, orderBy: $orderBy) {
    id
    order
    question
  }
}
    `;

/**
 * __useGetProjectQuestionnaireStatusesQuery__
 *
 * To run a query within a React component, call `useGetProjectQuestionnaireStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectQuestionnaireStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectQuestionnaireStatusesQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetProjectQuestionnaireStatusesQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectQuestionnaireStatusesQuery, GetProjectQuestionnaireStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectQuestionnaireStatusesQuery, GetProjectQuestionnaireStatusesQueryVariables>(GetProjectQuestionnaireStatusesDocument, options);
      }
export function useGetProjectQuestionnaireStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectQuestionnaireStatusesQuery, GetProjectQuestionnaireStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectQuestionnaireStatusesQuery, GetProjectQuestionnaireStatusesQueryVariables>(GetProjectQuestionnaireStatusesDocument, options);
        }
export type GetProjectQuestionnaireStatusesQueryHookResult = ReturnType<typeof useGetProjectQuestionnaireStatusesQuery>;
export type GetProjectQuestionnaireStatusesLazyQueryHookResult = ReturnType<typeof useGetProjectQuestionnaireStatusesLazyQuery>;
export type GetProjectQuestionnaireStatusesQueryResult = Apollo.QueryResult<GetProjectQuestionnaireStatusesQuery, GetProjectQuestionnaireStatusesQueryVariables>;
export const GetProjectQuestionnairesDocument = gql`
    query getProjectQuestionnaires($where: ProjectQuestionnaireWhereInput) {
  projectQuestionnaires(where: $where) {
    id
    value
  }
}
    `;

/**
 * __useGetProjectQuestionnairesQuery__
 *
 * To run a query within a React component, call `useGetProjectQuestionnairesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectQuestionnairesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectQuestionnairesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetProjectQuestionnairesQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectQuestionnairesQuery, GetProjectQuestionnairesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectQuestionnairesQuery, GetProjectQuestionnairesQueryVariables>(GetProjectQuestionnairesDocument, options);
      }
export function useGetProjectQuestionnairesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectQuestionnairesQuery, GetProjectQuestionnairesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectQuestionnairesQuery, GetProjectQuestionnairesQueryVariables>(GetProjectQuestionnairesDocument, options);
        }
export type GetProjectQuestionnairesQueryHookResult = ReturnType<typeof useGetProjectQuestionnairesQuery>;
export type GetProjectQuestionnairesLazyQueryHookResult = ReturnType<typeof useGetProjectQuestionnairesLazyQuery>;
export type GetProjectQuestionnairesQueryResult = Apollo.QueryResult<GetProjectQuestionnairesQuery, GetProjectQuestionnairesQueryVariables>;
export const CreateProjectQuestionnaireDocument = gql`
    mutation createProjectQuestionnaire($data: ProjectQuestionnaireCreateInput!) {
  createProjectQuestionnaire(data: $data) {
    id
  }
}
    `;
export type CreateProjectQuestionnaireMutationFn = Apollo.MutationFunction<CreateProjectQuestionnaireMutation, CreateProjectQuestionnaireMutationVariables>;

/**
 * __useCreateProjectQuestionnaireMutation__
 *
 * To run a mutation, you first call `useCreateProjectQuestionnaireMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectQuestionnaireMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectQuestionnaireMutation, { data, loading, error }] = useCreateProjectQuestionnaireMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateProjectQuestionnaireMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectQuestionnaireMutation, CreateProjectQuestionnaireMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectQuestionnaireMutation, CreateProjectQuestionnaireMutationVariables>(CreateProjectQuestionnaireDocument, options);
      }
export type CreateProjectQuestionnaireMutationHookResult = ReturnType<typeof useCreateProjectQuestionnaireMutation>;
export type CreateProjectQuestionnaireMutationResult = Apollo.MutationResult<CreateProjectQuestionnaireMutation>;
export type CreateProjectQuestionnaireMutationOptions = Apollo.BaseMutationOptions<CreateProjectQuestionnaireMutation, CreateProjectQuestionnaireMutationVariables>;
export const CreateProjectApprovalDocument = gql`
    mutation createProjectApproval($data: ProjectApprovalCreateInput!) {
  createProjectApproval(data: $data) {
    createdBy
  }
}
    `;
export type CreateProjectApprovalMutationFn = Apollo.MutationFunction<CreateProjectApprovalMutation, CreateProjectApprovalMutationVariables>;

/**
 * __useCreateProjectApprovalMutation__
 *
 * To run a mutation, you first call `useCreateProjectApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectApprovalMutation, { data, loading, error }] = useCreateProjectApprovalMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateProjectApprovalMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectApprovalMutation, CreateProjectApprovalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectApprovalMutation, CreateProjectApprovalMutationVariables>(CreateProjectApprovalDocument, options);
      }
export type CreateProjectApprovalMutationHookResult = ReturnType<typeof useCreateProjectApprovalMutation>;
export type CreateProjectApprovalMutationResult = Apollo.MutationResult<CreateProjectApprovalMutation>;
export type CreateProjectApprovalMutationOptions = Apollo.BaseMutationOptions<CreateProjectApprovalMutation, CreateProjectApprovalMutationVariables>;
export const UpdateProjectApprovalDocument = gql`
    mutation updateProjectApproval($data: ProjectApprovalUpdateInput!, $where: ProjectApprovalWhereUniqueInput!) {
  updateProjectApproval(data: $data, where: $where) {
    createdBy
  }
}
    `;
export type UpdateProjectApprovalMutationFn = Apollo.MutationFunction<UpdateProjectApprovalMutation, UpdateProjectApprovalMutationVariables>;

/**
 * __useUpdateProjectApprovalMutation__
 *
 * To run a mutation, you first call `useUpdateProjectApprovalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectApprovalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectApprovalMutation, { data, loading, error }] = useUpdateProjectApprovalMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateProjectApprovalMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectApprovalMutation, UpdateProjectApprovalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectApprovalMutation, UpdateProjectApprovalMutationVariables>(UpdateProjectApprovalDocument, options);
      }
export type UpdateProjectApprovalMutationHookResult = ReturnType<typeof useUpdateProjectApprovalMutation>;
export type UpdateProjectApprovalMutationResult = Apollo.MutationResult<UpdateProjectApprovalMutation>;
export type UpdateProjectApprovalMutationOptions = Apollo.BaseMutationOptions<UpdateProjectApprovalMutation, UpdateProjectApprovalMutationVariables>;
export const CreateProjectAllocationInputDocument = gql`
    mutation createProjectAllocationInput($data: ProjectAllocationCreateInput!) {
  createProjectAllocationInput(data: $data) {
    id
  }
}
    `;
export type CreateProjectAllocationInputMutationFn = Apollo.MutationFunction<CreateProjectAllocationInputMutation, CreateProjectAllocationInputMutationVariables>;

/**
 * __useCreateProjectAllocationInputMutation__
 *
 * To run a mutation, you first call `useCreateProjectAllocationInputMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectAllocationInputMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectAllocationInputMutation, { data, loading, error }] = useCreateProjectAllocationInputMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateProjectAllocationInputMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectAllocationInputMutation, CreateProjectAllocationInputMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectAllocationInputMutation, CreateProjectAllocationInputMutationVariables>(CreateProjectAllocationInputDocument, options);
      }
export type CreateProjectAllocationInputMutationHookResult = ReturnType<typeof useCreateProjectAllocationInputMutation>;
export type CreateProjectAllocationInputMutationResult = Apollo.MutationResult<CreateProjectAllocationInputMutation>;
export type CreateProjectAllocationInputMutationOptions = Apollo.BaseMutationOptions<CreateProjectAllocationInputMutation, CreateProjectAllocationInputMutationVariables>;
export const GetGeneralItCostsDocument = gql`
    query getGeneralItCosts {
  generalItCosts {
    id
    costTypeId
    costSubtypeId
    year
    sum
    deletedBy
  }
  generalItCostTypes {
    id
    description
    GerneralItCosts {
      costSubtypeId
    }
  }
  generalItCostSubtypes {
    id
    description
  }
}
    `;

/**
 * __useGetGeneralItCostsQuery__
 *
 * To run a query within a React component, call `useGetGeneralItCostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGeneralItCostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGeneralItCostsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGeneralItCostsQuery(baseOptions?: Apollo.QueryHookOptions<GetGeneralItCostsQuery, GetGeneralItCostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGeneralItCostsQuery, GetGeneralItCostsQueryVariables>(GetGeneralItCostsDocument, options);
      }
export function useGetGeneralItCostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGeneralItCostsQuery, GetGeneralItCostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGeneralItCostsQuery, GetGeneralItCostsQueryVariables>(GetGeneralItCostsDocument, options);
        }
export type GetGeneralItCostsQueryHookResult = ReturnType<typeof useGetGeneralItCostsQuery>;
export type GetGeneralItCostsLazyQueryHookResult = ReturnType<typeof useGetGeneralItCostsLazyQuery>;
export type GetGeneralItCostsQueryResult = Apollo.QueryResult<GetGeneralItCostsQuery, GetGeneralItCostsQueryVariables>;
export const UpdateGeneralItCostDocument = gql`
    mutation updateGeneralItCost($data: GerneralItCostsUpdateInput!, $where: GerneralItCostsWhereUniqueInput!) {
  updateGeneralItCost(data: $data, where: $where) {
    id
    sum
  }
}
    `;
export type UpdateGeneralItCostMutationFn = Apollo.MutationFunction<UpdateGeneralItCostMutation, UpdateGeneralItCostMutationVariables>;

/**
 * __useUpdateGeneralItCostMutation__
 *
 * To run a mutation, you first call `useUpdateGeneralItCostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGeneralItCostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGeneralItCostMutation, { data, loading, error }] = useUpdateGeneralItCostMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateGeneralItCostMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGeneralItCostMutation, UpdateGeneralItCostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGeneralItCostMutation, UpdateGeneralItCostMutationVariables>(UpdateGeneralItCostDocument, options);
      }
export type UpdateGeneralItCostMutationHookResult = ReturnType<typeof useUpdateGeneralItCostMutation>;
export type UpdateGeneralItCostMutationResult = Apollo.MutationResult<UpdateGeneralItCostMutation>;
export type UpdateGeneralItCostMutationOptions = Apollo.BaseMutationOptions<UpdateGeneralItCostMutation, UpdateGeneralItCostMutationVariables>;
export const CreateGeneralItCostDocument = gql`
    mutation CreateGeneralItCost($data: GerneralItCostsCreateInput!) {
  createGeneralItCost(data: $data) {
    costTypeId
    costSubtypeId
    id
    sum
    year
  }
}
    `;
export type CreateGeneralItCostMutationFn = Apollo.MutationFunction<CreateGeneralItCostMutation, CreateGeneralItCostMutationVariables>;

/**
 * __useCreateGeneralItCostMutation__
 *
 * To run a mutation, you first call `useCreateGeneralItCostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGeneralItCostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGeneralItCostMutation, { data, loading, error }] = useCreateGeneralItCostMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateGeneralItCostMutation(baseOptions?: Apollo.MutationHookOptions<CreateGeneralItCostMutation, CreateGeneralItCostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGeneralItCostMutation, CreateGeneralItCostMutationVariables>(CreateGeneralItCostDocument, options);
      }
export type CreateGeneralItCostMutationHookResult = ReturnType<typeof useCreateGeneralItCostMutation>;
export type CreateGeneralItCostMutationResult = Apollo.MutationResult<CreateGeneralItCostMutation>;
export type CreateGeneralItCostMutationOptions = Apollo.BaseMutationOptions<CreateGeneralItCostMutation, CreateGeneralItCostMutationVariables>;
export const RemoveGeneralItCostDocument = gql`
    mutation removeGeneralItCost($where: GerneralItCostsWhereUniqueInput!) {
  removeGeneralItCost(where: $where) {
    id
  }
}
    `;
export type RemoveGeneralItCostMutationFn = Apollo.MutationFunction<RemoveGeneralItCostMutation, RemoveGeneralItCostMutationVariables>;

/**
 * __useRemoveGeneralItCostMutation__
 *
 * To run a mutation, you first call `useRemoveGeneralItCostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveGeneralItCostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeGeneralItCostMutation, { data, loading, error }] = useRemoveGeneralItCostMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useRemoveGeneralItCostMutation(baseOptions?: Apollo.MutationHookOptions<RemoveGeneralItCostMutation, RemoveGeneralItCostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveGeneralItCostMutation, RemoveGeneralItCostMutationVariables>(RemoveGeneralItCostDocument, options);
      }
export type RemoveGeneralItCostMutationHookResult = ReturnType<typeof useRemoveGeneralItCostMutation>;
export type RemoveGeneralItCostMutationResult = Apollo.MutationResult<RemoveGeneralItCostMutation>;
export type RemoveGeneralItCostMutationOptions = Apollo.BaseMutationOptions<RemoveGeneralItCostMutation, RemoveGeneralItCostMutationVariables>;
export const GetApproverMailsDocument = gql`
    query getApproverMails($where: ApproverWhereInput, $take: Int) {
  approvers(where: $where, take: $take) {
    kid
  }
}
    `;

/**
 * __useGetApproverMailsQuery__
 *
 * To run a query within a React component, call `useGetApproverMailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApproverMailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApproverMailsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetApproverMailsQuery(baseOptions?: Apollo.QueryHookOptions<GetApproverMailsQuery, GetApproverMailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApproverMailsQuery, GetApproverMailsQueryVariables>(GetApproverMailsDocument, options);
      }
export function useGetApproverMailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApproverMailsQuery, GetApproverMailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApproverMailsQuery, GetApproverMailsQueryVariables>(GetApproverMailsDocument, options);
        }
export type GetApproverMailsQueryHookResult = ReturnType<typeof useGetApproverMailsQuery>;
export type GetApproverMailsLazyQueryHookResult = ReturnType<typeof useGetApproverMailsLazyQuery>;
export type GetApproverMailsQueryResult = Apollo.QueryResult<GetApproverMailsQuery, GetApproverMailsQueryVariables>;
export const DeleteMasterDocument = gql`
    mutation deleteMaster($data: MasterUpdateInput!, $where: MasterWhereUniqueInput!) {
  updateMaster(data: $data, where: $where) {
    deletedAt
    deletedBy
  }
}
    `;
export type DeleteMasterMutationFn = Apollo.MutationFunction<DeleteMasterMutation, DeleteMasterMutationVariables>;

/**
 * __useDeleteMasterMutation__
 *
 * To run a mutation, you first call `useDeleteMasterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMasterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMasterMutation, { data, loading, error }] = useDeleteMasterMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteMasterMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMasterMutation, DeleteMasterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMasterMutation, DeleteMasterMutationVariables>(DeleteMasterDocument, options);
      }
export type DeleteMasterMutationHookResult = ReturnType<typeof useDeleteMasterMutation>;
export type DeleteMasterMutationResult = Apollo.MutationResult<DeleteMasterMutation>;
export type DeleteMasterMutationOptions = Apollo.BaseMutationOptions<DeleteMasterMutation, DeleteMasterMutationVariables>;
export const UpdateProjectDocumentDocument = gql`
    mutation updateProjectDocument($data: ProjectDocumentsUpdateInput!, $where: ProjectDocumentsWhereUniqueInput!) {
  updateProjectDocument(data: $data, where: $where) {
    id
    uri
  }
}
    `;
export type UpdateProjectDocumentMutationFn = Apollo.MutationFunction<UpdateProjectDocumentMutation, UpdateProjectDocumentMutationVariables>;

/**
 * __useUpdateProjectDocumentMutation__
 *
 * To run a mutation, you first call `useUpdateProjectDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectDocumentMutation, { data, loading, error }] = useUpdateProjectDocumentMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateProjectDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectDocumentMutation, UpdateProjectDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectDocumentMutation, UpdateProjectDocumentMutationVariables>(UpdateProjectDocumentDocument, options);
      }
export type UpdateProjectDocumentMutationHookResult = ReturnType<typeof useUpdateProjectDocumentMutation>;
export type UpdateProjectDocumentMutationResult = Apollo.MutationResult<UpdateProjectDocumentMutation>;
export type UpdateProjectDocumentMutationOptions = Apollo.BaseMutationOptions<UpdateProjectDocumentMutation, UpdateProjectDocumentMutationVariables>;
export const CreateRemarkDocument = gql`
    mutation createRemark($data: RemarkCreateInput!) {
  createRemark(data: $data) {
    id
  }
}
    `;
export type CreateRemarkMutationFn = Apollo.MutationFunction<CreateRemarkMutation, CreateRemarkMutationVariables>;

/**
 * __useCreateRemarkMutation__
 *
 * To run a mutation, you first call `useCreateRemarkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRemarkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRemarkMutation, { data, loading, error }] = useCreateRemarkMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateRemarkMutation(baseOptions?: Apollo.MutationHookOptions<CreateRemarkMutation, CreateRemarkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRemarkMutation, CreateRemarkMutationVariables>(CreateRemarkDocument, options);
      }
export type CreateRemarkMutationHookResult = ReturnType<typeof useCreateRemarkMutation>;
export type CreateRemarkMutationResult = Apollo.MutationResult<CreateRemarkMutation>;
export type CreateRemarkMutationOptions = Apollo.BaseMutationOptions<CreateRemarkMutation, CreateRemarkMutationVariables>;
export const GetSegmentsDocument = gql`
    query getSegments {
  segments {
    id
    segment
  }
}
    `;

/**
 * __useGetSegmentsQuery__
 *
 * To run a query within a React component, call `useGetSegmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSegmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSegmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSegmentsQuery(baseOptions?: Apollo.QueryHookOptions<GetSegmentsQuery, GetSegmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSegmentsQuery, GetSegmentsQueryVariables>(GetSegmentsDocument, options);
      }
export function useGetSegmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSegmentsQuery, GetSegmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSegmentsQuery, GetSegmentsQueryVariables>(GetSegmentsDocument, options);
        }
export type GetSegmentsQueryHookResult = ReturnType<typeof useGetSegmentsQuery>;
export type GetSegmentsLazyQueryHookResult = ReturnType<typeof useGetSegmentsLazyQuery>;
export type GetSegmentsQueryResult = Apollo.QueryResult<GetSegmentsQuery, GetSegmentsQueryVariables>;
export const CreateGeneralCostShortHistoryDocument = gql`
    mutation createGeneralCostShortHistory($data: GeneralCostShortHistoryCreateInput!) {
  createGeneralCostShortHistory(data: $data) {
    id
  }
}
    `;
export type CreateGeneralCostShortHistoryMutationFn = Apollo.MutationFunction<CreateGeneralCostShortHistoryMutation, CreateGeneralCostShortHistoryMutationVariables>;

/**
 * __useCreateGeneralCostShortHistoryMutation__
 *
 * To run a mutation, you first call `useCreateGeneralCostShortHistoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGeneralCostShortHistoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGeneralCostShortHistoryMutation, { data, loading, error }] = useCreateGeneralCostShortHistoryMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateGeneralCostShortHistoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateGeneralCostShortHistoryMutation, CreateGeneralCostShortHistoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGeneralCostShortHistoryMutation, CreateGeneralCostShortHistoryMutationVariables>(CreateGeneralCostShortHistoryDocument, options);
      }
export type CreateGeneralCostShortHistoryMutationHookResult = ReturnType<typeof useCreateGeneralCostShortHistoryMutation>;
export type CreateGeneralCostShortHistoryMutationResult = Apollo.MutationResult<CreateGeneralCostShortHistoryMutation>;
export type CreateGeneralCostShortHistoryMutationOptions = Apollo.BaseMutationOptions<CreateGeneralCostShortHistoryMutation, CreateGeneralCostShortHistoryMutationVariables>;
export const EmailHistoriesDocument = gql`
    query EmailHistories {
  emailHistories {
    approverId
    createdAt
    createdBy
    deletedAt
    deletedBy
    id
    input
    projectId
    description
  }
}
    `;

/**
 * __useEmailHistoriesQuery__
 *
 * To run a query within a React component, call `useEmailHistoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailHistoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailHistoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useEmailHistoriesQuery(baseOptions?: Apollo.QueryHookOptions<EmailHistoriesQuery, EmailHistoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailHistoriesQuery, EmailHistoriesQueryVariables>(EmailHistoriesDocument, options);
      }
export function useEmailHistoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailHistoriesQuery, EmailHistoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailHistoriesQuery, EmailHistoriesQueryVariables>(EmailHistoriesDocument, options);
        }
export type EmailHistoriesQueryHookResult = ReturnType<typeof useEmailHistoriesQuery>;
export type EmailHistoriesLazyQueryHookResult = ReturnType<typeof useEmailHistoriesLazyQuery>;
export type EmailHistoriesQueryResult = Apollo.QueryResult<EmailHistoriesQuery, EmailHistoriesQueryVariables>;
export const GetEmailHistoryDocument = gql`
    query getEmailHistory($projectId: String!, $approverId: String!) {
  emailHistories(
    where: {projectId: {equals: $projectId}, approverId: {equals: $approverId}}
  ) {
    approverId
    createdAt
    createdBy
    deletedAt
    deletedBy
    id
    input
    projectId
    description
  }
}
    `;

/**
 * __useGetEmailHistoryQuery__
 *
 * To run a query within a React component, call `useGetEmailHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailHistoryQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      approverId: // value for 'approverId'
 *   },
 * });
 */
export function useGetEmailHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetEmailHistoryQuery, GetEmailHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmailHistoryQuery, GetEmailHistoryQueryVariables>(GetEmailHistoryDocument, options);
      }
export function useGetEmailHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmailHistoryQuery, GetEmailHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmailHistoryQuery, GetEmailHistoryQueryVariables>(GetEmailHistoryDocument, options);
        }
export type GetEmailHistoryQueryHookResult = ReturnType<typeof useGetEmailHistoryQuery>;
export type GetEmailHistoryLazyQueryHookResult = ReturnType<typeof useGetEmailHistoryLazyQuery>;
export type GetEmailHistoryQueryResult = Apollo.QueryResult<GetEmailHistoryQuery, GetEmailHistoryQueryVariables>;
export const CreateEmailHistoryDocument = gql`
    mutation createEmailHistory($data: EmailHistoryCreateInput!) {
  createEmailHistory(data: $data) {
    approverId
    projectId
    id
    input
    description
  }
}
    `;
export type CreateEmailHistoryMutationFn = Apollo.MutationFunction<CreateEmailHistoryMutation, CreateEmailHistoryMutationVariables>;

/**
 * __useCreateEmailHistoryMutation__
 *
 * To run a mutation, you first call `useCreateEmailHistoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmailHistoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmailHistoryMutation, { data, loading, error }] = useCreateEmailHistoryMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateEmailHistoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmailHistoryMutation, CreateEmailHistoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmailHistoryMutation, CreateEmailHistoryMutationVariables>(CreateEmailHistoryDocument, options);
      }
export type CreateEmailHistoryMutationHookResult = ReturnType<typeof useCreateEmailHistoryMutation>;
export type CreateEmailHistoryMutationResult = Apollo.MutationResult<CreateEmailHistoryMutation>;
export type CreateEmailHistoryMutationOptions = Apollo.BaseMutationOptions<CreateEmailHistoryMutation, CreateEmailHistoryMutationVariables>;
export const ContactHistoriesDocument = gql`
    query ContactHistories {
  ContactHistories {
    addressees
    approverProcessId
    isMail
    projectId
    rowNumber
    sendDate
    createdAt
    createdBy
  }
}
    `;

/**
 * __useContactHistoriesQuery__
 *
 * To run a query within a React component, call `useContactHistoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactHistoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactHistoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useContactHistoriesQuery(baseOptions?: Apollo.QueryHookOptions<ContactHistoriesQuery, ContactHistoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactHistoriesQuery, ContactHistoriesQueryVariables>(ContactHistoriesDocument, options);
      }
export function useContactHistoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactHistoriesQuery, ContactHistoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactHistoriesQuery, ContactHistoriesQueryVariables>(ContactHistoriesDocument, options);
        }
export type ContactHistoriesQueryHookResult = ReturnType<typeof useContactHistoriesQuery>;
export type ContactHistoriesLazyQueryHookResult = ReturnType<typeof useContactHistoriesLazyQuery>;
export type ContactHistoriesQueryResult = Apollo.QueryResult<ContactHistoriesQuery, ContactHistoriesQueryVariables>;
export const CreateContactHistoryDocument = gql`
    mutation createContactHistory($data: ContactHistoryCreateInput!) {
  createContactHistory(data: $data) {
    addressees
    approverProcessId
    isMail
    projectId
    rowNumber
    sendDate
    createdAt
    createdBy
  }
}
    `;
export type CreateContactHistoryMutationFn = Apollo.MutationFunction<CreateContactHistoryMutation, CreateContactHistoryMutationVariables>;

/**
 * __useCreateContactHistoryMutation__
 *
 * To run a mutation, you first call `useCreateContactHistoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactHistoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactHistoryMutation, { data, loading, error }] = useCreateContactHistoryMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateContactHistoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateContactHistoryMutation, CreateContactHistoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContactHistoryMutation, CreateContactHistoryMutationVariables>(CreateContactHistoryDocument, options);
      }
export type CreateContactHistoryMutationHookResult = ReturnType<typeof useCreateContactHistoryMutation>;
export type CreateContactHistoryMutationResult = Apollo.MutationResult<CreateContactHistoryMutation>;
export type CreateContactHistoryMutationOptions = Apollo.BaseMutationOptions<CreateContactHistoryMutation, CreateContactHistoryMutationVariables>;
export const ResourceplanningGetProjectByIdDocument = gql`
    query resourceplanningGetProjectById($id: String!, $orderBy: [MasterOrderByWithRelationInput!]) {
  masters(where: {id: {equals: $id}}, orderBy: $orderBy) {
    ...MasterDetails
    projectResourceCapture {
      id
      roleId
      department
      employee {
        id
        firstName
        lastName
      }
      employeeId
      projectPhaseId
      year
      month
      rate
      communication
      update
      onboarding
      endDate
      deletedBy
    }
  }
}
    ${MasterDetailsFragmentDoc}`;

/**
 * __useResourceplanningGetProjectByIdQuery__
 *
 * To run a query within a React component, call `useResourceplanningGetProjectByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceplanningGetProjectByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceplanningGetProjectByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useResourceplanningGetProjectByIdQuery(baseOptions: Apollo.QueryHookOptions<ResourceplanningGetProjectByIdQuery, ResourceplanningGetProjectByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourceplanningGetProjectByIdQuery, ResourceplanningGetProjectByIdQueryVariables>(ResourceplanningGetProjectByIdDocument, options);
      }
export function useResourceplanningGetProjectByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourceplanningGetProjectByIdQuery, ResourceplanningGetProjectByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourceplanningGetProjectByIdQuery, ResourceplanningGetProjectByIdQueryVariables>(ResourceplanningGetProjectByIdDocument, options);
        }
export type ResourceplanningGetProjectByIdQueryHookResult = ReturnType<typeof useResourceplanningGetProjectByIdQuery>;
export type ResourceplanningGetProjectByIdLazyQueryHookResult = ReturnType<typeof useResourceplanningGetProjectByIdLazyQuery>;
export type ResourceplanningGetProjectByIdQueryResult = Apollo.QueryResult<ResourceplanningGetProjectByIdQuery, ResourceplanningGetProjectByIdQueryVariables>;
export const ResourceplanningDropdownDataDocument = gql`
    query resourceplanningDropdownData($where: EmployeeWhereInput, $projectPhasesWhere2: ProjectPhaseWhereInput) {
  projectPhases(where: $projectPhasesWhere2) {
    id
  }
  employees(where: $where) {
    id
    firstName
    lastName
    department
  }
  roles {
    id
  }
}
    `;

/**
 * __useResourceplanningDropdownDataQuery__
 *
 * To run a query within a React component, call `useResourceplanningDropdownDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceplanningDropdownDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceplanningDropdownDataQuery({
 *   variables: {
 *      where: // value for 'where'
 *      projectPhasesWhere2: // value for 'projectPhasesWhere2'
 *   },
 * });
 */
export function useResourceplanningDropdownDataQuery(baseOptions?: Apollo.QueryHookOptions<ResourceplanningDropdownDataQuery, ResourceplanningDropdownDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourceplanningDropdownDataQuery, ResourceplanningDropdownDataQueryVariables>(ResourceplanningDropdownDataDocument, options);
      }
export function useResourceplanningDropdownDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourceplanningDropdownDataQuery, ResourceplanningDropdownDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourceplanningDropdownDataQuery, ResourceplanningDropdownDataQueryVariables>(ResourceplanningDropdownDataDocument, options);
        }
export type ResourceplanningDropdownDataQueryHookResult = ReturnType<typeof useResourceplanningDropdownDataQuery>;
export type ResourceplanningDropdownDataLazyQueryHookResult = ReturnType<typeof useResourceplanningDropdownDataLazyQuery>;
export type ResourceplanningDropdownDataQueryResult = Apollo.QueryResult<ResourceplanningDropdownDataQuery, ResourceplanningDropdownDataQueryVariables>;
export const CreateProjectResourceCaptureDocument = gql`
    mutation createProjectResourceCapture($data: ProjectResourceCaptureCreateInput!) {
  createProjectResourceCapture(data: $data) {
    id
  }
}
    `;
export type CreateProjectResourceCaptureMutationFn = Apollo.MutationFunction<CreateProjectResourceCaptureMutation, CreateProjectResourceCaptureMutationVariables>;

/**
 * __useCreateProjectResourceCaptureMutation__
 *
 * To run a mutation, you first call `useCreateProjectResourceCaptureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectResourceCaptureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectResourceCaptureMutation, { data, loading, error }] = useCreateProjectResourceCaptureMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateProjectResourceCaptureMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectResourceCaptureMutation, CreateProjectResourceCaptureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectResourceCaptureMutation, CreateProjectResourceCaptureMutationVariables>(CreateProjectResourceCaptureDocument, options);
      }
export type CreateProjectResourceCaptureMutationHookResult = ReturnType<typeof useCreateProjectResourceCaptureMutation>;
export type CreateProjectResourceCaptureMutationResult = Apollo.MutationResult<CreateProjectResourceCaptureMutation>;
export type CreateProjectResourceCaptureMutationOptions = Apollo.BaseMutationOptions<CreateProjectResourceCaptureMutation, CreateProjectResourceCaptureMutationVariables>;
export const UpdateProjectResourceCaptureDocument = gql`
    mutation updateProjectResourceCapture($data: ProjectResourceCaptureUpdateInput!, $where: ProjectResourceCaptureWhereUniqueInput!) {
  updateProjectResourceCapture(data: $data, where: $where) {
    id
  }
}
    `;
export type UpdateProjectResourceCaptureMutationFn = Apollo.MutationFunction<UpdateProjectResourceCaptureMutation, UpdateProjectResourceCaptureMutationVariables>;

/**
 * __useUpdateProjectResourceCaptureMutation__
 *
 * To run a mutation, you first call `useUpdateProjectResourceCaptureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectResourceCaptureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectResourceCaptureMutation, { data, loading, error }] = useUpdateProjectResourceCaptureMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateProjectResourceCaptureMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectResourceCaptureMutation, UpdateProjectResourceCaptureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectResourceCaptureMutation, UpdateProjectResourceCaptureMutationVariables>(UpdateProjectResourceCaptureDocument, options);
      }
export type UpdateProjectResourceCaptureMutationHookResult = ReturnType<typeof useUpdateProjectResourceCaptureMutation>;
export type UpdateProjectResourceCaptureMutationResult = Apollo.MutationResult<UpdateProjectResourceCaptureMutation>;
export type UpdateProjectResourceCaptureMutationOptions = Apollo.BaseMutationOptions<UpdateProjectResourceCaptureMutation, UpdateProjectResourceCaptureMutationVariables>;
export const ReportingGetProjectByIdDocument = gql`
    query reportingGetProjectById($id: String!) {
  masters(where: {id: {equals: $id}}) {
    ...MasterDetails
    projectPhaseCapture {
      id
      projectPhaseId
      comment
      startDate
      endDate
      deletedBy
    }
    projectResourceCapture {
      roleId
      department
      employee {
        firstName
        lastName
      }
    }
    projectShortHistory {
      createdAt
      createdBy
      action
      rowNumber
    }
    report {
      addresseeGroup {
        reportId
        employeeId
        createdBy
        deletedBy
      }
      deletedBy
      createdBy
      id
      projectId
      reportLink
      reportTitle
      update
      project {
        projectDescriptions {
          name
        }
      }
    }
    projectInterface {
      cause
      challenges
      collaboration
      createdBy
      deletedBy
      deletedAt
      description
      employeeId
      employee {
        id
        firstName
        lastName
      }
      interfaceReference {
        description
        id
      }
      interfaceDetail {
        description
        id
        interfaceFormat {
          id
          description
        }
        interfaceFormatId
        interfaceType {
          description
          id
        }
        interfaceTypeId
        isExport
      }
      id
      projectId
      status
      name
    }
  }
}
    ${MasterDetailsFragmentDoc}`;

/**
 * __useReportingGetProjectByIdQuery__
 *
 * To run a query within a React component, call `useReportingGetProjectByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportingGetProjectByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingGetProjectByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReportingGetProjectByIdQuery(baseOptions: Apollo.QueryHookOptions<ReportingGetProjectByIdQuery, ReportingGetProjectByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportingGetProjectByIdQuery, ReportingGetProjectByIdQueryVariables>(ReportingGetProjectByIdDocument, options);
      }
export function useReportingGetProjectByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportingGetProjectByIdQuery, ReportingGetProjectByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportingGetProjectByIdQuery, ReportingGetProjectByIdQueryVariables>(ReportingGetProjectByIdDocument, options);
        }
export type ReportingGetProjectByIdQueryHookResult = ReturnType<typeof useReportingGetProjectByIdQuery>;
export type ReportingGetProjectByIdLazyQueryHookResult = ReturnType<typeof useReportingGetProjectByIdLazyQuery>;
export type ReportingGetProjectByIdQueryResult = Apollo.QueryResult<ReportingGetProjectByIdQuery, ReportingGetProjectByIdQueryVariables>;
export const UpdateProjectPhaseCaptureDocument = gql`
    mutation updateProjectPhaseCapture($data: ProjectPhaseCaptureUpdateInput!, $where: ProjectPhaseCaptureWhereUniqueInput!) {
  updateProjectPhaseCapture(data: $data, where: $where) {
    id
  }
}
    `;
export type UpdateProjectPhaseCaptureMutationFn = Apollo.MutationFunction<UpdateProjectPhaseCaptureMutation, UpdateProjectPhaseCaptureMutationVariables>;

/**
 * __useUpdateProjectPhaseCaptureMutation__
 *
 * To run a mutation, you first call `useUpdateProjectPhaseCaptureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectPhaseCaptureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectPhaseCaptureMutation, { data, loading, error }] = useUpdateProjectPhaseCaptureMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateProjectPhaseCaptureMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectPhaseCaptureMutation, UpdateProjectPhaseCaptureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectPhaseCaptureMutation, UpdateProjectPhaseCaptureMutationVariables>(UpdateProjectPhaseCaptureDocument, options);
      }
export type UpdateProjectPhaseCaptureMutationHookResult = ReturnType<typeof useUpdateProjectPhaseCaptureMutation>;
export type UpdateProjectPhaseCaptureMutationResult = Apollo.MutationResult<UpdateProjectPhaseCaptureMutation>;
export type UpdateProjectPhaseCaptureMutationOptions = Apollo.BaseMutationOptions<UpdateProjectPhaseCaptureMutation, UpdateProjectPhaseCaptureMutationVariables>;
export const ProjectPhasesDocument = gql`
    query ProjectPhases($where: ProjectPhaseWhereInput) {
  projectPhases(where: $where) {
    id
  }
}
    `;

/**
 * __useProjectPhasesQuery__
 *
 * To run a query within a React component, call `useProjectPhasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectPhasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectPhasesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useProjectPhasesQuery(baseOptions?: Apollo.QueryHookOptions<ProjectPhasesQuery, ProjectPhasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectPhasesQuery, ProjectPhasesQueryVariables>(ProjectPhasesDocument, options);
      }
export function useProjectPhasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectPhasesQuery, ProjectPhasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectPhasesQuery, ProjectPhasesQueryVariables>(ProjectPhasesDocument, options);
        }
export type ProjectPhasesQueryHookResult = ReturnType<typeof useProjectPhasesQuery>;
export type ProjectPhasesLazyQueryHookResult = ReturnType<typeof useProjectPhasesLazyQuery>;
export type ProjectPhasesQueryResult = Apollo.QueryResult<ProjectPhasesQuery, ProjectPhasesQueryVariables>;
export const GetProjectInterfacesDocument = gql`
    query getProjectInterfaces($where: ProjectInterfaceWhereInput) {
  projectInterfaces(where: $where) {
    deletedBy
    id
    projectId
    cause
    employeeId
    name
    description
    challenges
    interfaceId
    status
    collaboration
    isAutomatic
    interfaceReferenceId
    riskStatusId
    riskOccuranceId
    riskDamagePotentialId
    interfaceDetail {
      leanixMappingId
      id
      deletedBy
      createdAt
      description
      interfaceTypeId
      interfaceFormatId
      isExport
    }
  }
}
    `;

/**
 * __useGetProjectInterfacesQuery__
 *
 * To run a query within a React component, call `useGetProjectInterfacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectInterfacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectInterfacesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetProjectInterfacesQuery(baseOptions?: Apollo.QueryHookOptions<GetProjectInterfacesQuery, GetProjectInterfacesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectInterfacesQuery, GetProjectInterfacesQueryVariables>(GetProjectInterfacesDocument, options);
      }
export function useGetProjectInterfacesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectInterfacesQuery, GetProjectInterfacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectInterfacesQuery, GetProjectInterfacesQueryVariables>(GetProjectInterfacesDocument, options);
        }
export type GetProjectInterfacesQueryHookResult = ReturnType<typeof useGetProjectInterfacesQuery>;
export type GetProjectInterfacesLazyQueryHookResult = ReturnType<typeof useGetProjectInterfacesLazyQuery>;
export type GetProjectInterfacesQueryResult = Apollo.QueryResult<GetProjectInterfacesQuery, GetProjectInterfacesQueryVariables>;
export const GetProjectInterfaceByIdDocument = gql`
    query getProjectInterfaceById($id: String!) {
  projectInterface(where: {id: $id}) {
    id
    name
    cause
    interfaceReferenceId
    employeeId
    collaboration
    challenges
    status
    description
    isAutomatic
    riskStatusId
    riskOccuranceId
    riskDamagePotentialId
    interfaceId
    deletedBy
  }
}
    `;

/**
 * __useGetProjectInterfaceByIdQuery__
 *
 * To run a query within a React component, call `useGetProjectInterfaceByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectInterfaceByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectInterfaceByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProjectInterfaceByIdQuery(baseOptions: Apollo.QueryHookOptions<GetProjectInterfaceByIdQuery, GetProjectInterfaceByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectInterfaceByIdQuery, GetProjectInterfaceByIdQueryVariables>(GetProjectInterfaceByIdDocument, options);
      }
export function useGetProjectInterfaceByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectInterfaceByIdQuery, GetProjectInterfaceByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectInterfaceByIdQuery, GetProjectInterfaceByIdQueryVariables>(GetProjectInterfaceByIdDocument, options);
        }
export type GetProjectInterfaceByIdQueryHookResult = ReturnType<typeof useGetProjectInterfaceByIdQuery>;
export type GetProjectInterfaceByIdLazyQueryHookResult = ReturnType<typeof useGetProjectInterfaceByIdLazyQuery>;
export type GetProjectInterfaceByIdQueryResult = Apollo.QueryResult<GetProjectInterfaceByIdQuery, GetProjectInterfaceByIdQueryVariables>;
export const ReportingGetProjectInterfacesByIdDocument = gql`
    query reportingGetProjectInterfacesById($id: String!) {
  masters(where: {id: {equals: $id}}) {
    ...MasterDetails
    projectInterface {
      cause
      challenges
      collaboration
      createdBy
      deletedAt
      description
      employeeId
      employee {
        id
        firstName
        lastName
      }
      interfaceReferenceId
      interfaceReference {
        description
        id
      }
      interfaceDetail {
        description
        id
        interfaceFormat {
          id
          description
        }
        interfaceFormatId
        interfaceType {
          description
          id
        }
        interfaceTypeId
        isExport
      }
      id
      projectId
      status
      name
    }
  }
}
    ${MasterDetailsFragmentDoc}`;

/**
 * __useReportingGetProjectInterfacesByIdQuery__
 *
 * To run a query within a React component, call `useReportingGetProjectInterfacesByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportingGetProjectInterfacesByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingGetProjectInterfacesByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReportingGetProjectInterfacesByIdQuery(baseOptions: Apollo.QueryHookOptions<ReportingGetProjectInterfacesByIdQuery, ReportingGetProjectInterfacesByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportingGetProjectInterfacesByIdQuery, ReportingGetProjectInterfacesByIdQueryVariables>(ReportingGetProjectInterfacesByIdDocument, options);
      }
export function useReportingGetProjectInterfacesByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportingGetProjectInterfacesByIdQuery, ReportingGetProjectInterfacesByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportingGetProjectInterfacesByIdQuery, ReportingGetProjectInterfacesByIdQueryVariables>(ReportingGetProjectInterfacesByIdDocument, options);
        }
export type ReportingGetProjectInterfacesByIdQueryHookResult = ReturnType<typeof useReportingGetProjectInterfacesByIdQuery>;
export type ReportingGetProjectInterfacesByIdLazyQueryHookResult = ReturnType<typeof useReportingGetProjectInterfacesByIdLazyQuery>;
export type ReportingGetProjectInterfacesByIdQueryResult = Apollo.QueryResult<ReportingGetProjectInterfacesByIdQuery, ReportingGetProjectInterfacesByIdQueryVariables>;
export const CreateInterfaceDetailDocument = gql`
    mutation createInterfaceDetail($data: InterfaceDetailCreateInput!) {
  createInterfaceDetail(data: $data) {
    id
    description
    projectInterfaceId
    interfaceTypeId
    interfaceFormatId
    isExport
  }
}
    `;
export type CreateInterfaceDetailMutationFn = Apollo.MutationFunction<CreateInterfaceDetailMutation, CreateInterfaceDetailMutationVariables>;

/**
 * __useCreateInterfaceDetailMutation__
 *
 * To run a mutation, you first call `useCreateInterfaceDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInterfaceDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInterfaceDetailMutation, { data, loading, error }] = useCreateInterfaceDetailMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateInterfaceDetailMutation(baseOptions?: Apollo.MutationHookOptions<CreateInterfaceDetailMutation, CreateInterfaceDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInterfaceDetailMutation, CreateInterfaceDetailMutationVariables>(CreateInterfaceDetailDocument, options);
      }
export type CreateInterfaceDetailMutationHookResult = ReturnType<typeof useCreateInterfaceDetailMutation>;
export type CreateInterfaceDetailMutationResult = Apollo.MutationResult<CreateInterfaceDetailMutation>;
export type CreateInterfaceDetailMutationOptions = Apollo.BaseMutationOptions<CreateInterfaceDetailMutation, CreateInterfaceDetailMutationVariables>;
export const CreateProjectInterfaceDocument = gql`
    mutation createProjectInterface($data: ProjectInterfaceCreateInput!) {
  createProjectInterface(data: $data) {
    projectId
    interfaceReferenceId
    description
    cause
    challenges
    collaboration
    status
    deletedBy
    employeeId
    interfaceDetail {
      id
    }
  }
}
    `;
export type CreateProjectInterfaceMutationFn = Apollo.MutationFunction<CreateProjectInterfaceMutation, CreateProjectInterfaceMutationVariables>;

/**
 * __useCreateProjectInterfaceMutation__
 *
 * To run a mutation, you first call `useCreateProjectInterfaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProjectInterfaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProjectInterfaceMutation, { data, loading, error }] = useCreateProjectInterfaceMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateProjectInterfaceMutation(baseOptions?: Apollo.MutationHookOptions<CreateProjectInterfaceMutation, CreateProjectInterfaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProjectInterfaceMutation, CreateProjectInterfaceMutationVariables>(CreateProjectInterfaceDocument, options);
      }
export type CreateProjectInterfaceMutationHookResult = ReturnType<typeof useCreateProjectInterfaceMutation>;
export type CreateProjectInterfaceMutationResult = Apollo.MutationResult<CreateProjectInterfaceMutation>;
export type CreateProjectInterfaceMutationOptions = Apollo.BaseMutationOptions<CreateProjectInterfaceMutation, CreateProjectInterfaceMutationVariables>;
export const GetLandingApplicationClustersDocument = gql`
    query getLandingApplicationClusters($orderBy: [LandingApplicationClusterOrderByWithRelationInput!], $where: LandingApplicationClusterWhereInput) {
  landingApplicationClusters(orderBy: $orderBy, where: $where) {
    id
    clusterName
    label
    isActive
    tooltip
    icon
    order
    uri
    landingApplicationClusterGroup {
      id
      groupId
      deletedBy
    }
  }
}
    `;

/**
 * __useGetLandingApplicationClustersQuery__
 *
 * To run a query within a React component, call `useGetLandingApplicationClustersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLandingApplicationClustersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLandingApplicationClustersQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetLandingApplicationClustersQuery(baseOptions?: Apollo.QueryHookOptions<GetLandingApplicationClustersQuery, GetLandingApplicationClustersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLandingApplicationClustersQuery, GetLandingApplicationClustersQueryVariables>(GetLandingApplicationClustersDocument, options);
      }
export function useGetLandingApplicationClustersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLandingApplicationClustersQuery, GetLandingApplicationClustersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLandingApplicationClustersQuery, GetLandingApplicationClustersQueryVariables>(GetLandingApplicationClustersDocument, options);
        }
export type GetLandingApplicationClustersQueryHookResult = ReturnType<typeof useGetLandingApplicationClustersQuery>;
export type GetLandingApplicationClustersLazyQueryHookResult = ReturnType<typeof useGetLandingApplicationClustersLazyQuery>;
export type GetLandingApplicationClustersQueryResult = Apollo.QueryResult<GetLandingApplicationClustersQuery, GetLandingApplicationClustersQueryVariables>;
export const CreateLandingApplicationClusterMappingDocument = gql`
    mutation createLandingApplicationClusterMapping($data: LandingApplicationClusterMappingCreateInput!) {
  createLandingApplicationClusterMapping(data: $data) {
    id
  }
}
    `;
export type CreateLandingApplicationClusterMappingMutationFn = Apollo.MutationFunction<CreateLandingApplicationClusterMappingMutation, CreateLandingApplicationClusterMappingMutationVariables>;

/**
 * __useCreateLandingApplicationClusterMappingMutation__
 *
 * To run a mutation, you first call `useCreateLandingApplicationClusterMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLandingApplicationClusterMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLandingApplicationClusterMappingMutation, { data, loading, error }] = useCreateLandingApplicationClusterMappingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateLandingApplicationClusterMappingMutation(baseOptions?: Apollo.MutationHookOptions<CreateLandingApplicationClusterMappingMutation, CreateLandingApplicationClusterMappingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLandingApplicationClusterMappingMutation, CreateLandingApplicationClusterMappingMutationVariables>(CreateLandingApplicationClusterMappingDocument, options);
      }
export type CreateLandingApplicationClusterMappingMutationHookResult = ReturnType<typeof useCreateLandingApplicationClusterMappingMutation>;
export type CreateLandingApplicationClusterMappingMutationResult = Apollo.MutationResult<CreateLandingApplicationClusterMappingMutation>;
export type CreateLandingApplicationClusterMappingMutationOptions = Apollo.BaseMutationOptions<CreateLandingApplicationClusterMappingMutation, CreateLandingApplicationClusterMappingMutationVariables>;
export const UpdateLandingApplicationClusterMappingDocument = gql`
    mutation updateLandingApplicationClusterMapping($data: LandingApplicationClusterMappingUpdateInput!, $where: LandingApplicationClusterMappingWhereUniqueInput!) {
  updateLandingApplicationClusterMapping(data: $data, where: $where) {
    id
  }
}
    `;
export type UpdateLandingApplicationClusterMappingMutationFn = Apollo.MutationFunction<UpdateLandingApplicationClusterMappingMutation, UpdateLandingApplicationClusterMappingMutationVariables>;

/**
 * __useUpdateLandingApplicationClusterMappingMutation__
 *
 * To run a mutation, you first call `useUpdateLandingApplicationClusterMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLandingApplicationClusterMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLandingApplicationClusterMappingMutation, { data, loading, error }] = useUpdateLandingApplicationClusterMappingMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateLandingApplicationClusterMappingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLandingApplicationClusterMappingMutation, UpdateLandingApplicationClusterMappingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLandingApplicationClusterMappingMutation, UpdateLandingApplicationClusterMappingMutationVariables>(UpdateLandingApplicationClusterMappingDocument, options);
      }
export type UpdateLandingApplicationClusterMappingMutationHookResult = ReturnType<typeof useUpdateLandingApplicationClusterMappingMutation>;
export type UpdateLandingApplicationClusterMappingMutationResult = Apollo.MutationResult<UpdateLandingApplicationClusterMappingMutation>;
export type UpdateLandingApplicationClusterMappingMutationOptions = Apollo.BaseMutationOptions<UpdateLandingApplicationClusterMappingMutation, UpdateLandingApplicationClusterMappingMutationVariables>;
export const CreateLandingApplicationClusterDocument = gql`
    mutation createLandingApplicationCluster($data: LandingApplicationClusterCreateInput!, $file: Upload!) {
  createLandingApplicationCluster(data: $data, file: $file) {
    id
  }
}
    `;
export type CreateLandingApplicationClusterMutationFn = Apollo.MutationFunction<CreateLandingApplicationClusterMutation, CreateLandingApplicationClusterMutationVariables>;

/**
 * __useCreateLandingApplicationClusterMutation__
 *
 * To run a mutation, you first call `useCreateLandingApplicationClusterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLandingApplicationClusterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLandingApplicationClusterMutation, { data, loading, error }] = useCreateLandingApplicationClusterMutation({
 *   variables: {
 *      data: // value for 'data'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useCreateLandingApplicationClusterMutation(baseOptions?: Apollo.MutationHookOptions<CreateLandingApplicationClusterMutation, CreateLandingApplicationClusterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLandingApplicationClusterMutation, CreateLandingApplicationClusterMutationVariables>(CreateLandingApplicationClusterDocument, options);
      }
export type CreateLandingApplicationClusterMutationHookResult = ReturnType<typeof useCreateLandingApplicationClusterMutation>;
export type CreateLandingApplicationClusterMutationResult = Apollo.MutationResult<CreateLandingApplicationClusterMutation>;
export type CreateLandingApplicationClusterMutationOptions = Apollo.BaseMutationOptions<CreateLandingApplicationClusterMutation, CreateLandingApplicationClusterMutationVariables>;
export const GetSecurityGroupsDocument = gql`
    query getSecurityGroups {
  securityGroups {
    id
    name
  }
}
    `;

/**
 * __useGetSecurityGroupsQuery__
 *
 * To run a query within a React component, call `useGetSecurityGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSecurityGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSecurityGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSecurityGroupsQuery(baseOptions?: Apollo.QueryHookOptions<GetSecurityGroupsQuery, GetSecurityGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSecurityGroupsQuery, GetSecurityGroupsQueryVariables>(GetSecurityGroupsDocument, options);
      }
export function useGetSecurityGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSecurityGroupsQuery, GetSecurityGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSecurityGroupsQuery, GetSecurityGroupsQueryVariables>(GetSecurityGroupsDocument, options);
        }
export type GetSecurityGroupsQueryHookResult = ReturnType<typeof useGetSecurityGroupsQuery>;
export type GetSecurityGroupsLazyQueryHookResult = ReturnType<typeof useGetSecurityGroupsLazyQuery>;
export type GetSecurityGroupsQueryResult = Apollo.QueryResult<GetSecurityGroupsQuery, GetSecurityGroupsQueryVariables>;
export const UpdateLandingApplicationClusterDocument = gql`
    mutation updateLandingApplicationCluster($data: LandingApplicationClusterUpdateInput!, $where: LandingApplicationClusterWhereUniqueInput!, $file: Upload) {
  updateLandingApplicationCluster(data: $data, where: $where, file: $file) {
    id
  }
}
    `;
export type UpdateLandingApplicationClusterMutationFn = Apollo.MutationFunction<UpdateLandingApplicationClusterMutation, UpdateLandingApplicationClusterMutationVariables>;

/**
 * __useUpdateLandingApplicationClusterMutation__
 *
 * To run a mutation, you first call `useUpdateLandingApplicationClusterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLandingApplicationClusterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLandingApplicationClusterMutation, { data, loading, error }] = useUpdateLandingApplicationClusterMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUpdateLandingApplicationClusterMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLandingApplicationClusterMutation, UpdateLandingApplicationClusterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLandingApplicationClusterMutation, UpdateLandingApplicationClusterMutationVariables>(UpdateLandingApplicationClusterDocument, options);
      }
export type UpdateLandingApplicationClusterMutationHookResult = ReturnType<typeof useUpdateLandingApplicationClusterMutation>;
export type UpdateLandingApplicationClusterMutationResult = Apollo.MutationResult<UpdateLandingApplicationClusterMutation>;
export type UpdateLandingApplicationClusterMutationOptions = Apollo.BaseMutationOptions<UpdateLandingApplicationClusterMutation, UpdateLandingApplicationClusterMutationVariables>;
export const CreateLandingApplicationClusterGroupDocument = gql`
    mutation createLandingApplicationClusterGroup($data: LandingApplicationClusterGroupCreateInput!) {
  createLandingApplicationClusterGroup(data: $data) {
    id
  }
}
    `;
export type CreateLandingApplicationClusterGroupMutationFn = Apollo.MutationFunction<CreateLandingApplicationClusterGroupMutation, CreateLandingApplicationClusterGroupMutationVariables>;

/**
 * __useCreateLandingApplicationClusterGroupMutation__
 *
 * To run a mutation, you first call `useCreateLandingApplicationClusterGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLandingApplicationClusterGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLandingApplicationClusterGroupMutation, { data, loading, error }] = useCreateLandingApplicationClusterGroupMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateLandingApplicationClusterGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateLandingApplicationClusterGroupMutation, CreateLandingApplicationClusterGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLandingApplicationClusterGroupMutation, CreateLandingApplicationClusterGroupMutationVariables>(CreateLandingApplicationClusterGroupDocument, options);
      }
export type CreateLandingApplicationClusterGroupMutationHookResult = ReturnType<typeof useCreateLandingApplicationClusterGroupMutation>;
export type CreateLandingApplicationClusterGroupMutationResult = Apollo.MutationResult<CreateLandingApplicationClusterGroupMutation>;
export type CreateLandingApplicationClusterGroupMutationOptions = Apollo.BaseMutationOptions<CreateLandingApplicationClusterGroupMutation, CreateLandingApplicationClusterGroupMutationVariables>;
export const UpdateLandingApplicationClusterGroupDocument = gql`
    mutation updateLandingApplicationClusterGroup($data: LandingApplicationClusterGroupUpdateInput!, $where: LandingApplicationClusterGroupWhereUniqueInput!) {
  updateLandingApplicationClusterGroup(data: $data, where: $where) {
    id
  }
}
    `;
export type UpdateLandingApplicationClusterGroupMutationFn = Apollo.MutationFunction<UpdateLandingApplicationClusterGroupMutation, UpdateLandingApplicationClusterGroupMutationVariables>;

/**
 * __useUpdateLandingApplicationClusterGroupMutation__
 *
 * To run a mutation, you first call `useUpdateLandingApplicationClusterGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLandingApplicationClusterGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLandingApplicationClusterGroupMutation, { data, loading, error }] = useUpdateLandingApplicationClusterGroupMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateLandingApplicationClusterGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLandingApplicationClusterGroupMutation, UpdateLandingApplicationClusterGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLandingApplicationClusterGroupMutation, UpdateLandingApplicationClusterGroupMutationVariables>(UpdateLandingApplicationClusterGroupDocument, options);
      }
export type UpdateLandingApplicationClusterGroupMutationHookResult = ReturnType<typeof useUpdateLandingApplicationClusterGroupMutation>;
export type UpdateLandingApplicationClusterGroupMutationResult = Apollo.MutationResult<UpdateLandingApplicationClusterGroupMutation>;
export type UpdateLandingApplicationClusterGroupMutationOptions = Apollo.BaseMutationOptions<UpdateLandingApplicationClusterGroupMutation, UpdateLandingApplicationClusterGroupMutationVariables>;
export const UpdateInterfaceDetailDocument = gql`
    mutation updateInterfaceDetail($data: InterfaceDetailUpdateInput!, $where: InterfaceDetailWhereUniqueInput!) {
  updateInterfaceDetail(data: $data, where: $where) {
    id
  }
}
    `;
export type UpdateInterfaceDetailMutationFn = Apollo.MutationFunction<UpdateInterfaceDetailMutation, UpdateInterfaceDetailMutationVariables>;

/**
 * __useUpdateInterfaceDetailMutation__
 *
 * To run a mutation, you first call `useUpdateInterfaceDetailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInterfaceDetailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInterfaceDetailMutation, { data, loading, error }] = useUpdateInterfaceDetailMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateInterfaceDetailMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInterfaceDetailMutation, UpdateInterfaceDetailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInterfaceDetailMutation, UpdateInterfaceDetailMutationVariables>(UpdateInterfaceDetailDocument, options);
      }
export type UpdateInterfaceDetailMutationHookResult = ReturnType<typeof useUpdateInterfaceDetailMutation>;
export type UpdateInterfaceDetailMutationResult = Apollo.MutationResult<UpdateInterfaceDetailMutation>;
export type UpdateInterfaceDetailMutationOptions = Apollo.BaseMutationOptions<UpdateInterfaceDetailMutation, UpdateInterfaceDetailMutationVariables>;
export const GetInterfaceDetailDocument = gql`
    query getInterfaceDetail {
  interfaceDetails {
    deletedBy
    id
    projectInterfaceId
    leanixMappingId
    description
    interfaceFormatId
    interfaceTypeId
    isExport
    createdAt
    createdBy
  }
}
    `;

/**
 * __useGetInterfaceDetailQuery__
 *
 * To run a query within a React component, call `useGetInterfaceDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInterfaceDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInterfaceDetailQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInterfaceDetailQuery(baseOptions?: Apollo.QueryHookOptions<GetInterfaceDetailQuery, GetInterfaceDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInterfaceDetailQuery, GetInterfaceDetailQueryVariables>(GetInterfaceDetailDocument, options);
      }
export function useGetInterfaceDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInterfaceDetailQuery, GetInterfaceDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInterfaceDetailQuery, GetInterfaceDetailQueryVariables>(GetInterfaceDetailDocument, options);
        }
export type GetInterfaceDetailQueryHookResult = ReturnType<typeof useGetInterfaceDetailQuery>;
export type GetInterfaceDetailLazyQueryHookResult = ReturnType<typeof useGetInterfaceDetailLazyQuery>;
export type GetInterfaceDetailQueryResult = Apollo.QueryResult<GetInterfaceDetailQuery, GetInterfaceDetailQueryVariables>;
export const UpdateProjectInterfaceDocument = gql`
    mutation updateProjectInterface($data: ProjectInterfaceUpdateInput!, $where: ProjectInterfaceWhereUniqueInput!) {
  updateProjectInterface(data: $data, where: $where) {
    id
  }
}
    `;
export type UpdateProjectInterfaceMutationFn = Apollo.MutationFunction<UpdateProjectInterfaceMutation, UpdateProjectInterfaceMutationVariables>;

/**
 * __useUpdateProjectInterfaceMutation__
 *
 * To run a mutation, you first call `useUpdateProjectInterfaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectInterfaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectInterfaceMutation, { data, loading, error }] = useUpdateProjectInterfaceMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateProjectInterfaceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProjectInterfaceMutation, UpdateProjectInterfaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProjectInterfaceMutation, UpdateProjectInterfaceMutationVariables>(UpdateProjectInterfaceDocument, options);
      }
export type UpdateProjectInterfaceMutationHookResult = ReturnType<typeof useUpdateProjectInterfaceMutation>;
export type UpdateProjectInterfaceMutationResult = Apollo.MutationResult<UpdateProjectInterfaceMutation>;
export type UpdateProjectInterfaceMutationOptions = Apollo.BaseMutationOptions<UpdateProjectInterfaceMutation, UpdateProjectInterfaceMutationVariables>;
export const CreateLeanixMappingDocument = gql`
    mutation createLeanixMapping($data: LeanixMappingCreateInput!) {
  createLeanixMapping(data: $data) {
    id
    description
    name
    master {
      id
    }
    leanixId
    type
    deletedBy
  }
}
    `;
export type CreateLeanixMappingMutationFn = Apollo.MutationFunction<CreateLeanixMappingMutation, CreateLeanixMappingMutationVariables>;

/**
 * __useCreateLeanixMappingMutation__
 *
 * To run a mutation, you first call `useCreateLeanixMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLeanixMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLeanixMappingMutation, { data, loading, error }] = useCreateLeanixMappingMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateLeanixMappingMutation(baseOptions?: Apollo.MutationHookOptions<CreateLeanixMappingMutation, CreateLeanixMappingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLeanixMappingMutation, CreateLeanixMappingMutationVariables>(CreateLeanixMappingDocument, options);
      }
export type CreateLeanixMappingMutationHookResult = ReturnType<typeof useCreateLeanixMappingMutation>;
export type CreateLeanixMappingMutationResult = Apollo.MutationResult<CreateLeanixMappingMutation>;
export type CreateLeanixMappingMutationOptions = Apollo.BaseMutationOptions<CreateLeanixMappingMutation, CreateLeanixMappingMutationVariables>;
export const RiskCategoriesDocument = gql`
    query riskCategories {
  riskOccurances {
    id
  }
  riskDamagePotentials {
    id
  }
  riskStatuses {
    id
  }
}
    `;

/**
 * __useRiskCategoriesQuery__
 *
 * To run a query within a React component, call `useRiskCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRiskCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRiskCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useRiskCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<RiskCategoriesQuery, RiskCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RiskCategoriesQuery, RiskCategoriesQueryVariables>(RiskCategoriesDocument, options);
      }
export function useRiskCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RiskCategoriesQuery, RiskCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RiskCategoriesQuery, RiskCategoriesQueryVariables>(RiskCategoriesDocument, options);
        }
export type RiskCategoriesQueryHookResult = ReturnType<typeof useRiskCategoriesQuery>;
export type RiskCategoriesLazyQueryHookResult = ReturnType<typeof useRiskCategoriesLazyQuery>;
export type RiskCategoriesQueryResult = Apollo.QueryResult<RiskCategoriesQuery, RiskCategoriesQueryVariables>;
export const CheckProjectResourceCaptureDocument = gql`
    query checkProjectResourceCapture($id: String, $projectStatus: [String!], $projectEmployee: String) {
  masters(
    where: {id: {equals: $id}, projectStatus: {some: {sequenceStatusId: {in: $projectStatus}, deletedBy: {equals: null}}}, OR: [{projectRole: {some: {employeeId: {equals: $projectEmployee}, deletedBy: {equals: null}, roleId: {equals: "Projektleitung"}}}}, {projectResourceCapture: {some: {employeeId: {equals: $projectEmployee}, deletedBy: {equals: null}}}}]}
  ) {
    id
  }
}
    `;

/**
 * __useCheckProjectResourceCaptureQuery__
 *
 * To run a query within a React component, call `useCheckProjectResourceCaptureQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckProjectResourceCaptureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckProjectResourceCaptureQuery({
 *   variables: {
 *      id: // value for 'id'
 *      projectStatus: // value for 'projectStatus'
 *      projectEmployee: // value for 'projectEmployee'
 *   },
 * });
 */
export function useCheckProjectResourceCaptureQuery(baseOptions?: Apollo.QueryHookOptions<CheckProjectResourceCaptureQuery, CheckProjectResourceCaptureQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckProjectResourceCaptureQuery, CheckProjectResourceCaptureQueryVariables>(CheckProjectResourceCaptureDocument, options);
      }
export function useCheckProjectResourceCaptureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckProjectResourceCaptureQuery, CheckProjectResourceCaptureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckProjectResourceCaptureQuery, CheckProjectResourceCaptureQueryVariables>(CheckProjectResourceCaptureDocument, options);
        }
export type CheckProjectResourceCaptureQueryHookResult = ReturnType<typeof useCheckProjectResourceCaptureQuery>;
export type CheckProjectResourceCaptureLazyQueryHookResult = ReturnType<typeof useCheckProjectResourceCaptureLazyQuery>;
export type CheckProjectResourceCaptureQueryResult = Apollo.QueryResult<CheckProjectResourceCaptureQuery, CheckProjectResourceCaptureQueryVariables>;
export const CreateAddresseeGroupDocument = gql`
    mutation CreateAddresseeGroup($data: AddresseeGroupCreateInput!) {
  createAddresseeGroup(data: $data) {
    employeeId
    createdBy
    report {
      id
    }
  }
}
    `;
export type CreateAddresseeGroupMutationFn = Apollo.MutationFunction<CreateAddresseeGroupMutation, CreateAddresseeGroupMutationVariables>;

/**
 * __useCreateAddresseeGroupMutation__
 *
 * To run a mutation, you first call `useCreateAddresseeGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAddresseeGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAddresseeGroupMutation, { data, loading, error }] = useCreateAddresseeGroupMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateAddresseeGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateAddresseeGroupMutation, CreateAddresseeGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAddresseeGroupMutation, CreateAddresseeGroupMutationVariables>(CreateAddresseeGroupDocument, options);
      }
export type CreateAddresseeGroupMutationHookResult = ReturnType<typeof useCreateAddresseeGroupMutation>;
export type CreateAddresseeGroupMutationResult = Apollo.MutationResult<CreateAddresseeGroupMutation>;
export type CreateAddresseeGroupMutationOptions = Apollo.BaseMutationOptions<CreateAddresseeGroupMutation, CreateAddresseeGroupMutationVariables>;
export const UpdateAddresseeGroupDocument = gql`
    mutation UpdateAddresseeGroup($data: AddresseeGroupUpdateInput!, $where: AddresseeGroupWhereUniqueInput!) {
  updateAddresseeGroup(data: $data, where: $where) {
    deletedBy
    deletedAt
  }
}
    `;
export type UpdateAddresseeGroupMutationFn = Apollo.MutationFunction<UpdateAddresseeGroupMutation, UpdateAddresseeGroupMutationVariables>;

/**
 * __useUpdateAddresseeGroupMutation__
 *
 * To run a mutation, you first call `useUpdateAddresseeGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAddresseeGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAddresseeGroupMutation, { data, loading, error }] = useUpdateAddresseeGroupMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateAddresseeGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAddresseeGroupMutation, UpdateAddresseeGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAddresseeGroupMutation, UpdateAddresseeGroupMutationVariables>(UpdateAddresseeGroupDocument, options);
      }
export type UpdateAddresseeGroupMutationHookResult = ReturnType<typeof useUpdateAddresseeGroupMutation>;
export type UpdateAddresseeGroupMutationResult = Apollo.MutationResult<UpdateAddresseeGroupMutation>;
export type UpdateAddresseeGroupMutationOptions = Apollo.BaseMutationOptions<UpdateAddresseeGroupMutation, UpdateAddresseeGroupMutationVariables>;
export const GetAddresseeGroupDocument = gql`
    query getAddresseeGroup {
  addresseeGroups {
    id
    deletedBy
    employeeId
    reportId
    employee {
      id
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useGetAddresseeGroupQuery__
 *
 * To run a query within a React component, call `useGetAddresseeGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddresseeGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddresseeGroupQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAddresseeGroupQuery(baseOptions?: Apollo.QueryHookOptions<GetAddresseeGroupQuery, GetAddresseeGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAddresseeGroupQuery, GetAddresseeGroupQueryVariables>(GetAddresseeGroupDocument, options);
      }
export function useGetAddresseeGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAddresseeGroupQuery, GetAddresseeGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAddresseeGroupQuery, GetAddresseeGroupQueryVariables>(GetAddresseeGroupDocument, options);
        }
export type GetAddresseeGroupQueryHookResult = ReturnType<typeof useGetAddresseeGroupQuery>;
export type GetAddresseeGroupLazyQueryHookResult = ReturnType<typeof useGetAddresseeGroupLazyQuery>;
export type GetAddresseeGroupQueryResult = Apollo.QueryResult<GetAddresseeGroupQuery, GetAddresseeGroupQueryVariables>;
export const UpdateReportDocument = gql`
    mutation UpdateReport($data: ReportUpdateInput!, $where: ReportWhereUniqueInput!) {
  updateReport(data: $data, where: $where) {
    reportLink
    deletedBy
  }
}
    `;
export type UpdateReportMutationFn = Apollo.MutationFunction<UpdateReportMutation, UpdateReportMutationVariables>;

/**
 * __useUpdateReportMutation__
 *
 * To run a mutation, you first call `useUpdateReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportMutation, { data, loading, error }] = useUpdateReportMutation({
 *   variables: {
 *      data: // value for 'data'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useUpdateReportMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportMutation, UpdateReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportMutation, UpdateReportMutationVariables>(UpdateReportDocument, options);
      }
export type UpdateReportMutationHookResult = ReturnType<typeof useUpdateReportMutation>;
export type UpdateReportMutationResult = Apollo.MutationResult<UpdateReportMutation>;
export type UpdateReportMutationOptions = Apollo.BaseMutationOptions<UpdateReportMutation, UpdateReportMutationVariables>;
export const CreateReportDocument = gql`
    mutation CreateReport($data: ReportCreateInput!) {
  createReport(data: $data) {
    reportLink
  }
}
    `;
export type CreateReportMutationFn = Apollo.MutationFunction<CreateReportMutation, CreateReportMutationVariables>;

/**
 * __useCreateReportMutation__
 *
 * To run a mutation, you first call `useCreateReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportMutation, { data, loading, error }] = useCreateReportMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateReportMutation(baseOptions?: Apollo.MutationHookOptions<CreateReportMutation, CreateReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReportMutation, CreateReportMutationVariables>(CreateReportDocument, options);
      }
export type CreateReportMutationHookResult = ReturnType<typeof useCreateReportMutation>;
export type CreateReportMutationResult = Apollo.MutationResult<CreateReportMutation>;
export type CreateReportMutationOptions = Apollo.BaseMutationOptions<CreateReportMutation, CreateReportMutationVariables>;
export const ProjectDescriptionNamesDocument = gql`
    query projectDescriptionNames($where: ProjectDescriptionWhereInput) {
  projectDescriptions(where: $where) {
    name
  }
}
    `;

/**
 * __useProjectDescriptionNamesQuery__
 *
 * To run a query within a React component, call `useProjectDescriptionNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectDescriptionNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectDescriptionNamesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useProjectDescriptionNamesQuery(baseOptions?: Apollo.QueryHookOptions<ProjectDescriptionNamesQuery, ProjectDescriptionNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectDescriptionNamesQuery, ProjectDescriptionNamesQueryVariables>(ProjectDescriptionNamesDocument, options);
      }
export function useProjectDescriptionNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectDescriptionNamesQuery, ProjectDescriptionNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectDescriptionNamesQuery, ProjectDescriptionNamesQueryVariables>(ProjectDescriptionNamesDocument, options);
        }
export type ProjectDescriptionNamesQueryHookResult = ReturnType<typeof useProjectDescriptionNamesQuery>;
export type ProjectDescriptionNamesLazyQueryHookResult = ReturnType<typeof useProjectDescriptionNamesLazyQuery>;
export type ProjectDescriptionNamesQueryResult = Apollo.QueryResult<ProjectDescriptionNamesQuery, ProjectDescriptionNamesQueryVariables>;
export const GetProjectApprovalsByIdDocument = gql`
    query getProjectApprovalsById($projectId: String!, $approvalBoardId: String!) {
  projectApprovals(
    where: {projectId: {equals: $projectId}, approvalBoardId: {equals: $approvalBoardId}}
  ) {
    approvalStatusId
  }
}
    `;

/**
 * __useGetProjectApprovalsByIdQuery__
 *
 * To run a query within a React component, call `useGetProjectApprovalsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectApprovalsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectApprovalsByIdQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      approvalBoardId: // value for 'approvalBoardId'
 *   },
 * });
 */
export function useGetProjectApprovalsByIdQuery(baseOptions: Apollo.QueryHookOptions<GetProjectApprovalsByIdQuery, GetProjectApprovalsByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProjectApprovalsByIdQuery, GetProjectApprovalsByIdQueryVariables>(GetProjectApprovalsByIdDocument, options);
      }
export function useGetProjectApprovalsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProjectApprovalsByIdQuery, GetProjectApprovalsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProjectApprovalsByIdQuery, GetProjectApprovalsByIdQueryVariables>(GetProjectApprovalsByIdDocument, options);
        }
export type GetProjectApprovalsByIdQueryHookResult = ReturnType<typeof useGetProjectApprovalsByIdQuery>;
export type GetProjectApprovalsByIdLazyQueryHookResult = ReturnType<typeof useGetProjectApprovalsByIdLazyQuery>;
export type GetProjectApprovalsByIdQueryResult = Apollo.QueryResult<GetProjectApprovalsByIdQuery, GetProjectApprovalsByIdQueryVariables>;
export const CheckProjectApprovalsDocument = gql`
    query checkProjectApprovals($where: ProjectApprovalWhereInput, $take: Int, $orderBy: [ProjectApprovalOrderByWithRelationInput!]) {
  projectApprovals(where: $where, take: $take, orderBy: $orderBy) {
    id
  }
}
    `;

/**
 * __useCheckProjectApprovalsQuery__
 *
 * To run a query within a React component, call `useCheckProjectApprovalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckProjectApprovalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckProjectApprovalsQuery({
 *   variables: {
 *      where: // value for 'where'
 *      take: // value for 'take'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useCheckProjectApprovalsQuery(baseOptions?: Apollo.QueryHookOptions<CheckProjectApprovalsQuery, CheckProjectApprovalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckProjectApprovalsQuery, CheckProjectApprovalsQueryVariables>(CheckProjectApprovalsDocument, options);
      }
export function useCheckProjectApprovalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckProjectApprovalsQuery, CheckProjectApprovalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckProjectApprovalsQuery, CheckProjectApprovalsQueryVariables>(CheckProjectApprovalsDocument, options);
        }
export type CheckProjectApprovalsQueryHookResult = ReturnType<typeof useCheckProjectApprovalsQuery>;
export type CheckProjectApprovalsLazyQueryHookResult = ReturnType<typeof useCheckProjectApprovalsLazyQuery>;
export type CheckProjectApprovalsQueryResult = Apollo.QueryResult<CheckProjectApprovalsQuery, CheckProjectApprovalsQueryVariables>;